/* 🤖 this file was generated by svg-to-ts */
import { MGCIcon } from './mgc-icons.model';
import { mgcIconAlignArrowDownCuteFi } from './mgcIcon-align_arrow_down_cute_fi.icon';
import { mgcIconAlignArrowLeftCuteFi } from './mgcIcon-align_arrow_left_cute_fi.icon';
import { mgcIconAlignArrowRightCuteFi } from './mgcIcon-align_arrow_right_cute_fi.icon';
import { mgcIconAlignArrowUpCuteFi } from './mgcIcon-align_arrow_up_cute_fi.icon';
import { mgcIconArrowDownCircleCuteFi } from './mgcIcon-arrow_down_circle_cute_fi.icon';
import { mgcIconArrowDownCuteFi } from './mgcIcon-arrow_down_cute_fi.icon';
import { mgcIconArrowLeftCircleCuteFi } from './mgcIcon-arrow_left_circle_cute_fi.icon';
import { mgcIconArrowLeftCuteFi } from './mgcIcon-arrow_left_cute_fi.icon';
import { mgcIconArrowLeftDownCircleCuteFi } from './mgcIcon-arrow_left_down_circle_cute_fi.icon';
import { mgcIconArrowLeftDownCuteFi } from './mgcIcon-arrow_left_down_cute_fi.icon';
import { mgcIconArrowLeftUpCircleCuteFi } from './mgcIcon-arrow_left_up_circle_cute_fi.icon';
import { mgcIconArrowLeftUpCuteFi } from './mgcIcon-arrow_left_up_cute_fi.icon';
import { mgcIconArrowRightCircleCuteFi } from './mgcIcon-arrow_right_circle_cute_fi.icon';
import { mgcIconArrowRightCuteFi } from './mgcIcon-arrow_right_cute_fi.icon';
import { mgcIconArrowRightDownCircleCuteFi } from './mgcIcon-arrow_right_down_circle_cute_fi.icon';
import { mgcIconArrowRightDownCuteFi } from './mgcIcon-arrow_right_down_cute_fi.icon';
import { mgcIconArrowRightUpCircleCuteFi } from './mgcIcon-arrow_right_up_circle_cute_fi.icon';
import { mgcIconArrowRightUpCuteFi } from './mgcIcon-arrow_right_up_cute_fi.icon';
import { mgcIconArrowToDownCuteFi } from './mgcIcon-arrow_to_down_cute_fi.icon';
import { mgcIconArrowToLeftCuteFi } from './mgcIcon-arrow_to_left_cute_fi.icon';
import { mgcIconArrowToRightCuteFi } from './mgcIcon-arrow_to_right_cute_fi.icon';
import { mgcIconArrowToUpCuteFi } from './mgcIcon-arrow_to_up_cute_fi.icon';
import { mgcIconArrowUpCircleCuteFi } from './mgcIcon-arrow_up_circle_cute_fi.icon';
import { mgcIconArrowUpCuteFi } from './mgcIcon-arrow_up_cute_fi.icon';
import { mgcIconArrowsDownCuteFi } from './mgcIcon-arrows_down_cute_fi.icon';
import { mgcIconArrowsLeftCuteFi } from './mgcIcon-arrows_left_cute_fi.icon';
import { mgcIconArrowsRightCuteFi } from './mgcIcon-arrows_right_cute_fi.icon';
import { mgcIconArrowsUpCuteFi } from './mgcIcon-arrows_up_cute_fi.icon';
import { mgcIconBack2CuteFi } from './mgcIcon-back_2_cute_fi.icon';
import { mgcIconBackCuteFi } from './mgcIcon-back_cute_fi.icon';
import { mgcIconCornerDownLeftCuteFi } from './mgcIcon-corner_down_left_cute_fi.icon';
import { mgcIconCornerDownRightCuteFi } from './mgcIcon-corner_down_right_cute_fi.icon';
import { mgcIconCornerUpLeftCuteFi } from './mgcIcon-corner_up_left_cute_fi.icon';
import { mgcIconCornerUpRightCuteFi } from './mgcIcon-corner_up_right_cute_fi.icon';
import { mgcIconDirectionArrowCuteFi } from './mgcIcon-direction_arrow_cute_fi.icon';
import { mgcIconDownCuteFi } from './mgcIcon-down_cute_fi.icon';
import { mgcIconDownSmallCuteFi } from './mgcIcon-down_small_cute_fi.icon';
import { mgcIconForward2CuteFi } from './mgcIcon-forward_2_cute_fi.icon';
import { mgcIconForwardCuteFi } from './mgcIcon-forward_cute_fi.icon';
import { mgcIconFullscreen2CuteFi } from './mgcIcon-fullscreen_2_cute_fi.icon';
import { mgcIconFullscreenExit2CuteFi } from './mgcIcon-fullscreen_exit_2_cute_fi.icon';
import { mgcIconLargeArrowDownCuteFi } from './mgcIcon-large_arrow_down_cute_fi.icon';
import { mgcIconLargeArrowLeftCuteFi } from './mgcIcon-large_arrow_left_cute_fi.icon';
import { mgcIconLargeArrowRightCuteFi } from './mgcIcon-large_arrow_right_cute_fi.icon';
import { mgcIconLargeArrowUpCuteFi } from './mgcIcon-large_arrow_up_cute_fi.icon';
import { mgcIconLeftCuteFi } from './mgcIcon-left_cute_fi.icon';
import { mgcIconLeftSmallCuteFi } from './mgcIcon-left_small_cute_fi.icon';
import { mgcIconMoveCuteFi } from './mgcIcon-move_cute_fi.icon';
import { mgcIconRightCuteFi } from './mgcIcon-right_cute_fi.icon';
import { mgcIconRightSmallCuteFi } from './mgcIcon-right_small_cute_fi.icon';
import { mgcIconSelectorHorizontalCuteFi } from './mgcIcon-selector_horizontal_cute_fi.icon';
import { mgcIconSelectorVerticalCuteFi } from './mgcIcon-selector_vertical_cute_fi.icon';
import { mgcIconSquareArrowDownCuteFi } from './mgcIcon-square_arrow_down_cute_fi.icon';
import { mgcIconSquareArrowLeftCuteFi } from './mgcIcon-square_arrow_left_cute_fi.icon';
import { mgcIconSquareArrowRightCuteFi } from './mgcIcon-square_arrow_right_cute_fi.icon';
import { mgcIconSquareArrowUpCuteFi } from './mgcIcon-square_arrow_up_cute_fi.icon';
import { mgcIconTransfer2CuteFi } from './mgcIcon-transfer_2_cute_fi.icon';
import { mgcIconTransfer3CuteFi } from './mgcIcon-transfer_3_cute_fi.icon';
import { mgcIconTransfer4CuteFi } from './mgcIcon-transfer_4_cute_fi.icon';
import { mgcIconTransferCuteFi } from './mgcIcon-transfer_cute_fi.icon';
import { mgcIconTransferHorizontalCuteFi } from './mgcIcon-transfer_horizontal_cute_fi.icon';
import { mgcIconTransferVerticalCuteFi } from './mgcIcon-transfer_vertical_cute_fi.icon';
import { mgcIconTrendingDownCuteFi } from './mgcIcon-trending_down_cute_fi.icon';
import { mgcIconTrendingUpCuteFi } from './mgcIcon-trending_up_cute_fi.icon';
import { mgcIconUpCuteFi } from './mgcIcon-up_cute_fi.icon';
import { mgcIconUpSmallCuteFi } from './mgcIcon-up_small_cute_fi.icon';
import { mgcIconBankCuteFi } from './mgcIcon-bank_cute_fi.icon';
import { mgcIconBankOfChinaTowerCuteFi } from './mgcIcon-bank_of_china_tower_cute_fi.icon';
import { mgcIconBigBenCuteFi } from './mgcIcon-big_ben_cute_fi.icon';
import { mgcIconBridge2CuteFi } from './mgcIcon-bridge_2_cute_fi.icon';
import { mgcIconBridgeCuteFi } from './mgcIcon-bridge_cute_fi.icon';
import { mgcIconBuilding1CuteFi } from './mgcIcon-building_1_cute_fi.icon';
import { mgcIconBuilding2CuteFi } from './mgcIcon-building_2_cute_fi.icon';
import { mgcIconBuilding3CuteFi } from './mgcIcon-building_3_cute_fi.icon';
import { mgcIconBuilding4CuteFi } from './mgcIcon-building_4_cute_fi.icon';
import { mgcIconBuilding5CuteFi } from './mgcIcon-building_5_cute_fi.icon';
import { mgcIconBuilding6CuteFi } from './mgcIcon-building_6_cute_fi.icon';
import { mgcIconBurjAlArabCuteFi } from './mgcIcon-burj_al_arab_cute_fi.icon';
import { mgcIconBurjKhalifaTowerCuteFi } from './mgcIcon-burj_khalifa_tower_cute_fi.icon';
import { mgcIconCampgroundCuteFi } from './mgcIcon-campground_cute_fi.icon';
import { mgcIconCantonTowerCuteFi } from './mgcIcon-canton_tower_cute_fi.icon';
import { mgcIconChristTheRedeemerCuteFi } from './mgcIcon-christ_the_redeemer_cute_fi.icon';
import { mgcIconChurchCuteFi } from './mgcIcon-church_cute_fi.icon';
import { mgcIconDutchWindmillCuteFi } from './mgcIcon-dutch_windmill_cute_fi.icon';
import { mgcIconEgyptianPyramidsCuteFi } from './mgcIcon-egyptian_pyramids_cute_fi.icon';
import { mgcIconEiffelTowerCuteFi } from './mgcIcon-eiffel_tower_cute_fi.icon';
import { mgcIconFactory2CuteFi } from './mgcIcon-factory_2_cute_fi.icon';
import { mgcIconFactoryCuteFi } from './mgcIcon-factory_cute_fi.icon';
import { mgcIconFerrisWheelCuteFi } from './mgcIcon-ferris_wheel_cute_fi.icon';
import { mgcIconGovernmentCuteFi } from './mgcIcon-government_cute_fi.icon';
import { mgcIconGreatwallCuteFi } from './mgcIcon-greatwall_cute_fi.icon';
import { mgcIconHome1CuteFi } from './mgcIcon-home_1_cute_fi.icon';
import { mgcIconHome2CuteFi } from './mgcIcon-home_2_cute_fi.icon';
import { mgcIconHome3CuteFi } from './mgcIcon-home_3_cute_fi.icon';
import { mgcIconHome4CuteFi } from './mgcIcon-home_4_cute_fi.icon';
import { mgcIconHome5CuteFi } from './mgcIcon-home_5_cute_fi.icon';
import { mgcIconHome6CuteFi } from './mgcIcon-home_6_cute_fi.icon';
import { mgcIconHome7CuteFi } from './mgcIcon-home_7_cute_fi.icon';
import { mgcIconHospitalCuteFi } from './mgcIcon-hospital_cute_fi.icon';
import { mgcIconHotelCuteFi } from './mgcIcon-hotel_cute_fi.icon';
import { mgcIconHouse2CuteFi } from './mgcIcon-house_2_cute_fi.icon';
import { mgcIconHouseCuteFi } from './mgcIcon-house_cute_fi.icon';
import { mgcIconKingkey100TowerCuteFi } from './mgcIcon-kingkey_100_tower_cute_fi.icon';
import { mgcIconLighthouseCuteFi } from './mgcIcon-lighthouse_cute_fi.icon';
import { mgcIconMarinaBaySandCuteFi } from './mgcIcon-marina_bay_sand_cute_fi.icon';
import { mgcIconMayaPyramidsCuteFi } from './mgcIcon-maya_pyramids_cute_fi.icon';
import { mgcIconMiyajimaToriiCuteFi } from './mgcIcon-miyajima_torii_cute_fi.icon';
import { mgcIconMoaiCuteFi } from './mgcIcon-moai_cute_fi.icon';
import { mgcIconMonumentCuteFi } from './mgcIcon-monument_cute_fi.icon';
import { mgcIconPalaceCuteFi } from './mgcIcon-palace_cute_fi.icon';
import { mgcIconPavilionCuteFi } from './mgcIcon-pavilion_cute_fi.icon';
import { mgcIconPisaTowerCuteFi } from './mgcIcon-pisa_tower_cute_fi.icon';
import { mgcIconSchoolCuteFi } from './mgcIcon-school_cute_fi.icon';
import { mgcIconShopCuteFi } from './mgcIcon-shop_cute_fi.icon';
import { mgcIconStatueOfLibertyCuteFi } from './mgcIcon-statue_of_liberty_cute_fi.icon';
import { mgcIconStore2CuteFi } from './mgcIcon-store_2_cute_fi.icon';
import { mgcIconStoreCuteFi } from './mgcIcon-store_cute_fi.icon';
import { mgcIconSydneyOperaHouseCuteFi } from './mgcIcon-sydney_opera_house_cute_fi.icon';
import { mgcIconTaipei101CuteFi } from './mgcIcon-taipei101_cute_fi.icon';
import { mgcIconTajMahalCuteFi } from './mgcIcon-taj_mahal_cute_fi.icon';
import { mgcIconTempleOfHeavenCuteFi } from './mgcIcon-temple_of_heaven_cute_fi.icon';
import { mgcIconTentCuteFi } from './mgcIcon-tent_cute_fi.icon';
import { mgcIconTowerCuteFi } from './mgcIcon-tower_cute_fi.icon';
import { mgcIconTriumphalArchCuteFi } from './mgcIcon-triumphal_arch_cute_fi.icon';
import { mgcIconTvTowerCuteFi } from './mgcIcon-tv_tower_cute_fi.icon';
import { mgcIconAdCircleCuteFi } from './mgcIcon-ad_circle_cute_fi.icon';
import { mgcIconAdCircleOffCuteFi } from './mgcIcon-ad_circle_off_cute_fi.icon';
import { mgcIconAdRectangleCuteFi } from './mgcIcon-ad_rectangle_cute_fi.icon';
import { mgcIconAdRectangleOffCuteFi } from './mgcIcon-ad_rectangle_off_cute_fi.icon';
import { mgcIconAnniversaryCuteFi } from './mgcIcon-anniversary_cute_fi.icon';
import { mgcIconAuctionCuteFi } from './mgcIcon-auction_cute_fi.icon';
import { mgcIconAwardCuteFi } from './mgcIcon-award_cute_fi.icon';
import { mgcIconBankCardCuteFi } from './mgcIcon-bank_card_cute_fi.icon';
import { mgcIconBasket2CuteFi } from './mgcIcon-basket_2_cute_fi.icon';
import { mgcIconBasketCuteFi } from './mgcIcon-basket_cute_fi.icon';
import { mgcIconBriefcase2CuteFi } from './mgcIcon-briefcase_2_cute_fi.icon';
import { mgcIconBriefcaseCuteFi } from './mgcIcon-briefcase_cute_fi.icon';
import { mgcIconCalendar2CuteFi } from './mgcIcon-calendar_2_cute_fi.icon';
import { mgcIconCalendar3CuteFi } from './mgcIcon-calendar_3_cute_fi.icon';
import { mgcIconCalendarAddCuteFi } from './mgcIcon-calendar_add_cute_fi.icon';
import { mgcIconCalendarCuteFi } from './mgcIcon-calendar_cute_fi.icon';
import { mgcIconCalendarDayCuteFi } from './mgcIcon-calendar_day_cute_fi.icon';
import { mgcIconCalendarMonthCuteFi } from './mgcIcon-calendar_month_cute_fi.icon';
import { mgcIconCalendarTimeAddCuteFi } from './mgcIcon-calendar_time_add_cute_fi.icon';
import { mgcIconCalendarWeekCuteFi } from './mgcIcon-calendar_week_cute_fi.icon';
import { mgcIconCandleCuteFi } from './mgcIcon-candle_cute_fi.icon';
import { mgcIconCandlesCuteFi } from './mgcIcon-candles_cute_fi.icon';
import { mgcIconCardPayCuteFi } from './mgcIcon-card_pay_cute_fi.icon';
import { mgcIconCardRefundCuteFi } from './mgcIcon-card_refund_cute_fi.icon';
import { mgcIconCash2CuteFi } from './mgcIcon-cash_2_cute_fi.icon';
import { mgcIconCashCuteFi } from './mgcIcon-cash_cute_fi.icon';
import { mgcIconCelebrateCuteFi } from './mgcIcon-celebrate_cute_fi.icon';
import { mgcIconChartBar2CuteFi } from './mgcIcon-chart_bar_2_cute_fi.icon';
import { mgcIconChartBarCuteFi } from './mgcIcon-chart_bar_cute_fi.icon';
import { mgcIconChartDecreaseCuteFi } from './mgcIcon-chart_decrease_cute_fi.icon';
import { mgcIconChartHorizontalCuteFi } from './mgcIcon-chart_horizontal_cute_fi.icon';
import { mgcIconChartLineCuteFi } from './mgcIcon-chart_line_cute_fi.icon';
import { mgcIconChartPie2CuteFi } from './mgcIcon-chart_pie_2_cute_fi.icon';
import { mgcIconChartPieCuteFi } from './mgcIcon-chart_pie_cute_fi.icon';
import { mgcIconChartVerticalCuteFi } from './mgcIcon-chart_vertical_cute_fi.icon';
import { mgcIconChineseKnotCuteFi } from './mgcIcon-chinese_knot_cute_fi.icon';
import { mgcIconChristmasBallCuteFi } from './mgcIcon-christmas_ball_cute_fi.icon';
import { mgcIconCoin2CuteFi } from './mgcIcon-coin_2_cute_fi.icon';
import { mgcIconCoin3CuteFi } from './mgcIcon-coin_3_cute_fi.icon';
import { mgcIconCoinCuteFi } from './mgcIcon-coin_cute_fi.icon';
import { mgcIconCopperCoinCuteFi } from './mgcIcon-copper_coin_cute_fi.icon';
import { mgcIconCopyrightCuteFi } from './mgcIcon-copyright_cute_fi.icon';
import { mgcIconCouponCuteFi } from './mgcIcon-coupon_cute_fi.icon';
import { mgcIconCurrencyBaht2CuteFi } from './mgcIcon-currency_baht_2_cute_fi.icon';
import { mgcIconCurrencyBahtCuteFi } from './mgcIcon-currency_baht_cute_fi.icon';
import { mgcIconCurrencyCny2CuteFi } from './mgcIcon-currency_cny_2_cute_fi.icon';
import { mgcIconCurrencyCnyCuteFi } from './mgcIcon-currency_cny_cute_fi.icon';
import { mgcIconCurrencyDollar2CuteFi } from './mgcIcon-currency_dollar_2_cute_fi.icon';
import { mgcIconCurrencyDollarCuteFi } from './mgcIcon-currency_dollar_cute_fi.icon';
import { mgcIconCurrencyEuro2CuteFi } from './mgcIcon-currency_euro_2_cute_fi.icon';
import { mgcIconCurrencyEuroCuteFi } from './mgcIcon-currency_euro_cute_fi.icon';
import { mgcIconCurrencyLira2CuteFi } from './mgcIcon-currency_lira_2_cute_fi.icon';
import { mgcIconCurrencyLiraCuteFi } from './mgcIcon-currency_lira_cute_fi.icon';
import { mgcIconCurrencyNigeria2CuteFi } from './mgcIcon-currency_nigeria_2_cute_fi.icon';
import { mgcIconCurrencyNigeriaCuteFi } from './mgcIcon-currency_nigeria_cute_fi.icon';
import { mgcIconCurrencyRubel2CuteFi } from './mgcIcon-currency_rubel_2_cute_fi.icon';
import { mgcIconCurrencyRubelCuteFi } from './mgcIcon-currency_rubel_cute_fi.icon';
import { mgcIconCurrencyRupee2CuteFi } from './mgcIcon-currency_rupee_2_cute_fi.icon';
import { mgcIconCurrencyRupeeCuteFi } from './mgcIcon-currency_rupee_cute_fi.icon';
import { mgcIconCurrencyShekel2CuteFi } from './mgcIcon-currency_shekel_2_cute_fi.icon';
import { mgcIconCurrencyShekelCuteFi } from './mgcIcon-currency_shekel_cute_fi.icon';
import { mgcIconCurrencyWon2CuteFi } from './mgcIcon-currency_won_2_cute_fi.icon';
import { mgcIconCurrencyWonCuteFi } from './mgcIcon-currency_won_cute_fi.icon';
import { mgcIconDiamond2CuteFi } from './mgcIcon-diamond_2_cute_fi.icon';
import { mgcIconExchangeBahtCuteFi } from './mgcIcon-exchange_baht_cute_fi.icon';
import { mgcIconExchangeCnyCuteFi } from './mgcIcon-exchange_cny_cute_fi.icon';
import { mgcIconExchangeDollarCuteFi } from './mgcIcon-exchange_dollar_cute_fi.icon';
import { mgcIconExchangeEuroCuteFi } from './mgcIcon-exchange_euro_cute_fi.icon';
import { mgcIconFilter3CuteFi } from './mgcIcon-filter_3_cute_fi.icon';
import { mgcIconFilterCuteFi } from './mgcIcon-filter_cute_fi.icon';
import { mgcIconFlag1CuteFi } from './mgcIcon-flag_1_cute_fi.icon';
import { mgcIconFlag2CuteFi } from './mgcIcon-flag_2_cute_fi.icon';
import { mgcIconFlag3CuteFi } from './mgcIcon-flag_3_cute_fi.icon';
import { mgcIconFlag4CuteFi } from './mgcIcon-flag_4_cute_fi.icon';
import { mgcIconGift2CuteFi } from './mgcIcon-gift_2_cute_fi.icon';
import { mgcIconGiftCardCuteFi } from './mgcIcon-gift_card_cute_fi.icon';
import { mgcIconGiftCuteFi } from './mgcIcon-gift_cute_fi.icon';
import { mgcIconLadderCuteFi } from './mgcIcon-ladder_cute_fi.icon';
import { mgcIconLantern2CuteFi } from './mgcIcon-lantern_2_cute_fi.icon';
import { mgcIconLanternCuteFi } from './mgcIcon-lantern_cute_fi.icon';
import { mgcIconLaurelWreathCuteFi } from './mgcIcon-laurel_wreath_cute_fi.icon';
import { mgcIconLuggageCuteFi } from './mgcIcon-luggage_cute_fi.icon';
import { mgcIconMedalCuteFi } from './mgcIcon-medal_cute_fi.icon';
import { mgcIconPalette3CuteFi } from './mgcIcon-palette_3_cute_fi.icon';
import { mgcIconPigMoneyCuteFi } from './mgcIcon-pig_money_cute_fi.icon';
import { mgcIconPound2CuteFi } from './mgcIcon-pound_2_cute_fi.icon';
import { mgcIconPoundCuteFi } from './mgcIcon-pound_cute_fi.icon';
import { mgcIconPresentation1CuteFi } from './mgcIcon-presentation_1_cute_fi.icon';
import { mgcIconPresentation2CuteFi } from './mgcIcon-presentation_2_cute_fi.icon';
import { mgcIconPresentation3CuteFi } from './mgcIcon-presentation_3_cute_fi.icon';
import { mgcIconPumpkinLanternCuteFi } from './mgcIcon-pumpkin_lantern_cute_fi.icon';
import { mgcIconReceiveMoneyCuteFi } from './mgcIcon-receive_money_cute_fi.icon';
import { mgcIconRedPacketCuteFi } from './mgcIcon-red_packet_cute_fi.icon';
import { mgcIconRedPacketOpenCuteFi } from './mgcIcon-red_packet_open_cute_fi.icon';
import { mgcIconRefundCnyCuteFi } from './mgcIcon-refund_cny_cute_fi.icon';
import { mgcIconRefundDollarCuteFi } from './mgcIcon-refund_dollar_cute_fi.icon';
import { mgcIconRegisteredCuteFi } from './mgcIcon-registered_cute_fi.icon';
import { mgcIconSafeBoxCuteFi } from './mgcIcon-safe_box_cute_fi.icon';
import { mgcIconSaleCuteFi } from './mgcIcon-sale_cute_fi.icon';
import { mgcIconScheduleCuteFi } from './mgcIcon-schedule_cute_fi.icon';
import { mgcIconSealCuteFi } from './mgcIcon-seal_cute_fi.icon';
import { mgcIconShoppingBag1CuteFi } from './mgcIcon-shopping_bag_1_cute_fi.icon';
import { mgcIconShoppingBag2CuteFi } from './mgcIcon-shopping_bag_2_cute_fi.icon';
import { mgcIconShoppingBag3CuteFi } from './mgcIcon-shopping_bag_3_cute_fi.icon';
import { mgcIconShoppingCart1CuteFi } from './mgcIcon-shopping_cart_1_cute_fi.icon';
import { mgcIconShoppingCart2CuteFi } from './mgcIcon-shopping_cart_2_cute_fi.icon';
import { mgcIconSofaCuteFi } from './mgcIcon-sofa_cute_fi.icon';
import { mgcIconStockCuteFi } from './mgcIcon-stock_cute_fi.icon';
import { mgcIconSuitcase2CuteFi } from './mgcIcon-suitcase_2_cute_fi.icon';
import { mgcIconSuitcaseCuteFi } from './mgcIcon-suitcase_cute_fi.icon';
import { mgcIconTag2CuteFi } from './mgcIcon-tag_2_cute_fi.icon';
import { mgcIconTagChevronCuteFi } from './mgcIcon-tag_chevron_cute_fi.icon';
import { mgcIconTagCuteFi } from './mgcIcon-tag_cute_fi.icon';
import { mgcIconTargetCuteFi } from './mgcIcon-target_cute_fi.icon';
import { mgcIconTicketCuteFi } from './mgcIcon-ticket_cute_fi.icon';
import { mgcIconTrophyCuteFi } from './mgcIcon-trophy_cute_fi.icon';
import { mgcIconVip1CuteFi } from './mgcIcon-VIP_1_cute_fi.icon';
import { mgcIconVip2CuteFi } from './mgcIcon-VIP_2_cute_fi.icon';
import { mgcIconVip3CuteFi } from './mgcIcon-VIP_3_cute_fi.icon';
import { mgcIconVip4CuteFi } from './mgcIcon-VIP_4_cute_fi.icon';
import { mgcIconWallet2CuteFi } from './mgcIcon-wallet_2_cute_fi.icon';
import { mgcIconWallet3CuteFi } from './mgcIcon-wallet_3_cute_fi.icon';
import { mgcIconWallet4CuteFi } from './mgcIcon-wallet_4_cute_fi.icon';
import { mgcIconWallet5CuteFi } from './mgcIcon-wallet_5_cute_fi.icon';
import { mgcIconWalletCuteFi } from './mgcIcon-wallet_cute_fi.icon';
import { mgcIconYuanbaoCuteFi } from './mgcIcon-yuanbao_cute_fi.icon';
import { mgcIconChat1CuteFi } from './mgcIcon-chat_1_cute_fi.icon';
import { mgcIconChat2CuteFi } from './mgcIcon-chat_2_cute_fi.icon';
import { mgcIconChat3CuteFi } from './mgcIcon-chat_3_cute_fi.icon';
import { mgcIconChat4CuteFi } from './mgcIcon-chat_4_cute_fi.icon';
import { mgcIconComment2CuteFi } from './mgcIcon-comment_2_cute_fi.icon';
import { mgcIconCommentCuteFi } from './mgcIcon-comment_cute_fi.icon';
import { mgcIconInviteCuteFi } from './mgcIcon-invite_cute_fi.icon';
import { mgcIconMailAiCuteFi } from './mgcIcon-mail_ai_cute_fi.icon';
import { mgcIconMailCuteFi } from './mgcIcon-mail_cute_fi.icon';
import { mgcIconMailOpenCuteFi } from './mgcIcon-mail_open_cute_fi.icon';
import { mgcIconMailSendCuteFi } from './mgcIcon-mail_send_cute_fi.icon';
import { mgcIconMailboxCuteFi } from './mgcIcon-mailbox_cute_fi.icon';
import { mgcIconMessage1CuteFi } from './mgcIcon-message_1_cute_fi.icon';
import { mgcIconMessage2CuteFi } from './mgcIcon-message_2_cute_fi.icon';
import { mgcIconMessage3CuteFi } from './mgcIcon-message_3_cute_fi.icon';
import { mgcIconMessage4CuteFi } from './mgcIcon-message_4_cute_fi.icon';
import { mgcIconPhoneAddCuteFi } from './mgcIcon-phone_add_cute_fi.icon';
import { mgcIconPhoneBlockCuteFi } from './mgcIcon-phone_block_cute_fi.icon';
import { mgcIconPhoneCallCuteFi } from './mgcIcon-phone_call_cute_fi.icon';
import { mgcIconPhoneCuteFi } from './mgcIcon-phone_cute_fi.icon';
import { mgcIconPhoneIncomingCuteFi } from './mgcIcon-phone_incoming_cute_fi.icon';
import { mgcIconPhoneOffCuteFi } from './mgcIcon-phone_off_cute_fi.icon';
import { mgcIconPhoneOutgoingCuteFi } from './mgcIcon-phone_outgoing_cute_fi.icon';
import { mgcIconPhoneSuccessCuteFi } from './mgcIcon-phone_success_cute_fi.icon';
import { mgcIconSendCuteFi } from './mgcIcon-send_cute_fi.icon';
import { mgcIconSendPlaneCuteFi } from './mgcIcon-send_plane_cute_fi.icon';
import { mgcIconAvalancheAvaxCuteFi } from './mgcIcon-avalanche_AVAX_cute_fi.icon';
import { mgcIconBinanceCoinBnbCuteFi } from './mgcIcon-binance_coin_BNB_cute_fi.icon';
import { mgcIconBinanceUsdBusdCuteFi } from './mgcIcon-binance_USD_BUSD_cute_fi.icon';
import { mgcIconBnbCuteFi } from './mgcIcon-BNB_cute_fi.icon';
import { mgcIconCardanoAdaCuteFi } from './mgcIcon-cardano_ADA_cute_fi.icon';
import { mgcIconCurrencyBitcoin2CuteFi } from './mgcIcon-currency_bitcoin_2_cute_fi.icon';
import { mgcIconCurrencyBitcoinCuteFi } from './mgcIcon-currency_bitcoin_cute_fi.icon';
import { mgcIconDogecoinDogeCuteFi } from './mgcIcon-dogecoin_DOGE_cute_fi.icon';
import { mgcIconEthereumCuteFi } from './mgcIcon-ethereum_cute_fi.icon';
import { mgcIconExchangeBitcoinCuteFi } from './mgcIcon-exchange_bitcoin_cute_fi.icon';
import { mgcIconMoneroCuteFi } from './mgcIcon-monero_cute_fi.icon';
import { mgcIconPolkadotDotCuteFi } from './mgcIcon-polkadot_DOT_cute_fi.icon';
import { mgcIconSolanaSolCuteFi } from './mgcIcon-solana_SOL_cute_fi.icon';
import { mgcIconTetherUsdtCuteFi } from './mgcIcon-tether_USDT_cute_fi.icon';
import { mgcIconUsdCoinUsdcCuteFi } from './mgcIcon-usd_coin_USDC_cute_fi.icon';
import { mgcIconXrpCuteFi } from './mgcIcon-XRP_cute_fi.icon';
import { mgcIconAlignBottomCuteFi } from './mgcIcon-align_bottom_cute_fi.icon';
import { mgcIconAlignHorizontalCenterCuteFi } from './mgcIcon-align_horizontal_center_cute_fi.icon';
import { mgcIconAlignLeft2CuteFi } from './mgcIcon-align_left_2_cute_fi.icon';
import { mgcIconAlignRight2CuteFi } from './mgcIcon-align_right_2_cute_fi.icon';
import { mgcIconAlignTopCuteFi } from './mgcIcon-align_top_cute_fi.icon';
import { mgcIconAlignVerticalCenterCuteFi } from './mgcIcon-align_vertical_center_cute_fi.icon';
import { mgcIconAnticlockwiseAltCuteFi } from './mgcIcon-anticlockwise_alt_cute_fi.icon';
import { mgcIconAnticlockwiseCuteFi } from './mgcIcon-anticlockwise_cute_fi.icon';
import { mgcIconArtboardCuteFi } from './mgcIcon-artboard_cute_fi.icon';
import { mgcIconBackgroundBaseCuteFi } from './mgcIcon-background_base_cute_fi.icon';
import { mgcIconBackgroundCuteFi } from './mgcIcon-background_cute_fi.icon';
import { mgcIconBlingCuteFi } from './mgcIcon-bling_cute_fi.icon';
import { mgcIconBoardCuteFi } from './mgcIcon-board_cute_fi.icon';
import { mgcIconBorderBlankCuteFi } from './mgcIcon-border_blank_cute_fi.icon';
import { mgcIconBorderBottomCuteFi } from './mgcIcon-border_bottom_cute_fi.icon';
import { mgcIconBorderHorizontalCuteFi } from './mgcIcon-border_horizontal_cute_fi.icon';
import { mgcIconBorderInnerCuteFi } from './mgcIcon-border_inner_cute_fi.icon';
import { mgcIconBorderLeftCuteFi } from './mgcIcon-border_left_cute_fi.icon';
import { mgcIconBorderOuterCuteFi } from './mgcIcon-border_outer_cute_fi.icon';
import { mgcIconBorderRadiusCuteFi } from './mgcIcon-border_radius_cute_fi.icon';
import { mgcIconBorderRightCuteFi } from './mgcIcon-border_right_cute_fi.icon';
import { mgcIconBorderTopCuteFi } from './mgcIcon-border_top_cute_fi.icon';
import { mgcIconBorderVerticalCuteFi } from './mgcIcon-border_vertical_cute_fi.icon';
import { mgcIconBrightnessCuteFi } from './mgcIcon-brightness_cute_fi.icon';
import { mgcIconBrush2CuteFi } from './mgcIcon-brush_2_cute_fi.icon';
import { mgcIconClockwiseAltCuteFi } from './mgcIcon-clockwise_alt_cute_fi.icon';
import { mgcIconClockwiseCuteFi } from './mgcIcon-clockwise_cute_fi.icon';
import { mgcIconColorFilterCuteFi } from './mgcIcon-color_filter_cute_fi.icon';
import { mgcIconColorPickerCuteFi } from './mgcIcon-color_picker_cute_fi.icon';
import { mgcIconColumns2CuteFi } from './mgcIcon-columns_2_cute_fi.icon';
import { mgcIconColumns3CuteFi } from './mgcIcon-columns_3_cute_fi.icon';
import { mgcIconCombineCuteFi } from './mgcIcon-combine_cute_fi.icon';
import { mgcIconComponentsCuteFi } from './mgcIcon-components_cute_fi.icon';
import { mgcIconDistributeSpacingHorizontalCuteFi } from './mgcIcon-distribute_spacing_horizontal_cute_fi.icon';
import { mgcIconDistributeSpacingVerticalCuteFi } from './mgcIcon-distribute_spacing_vertical_cute_fi.icon';
import { mgcIconDrawingBoardCuteFi } from './mgcIcon-drawing_board_cute_fi.icon';
import { mgcIconDropCuteFi } from './mgcIcon-drop_cute_fi.icon';
import { mgcIconEaseInControlPointCuteFi } from './mgcIcon-ease_in_control_point_cute_fi.icon';
import { mgcIconEaseInCuteFi } from './mgcIcon-ease_in_cute_fi.icon';
import { mgcIconEaseInOutControlPointCuteFi } from './mgcIcon-ease_in_out_control_point_cute_fi.icon';
import { mgcIconEaseOutControlPointCuteFi } from './mgcIcon-ease_out_control_point_cute_fi.icon';
import { mgcIconEaseOutCuteFi } from './mgcIcon-ease_out_cute_fi.icon';
import { mgcIconEasyInOutCuteFi } from './mgcIcon-easy_in_out_cute_fi.icon';
import { mgcIconExcludeCuteFi } from './mgcIcon-exclude_cute_fi.icon';
import { mgcIconExposureCuteFi } from './mgcIcon-exposure_cute_fi.icon';
import { mgcIconFlipHorizontalCuteFi } from './mgcIcon-flip_horizontal_cute_fi.icon';
import { mgcIconFlipVerticalCuteFi } from './mgcIcon-flip_vertical_cute_fi.icon';
import { mgcIconFoldHorizontalCuteFi } from './mgcIcon-fold_horizontal_cute_fi.icon';
import { mgcIconFoldVerticalCuteFi } from './mgcIcon-fold_vertical_cute_fi.icon';
import { mgcIconIntersectCuteFi } from './mgcIcon-intersect_cute_fi.icon';
import { mgcIconKnifeCuteFi } from './mgcIcon-knife_cute_fi.icon';
import { mgcIconLayerCuteFi } from './mgcIcon-layer_cute_fi.icon';
import { mgcIconLayout10CuteFi } from './mgcIcon-layout_10_cute_fi.icon';
import { mgcIconLayout11CuteFi } from './mgcIcon-layout_11_cute_fi.icon';
import { mgcIconLayout2CuteFi } from './mgcIcon-layout_2_cute_fi.icon';
import { mgcIconLayout3CuteFi } from './mgcIcon-layout_3_cute_fi.icon';
import { mgcIconLayout4CuteFi } from './mgcIcon-layout_4_cute_fi.icon';
import { mgcIconLayout5CuteFi } from './mgcIcon-layout_5_cute_fi.icon';
import { mgcIconLayout6CuteFi } from './mgcIcon-layout_6_cute_fi.icon';
import { mgcIconLayout7CuteFi } from './mgcIcon-layout_7_cute_fi.icon';
import { mgcIconLayout8CuteFi } from './mgcIcon-layout_8_cute_fi.icon';
import { mgcIconLayout9CuteFi } from './mgcIcon-layout_9_cute_fi.icon';
import { mgcIconLayoutBottomCloseCuteFi } from './mgcIcon-layout_bottom_close_cute_fi.icon';
import { mgcIconLayoutBottomCuteFi } from './mgcIcon-layout_bottom_cute_fi.icon';
import { mgcIconLayoutBottomOpenCuteFi } from './mgcIcon-layout_bottom_open_cute_fi.icon';
import { mgcIconLayoutCuteFi } from './mgcIcon-layout_cute_fi.icon';
import { mgcIconLayoutGridCuteFi } from './mgcIcon-layout_grid_cute_fi.icon';
import { mgcIconLayoutLeftCuteFi } from './mgcIcon-layout_left_cute_fi.icon';
import { mgcIconLayoutLeftbarCloseCuteFi } from './mgcIcon-layout_leftbar_close_cute_fi.icon';
import { mgcIconLayoutLeftbarOpenCuteFi } from './mgcIcon-layout_leftbar_open_cute_fi.icon';
import { mgcIconLayoutRightCuteFi } from './mgcIcon-layout_right_cute_fi.icon';
import { mgcIconLayoutRightbarCloseCuteFi } from './mgcIcon-layout_rightbar_close_cute_fi.icon';
import { mgcIconLayoutRightbarOpenCuteFi } from './mgcIcon-layout_rightbar_open_cute_fi.icon';
import { mgcIconLayoutTopCloseCuteFi } from './mgcIcon-layout_top_close_cute_fi.icon';
import { mgcIconLayoutTopCuteFi } from './mgcIcon-layout_top_cute_fi.icon';
import { mgcIconLayoutTopOpenCuteFi } from './mgcIcon-layout_top_open_cute_fi.icon';
import { mgcIconMagic1CuteFi } from './mgcIcon-magic_1_cute_fi.icon';
import { mgcIconMagic2CuteFi } from './mgcIcon-magic_2_cute_fi.icon';
import { mgcIconMagic3CuteFi } from './mgcIcon-magic_3_cute_fi.icon';
import { mgcIconMagicHat2CuteFi } from './mgcIcon-magic_hat_2_cute_fi.icon';
import { mgcIconMagicHatCuteFi } from './mgcIcon-magic_hat_cute_fi.icon';
import { mgcIconMarkPenCuteFi } from './mgcIcon-mark_pen_cute_fi.icon';
import { mgcIconMarkupCuteFi } from './mgcIcon-markup_cute_fi.icon';
import { mgcIconMirrorCuteFi } from './mgcIcon-mirror_cute_fi.icon';
import { mgcIconMosaicCuteFi } from './mgcIcon-mosaic_cute_fi.icon';
import { mgcIconPaint2CuteFi } from './mgcIcon-paint_2_cute_fi.icon';
import { mgcIconPaintBrushAiCuteFi } from './mgcIcon-paint_brush_ai_cute_fi.icon';
import { mgcIconPaintBrushCuteFi } from './mgcIcon-paint_brush_cute_fi.icon';
import { mgcIconPalette2CuteFi } from './mgcIcon-palette_2_cute_fi.icon';
import { mgcIconPaletteCuteFi } from './mgcIcon-palette_cute_fi.icon';
import { mgcIconPasterCuteFi } from './mgcIcon-paster_cute_fi.icon';
import { mgcIconPenCuteFi } from './mgcIcon-pen_cute_fi.icon';
import { mgcIconQuillPenAiCuteFi } from './mgcIcon-quill_pen_ai_cute_fi.icon';
import { mgcIconQuillPenCuteFi } from './mgcIcon-quill_pen_cute_fi.icon';
import { mgcIconRotateXCuteFi } from './mgcIcon-rotate_x_cute_fi.icon';
import { mgcIconRotateYCuteFi } from './mgcIcon-rotate_y_cute_fi.icon';
import { mgcIconRows2CuteFi } from './mgcIcon-rows_2_cute_fi.icon';
import { mgcIconRows3CuteFi } from './mgcIcon-rows_3_cute_fi.icon';
import { mgcIconRows4CuteFi } from './mgcIcon-rows_4_cute_fi.icon';
import { mgcIconRulerCuteFi } from './mgcIcon-ruler_cute_fi.icon';
import { mgcIconScaleCuteFi } from './mgcIcon-scale_cute_fi.icon';
import { mgcIconScissors2CuteFi } from './mgcIcon-scissors_2_cute_fi.icon';
import { mgcIconScissors3CuteFi } from './mgcIcon-scissors_3_cute_fi.icon';
import { mgcIconScissorsCuteFi } from './mgcIcon-scissors_cute_fi.icon';
import { mgcIconScreenshotCuteFi } from './mgcIcon-screenshot_cute_fi.icon';
import { mgcIconSectionCuteFi } from './mgcIcon-section_cute_fi.icon';
import { mgcIconShadowCuteFi } from './mgcIcon-shadow_cute_fi.icon';
import { mgcIconStickerCuteFi } from './mgcIcon-sticker_cute_fi.icon';
import { mgcIconSubtractCuteFi } from './mgcIcon-subtract_cute_fi.icon';
import { mgcIconTable2CuteFi } from './mgcIcon-table_2_cute_fi.icon';
import { mgcIconUnfoldHorizontalCuteFi } from './mgcIcon-unfold_horizontal_cute_fi.icon';
import { mgcIconUnfoldVerticalCuteFi } from './mgcIcon-unfold_vertical_cute_fi.icon';
import { mgcIconUnionCuteFi } from './mgcIcon-union_cute_fi.icon';
import { mgcIconVectorBezier2CuteFi } from './mgcIcon-vector_bezier_2_cute_fi.icon';
import { mgcIconVectorBezier3CuteFi } from './mgcIcon-vector_bezier_3_cute_fi.icon';
import { mgcIconVectorBezierCuteFi } from './mgcIcon-vector_bezier_cute_fi.icon';
import { mgcIconVectorGroupCuteFi } from './mgcIcon-vector_group_cute_fi.icon';
import { mgcIconXSkewCuteFi } from './mgcIcon-x_skew_cute_fi.icon';
import { mgcIconYSkewCuteFi } from './mgcIcon-y_skew_cute_fi.icon';
import { mgcIconBracesCuteFi } from './mgcIcon-braces_cute_fi.icon';
import { mgcIconBracketsAngleCuteFi } from './mgcIcon-brackets_angle_cute_fi.icon';
import { mgcIconBracketsCuteFi } from './mgcIcon-brackets_cute_fi.icon';
import { mgcIconBugCuteFi } from './mgcIcon-bug_cute_fi.icon';
import { mgcIconCodeCuteFi } from './mgcIcon-code_cute_fi.icon';
import { mgcIconCommandCuteFi } from './mgcIcon-command_cute_fi.icon';
import { mgcIconCursor2CuteFi } from './mgcIcon-cursor_2_cute_fi.icon';
import { mgcIconCursor3CuteFi } from './mgcIcon-cursor_3_cute_fi.icon';
import { mgcIconCursorCuteFi } from './mgcIcon-cursor_cute_fi.icon';
import { mgcIconDepartmentCuteFi } from './mgcIcon-department_cute_fi.icon';
import { mgcIconDirectoryCuteFi } from './mgcIcon-directory_cute_fi.icon';
import { mgcIconGitBranchCuteFi } from './mgcIcon-git_branch_cute_fi.icon';
import { mgcIconGitCommitCuteFi } from './mgcIcon-git_commit_cute_fi.icon';
import { mgcIconGitCompareCuteFi } from './mgcIcon-git_compare_cute_fi.icon';
import { mgcIconGitMergeCuteFi } from './mgcIcon-git_merge_cute_fi.icon';
import { mgcIconGitPullRequestCloseCuteFi } from './mgcIcon-git_pull_request_close_cute_fi.icon';
import { mgcIconGitPullRequestCuteFi } from './mgcIcon-git_pull_request_cute_fi.icon';
import { mgcIconHotkeyCuteFi } from './mgcIcon-hotkey_cute_fi.icon';
import { mgcIconInspectCuteFi } from './mgcIcon-inspect_cute_fi.icon';
import { mgcIconParenthesesCuteFi } from './mgcIcon-parentheses_cute_fi.icon';
import { mgcIconPerformanceCuteFi } from './mgcIcon-performance_cute_fi.icon';
import { mgcIconSitemapCuteFi } from './mgcIcon-sitemap_cute_fi.icon';
import { mgcIconTerminalBoxCuteFi } from './mgcIcon-terminal_box_cute_fi.icon';
import { mgcIconTerminalCuteFi } from './mgcIcon-terminal_cute_fi.icon';
import { mgcIconWebCuteFi } from './mgcIcon-web_cute_fi.icon';
import { mgcIconAiCuteFi } from './mgcIcon-ai_cute_fi.icon';
import { mgcIconAirConditionCuteFi } from './mgcIcon-air_condition_cute_fi.icon';
import { mgcIconAirConditionOpenCuteFi } from './mgcIcon-air_condition_open_cute_fi.icon';
import { mgcIconAirplayCuteFi } from './mgcIcon-airplay_cute_fi.icon';
import { mgcIconAirpods2CuteFi } from './mgcIcon-airpods_2_cute_fi.icon';
import { mgcIconAlarm1CuteFi } from './mgcIcon-alarm_1_cute_fi.icon';
import { mgcIconAlarm2CuteFi } from './mgcIcon-alarm_2_cute_fi.icon';
import { mgcIconAspectRatioCuteFi } from './mgcIcon-aspect_ratio_cute_fi.icon';
import { mgcIconBarcodeCuteFi } from './mgcIcon-barcode_cute_fi.icon';
import { mgcIconBarcodeScaCuteFi } from './mgcIcon-barcode_sca_cute_fi.icon';
import { mgcIconBaseStation2CuteFi } from './mgcIcon-base_station_2_cute_fi.icon';
import { mgcIconBaseStationCuteFi } from './mgcIcon-base_station_cute_fi.icon';
import { mgcIconBattery1CuteFi } from './mgcIcon-battery_1_cute_fi.icon';
import { mgcIconBattery2CuteFi } from './mgcIcon-battery_2_cute_fi.icon';
import { mgcIconBattery3CuteFi } from './mgcIcon-battery_3_cute_fi.icon';
import { mgcIconBattery4CuteFi } from './mgcIcon-battery_4_cute_fi.icon';
import { mgcIconBatteryAutomotiveCuteFi } from './mgcIcon-battery_automotive_cute_fi.icon';
import { mgcIconBatteryChargingCuteFi } from './mgcIcon-battery_charging_cute_fi.icon';
import { mgcIconBatteryCuteFi } from './mgcIcon-battery_cute_fi.icon';
import { mgcIconBluetoothCuteFi } from './mgcIcon-bluetooth_cute_fi.icon';
import { mgcIconBluetoothOffCuteFi } from './mgcIcon-bluetooth_off_cute_fi.icon';
import { mgcIconBulb2CuteFi } from './mgcIcon-bulb_2_cute_fi.icon';
import { mgcIconBulbCuteFi } from './mgcIcon-bulb_cute_fi.icon';
import { mgcIconCamcorder2CuteFi } from './mgcIcon-camcorder_2_cute_fi.icon';
import { mgcIconCardboardVrCuteFi } from './mgcIcon-cardboard_vr_cute_fi.icon';
import { mgcIconCeilingLampCuteFi } from './mgcIcon-ceiling_lamp_cute_fi.icon';
import { mgcIconCellphone2AiCuteFi } from './mgcIcon-cellphone_2_ai_cute_fi.icon';
import { mgcIconCellphone2CuteFi } from './mgcIcon-cellphone_2_cute_fi.icon';
import { mgcIconCellphone2HorizontalCuteFi } from './mgcIcon-cellphone_2_horizontal_cute_fi.icon';
import { mgcIconCellphoneCuteFi } from './mgcIcon-cellphone_cute_fi.icon';
import { mgcIconCellphoneVibrationCuteFi } from './mgcIcon-cellphone_vibration_cute_fi.icon';
import { mgcIconChipCuteFi } from './mgcIcon-chip_cute_fi.icon';
import { mgcIconComputerCamerCuteFi } from './mgcIcon-computer_camer_cute_fi.icon';
import { mgcIconComputerCameraOffCuteFi } from './mgcIcon-computer_camera_off_cute_fi.icon';
import { mgcIconComputerCuteFi } from './mgcIcon-computer_cute_fi.icon';
import { mgcIconCounter2CuteFi } from './mgcIcon-counter_2_cute_fi.icon';
import { mgcIconCube3DCuteFi } from './mgcIcon-cube_3d_cute_fi.icon';
import { mgcIconDashboard2CuteFi } from './mgcIcon-dashboard_2_cute_fi.icon';
import { mgcIconDashboard3CuteFi } from './mgcIcon-dashboard_3_cute_fi.icon';
import { mgcIconDashboard4CuteFi } from './mgcIcon-dashboard_4_cute_fi.icon';
import { mgcIconDashboardCuteFi } from './mgcIcon-dashboard_cute_fi.icon';
import { mgcIconDeskLamp2CuteFi } from './mgcIcon-desk_lamp_2_cute_fi.icon';
import { mgcIconDeskLampCuteFi } from './mgcIcon-desk_lamp_cute_fi.icon';
import { mgcIconDeviceCuteFi } from './mgcIcon-device_cute_fi.icon';
import { mgcIconDisplayCuteFi } from './mgcIcon-display_cute_fi.icon';
import { mgcIconDroneCuteFi } from './mgcIcon-drone_cute_fi.icon';
import { mgcIconEscalatorDownCuteFi } from './mgcIcon-escalator_down_cute_fi.icon';
import { mgcIconEscalatorUpCuteFi } from './mgcIcon-escalator_up_cute_fi.icon';
import { mgcIconFaxCuteFi } from './mgcIcon-fax_cute_fi.icon';
import { mgcIconFlashCircleCuteFi } from './mgcIcon-flash_circle_cute_fi.icon';
import { mgcIconFlashCuteFi } from './mgcIcon-flash_cute_fi.icon';
import { mgcIconFlashlightCuteFi } from './mgcIcon-flashlight_cute_fi.icon';
import { mgcIconFridgeCuteFi } from './mgcIcon-fridge_cute_fi.icon';
import { mgcIconGame1CuteFi } from './mgcIcon-game_1_cute_fi.icon';
import { mgcIconGame2CuteFi } from './mgcIcon-game_2_cute_fi.icon';
import { mgcIconGradienterCuteFi } from './mgcIcon-gradienter_cute_fi.icon';
import { mgcIconGuitarCuteFi } from './mgcIcon-guitar_cute_fi.icon';
import { mgcIconHighVoltagePowerCuteFi } from './mgcIcon-high_voltage_power_cute_fi.icon';
import { mgcIconHomeWifiCuteFi } from './mgcIcon-home_wifi_cute_fi.icon';
import { mgcIconHomepodCuteFi } from './mgcIcon-homepod_cute_fi.icon';
import { mgcIconHomepodMiniCuteFi } from './mgcIcon-homepod_mini_cute_fi.icon';
import { mgcIconIMacCuteFi } from './mgcIcon-iMac_cute_fi.icon';
import { mgcIconInstrumentCuteFi } from './mgcIcon-instrument_cute_fi.icon';
import { mgcIconKeyboard2CuteFi } from './mgcIcon-keyboard_2_cute_fi.icon';
import { mgcIconKeyboardCuteFi } from './mgcIcon-keyboard_cute_fi.icon';
import { mgcIconLaptop2CuteFi } from './mgcIcon-laptop_2_cute_fi.icon';
import { mgcIconLaptopCuteFi } from './mgcIcon-laptop_cute_fi.icon';
import { mgcIconLightCuteFi } from './mgcIcon-light_cute_fi.icon';
import { mgcIconMicroscopeCuteFi } from './mgcIcon-microscope_cute_fi.icon';
import { mgcIconMidiCuteFi } from './mgcIcon-midi_cute_fi.icon';
import { mgcIconMonitorCuteFi } from './mgcIcon-monitor_cute_fi.icon';
import { mgcIconMouseCuteFi } from './mgcIcon-mouse_cute_fi.icon';
import { mgcIconPadCuteFi } from './mgcIcon-pad_cute_fi.icon';
import { mgcIconPanoramasCuteFi } from './mgcIcon-panoramas_cute_fi.icon';
import { mgcIconPlugin2CuteFi } from './mgcIcon-plugin_2_cute_fi.icon';
import { mgcIconPluginCuteFi } from './mgcIcon-plugin_cute_fi.icon';
import { mgcIconPrintCuteFi } from './mgcIcon-print_cute_fi.icon';
import { mgcIconProjectorCuteFi } from './mgcIcon-projector_cute_fi.icon';
import { mgcIconProjectorScreenCuteFi } from './mgcIcon-projector_screen_cute_fi.icon';
import { mgcIconQrcode2CuteFi } from './mgcIcon-qrcode_2_cute_fi.icon';
import { mgcIconQrcodeCuteFi } from './mgcIcon-qrcode_cute_fi.icon';
import { mgcIconRadaCuteFi } from './mgcIcon-rada_cute_fi.icon';
import { mgcIconRadar2CuteFi } from './mgcIcon-radar_2_cute_fi.icon';
import { mgcIconRadioCuteFi } from './mgcIcon-radio_cute_fi.icon';
import { mgcIconRemoteControlCuteFi } from './mgcIcon-remote_control_cute_fi.icon';
import { mgcIconRemoteCuteFi } from './mgcIcon-remote_cute_fi.icon';
import { mgcIconRouterModemCuteFi } from './mgcIcon-router_modem_cute_fi.icon';
import { mgcIconRss2CuteFi } from './mgcIcon-rss_2_cute_fi.icon';
import { mgcIconRssCuteFi } from './mgcIcon-rss_cute_fi.icon';
import { mgcIconSandglass2CuteFi } from './mgcIcon-sandglass_2_cute_fi.icon';
import { mgcIconSandglassCuteFi } from './mgcIcon-sandglass_cute_fi.icon';
import { mgcIconScan2CuteFi } from './mgcIcon-scan_2_cute_fi.icon';
import { mgcIconScanCuteFi } from './mgcIcon-scan_cute_fi.icon';
import { mgcIconServer2CuteFi } from './mgcIcon-server_2_cute_fi.icon';
import { mgcIconServerCuteFi } from './mgcIcon-server_cute_fi.icon';
import { mgcIconShowerCuteFi } from './mgcIcon-shower_cute_fi.icon';
import { mgcIconSignalCuteFi } from './mgcIcon-signal_cute_fi.icon';
import { mgcIconSolarPanelCuteFi } from './mgcIcon-solar_panel_cute_fi.icon';
import { mgcIconSpeakerCuteFi } from './mgcIcon-speaker_cute_fi.icon';
import { mgcIconStopwatchCuteFi } from './mgcIcon-stopwatch_cute_fi.icon';
import { mgcIconStorageCuteFi } from './mgcIcon-storage_cute_fi.icon';
import { mgcIconTelescope2CuteFi } from './mgcIcon-telescope_2_cute_fi.icon';
import { mgcIconTelescopeCuteFi } from './mgcIcon-telescope_cute_fi.icon';
import { mgcIconTowerCraneCuteFi } from './mgcIcon-tower_crane_cute_fi.icon';
import { mgcIconTv1CuteFi } from './mgcIcon-tv_1_cute_fi.icon';
import { mgcIconTv2CuteFi } from './mgcIcon-tv_2_cute_fi.icon';
import { mgcIconUsbCuteFi } from './mgcIcon-usb_cute_fi.icon';
import { mgcIconUsbFlashDiskCuteFi } from './mgcIcon-usb_flash_disk_cute_fi.icon';
import { mgcIconVisonProCuteFi } from './mgcIcon-vison_pro_cute_fi.icon';
import { mgcIconWashMachineCuteFi } from './mgcIcon-wash_machine_cute_fi.icon';
import { mgcIconWatch2CuteFi } from './mgcIcon-watch_2_cute_fi.icon';
import { mgcIconWatchCuteFi } from './mgcIcon-watch_cute_fi.icon';
import { mgcIconWifiCuteFi } from './mgcIcon-wifi_cute_fi.icon';
import { mgcIconWifiOffCuteFi } from './mgcIcon-wifi_off_cute_fi.icon';
import { mgcIconAlignCenterCuteFi } from './mgcIcon-align_center_cute_fi.icon';
import { mgcIconAlignJustifyCuteFi } from './mgcIcon-align_justify_cute_fi.icon';
import { mgcIconAlignLeftCuteFi } from './mgcIcon-align_left_cute_fi.icon';
import { mgcIconAlignRightCuteFi } from './mgcIcon-align_right_cute_fi.icon';
import { mgcIconAndCuteFi } from './mgcIcon-and_cute_fi.icon';
import { mgcIconAsterisk2CuteFi } from './mgcIcon-asterisk_2_cute_fi.icon';
import { mgcIconAsteriskCuteFi } from './mgcIcon-asterisk_cute_fi.icon';
import { mgcIconAtCuteFi } from './mgcIcon-at_cute_fi.icon';
import { mgcIconAzSortAscendingLettersCuteFi } from './mgcIcon-AZ_sort_ascending_letters_cute_fi.icon';
import { mgcIconAzSortDescendingLettersCuteFi } from './mgcIcon-AZ_sort_descending_letters_cute_fi.icon';
import { mgcIconBlockquoteCuteFi } from './mgcIcon-blockquote_cute_fi.icon';
import { mgcIconBoldCuteFi } from './mgcIcon-bold_cute_fi.icon';
import { mgcIconColumnCuteFi } from './mgcIcon-column_cute_fi.icon';
import { mgcIconContentAiCuteFi } from './mgcIcon-content_ai_cute_fi.icon';
import { mgcIconCursorTextCuteFi } from './mgcIcon-cursor_text_cute_fi.icon';
import { mgcIconDividingLineCuteFi } from './mgcIcon-dividing_line_cute_fi.icon';
import { mgcIconEdit2CuteFi } from './mgcIcon-edit_2_cute_fi.icon';
import { mgcIconEdit3CuteFi } from './mgcIcon-edit_3_cute_fi.icon';
import { mgcIconEdit4CuteFi } from './mgcIcon-edit_4_cute_fi.icon';
import { mgcIconEditCuteFi } from './mgcIcon-edit_cute_fi.icon';
import { mgcIconEraserCuteFi } from './mgcIcon-eraser_cute_fi.icon';
import { mgcIconFontCuteFi } from './mgcIcon-font_cute_fi.icon';
import { mgcIconFontSizeCuteFi } from './mgcIcon-font_size_cute_fi.icon';
import { mgcIconFormulaCuteFi } from './mgcIcon-formula_cute_fi.icon';
import { mgcIconFrameCuteFi } from './mgcIcon-frame_cute_fi.icon';
import { mgcIconHashtagCuteFi } from './mgcIcon-hashtag_cute_fi.icon';
import { mgcIconHeading1CuteFi } from './mgcIcon-heading_1_cute_fi.icon';
import { mgcIconHeading2CuteFi } from './mgcIcon-heading_2_cute_fi.icon';
import { mgcIconHeading3CuteFi } from './mgcIcon-heading_3_cute_fi.icon';
import { mgcIconIndentDecreaseCuteFi } from './mgcIcon-indent_decrease_cute_fi.icon';
import { mgcIconIndentIncreaseCuteFi } from './mgcIcon-indent_increase_cute_fi.icon';
import { mgcIconItalicCuteFi } from './mgcIcon-italic_cute_fi.icon';
import { mgcIconLetterSpacingCuteFi } from './mgcIcon-letter_spacing_cute_fi.icon';
import { mgcIconLineHeightCuteFi } from './mgcIcon-line_height_cute_fi.icon';
import { mgcIconListCheck2CuteFi } from './mgcIcon-list_check_2_cute_fi.icon';
import { mgcIconListCheck3CuteFi } from './mgcIcon-list_check_3_cute_fi.icon';
import { mgcIconListCheckCuteFi } from './mgcIcon-list_check_cute_fi.icon';
import { mgcIconListCollapseCuteFi } from './mgcIcon-list_collapse_cute_fi.icon';
import { mgcIconListExpansionCuteFi } from './mgcIcon-list_expansion_cute_fi.icon';
import { mgcIconListOrderedCuteFi } from './mgcIcon-list_ordered_cute_fi.icon';
import { mgcIconListSearchCuteFi } from './mgcIcon-list_search_cute_fi.icon';
import { mgcIconMenuCuteFi } from './mgcIcon-menu_cute_fi.icon';
import { mgcIconNumbers09SortAscendingCuteFi } from './mgcIcon-numbers_09_sort_ascending_cute_fi.icon';
import { mgcIconNumbers09SortDescendingCuteFi } from './mgcIcon-numbers_09_sort_descending_cute_fi.icon';
import { mgcIconNumbers90SortAscendingCuteFi } from './mgcIcon-numbers_90_sort_ascending_cute_fi.icon';
import { mgcIconNumbers90SortDescendingCuteFi } from './mgcIcon-numbers_90_sort_descending_cute_fi.icon';
import { mgcIconOmegaCuteFi } from './mgcIcon-omega_cute_fi.icon';
import { mgcIconPaintCuteFi } from './mgcIcon-paint_cute_fi.icon';
import { mgcIconParagraphCuteFi } from './mgcIcon-paragraph_cute_fi.icon';
import { mgcIconPen2CuteFi } from './mgcIcon-pen_2_cute_fi.icon';
import { mgcIconPencil2AiCuteFi } from './mgcIcon-pencil_2_ai_cute_fi.icon';
import { mgcIconPencil2CuteFi } from './mgcIcon-pencil_2_cute_fi.icon';
import { mgcIconPencil3CuteFi } from './mgcIcon-pencil_3_cute_fi.icon';
import { mgcIconPencilCuteFi } from './mgcIcon-pencil_cute_fi.icon';
import { mgcIconPencilRulerCuteFi } from './mgcIcon-pencil_ruler_cute_fi.icon';
import { mgcIconQuoteLeftCuteFi } from './mgcIcon-quote_left_cute_fi.icon';
import { mgcIconQuoteRightCuteFi } from './mgcIcon-quote_right_cute_fi.icon';
import { mgcIconSignatureCuteFi } from './mgcIcon-signature_cute_fi.icon';
import { mgcIconSortAscendingCuteFi } from './mgcIcon-sort_ascending_cute_fi.icon';
import { mgcIconSortDescendingCuteFi } from './mgcIcon-sort_descending_cute_fi.icon';
import { mgcIconSpaceCuteFi } from './mgcIcon-space_cute_fi.icon';
import { mgcIconSpacingHorizontalCuteFi } from './mgcIcon-spacing_horizontal_cute_fi.icon';
import { mgcIconSpacingVerticalCuteFi } from './mgcIcon-spacing_vertical_cute_fi.icon';
import { mgcIconStrikethroughCuteFi } from './mgcIcon-strikethrough_cute_fi.icon';
import { mgcIconSubtitleCuteFi } from './mgcIcon-subtitle_cute_fi.icon';
import { mgcIconTable3CuteFi } from './mgcIcon-table_3_cute_fi.icon';
import { mgcIconTableCuteFi } from './mgcIcon-table_cute_fi.icon';
import { mgcIconText2CuteFi } from './mgcIcon-text_2_cute_fi.icon';
import { mgcIconTextAreaCuteFi } from './mgcIcon-text_area_cute_fi.icon';
import { mgcIconTextColorCuteFi } from './mgcIcon-text_color_cute_fi.icon';
import { mgcIconTextCuteFi } from './mgcIcon-text_cute_fi.icon';
import { mgcIconTextDirectionLeftCuteFi } from './mgcIcon-text_direction_left_cute_fi.icon';
import { mgcIconTextDirectionRightCuteFi } from './mgcIcon-text_direction_right_cute_fi.icon';
import { mgcIconTextboxAiCuteFi } from './mgcIcon-textbox_ai_cute_fi.icon';
import { mgcIconTextboxCuteFi } from './mgcIcon-textbox_cute_fi.icon';
import { mgcIconTranslate2AiCuteFi } from './mgcIcon-translate_2_ai_cute_fi.icon';
import { mgcIconTranslate2CuteFi } from './mgcIcon-translate_2_cute_fi.icon';
import { mgcIconTranslateCuteFi } from './mgcIcon-translate_cute_fi.icon';
import { mgcIconUnderlineCuteFi } from './mgcIcon-underline_cute_fi.icon';
import { mgcIconZaSortAscendingLettersCuteFi } from './mgcIcon-ZA_sort_ascending_letters_cute_fi.icon';
import { mgcIconZaSortDescendingLettersCuteFi } from './mgcIcon-ZA_sort_descending_letters_cute_fi.icon';
import { mgcIconBackpackCuteFi } from './mgcIcon-backpack_cute_fi.icon';
import { mgcIconBalanceCuteFi } from './mgcIcon-balance_cute_fi.icon';
import { mgcIconBlackBoard2CuteFi } from './mgcIcon-black_board_2_cute_fi.icon';
import { mgcIconBlackBoardCuteFi } from './mgcIcon-black_board_cute_fi.icon';
import { mgcIconBook2CuteFi } from './mgcIcon-book_2_cute_fi.icon';
import { mgcIconBook3CuteFi } from './mgcIcon-book_3_cute_fi.icon';
import { mgcIconBook4CuteFi } from './mgcIcon-book_4_cute_fi.icon';
import { mgcIconBook5CuteFi } from './mgcIcon-book_5_cute_fi.icon';
import { mgcIconBook6CuteFi } from './mgcIcon-book_6_cute_fi.icon';
import { mgcIconBookCuteFi } from './mgcIcon-book_cute_fi.icon';
import { mgcIconBookmarkAddCuteFi } from './mgcIcon-bookmark_add_cute_fi.icon';
import { mgcIconBookmarkCuteFi } from './mgcIcon-bookmark_cute_fi.icon';
import { mgcIconBookmarkEditCuteFi } from './mgcIcon-bookmark_edit_cute_fi.icon';
import { mgcIconBookmarkRemoveCuteFi } from './mgcIcon-bookmark_remove_cute_fi.icon';
import { mgcIconBookmarksCuteFi } from './mgcIcon-bookmarks_cute_fi.icon';
import { mgcIconCertificate2CuteFi } from './mgcIcon-certificate_2_cute_fi.icon';
import { mgcIconCompass2CuteFi } from './mgcIcon-compass_2_cute_fi.icon';
import { mgcIconCounterCuteFi } from './mgcIcon-counter_cute_fi.icon';
import { mgcIconDeskCuteFi } from './mgcIcon-desk_cute_fi.icon';
import { mgcIconDiaryCuteFi } from './mgcIcon-diary_cute_fi.icon';
import { mgcIconDrumCuteFi } from './mgcIcon-drum_cute_fi.icon';
import { mgcIconEyeglassCuteFi } from './mgcIcon-eyeglass_cute_fi.icon';
import { mgcIconFlask2CuteFi } from './mgcIcon-flask_2_cute_fi.icon';
import { mgcIconFlask3CuteFi } from './mgcIcon-flask_3_cute_fi.icon';
import { mgcIconFlaskCuteFi } from './mgcIcon-flask_cute_fi.icon';
import { mgcIconFoldingFanCuteFi } from './mgcIcon-folding_fan_cute_fi.icon';
import { mgcIconGlobeCuteFi } from './mgcIcon-globe_cute_fi.icon';
import { mgcIconMagnetCuteFi } from './mgcIcon-magnet_cute_fi.icon';
import { mgcIconMortarboardCuteFi } from './mgcIcon-mortarboard_cute_fi.icon';
import { mgcIconNotebook2CuteFi } from './mgcIcon-notebook_2_cute_fi.icon';
import { mgcIconNotebookCuteFi } from './mgcIcon-notebook_cute_fi.icon';
import { mgcIconScienceCuteFi } from './mgcIcon-science_cute_fi.icon';
import { mgcIconSpeechCuteFi } from './mgcIcon-speech_cute_fi.icon';
import { mgcIconTestTubeCuteFi } from './mgcIcon-test_tube_cute_fi.icon';
import { mgcIconAngelCuteFi } from './mgcIcon-angel_cute_fi.icon';
import { mgcIconAngryCuteFi } from './mgcIcon-angry_cute_fi.icon';
import { mgcIconConfusedCuteFi } from './mgcIcon-confused_cute_fi.icon';
import { mgcIconEmoji2CuteFi } from './mgcIcon-emoji_2_cute_fi.icon';
import { mgcIconEmojiCuteFi } from './mgcIcon-emoji_cute_fi.icon';
import { mgcIconHappyCuteFi } from './mgcIcon-happy_cute_fi.icon';
import { mgcIconLaughCuteFi } from './mgcIcon-laugh_cute_fi.icon';
import { mgcIconLookDownCuteFi } from './mgcIcon-look_down_cute_fi.icon';
import { mgcIconLookLeftCuteFi } from './mgcIcon-look_left_cute_fi.icon';
import { mgcIconLookRightCuteFi } from './mgcIcon-look_right_cute_fi.icon';
import { mgcIconLookUpCuteFi } from './mgcIcon-look_up_cute_fi.icon';
import { mgcIconOmgCuteFi } from './mgcIcon-omg_cute_fi.icon';
import { mgcIconPuzzledCuteFi } from './mgcIcon-puzzled_cute_fi.icon';
import { mgcIconSadCuteFi } from './mgcIcon-sad_cute_fi.icon';
import { mgcIconSickCuteFi } from './mgcIcon-sick_cute_fi.icon';
import { mgcIconSilentCuteFi } from './mgcIcon-silent_cute_fi.icon';
import { mgcIconSobCuteFi } from './mgcIcon-sob_cute_fi.icon';
import { mgcIconSurpriseCuteFi } from './mgcIcon-surprise_cute_fi.icon';
import { mgcIconSweatsCuteFi } from './mgcIcon-sweats_cute_fi.icon';
import { mgcIconTerrorCuteFi } from './mgcIcon-terror_cute_fi.icon';
import { mgcIconTongueCuteFi } from './mgcIcon-tongue_cute_fi.icon';
import { mgcIconUnhappyCuteFi } from './mgcIcon-unhappy_cute_fi.icon';
import { mgcIconUnhappyDizzyCuteFi } from './mgcIcon-unhappy_dizzy_cute_fi.icon';
import { mgcIconAlbum2CuteFi } from './mgcIcon-album_2_cute_fi.icon';
import { mgcIconArchiveCuteFi } from './mgcIcon-archive_cute_fi.icon';
import { mgcIconAttachment2CuteFi } from './mgcIcon-attachment_2_cute_fi.icon';
import { mgcIconAttachmentCuteFi } from './mgcIcon-attachment_cute_fi.icon';
import { mgcIconBill2CuteFi } from './mgcIcon-bill_2_cute_fi.icon';
import { mgcIconBillCuteFi } from './mgcIcon-bill_cute_fi.icon';
import { mgcIconBox2CuteFi } from './mgcIcon-box_2_cute_fi.icon';
import { mgcIconBox3CuteFi } from './mgcIcon-box_3_cute_fi.icon';
import { mgcIconBoxCuteFi } from './mgcIcon-box_cute_fi.icon';
import { mgcIconClipboardCuteFi } from './mgcIcon-clipboard_cute_fi.icon';
import { mgcIconCopy2CuteFi } from './mgcIcon-copy_2_cute_fi.icon';
import { mgcIconCopy3CuteFi } from './mgcIcon-copy_3_cute_fi.icon';
import { mgcIconCopyCuteFi } from './mgcIcon-copy_cute_fi.icon';
import { mgcIconDocCuteFi } from './mgcIcon-doc_cute_fi.icon';
import { mgcIconDocmentCuteFi } from './mgcIcon-docment_cute_fi.icon';
import { mgcIconDocument2CuteFi } from './mgcIcon-document_2_cute_fi.icon';
import { mgcIconDocument3CuteFi } from './mgcIcon-document_3_cute_fi.icon';
import { mgcIconDocumentsCuteFi } from './mgcIcon-documents_cute_fi.icon';
import { mgcIconDownload2CuteFi } from './mgcIcon-download_2_cute_fi.icon';
import { mgcIconDownload3CuteFi } from './mgcIcon-download_3_cute_fi.icon';
import { mgcIconDownloadCuteFi } from './mgcIcon-download_cute_fi.icon';
import { mgcIconEmptyBoxCuteFi } from './mgcIcon-empty_box_cute_fi.icon';
import { mgcIconExternalLinkCuteFi } from './mgcIcon-external_link_cute_fi.icon';
import { mgcIconFileCertificateCuteFi } from './mgcIcon-file_certificate_cute_fi.icon';
import { mgcIconFileCheckCuteFi } from './mgcIcon-file_check_cute_fi.icon';
import { mgcIconFileCodeCuteFi } from './mgcIcon-file_code_cute_fi.icon';
import { mgcIconFileCuteFi } from './mgcIcon-file_cute_fi.icon';
import { mgcIconFileDownloadCuteFi } from './mgcIcon-file_download_cute_fi.icon';
import { mgcIconFileExportCuteFi } from './mgcIcon-file_export_cute_fi.icon';
import { mgcIconFileForbidCuteFi } from './mgcIcon-file_forbid_cute_fi.icon';
import { mgcIconFileImportCuteFi } from './mgcIcon-file_import_cute_fi.icon';
import { mgcIconFileInfoCuteFi } from './mgcIcon-file_info_cute_fi.icon';
import { mgcIconFileLockedCuteFi } from './mgcIcon-file_locked_cute_fi.icon';
import { mgcIconFileMoreCuteFi } from './mgcIcon-file_more_cute_fi.icon';
import { mgcIconFileMusicCuteFi } from './mgcIcon-file_music_cute_fi.icon';
import { mgcIconFileNewCuteFi } from './mgcIcon-file_new_cute_fi.icon';
import { mgcIconFileSearchCuteFi } from './mgcIcon-file_search_cute_fi.icon';
import { mgcIconFileSecurityCuteFi } from './mgcIcon-file_security_cute_fi.icon';
import { mgcIconFileStarCuteFi } from './mgcIcon-file_star_cute_fi.icon';
import { mgcIconFileUnknownCuteFi } from './mgcIcon-file_unknown_cute_fi.icon';
import { mgcIconFileUploadCuteFi } from './mgcIcon-file_upload_cute_fi.icon';
import { mgcIconFileWarningCuteFi } from './mgcIcon-file_warning_cute_fi.icon';
import { mgcIconFileZipCuteFi } from './mgcIcon-file_zip_cute_fi.icon';
import { mgcIconFolder2CuteFi } from './mgcIcon-folder_2_cute_fi.icon';
import { mgcIconFolder3CuteFi } from './mgcIcon-folder_3_cute_fi.icon';
import { mgcIconFolderCheckCuteFi } from './mgcIcon-folder_check_cute_fi.icon';
import { mgcIconFolderCuteFi } from './mgcIcon-folder_cute_fi.icon';
import { mgcIconFolderDeleteCuteFi } from './mgcIcon-folder_delete_cute_fi.icon';
import { mgcIconFolderDownloadCuteFi } from './mgcIcon-folder_download_cute_fi.icon';
import { mgcIconFolderForbidCuteFi } from './mgcIcon-folder_forbid_cute_fi.icon';
import { mgcIconFolderInfoCuteFi } from './mgcIcon-folder_info_cute_fi.icon';
import { mgcIconFolderLocked2CuteFi } from './mgcIcon-folder_locked_2_cute_fi.icon';
import { mgcIconFolderLockedCuteFi } from './mgcIcon-folder_locked_cute_fi.icon';
import { mgcIconFolderMinusCuteFi } from './mgcIcon-folder_minus_cute_fi.icon';
import { mgcIconFolderMoreCuteFi } from './mgcIcon-folder_more_cute_fi.icon';
import { mgcIconFolderOpen2CuteFi } from './mgcIcon-folder_open_2_cute_fi.icon';
import { mgcIconFolderOpenCuteFi } from './mgcIcon-folder_open_cute_fi.icon';
import { mgcIconFolderSecurityCuteFi } from './mgcIcon-folder_security_cute_fi.icon';
import { mgcIconFolderStarCuteFi } from './mgcIcon-folder_star_cute_fi.icon';
import { mgcIconFolderUploadCuteFi } from './mgcIcon-folder_upload_cute_fi.icon';
import { mgcIconFolderWarningCuteFi } from './mgcIcon-folder_warning_cute_fi.icon';
import { mgcIconFolderZipCuteFi } from './mgcIcon-folder_zip_cute_fi.icon';
import { mgcIconFoldersCuteFi } from './mgcIcon-folders_cute_fi.icon';
import { mgcIconInbox2CuteFi } from './mgcIcon-inbox_2_cute_fi.icon';
import { mgcIconInboxCuteFi } from './mgcIcon-inbox_cute_fi.icon';
import { mgcIconInventoryCuteFi } from './mgcIcon-inventory_cute_fi.icon';
import { mgcIconLink2CuteFi } from './mgcIcon-link_2_cute_fi.icon';
import { mgcIconLink3CuteFi } from './mgcIcon-link_3_cute_fi.icon';
import { mgcIconLinkCuteFi } from './mgcIcon-link_cute_fi.icon';
import { mgcIconMarkdownCuteFi } from './mgcIcon-markdown_cute_fi.icon';
import { mgcIconNewFolderCuteFi } from './mgcIcon-new_folder_cute_fi.icon';
import { mgcIconNews2CuteFi } from './mgcIcon-news_2_cute_fi.icon';
import { mgcIconNewsCuteFi } from './mgcIcon-news_cute_fi.icon';
import { mgcIconPackage2CuteFi } from './mgcIcon-package_2_cute_fi.icon';
import { mgcIconPackageCuteFi } from './mgcIcon-package_cute_fi.icon';
import { mgcIconPaper2CuteFi } from './mgcIcon-paper_2_cute_fi.icon';
import { mgcIconPaperCuteFi } from './mgcIcon-paper_cute_fi.icon';
import { mgcIconPassportCuteFi } from './mgcIcon-passport_cute_fi.icon';
import { mgcIconPasteCuteFi } from './mgcIcon-paste_cute_fi.icon';
import { mgcIconPdfCuteFi } from './mgcIcon-pdf_cute_fi.icon';
import { mgcIconPhotoAlbum2CuteFi } from './mgcIcon-photo_album_2_cute_fi.icon';
import { mgcIconPhotoAlbumCuteFi } from './mgcIcon-photo_album_cute_fi.icon';
import { mgcIconPic2CuteFi } from './mgcIcon-pic_2_cute_fi.icon';
import { mgcIconPicAiCuteFi } from './mgcIcon-pic_ai_cute_fi.icon';
import { mgcIconPicCuteFi } from './mgcIcon-pic_cute_fi.icon';
import { mgcIconPin2CuteFi } from './mgcIcon-pin_2_cute_fi.icon';
import { mgcIconPinCuteFi } from './mgcIcon-pin_cute_fi.icon';
import { mgcIconPptCuteFi } from './mgcIcon-ppt_cute_fi.icon';
import { mgcIconProfileCuteFi } from './mgcIcon-profile_cute_fi.icon';
import { mgcIconReportFormsCuteFi } from './mgcIcon-report_forms_cute_fi.icon';
import { mgcIconSave2CuteFi } from './mgcIcon-save_2_cute_fi.icon';
import { mgcIconSaveCuteFi } from './mgcIcon-save_cute_fi.icon';
import { mgcIconSearch2CuteFi } from './mgcIcon-search_2_cute_fi.icon';
import { mgcIconSearch3CuteFi } from './mgcIcon-search_3_cute_fi.icon';
import { mgcIconSearchAiCuteFi } from './mgcIcon-search_ai_cute_fi.icon';
import { mgcIconSearchCuteFi } from './mgcIcon-search_cute_fi.icon';
import { mgcIconTask2CuteFi } from './mgcIcon-task_2_cute_fi.icon';
import { mgcIconTaskCuteFi } from './mgcIcon-task_cute_fi.icon';
import { mgcIconToDoCuteFi } from './mgcIcon-to_do_cute_fi.icon';
import { mgcIconUnarchiveCuteFi } from './mgcIcon-unarchive_cute_fi.icon';
import { mgcIconUnlink2CuteFi } from './mgcIcon-unlink_2_cute_fi.icon';
import { mgcIconUnlinkCuteFi } from './mgcIcon-unlink_cute_fi.icon';
import { mgcIconUpload2CuteFi } from './mgcIcon-upload_2_cute_fi.icon';
import { mgcIconUpload3CuteFi } from './mgcIcon-upload_3_cute_fi.icon';
import { mgcIconUploadCuteFi } from './mgcIcon-upload_cute_fi.icon';
import { mgcIconXlsCuteFi } from './mgcIcon-xls_cute_fi.icon';
import { mgcIconZoomInCuteFi } from './mgcIcon-zoom_in_cute_fi.icon';
import { mgcIconZoomOutCuteFi } from './mgcIcon-zoom_out_cute_fi.icon';
import { mgcIconBirthday2CuteFi } from './mgcIcon-birthday_2_cute_fi.icon';
import { mgcIconBoneCuteFi } from './mgcIcon-bone_cute_fi.icon';
import { mgcIconBottleGlassCuteFi } from './mgcIcon-bottle_glass_cute_fi.icon';
import { mgcIconBowl2CuteFi } from './mgcIcon-bowl_2_cute_fi.icon';
import { mgcIconBowlCuteFi } from './mgcIcon-bowl_cute_fi.icon';
import { mgcIconBreadCuteFi } from './mgcIcon-bread_cute_fi.icon';
import { mgcIconCakeCuteFi } from './mgcIcon-cake_cute_fi.icon';
import { mgcIconCandy2CuteFi } from './mgcIcon-candy_2_cute_fi.icon';
import { mgcIconCandyCuteFi } from './mgcIcon-candy_cute_fi.icon';
import { mgcIconCarrotCuteFi } from './mgcIcon-carrot_cute_fi.icon';
import { mgcIconChampagneCuteFi } from './mgcIcon-champagne_cute_fi.icon';
import { mgcIconChickenCuteFi } from './mgcIcon-chicken_cute_fi.icon';
import { mgcIconChopsticksCuteFi } from './mgcIcon-chopsticks_cute_fi.icon';
import { mgcIconCookieCuteFi } from './mgcIcon-cookie_cute_fi.icon';
import { mgcIconCookieManCuteFi } from './mgcIcon-cookie_man_cute_fi.icon';
import { mgcIconCupcakeCuteFi } from './mgcIcon-cupcake_cute_fi.icon';
import { mgcIconDinnerCuteFi } from './mgcIcon-dinner_cute_fi.icon';
import { mgcIconDishCoverCuteFi } from './mgcIcon-dish_cover_cute_fi.icon';
import { mgcIconDonutCuteFi } from './mgcIcon-donut_cute_fi.icon';
import { mgcIconDrinkCuteFi } from './mgcIcon-drink_cute_fi.icon';
import { mgcIconEggCrackCuteFi } from './mgcIcon-egg_crack_cute_fi.icon';
import { mgcIconEggCuteFi } from './mgcIcon-egg_cute_fi.icon';
import { mgcIconElectricCookerCuteFi } from './mgcIcon-electric_cooker_cute_fi.icon';
import { mgcIconFeederCuteFi } from './mgcIcon-feeder_cute_fi.icon';
import { mgcIconFishCuteFi } from './mgcIcon-fish_cute_fi.icon';
import { mgcIconForkCuteFi } from './mgcIcon-fork_cute_fi.icon';
import { mgcIconForkKnifeCuteFi } from './mgcIcon-fork_knife_cute_fi.icon';
import { mgcIconForkSpoonCuteFi } from './mgcIcon-fork_spoon_cute_fi.icon';
import { mgcIconFriedEggCuteFi } from './mgcIcon-fried_egg_cute_fi.icon';
import { mgcIconFriesCuteFi } from './mgcIcon-fries_cute_fi.icon';
import { mgcIconGlassCupCuteFi } from './mgcIcon-glass_cup_cute_fi.icon';
import { mgcIconHamburgerCuteFi } from './mgcIcon-hamburger_cute_fi.icon';
import { mgcIconIceCream2CuteFi } from './mgcIcon-ice_cream_2_cute_fi.icon';
import { mgcIconIceCreamCuteFi } from './mgcIcon-ice_cream_cute_fi.icon';
import { mgcIconLollipopCuteFi } from './mgcIcon-lollipop_cute_fi.icon';
import { mgcIconPizzaCuteFi } from './mgcIcon-pizza_cute_fi.icon';
import { mgcIconSoupPot2CuteFi } from './mgcIcon-soup_pot_2_cute_fi.icon';
import { mgcIconSoupPotCuteFi } from './mgcIcon-soup_pot_cute_fi.icon';
import { mgcIconSpatulaCuteFi } from './mgcIcon-spatula_cute_fi.icon';
import { mgcIconSpoonCuteFi } from './mgcIcon-spoon_cute_fi.icon';
import { mgcIconSugarCoatedHawsCuteFi } from './mgcIcon-sugar_coated_haws_cute_fi.icon';
import { mgcIconTeacupCuteFi } from './mgcIcon-teacup_cute_fi.icon';
import { mgcIconWineCuteFi } from './mgcIcon-wine_cute_fi.icon';
import { mgcIconWineglass2CuteFi } from './mgcIcon-wineglass_2_cute_fi.icon';
import { mgcIconWineglassCuteFi } from './mgcIcon-wineglass_cute_fi.icon';
import { mgcIconAirbnbCuteFi } from './mgcIcon-airbnb_cute_fi.icon';
import { mgcIconAirdropCuteFi } from './mgcIcon-airdrop_cute_fi.icon';
import { mgcIconAlipayCuteFi } from './mgcIcon-alipay_cute_fi.icon';
import { mgcIconAndroid2CuteFi } from './mgcIcon-Android_2_cute_fi.icon';
import { mgcIconAndroidCuteFi } from './mgcIcon-android_cute_fi.icon';
import { mgcIconAppleCuteFi } from './mgcIcon-apple_cute_fi.icon';
import { mgcIconAppleIntelligenceCuteFi } from './mgcIcon-apple_intelligence_cute_fi.icon';
import { mgcIconAppleIntelligenceFrameCuteFi } from './mgcIcon-apple_intelligence_frame_cute_fi.icon';
import { mgcIconAppstoreCuteFi } from './mgcIcon-appstore_cute_fi.icon';
import { mgcIconArcBrowserCuteFi } from './mgcIcon-arc_browser_cute_fi.icon';
import { mgcIconBehanceCuteFi } from './mgcIcon-behance_cute_fi.icon';
import { mgcIconBilibiliCuteFi } from './mgcIcon-bilibili_cute_fi.icon';
import { mgcIconBlueskySocialCuteFi } from './mgcIcon-bluesky_social_cute_fi.icon';
import { mgcIconCarplayCuteFi } from './mgcIcon-carplay_cute_fi.icon';
import { mgcIconChromeCuteFi } from './mgcIcon-chrome_cute_fi.icon';
import { mgcIconCodepenCuteFi } from './mgcIcon-codepen_cute_fi.icon';
import { mgcIconCopilotCuteFi } from './mgcIcon-copilot_cute_fi.icon';
import { mgcIconDingtalkCuteFi } from './mgcIcon-dingtalk_cute_fi.icon';
import { mgcIconDiscordCuteFi } from './mgcIcon-discord_cute_fi.icon';
import { mgcIconDribbbleCuteFi } from './mgcIcon-dribbble_cute_fi.icon';
import { mgcIconDriveCuteFi } from './mgcIcon-drive_cute_fi.icon';
import { mgcIconDropboxCuteFi } from './mgcIcon-dropbox_cute_fi.icon';
import { mgcIconEdgeCuteFi } from './mgcIcon-edge_cute_fi.icon';
import { mgcIconFacebookCuteFi } from './mgcIcon-facebook_cute_fi.icon';
import { mgcIconFigmaCuteFi } from './mgcIcon-figma_cute_fi.icon';
import { mgcIconFirefoxCuteFi } from './mgcIcon-firefox_cute_fi.icon';
import { mgcIconFollowCuteFi } from './mgcIcon-follow_cute_fi.icon';
import { mgcIconGitLabCuteFi } from './mgcIcon-git_lab_cute_fi.icon';
import { mgcIconGithub2CuteFi } from './mgcIcon-github_2_cute_fi.icon';
import { mgcIconGithubCuteFi } from './mgcIcon-github_cute_fi.icon';
import { mgcIconGoogleCuteFi } from './mgcIcon-google_cute_fi.icon';
import { mgcIconGooglePlayCuteFi } from './mgcIcon-google_play_cute_fi.icon';
import { mgcIconGrokCuteFi } from './mgcIcon-grok_cute_fi.icon';
import { mgcIconGumroadCuteFi } from './mgcIcon-gumroad_cute_fi.icon';
import { mgcIconInstagramCuteFi } from './mgcIcon-instagram_cute_fi.icon';
import { mgcIconKakaoTalkCuteFi } from './mgcIcon-kakao_talk_cute_fi.icon';
import { mgcIconLayersCuteFi } from './mgcIcon-layers_cute_fi.icon';
import { mgcIconLemonSqueezyCuteFi } from './mgcIcon-lemon_squeezy_cute_fi.icon';
import { mgcIconLineAppCuteFi } from './mgcIcon-line_app_cute_fi.icon';
import { mgcIconLinearCuteFi } from './mgcIcon-linear_cute_fi.icon';
import { mgcIconLinkedinCuteFi } from './mgcIcon-linkedin_cute_fi.icon';
import { mgcIconLinuxCuteFi } from './mgcIcon-linux_cute_fi.icon';
import { mgcIconMastercardCuteFi } from './mgcIcon-mastercard_cute_fi.icon';
import { mgcIconMastodonCuteFi } from './mgcIcon-mastodon_cute_fi.icon';
import { mgcIconMediumCuteFi } from './mgcIcon-medium_cute_fi.icon';
import { mgcIconMessengerCuteFi } from './mgcIcon-messenger_cute_fi.icon';
import { mgcIconMetaCuteFi } from './mgcIcon-meta_cute_fi.icon';
import { mgcIconMingcuteCuteFi } from './mgcIcon-mingcute_cute_fi.icon';
import { mgcIconMomentCuteFi } from './mgcIcon-moment_cute_fi.icon';
import { mgcIconNeteaseMusicCuteFi } from './mgcIcon-netease_music_cute_fi.icon';
import { mgcIconNfcCuteFi } from './mgcIcon-nfc_cute_fi.icon';
import { mgcIconNintendoSwitchCuteFi } from './mgcIcon-nintendo_switch_cute_fi.icon';
import { mgcIconNotionCuteFi } from './mgcIcon-notion_cute_fi.icon';
import { mgcIconOpenaiCuteFi } from './mgcIcon-openai_cute_fi.icon';
import { mgcIconPaypalCuteFi } from './mgcIcon-paypal_cute_fi.icon';
import { mgcIconPinterestCuteFi } from './mgcIcon-pinterest_cute_fi.icon';
import { mgcIconQqCuteFi } from './mgcIcon-qq_cute_fi.icon';
import { mgcIconReactCuteFi } from './mgcIcon-react_cute_fi.icon';
import { mgcIconRedditCuteFi } from './mgcIcon-reddit_cute_fi.icon';
import { mgcIconSafariCuteFi } from './mgcIcon-safari_cute_fi.icon';
import { mgcIconSiriCuteFi } from './mgcIcon-siri_cute_fi.icon';
import { mgcIconSiriFrameCuteFi } from './mgcIcon-siri_frame_cute_fi.icon';
import { mgcIconSnapchatCuteFi } from './mgcIcon-snapchat_cute_fi.icon';
import { mgcIconSocialXCuteFi } from './mgcIcon-social_x_cute_fi.icon';
import { mgcIconSpotifyCuteFi } from './mgcIcon-spotify_cute_fi.icon';
import { mgcIconStripeCuteFi } from './mgcIcon-stripe_cute_fi.icon';
import { mgcIconTelegramCuteFi } from './mgcIcon-telegram_cute_fi.icon';
import { mgcIconThreadsCuteFi } from './mgcIcon-threads_cute_fi.icon';
import { mgcIconTiktokCuteFi } from './mgcIcon-tiktok_cute_fi.icon';
import { mgcIconTrelloBoardCuteFi } from './mgcIcon-trello_board_cute_fi.icon';
import { mgcIconTwitterCuteFi } from './mgcIcon-twitter_cute_fi.icon';
import { mgcIconViberMessengerCuteFi } from './mgcIcon-viber_messenger_cute_fi.icon';
import { mgcIconVisaCuteFi } from './mgcIcon-visa_cute_fi.icon';
import { mgcIconVkontakteCuteFi } from './mgcIcon-vkontakte_cute_fi.icon';
import { mgcIconVscodeCuteFi } from './mgcIcon-vscode_cute_fi.icon';
import { mgcIconVueCuteFi } from './mgcIcon-vue_cute_fi.icon';
import { mgcIconWechatCuteFi } from './mgcIcon-wechat_cute_fi.icon';
import { mgcIconWechatMiniprogramCuteFi } from './mgcIcon-wechat_miniprogram_cute_fi.icon';
import { mgcIconWechatPayCuteFi } from './mgcIcon-wechat_pay_cute_fi.icon';
import { mgcIconWeiboCuteFi } from './mgcIcon-weibo_cute_fi.icon';
import { mgcIconWhatsappCuteFi } from './mgcIcon-whatsapp_cute_fi.icon';
import { mgcIconWindowsCuteFi } from './mgcIcon-windows_cute_fi.icon';
import { mgcIconXboxCuteFi } from './mgcIcon-xbox_cute_fi.icon';
import { mgcIconYoutubeCuteFi } from './mgcIcon-youtube_cute_fi.icon';
import { mgcIconAiming2CuteFi } from './mgcIcon-aiming_2_cute_fi.icon';
import { mgcIconAimingCuteFi } from './mgcIcon-aiming_cute_fi.icon';
import { mgcIconAnchorCuteFi } from './mgcIcon-anchor_cute_fi.icon';
import { mgcIconBed2CuteFi } from './mgcIcon-bed_2_cute_fi.icon';
import { mgcIconBedCuteFi } from './mgcIcon-bed_cute_fi.icon';
import { mgcIconClock2CuteFi } from './mgcIcon-clock_2_cute_fi.icon';
import { mgcIconClockCuteFi } from './mgcIcon-clock_cute_fi.icon';
import { mgcIconCompass3CuteFi } from './mgcIcon-compass_3_cute_fi.icon';
import { mgcIconCompassCuteFi } from './mgcIcon-compass_cute_fi.icon';
import { mgcIconDirections2CuteFi } from './mgcIcon-directions_2_cute_fi.icon';
import { mgcIconDirectionsCuteFi } from './mgcIcon-directions_cute_fi.icon';
import { mgcIconEarth2CuteFi } from './mgcIcon-earth_2_cute_fi.icon';
import { mgcIconEarth3CuteFi } from './mgcIcon-earth_3_cute_fi.icon';
import { mgcIconEarthCuteFi } from './mgcIcon-earth_cute_fi.icon';
import { mgcIconEarthLatitudeCuteFi } from './mgcIcon-earth_latitude_cute_fi.icon';
import { mgcIconEarthLongitudeCuteFi } from './mgcIcon-earth_longitude_cute_fi.icon';
import { mgcIconFootCuteFi } from './mgcIcon-foot_cute_fi.icon';
import { mgcIconGlobe2CuteFi } from './mgcIcon-globe_2_cute_fi.icon';
import { mgcIconHoursCuteFi } from './mgcIcon-hours_cute_fi.icon';
import { mgcIconLifebuoyCuteFi } from './mgcIcon-lifebuoy_cute_fi.icon';
import { mgcIconLiveLocationCuteFi } from './mgcIcon-live_location_cute_fi.icon';
import { mgcIconLocation2CuteFi } from './mgcIcon-location_2_cute_fi.icon';
import { mgcIconLocation3CuteFi } from './mgcIcon-location_3_cute_fi.icon';
import { mgcIconLocationCuteFi } from './mgcIcon-location_cute_fi.icon';
import { mgcIconMap2CuteFi } from './mgcIcon-map_2_cute_fi.icon';
import { mgcIconMapCuteFi } from './mgcIcon-map_cute_fi.icon';
import { mgcIconMapPinCuteFi } from './mgcIcon-map_pin_cute_fi.icon';
import { mgcIconNavigationCuteFi } from './mgcIcon-navigation_cute_fi.icon';
import { mgcIconParkingCuteFi } from './mgcIcon-parking_cute_fi.icon';
import { mgcIconPlanetCuteFi } from './mgcIcon-planet_cute_fi.icon';
import { mgcIconRestAreaCuteFi } from './mgcIcon-rest_area_cute_fi.icon';
import { mgcIconRoadCuteFi } from './mgcIcon-road_cute_fi.icon';
import { mgcIconRouteCuteFi } from './mgcIcon-route_cute_fi.icon';
import { mgcIconTrafficConeCuteFi } from './mgcIcon-traffic_cone_cute_fi.icon';
import { mgcIconTunnelCuteFi } from './mgcIcon-tunnel_cute_fi.icon';
import { mgcIconUmbrella2CuteFi } from './mgcIcon-umbrella_2_cute_fi.icon';
import { mgcIconWorld2CuteFi } from './mgcIcon-world_2_cute_fi.icon';
import { mgcIconWorldCuteFi } from './mgcIcon-world_cute_fi.icon';
import { mgcIconAirpodsCuteFi } from './mgcIcon-airpods_cute_fi.icon';
import { mgcIconAlbumCuteFi } from './mgcIcon-album_cute_fi.icon';
import { mgcIconAnnouncementCuteFi } from './mgcIcon-announcement_cute_fi.icon';
import { mgcIconAudioTapeCuteFi } from './mgcIcon-audio_tape_cute_fi.icon';
import { mgcIconBellRingingCuteFi } from './mgcIcon-bell_ringing_cute_fi.icon';
import { mgcIconCamcorder3CuteFi } from './mgcIcon-camcorder_3_cute_fi.icon';
import { mgcIconCamcorderCuteFi } from './mgcIcon-camcorder_cute_fi.icon';
import { mgcIconCamcorderOffCuteFi } from './mgcIcon-camcorder_off_cute_fi.icon';
import { mgcIconCamera2AiCuteFi } from './mgcIcon-camera_2_ai_cute_fi.icon';
import { mgcIconCamera2CuteFi } from './mgcIcon-camera_2_cute_fi.icon';
import { mgcIconCamera2OffCuteFi } from './mgcIcon-camera_2_off_cute_fi.icon';
import { mgcIconCameraCuteFi } from './mgcIcon-camera_cute_fi.icon';
import { mgcIconCameraRotateCuteFi } from './mgcIcon-camera_rotate_cute_fi.icon';
import { mgcIconClapperboardCuteFi } from './mgcIcon-clapperboard_cute_fi.icon';
import { mgcIconDanmakuCuteFi } from './mgcIcon-danmaku_cute_fi.icon';
import { mgcIconDanmakuOffCuteFi } from './mgcIcon-danmaku_off_cute_fi.icon';
import { mgcIconDanmakuOnCuteFi } from './mgcIcon-danmaku_on_cute_fi.icon';
import { mgcIconDiscCuteFi } from './mgcIcon-disc_cute_fi.icon';
import { mgcIconExpandPlayerCuteFi } from './mgcIcon-expand_player_cute_fi.icon';
import { mgcIconFastForwardCuteFi } from './mgcIcon-fast_forward_cute_fi.icon';
import { mgcIconFastRewindCuteFi } from './mgcIcon-fast_rewind_cute_fi.icon';
import { mgcIconFilmCuteFi } from './mgcIcon-film_cute_fi.icon';
import { mgcIconFullscreenCuteFi } from './mgcIcon-fullscreen_cute_fi.icon';
import { mgcIconFullscreenExitCuteFi } from './mgcIcon-fullscreen_exit_cute_fi.icon';
import { mgcIconHeadphone2CuteFi } from './mgcIcon-headphone_2_cute_fi.icon';
import { mgcIconHeadphoneCuteFi } from './mgcIcon-headphone_cute_fi.icon';
import { mgcIconHorn2CuteFi } from './mgcIcon-horn_2_cute_fi.icon';
import { mgcIconHornCuteFi } from './mgcIcon-horn_cute_fi.icon';
import { mgcIconLiveCuteFi } from './mgcIcon-live_cute_fi.icon';
import { mgcIconLivePhotoCuteFi } from './mgcIcon-live_photo_cute_fi.icon';
import { mgcIconMic2CuteFi } from './mgcIcon-mic_2_cute_fi.icon';
import { mgcIconMicAiCuteFi } from './mgcIcon-mic_ai_cute_fi.icon';
import { mgcIconMicCuteFi } from './mgcIcon-mic_cute_fi.icon';
import { mgcIconMicOffCuteFi } from './mgcIcon-mic_off_cute_fi.icon';
import { mgcIconMicrophoneCuteFi } from './mgcIcon-microphone_cute_fi.icon';
import { mgcIconMiniplayerCuteFi } from './mgcIcon-miniplayer_cute_fi.icon';
import { mgcIconMovieCuteFi } from './mgcIcon-movie_cute_fi.icon';
import { mgcIconMusic2AiCuteFi } from './mgcIcon-music_2_ai_cute_fi.icon';
import { mgcIconMusic2CuteFi } from './mgcIcon-music_2_cute_fi.icon';
import { mgcIconMusic3CuteFi } from './mgcIcon-music_3_cute_fi.icon';
import { mgcIconMusicCuteFi } from './mgcIcon-music_cute_fi.icon';
import { mgcIconNotificationCuteFi } from './mgcIcon-notification_cute_fi.icon';
import { mgcIconNotificationNewdotCuteFi } from './mgcIcon-notification_newdot_cute_fi.icon';
import { mgcIconNotificationOffCuteFi } from './mgcIcon-notification_off_cute_fi.icon';
import { mgcIconPauseCircleCuteFi } from './mgcIcon-pause_circle_cute_fi.icon';
import { mgcIconPauseCuteFi } from './mgcIcon-pause_cute_fi.icon';
import { mgcIconPlayCircleCuteFi } from './mgcIcon-play_circle_cute_fi.icon';
import { mgcIconPlayCuteFi } from './mgcIcon-play_cute_fi.icon';
import { mgcIconPlaylist2CuteFi } from './mgcIcon-playlist_2_cute_fi.icon';
import { mgcIconPlaylistCuteFi } from './mgcIcon-playlist_cute_fi.icon';
import { mgcIconRecordMailCuteFi } from './mgcIcon-record_mail_cute_fi.icon';
import { mgcIconRepeatCuteFi } from './mgcIcon-repeat_cute_fi.icon';
import { mgcIconRepeatOneCuteFi } from './mgcIcon-repeat_one_cute_fi.icon';
import { mgcIconRewindBackward10CuteFi } from './mgcIcon-rewind_backward_10_cute_fi.icon';
import { mgcIconRewindBackward15CuteFi } from './mgcIcon-rewind_backward_15_cute_fi.icon';
import { mgcIconRewindBackward30CuteFi } from './mgcIcon-rewind_backward_30_cute_fi.icon';
import { mgcIconRewindBackward5CuteFi } from './mgcIcon-rewind_backward_5_cute_fi.icon';
import { mgcIconRewindBackwardSquare10CuteFi } from './mgcIcon-rewind_backward_square_10_cute_fi.icon';
import { mgcIconRewindBackwardSquare15CuteFi } from './mgcIcon-rewind_backward_square_15_cute_fi.icon';
import { mgcIconRewindBackwardSquare30CuteFi } from './mgcIcon-rewind_backward_square_30_cute_fi.icon';
import { mgcIconRewindBackwardSquare5CuteFi } from './mgcIcon-rewind_backward_square_5_cute_fi.icon';
import { mgcIconRewindForward10CuteFi } from './mgcIcon-rewind_forward_10_cute_fi.icon';
import { mgcIconRewindForward15CuteFi } from './mgcIcon-rewind_forward_15_cute_fi.icon';
import { mgcIconRewindForward30CuteFi } from './mgcIcon-rewind_forward_30_cute_fi.icon';
import { mgcIconRewindForward5CuteFi } from './mgcIcon-rewind_forward_5_cute_fi.icon';
import { mgcIconRewindForwardSquare10CuteFi } from './mgcIcon-rewind_forward_square_10_cute_fi.icon';
import { mgcIconRewindForwardSquare15CuteFi } from './mgcIcon-rewind_forward_square_15_cute_fi.icon';
import { mgcIconRewindForwardSquare30CuteFi } from './mgcIcon-rewind_forward_square_30_cute_fi.icon';
import { mgcIconRewindForwardSquare5CuteFi } from './mgcIcon-rewind_forward_square_5_cute_fi.icon';
import { mgcIconRotateToHorizontalCuteFi } from './mgcIcon-rotate_to_horizontal_cute_fi.icon';
import { mgcIconRotateToVerticalCuteFi } from './mgcIcon-rotate_to_vertical_cute_fi.icon';
import { mgcIconServiceCuteFi } from './mgcIcon-service_cute_fi.icon';
import { mgcIconShuffle2CuteFi } from './mgcIcon-shuffle_2_cute_fi.icon';
import { mgcIconShuffleCuteFi } from './mgcIcon-shuffle_cute_fi.icon';
import { mgcIconSkipForwardCuteFi } from './mgcIcon-skip_forward_cute_fi.icon';
import { mgcIconSkipPreviousCuteFi } from './mgcIcon-skip_previous_cute_fi.icon';
import { mgcIconSoundLineCuteFi } from './mgcIcon-sound_line_cute_fi.icon';
import { mgcIconStopCircleCuteFi } from './mgcIcon-stop_circle_cute_fi.icon';
import { mgcIconStopCuteFi } from './mgcIcon-stop_cute_fi.icon';
import { mgcIconVideoCamera2CuteFi } from './mgcIcon-video_camera_2_cute_fi.icon';
import { mgcIconVideoCameraCuteFi } from './mgcIcon-video_camera_cute_fi.icon';
import { mgcIconVideoCuteFi } from './mgcIcon-video_cute_fi.icon';
import { mgcIconVoice2CuteFi } from './mgcIcon-voice_2_cute_fi.icon';
import { mgcIconVoiceCuteFi } from './mgcIcon-voice_cute_fi.icon';
import { mgcIconVolumeCuteFi } from './mgcIcon-volume_cute_fi.icon';
import { mgcIconVolumeMuteCuteFi } from './mgcIcon-volume_mute_cute_fi.icon';
import { mgcIconVolumeOffCuteFi } from './mgcIcon-volume_off_cute_fi.icon';
import { mgcIconBearCuteFi } from './mgcIcon-bear_cute_fi.icon';
import { mgcIconBirdCuteFi } from './mgcIcon-bird_cute_fi.icon';
import { mgcIconButterfly2CuteFi } from './mgcIcon-butterfly_2_cute_fi.icon';
import { mgcIconButterflyCuteFi } from './mgcIcon-butterfly_cute_fi.icon';
import { mgcIconCactus2CuteFi } from './mgcIcon-cactus_2_cute_fi.icon';
import { mgcIconCactusCuteFi } from './mgcIcon-cactus_cute_fi.icon';
import { mgcIconCampfireCuteFi } from './mgcIcon-campfire_cute_fi.icon';
import { mgcIconCatCuteFi } from './mgcIcon-cat_cute_fi.icon';
import { mgcIconChessCuteFi } from './mgcIcon-chess_cute_fi.icon';
import { mgcIconDandelionCuteFi } from './mgcIcon-dandelion_cute_fi.icon';
import { mgcIconDogCuteFi } from './mgcIcon-dog_cute_fi.icon';
import { mgcIconDragonflyCuteFi } from './mgcIcon-dragonfly_cute_fi.icon';
import { mgcIconFlower2CuteFi } from './mgcIcon-flower_2_cute_fi.icon';
import { mgcIconFlower3CuteFi } from './mgcIcon-flower_3_cute_fi.icon';
import { mgcIconFlower4CuteFi } from './mgcIcon-flower_4_cute_fi.icon';
import { mgcIconFlower5CuteFi } from './mgcIcon-flower_5_cute_fi.icon';
import { mgcIconFlowerCuteFi } from './mgcIcon-flower_cute_fi.icon';
import { mgcIconFlowerpotCuteFi } from './mgcIcon-flowerpot_cute_fi.icon';
import { mgcIconGrassCuteFi } from './mgcIcon-grass_cute_fi.icon';
import { mgcIconLeaf2CuteFi } from './mgcIcon-leaf_2_cute_fi.icon';
import { mgcIconLeaf3CuteFi } from './mgcIcon-leaf_3_cute_fi.icon';
import { mgcIconLeafCuteFi } from './mgcIcon-leaf_cute_fi.icon';
import { mgcIconLotusCuteFi } from './mgcIcon-lotus_cute_fi.icon';
import { mgcIconMapleLeafCuteFi } from './mgcIcon-maple_leaf_cute_fi.icon';
import { mgcIconMickeymouseCuteFi } from './mgcIcon-mickeymouse_cute_fi.icon';
import { mgcIconMountain2CuteFi } from './mgcIcon-mountain_2_cute_fi.icon';
import { mgcIconMountainCuteFi } from './mgcIcon-mountain_cute_fi.icon';
import { mgcIconMushroomCuteFi } from './mgcIcon-mushroom_cute_fi.icon';
import { mgcIconPawCuteFi } from './mgcIcon-paw_cute_fi.icon';
import { mgcIconPigCuteFi } from './mgcIcon-pig_cute_fi.icon';
import { mgcIconPumpkinCuteFi } from './mgcIcon-pumpkin_cute_fi.icon';
import { mgcIconRabbitCuteFi } from './mgcIcon-rabbit_cute_fi.icon';
import { mgcIconSunflowerCuteFi } from './mgcIcon-sunflower_cute_fi.icon';
import { mgcIconToyHorseCuteFi } from './mgcIcon-toy_horse_cute_fi.icon';
import { mgcIconTree2CuteFi } from './mgcIcon-tree_2_cute_fi.icon';
import { mgcIconTree3CuteFi } from './mgcIcon-tree_3_cute_fi.icon';
import { mgcIconTree4CuteFi } from './mgcIcon-tree_4_cute_fi.icon';
import { mgcIconTreeCuteFi } from './mgcIcon-tree_cute_fi.icon';
import { mgcIconWreathCuteFi } from './mgcIcon-wreath_cute_fi.icon';
import { mgcIconAxeCuteFi } from './mgcIcon-axe_cute_fi.icon';
import { mgcIconBalloon2CuteFi } from './mgcIcon-balloon_2_cute_fi.icon';
import { mgcIconBathCuteFi } from './mgcIcon-bath_cute_fi.icon';
import { mgcIconBedsideTable2CuteFi } from './mgcIcon-bedside_table_2_cute_fi.icon';
import { mgcIconBedsideTableCuteFi } from './mgcIcon-bedside_table_cute_fi.icon';
import { mgcIconBlessingCuteFi } from './mgcIcon-blessing_cute_fi.icon';
import { mgcIconBombCuteFi } from './mgcIcon-bomb_cute_fi.icon';
import { mgcIconBoomCuteFi } from './mgcIcon-boom_cute_fi.icon';
import { mgcIconBottleCuteFi } from './mgcIcon-bottle_cute_fi.icon';
import { mgcIconCapsuleCuteFi } from './mgcIcon-capsule_cute_fi.icon';
import { mgcIconCoathangerCuteFi } from './mgcIcon-coathanger_cute_fi.icon';
import { mgcIconCross2CuteFi } from './mgcIcon-cross_2_cute_fi.icon';
import { mgcIconCrystalBallCuteFi } from './mgcIcon-crystal_ball_cute_fi.icon';
import { mgcIconCurtainCuteFi } from './mgcIcon-curtain_cute_fi.icon';
import { mgcIconDrawer2CuteFi } from './mgcIcon-drawer_2_cute_fi.icon';
import { mgcIconDrawerCuteFi } from './mgcIcon-drawer_cute_fi.icon';
import { mgcIconFaceMaskCuteFi } from './mgcIcon-face_mask_cute_fi.icon';
import { mgcIconFirecrackerCuteFi } from './mgcIcon-firecracker_cute_fi.icon';
import { mgcIconFireworkCuteFi } from './mgcIcon-firework_cute_fi.icon';
import { mgcIconFirstAidKitCuteFi } from './mgcIcon-first_aid_kit_cute_fi.icon';
import { mgcIconHammerCuteFi } from './mgcIcon-hammer_cute_fi.icon';
import { mgcIconHandCardCuteFi } from './mgcIcon-hand_card_cute_fi.icon';
import { mgcIconHandHeartCuteFi } from './mgcIcon-hand_heart_cute_fi.icon';
import { mgcIconHoeCuteFi } from './mgcIcon-hoe_cute_fi.icon';
import { mgcIconInjectionCuteFi } from './mgcIcon-injection_cute_fi.icon';
import { mgcIconKiteCuteFi } from './mgcIcon-kite_cute_fi.icon';
import { mgcIconLipstickCuteFi } from './mgcIcon-lipstick_cute_fi.icon';
import { mgcIconNurseCuteFi } from './mgcIcon-nurse_cute_fi.icon';
import { mgcIconParfumCuteFi } from './mgcIcon-parfum_cute_fi.icon';
import { mgcIconPickaxCuteFi } from './mgcIcon-pickax_cute_fi.icon';
import { mgcIconPotCuteFi } from './mgcIcon-pot_cute_fi.icon';
import { mgcIconPrescriptionCuteFi } from './mgcIcon-prescription_cute_fi.icon';
import { mgcIconRakeCuteFi } from './mgcIcon-rake_cute_fi.icon';
import { mgcIconRandomCuteFi } from './mgcIcon-random_cute_fi.icon';
import { mgcIconScrewdriverCuteFi } from './mgcIcon-screwdriver_cute_fi.icon';
import { mgcIconShovelCuteFi } from './mgcIcon-shovel_cute_fi.icon';
import { mgcIconShowerGelCuteFi } from './mgcIcon-shower_gel_cute_fi.icon';
import { mgcIconStar2CuteFi } from './mgcIcon-star_2_cute_fi.icon';
import { mgcIconStarTopperCuteFi } from './mgcIcon-star_topper_cute_fi.icon';
import { mgcIconStethoscopeCuteFi } from './mgcIcon-stethoscope_cute_fi.icon';
import { mgcIconThoughtCuteFi } from './mgcIcon-thought_cute_fi.icon';
import { mgcIconToiletPaperCuteFi } from './mgcIcon-toilet_paper_cute_fi.icon';
import { mgcIconVirusCuteFi } from './mgcIcon-virus_cute_fi.icon';
import { mgcIconWardrobe2CuteFi } from './mgcIcon-wardrobe_2_cute_fi.icon';
import { mgcIconWardrobeCuteFi } from './mgcIcon-wardrobe_cute_fi.icon';
import { mgcIconWateringCanCuteFi } from './mgcIcon-watering_can_cute_fi.icon';
import { mgcIconYinyangCuteFi } from './mgcIcon-yinyang_cute_fi.icon';
import { mgcIconBabyCuteFi } from './mgcIcon-baby_cute_fi.icon';
import { mgcIconBeardCuteFi } from './mgcIcon-beard_cute_fi.icon';
import { mgcIconBodyCuteFi } from './mgcIcon-body_cute_fi.icon';
import { mgcIconBowTieCuteFi } from './mgcIcon-bow_tie_cute_fi.icon';
import { mgcIconBowknotCuteFi } from './mgcIcon-bowknot_cute_fi.icon';
import { mgcIconBrainCuteFi } from './mgcIcon-brain_cute_fi.icon';
import { mgcIconBriefCuteFi } from './mgcIcon-brief_cute_fi.icon';
import { mgcIconChefHatCuteFi } from './mgcIcon-chef_hat_cute_fi.icon';
import { mgcIconChristmasHatCuteFi } from './mgcIcon-christmas_hat_cute_fi.icon';
import { mgcIconCoatCuteFi } from './mgcIcon-coat_cute_fi.icon';
import { mgcIconDeerCuteFi } from './mgcIcon-deer_cute_fi.icon';
import { mgcIconDentalCuteFi } from './mgcIcon-dental_cute_fi.icon';
import { mgcIconDressCuteFi } from './mgcIcon-dress_cute_fi.icon';
import { mgcIconEarCuteFi } from './mgcIcon-ear_cute_fi.icon';
import { mgcIconEye2CuteFi } from './mgcIcon-eye_2_cute_fi.icon';
import { mgcIconEyebrowCuteFi } from './mgcIcon-eyebrow_cute_fi.icon';
import { mgcIconFaceCuteFi } from './mgcIcon-face_cute_fi.icon';
import { mgcIconFatherChristmasCuteFi } from './mgcIcon-father_christmas_cute_fi.icon';
import { mgcIconFingerPressCuteFi } from './mgcIcon-finger_press_cute_fi.icon';
import { mgcIconFingerRockCuteFi } from './mgcIcon-finger_rock_cute_fi.icon';
import { mgcIconFingerSwipeCuteFi } from './mgcIcon-finger_swipe_cute_fi.icon';
import { mgcIconFingerTapCuteFi } from './mgcIcon-finger_tap_cute_fi.icon';
import { mgcIconGloveCuteFi } from './mgcIcon-glove_cute_fi.icon';
import { mgcIconHair2CuteFi } from './mgcIcon-hair_2_cute_fi.icon';
import { mgcIconHairCuteFi } from './mgcIcon-hair_cute_fi.icon';
import { mgcIconHandCuteFi } from './mgcIcon-hand_cute_fi.icon';
import { mgcIconHandFinger2CuteFi } from './mgcIcon-hand_finger_2_cute_fi.icon';
import { mgcIconHandFingerCuteFi } from './mgcIcon-hand_finger_cute_fi.icon';
import { mgcIconHandGrabCuteFi } from './mgcIcon-hand_grab_cute_fi.icon';
import { mgcIconHandTwoFingersCuteFi } from './mgcIcon-hand_two_fingers_cute_fi.icon';
import { mgcIconHandsClappingCuteFi } from './mgcIcon-hands_clapping_cute_fi.icon';
import { mgcIconHat2CuteFi } from './mgcIcon-hat_2_cute_fi.icon';
import { mgcIconHatCuteFi } from './mgcIcon-hat_cute_fi.icon';
import { mgcIconHeadCuteFi } from './mgcIcon-head_cute_fi.icon';
import { mgcIconHeartHandCuteFi } from './mgcIcon-heart_hand_cute_fi.icon';
import { mgcIconHeartbeat2CuteFi } from './mgcIcon-heartbeat_2_cute_fi.icon';
import { mgcIconIncognitoModeCuteFi } from './mgcIcon-incognito_mode_cute_fi.icon';
import { mgcIconLoveCuteFi } from './mgcIcon-love_cute_fi.icon';
import { mgcIconLungsCuteFi } from './mgcIcon-lungs_cute_fi.icon';
import { mgcIconMiddleFingerCuteFi } from './mgcIcon-middle_finger_cute_fi.icon';
import { mgcIconMouthCuteFi } from './mgcIcon-mouth_cute_fi.icon';
import { mgcIconNecktieCuteFi } from './mgcIcon-necktie_cute_fi.icon';
import { mgcIconNoseCuteFi } from './mgcIcon-nose_cute_fi.icon';
import { mgcIconPrayCuteFi } from './mgcIcon-pray_cute_fi.icon';
import { mgcIconScarfCuteFi } from './mgcIcon-scarf_cute_fi.icon';
import { mgcIconShirtCuteFi } from './mgcIcon-shirt_cute_fi.icon';
import { mgcIconShoe2CuteFi } from './mgcIcon-shoe_2_cute_fi.icon';
import { mgcIconShoeCuteFi } from './mgcIcon-shoe_cute_fi.icon';
import { mgcIconShortsCuteFi } from './mgcIcon-shorts_cute_fi.icon';
import { mgcIconSkirtCuteFi } from './mgcIcon-skirt_cute_fi.icon';
import { mgcIconSkullCuteFi } from './mgcIcon-skull_cute_fi.icon';
import { mgcIconSockCuteFi } from './mgcIcon-sock_cute_fi.icon';
import { mgcIconTShirt2CuteFi } from './mgcIcon-t_shirt_2_cute_fi.icon';
import { mgcIconTrouserCuteFi } from './mgcIcon-trouser_cute_fi.icon';
import { mgcIconVestCuteFi } from './mgcIcon-vest_cute_fi.icon';
import { mgcIconClubsCuteFi } from './mgcIcon-clubs_cute_fi.icon';
import { mgcIconCylinder2CuteFi } from './mgcIcon-cylinder_2_cute_fi.icon';
import { mgcIconCylinderCuteFi } from './mgcIcon-cylinder_cute_fi.icon';
import { mgcIconDiamondCuteFi } from './mgcIcon-diamond_cute_fi.icon';
import { mgcIconDiamondSquareCuteFi } from './mgcIcon-diamond_square_cute_fi.icon';
import { mgcIconHeartCrackCuteFi } from './mgcIcon-heart_crack_cute_fi.icon';
import { mgcIconHeartCuteFi } from './mgcIcon-heart_cute_fi.icon';
import { mgcIconHeartHalfCuteFi } from './mgcIcon-heart_half_cute_fi.icon';
import { mgcIconHemisphere2CuteFi } from './mgcIcon-hemisphere_2_cute_fi.icon';
import { mgcIconHemisphereCuteFi } from './mgcIcon-hemisphere_cute_fi.icon';
import { mgcIconHexagonCuteFi } from './mgcIcon-hexagon_cute_fi.icon';
import { mgcIconLineCuteFi } from './mgcIcon-line_cute_fi.icon';
import { mgcIconOctagonCuteFi } from './mgcIcon-octagon_cute_fi.icon';
import { mgcIconPentagonCuteFi } from './mgcIcon-pentagon_cute_fi.icon';
import { mgcIconRectangleCuteFi } from './mgcIcon-rectangle_cute_fi.icon';
import { mgcIconRectangleVerticalCuteFi } from './mgcIcon-rectangle_vertical_cute_fi.icon';
import { mgcIconRoundCuteFi } from './mgcIcon-round_cute_fi.icon';
import { mgcIconSectorCuteFi } from './mgcIcon-sector_cute_fi.icon';
import { mgcIconShieldShapeCuteFi } from './mgcIcon-shield_shape_cute_fi.icon';
import { mgcIconSpadeCuteFi } from './mgcIcon-spade_cute_fi.icon';
import { mgcIconSquareCuteFi } from './mgcIcon-square_cute_fi.icon';
import { mgcIconStarCuteFi } from './mgcIcon-star_cute_fi.icon';
import { mgcIconStarHalfCuteFi } from './mgcIcon-star_half_cute_fi.icon';
import { mgcIconTriangleCuteFi } from './mgcIcon-triangle_cute_fi.icon';
import { mgcIconAirBalloonCuteFi } from './mgcIcon-air_balloon_cute_fi.icon';
import { mgcIconAmericanFootballCuteFi } from './mgcIcon-american_football_cute_fi.icon';
import { mgcIconBackboardCuteFi } from './mgcIcon-backboard_cute_fi.icon';
import { mgcIconBadmintonCuteFi } from './mgcIcon-badminton_cute_fi.icon';
import { mgcIconBarbellCuteFi } from './mgcIcon-barbell_cute_fi.icon';
import { mgcIconBaseball2CuteFi } from './mgcIcon-baseball_2_cute_fi.icon';
import { mgcIconBaseballCuteFi } from './mgcIcon-baseball_cute_fi.icon';
import { mgcIconBasketballCuteFi } from './mgcIcon-basketball_cute_fi.icon';
import { mgcIconBeachballCuteFi } from './mgcIcon-beachball_cute_fi.icon';
import { mgcIconDisabled2CuteFi } from './mgcIcon-disabled_2_cute_fi.icon';
import { mgcIconDisabledCuteFi } from './mgcIcon-disabled_cute_fi.icon';
import { mgcIconFitnessCuteFi } from './mgcIcon-fitness_cute_fi.icon';
import { mgcIconFootballCuteFi } from './mgcIcon-football_cute_fi.icon';
import { mgcIconParachuteCuteFi } from './mgcIcon-parachute_cute_fi.icon';
import { mgcIconPingpongCuteFi } from './mgcIcon-pingpong_cute_fi.icon';
import { mgcIconPlaygroundCuteFi } from './mgcIcon-playground_cute_fi.icon';
import { mgcIconRidingCuteFi } from './mgcIcon-riding_cute_fi.icon';
import { mgcIconRunCuteFi } from './mgcIcon-run_cute_fi.icon';
import { mgcIconSkateboardCuteFi } from './mgcIcon-skateboard_cute_fi.icon';
import { mgcIconSurfboardCuteFi } from './mgcIcon-surfboard_cute_fi.icon';
import { mgcIconSwimmingPoolCuteFi } from './mgcIcon-swimming_pool_cute_fi.icon';
import { mgcIconSwordCuteFi } from './mgcIcon-sword_cute_fi.icon';
import { mgcIconToxophilyCuteFi } from './mgcIcon-toxophily_cute_fi.icon';
import { mgcIconVolleyballCuteFi } from './mgcIcon-volleyball_cute_fi.icon';
import { mgcIconWalkCuteFi } from './mgcIcon-walk_cute_fi.icon';
import { mgcIconWheelchairCuteFi } from './mgcIcon-wheelchair_cute_fi.icon';
import { mgcIconWhistleCuteFi } from './mgcIcon-whistle_cute_fi.icon';
import { mgcIconAddCircleCuteFi } from './mgcIcon-add_circle_cute_fi.icon';
import { mgcIconAddCuteFi } from './mgcIcon-add_cute_fi.icon';
import { mgcIconAddSquareCuteFi } from './mgcIcon-add_square_cute_fi.icon';
import { mgcIconAlertCuteFi } from './mgcIcon-alert_cute_fi.icon';
import { mgcIconAlertDiamondCuteFi } from './mgcIcon-alert_diamond_cute_fi.icon';
import { mgcIconAlertOctagonCuteFi } from './mgcIcon-alert_octagon_cute_fi.icon';
import { mgcIconBroomCuteFi } from './mgcIcon-broom_cute_fi.icon';
import { mgcIconBrush3CuteFi } from './mgcIcon-brush_3_cute_fi.icon';
import { mgcIconBrushCuteFi } from './mgcIcon-brush_cute_fi.icon';
import { mgcIconBubbleCuteFi } from './mgcIcon-bubble_cute_fi.icon';
import { mgcIconCertificateCuteFi } from './mgcIcon-certificate_cute_fi.icon';
import { mgcIconCheck2CuteFi } from './mgcIcon-check_2_cute_fi.icon';
import { mgcIconCheckCircleCuteFi } from './mgcIcon-check_circle_cute_fi.icon';
import { mgcIconCheckCuteFi } from './mgcIcon-check_cute_fi.icon';
import { mgcIconCheckboxCuteFi } from './mgcIcon-checkbox_cute_fi.icon';
import { mgcIconChecksCuteFi } from './mgcIcon-checks_cute_fi.icon';
import { mgcIconChoiceCuteFi } from './mgcIcon-choice_cute_fi.icon';
import { mgcIconClassify2CuteFi } from './mgcIcon-classify_2_cute_fi.icon';
import { mgcIconClassify3CuteFi } from './mgcIcon-classify_3_cute_fi.icon';
import { mgcIconClassifyAdd2CuteFi } from './mgcIcon-classify_add_2_cute_fi.icon';
import { mgcIconClassifyAddCuteFi } from './mgcIcon-classify_add_cute_fi.icon';
import { mgcIconClassifyCuteFi } from './mgcIcon-classify_cute_fi.icon';
import { mgcIconCloseCircleCuteFi } from './mgcIcon-close_circle_cute_fi.icon';
import { mgcIconCloseCuteFi } from './mgcIcon-close_cute_fi.icon';
import { mgcIconCloseSquareCuteFi } from './mgcIcon-close_square_cute_fi.icon';
import { mgcIconCrossCuteFi } from './mgcIcon-cross_cute_fi.icon';
import { mgcIconCrutchCuteFi } from './mgcIcon-crutch_cute_fi.icon';
import { mgcIconCubeCuteFi } from './mgcIcon-cube_cute_fi.icon';
import { mgcIconDelete2CuteFi } from './mgcIcon-delete_2_cute_fi.icon';
import { mgcIconDelete3CuteFi } from './mgcIcon-delete_3_cute_fi.icon';
import { mgcIconDeleteBackCuteFi } from './mgcIcon-delete_back_cute_fi.icon';
import { mgcIconDeleteCuteFi } from './mgcIcon-delete_cute_fi.icon';
import { mgcIconDirectionDotCuteFi } from './mgcIcon-direction_dot_cute_fi.icon';
import { mgcIconDoorCuteFi } from './mgcIcon-door_cute_fi.icon';
import { mgcIconDotGridCuteFi } from './mgcIcon-dot_grid_cute_fi.icon';
import { mgcIconDotsCuteFi } from './mgcIcon-dots_cute_fi.icon';
import { mgcIconDotsVerticalCuteFi } from './mgcIcon-dots_vertical_cute_fi.icon';
import { mgcIconEnterDoorCuteFi } from './mgcIcon-enter_door_cute_fi.icon';
import { mgcIconEntranceCuteFi } from './mgcIcon-entrance_cute_fi.icon';
import { mgcIconExitCuteFi } from './mgcIcon-exit_cute_fi.icon';
import { mgcIconExitDoorCuteFi } from './mgcIcon-exit_door_cute_fi.icon';
import { mgcIconEyeCloseCuteFi } from './mgcIcon-eye_close_cute_fi.icon';
import { mgcIconEyeCuteFi } from './mgcIcon-eye_cute_fi.icon';
import { mgcIconFaceidCuteFi } from './mgcIcon-faceid_cute_fi.icon';
import { mgcIconFaultCuteFi } from './mgcIcon-fault_cute_fi.icon';
import { mgcIconFilter2CuteFi } from './mgcIcon-filter_2_cute_fi.icon';
import { mgcIconFingerprint2CuteFi } from './mgcIcon-fingerprint_2_cute_fi.icon';
import { mgcIconFingerprintCuteFi } from './mgcIcon-fingerprint_cute_fi.icon';
import { mgcIconFireCuteFi } from './mgcIcon-fire_cute_fi.icon';
import { mgcIconFlameCuteFi } from './mgcIcon-flame_cute_fi.icon';
import { mgcIconForbidCircleCuteFi } from './mgcIcon-forbid_circle_cute_fi.icon';
import { mgcIconGestureUnlockCuteFi } from './mgcIcon-gesture_unlock_cute_fi.icon';
import { mgcIconGhostCuteFi } from './mgcIcon-ghost_cute_fi.icon';
import { mgcIconGrid2CuteFi } from './mgcIcon-grid_2_cute_fi.icon';
import { mgcIconGridCuteFi } from './mgcIcon-grid_cute_fi.icon';
import { mgcIconHeartbeatCuteFi } from './mgcIcon-heartbeat_cute_fi.icon';
import { mgcIconHexagons2CuteFi } from './mgcIcon-hexagons_2_cute_fi.icon';
import { mgcIconHexagonsCuteFi } from './mgcIcon-hexagons_cute_fi.icon';
import { mgcIconHistory2CuteFi } from './mgcIcon-history_2_cute_fi.icon';
import { mgcIconHistoryAnticlockwiseCuteFi } from './mgcIcon-history_anticlockwise_cute_fi.icon';
import { mgcIconHistoryCuteFi } from './mgcIcon-history_cute_fi.icon';
import { mgcIconInformationCuteFi } from './mgcIcon-information_cute_fi.icon';
import { mgcIconKey1CuteFi } from './mgcIcon-key_1_cute_fi.icon';
import { mgcIconKey2CuteFi } from './mgcIcon-key_2_cute_fi.icon';
import { mgcIconKeyholeCuteFi } from './mgcIcon-keyhole_cute_fi.icon';
import { mgcIconLoading2CuteFi } from './mgcIcon-loading_2_cute_fi.icon';
import { mgcIconLoading3CuteFi } from './mgcIcon-loading_3_cute_fi.icon';
import { mgcIconLoading4CuteFi } from './mgcIcon-loading_4_cute_fi.icon';
import { mgcIconLoadingCuteFi } from './mgcIcon-loading_cute_fi.icon';
import { mgcIconLockCuteFi } from './mgcIcon-lock_cute_fi.icon';
import { mgcIconMindMapCuteFi } from './mgcIcon-mind_map_cute_fi.icon';
import { mgcIconMinimizeCuteFi } from './mgcIcon-minimize_cute_fi.icon';
import { mgcIconMinusCircleCuteFi } from './mgcIcon-minus_circle_cute_fi.icon';
import { mgcIconMinusSquareCuteFi } from './mgcIcon-minus_square_cute_fi.icon';
import { mgcIconMore1CuteFi } from './mgcIcon-more_1_cute_fi.icon';
import { mgcIconMore2CuteFi } from './mgcIcon-more_2_cute_fi.icon';
import { mgcIconMore3CuteFi } from './mgcIcon-more_3_cute_fi.icon';
import { mgcIconMore4CuteFi } from './mgcIcon-more_4_cute_fi.icon';
import { mgcIconMultiselectCuteFi } from './mgcIcon-multiselect_cute_fi.icon';
import { mgcIconNewdotCuteFi } from './mgcIcon-newdot_cute_fi.icon';
import { mgcIconOpenDoorCuteFi } from './mgcIcon-open_door_cute_fi.icon';
import { mgcIconPlusCuteFi } from './mgcIcon-plus_cute_fi.icon';
import { mgcIconPolygonCuteFi } from './mgcIcon-polygon_cute_fi.icon';
import { mgcIconPowerCuteFi } from './mgcIcon-power_cute_fi.icon';
import { mgcIconProcessCuteFi } from './mgcIcon-process_cute_fi.icon';
import { mgcIconQuestionCuteFi } from './mgcIcon-question_cute_fi.icon';
import { mgcIconRadioboxCuteFi } from './mgcIcon-radiobox_cute_fi.icon';
import { mgcIconRecycleCuteFi } from './mgcIcon-recycle_cute_fi.icon';
import { mgcIconRefresh1CuteFi } from './mgcIcon-refresh_1_cute_fi.icon';
import { mgcIconRefresh2CuteFi } from './mgcIcon-refresh_2_cute_fi.icon';
import { mgcIconRefresh3CuteFi } from './mgcIcon-refresh_3_cute_fi.icon';
import { mgcIconRefresh4AiCuteFi } from './mgcIcon-refresh_4_ai_cute_fi.icon';
import { mgcIconRefresh4CuteFi } from './mgcIcon-refresh_4_cute_fi.icon';
import { mgcIconRefreshAnticlockwise1CuteFi } from './mgcIcon-refresh_anticlockwise_1_cute_fi.icon';
import { mgcIconReportCuteFi } from './mgcIcon-report_cute_fi.icon';
import { mgcIconRestoreCuteFi } from './mgcIcon-restore_cute_fi.icon';
import { mgcIconSafeAlertCuteFi } from './mgcIcon-safe_alert_cute_fi.icon';
import { mgcIconSafeFlashCuteFi } from './mgcIcon-safe_flash_cute_fi.icon';
import { mgcIconSafeLockCuteFi } from './mgcIcon-safe_lock_cute_fi.icon';
import { mgcIconSafeShield2CuteFi } from './mgcIcon-safe_shield_2_cute_fi.icon';
import { mgcIconSafeShieldCuteFi } from './mgcIcon-safe_shield_cute_fi.icon';
import { mgcIconSafetyCertificateCuteFi } from './mgcIcon-safety_certificate_cute_fi.icon';
import { mgcIconSettings1CuteFi } from './mgcIcon-settings_1_cute_fi.icon';
import { mgcIconSettings2CuteFi } from './mgcIcon-settings_2_cute_fi.icon';
import { mgcIconSettings3CuteFi } from './mgcIcon-settings_3_cute_fi.icon';
import { mgcIconSettings4CuteFi } from './mgcIcon-settings_4_cute_fi.icon';
import { mgcIconSettings5CuteFi } from './mgcIcon-settings_5_cute_fi.icon';
import { mgcIconSettings6CuteFi } from './mgcIcon-settings_6_cute_fi.icon';
import { mgcIconSettings7CuteFi } from './mgcIcon-settings_7_cute_fi.icon';
import { mgcIconShare2CuteFi } from './mgcIcon-share_2_cute_fi.icon';
import { mgcIconShare3CuteFi } from './mgcIcon-share_3_cute_fi.icon';
import { mgcIconShareForwardCuteFi } from './mgcIcon-share_forward_cute_fi.icon';
import { mgcIconShieldCuteFi } from './mgcIcon-shield_cute_fi.icon';
import { mgcIconSleepCuteFi } from './mgcIcon-sleep_cute_fi.icon';
import { mgcIconSwitchCuteFi } from './mgcIcon-switch_cute_fi.icon';
import { mgcIconTShirtCuteFi } from './mgcIcon-t_shirt_cute_fi.icon';
import { mgcIconThreeCirclesCuteFi } from './mgcIcon-three_circles_cute_fi.icon';
import { mgcIconThumbDown2CuteFi } from './mgcIcon-thumb_down_2_cute_fi.icon';
import { mgcIconThumbDownCuteFi } from './mgcIcon-thumb_down_cute_fi.icon';
import { mgcIconThumbUp2CuteFi } from './mgcIcon-thumb_up_2_cute_fi.icon';
import { mgcIconThumbUpCuteFi } from './mgcIcon-thumb_up_cute_fi.icon';
import { mgcIconTimeCuteFi } from './mgcIcon-time_cute_fi.icon';
import { mgcIconTimeDurationCuteFi } from './mgcIcon-time_duration_cute_fi.icon';
import { mgcIconTimelineCuteFi } from './mgcIcon-timeline_cute_fi.icon';
import { mgcIconToggleLeft2CuteFi } from './mgcIcon-toggle_left_2_cute_fi.icon';
import { mgcIconToggleLeftCuteFi } from './mgcIcon-toggle_left_cute_fi.icon';
import { mgcIconToggleRight2CuteFi } from './mgcIcon-toggle_right_2_cute_fi.icon';
import { mgcIconToggleRightCuteFi } from './mgcIcon-toggle_right_cute_fi.icon';
import { mgcIconToolCuteFi } from './mgcIcon-tool_cute_fi.icon';
import { mgcIconTransformationCuteFi } from './mgcIcon-transformation_cute_fi.icon';
import { mgcIconUnlockCuteFi } from './mgcIcon-unlock_cute_fi.icon';
import { mgcIconVersionCuteFi } from './mgcIcon-version_cute_fi.icon';
import { mgcIconWarningCuteFi } from './mgcIcon-warning_cute_fi.icon';
import { mgcIconWastebasketCuteFi } from './mgcIcon-wastebasket_cute_fi.icon';
import { mgcIconWebhookCuteFi } from './mgcIcon-webhook_cute_fi.icon';
import { mgcIconAbsCuteFi } from './mgcIcon-ABS_cute_fi.icon';
import { mgcIconAerialLiftCuteFi } from './mgcIcon-aerial_lift_cute_fi.icon';
import { mgcIconAirplaneCuteFi } from './mgcIcon-airplane_cute_fi.icon';
import { mgcIconAutoHoldCuteFi } from './mgcIcon-auto_hold_cute_fi.icon';
import { mgcIconBabyCarriageCuteFi } from './mgcIcon-baby_carriage_cute_fi.icon';
import { mgcIconBikeCuteFi } from './mgcIcon-bike_cute_fi.icon';
import { mgcIconBrakeCuteFi } from './mgcIcon-brake_cute_fi.icon';
import { mgcIconBus2CuteFi } from './mgcIcon-bus_2_cute_fi.icon';
import { mgcIconBusCuteFi } from './mgcIcon-bus_cute_fi.icon';
import { mgcIconCar2CuteFi } from './mgcIcon-car_2_cute_fi.icon';
import { mgcIconCar3CuteFi } from './mgcIcon-car_3_cute_fi.icon';
import { mgcIconCarCuteFi } from './mgcIcon-car_cute_fi.icon';
import { mgcIconCarDoorCuteFi } from './mgcIcon-car_door_cute_fi.icon';
import { mgcIconCarWindowCuteFi } from './mgcIcon-car_window_cute_fi.icon';
import { mgcIconChargingPileCuteFi } from './mgcIcon-charging_pile_cute_fi.icon';
import { mgcIconEbikeCuteFi } from './mgcIcon-ebike_cute_fi.icon';
import { mgcIconEmergencyFlashersCuteFi } from './mgcIcon-emergency_flashers_cute_fi.icon';
import { mgcIconEngineCuteFi } from './mgcIcon-engine_cute_fi.icon';
import { mgcIconFan2CuteFi } from './mgcIcon-fan_2_cute_fi.icon';
import { mgcIconFanCuteFi } from './mgcIcon-fan_cute_fi.icon';
import { mgcIconFanDirectionDownCuteFi } from './mgcIcon-fan_direction_down_cute_fi.icon';
import { mgcIconFanDirectionFrontCuteFi } from './mgcIcon-fan_direction_front_cute_fi.icon';
import { mgcIconFanDirectionUpCuteFi } from './mgcIcon-fan_direction_up_cute_fi.icon';
import { mgcIconFlightInflightCuteFi } from './mgcIcon-flight_inflight_cute_fi.icon';
import { mgcIconFlightLandCuteFi } from './mgcIcon-flight_land_cute_fi.icon';
import { mgcIconFlightTakeoffCuteFi } from './mgcIcon-flight_takeoff_cute_fi.icon';
import { mgcIconFourWheelDriveCuteFi } from './mgcIcon-four_wheel_drive_cute_fi.icon';
import { mgcIconFrontFogLightsCuteFi } from './mgcIcon-front_fog_lights_cute_fi.icon';
import { mgcIconFrontWindshieldDefrosterCuteFi } from './mgcIcon-front_windshield_defroster_cute_fi.icon';
import { mgcIconGasStationCuteFi } from './mgcIcon-gas_station_cute_fi.icon';
import { mgcIconHightBeamHeadlightsCuteFi } from './mgcIcon-hight_beam_headlights_cute_fi.icon';
import { mgcIconHoodCuteFi } from './mgcIcon-hood_cute_fi.icon';
import { mgcIconJeepCuteFi } from './mgcIcon-jeep_cute_fi.icon';
import { mgcIconLowBeamHeadlightsCuteFi } from './mgcIcon-low_beam_headlights_cute_fi.icon';
import { mgcIconOilCuteFi } from './mgcIcon-oil_cute_fi.icon';
import { mgcIconParkCuteFi } from './mgcIcon-park_cute_fi.icon';
import { mgcIconParkingLightsCuteFi } from './mgcIcon-parking_lights_cute_fi.icon';
import { mgcIconPinwheel2CuteFi } from './mgcIcon-pinwheel_2_cute_fi.icon';
import { mgcIconPinwheelCuteFi } from './mgcIcon-pinwheel_cute_fi.icon';
import { mgcIconRareFogLightsCuteFi } from './mgcIcon-rare_fog_lights_cute_fi.icon';
import { mgcIconRearWindshieldDefrosterCuteFi } from './mgcIcon-rear_windshield_defroster_cute_fi.icon';
import { mgcIconRocket2CuteFi } from './mgcIcon-rocket_2_cute_fi.icon';
import { mgcIconRocketCuteFi } from './mgcIcon-rocket_cute_fi.icon';
import { mgcIconRudderCuteFi } from './mgcIcon-rudder_cute_fi.icon';
import { mgcIconSailboatCuteFi } from './mgcIcon-sailboat_cute_fi.icon';
import { mgcIconScooterCuteFi } from './mgcIcon-scooter_cute_fi.icon';
import { mgcIconSeatCuteFi } from './mgcIcon-seat_cute_fi.icon';
import { mgcIconSeatHeatedCuteFi } from './mgcIcon-seat_heated_cute_fi.icon';
import { mgcIconShipCuteFi } from './mgcIcon-ship_cute_fi.icon';
import { mgcIconSleighCuteFi } from './mgcIcon-sleigh_cute_fi.icon';
import { mgcIconSteeringWheelCuteFi } from './mgcIcon-steering_wheel_cute_fi.icon';
import { mgcIconTankCuteFi } from './mgcIcon-tank_cute_fi.icon';
import { mgcIconTrafficLightsCuteFi } from './mgcIcon-traffic_lights_cute_fi.icon';
import { mgcIconTrain2CuteFi } from './mgcIcon-train_2_cute_fi.icon';
import { mgcIconTrain3CuteFi } from './mgcIcon-train_3_cute_fi.icon';
import { mgcIconTrain4CuteFi } from './mgcIcon-train_4_cute_fi.icon';
import { mgcIconTrainCuteFi } from './mgcIcon-train_cute_fi.icon';
import { mgcIconTruckCuteFi } from './mgcIcon-truck_cute_fi.icon';
import { mgcIconTrunkCuteFi } from './mgcIcon-trunk_cute_fi.icon';
import { mgcIconTyreCuteFi } from './mgcIcon-tyre_cute_fi.icon';
import { mgcIconUfo2CuteFi } from './mgcIcon-UFO_2_cute_fi.icon';
import { mgcIconUfoCuteFi } from './mgcIcon-UFO_cute_fi.icon';
import { mgcIconWheelCuteFi } from './mgcIcon-wheel_cute_fi.icon';
import { mgcIconWiperCuteFi } from './mgcIcon-wiper_cute_fi.icon';
import { mgcIconBadgeCuteFi } from './mgcIcon-badge_cute_fi.icon';
import { mgcIconContacts2CuteFi } from './mgcIcon-contacts_2_cute_fi.icon';
import { mgcIconContacts3CuteFi } from './mgcIcon-contacts_3_cute_fi.icon';
import { mgcIconContacts4CuteFi } from './mgcIcon-contacts_4_cute_fi.icon';
import { mgcIconContactsCuteFi } from './mgcIcon-contacts_cute_fi.icon';
import { mgcIconFemaleCuteFi } from './mgcIcon-female_cute_fi.icon';
import { mgcIconGroup2CuteFi } from './mgcIcon-group_2_cute_fi.icon';
import { mgcIconGroup3CuteFi } from './mgcIcon-group_3_cute_fi.icon';
import { mgcIconGroupCuteFi } from './mgcIcon-group_cute_fi.icon';
import { mgcIconIDcardCuteFi } from './mgcIcon-IDcard_cute_fi.icon';
import { mgcIconMaleCuteFi } from './mgcIcon-male_cute_fi.icon';
import { mgcIconUser1CuteFi } from './mgcIcon-user_1_cute_fi.icon';
import { mgcIconUser2CuteFi } from './mgcIcon-user_2_cute_fi.icon';
import { mgcIconUser3CuteFi } from './mgcIcon-user_3_cute_fi.icon';
import { mgcIconUser4CuteFi } from './mgcIcon-user_4_cute_fi.icon';
import { mgcIconUser5CuteFi } from './mgcIcon-user_5_cute_fi.icon';
import { mgcIconUserAdd2CuteFi } from './mgcIcon-user_add_2_cute_fi.icon';
import { mgcIconUserAddCuteFi } from './mgcIcon-user_add_cute_fi.icon';
import { mgcIconUserEditCuteFi } from './mgcIcon-user_edit_cute_fi.icon';
import { mgcIconUserFollow2CuteFi } from './mgcIcon-user_follow_2_cute_fi.icon';
import { mgcIconUserFollowCuteFi } from './mgcIcon-user_follow_cute_fi.icon';
import { mgcIconUserForbidCuteFi } from './mgcIcon-user_forbid_cute_fi.icon';
import { mgcIconUserHeartCuteFi } from './mgcIcon-user_heart_cute_fi.icon';
import { mgcIconUserHideCuteFi } from './mgcIcon-user_hide_cute_fi.icon';
import { mgcIconUserInfoCuteFi } from './mgcIcon-user_info_cute_fi.icon';
import { mgcIconUserLockCuteFi } from './mgcIcon-user_lock_cute_fi.icon';
import { mgcIconUserPinCuteFi } from './mgcIcon-user_pin_cute_fi.icon';
import { mgcIconUserQuestionCuteFi } from './mgcIcon-user_question_cute_fi.icon';
import { mgcIconUserRemove2CuteFi } from './mgcIcon-user_remove_2_cute_fi.icon';
import { mgcIconUserRemoveCuteFi } from './mgcIcon-user_remove_cute_fi.icon';
import { mgcIconUserSearchCuteFi } from './mgcIcon-user_search_cute_fi.icon';
import { mgcIconUserSecurityCuteFi } from './mgcIcon-user_security_cute_fi.icon';
import { mgcIconUserSettingCuteFi } from './mgcIcon-user_setting_cute_fi.icon';
import { mgcIconUserStarCuteFi } from './mgcIcon-user_star_cute_fi.icon';
import { mgcIconUserVisibleCuteFi } from './mgcIcon-user_visible_cute_fi.icon';
import { mgcIconUserWarningCuteFi } from './mgcIcon-user_warning_cute_fi.icon';
import { mgcIconUserXCuteFi } from './mgcIcon-user_x_cute_fi.icon';
import { mgcIconCelsiusCuteFi } from './mgcIcon-celsius_cute_fi.icon';
import { mgcIconCloud2CuteFi } from './mgcIcon-cloud_2_cute_fi.icon';
import { mgcIconCloudCuteFi } from './mgcIcon-cloud_cute_fi.icon';
import { mgcIconCloudLightningCuteFi } from './mgcIcon-cloud_lightning_cute_fi.icon';
import { mgcIconCloudSnowCuteFi } from './mgcIcon-cloud_snow_cute_fi.icon';
import { mgcIconCloudWindyCuteFi } from './mgcIcon-cloud_windy_cute_fi.icon';
import { mgcIconCloudsCuteFi } from './mgcIcon-clouds_cute_fi.icon';
import { mgcIconDrizzleCuteFi } from './mgcIcon-drizzle_cute_fi.icon';
import { mgcIconDryCuteFi } from './mgcIcon-dry_cute_fi.icon';
import { mgcIconFahrenheitCuteFi } from './mgcIcon-fahrenheit_cute_fi.icon';
import { mgcIconFloatingDustCuteFi } from './mgcIcon-floating_dust_cute_fi.icon';
import { mgcIconFogCuteFi } from './mgcIcon-fog_cute_fi.icon';
import { mgcIconFullMoonCuteFi } from './mgcIcon-full_moon_cute_fi.icon';
import { mgcIconHailCuteFi } from './mgcIcon-hail_cute_fi.icon';
import { mgcIconHazeCuteFi } from './mgcIcon-haze_cute_fi.icon';
import { mgcIconHeavyRainCuteFi } from './mgcIcon-heavy_rain_cute_fi.icon';
import { mgcIconHeavyRainstormCuteFi } from './mgcIcon-heavy_rainstorm_cute_fi.icon';
import { mgcIconHeavySnowCuteFi } from './mgcIcon-heavy_snow_cute_fi.icon';
import { mgcIconHeavySnowstormCuteFi } from './mgcIcon-heavy_snowstorm_cute_fi.icon';
import { mgcIconHighTemperatureCuteFi } from './mgcIcon-high_temperature_cute_fi.icon';
import { mgcIconLightSnowCuteFi } from './mgcIcon-light_snow_cute_fi.icon';
import { mgcIconLightningCuteFi } from './mgcIcon-lightning_cute_fi.icon';
import { mgcIconLowTemperatureCuteFi } from './mgcIcon-low_temperature_cute_fi.icon';
import { mgcIconModerateSnowCuteFi } from './mgcIcon-moderate_snow_cute_fi.icon';
import { mgcIconMoonCloudyCuteFi } from './mgcIcon-moon_cloudy_cute_fi.icon';
import { mgcIconMoonCuteFi } from './mgcIcon-moon_cute_fi.icon';
import { mgcIconMoonFogCuteFi } from './mgcIcon-moon_fog_cute_fi.icon';
import { mgcIconMoonStarsCuteFi } from './mgcIcon-moon_stars_cute_fi.icon';
import { mgcIconMoonlightCuteFi } from './mgcIcon-moonlight_cute_fi.icon';
import { mgcIconNaCuteFi } from './mgcIcon-na_cute_fi.icon';
import { mgcIconPartlyCloudDaytimeCuteFi } from './mgcIcon-partly_cloud_daytime_cute_fi.icon';
import { mgcIconPartlyCloudNightCuteFi } from './mgcIcon-partly_cloud_night_cute_fi.icon';
import { mgcIconRainCuteFi } from './mgcIcon-rain_cute_fi.icon';
import { mgcIconRainbowCuteFi } from './mgcIcon-rainbow_cute_fi.icon';
import { mgcIconRainstormCuteFi } from './mgcIcon-rainstorm_cute_fi.icon';
import { mgcIconSandstormCuteFi } from './mgcIcon-sandstorm_cute_fi.icon';
import { mgcIconShowersCuteFi } from './mgcIcon-showers_cute_fi.icon';
import { mgcIconSnowCuteFi } from './mgcIcon-snow_cute_fi.icon';
import { mgcIconSnowflakeCuteFi } from './mgcIcon-snowflake_cute_fi.icon';
import { mgcIconSnowmanCuteFi } from './mgcIcon-snowman_cute_fi.icon';
import { mgcIconSnowstorm2CuteFi } from './mgcIcon-snowstorm_2_cute_fi.icon';
import { mgcIconSnowstormCuteFi } from './mgcIcon-snowstorm_cute_fi.icon';
import { mgcIconSparkles2CuteFi } from './mgcIcon-sparkles_2_cute_fi.icon';
import { mgcIconSparkles3CuteFi } from './mgcIcon-sparkles_3_cute_fi.icon';
import { mgcIconSparklesCuteFi } from './mgcIcon-sparkles_cute_fi.icon';
import { mgcIconSun2CuteFi } from './mgcIcon-sun_2_cute_fi.icon';
import { mgcIconSunCloudyCuteFi } from './mgcIcon-sun_cloudy_cute_fi.icon';
import { mgcIconSunCuteFi } from './mgcIcon-sun_cute_fi.icon';
import { mgcIconSunFogCuteFi } from './mgcIcon-sun_fog_cute_fi.icon';
import { mgcIconSunriseCuteFi } from './mgcIcon-sunrise_cute_fi.icon';
import { mgcIconSunsetCuteFi } from './mgcIcon-sunset_cute_fi.icon';
import { mgcIconThermometerCuteFi } from './mgcIcon-thermometer_cute_fi.icon';
import { mgcIconThunderstormCuteFi } from './mgcIcon-thunderstorm_cute_fi.icon';
import { mgcIconTornado2CuteFi } from './mgcIcon-tornado_2_cute_fi.icon';
import { mgcIconTornadoCuteFi } from './mgcIcon-tornado_cute_fi.icon';
import { mgcIconTyphoonCuteFi } from './mgcIcon-typhoon_cute_fi.icon';
import { mgcIconUmbrellaCuteFi } from './mgcIcon-umbrella_cute_fi.icon';
import { mgcIconWaveCuteFi } from './mgcIcon-wave_cute_fi.icon';
import { mgcIconWetCuteFi } from './mgcIcon-wet_cute_fi.icon';
import { mgcIconWindCuteFi } from './mgcIcon-wind_cute_fi.icon';
import { mgcIconAquariusCuteFi } from './mgcIcon-Aquarius_cute_fi.icon';
import { mgcIconAriesCuteFi } from './mgcIcon-Aries_cute_fi.icon';
import { mgcIconCancerCuteFi } from './mgcIcon-Cancer_cute_fi.icon';
import { mgcIconCapricornCuteFi } from './mgcIcon-Capricorn_cute_fi.icon';
import { mgcIconGeminiCuteFi } from './mgcIcon-Gemini_cute_fi.icon';
import { mgcIconLeoCuteFi } from './mgcIcon-Leo_cute_fi.icon';
import { mgcIconLibraCuteFi } from './mgcIcon-Libra_cute_fi.icon';
import { mgcIconPiscesCuteFi } from './mgcIcon-Pisces_cute_fi.icon';
import { mgcIconSagittariusCuteFi } from './mgcIcon-Sagittarius_cute_fi.icon';
import { mgcIconScorpioCuteFi } from './mgcIcon-Scorpio_cute_fi.icon';
import { mgcIconTaurusCuteFi } from './mgcIcon-Taurus_cute_fi.icon';
import { mgcIconVirgoCuteFi } from './mgcIcon-Virgo_cute_fi.icon';
import { mgcIconAlignArrowDownCuteRe } from './mgcIcon-align_arrow_down_cute_re.icon';
import { mgcIconAlignArrowLeftCuteRe } from './mgcIcon-align_arrow_left_cute_re.icon';
import { mgcIconAlignArrowRightCuteRe } from './mgcIcon-align_arrow_right_cute_re.icon';
import { mgcIconAlignArrowUpCuteRe } from './mgcIcon-align_arrow_up_cute_re.icon';
import { mgcIconArrowDownCircleCuteRe } from './mgcIcon-arrow_down_circle_cute_re.icon';
import { mgcIconArrowDownCuteRe } from './mgcIcon-arrow_down_cute_re.icon';
import { mgcIconArrowLeftCircleCuteRe } from './mgcIcon-arrow_left_circle_cute_re.icon';
import { mgcIconArrowLeftCuteRe } from './mgcIcon-arrow_left_cute_re.icon';
import { mgcIconArrowLeftDownCircleCuteRe } from './mgcIcon-arrow_left_down_circle_cute_re.icon';
import { mgcIconArrowLeftDownCuteRe } from './mgcIcon-arrow_left_down_cute_re.icon';
import { mgcIconArrowLeftUpCircleCuteRe } from './mgcIcon-arrow_left_up_circle_cute_re.icon';
import { mgcIconArrowLeftUpCuteRe } from './mgcIcon-arrow_left_up_cute_re.icon';
import { mgcIconArrowRightCircleCuteRe } from './mgcIcon-arrow_right_circle_cute_re.icon';
import { mgcIconArrowRightCuteRe } from './mgcIcon-arrow_right_cute_re.icon';
import { mgcIconArrowRightDownCircleCuteRe } from './mgcIcon-arrow_right_down_circle_cute_re.icon';
import { mgcIconArrowRightDownCuteRe } from './mgcIcon-arrow_right_down_cute_re.icon';
import { mgcIconArrowRightUpCircleCuteRe } from './mgcIcon-arrow_right_up_circle_cute_re.icon';
import { mgcIconArrowRightUpCuteRe } from './mgcIcon-arrow_right_up_cute_re.icon';
import { mgcIconArrowToDownCuteRe } from './mgcIcon-arrow_to_down_cute_re.icon';
import { mgcIconArrowToLeftCuteRe } from './mgcIcon-arrow_to_left_cute_re.icon';
import { mgcIconArrowToRightCuteRe } from './mgcIcon-arrow_to_right_cute_re.icon';
import { mgcIconArrowToUpCuteRe } from './mgcIcon-arrow_to_up_cute_re.icon';
import { mgcIconArrowUpCircleCuteRe } from './mgcIcon-arrow_up_circle_cute_re.icon';
import { mgcIconArrowUpCuteRe } from './mgcIcon-arrow_up_cute_re.icon';
import { mgcIconArrowsDownCuteRe } from './mgcIcon-arrows_down_cute_re.icon';
import { mgcIconArrowsLeftCuteRe } from './mgcIcon-arrows_left_cute_re.icon';
import { mgcIconArrowsRightCuteRe } from './mgcIcon-arrows_right_cute_re.icon';
import { mgcIconArrowsUpCuteRe } from './mgcIcon-arrows_up_cute_re.icon';
import { mgcIconBack2CuteRe } from './mgcIcon-back_2_cute_re.icon';
import { mgcIconBackCuteRe } from './mgcIcon-back_cute_re.icon';
import { mgcIconCornerDownLeftCuteRe } from './mgcIcon-corner_down_left_cute_re.icon';
import { mgcIconCornerDownRightCuteRe } from './mgcIcon-corner_down_right_cute_re.icon';
import { mgcIconCornerUpLeftCuteRe } from './mgcIcon-corner_up_left_cute_re.icon';
import { mgcIconCornerUpRightCuteRe } from './mgcIcon-corner_up_right_cute_re.icon';
import { mgcIconDirectionArrowCuteRe } from './mgcIcon-direction_arrow_cute_re.icon';
import { mgcIconDownCuteRe } from './mgcIcon-down_cute_re.icon';
import { mgcIconDownSmallCuteRe } from './mgcIcon-down_small_cute_re.icon';
import { mgcIconForward2CuteRe } from './mgcIcon-forward_2_cute_re.icon';
import { mgcIconForwardCuteRe } from './mgcIcon-forward_cute_re.icon';
import { mgcIconFullscreen2CuteRe } from './mgcIcon-fullscreen_2_cute_re.icon';
import { mgcIconFullscreenExit2CuteRe } from './mgcIcon-fullscreen_exit_2_cute_re.icon';
import { mgcIconLargeArrowDownCuteRe } from './mgcIcon-large_arrow_down_cute_re.icon';
import { mgcIconLargeArrowLeftCuteRe } from './mgcIcon-large_arrow_left_cute_re.icon';
import { mgcIconLargeArrowRightCuteRe } from './mgcIcon-large_arrow_right_cute_re.icon';
import { mgcIconLargeArrowUpCuteRe } from './mgcIcon-large_arrow_up_cute_re.icon';
import { mgcIconLeftCuteRe } from './mgcIcon-left_cute_re.icon';
import { mgcIconLeftSmallCuteRe } from './mgcIcon-left_small_cute_re.icon';
import { mgcIconMoveCuteRe } from './mgcIcon-move_cute_re.icon';
import { mgcIconRightCuteRe } from './mgcIcon-right_cute_re.icon';
import { mgcIconRightSmallCuteRe } from './mgcIcon-right_small_cute_re.icon';
import { mgcIconSelectorHorizontalCuteRe } from './mgcIcon-selector_horizontal_cute_re.icon';
import { mgcIconSelectorVerticalCuteRe } from './mgcIcon-selector_vertical_cute_re.icon';
import { mgcIconSquareArrowDownCuteRe } from './mgcIcon-square_arrow_down_cute_re.icon';
import { mgcIconSquareArrowLeftCuteRe } from './mgcIcon-square_arrow_left_cute_re.icon';
import { mgcIconSquareArrowRightCuteRe } from './mgcIcon-square_arrow_right_cute_re.icon';
import { mgcIconSquareArrowUpCuteRe } from './mgcIcon-square_arrow_up_cute_re.icon';
import { mgcIconTransfer2CuteRe } from './mgcIcon-transfer_2_cute_re.icon';
import { mgcIconTransfer3CuteRe } from './mgcIcon-transfer_3_cute_re.icon';
import { mgcIconTransfer4CuteRe } from './mgcIcon-transfer_4_cute_re.icon';
import { mgcIconTransferCuteRe } from './mgcIcon-transfer_cute_re.icon';
import { mgcIconTransferHorizontalCuteRe } from './mgcIcon-transfer_horizontal_cute_re.icon';
import { mgcIconTransferVerticalCuteRe } from './mgcIcon-transfer_vertical_cute_re.icon';
import { mgcIconTrendingDownCuteRe } from './mgcIcon-trending_down_cute_re.icon';
import { mgcIconTrendingUpCuteRe } from './mgcIcon-trending_up_cute_re.icon';
import { mgcIconUpCuteRe } from './mgcIcon-up_cute_re.icon';
import { mgcIconUpSmallCuteRe } from './mgcIcon-up_small_cute_re.icon';
import { mgcIconBankCuteRe } from './mgcIcon-bank_cute_re.icon';
import { mgcIconBankOfChinaTowerCuteRe } from './mgcIcon-bank_of_china_tower_cute_re.icon';
import { mgcIconBigBenCuteRe } from './mgcIcon-big_ben_cute_re.icon';
import { mgcIconBridge2CuteRe } from './mgcIcon-bridge_2_cute_re.icon';
import { mgcIconBridgeCuteRe } from './mgcIcon-bridge_cute_re.icon';
import { mgcIconBuilding1CuteRe } from './mgcIcon-building_1_cute_re.icon';
import { mgcIconBuilding2CuteRe } from './mgcIcon-building_2_cute_re.icon';
import { mgcIconBuilding3CuteRe } from './mgcIcon-building_3_cute_re.icon';
import { mgcIconBuilding4CuteRe } from './mgcIcon-building_4_cute_re.icon';
import { mgcIconBuilding5CuteRe } from './mgcIcon-building_5_cute_re.icon';
import { mgcIconBuilding6CuteRe } from './mgcIcon-building_6_cute_re.icon';
import { mgcIconBurjAlArabCuteRe } from './mgcIcon-burj_al_arab_cute_re.icon';
import { mgcIconBurjKhalifaTowerCuteRe } from './mgcIcon-burj_khalifa_tower_cute_re.icon';
import { mgcIconCampgroundCuteRe } from './mgcIcon-campground_cute_re.icon';
import { mgcIconCantonTowerCuteRe } from './mgcIcon-canton_tower_cute_re.icon';
import { mgcIconChristTheRedeemerCuteRe } from './mgcIcon-christ_the_redeemer_cute_re.icon';
import { mgcIconChurchCuteRe } from './mgcIcon-church_cute_re.icon';
import { mgcIconDutchWindmillCuteRe } from './mgcIcon-dutch_windmill_cute_re.icon';
import { mgcIconEgyptianPyramidsCuteRe } from './mgcIcon-egyptian_pyramids_cute_re.icon';
import { mgcIconEiffelTowerCuteRe } from './mgcIcon-eiffel_tower_cute_re.icon';
import { mgcIconFactory2CuteRe } from './mgcIcon-factory_2_cute_re.icon';
import { mgcIconFactoryCuteRe } from './mgcIcon-factory_cute_re.icon';
import { mgcIconFerrisWheelCuteRe } from './mgcIcon-ferris_wheel_cute_re.icon';
import { mgcIconGovernmentCuteRe } from './mgcIcon-government_cute_re.icon';
import { mgcIconGreatwallCuteRe } from './mgcIcon-greatwall_cute_re.icon';
import { mgcIconHome1CuteRe } from './mgcIcon-home_1_cute_re.icon';
import { mgcIconHome2CuteRe } from './mgcIcon-home_2_cute_re.icon';
import { mgcIconHome3CuteRe } from './mgcIcon-home_3_cute_re.icon';
import { mgcIconHome4CuteRe } from './mgcIcon-home_4_cute_re.icon';
import { mgcIconHome5CuteRe } from './mgcIcon-home_5_cute_re.icon';
import { mgcIconHome6CuteRe } from './mgcIcon-home_6_cute_re.icon';
import { mgcIconHome7CuteRe } from './mgcIcon-home_7_cute_re.icon';
import { mgcIconHospitalCuteRe } from './mgcIcon-hospital_cute_re.icon';
import { mgcIconHotelCuteRe } from './mgcIcon-hotel_cute_re.icon';
import { mgcIconHouse2CuteRe } from './mgcIcon-house_2_cute_re.icon';
import { mgcIconHouseCuteRe } from './mgcIcon-house_cute_re.icon';
import { mgcIconKingkey100TowerCuteRe } from './mgcIcon-kingkey_100_tower_cute_re.icon';
import { mgcIconLighthouseCuteRe } from './mgcIcon-lighthouse_cute_re.icon';
import { mgcIconMarinaBaySandCuteRe } from './mgcIcon-marina_bay_sand_cute_re.icon';
import { mgcIconMayaPyramidsCuteRe } from './mgcIcon-maya_pyramids_cute_re.icon';
import { mgcIconMiyajimaToriiCuteRe } from './mgcIcon-miyajima_torii_cute_re.icon';
import { mgcIconMoaiCuteRe } from './mgcIcon-moai_cute_re.icon';
import { mgcIconMonumentCuteRe } from './mgcIcon-monument_cute_re.icon';
import { mgcIconPalaceCuteRe } from './mgcIcon-palace_cute_re.icon';
import { mgcIconPavilionCuteRe } from './mgcIcon-pavilion_cute_re.icon';
import { mgcIconPisaTowerCuteRe } from './mgcIcon-pisa_tower_cute_re.icon';
import { mgcIconSchoolCuteRe } from './mgcIcon-school_cute_re.icon';
import { mgcIconShopCuteRe } from './mgcIcon-shop_cute_re.icon';
import { mgcIconStatueOfLibertyCuteRe } from './mgcIcon-statue_of_liberty_cute_re.icon';
import { mgcIconStore2CuteRe } from './mgcIcon-store_2_cute_re.icon';
import { mgcIconStoreCuteRe } from './mgcIcon-store_cute_re.icon';
import { mgcIconSydneyOperaHouseCuteRe } from './mgcIcon-sydney_opera_house_cute_re.icon';
import { mgcIconTaipei101CuteRe } from './mgcIcon-taipei101_cute_re.icon';
import { mgcIconTajMahalCuteRe } from './mgcIcon-taj_mahal_cute_re.icon';
import { mgcIconTempleOfHeavenCuteRe } from './mgcIcon-temple_of_heaven_cute_re.icon';
import { mgcIconTentCuteRe } from './mgcIcon-tent_cute_re.icon';
import { mgcIconTowerCuteRe } from './mgcIcon-tower_cute_re.icon';
import { mgcIconTriumphalArchCuteRe } from './mgcIcon-triumphal_arch_cute_re.icon';
import { mgcIconTvTowerCuteRe } from './mgcIcon-tv_tower_cute_re.icon';
import { mgcIconAdCircleCuteRe } from './mgcIcon-ad_circle_cute_re.icon';
import { mgcIconAdCircleOffCuteRe } from './mgcIcon-ad_circle_off_cute_re.icon';
import { mgcIconAdRectangleCuteRe } from './mgcIcon-ad_rectangle_cute_re.icon';
import { mgcIconAdRectangleOffCuteRe } from './mgcIcon-ad_rectangle_off_cute_re.icon';
import { mgcIconAnniversaryCuteRe } from './mgcIcon-anniversary_cute_re.icon';
import { mgcIconAuctionCuteRe } from './mgcIcon-auction_cute_re.icon';
import { mgcIconAwardCuteRe } from './mgcIcon-award_cute_re.icon';
import { mgcIconBankCardCuteRe } from './mgcIcon-bank_card_cute_re.icon';
import { mgcIconBasket2CuteRe } from './mgcIcon-basket_2_cute_re.icon';
import { mgcIconBasketCuteRe } from './mgcIcon-basket_cute_re.icon';
import { mgcIconBriefcase2CuteRe } from './mgcIcon-briefcase_2_cute_re.icon';
import { mgcIconBriefcaseCuteRe } from './mgcIcon-briefcase_cute_re.icon';
import { mgcIconCalendar2CuteRe } from './mgcIcon-calendar_2_cute_re.icon';
import { mgcIconCalendar3CuteRe } from './mgcIcon-calendar_3_cute_re.icon';
import { mgcIconCalendarAddCuteRe } from './mgcIcon-calendar_add_cute_re.icon';
import { mgcIconCalendarCuteRe } from './mgcIcon-calendar_cute_re.icon';
import { mgcIconCalendarDayCuteRe } from './mgcIcon-calendar_day_cute_re.icon';
import { mgcIconCalendarMonthCuteRe } from './mgcIcon-calendar_month_cute_re.icon';
import { mgcIconCalendarTimeAddCuteRe } from './mgcIcon-calendar_time_add_cute_re.icon';
import { mgcIconCalendarWeekCuteRe } from './mgcIcon-calendar_week_cute_re.icon';
import { mgcIconCandleCuteRe } from './mgcIcon-candle_cute_re.icon';
import { mgcIconCandlesCuteRe } from './mgcIcon-candles_cute_re.icon';
import { mgcIconCardPayCuteRe } from './mgcIcon-card_pay_cute_re.icon';
import { mgcIconCardRefundCuteRe } from './mgcIcon-card_refund_cute_re.icon';
import { mgcIconCash2CuteRe } from './mgcIcon-cash_2_cute_re.icon';
import { mgcIconCashCuteRe } from './mgcIcon-cash_cute_re.icon';
import { mgcIconCelebrateCuteRe } from './mgcIcon-celebrate_cute_re.icon';
import { mgcIconChartBar2CuteRe } from './mgcIcon-chart_bar_2_cute_re.icon';
import { mgcIconChartBarCuteRe } from './mgcIcon-chart_bar_cute_re.icon';
import { mgcIconChartDecreaseCuteRe } from './mgcIcon-chart_decrease_cute_re.icon';
import { mgcIconChartHorizontalCuteRe } from './mgcIcon-chart_horizontal_cute_re.icon';
import { mgcIconChartLineCuteRe } from './mgcIcon-chart_line_cute_re.icon';
import { mgcIconChartPie2CuteRe } from './mgcIcon-chart_pie_2_cute_re.icon';
import { mgcIconChartPieCuteRe } from './mgcIcon-chart_pie_cute_re.icon';
import { mgcIconChartVerticalCuteRe } from './mgcIcon-chart_vertical_cute_re.icon';
import { mgcIconChineseKnotCuteRe } from './mgcIcon-chinese_knot_cute_re.icon';
import { mgcIconChristmasBallCuteRe } from './mgcIcon-christmas_ball_cute_re.icon';
import { mgcIconCoin2CuteRe } from './mgcIcon-coin_2_cute_re.icon';
import { mgcIconCoin3CuteRe } from './mgcIcon-coin_3_cute_re.icon';
import { mgcIconCoinCuteRe } from './mgcIcon-coin_cute_re.icon';
import { mgcIconCopperCoinCuteRe } from './mgcIcon-copper_coin_cute_re.icon';
import { mgcIconCopyrightCuteRe } from './mgcIcon-copyright_cute_re.icon';
import { mgcIconCouponCuteRe } from './mgcIcon-coupon_cute_re.icon';
import { mgcIconCurrencyBaht2CuteRe } from './mgcIcon-currency_baht_2_cute_re.icon';
import { mgcIconCurrencyBahtCuteRe } from './mgcIcon-currency_baht_cute_re.icon';
import { mgcIconCurrencyCny2CuteRe } from './mgcIcon-currency_cny_2_cute_re.icon';
import { mgcIconCurrencyCnyCuteRe } from './mgcIcon-currency_cny_cute_re.icon';
import { mgcIconCurrencyDollar2CuteRe } from './mgcIcon-currency_dollar_2_cute_re.icon';
import { mgcIconCurrencyDollarCuteRe } from './mgcIcon-currency_dollar_cute_re.icon';
import { mgcIconCurrencyEuro2CuteRe } from './mgcIcon-currency_euro_2_cute_re.icon';
import { mgcIconCurrencyEuroCuteRe } from './mgcIcon-currency_euro_cute_re.icon';
import { mgcIconCurrencyLira2CuteRe } from './mgcIcon-currency_lira_2_cute_re.icon';
import { mgcIconCurrencyLiraCuteRe } from './mgcIcon-currency_lira_cute_re.icon';
import { mgcIconCurrencyNigeria2CuteRe } from './mgcIcon-currency_nigeria_2_cute_re.icon';
import { mgcIconCurrencyNigeriaCuteRe } from './mgcIcon-currency_nigeria_cute_re.icon';
import { mgcIconCurrencyRubel2CuteRe } from './mgcIcon-currency_rubel_2_cute_re.icon';
import { mgcIconCurrencyRubelCuteRe } from './mgcIcon-currency_rubel_cute_re.icon';
import { mgcIconCurrencyRupee2CuteRe } from './mgcIcon-currency_rupee_2_cute_re.icon';
import { mgcIconCurrencyRupeeCuteRe } from './mgcIcon-currency_rupee_cute_re.icon';
import { mgcIconCurrencyShekel2CuteRe } from './mgcIcon-currency_shekel_2_cute_re.icon';
import { mgcIconCurrencyShekelCuteRe } from './mgcIcon-currency_shekel_cute_re.icon';
import { mgcIconCurrencyWon2CuteRe } from './mgcIcon-currency_won_2_cute_re.icon';
import { mgcIconCurrencyWonCuteRe } from './mgcIcon-currency_won_cute_re.icon';
import { mgcIconDiamond2CuteRe } from './mgcIcon-diamond_2_cute_re.icon';
import { mgcIconExchangeBahtCuteRe } from './mgcIcon-exchange_baht_cute_re.icon';
import { mgcIconExchangeCnyCuteRe } from './mgcIcon-exchange_cny_cute_re.icon';
import { mgcIconExchangeDollarCuteRe } from './mgcIcon-exchange_dollar_cute_re.icon';
import { mgcIconExchangeEuroCuteRe } from './mgcIcon-exchange_euro_cute_re.icon';
import { mgcIconFilter3CuteRe } from './mgcIcon-filter_3_cute_re.icon';
import { mgcIconFilterCuteRe } from './mgcIcon-filter_cute_re.icon';
import { mgcIconFlag1CuteRe } from './mgcIcon-flag_1_cute_re.icon';
import { mgcIconFlag2CuteRe } from './mgcIcon-flag_2_cute_re.icon';
import { mgcIconFlag3CuteRe } from './mgcIcon-flag_3_cute_re.icon';
import { mgcIconFlag4CuteRe } from './mgcIcon-flag_4_cute_re.icon';
import { mgcIconGift2CuteRe } from './mgcIcon-gift_2_cute_re.icon';
import { mgcIconGiftCardCuteRe } from './mgcIcon-gift_card_cute_re.icon';
import { mgcIconGiftCuteRe } from './mgcIcon-gift_cute_re.icon';
import { mgcIconLadderCuteRe } from './mgcIcon-ladder_cute_re.icon';
import { mgcIconLantern2CuteRe } from './mgcIcon-lantern_2_cute_re.icon';
import { mgcIconLanternCuteRe } from './mgcIcon-lantern_cute_re.icon';
import { mgcIconLaurelWreathCuteRe } from './mgcIcon-laurel_wreath_cute_re.icon';
import { mgcIconLuggageCuteRe } from './mgcIcon-luggage_cute_re.icon';
import { mgcIconMedalCuteRe } from './mgcIcon-medal_cute_re.icon';
import { mgcIconPalette3CuteRe } from './mgcIcon-palette_3_cute_re.icon';
import { mgcIconPigMoneyCuteRe } from './mgcIcon-pig_money_cute_re.icon';
import { mgcIconPound2CuteRe } from './mgcIcon-pound_2_cute_re.icon';
import { mgcIconPoundCuteRe } from './mgcIcon-pound_cute_re.icon';
import { mgcIconPresentation1CuteRe } from './mgcIcon-presentation_1_cute_re.icon';
import { mgcIconPresentation2CuteRe } from './mgcIcon-presentation_2_cute_re.icon';
import { mgcIconPresentation3CuteRe } from './mgcIcon-presentation_3_cute_re.icon';
import { mgcIconPumpkinLanternCuteRe } from './mgcIcon-pumpkin_lantern_cute_re.icon';
import { mgcIconReceiveMoneyCuteRe } from './mgcIcon-receive_money_cute_re.icon';
import { mgcIconRedPacketCuteRe } from './mgcIcon-red_packet_cute_re.icon';
import { mgcIconRedPacketOpenCuteRe } from './mgcIcon-red_packet_open_cute_re.icon';
import { mgcIconRefundCnyCuteRe } from './mgcIcon-refund_cny_cute_re.icon';
import { mgcIconRefundDollarCuteRe } from './mgcIcon-refund_dollar_cute_re.icon';
import { mgcIconRegisteredCuteRe } from './mgcIcon-registered_cute_re.icon';
import { mgcIconSafeBoxCuteRe } from './mgcIcon-safe_box_cute_re.icon';
import { mgcIconSaleCuteRe } from './mgcIcon-sale_cute_re.icon';
import { mgcIconScheduleCuteRe } from './mgcIcon-schedule_cute_re.icon';
import { mgcIconSealCuteRe } from './mgcIcon-seal_cute_re.icon';
import { mgcIconShoppingBag1CuteRe } from './mgcIcon-shopping_bag_1_cute_re.icon';
import { mgcIconShoppingBag2CuteRe } from './mgcIcon-shopping_bag_2_cute_re.icon';
import { mgcIconShoppingBag3CuteRe } from './mgcIcon-shopping_bag_3_cute_re.icon';
import { mgcIconShoppingCart1CuteRe } from './mgcIcon-shopping_cart_1_cute_re.icon';
import { mgcIconShoppingCart2CuteRe } from './mgcIcon-shopping_cart_2_cute_re.icon';
import { mgcIconSofaCuteRe } from './mgcIcon-sofa_cute_re.icon';
import { mgcIconStockCuteRe } from './mgcIcon-stock_cute_re.icon';
import { mgcIconSuitcase2CuteRe } from './mgcIcon-suitcase_2_cute_re.icon';
import { mgcIconSuitcaseCuteRe } from './mgcIcon-suitcase_cute_re.icon';
import { mgcIconTag2CuteRe } from './mgcIcon-tag_2_cute_re.icon';
import { mgcIconTagChevronCuteRe } from './mgcIcon-tag_chevron_cute_re.icon';
import { mgcIconTagCuteRe } from './mgcIcon-tag_cute_re.icon';
import { mgcIconTargetCuteRe } from './mgcIcon-target_cute_re.icon';
import { mgcIconTicketCuteRe } from './mgcIcon-ticket_cute_re.icon';
import { mgcIconTrophyCuteRe } from './mgcIcon-trophy_cute_re.icon';
import { mgcIconVip1CuteRe } from './mgcIcon-VIP_1_cute_re.icon';
import { mgcIconVip2CuteRe } from './mgcIcon-VIP_2_cute_re.icon';
import { mgcIconVip3CuteRe } from './mgcIcon-VIP_3_cute_re.icon';
import { mgcIconVip4CuteRe } from './mgcIcon-VIP_4_cute_re.icon';
import { mgcIconWallet2CuteRe } from './mgcIcon-wallet_2_cute_re.icon';
import { mgcIconWallet3CuteRe } from './mgcIcon-wallet_3_cute_re.icon';
import { mgcIconWallet4CuteRe } from './mgcIcon-wallet_4_cute_re.icon';
import { mgcIconWallet5CuteRe } from './mgcIcon-wallet_5_cute_re.icon';
import { mgcIconWalletCuteRe } from './mgcIcon-wallet_cute_re.icon';
import { mgcIconYuanbaoCuteRe } from './mgcIcon-yuanbao_cute_re.icon';
import { mgcIconChat1CuteRe } from './mgcIcon-chat_1_cute_re.icon';
import { mgcIconChat2CuteRe } from './mgcIcon-chat_2_cute_re.icon';
import { mgcIconChat3CuteRe } from './mgcIcon-chat_3_cute_re.icon';
import { mgcIconChat4CuteRe } from './mgcIcon-chat_4_cute_re.icon';
import { mgcIconComment2CuteRe } from './mgcIcon-comment_2_cute_re.icon';
import { mgcIconCommentCuteRe } from './mgcIcon-comment_cute_re.icon';
import { mgcIconInviteCuteRe } from './mgcIcon-invite_cute_re.icon';
import { mgcIconMailAiCuteRe } from './mgcIcon-mail_ai_cute_re.icon';
import { mgcIconMailCuteRe } from './mgcIcon-mail_cute_re.icon';
import { mgcIconMailOpenCuteRe } from './mgcIcon-mail_open_cute_re.icon';
import { mgcIconMailSendCuteRe } from './mgcIcon-mail_send_cute_re.icon';
import { mgcIconMailboxCuteRe } from './mgcIcon-mailbox_cute_re.icon';
import { mgcIconMessage1CuteRe } from './mgcIcon-message_1_cute_re.icon';
import { mgcIconMessage2CuteRe } from './mgcIcon-message_2_cute_re.icon';
import { mgcIconMessage3CuteRe } from './mgcIcon-message_3_cute_re.icon';
import { mgcIconMessage4CuteRe } from './mgcIcon-message_4_cute_re.icon';
import { mgcIconPhoneAddCuteRe } from './mgcIcon-phone_add_cute_re.icon';
import { mgcIconPhoneBlockCuteRe } from './mgcIcon-phone_block_cute_re.icon';
import { mgcIconPhoneCallCuteRe } from './mgcIcon-phone_call_cute_re.icon';
import { mgcIconPhoneCuteRe } from './mgcIcon-phone_cute_re.icon';
import { mgcIconPhoneIncomingCuteRe } from './mgcIcon-phone_incoming_cute_re.icon';
import { mgcIconPhoneOffCuteRe } from './mgcIcon-phone_off_cute_re.icon';
import { mgcIconPhoneOutgoingCuteRe } from './mgcIcon-phone_outgoing_cute_re.icon';
import { mgcIconPhoneSuccessCuteRe } from './mgcIcon-phone_success_cute_re.icon';
import { mgcIconSendCuteRe } from './mgcIcon-send_cute_re.icon';
import { mgcIconSendPlaneCuteRe } from './mgcIcon-send_plane_cute_re.icon';
import { mgcIconAvalancheAvaxCuteRe } from './mgcIcon-avalanche_AVAX_cute_re.icon';
import { mgcIconBinanceCoinBnbCuteRe } from './mgcIcon-binance_coin_BNB_cute_re.icon';
import { mgcIconBinanceUsdBusdCuteRe } from './mgcIcon-binance_USD_BUSD_cute_re.icon';
import { mgcIconBnbCuteRe } from './mgcIcon-BNB_cute_re.icon';
import { mgcIconCardanoAdaCuteRe } from './mgcIcon-cardano_ADA_cute_re.icon';
import { mgcIconCurrencyBitcoin2CuteRe } from './mgcIcon-currency_bitcoin_2_cute_re.icon';
import { mgcIconCurrencyBitcoinCuteRe } from './mgcIcon-currency_bitcoin_cute_re.icon';
import { mgcIconDogecoinDogeCuteRe } from './mgcIcon-dogecoin_DOGE_cute_re.icon';
import { mgcIconEthereumCuteRe } from './mgcIcon-ethereum_cute_re.icon';
import { mgcIconExchangeBitcoinCuteRe } from './mgcIcon-exchange_bitcoin_cute_re.icon';
import { mgcIconMoneroCuteRe } from './mgcIcon-monero_cute_re.icon';
import { mgcIconPolkadotDotCuteRe } from './mgcIcon-polkadot_DOT_cute_re.icon';
import { mgcIconSolanaSolCuteRe } from './mgcIcon-solana_SOL_cute_re.icon';
import { mgcIconTetherUsdtCuteRe } from './mgcIcon-tether_USDT_cute_re.icon';
import { mgcIconUsdCoinUsdcCuteRe } from './mgcIcon-usd_coin_USDC_cute_re.icon';
import { mgcIconXrpCuteRe } from './mgcIcon-XRP_cute_re.icon';
import { mgcIconAlignBottomCuteRe } from './mgcIcon-align_bottom_cute_re.icon';
import { mgcIconAlignHorizontalCenterCuteRe } from './mgcIcon-align_horizontal_center_cute_re.icon';
import { mgcIconAlignLeft2CuteRe } from './mgcIcon-align_left_2_cute_re.icon';
import { mgcIconAlignRight2CuteRe } from './mgcIcon-align_right_2_cute_re.icon';
import { mgcIconAlignTopCuteRe } from './mgcIcon-align_top_cute_re.icon';
import { mgcIconAlignVerticalCenterCuteRe } from './mgcIcon-align_vertical_center_cute_re.icon';
import { mgcIconAnticlockwiseAltCuteRe } from './mgcIcon-anticlockwise_alt_cute_re.icon';
import { mgcIconAnticlockwiseCuteRe } from './mgcIcon-anticlockwise_cute_re.icon';
import { mgcIconArtboardCuteRe } from './mgcIcon-artboard_cute_re.icon';
import { mgcIconBackgroundBaseCuteRe } from './mgcIcon-background_base_cute_re.icon';
import { mgcIconBackgroundCuteRe } from './mgcIcon-background_cute_re.icon';
import { mgcIconBlingCuteRe } from './mgcIcon-bling_cute_re.icon';
import { mgcIconBoardCuteRe } from './mgcIcon-board_cute_re.icon';
import { mgcIconBorderBlankCuteRe } from './mgcIcon-border_blank_cute_re.icon';
import { mgcIconBorderBottomCuteRe } from './mgcIcon-border_bottom_cute_re.icon';
import { mgcIconBorderHorizontalCuteRe } from './mgcIcon-border_horizontal_cute_re.icon';
import { mgcIconBorderInnerCuteRe } from './mgcIcon-border_inner_cute_re.icon';
import { mgcIconBorderLeftCuteRe } from './mgcIcon-border_left_cute_re.icon';
import { mgcIconBorderOuterCuteRe } from './mgcIcon-border_outer_cute_re.icon';
import { mgcIconBorderRadiusCuteRe } from './mgcIcon-border_radius_cute_re.icon';
import { mgcIconBorderRightCuteRe } from './mgcIcon-border_right_cute_re.icon';
import { mgcIconBorderTopCuteRe } from './mgcIcon-border_top_cute_re.icon';
import { mgcIconBorderVerticalCuteRe } from './mgcIcon-border_vertical_cute_re.icon';
import { mgcIconBrightnessCuteRe } from './mgcIcon-brightness_cute_re.icon';
import { mgcIconBrush2CuteRe } from './mgcIcon-brush_2_cute_re.icon';
import { mgcIconClockwiseAltCuteRe } from './mgcIcon-clockwise_alt_cute_re.icon';
import { mgcIconClockwiseCuteRe } from './mgcIcon-clockwise_cute_re.icon';
import { mgcIconColorFilterCuteRe } from './mgcIcon-color_filter_cute_re.icon';
import { mgcIconColorPickerCuteRe } from './mgcIcon-color_picker_cute_re.icon';
import { mgcIconColumns2CuteRe } from './mgcIcon-columns_2_cute_re.icon';
import { mgcIconColumns3CuteRe } from './mgcIcon-columns_3_cute_re.icon';
import { mgcIconCombineCuteRe } from './mgcIcon-combine_cute_re.icon';
import { mgcIconComponentsCuteRe } from './mgcIcon-components_cute_re.icon';
import { mgcIconDistributeSpacingHorizontalCuteRe } from './mgcIcon-distribute_spacing_horizontal_cute_re.icon';
import { mgcIconDistributeSpacingVerticalCuteRe } from './mgcIcon-distribute_spacing_vertical_cute_re.icon';
import { mgcIconDrawingBoardCuteRe } from './mgcIcon-drawing_board_cute_re.icon';
import { mgcIconDropCuteRe } from './mgcIcon-drop_cute_re.icon';
import { mgcIconEaseInControlPointCuteRe } from './mgcIcon-ease_in_control_point_cute_re.icon';
import { mgcIconEaseInCuteRe } from './mgcIcon-ease_in_cute_re.icon';
import { mgcIconEaseInOutControlPointCuteRe } from './mgcIcon-ease_in_out_control_point_cute_re.icon';
import { mgcIconEaseOutControlPointCuteRe } from './mgcIcon-ease_out_control_point_cute_re.icon';
import { mgcIconEaseOutCuteRe } from './mgcIcon-ease_out_cute_re.icon';
import { mgcIconEasyInOutCuteRe } from './mgcIcon-easy_in_out_cute_re.icon';
import { mgcIconExcludeCuteRe } from './mgcIcon-exclude_cute_re.icon';
import { mgcIconExposureCuteRe } from './mgcIcon-exposure_cute_re.icon';
import { mgcIconFlipHorizontalCuteRe } from './mgcIcon-flip_horizontal_cute_re.icon';
import { mgcIconFlipVerticalCuteRe } from './mgcIcon-flip_vertical_cute_re.icon';
import { mgcIconFoldHorizontalCuteRe } from './mgcIcon-fold_horizontal_cute_re.icon';
import { mgcIconFoldVerticalCuteRe } from './mgcIcon-fold_vertical_cute_re.icon';
import { mgcIconIntersectCuteRe } from './mgcIcon-intersect_cute_re.icon';
import { mgcIconKnifeCuteRe } from './mgcIcon-knife_cute_re.icon';
import { mgcIconLayerCuteRe } from './mgcIcon-layer_cute_re.icon';
import { mgcIconLayout10CuteRe } from './mgcIcon-layout_10_cute_re.icon';
import { mgcIconLayout11CuteRe } from './mgcIcon-layout_11_cute_re.icon';
import { mgcIconLayout2CuteRe } from './mgcIcon-layout_2_cute_re.icon';
import { mgcIconLayout3CuteRe } from './mgcIcon-layout_3_cute_re.icon';
import { mgcIconLayout4CuteRe } from './mgcIcon-layout_4_cute_re.icon';
import { mgcIconLayout5CuteRe } from './mgcIcon-layout_5_cute_re.icon';
import { mgcIconLayout6CuteRe } from './mgcIcon-layout_6_cute_re.icon';
import { mgcIconLayout7CuteRe } from './mgcIcon-layout_7_cute_re.icon';
import { mgcIconLayout8CuteRe } from './mgcIcon-layout_8_cute_re.icon';
import { mgcIconLayout9CuteRe } from './mgcIcon-layout_9_cute_re.icon';
import { mgcIconLayoutBottomCloseCuteRe } from './mgcIcon-layout_bottom_close_cute_re.icon';
import { mgcIconLayoutBottomCuteRe } from './mgcIcon-layout_bottom_cute_re.icon';
import { mgcIconLayoutBottomOpenCuteRe } from './mgcIcon-layout_bottom_open_cute_re.icon';
import { mgcIconLayoutCuteRe } from './mgcIcon-layout_cute_re.icon';
import { mgcIconLayoutGridCuteRe } from './mgcIcon-layout_grid_cute_re.icon';
import { mgcIconLayoutLeftCuteRe } from './mgcIcon-layout_left_cute_re.icon';
import { mgcIconLayoutLeftbarCloseCuteRe } from './mgcIcon-layout_leftbar_close_cute_re.icon';
import { mgcIconLayoutLeftbarOpenCuteRe } from './mgcIcon-layout_leftbar_open_cute_re.icon';
import { mgcIconLayoutRightCuteRe } from './mgcIcon-layout_right_cute_re.icon';
import { mgcIconLayoutRightbarCloseCuteRe } from './mgcIcon-layout_rightbar_close_cute_re.icon';
import { mgcIconLayoutRightbarOpenCuteRe } from './mgcIcon-layout_rightbar_open_cute_re.icon';
import { mgcIconLayoutTopCloseCuteRe } from './mgcIcon-layout_top_close_cute_re.icon';
import { mgcIconLayoutTopCuteRe } from './mgcIcon-layout_top_cute_re.icon';
import { mgcIconLayoutTopOpenCuteRe } from './mgcIcon-layout_top_open_cute_re.icon';
import { mgcIconMagic1CuteRe } from './mgcIcon-magic_1_cute_re.icon';
import { mgcIconMagic2CuteRe } from './mgcIcon-magic_2_cute_re.icon';
import { mgcIconMagic3CuteRe } from './mgcIcon-magic_3_cute_re.icon';
import { mgcIconMagicHat2CuteRe } from './mgcIcon-magic_hat_2_cute_re.icon';
import { mgcIconMagicHatCuteRe } from './mgcIcon-magic_hat_cute_re.icon';
import { mgcIconMarkPenCuteRe } from './mgcIcon-mark_pen_cute_re.icon';
import { mgcIconMarkupCuteRe } from './mgcIcon-markup_cute_re.icon';
import { mgcIconMirrorCuteRe } from './mgcIcon-mirror_cute_re.icon';
import { mgcIconMosaicCuteRe } from './mgcIcon-mosaic_cute_re.icon';
import { mgcIconPaint2CuteRe } from './mgcIcon-paint_2_cute_re.icon';
import { mgcIconPaintBrushAiCuteRe } from './mgcIcon-paint_brush_ai_cute_re.icon';
import { mgcIconPaintBrushCuteRe } from './mgcIcon-paint_brush_cute_re.icon';
import { mgcIconPalette2CuteRe } from './mgcIcon-palette_2_cute_re.icon';
import { mgcIconPaletteCuteRe } from './mgcIcon-palette_cute_re.icon';
import { mgcIconPasterCuteRe } from './mgcIcon-paster_cute_re.icon';
import { mgcIconPenCuteRe } from './mgcIcon-pen_cute_re.icon';
import { mgcIconQuillPenAiCuteRe } from './mgcIcon-quill_pen_ai_cute_re.icon';
import { mgcIconQuillPenCuteRe } from './mgcIcon-quill_pen_cute_re.icon';
import { mgcIconRotateXCuteRe } from './mgcIcon-rotate_x_cute_re.icon';
import { mgcIconRotateYCuteRe } from './mgcIcon-rotate_y_cute_re.icon';
import { mgcIconRows2CuteRe } from './mgcIcon-rows_2_cute_re.icon';
import { mgcIconRows3CuteRe } from './mgcIcon-rows_3_cute_re.icon';
import { mgcIconRows4CuteRe } from './mgcIcon-rows_4_cute_re.icon';
import { mgcIconRulerCuteRe } from './mgcIcon-ruler_cute_re.icon';
import { mgcIconScaleCuteRe } from './mgcIcon-scale_cute_re.icon';
import { mgcIconScissors2CuteRe } from './mgcIcon-scissors_2_cute_re.icon';
import { mgcIconScissors3CuteRe } from './mgcIcon-scissors_3_cute_re.icon';
import { mgcIconScissorsCuteRe } from './mgcIcon-scissors_cute_re.icon';
import { mgcIconScreenshotCuteRe } from './mgcIcon-screenshot_cute_re.icon';
import { mgcIconSectionCuteRe } from './mgcIcon-section_cute_re.icon';
import { mgcIconShadowCuteRe } from './mgcIcon-shadow_cute_re.icon';
import { mgcIconStickerCuteRe } from './mgcIcon-sticker_cute_re.icon';
import { mgcIconSubtractCuteRe } from './mgcIcon-subtract_cute_re.icon';
import { mgcIconTable2CuteRe } from './mgcIcon-table_2_cute_re.icon';
import { mgcIconUnfoldHorizontalCuteRe } from './mgcIcon-unfold_horizontal_cute_re.icon';
import { mgcIconUnfoldVerticalCuteRe } from './mgcIcon-unfold_vertical_cute_re.icon';
import { mgcIconUnionCuteRe } from './mgcIcon-union_cute_re.icon';
import { mgcIconVectorBezier2CuteRe } from './mgcIcon-vector_bezier_2_cute_re.icon';
import { mgcIconVectorBezier3CuteRe } from './mgcIcon-vector_bezier_3_cute_re.icon';
import { mgcIconVectorBezierCuteRe } from './mgcIcon-vector_bezier_cute_re.icon';
import { mgcIconVectorGroupCuteRe } from './mgcIcon-vector_group_cute_re.icon';
import { mgcIconXSkewCuteRe } from './mgcIcon-x_skew_cute_re.icon';
import { mgcIconYSkewCuteRe } from './mgcIcon-y_skew_cute_re.icon';
import { mgcIconBracesCuteRe } from './mgcIcon-braces_cute_re.icon';
import { mgcIconBracketsAngleCuteRe } from './mgcIcon-brackets_angle_cute_re.icon';
import { mgcIconBracketsCuteRe } from './mgcIcon-brackets_cute_re.icon';
import { mgcIconBugCuteRe } from './mgcIcon-bug_cute_re.icon';
import { mgcIconCodeCuteRe } from './mgcIcon-code_cute_re.icon';
import { mgcIconCommandCuteRe } from './mgcIcon-command_cute_re.icon';
import { mgcIconCursor2CuteRe } from './mgcIcon-cursor_2_cute_re.icon';
import { mgcIconCursor3CuteRe } from './mgcIcon-cursor_3_cute_re.icon';
import { mgcIconCursorCuteRe } from './mgcIcon-cursor_cute_re.icon';
import { mgcIconDepartmentCuteRe } from './mgcIcon-department_cute_re.icon';
import { mgcIconDirectoryCuteRe } from './mgcIcon-directory_cute_re.icon';
import { mgcIconGitBranchCuteRe } from './mgcIcon-git_branch_cute_re.icon';
import { mgcIconGitCommitCuteRe } from './mgcIcon-git_commit_cute_re.icon';
import { mgcIconGitCompareCuteRe } from './mgcIcon-git_compare_cute_re.icon';
import { mgcIconGitMergeCuteRe } from './mgcIcon-git_merge_cute_re.icon';
import { mgcIconGitPullRequestCloseCuteRe } from './mgcIcon-git_pull_request_close_cute_re.icon';
import { mgcIconGitPullRequestCuteRe } from './mgcIcon-git_pull_request_cute_re.icon';
import { mgcIconHotkeyCuteRe } from './mgcIcon-hotkey_cute_re.icon';
import { mgcIconInspectCuteRe } from './mgcIcon-inspect_cute_re.icon';
import { mgcIconParenthesesCuteRe } from './mgcIcon-parentheses_cute_re.icon';
import { mgcIconPerformanceCuteRe } from './mgcIcon-performance_cute_re.icon';
import { mgcIconSitemapCuteRe } from './mgcIcon-sitemap_cute_re.icon';
import { mgcIconTerminalBoxCuteRe } from './mgcIcon-terminal_box_cute_re.icon';
import { mgcIconTerminalCuteRe } from './mgcIcon-terminal_cute_re.icon';
import { mgcIconWebCuteRe } from './mgcIcon-web_cute_re.icon';
import { mgcIconAiCuteRe } from './mgcIcon-ai_cute_re.icon';
import { mgcIconAirConditionCuteRe } from './mgcIcon-air_condition_cute_re.icon';
import { mgcIconAirConditionOpenCuteRe } from './mgcIcon-air_condition_open_cute_re.icon';
import { mgcIconAirplayCuteRe } from './mgcIcon-airplay_cute_re.icon';
import { mgcIconAirpods2CuteRe } from './mgcIcon-airpods_2_cute_re.icon';
import { mgcIconAlarm1CuteRe } from './mgcIcon-alarm_1_cute_re.icon';
import { mgcIconAlarm2CuteRe } from './mgcIcon-alarm_2_cute_re.icon';
import { mgcIconAspectRatioCuteRe } from './mgcIcon-aspect_ratio_cute_re.icon';
import { mgcIconBarcodeCuteRe } from './mgcIcon-barcode_cute_re.icon';
import { mgcIconBarcodeScaCuteRe } from './mgcIcon-barcode_sca_cute_re.icon';
import { mgcIconBaseStation2CuteRe } from './mgcIcon-base_station_2_cute_re.icon';
import { mgcIconBaseStationCuteRe } from './mgcIcon-base_station_cute_re.icon';
import { mgcIconBattery1CuteRe } from './mgcIcon-battery_1_cute_re.icon';
import { mgcIconBattery2CuteRe } from './mgcIcon-battery_2_cute_re.icon';
import { mgcIconBattery3CuteRe } from './mgcIcon-battery_3_cute_re.icon';
import { mgcIconBattery4CuteRe } from './mgcIcon-battery_4_cute_re.icon';
import { mgcIconBatteryAutomotiveCuteRe } from './mgcIcon-battery_automotive_cute_re.icon';
import { mgcIconBatteryChargingCuteRe } from './mgcIcon-battery_charging_cute_re.icon';
import { mgcIconBatteryCuteRe } from './mgcIcon-battery_cute_re.icon';
import { mgcIconBluetoothCuteRe } from './mgcIcon-bluetooth_cute_re.icon';
import { mgcIconBluetoothOffCuteRe } from './mgcIcon-bluetooth_off_cute_re.icon';
import { mgcIconBulb2CuteRe } from './mgcIcon-bulb_2_cute_re.icon';
import { mgcIconBulbCuteRe } from './mgcIcon-bulb_cute_re.icon';
import { mgcIconCamcorder2CuteRe } from './mgcIcon-camcorder_2_cute_re.icon';
import { mgcIconCardboardVrCuteRe } from './mgcIcon-cardboard_vr_cute_re.icon';
import { mgcIconCeilingLampCuteRe } from './mgcIcon-ceiling_lamp_cute_re.icon';
import { mgcIconCellphone2AiCuteRe } from './mgcIcon-cellphone_2_ai_cute_re.icon';
import { mgcIconCellphone2CuteRe } from './mgcIcon-cellphone_2_cute_re.icon';
import { mgcIconCellphone2HorizontalCuteRe } from './mgcIcon-cellphone_2_horizontal_cute_re.icon';
import { mgcIconCellphoneCuteRe } from './mgcIcon-cellphone_cute_re.icon';
import { mgcIconCellphoneVibrationCuteRe } from './mgcIcon-cellphone_vibration_cute_re.icon';
import { mgcIconChipCuteRe } from './mgcIcon-chip_cute_re.icon';
import { mgcIconComputerCamerCuteRe } from './mgcIcon-computer_camer_cute_re.icon';
import { mgcIconComputerCameraOffCuteRe } from './mgcIcon-computer_camera_off_cute_re.icon';
import { mgcIconComputerCuteRe } from './mgcIcon-computer_cute_re.icon';
import { mgcIconCounter2CuteRe } from './mgcIcon-counter_2_cute_re.icon';
import { mgcIconCube3DCuteRe } from './mgcIcon-cube_3d_cute_re.icon';
import { mgcIconDashboard2CuteRe } from './mgcIcon-dashboard_2_cute_re.icon';
import { mgcIconDashboard3CuteRe } from './mgcIcon-dashboard_3_cute_re.icon';
import { mgcIconDashboard4CuteRe } from './mgcIcon-dashboard_4_cute_re.icon';
import { mgcIconDashboardCuteRe } from './mgcIcon-dashboard_cute_re.icon';
import { mgcIconDeskLamp2CuteRe } from './mgcIcon-desk_lamp_2_cute_re.icon';
import { mgcIconDeskLampCuteRe } from './mgcIcon-desk_lamp_cute_re.icon';
import { mgcIconDeviceCuteRe } from './mgcIcon-device_cute_re.icon';
import { mgcIconDisplayCuteRe } from './mgcIcon-display_cute_re.icon';
import { mgcIconDroneCuteRe } from './mgcIcon-drone_cute_re.icon';
import { mgcIconEscalatorDownCuteRe } from './mgcIcon-escalator_down_cute_re.icon';
import { mgcIconEscalatorUpCuteRe } from './mgcIcon-escalator_up_cute_re.icon';
import { mgcIconFaxCuteRe } from './mgcIcon-fax_cute_re.icon';
import { mgcIconFlashCircleCuteRe } from './mgcIcon-flash_circle_cute_re.icon';
import { mgcIconFlashCuteRe } from './mgcIcon-flash_cute_re.icon';
import { mgcIconFlashlightCuteRe } from './mgcIcon-flashlight_cute_re.icon';
import { mgcIconFridgeCuteRe } from './mgcIcon-fridge_cute_re.icon';
import { mgcIconGame1CuteRe } from './mgcIcon-game_1_cute_re.icon';
import { mgcIconGame2CuteRe } from './mgcIcon-game_2_cute_re.icon';
import { mgcIconGradienterCuteRe } from './mgcIcon-gradienter_cute_re.icon';
import { mgcIconGuitarCuteRe } from './mgcIcon-guitar_cute_re.icon';
import { mgcIconHighVoltagePowerCuteRe } from './mgcIcon-high_voltage_power_cute_re.icon';
import { mgcIconHomeWifiCuteRe } from './mgcIcon-home_wifi_cute_re.icon';
import { mgcIconHomepodCuteRe } from './mgcIcon-homepod_cute_re.icon';
import { mgcIconHomepodMiniCuteRe } from './mgcIcon-homepod_mini_cute_re.icon';
import { mgcIconIMacCuteRe } from './mgcIcon-iMac_cute_re.icon';
import { mgcIconInstrumentCuteRe } from './mgcIcon-instrument_cute_re.icon';
import { mgcIconKeyboard2CuteRe } from './mgcIcon-keyboard_2_cute_re.icon';
import { mgcIconKeyboardCuteRe } from './mgcIcon-keyboard_cute_re.icon';
import { mgcIconLaptop2CuteRe } from './mgcIcon-laptop_2_cute_re.icon';
import { mgcIconLaptopCuteRe } from './mgcIcon-laptop_cute_re.icon';
import { mgcIconLightCuteRe } from './mgcIcon-light_cute_re.icon';
import { mgcIconMicroscopeCuteRe } from './mgcIcon-microscope_cute_re.icon';
import { mgcIconMidiCuteRe } from './mgcIcon-midi_cute_re.icon';
import { mgcIconMonitorCuteRe } from './mgcIcon-monitor_cute_re.icon';
import { mgcIconMouseCuteRe } from './mgcIcon-mouse_cute_re.icon';
import { mgcIconPadCuteRe } from './mgcIcon-pad_cute_re.icon';
import { mgcIconPanoramasCuteRe } from './mgcIcon-panoramas_cute_re.icon';
import { mgcIconPlugin2CuteRe } from './mgcIcon-plugin_2_cute_re.icon';
import { mgcIconPluginCuteRe } from './mgcIcon-plugin_cute_re.icon';
import { mgcIconPrintCuteRe } from './mgcIcon-print_cute_re.icon';
import { mgcIconProjectorCuteRe } from './mgcIcon-projector_cute_re.icon';
import { mgcIconProjectorScreenCuteRe } from './mgcIcon-projector_screen_cute_re.icon';
import { mgcIconQrcode2CuteRe } from './mgcIcon-qrcode_2_cute_re.icon';
import { mgcIconQrcodeCuteRe } from './mgcIcon-qrcode_cute_re.icon';
import { mgcIconRadaCuteRe } from './mgcIcon-rada_cute_re.icon';
import { mgcIconRadar2CuteRe } from './mgcIcon-radar_2_cute_re.icon';
import { mgcIconRadioCuteRe } from './mgcIcon-radio_cute_re.icon';
import { mgcIconRemoteControlCuteRe } from './mgcIcon-remote_control_cute_re.icon';
import { mgcIconRemoteCuteRe } from './mgcIcon-remote_cute_re.icon';
import { mgcIconRouterModemCuteRe } from './mgcIcon-router_modem_cute_re.icon';
import { mgcIconRss2CuteRe } from './mgcIcon-rss_2_cute_re.icon';
import { mgcIconRssCuteRe } from './mgcIcon-rss_cute_re.icon';
import { mgcIconSandglass2CuteRe } from './mgcIcon-sandglass_2_cute_re.icon';
import { mgcIconSandglassCuteRe } from './mgcIcon-sandglass_cute_re.icon';
import { mgcIconScan2CuteRe } from './mgcIcon-scan_2_cute_re.icon';
import { mgcIconScanCuteRe } from './mgcIcon-scan_cute_re.icon';
import { mgcIconServer2CuteRe } from './mgcIcon-server_2_cute_re.icon';
import { mgcIconServerCuteRe } from './mgcIcon-server_cute_re.icon';
import { mgcIconShowerCuteRe } from './mgcIcon-shower_cute_re.icon';
import { mgcIconSignalCuteRe } from './mgcIcon-signal_cute_re.icon';
import { mgcIconSolarPanelCuteRe } from './mgcIcon-solar_panel_cute_re.icon';
import { mgcIconSpeakerCuteRe } from './mgcIcon-speaker_cute_re.icon';
import { mgcIconStopwatchCuteRe } from './mgcIcon-stopwatch_cute_re.icon';
import { mgcIconStorageCuteRe } from './mgcIcon-storage_cute_re.icon';
import { mgcIconTelescope2CuteRe } from './mgcIcon-telescope_2_cute_re.icon';
import { mgcIconTelescopeCuteRe } from './mgcIcon-telescope_cute_re.icon';
import { mgcIconTowerCraneCuteRe } from './mgcIcon-tower_crane_cute_re.icon';
import { mgcIconTv1CuteRe } from './mgcIcon-tv_1_cute_re.icon';
import { mgcIconTv2CuteRe } from './mgcIcon-tv_2_cute_re.icon';
import { mgcIconUsbCuteRe } from './mgcIcon-usb_cute_re.icon';
import { mgcIconUsbFlashDiskCuteRe } from './mgcIcon-usb_flash_disk_cute_re.icon';
import { mgcIconVisonProCuteRe } from './mgcIcon-vison_pro_cute_re.icon';
import { mgcIconWashMachineCuteRe } from './mgcIcon-wash_machine_cute_re.icon';
import { mgcIconWatch2CuteRe } from './mgcIcon-watch_2_cute_re.icon';
import { mgcIconWatchCuteRe } from './mgcIcon-watch_cute_re.icon';
import { mgcIconWifiCuteRe } from './mgcIcon-wifi_cute_re.icon';
import { mgcIconWifiOffCuteRe } from './mgcIcon-wifi_off_cute_re.icon';
import { mgcIconAlignCenterCuteRe } from './mgcIcon-align_center_cute_re.icon';
import { mgcIconAlignJustifyCuteRe } from './mgcIcon-align_justify_cute_re.icon';
import { mgcIconAlignLeftCuteRe } from './mgcIcon-align_left_cute_re.icon';
import { mgcIconAlignRightCuteRe } from './mgcIcon-align_right_cute_re.icon';
import { mgcIconAndCuteRe } from './mgcIcon-and_cute_re.icon';
import { mgcIconAsterisk2CuteRe } from './mgcIcon-asterisk_2_cute_re.icon';
import { mgcIconAsteriskCuteRe } from './mgcIcon-asterisk_cute_re.icon';
import { mgcIconAtCuteRe } from './mgcIcon-at_cute_re.icon';
import { mgcIconAzSortAscendingLettersCuteRe } from './mgcIcon-AZ_sort_ascending_letters_cute_re.icon';
import { mgcIconAzSortDescendingLettersCuteRe } from './mgcIcon-AZ_sort_descending_letters_cute_re.icon';
import { mgcIconBlockquoteCuteRe } from './mgcIcon-blockquote_cute_re.icon';
import { mgcIconBoldCuteRe } from './mgcIcon-bold_cute_re.icon';
import { mgcIconColumnCuteRe } from './mgcIcon-column_cute_re.icon';
import { mgcIconContentAiCuteRe } from './mgcIcon-content_ai_cute_re.icon';
import { mgcIconCursorTextCuteRe } from './mgcIcon-cursor_text_cute_re.icon';
import { mgcIconDividingLineCuteRe } from './mgcIcon-dividing_line_cute_re.icon';
import { mgcIconEdit2CuteRe } from './mgcIcon-edit_2_cute_re.icon';
import { mgcIconEdit3CuteRe } from './mgcIcon-edit_3_cute_re.icon';
import { mgcIconEdit4CuteRe } from './mgcIcon-edit_4_cute_re.icon';
import { mgcIconEditCuteRe } from './mgcIcon-edit_cute_re.icon';
import { mgcIconEraserCuteRe } from './mgcIcon-eraser_cute_re.icon';
import { mgcIconFontCuteRe } from './mgcIcon-font_cute_re.icon';
import { mgcIconFontSizeCuteRe } from './mgcIcon-font_size_cute_re.icon';
import { mgcIconFormulaCuteRe } from './mgcIcon-formula_cute_re.icon';
import { mgcIconFrameCuteRe } from './mgcIcon-frame_cute_re.icon';
import { mgcIconHashtagCuteRe } from './mgcIcon-hashtag_cute_re.icon';
import { mgcIconHeading1CuteRe } from './mgcIcon-heading_1_cute_re.icon';
import { mgcIconHeading2CuteRe } from './mgcIcon-heading_2_cute_re.icon';
import { mgcIconHeading3CuteRe } from './mgcIcon-heading_3_cute_re.icon';
import { mgcIconIndentDecreaseCuteRe } from './mgcIcon-indent_decrease_cute_re.icon';
import { mgcIconIndentIncreaseCuteRe } from './mgcIcon-indent_increase_cute_re.icon';
import { mgcIconItalicCuteRe } from './mgcIcon-italic_cute_re.icon';
import { mgcIconLetterSpacingCuteRe } from './mgcIcon-letter_spacing_cute_re.icon';
import { mgcIconLineHeightCuteRe } from './mgcIcon-line_height_cute_re.icon';
import { mgcIconListCheck2CuteRe } from './mgcIcon-list_check_2_cute_re.icon';
import { mgcIconListCheck3CuteRe } from './mgcIcon-list_check_3_cute_re.icon';
import { mgcIconListCheckCuteRe } from './mgcIcon-list_check_cute_re.icon';
import { mgcIconListCollapseCuteRe } from './mgcIcon-list_collapse_cute_re.icon';
import { mgcIconListExpansionCuteRe } from './mgcIcon-list_expansion_cute_re.icon';
import { mgcIconListOrderedCuteRe } from './mgcIcon-list_ordered_cute_re.icon';
import { mgcIconListSearchCuteRe } from './mgcIcon-list_search_cute_re.icon';
import { mgcIconMenuCuteRe } from './mgcIcon-menu_cute_re.icon';
import { mgcIconNumbers09SortAscendingCuteRe } from './mgcIcon-numbers_09_sort_ascending_cute_re.icon';
import { mgcIconNumbers09SortDescendingCuteRe } from './mgcIcon-numbers_09_sort_descending_cute_re.icon';
import { mgcIconNumbers90SortAscendingCuteRe } from './mgcIcon-numbers_90_sort_ascending_cute_re.icon';
import { mgcIconNumbers90SortDescendingCuteRe } from './mgcIcon-numbers_90_sort_descending_cute_re.icon';
import { mgcIconOmegaCuteRe } from './mgcIcon-omega_cute_re.icon';
import { mgcIconPaintCuteRe } from './mgcIcon-paint_cute_re.icon';
import { mgcIconParagraphCuteRe } from './mgcIcon-paragraph_cute_re.icon';
import { mgcIconPen2CuteRe } from './mgcIcon-pen_2_cute_re.icon';
import { mgcIconPencil2AiCuteRe } from './mgcIcon-pencil_2_ai_cute_re.icon';
import { mgcIconPencil2CuteRe } from './mgcIcon-pencil_2_cute_re.icon';
import { mgcIconPencil3CuteRe } from './mgcIcon-pencil_3_cute_re.icon';
import { mgcIconPencilCuteRe } from './mgcIcon-pencil_cute_re.icon';
import { mgcIconPencilRulerCuteRe } from './mgcIcon-pencil_ruler_cute_re.icon';
import { mgcIconQuoteLeftCuteRe } from './mgcIcon-quote_left_cute_re.icon';
import { mgcIconQuoteRightCuteRe } from './mgcIcon-quote_right_cute_re.icon';
import { mgcIconSignatureCuteRe } from './mgcIcon-signature_cute_re.icon';
import { mgcIconSortAscendingCuteRe } from './mgcIcon-sort_ascending_cute_re.icon';
import { mgcIconSortDescendingCuteRe } from './mgcIcon-sort_descending_cute_re.icon';
import { mgcIconSpaceCuteRe } from './mgcIcon-space_cute_re.icon';
import { mgcIconSpacingHorizontalCuteRe } from './mgcIcon-spacing_horizontal_cute_re.icon';
import { mgcIconSpacingVerticalCuteRe } from './mgcIcon-spacing_vertical_cute_re.icon';
import { mgcIconStrikethroughCuteRe } from './mgcIcon-strikethrough_cute_re.icon';
import { mgcIconSubtitleCuteRe } from './mgcIcon-subtitle_cute_re.icon';
import { mgcIconTable3CuteRe } from './mgcIcon-table_3_cute_re.icon';
import { mgcIconTableCuteRe } from './mgcIcon-table_cute_re.icon';
import { mgcIconText2CuteRe } from './mgcIcon-text_2_cute_re.icon';
import { mgcIconTextAreaCuteRe } from './mgcIcon-text_area_cute_re.icon';
import { mgcIconTextColorCuteRe } from './mgcIcon-text_color_cute_re.icon';
import { mgcIconTextCuteRe } from './mgcIcon-text_cute_re.icon';
import { mgcIconTextDirectionLeftCuteRe } from './mgcIcon-text_direction_left_cute_re.icon';
import { mgcIconTextDirectionRightCuteRe } from './mgcIcon-text_direction_right_cute_re.icon';
import { mgcIconTextboxAiCuteRe } from './mgcIcon-textbox_ai_cute_re.icon';
import { mgcIconTextboxCuteRe } from './mgcIcon-textbox_cute_re.icon';
import { mgcIconTranslate2AiCuteRe } from './mgcIcon-translate_2_ai_cute_re.icon';
import { mgcIconTranslate2CuteRe } from './mgcIcon-translate_2_cute_re.icon';
import { mgcIconTranslateCuteRe } from './mgcIcon-translate_cute_re.icon';
import { mgcIconUnderlineCuteRe } from './mgcIcon-underline_cute_re.icon';
import { mgcIconZaSortAscendingLettersCuteRe } from './mgcIcon-ZA_sort_ascending_letters_cute_re.icon';
import { mgcIconZaSortDescendingLettersCuteRe } from './mgcIcon-ZA_sort_descending_letters_cute_re.icon';
import { mgcIconBackpackCuteRe } from './mgcIcon-backpack_cute_re.icon';
import { mgcIconBalanceCuteRe } from './mgcIcon-balance_cute_re.icon';
import { mgcIconBlackBoard2CuteRe } from './mgcIcon-black_board_2_cute_re.icon';
import { mgcIconBlackBoardCuteRe } from './mgcIcon-black_board_cute_re.icon';
import { mgcIconBook2CuteRe } from './mgcIcon-book_2_cute_re.icon';
import { mgcIconBook3CuteRe } from './mgcIcon-book_3_cute_re.icon';
import { mgcIconBook4CuteRe } from './mgcIcon-book_4_cute_re.icon';
import { mgcIconBook5CuteRe } from './mgcIcon-book_5_cute_re.icon';
import { mgcIconBook6CuteRe } from './mgcIcon-book_6_cute_re.icon';
import { mgcIconBookCuteRe } from './mgcIcon-book_cute_re.icon';
import { mgcIconBookmarkAddCuteRe } from './mgcIcon-bookmark_add_cute_re.icon';
import { mgcIconBookmarkCuteRe } from './mgcIcon-bookmark_cute_re.icon';
import { mgcIconBookmarkEditCuteRe } from './mgcIcon-bookmark_edit_cute_re.icon';
import { mgcIconBookmarkRemoveCuteRe } from './mgcIcon-bookmark_remove_cute_re.icon';
import { mgcIconBookmarksCuteRe } from './mgcIcon-bookmarks_cute_re.icon';
import { mgcIconCertificate2CuteRe } from './mgcIcon-certificate_2_cute_re.icon';
import { mgcIconCompass2CuteRe } from './mgcIcon-compass_2_cute_re.icon';
import { mgcIconCounterCuteRe } from './mgcIcon-counter_cute_re.icon';
import { mgcIconDeskCuteRe } from './mgcIcon-desk_cute_re.icon';
import { mgcIconDiaryCuteRe } from './mgcIcon-diary_cute_re.icon';
import { mgcIconDrumCuteRe } from './mgcIcon-drum_cute_re.icon';
import { mgcIconEyeglassCuteRe } from './mgcIcon-eyeglass_cute_re.icon';
import { mgcIconFlask2CuteRe } from './mgcIcon-flask_2_cute_re.icon';
import { mgcIconFlask3CuteRe } from './mgcIcon-flask_3_cute_re.icon';
import { mgcIconFlaskCuteRe } from './mgcIcon-flask_cute_re.icon';
import { mgcIconFoldingFanCuteRe } from './mgcIcon-folding_fan_cute_re.icon';
import { mgcIconGlobeCuteRe } from './mgcIcon-globe_cute_re.icon';
import { mgcIconMagnetCuteRe } from './mgcIcon-magnet_cute_re.icon';
import { mgcIconMortarboardCuteRe } from './mgcIcon-mortarboard_cute_re.icon';
import { mgcIconNotebook2CuteRe } from './mgcIcon-notebook_2_cute_re.icon';
import { mgcIconNotebookCuteRe } from './mgcIcon-notebook_cute_re.icon';
import { mgcIconScienceCuteRe } from './mgcIcon-science_cute_re.icon';
import { mgcIconSpeechCuteRe } from './mgcIcon-speech_cute_re.icon';
import { mgcIconTestTubeCuteRe } from './mgcIcon-test_tube_cute_re.icon';
import { mgcIconAngelCuteRe } from './mgcIcon-angel_cute_re.icon';
import { mgcIconAngryCuteRe } from './mgcIcon-angry_cute_re.icon';
import { mgcIconConfusedCuteRe } from './mgcIcon-confused_cute_re.icon';
import { mgcIconEmoji2CuteRe } from './mgcIcon-emoji_2_cute_re.icon';
import { mgcIconEmojiCuteRe } from './mgcIcon-emoji_cute_re.icon';
import { mgcIconHappyCuteRe } from './mgcIcon-happy_cute_re.icon';
import { mgcIconLaughCuteRe } from './mgcIcon-laugh_cute_re.icon';
import { mgcIconLookDownCuteRe } from './mgcIcon-look_down_cute_re.icon';
import { mgcIconLookLeftCuteRe } from './mgcIcon-look_left_cute_re.icon';
import { mgcIconLookRightCuteRe } from './mgcIcon-look_right_cute_re.icon';
import { mgcIconLookUpCuteRe } from './mgcIcon-look_up_cute_re.icon';
import { mgcIconOmgCuteRe } from './mgcIcon-omg_cute_re.icon';
import { mgcIconPuzzledCuteRe } from './mgcIcon-puzzled_cute_re.icon';
import { mgcIconSadCuteRe } from './mgcIcon-sad_cute_re.icon';
import { mgcIconSickCuteRe } from './mgcIcon-sick_cute_re.icon';
import { mgcIconSilentCuteRe } from './mgcIcon-silent_cute_re.icon';
import { mgcIconSobCuteRe } from './mgcIcon-sob_cute_re.icon';
import { mgcIconSurpriseCuteRe } from './mgcIcon-surprise_cute_re.icon';
import { mgcIconSweatsCuteRe } from './mgcIcon-sweats_cute_re.icon';
import { mgcIconTerrorCuteRe } from './mgcIcon-terror_cute_re.icon';
import { mgcIconTongueCuteRe } from './mgcIcon-tongue_cute_re.icon';
import { mgcIconUnhappyCuteRe } from './mgcIcon-unhappy_cute_re.icon';
import { mgcIconUnhappyDizzyCuteRe } from './mgcIcon-unhappy_dizzy_cute_re.icon';
import { mgcIconAlbum2CuteRe } from './mgcIcon-album_2_cute_re.icon';
import { mgcIconArchiveCuteRe } from './mgcIcon-archive_cute_re.icon';
import { mgcIconAttachment2CuteRe } from './mgcIcon-attachment_2_cute_re.icon';
import { mgcIconAttachmentCuteRe } from './mgcIcon-attachment_cute_re.icon';
import { mgcIconBill2CuteRe } from './mgcIcon-bill_2_cute_re.icon';
import { mgcIconBillCuteRe } from './mgcIcon-bill_cute_re.icon';
import { mgcIconBox2CuteRe } from './mgcIcon-box_2_cute_re.icon';
import { mgcIconBox3CuteRe } from './mgcIcon-box_3_cute_re.icon';
import { mgcIconBoxCuteRe } from './mgcIcon-box_cute_re.icon';
import { mgcIconClipboardCuteRe } from './mgcIcon-clipboard_cute_re.icon';
import { mgcIconCopy2CuteRe } from './mgcIcon-copy_2_cute_re.icon';
import { mgcIconCopy3CuteRe } from './mgcIcon-copy_3_cute_re.icon';
import { mgcIconCopyCuteRe } from './mgcIcon-copy_cute_re.icon';
import { mgcIconDocCuteRe } from './mgcIcon-doc_cute_re.icon';
import { mgcIconDocmentCuteRe } from './mgcIcon-docment_cute_re.icon';
import { mgcIconDocument2CuteRe } from './mgcIcon-document_2_cute_re.icon';
import { mgcIconDocument3CuteRe } from './mgcIcon-document_3_cute_re.icon';
import { mgcIconDocumentsCuteRe } from './mgcIcon-documents_cute_re.icon';
import { mgcIconDownload2CuteRe } from './mgcIcon-download_2_cute_re.icon';
import { mgcIconDownload3CuteRe } from './mgcIcon-download_3_cute_re.icon';
import { mgcIconDownloadCuteRe } from './mgcIcon-download_cute_re.icon';
import { mgcIconEmptyBoxCuteRe } from './mgcIcon-empty_box_cute_re.icon';
import { mgcIconExternalLinkCuteRe } from './mgcIcon-external_link_cute_re.icon';
import { mgcIconFileCertificateCuteRe } from './mgcIcon-file_certificate_cute_re.icon';
import { mgcIconFileCheckCuteRe } from './mgcIcon-file_check_cute_re.icon';
import { mgcIconFileCodeCuteRe } from './mgcIcon-file_code_cute_re.icon';
import { mgcIconFileCuteRe } from './mgcIcon-file_cute_re.icon';
import { mgcIconFileDownloadCuteRe } from './mgcIcon-file_download_cute_re.icon';
import { mgcIconFileExportCuteRe } from './mgcIcon-file_export_cute_re.icon';
import { mgcIconFileForbidCuteRe } from './mgcIcon-file_forbid_cute_re.icon';
import { mgcIconFileImportCuteRe } from './mgcIcon-file_import_cute_re.icon';
import { mgcIconFileInfoCuteRe } from './mgcIcon-file_info_cute_re.icon';
import { mgcIconFileLockedCuteRe } from './mgcIcon-file_locked_cute_re.icon';
import { mgcIconFileMoreCuteRe } from './mgcIcon-file_more_cute_re.icon';
import { mgcIconFileMusicCuteRe } from './mgcIcon-file_music_cute_re.icon';
import { mgcIconFileNewCuteRe } from './mgcIcon-file_new_cute_re.icon';
import { mgcIconFileSearchCuteRe } from './mgcIcon-file_search_cute_re.icon';
import { mgcIconFileSecurityCuteRe } from './mgcIcon-file_security_cute_re.icon';
import { mgcIconFileStarCuteRe } from './mgcIcon-file_star_cute_re.icon';
import { mgcIconFileUnknownCuteRe } from './mgcIcon-file_unknown_cute_re.icon';
import { mgcIconFileUploadCuteRe } from './mgcIcon-file_upload_cute_re.icon';
import { mgcIconFileWarningCuteRe } from './mgcIcon-file_warning_cute_re.icon';
import { mgcIconFileZipCuteRe } from './mgcIcon-file_zip_cute_re.icon';
import { mgcIconFolder2CuteRe } from './mgcIcon-folder_2_cute_re.icon';
import { mgcIconFolder3CuteRe } from './mgcIcon-folder_3_cute_re.icon';
import { mgcIconFolderCheckCuteRe } from './mgcIcon-folder_check_cute_re.icon';
import { mgcIconFolderCuteRe } from './mgcIcon-folder_cute_re.icon';
import { mgcIconFolderDeleteCuteRe } from './mgcIcon-folder_delete_cute_re.icon';
import { mgcIconFolderDownloadCuteRe } from './mgcIcon-folder_download_cute_re.icon';
import { mgcIconFolderForbidCuteRe } from './mgcIcon-folder_forbid_cute_re.icon';
import { mgcIconFolderInfoCuteRe } from './mgcIcon-folder_info_cute_re.icon';
import { mgcIconFolderLocked2CuteRe } from './mgcIcon-folder_locked_2_cute_re.icon';
import { mgcIconFolderLockedCuteRe } from './mgcIcon-folder_locked_cute_re.icon';
import { mgcIconFolderMinusCuteRe } from './mgcIcon-folder_minus_cute_re.icon';
import { mgcIconFolderMoreCuteRe } from './mgcIcon-folder_more_cute_re.icon';
import { mgcIconFolderOpen2CuteRe } from './mgcIcon-folder_open_2_cute_re.icon';
import { mgcIconFolderOpenCuteRe } from './mgcIcon-folder_open_cute_re.icon';
import { mgcIconFolderSecurityCuteRe } from './mgcIcon-folder_security_cute_re.icon';
import { mgcIconFolderStarCuteRe } from './mgcIcon-folder_star_cute_re.icon';
import { mgcIconFolderUploadCuteRe } from './mgcIcon-folder_upload_cute_re.icon';
import { mgcIconFolderWarningCuteRe } from './mgcIcon-folder_warning_cute_re.icon';
import { mgcIconFolderZipCuteRe } from './mgcIcon-folder_zip_cute_re.icon';
import { mgcIconFoldersCuteRe } from './mgcIcon-folders_cute_re.icon';
import { mgcIconInbox2CuteRe } from './mgcIcon-inbox_2_cute_re.icon';
import { mgcIconInboxCuteRe } from './mgcIcon-inbox_cute_re.icon';
import { mgcIconInventoryCuteRe } from './mgcIcon-inventory_cute_re.icon';
import { mgcIconLink2CuteRe } from './mgcIcon-link_2_cute_re.icon';
import { mgcIconLink3CuteRe } from './mgcIcon-link_3_cute_re.icon';
import { mgcIconLinkCuteRe } from './mgcIcon-link_cute_re.icon';
import { mgcIconMarkdownCuteRe } from './mgcIcon-markdown_cute_re.icon';
import { mgcIconNewFolderCuteRe } from './mgcIcon-new_folder_cute_re.icon';
import { mgcIconNews2CuteRe } from './mgcIcon-news_2_cute_re.icon';
import { mgcIconNewsCuteRe } from './mgcIcon-news_cute_re.icon';
import { mgcIconPackage2CuteRe } from './mgcIcon-package_2_cute_re.icon';
import { mgcIconPackageCuteRe } from './mgcIcon-package_cute_re.icon';
import { mgcIconPaper2CuteRe } from './mgcIcon-paper_2_cute_re.icon';
import { mgcIconPaperCuteRe } from './mgcIcon-paper_cute_re.icon';
import { mgcIconPassportCuteRe } from './mgcIcon-passport_cute_re.icon';
import { mgcIconPasteCuteRe } from './mgcIcon-paste_cute_re.icon';
import { mgcIconPdfCuteRe } from './mgcIcon-pdf_cute_re.icon';
import { mgcIconPhotoAlbum2CuteRe } from './mgcIcon-photo_album_2_cute_re.icon';
import { mgcIconPhotoAlbumCuteRe } from './mgcIcon-photo_album_cute_re.icon';
import { mgcIconPic2CuteRe } from './mgcIcon-pic_2_cute_re.icon';
import { mgcIconPicAiCuteRe } from './mgcIcon-pic_ai_cute_re.icon';
import { mgcIconPicCuteRe } from './mgcIcon-pic_cute_re.icon';
import { mgcIconPin2CuteRe } from './mgcIcon-pin_2_cute_re.icon';
import { mgcIconPinCuteRe } from './mgcIcon-pin_cute_re.icon';
import { mgcIconPptCuteRe } from './mgcIcon-ppt_cute_re.icon';
import { mgcIconProfileCuteRe } from './mgcIcon-profile_cute_re.icon';
import { mgcIconReportFormsCuteRe } from './mgcIcon-report_forms_cute_re.icon';
import { mgcIconSave2CuteRe } from './mgcIcon-save_2_cute_re.icon';
import { mgcIconSaveCuteRe } from './mgcIcon-save_cute_re.icon';
import { mgcIconSearch2CuteRe } from './mgcIcon-search_2_cute_re.icon';
import { mgcIconSearch3CuteRe } from './mgcIcon-search_3_cute_re.icon';
import { mgcIconSearchAiCuteRe } from './mgcIcon-search_ai_cute_re.icon';
import { mgcIconSearchCuteRe } from './mgcIcon-search_cute_re.icon';
import { mgcIconTask2CuteRe } from './mgcIcon-task_2_cute_re.icon';
import { mgcIconTaskCuteRe } from './mgcIcon-task_cute_re.icon';
import { mgcIconToDoCuteRe } from './mgcIcon-to_do_cute_re.icon';
import { mgcIconUnarchiveCuteRe } from './mgcIcon-unarchive_cute_re.icon';
import { mgcIconUnlink2CuteRe } from './mgcIcon-unlink_2_cute_re.icon';
import { mgcIconUnlinkCuteRe } from './mgcIcon-unlink_cute_re.icon';
import { mgcIconUpload2CuteRe } from './mgcIcon-upload_2_cute_re.icon';
import { mgcIconUpload3CuteRe } from './mgcIcon-upload_3_cute_re.icon';
import { mgcIconUploadCuteRe } from './mgcIcon-upload_cute_re.icon';
import { mgcIconXlsCuteRe } from './mgcIcon-xls_cute_re.icon';
import { mgcIconZoomInCuteRe } from './mgcIcon-zoom_in_cute_re.icon';
import { mgcIconZoomOutCuteRe } from './mgcIcon-zoom_out_cute_re.icon';
import { mgcIconBirthday2CuteRe } from './mgcIcon-birthday_2_cute_re.icon';
import { mgcIconBoneCuteRe } from './mgcIcon-bone_cute_re.icon';
import { mgcIconBottleGlassCuteRe } from './mgcIcon-bottle_glass_cute_re.icon';
import { mgcIconBowl2CuteRe } from './mgcIcon-bowl_2_cute_re.icon';
import { mgcIconBowlCuteRe } from './mgcIcon-bowl_cute_re.icon';
import { mgcIconBreadCuteRe } from './mgcIcon-bread_cute_re.icon';
import { mgcIconCakeCuteRe } from './mgcIcon-cake_cute_re.icon';
import { mgcIconCandy2CuteRe } from './mgcIcon-candy_2_cute_re.icon';
import { mgcIconCandyCuteRe } from './mgcIcon-candy_cute_re.icon';
import { mgcIconCarrotCuteRe } from './mgcIcon-carrot_cute_re.icon';
import { mgcIconChampagneCuteRe } from './mgcIcon-champagne_cute_re.icon';
import { mgcIconChickenCuteRe } from './mgcIcon-chicken_cute_re.icon';
import { mgcIconChopsticksCuteRe } from './mgcIcon-chopsticks_cute_re.icon';
import { mgcIconCookieCuteRe } from './mgcIcon-cookie_cute_re.icon';
import { mgcIconCookieManCuteRe } from './mgcIcon-cookie_man_cute_re.icon';
import { mgcIconCupcakeCuteRe } from './mgcIcon-cupcake_cute_re.icon';
import { mgcIconDinnerCuteRe } from './mgcIcon-dinner_cute_re.icon';
import { mgcIconDishCoverCuteRe } from './mgcIcon-dish_cover_cute_re.icon';
import { mgcIconDonutCuteRe } from './mgcIcon-donut_cute_re.icon';
import { mgcIconDrinkCuteRe } from './mgcIcon-drink_cute_re.icon';
import { mgcIconEggCrackCuteRe } from './mgcIcon-egg_crack_cute_re.icon';
import { mgcIconEggCuteRe } from './mgcIcon-egg_cute_re.icon';
import { mgcIconElectricCookerCuteRe } from './mgcIcon-electric_cooker_cute_re.icon';
import { mgcIconFeederCuteRe } from './mgcIcon-feeder_cute_re.icon';
import { mgcIconFishCuteRe } from './mgcIcon-fish_cute_re.icon';
import { mgcIconForkCuteRe } from './mgcIcon-fork_cute_re.icon';
import { mgcIconForkKnifeCuteRe } from './mgcIcon-fork_knife_cute_re.icon';
import { mgcIconForkSpoonCuteRe } from './mgcIcon-fork_spoon_cute_re.icon';
import { mgcIconFriedEggCuteRe } from './mgcIcon-fried_egg_cute_re.icon';
import { mgcIconFriesCuteRe } from './mgcIcon-fries_cute_re.icon';
import { mgcIconGlassCupCuteRe } from './mgcIcon-glass_cup_cute_re.icon';
import { mgcIconHamburgerCuteRe } from './mgcIcon-hamburger_cute_re.icon';
import { mgcIconIceCream2CuteRe } from './mgcIcon-ice_cream_2_cute_re.icon';
import { mgcIconIceCreamCuteRe } from './mgcIcon-ice_cream_cute_re.icon';
import { mgcIconLollipopCuteRe } from './mgcIcon-lollipop_cute_re.icon';
import { mgcIconPizzaCuteRe } from './mgcIcon-pizza_cute_re.icon';
import { mgcIconSoupPot2CuteRe } from './mgcIcon-soup_pot_2_cute_re.icon';
import { mgcIconSoupPotCuteRe } from './mgcIcon-soup_pot_cute_re.icon';
import { mgcIconSpatulaCuteRe } from './mgcIcon-spatula_cute_re.icon';
import { mgcIconSpoonCuteRe } from './mgcIcon-spoon_cute_re.icon';
import { mgcIconSugarCoatedHawsCuteRe } from './mgcIcon-sugar_coated_haws_cute_re.icon';
import { mgcIconTeacupCuteRe } from './mgcIcon-teacup_cute_re.icon';
import { mgcIconWineCuteRe } from './mgcIcon-wine_cute_re.icon';
import { mgcIconWineglass2CuteRe } from './mgcIcon-wineglass_2_cute_re.icon';
import { mgcIconWineglassCuteRe } from './mgcIcon-wineglass_cute_re.icon';
import { mgcIconAirbnbCuteRe } from './mgcIcon-airbnb_cute_re.icon';
import { mgcIconAirdropCuteRe } from './mgcIcon-airdrop_cute_re.icon';
import { mgcIconAlipayCuteRe } from './mgcIcon-alipay_cute_re.icon';
import { mgcIconAndroid2CuteRe } from './mgcIcon-Android_2_cute_re.icon';
import { mgcIconAndroidCuteRe } from './mgcIcon-android_cute_re.icon';
import { mgcIconAppleCuteRe } from './mgcIcon-apple_cute_re.icon';
import { mgcIconAppleIntelligenceCuteRe } from './mgcIcon-apple_intelligence_cute_re.icon';
import { mgcIconAppleIntelligenceFrameCuteRe } from './mgcIcon-apple_intelligence_frame_cute_re.icon';
import { mgcIconAppstoreCuteRe } from './mgcIcon-appstore_cute_re.icon';
import { mgcIconArcBrowserCuteRe } from './mgcIcon-arc_browser_cute_re.icon';
import { mgcIconBehanceCuteRe } from './mgcIcon-behance_cute_re.icon';
import { mgcIconBilibiliCuteRe } from './mgcIcon-bilibili_cute_re.icon';
import { mgcIconBlueskySocialCuteRe } from './mgcIcon-bluesky_social_cute_re.icon';
import { mgcIconCarplayCuteRe } from './mgcIcon-carplay_cute_re.icon';
import { mgcIconChromeCuteRe } from './mgcIcon-chrome_cute_re.icon';
import { mgcIconCodepenCuteRe } from './mgcIcon-codepen_cute_re.icon';
import { mgcIconCopilotCuteRe } from './mgcIcon-copilot_cute_re.icon';
import { mgcIconDingtalkCuteRe } from './mgcIcon-dingtalk_cute_re.icon';
import { mgcIconDiscordCuteRe } from './mgcIcon-discord_cute_re.icon';
import { mgcIconDribbbleCuteRe } from './mgcIcon-dribbble_cute_re.icon';
import { mgcIconDriveCuteRe } from './mgcIcon-drive_cute_re.icon';
import { mgcIconDropboxCuteRe } from './mgcIcon-dropbox_cute_re.icon';
import { mgcIconEdgeCuteRe } from './mgcIcon-edge_cute_re.icon';
import { mgcIconFacebookCuteRe } from './mgcIcon-facebook_cute_re.icon';
import { mgcIconFigmaCuteRe } from './mgcIcon-figma_cute_re.icon';
import { mgcIconFirefoxCuteRe } from './mgcIcon-firefox_cute_re.icon';
import { mgcIconFollowCuteRe } from './mgcIcon-follow_cute_re.icon';
import { mgcIconGitLabCuteRe } from './mgcIcon-git_lab_cute_re.icon';
import { mgcIconGithub2CuteRe } from './mgcIcon-github_2_cute_re.icon';
import { mgcIconGithubCuteRe } from './mgcIcon-github_cute_re.icon';
import { mgcIconGoogleCuteRe } from './mgcIcon-google_cute_re.icon';
import { mgcIconGooglePlayCuteRe } from './mgcIcon-google_play_cute_re.icon';
import { mgcIconGrokCuteRe } from './mgcIcon-grok_cute_re.icon';
import { mgcIconGumroadCuteRe } from './mgcIcon-gumroad_cute_re.icon';
import { mgcIconInstagramCuteRe } from './mgcIcon-instagram_cute_re.icon';
import { mgcIconKakaoTalkCuteRe } from './mgcIcon-kakao_talk_cute_re.icon';
import { mgcIconLayersCuteRe } from './mgcIcon-layers_cute_re.icon';
import { mgcIconLemonSqueezyCuteRe } from './mgcIcon-lemon_squeezy_cute_re.icon';
import { mgcIconLineAppCuteRe } from './mgcIcon-line_app_cute_re.icon';
import { mgcIconLinearCuteRe } from './mgcIcon-linear_cute_re.icon';
import { mgcIconLinkedinCuteRe } from './mgcIcon-linkedin_cute_re.icon';
import { mgcIconLinuxCuteRe } from './mgcIcon-linux_cute_re.icon';
import { mgcIconMastercardCuteRe } from './mgcIcon-mastercard_cute_re.icon';
import { mgcIconMastodonCuteRe } from './mgcIcon-mastodon_cute_re.icon';
import { mgcIconMediumCuteRe } from './mgcIcon-medium_cute_re.icon';
import { mgcIconMessengerCuteRe } from './mgcIcon-messenger_cute_re.icon';
import { mgcIconMetaCuteRe } from './mgcIcon-meta_cute_re.icon';
import { mgcIconMingcuteCuteRe } from './mgcIcon-mingcute_cute_re.icon';
import { mgcIconMomentCuteRe } from './mgcIcon-moment_cute_re.icon';
import { mgcIconNeteaseMusicCuteRe } from './mgcIcon-netease_music_cute_re.icon';
import { mgcIconNfcCuteRe } from './mgcIcon-nfc_cute_re.icon';
import { mgcIconNintendoSwitchCuteRe } from './mgcIcon-nintendo_switch_cute_re.icon';
import { mgcIconNotionCuteRe } from './mgcIcon-notion_cute_re.icon';
import { mgcIconOpenaiCuteRe } from './mgcIcon-openai_cute_re.icon';
import { mgcIconPaypalCuteRe } from './mgcIcon-paypal_cute_re.icon';
import { mgcIconPinterestCuteRe } from './mgcIcon-pinterest_cute_re.icon';
import { mgcIconQqCuteRe } from './mgcIcon-qq_cute_re.icon';
import { mgcIconReactCuteRe } from './mgcIcon-react_cute_re.icon';
import { mgcIconRedditCuteRe } from './mgcIcon-reddit_cute_re.icon';
import { mgcIconSafariCuteRe } from './mgcIcon-safari_cute_re.icon';
import { mgcIconSiriCuteRe } from './mgcIcon-siri_cute_re.icon';
import { mgcIconSiriFrameCuteRe } from './mgcIcon-siri_frame_cute_re.icon';
import { mgcIconSnapchatCuteRe } from './mgcIcon-snapchat_cute_re.icon';
import { mgcIconSocialXCuteRe } from './mgcIcon-social_x_cute_re.icon';
import { mgcIconSpotifyCuteRe } from './mgcIcon-spotify_cute_re.icon';
import { mgcIconStripeCuteRe } from './mgcIcon-stripe_cute_re.icon';
import { mgcIconTelegramCuteRe } from './mgcIcon-telegram_cute_re.icon';
import { mgcIconThreadsCuteRe } from './mgcIcon-threads_cute_re.icon';
import { mgcIconTiktokCuteRe } from './mgcIcon-tiktok_cute_re.icon';
import { mgcIconTrelloBoardCuteRe } from './mgcIcon-trello_board_cute_re.icon';
import { mgcIconTwitterCuteRe } from './mgcIcon-twitter_cute_re.icon';
import { mgcIconViberMessengerCuteRe } from './mgcIcon-viber_messenger_cute_re.icon';
import { mgcIconVisaCuteRe } from './mgcIcon-visa_cute_re.icon';
import { mgcIconVkontakteCuteRe } from './mgcIcon-vkontakte_cute_re.icon';
import { mgcIconVscodeCuteRe } from './mgcIcon-vscode_cute_re.icon';
import { mgcIconVueCuteRe } from './mgcIcon-vue_cute_re.icon';
import { mgcIconWechatCuteRe } from './mgcIcon-wechat_cute_re.icon';
import { mgcIconWechatMiniprogramCuteRe } from './mgcIcon-wechat_miniprogram_cute_re.icon';
import { mgcIconWechatPayCuteRe } from './mgcIcon-wechat_pay_cute_re.icon';
import { mgcIconWeiboCuteRe } from './mgcIcon-weibo_cute_re.icon';
import { mgcIconWhatsappCuteRe } from './mgcIcon-whatsapp_cute_re.icon';
import { mgcIconWindowsCuteRe } from './mgcIcon-windows_cute_re.icon';
import { mgcIconXboxCuteRe } from './mgcIcon-xbox_cute_re.icon';
import { mgcIconYoutubeCuteRe } from './mgcIcon-youtube_cute_re.icon';
import { mgcIconAiming2CuteRe } from './mgcIcon-aiming_2_cute_re.icon';
import { mgcIconAimingCuteRe } from './mgcIcon-aiming_cute_re.icon';
import { mgcIconAnchorCuteRe } from './mgcIcon-anchor_cute_re.icon';
import { mgcIconBed2CuteRe } from './mgcIcon-bed_2_cute_re.icon';
import { mgcIconBedCuteRe } from './mgcIcon-bed_cute_re.icon';
import { mgcIconClock2CuteRe } from './mgcIcon-clock_2_cute_re.icon';
import { mgcIconClockCuteRe } from './mgcIcon-clock_cute_re.icon';
import { mgcIconCompass3CuteRe } from './mgcIcon-compass_3_cute_re.icon';
import { mgcIconCompassCuteRe } from './mgcIcon-compass_cute_re.icon';
import { mgcIconDirections2CuteRe } from './mgcIcon-directions_2_cute_re.icon';
import { mgcIconDirectionsCuteRe } from './mgcIcon-directions_cute_re.icon';
import { mgcIconEarth2CuteRe } from './mgcIcon-earth_2_cute_re.icon';
import { mgcIconEarth3CuteRe } from './mgcIcon-earth_3_cute_re.icon';
import { mgcIconEarthCuteRe } from './mgcIcon-earth_cute_re.icon';
import { mgcIconEarthLatitudeCuteRe } from './mgcIcon-earth_latitude_cute_re.icon';
import { mgcIconEarthLongitudeCuteRe } from './mgcIcon-earth_longitude_cute_re.icon';
import { mgcIconFootCuteRe } from './mgcIcon-foot_cute_re.icon';
import { mgcIconGlobe2CuteRe } from './mgcIcon-globe_2_cute_re.icon';
import { mgcIconHoursCuteRe } from './mgcIcon-hours_cute_re.icon';
import { mgcIconLifebuoyCuteRe } from './mgcIcon-lifebuoy_cute_re.icon';
import { mgcIconLiveLocationCuteRe } from './mgcIcon-live_location_cute_re.icon';
import { mgcIconLocation2CuteRe } from './mgcIcon-location_2_cute_re.icon';
import { mgcIconLocation3CuteRe } from './mgcIcon-location_3_cute_re.icon';
import { mgcIconLocationCuteRe } from './mgcIcon-location_cute_re.icon';
import { mgcIconMap2CuteRe } from './mgcIcon-map_2_cute_re.icon';
import { mgcIconMapCuteRe } from './mgcIcon-map_cute_re.icon';
import { mgcIconMapPinCuteRe } from './mgcIcon-map_pin_cute_re.icon';
import { mgcIconNavigationCuteRe } from './mgcIcon-navigation_cute_re.icon';
import { mgcIconParkingCuteRe } from './mgcIcon-parking_cute_re.icon';
import { mgcIconPlanetCuteRe } from './mgcIcon-planet_cute_re.icon';
import { mgcIconRestAreaCuteRe } from './mgcIcon-rest_area_cute_re.icon';
import { mgcIconRoadCuteRe } from './mgcIcon-road_cute_re.icon';
import { mgcIconRouteCuteRe } from './mgcIcon-route_cute_re.icon';
import { mgcIconTrafficConeCuteRe } from './mgcIcon-traffic_cone_cute_re.icon';
import { mgcIconTunnelCuteRe } from './mgcIcon-tunnel_cute_re.icon';
import { mgcIconUmbrella2CuteRe } from './mgcIcon-umbrella_2_cute_re.icon';
import { mgcIconWorld2CuteRe } from './mgcIcon-world_2_cute_re.icon';
import { mgcIconWorldCuteRe } from './mgcIcon-world_cute_re.icon';
import { mgcIconAirpodsCuteRe } from './mgcIcon-airpods_cute_re.icon';
import { mgcIconAlbumCuteRe } from './mgcIcon-album_cute_re.icon';
import { mgcIconAnnouncementCuteRe } from './mgcIcon-announcement_cute_re.icon';
import { mgcIconAudioTapeCuteRe } from './mgcIcon-audio_tape_cute_re.icon';
import { mgcIconBellRingingCuteRe } from './mgcIcon-bell_ringing_cute_re.icon';
import { mgcIconCamcorder3CuteRe } from './mgcIcon-camcorder_3_cute_re.icon';
import { mgcIconCamcorderCuteRe } from './mgcIcon-camcorder_cute_re.icon';
import { mgcIconCamcorderOffCuteRe } from './mgcIcon-camcorder_off_cute_re.icon';
import { mgcIconCamera2AiCuteRe } from './mgcIcon-camera_2_ai_cute_re.icon';
import { mgcIconCamera2CuteRe } from './mgcIcon-camera_2_cute_re.icon';
import { mgcIconCamera2OffCuteRe } from './mgcIcon-camera_2_off_cute_re.icon';
import { mgcIconCameraCuteRe } from './mgcIcon-camera_cute_re.icon';
import { mgcIconCameraRotateCuteRe } from './mgcIcon-camera_rotate_cute_re.icon';
import { mgcIconClapperboardCuteRe } from './mgcIcon-clapperboard_cute_re.icon';
import { mgcIconDanmakuCuteRe } from './mgcIcon-danmaku_cute_re.icon';
import { mgcIconDanmakuOffCuteRe } from './mgcIcon-danmaku_off_cute_re.icon';
import { mgcIconDanmakuOnCuteRe } from './mgcIcon-danmaku_on_cute_re.icon';
import { mgcIconDiscCuteRe } from './mgcIcon-disc_cute_re.icon';
import { mgcIconExpandPlayerCuteRe } from './mgcIcon-expand_player_cute_re.icon';
import { mgcIconFastForwardCuteRe } from './mgcIcon-fast_forward_cute_re.icon';
import { mgcIconFastRewindCuteRe } from './mgcIcon-fast_rewind_cute_re.icon';
import { mgcIconFilmCuteRe } from './mgcIcon-film_cute_re.icon';
import { mgcIconFullscreenCuteRe } from './mgcIcon-fullscreen_cute_re.icon';
import { mgcIconFullscreenExitCuteRe } from './mgcIcon-fullscreen_exit_cute_re.icon';
import { mgcIconHeadphone2CuteRe } from './mgcIcon-headphone_2_cute_re.icon';
import { mgcIconHeadphoneCuteRe } from './mgcIcon-headphone_cute_re.icon';
import { mgcIconHorn2CuteRe } from './mgcIcon-horn_2_cute_re.icon';
import { mgcIconHornCuteRe } from './mgcIcon-horn_cute_re.icon';
import { mgcIconLiveCuteRe } from './mgcIcon-live_cute_re.icon';
import { mgcIconLivePhotoCuteRe } from './mgcIcon-live_photo_cute_re.icon';
import { mgcIconMic2CuteRe } from './mgcIcon-mic_2_cute_re.icon';
import { mgcIconMicAiCuteRe } from './mgcIcon-mic_ai_cute_re.icon';
import { mgcIconMicCuteRe } from './mgcIcon-mic_cute_re.icon';
import { mgcIconMicOffCuteRe } from './mgcIcon-mic_off_cute_re.icon';
import { mgcIconMicrophoneCuteRe } from './mgcIcon-microphone_cute_re.icon';
import { mgcIconMiniplayerCuteRe } from './mgcIcon-miniplayer_cute_re.icon';
import { mgcIconMovieCuteRe } from './mgcIcon-movie_cute_re.icon';
import { mgcIconMusic2AiCuteRe } from './mgcIcon-music_2_ai_cute_re.icon';
import { mgcIconMusic2CuteRe } from './mgcIcon-music_2_cute_re.icon';
import { mgcIconMusic3CuteRe } from './mgcIcon-music_3_cute_re.icon';
import { mgcIconMusicCuteRe } from './mgcIcon-music_cute_re.icon';
import { mgcIconNotificationCuteRe } from './mgcIcon-notification_cute_re.icon';
import { mgcIconNotificationNewdotCuteRe } from './mgcIcon-notification_newdot_cute_re.icon';
import { mgcIconNotificationOffCuteRe } from './mgcIcon-notification_off_cute_re.icon';
import { mgcIconPauseCircleCuteRe } from './mgcIcon-pause_circle_cute_re.icon';
import { mgcIconPauseCuteRe } from './mgcIcon-pause_cute_re.icon';
import { mgcIconPlayCircleCuteRe } from './mgcIcon-play_circle_cute_re.icon';
import { mgcIconPlayCuteRe } from './mgcIcon-play_cute_re.icon';
import { mgcIconPlaylist2CuteRe } from './mgcIcon-playlist_2_cute_re.icon';
import { mgcIconPlaylistCuteRe } from './mgcIcon-playlist_cute_re.icon';
import { mgcIconRecordMailCuteRe } from './mgcIcon-record_mail_cute_re.icon';
import { mgcIconRepeatCuteRe } from './mgcIcon-repeat_cute_re.icon';
import { mgcIconRepeatOneCuteRe } from './mgcIcon-repeat_one_cute_re.icon';
import { mgcIconRewindBackward10CuteRe } from './mgcIcon-rewind_backward_10_cute_re.icon';
import { mgcIconRewindBackward15CuteRe } from './mgcIcon-rewind_backward_15_cute_re.icon';
import { mgcIconRewindBackward30CuteRe } from './mgcIcon-rewind_backward_30_cute_re.icon';
import { mgcIconRewindBackward5CuteRe } from './mgcIcon-rewind_backward_5_cute_re.icon';
import { mgcIconRewindBackwardSquare10CuteRe } from './mgcIcon-rewind_backward_square_10_cute_re.icon';
import { mgcIconRewindBackwardSquare15CuteRe } from './mgcIcon-rewind_backward_square_15_cute_re.icon';
import { mgcIconRewindBackwardSquare30CuteRe } from './mgcIcon-rewind_backward_square_30_cute_re.icon';
import { mgcIconRewindBackwardSquare5CuteRe } from './mgcIcon-rewind_backward_square_5_cute_re.icon';
import { mgcIconRewindForward10CuteRe } from './mgcIcon-rewind_forward_10_cute_re.icon';
import { mgcIconRewindForward15CuteRe } from './mgcIcon-rewind_forward_15_cute_re.icon';
import { mgcIconRewindForward30CuteRe } from './mgcIcon-rewind_forward_30_cute_re.icon';
import { mgcIconRewindForward5CuteRe } from './mgcIcon-rewind_forward_5_cute_re.icon';
import { mgcIconRewindForwardSquare10CuteRe } from './mgcIcon-rewind_forward_square_10_cute_re.icon';
import { mgcIconRewindForwardSquare15CuteRe } from './mgcIcon-rewind_forward_square_15_cute_re.icon';
import { mgcIconRewindForwardSquare30CuteRe } from './mgcIcon-rewind_forward_square_30_cute_re.icon';
import { mgcIconRewindForwardSquare5CuteRe } from './mgcIcon-rewind_forward_square_5_cute_re.icon';
import { mgcIconRotateToHorizontalCuteRe } from './mgcIcon-rotate_to_horizontal_cute_re.icon';
import { mgcIconRotateToVerticalCuteRe } from './mgcIcon-rotate_to_vertical_cute_re.icon';
import { mgcIconServiceCuteRe } from './mgcIcon-service_cute_re.icon';
import { mgcIconShuffle2CuteRe } from './mgcIcon-shuffle_2_cute_re.icon';
import { mgcIconShuffleCuteRe } from './mgcIcon-shuffle_cute_re.icon';
import { mgcIconSkipForwardCuteRe } from './mgcIcon-skip_forward_cute_re.icon';
import { mgcIconSkipPreviousCuteRe } from './mgcIcon-skip_previous_cute_re.icon';
import { mgcIconSoundLineCuteRe } from './mgcIcon-sound_line_cute_re.icon';
import { mgcIconStopCircleCuteRe } from './mgcIcon-stop_circle_cute_re.icon';
import { mgcIconStopCuteRe } from './mgcIcon-stop_cute_re.icon';
import { mgcIconVideoCamera2CuteRe } from './mgcIcon-video_camera_2_cute_re.icon';
import { mgcIconVideoCameraCuteRe } from './mgcIcon-video_camera_cute_re.icon';
import { mgcIconVideoCuteRe } from './mgcIcon-video_cute_re.icon';
import { mgcIconVoice2CuteRe } from './mgcIcon-voice_2_cute_re.icon';
import { mgcIconVoiceCuteRe } from './mgcIcon-voice_cute_re.icon';
import { mgcIconVolumeCuteRe } from './mgcIcon-volume_cute_re.icon';
import { mgcIconVolumeMuteCuteRe } from './mgcIcon-volume_mute_cute_re.icon';
import { mgcIconVolumeOffCuteRe } from './mgcIcon-volume_off_cute_re.icon';
import { mgcIconBearCuteRe } from './mgcIcon-bear_cute_re.icon';
import { mgcIconBirdCuteRe } from './mgcIcon-bird_cute_re.icon';
import { mgcIconButterfly2CuteRe } from './mgcIcon-butterfly_2_cute_re.icon';
import { mgcIconButterflyCuteRe } from './mgcIcon-butterfly_cute_re.icon';
import { mgcIconCactus2CuteRe } from './mgcIcon-cactus_2_cute_re.icon';
import { mgcIconCactusCuteRe } from './mgcIcon-cactus_cute_re.icon';
import { mgcIconCampfireCuteRe } from './mgcIcon-campfire_cute_re.icon';
import { mgcIconCatCuteRe } from './mgcIcon-cat_cute_re.icon';
import { mgcIconChessCuteRe } from './mgcIcon-chess_cute_re.icon';
import { mgcIconDandelionCuteRe } from './mgcIcon-dandelion_cute_re.icon';
import { mgcIconDogCuteRe } from './mgcIcon-dog_cute_re.icon';
import { mgcIconDragonflyCuteRe } from './mgcIcon-dragonfly_cute_re.icon';
import { mgcIconFlower2CuteRe } from './mgcIcon-flower_2_cute_re.icon';
import { mgcIconFlower3CuteRe } from './mgcIcon-flower_3_cute_re.icon';
import { mgcIconFlower4CuteRe } from './mgcIcon-flower_4_cute_re.icon';
import { mgcIconFlower5CuteRe } from './mgcIcon-flower_5_cute_re.icon';
import { mgcIconFlowerCuteRe } from './mgcIcon-flower_cute_re.icon';
import { mgcIconFlowerpotCuteRe } from './mgcIcon-flowerpot_cute_re.icon';
import { mgcIconGrassCuteRe } from './mgcIcon-grass_cute_re.icon';
import { mgcIconLeaf2CuteRe } from './mgcIcon-leaf_2_cute_re.icon';
import { mgcIconLeaf3CuteRe } from './mgcIcon-leaf_3_cute_re.icon';
import { mgcIconLeafCuteRe } from './mgcIcon-leaf_cute_re.icon';
import { mgcIconLotusCuteRe } from './mgcIcon-lotus_cute_re.icon';
import { mgcIconMapleLeafCuteRe } from './mgcIcon-maple_leaf_cute_re.icon';
import { mgcIconMickeymouseCuteRe } from './mgcIcon-mickeymouse_cute_re.icon';
import { mgcIconMountain2CuteRe } from './mgcIcon-mountain_2_cute_re.icon';
import { mgcIconMountainCuteRe } from './mgcIcon-mountain_cute_re.icon';
import { mgcIconMushroomCuteRe } from './mgcIcon-mushroom_cute_re.icon';
import { mgcIconPawCuteRe } from './mgcIcon-paw_cute_re.icon';
import { mgcIconPigCuteRe } from './mgcIcon-pig_cute_re.icon';
import { mgcIconPumpkinCuteRe } from './mgcIcon-pumpkin_cute_re.icon';
import { mgcIconRabbitCuteRe } from './mgcIcon-rabbit_cute_re.icon';
import { mgcIconSunflowerCuteRe } from './mgcIcon-sunflower_cute_re.icon';
import { mgcIconToyHorseCuteRe } from './mgcIcon-toy_horse_cute_re.icon';
import { mgcIconTree2CuteRe } from './mgcIcon-tree_2_cute_re.icon';
import { mgcIconTree3CuteRe } from './mgcIcon-tree_3_cute_re.icon';
import { mgcIconTree4CuteRe } from './mgcIcon-tree_4_cute_re.icon';
import { mgcIconTreeCuteRe } from './mgcIcon-tree_cute_re.icon';
import { mgcIconWreathCuteRe } from './mgcIcon-wreath_cute_re.icon';
import { mgcIconAxeCuteRe } from './mgcIcon-axe_cute_re.icon';
import { mgcIconBalloon2CuteRe } from './mgcIcon-balloon_2_cute_re.icon';
import { mgcIconBathCuteRe } from './mgcIcon-bath_cute_re.icon';
import { mgcIconBedsideTable2CuteRe } from './mgcIcon-bedside_table_2_cute_re.icon';
import { mgcIconBedsideTableCuteRe } from './mgcIcon-bedside_table_cute_re.icon';
import { mgcIconBlessingCuteRe } from './mgcIcon-blessing_cute_re.icon';
import { mgcIconBombCuteRe } from './mgcIcon-bomb_cute_re.icon';
import { mgcIconBoomCuteRe } from './mgcIcon-boom_cute_re.icon';
import { mgcIconBottleCuteRe } from './mgcIcon-bottle_cute_re.icon';
import { mgcIconCapsuleCuteRe } from './mgcIcon-capsule_cute_re.icon';
import { mgcIconCoathangerCuteRe } from './mgcIcon-coathanger_cute_re.icon';
import { mgcIconCross2CuteRe } from './mgcIcon-cross_2_cute_re.icon';
import { mgcIconCrystalBallCuteRe } from './mgcIcon-crystal_ball_cute_re.icon';
import { mgcIconCurtainCuteRe } from './mgcIcon-curtain_cute_re.icon';
import { mgcIconDrawer2CuteRe } from './mgcIcon-drawer_2_cute_re.icon';
import { mgcIconDrawerCuteRe } from './mgcIcon-drawer_cute_re.icon';
import { mgcIconFaceMaskCuteRe } from './mgcIcon-face_mask_cute_re.icon';
import { mgcIconFirecrackerCuteRe } from './mgcIcon-firecracker_cute_re.icon';
import { mgcIconFireworkCuteRe } from './mgcIcon-firework_cute_re.icon';
import { mgcIconFirstAidKitCuteRe } from './mgcIcon-first_aid_kit_cute_re.icon';
import { mgcIconHammerCuteRe } from './mgcIcon-hammer_cute_re.icon';
import { mgcIconHandCardCuteRe } from './mgcIcon-hand_card_cute_re.icon';
import { mgcIconHandHeartCuteRe } from './mgcIcon-hand_heart_cute_re.icon';
import { mgcIconHoeCuteRe } from './mgcIcon-hoe_cute_re.icon';
import { mgcIconInjectionCuteRe } from './mgcIcon-injection_cute_re.icon';
import { mgcIconKiteCuteRe } from './mgcIcon-kite_cute_re.icon';
import { mgcIconLipstickCuteRe } from './mgcIcon-lipstick_cute_re.icon';
import { mgcIconNurseCuteRe } from './mgcIcon-nurse_cute_re.icon';
import { mgcIconParfumCuteRe } from './mgcIcon-parfum_cute_re.icon';
import { mgcIconPickaxCuteRe } from './mgcIcon-pickax_cute_re.icon';
import { mgcIconPotCuteRe } from './mgcIcon-pot_cute_re.icon';
import { mgcIconPrescriptionCuteRe } from './mgcIcon-prescription_cute_re.icon';
import { mgcIconRakeCuteRe } from './mgcIcon-rake_cute_re.icon';
import { mgcIconRandomCuteRe } from './mgcIcon-random_cute_re.icon';
import { mgcIconScrewdriverCuteRe } from './mgcIcon-screwdriver_cute_re.icon';
import { mgcIconShovelCuteRe } from './mgcIcon-shovel_cute_re.icon';
import { mgcIconShowerGelCuteRe } from './mgcIcon-shower_gel_cute_re.icon';
import { mgcIconStar2CuteRe } from './mgcIcon-star_2_cute_re.icon';
import { mgcIconStarTopperCuteRe } from './mgcIcon-star_topper_cute_re.icon';
import { mgcIconStethoscopeCuteRe } from './mgcIcon-stethoscope_cute_re.icon';
import { mgcIconThoughtCuteRe } from './mgcIcon-thought_cute_re.icon';
import { mgcIconToiletPaperCuteRe } from './mgcIcon-toilet_paper_cute_re.icon';
import { mgcIconVirusCuteRe } from './mgcIcon-virus_cute_re.icon';
import { mgcIconWardrobe2CuteRe } from './mgcIcon-wardrobe_2_cute_re.icon';
import { mgcIconWardrobeCuteRe } from './mgcIcon-wardrobe_cute_re.icon';
import { mgcIconWateringCanCuteRe } from './mgcIcon-watering_can_cute_re.icon';
import { mgcIconYinyangCuteRe } from './mgcIcon-yinyang_cute_re.icon';
import { mgcIconBabyCuteRe } from './mgcIcon-baby_cute_re.icon';
import { mgcIconBeardCuteRe } from './mgcIcon-beard_cute_re.icon';
import { mgcIconBodyCuteRe } from './mgcIcon-body_cute_re.icon';
import { mgcIconBowTieCuteRe } from './mgcIcon-bow_tie_cute_re.icon';
import { mgcIconBowknotCuteRe } from './mgcIcon-bowknot_cute_re.icon';
import { mgcIconBrainCuteRe } from './mgcIcon-brain_cute_re.icon';
import { mgcIconBriefCuteRe } from './mgcIcon-brief_cute_re.icon';
import { mgcIconChefHatCuteRe } from './mgcIcon-chef_hat_cute_re.icon';
import { mgcIconChristmasHatCuteRe } from './mgcIcon-christmas_hat_cute_re.icon';
import { mgcIconCoatCuteRe } from './mgcIcon-coat_cute_re.icon';
import { mgcIconDeerCuteRe } from './mgcIcon-deer_cute_re.icon';
import { mgcIconDentalCuteRe } from './mgcIcon-dental_cute_re.icon';
import { mgcIconDressCuteRe } from './mgcIcon-dress_cute_re.icon';
import { mgcIconEarCuteRe } from './mgcIcon-ear_cute_re.icon';
import { mgcIconEye2CuteRe } from './mgcIcon-eye_2_cute_re.icon';
import { mgcIconEyebrowCuteRe } from './mgcIcon-eyebrow_cute_re.icon';
import { mgcIconFaceCuteRe } from './mgcIcon-face_cute_re.icon';
import { mgcIconFatherChristmasCuteRe } from './mgcIcon-father_christmas_cute_re.icon';
import { mgcIconFingerPressCuteRe } from './mgcIcon-finger_press_cute_re.icon';
import { mgcIconFingerRockCuteRe } from './mgcIcon-finger_rock_cute_re.icon';
import { mgcIconFingerSwipeCuteRe } from './mgcIcon-finger_swipe_cute_re.icon';
import { mgcIconFingerTapCuteRe } from './mgcIcon-finger_tap_cute_re.icon';
import { mgcIconGloveCuteRe } from './mgcIcon-glove_cute_re.icon';
import { mgcIconHair2CuteRe } from './mgcIcon-hair_2_cute_re.icon';
import { mgcIconHairCuteRe } from './mgcIcon-hair_cute_re.icon';
import { mgcIconHandCuteRe } from './mgcIcon-hand_cute_re.icon';
import { mgcIconHandFinger2CuteRe } from './mgcIcon-hand_finger_2_cute_re.icon';
import { mgcIconHandFingerCuteRe } from './mgcIcon-hand_finger_cute_re.icon';
import { mgcIconHandGrabCuteRe } from './mgcIcon-hand_grab_cute_re.icon';
import { mgcIconHandTwoFingersCuteRe } from './mgcIcon-hand_two_fingers_cute_re.icon';
import { mgcIconHandsClappingCuteRe } from './mgcIcon-hands_clapping_cute_re.icon';
import { mgcIconHat2CuteRe } from './mgcIcon-hat_2_cute_re.icon';
import { mgcIconHatCuteRe } from './mgcIcon-hat_cute_re.icon';
import { mgcIconHeadCuteRe } from './mgcIcon-head_cute_re.icon';
import { mgcIconHeartHandCuteRe } from './mgcIcon-heart_hand_cute_re.icon';
import { mgcIconHeartbeat2CuteRe } from './mgcIcon-heartbeat_2_cute_re.icon';
import { mgcIconIncognitoModeCuteRe } from './mgcIcon-incognito_mode_cute_re.icon';
import { mgcIconLoveCuteRe } from './mgcIcon-love_cute_re.icon';
import { mgcIconLungsCuteRe } from './mgcIcon-lungs_cute_re.icon';
import { mgcIconMiddleFingerCuteRe } from './mgcIcon-middle_finger_cute_re.icon';
import { mgcIconMouthCuteRe } from './mgcIcon-mouth_cute_re.icon';
import { mgcIconNecktieCuteRe } from './mgcIcon-necktie_cute_re.icon';
import { mgcIconNoseCuteRe } from './mgcIcon-nose_cute_re.icon';
import { mgcIconPrayCuteRe } from './mgcIcon-pray_cute_re.icon';
import { mgcIconScarfCuteRe } from './mgcIcon-scarf_cute_re.icon';
import { mgcIconShirtCuteRe } from './mgcIcon-shirt_cute_re.icon';
import { mgcIconShoe2CuteRe } from './mgcIcon-shoe_2_cute_re.icon';
import { mgcIconShoeCuteRe } from './mgcIcon-shoe_cute_re.icon';
import { mgcIconShortsCuteRe } from './mgcIcon-shorts_cute_re.icon';
import { mgcIconSkirtCuteRe } from './mgcIcon-skirt_cute_re.icon';
import { mgcIconSkullCuteRe } from './mgcIcon-skull_cute_re.icon';
import { mgcIconSockCuteRe } from './mgcIcon-sock_cute_re.icon';
import { mgcIconTShirt2CuteRe } from './mgcIcon-t_shirt_2_cute_re.icon';
import { mgcIconTrouserCuteRe } from './mgcIcon-trouser_cute_re.icon';
import { mgcIconVestCuteRe } from './mgcIcon-vest_cute_re.icon';
import { mgcIconClubsCuteRe } from './mgcIcon-clubs_cute_re.icon';
import { mgcIconCylinder2CuteRe } from './mgcIcon-cylinder_2_cute_re.icon';
import { mgcIconCylinderCuteRe } from './mgcIcon-cylinder_cute_re.icon';
import { mgcIconDiamondCuteRe } from './mgcIcon-diamond_cute_re.icon';
import { mgcIconDiamondSquareCuteRe } from './mgcIcon-diamond_square_cute_re.icon';
import { mgcIconHeartCrackCuteRe } from './mgcIcon-heart_crack_cute_re.icon';
import { mgcIconHeartCuteRe } from './mgcIcon-heart_cute_re.icon';
import { mgcIconHeartHalfCuteRe } from './mgcIcon-heart_half_cute_re.icon';
import { mgcIconHemisphere2CuteRe } from './mgcIcon-hemisphere_2_cute_re.icon';
import { mgcIconHemisphereCuteRe } from './mgcIcon-hemisphere_cute_re.icon';
import { mgcIconHexagonCuteRe } from './mgcIcon-hexagon_cute_re.icon';
import { mgcIconLineCuteRe } from './mgcIcon-line_cute_re.icon';
import { mgcIconOctagonCuteRe } from './mgcIcon-octagon_cute_re.icon';
import { mgcIconPentagonCuteRe } from './mgcIcon-pentagon_cute_re.icon';
import { mgcIconRectangleCuteRe } from './mgcIcon-rectangle_cute_re.icon';
import { mgcIconRectangleVerticalCuteRe } from './mgcIcon-rectangle_vertical_cute_re.icon';
import { mgcIconRoundCuteRe } from './mgcIcon-round_cute_re.icon';
import { mgcIconSectorCuteRe } from './mgcIcon-sector_cute_re.icon';
import { mgcIconShieldShapeCuteRe } from './mgcIcon-shield_shape_cute_re.icon';
import { mgcIconSpadeCuteRe } from './mgcIcon-spade_cute_re.icon';
import { mgcIconSquareCuteRe } from './mgcIcon-square_cute_re.icon';
import { mgcIconStarCuteRe } from './mgcIcon-star_cute_re.icon';
import { mgcIconStarHalfCuteRe } from './mgcIcon-star_half_cute_re.icon';
import { mgcIconTriangleCuteRe } from './mgcIcon-triangle_cute_re.icon';
import { mgcIconAirBalloonCuteRe } from './mgcIcon-air_balloon_cute_re.icon';
import { mgcIconAmericanFootballCuteRe } from './mgcIcon-american_football_cute_re.icon';
import { mgcIconBackboardCuteRe } from './mgcIcon-backboard_cute_re.icon';
import { mgcIconBadmintonCuteRe } from './mgcIcon-badminton_cute_re.icon';
import { mgcIconBarbellCuteRe } from './mgcIcon-barbell_cute_re.icon';
import { mgcIconBaseball2CuteRe } from './mgcIcon-baseball_2_cute_re.icon';
import { mgcIconBaseballCuteRe } from './mgcIcon-baseball_cute_re.icon';
import { mgcIconBasketballCuteRe } from './mgcIcon-basketball_cute_re.icon';
import { mgcIconBeachballCuteRe } from './mgcIcon-beachball_cute_re.icon';
import { mgcIconDisabled2CuteRe } from './mgcIcon-disabled_2_cute_re.icon';
import { mgcIconDisabledCuteRe } from './mgcIcon-disabled_cute_re.icon';
import { mgcIconFitnessCuteRe } from './mgcIcon-fitness_cute_re.icon';
import { mgcIconFootballCuteRe } from './mgcIcon-football_cute_re.icon';
import { mgcIconParachuteCuteRe } from './mgcIcon-parachute_cute_re.icon';
import { mgcIconPingpongCuteRe } from './mgcIcon-pingpong_cute_re.icon';
import { mgcIconPlaygroundCuteRe } from './mgcIcon-playground_cute_re.icon';
import { mgcIconRidingCuteRe } from './mgcIcon-riding_cute_re.icon';
import { mgcIconRunCuteRe } from './mgcIcon-run_cute_re.icon';
import { mgcIconSkateboardCuteRe } from './mgcIcon-skateboard_cute_re.icon';
import { mgcIconSurfboardCuteRe } from './mgcIcon-surfboard_cute_re.icon';
import { mgcIconSwimmingPoolCuteRe } from './mgcIcon-swimming_pool_cute_re.icon';
import { mgcIconSwordCuteRe } from './mgcIcon-sword_cute_re.icon';
import { mgcIconToxophilyCuteRe } from './mgcIcon-toxophily_cute_re.icon';
import { mgcIconVolleyballCuteRe } from './mgcIcon-volleyball_cute_re.icon';
import { mgcIconWalkCuteRe } from './mgcIcon-walk_cute_re.icon';
import { mgcIconWheelchairCuteRe } from './mgcIcon-wheelchair_cute_re.icon';
import { mgcIconWhistleCuteRe } from './mgcIcon-whistle_cute_re.icon';
import { mgcIconAddCircleCuteRe } from './mgcIcon-add_circle_cute_re.icon';
import { mgcIconAddCuteRe } from './mgcIcon-add_cute_re.icon';
import { mgcIconAddSquareCuteRe } from './mgcIcon-add_square_cute_re.icon';
import { mgcIconAlertCuteRe } from './mgcIcon-alert_cute_re.icon';
import { mgcIconAlertDiamondCuteRe } from './mgcIcon-alert_diamond_cute_re.icon';
import { mgcIconAlertOctagonCuteRe } from './mgcIcon-alert_octagon_cute_re.icon';
import { mgcIconBroomCuteRe } from './mgcIcon-broom_cute_re.icon';
import { mgcIconBrush3CuteRe } from './mgcIcon-brush_3_cute_re.icon';
import { mgcIconBrushCuteRe } from './mgcIcon-brush_cute_re.icon';
import { mgcIconBubbleCuteRe } from './mgcIcon-bubble_cute_re.icon';
import { mgcIconCertificateCuteRe } from './mgcIcon-certificate_cute_re.icon';
import { mgcIconCheck2CuteRe } from './mgcIcon-check_2_cute_re.icon';
import { mgcIconCheckCircleCuteRe } from './mgcIcon-check_circle_cute_re.icon';
import { mgcIconCheckCuteRe } from './mgcIcon-check_cute_re.icon';
import { mgcIconCheckboxCuteRe } from './mgcIcon-checkbox_cute_re.icon';
import { mgcIconChecksCuteRe } from './mgcIcon-checks_cute_re.icon';
import { mgcIconChoiceCuteRe } from './mgcIcon-choice_cute_re.icon';
import { mgcIconClassify2CuteRe } from './mgcIcon-classify_2_cute_re.icon';
import { mgcIconClassify3CuteRe } from './mgcIcon-classify_3_cute_re.icon';
import { mgcIconClassifyAdd2CuteRe } from './mgcIcon-classify_add_2_cute_re.icon';
import { mgcIconClassifyAddCuteRe } from './mgcIcon-classify_add_cute_re.icon';
import { mgcIconClassifyCuteRe } from './mgcIcon-classify_cute_re.icon';
import { mgcIconCloseCircleCuteRe } from './mgcIcon-close_circle_cute_re.icon';
import { mgcIconCloseCuteRe } from './mgcIcon-close_cute_re.icon';
import { mgcIconCloseSquareCuteRe } from './mgcIcon-close_square_cute_re.icon';
import { mgcIconCrossCuteRe } from './mgcIcon-cross_cute_re.icon';
import { mgcIconCrutchCuteRe } from './mgcIcon-crutch_cute_re.icon';
import { mgcIconCubeCuteRe } from './mgcIcon-cube_cute_re.icon';
import { mgcIconDelete2CuteRe } from './mgcIcon-delete_2_cute_re.icon';
import { mgcIconDelete3CuteRe } from './mgcIcon-delete_3_cute_re.icon';
import { mgcIconDeleteBackCuteRe } from './mgcIcon-delete_back_cute_re.icon';
import { mgcIconDeleteCuteRe } from './mgcIcon-delete_cute_re.icon';
import { mgcIconDirectionDotCuteRe } from './mgcIcon-direction_dot_cute_re.icon';
import { mgcIconDoorCuteRe } from './mgcIcon-door_cute_re.icon';
import { mgcIconDotGridCuteRe } from './mgcIcon-dot_grid_cute_re.icon';
import { mgcIconDotsCuteRe } from './mgcIcon-dots_cute_re.icon';
import { mgcIconDotsVerticalCuteRe } from './mgcIcon-dots_vertical_cute_re.icon';
import { mgcIconEnterDoorCuteRe } from './mgcIcon-enter_door_cute_re.icon';
import { mgcIconEntranceCuteRe } from './mgcIcon-entrance_cute_re.icon';
import { mgcIconExitCuteRe } from './mgcIcon-exit_cute_re.icon';
import { mgcIconExitDoorCuteRe } from './mgcIcon-exit_door_cute_re.icon';
import { mgcIconEyeCloseCuteRe } from './mgcIcon-eye_close_cute_re.icon';
import { mgcIconEyeCuteRe } from './mgcIcon-eye_cute_re.icon';
import { mgcIconFaceidCuteRe } from './mgcIcon-faceid_cute_re.icon';
import { mgcIconFaultCuteRe } from './mgcIcon-fault_cute_re.icon';
import { mgcIconFilter2CuteRe } from './mgcIcon-filter_2_cute_re.icon';
import { mgcIconFingerprint2CuteRe } from './mgcIcon-fingerprint_2_cute_re.icon';
import { mgcIconFingerprintCuteRe } from './mgcIcon-fingerprint_cute_re.icon';
import { mgcIconFireCuteRe } from './mgcIcon-fire_cute_re.icon';
import { mgcIconFlameCuteRe } from './mgcIcon-flame_cute_re.icon';
import { mgcIconForbidCircleCuteRe } from './mgcIcon-forbid_circle_cute_re.icon';
import { mgcIconGestureUnlockCuteRe } from './mgcIcon-gesture_unlock_cute_re.icon';
import { mgcIconGhostCuteRe } from './mgcIcon-ghost_cute_re.icon';
import { mgcIconGrid2CuteRe } from './mgcIcon-grid_2_cute_re.icon';
import { mgcIconGridCuteRe } from './mgcIcon-grid_cute_re.icon';
import { mgcIconHeartbeatCuteRe } from './mgcIcon-heartbeat_cute_re.icon';
import { mgcIconHexagons2CuteRe } from './mgcIcon-hexagons_2_cute_re.icon';
import { mgcIconHexagonsCuteRe } from './mgcIcon-hexagons_cute_re.icon';
import { mgcIconHistory2CuteRe } from './mgcIcon-history_2_cute_re.icon';
import { mgcIconHistoryAnticlockwiseCuteRe } from './mgcIcon-history_anticlockwise_cute_re.icon';
import { mgcIconHistoryCuteRe } from './mgcIcon-history_cute_re.icon';
import { mgcIconInformationCuteRe } from './mgcIcon-information_cute_re.icon';
import { mgcIconKey1CuteRe } from './mgcIcon-key_1_cute_re.icon';
import { mgcIconKey2CuteRe } from './mgcIcon-key_2_cute_re.icon';
import { mgcIconKeyholeCuteRe } from './mgcIcon-keyhole_cute_re.icon';
import { mgcIconLoading2CuteRe } from './mgcIcon-loading_2_cute_re.icon';
import { mgcIconLoading3CuteRe } from './mgcIcon-loading_3_cute_re.icon';
import { mgcIconLoading4CuteRe } from './mgcIcon-loading_4_cute_re.icon';
import { mgcIconLoadingCuteRe } from './mgcIcon-loading_cute_re.icon';
import { mgcIconLockCuteRe } from './mgcIcon-lock_cute_re.icon';
import { mgcIconMindMapCuteRe } from './mgcIcon-mind_map_cute_re.icon';
import { mgcIconMinimizeCuteRe } from './mgcIcon-minimize_cute_re.icon';
import { mgcIconMinusCircleCuteRe } from './mgcIcon-minus_circle_cute_re.icon';
import { mgcIconMinusSquareCuteRe } from './mgcIcon-minus_square_cute_re.icon';
import { mgcIconMore1CuteRe } from './mgcIcon-more_1_cute_re.icon';
import { mgcIconMore2CuteRe } from './mgcIcon-more_2_cute_re.icon';
import { mgcIconMore3CuteRe } from './mgcIcon-more_3_cute_re.icon';
import { mgcIconMore4CuteRe } from './mgcIcon-more_4_cute_re.icon';
import { mgcIconMultiselectCuteRe } from './mgcIcon-multiselect_cute_re.icon';
import { mgcIconNewdotCuteRe } from './mgcIcon-newdot_cute_re.icon';
import { mgcIconOpenDoorCuteRe } from './mgcIcon-open_door_cute_re.icon';
import { mgcIconPlusCuteRe } from './mgcIcon-plus_cute_re.icon';
import { mgcIconPolygonCuteRe } from './mgcIcon-polygon_cute_re.icon';
import { mgcIconPowerCuteRe } from './mgcIcon-power_cute_re.icon';
import { mgcIconProcessCuteRe } from './mgcIcon-process_cute_re.icon';
import { mgcIconQuestionCuteRe } from './mgcIcon-question_cute_re.icon';
import { mgcIconRadioboxCuteRe } from './mgcIcon-radiobox_cute_re.icon';
import { mgcIconRecycleCuteRe } from './mgcIcon-recycle_cute_re.icon';
import { mgcIconRefresh1CuteRe } from './mgcIcon-refresh_1_cute_re.icon';
import { mgcIconRefresh2CuteRe } from './mgcIcon-refresh_2_cute_re.icon';
import { mgcIconRefresh3CuteRe } from './mgcIcon-refresh_3_cute_re.icon';
import { mgcIconRefresh4AiCuteRe } from './mgcIcon-refresh_4_ai_cute_re.icon';
import { mgcIconRefresh4CuteRe } from './mgcIcon-refresh_4_cute_re.icon';
import { mgcIconRefreshAnticlockwise1CuteRe } from './mgcIcon-refresh_anticlockwise_1_cute_re.icon';
import { mgcIconReportCuteRe } from './mgcIcon-report_cute_re.icon';
import { mgcIconRestoreCuteRe } from './mgcIcon-restore_cute_re.icon';
import { mgcIconSafeAlertCuteRe } from './mgcIcon-safe_alert_cute_re.icon';
import { mgcIconSafeFlashCuteRe } from './mgcIcon-safe_flash_cute_re.icon';
import { mgcIconSafeLockCuteRe } from './mgcIcon-safe_lock_cute_re.icon';
import { mgcIconSafeShield2CuteRe } from './mgcIcon-safe_shield_2_cute_re.icon';
import { mgcIconSafeShieldCuteRe } from './mgcIcon-safe_shield_cute_re.icon';
import { mgcIconSafetyCertificateCuteRe } from './mgcIcon-safety_certificate_cute_re.icon';
import { mgcIconSettings1CuteRe } from './mgcIcon-settings_1_cute_re.icon';
import { mgcIconSettings2CuteRe } from './mgcIcon-settings_2_cute_re.icon';
import { mgcIconSettings3CuteRe } from './mgcIcon-settings_3_cute_re.icon';
import { mgcIconSettings4CuteRe } from './mgcIcon-settings_4_cute_re.icon';
import { mgcIconSettings5CuteRe } from './mgcIcon-settings_5_cute_re.icon';
import { mgcIconSettings6CuteRe } from './mgcIcon-settings_6_cute_re.icon';
import { mgcIconSettings7CuteRe } from './mgcIcon-settings_7_cute_re.icon';
import { mgcIconShare2CuteRe } from './mgcIcon-share_2_cute_re.icon';
import { mgcIconShare3CuteRe } from './mgcIcon-share_3_cute_re.icon';
import { mgcIconShareForwardCuteRe } from './mgcIcon-share_forward_cute_re.icon';
import { mgcIconShieldCuteRe } from './mgcIcon-shield_cute_re.icon';
import { mgcIconSleepCuteRe } from './mgcIcon-sleep_cute_re.icon';
import { mgcIconSwitchCuteRe } from './mgcIcon-switch_cute_re.icon';
import { mgcIconTShirtCuteRe } from './mgcIcon-t_shirt_cute_re.icon';
import { mgcIconThreeCirclesCuteRe } from './mgcIcon-three_circles_cute_re.icon';
import { mgcIconThumbDown2CuteRe } from './mgcIcon-thumb_down_2_cute_re.icon';
import { mgcIconThumbDownCuteRe } from './mgcIcon-thumb_down_cute_re.icon';
import { mgcIconThumbUp2CuteRe } from './mgcIcon-thumb_up_2_cute_re.icon';
import { mgcIconThumbUpCuteRe } from './mgcIcon-thumb_up_cute_re.icon';
import { mgcIconTimeCuteRe } from './mgcIcon-time_cute_re.icon';
import { mgcIconTimeDurationCuteRe } from './mgcIcon-time_duration_cute_re.icon';
import { mgcIconTimelineCuteRe } from './mgcIcon-timeline_cute_re.icon';
import { mgcIconToggleLeft2CuteRe } from './mgcIcon-toggle_left_2_cute_re.icon';
import { mgcIconToggleLeftCuteRe } from './mgcIcon-toggle_left_cute_re.icon';
import { mgcIconToggleRight2CuteRe } from './mgcIcon-toggle_right_2_cute_re.icon';
import { mgcIconToggleRightCuteRe } from './mgcIcon-toggle_right_cute_re.icon';
import { mgcIconToolCuteRe } from './mgcIcon-tool_cute_re.icon';
import { mgcIconTransformationCuteRe } from './mgcIcon-transformation_cute_re.icon';
import { mgcIconUnlockCuteRe } from './mgcIcon-unlock_cute_re.icon';
import { mgcIconVersionCuteRe } from './mgcIcon-version_cute_re.icon';
import { mgcIconWarningCuteRe } from './mgcIcon-warning_cute_re.icon';
import { mgcIconWastebasketCuteRe } from './mgcIcon-wastebasket_cute_re.icon';
import { mgcIconWebhookCuteRe } from './mgcIcon-webhook_cute_re.icon';
import { mgcIconAbsCuteRe } from './mgcIcon-ABS_cute_re.icon';
import { mgcIconAerialLiftCuteRe } from './mgcIcon-aerial_lift_cute_re.icon';
import { mgcIconAirplaneCuteRe } from './mgcIcon-airplane_cute_re.icon';
import { mgcIconAutoHoldCuteRe } from './mgcIcon-auto_hold_cute_re.icon';
import { mgcIconBabyCarriageCuteRe } from './mgcIcon-baby_carriage_cute_re.icon';
import { mgcIconBikeCuteRe } from './mgcIcon-bike_cute_re.icon';
import { mgcIconBrakeCuteRe } from './mgcIcon-brake_cute_re.icon';
import { mgcIconBus2CuteRe } from './mgcIcon-bus_2_cute_re.icon';
import { mgcIconBusCuteRe } from './mgcIcon-bus_cute_re.icon';
import { mgcIconCar2CuteRe } from './mgcIcon-car_2_cute_re.icon';
import { mgcIconCar3CuteRe } from './mgcIcon-car_3_cute_re.icon';
import { mgcIconCarCuteRe } from './mgcIcon-car_cute_re.icon';
import { mgcIconCarDoorCuteRe } from './mgcIcon-car_door_cute_re.icon';
import { mgcIconCarWindowCuteRe } from './mgcIcon-car_window_cute_re.icon';
import { mgcIconChargingPileCuteRe } from './mgcIcon-charging_pile_cute_re.icon';
import { mgcIconEbikeCuteRe } from './mgcIcon-ebike_cute_re.icon';
import { mgcIconEmergencyFlashersCuteRe } from './mgcIcon-emergency_flashers_cute_re.icon';
import { mgcIconEngineCuteRe } from './mgcIcon-engine_cute_re.icon';
import { mgcIconFan2CuteRe } from './mgcIcon-fan_2_cute_re.icon';
import { mgcIconFanCuteRe } from './mgcIcon-fan_cute_re.icon';
import { mgcIconFanDirectionDownCuteRe } from './mgcIcon-fan_direction_down_cute_re.icon';
import { mgcIconFanDirectionFrontCuteRe } from './mgcIcon-fan_direction_front_cute_re.icon';
import { mgcIconFanDirectionUpCuteRe } from './mgcIcon-fan_direction_up_cute_re.icon';
import { mgcIconFlightInflightCuteRe } from './mgcIcon-flight_inflight_cute_re.icon';
import { mgcIconFlightLandCuteRe } from './mgcIcon-flight_land_cute_re.icon';
import { mgcIconFlightTakeoffCuteRe } from './mgcIcon-flight_takeoff_cute_re.icon';
import { mgcIconFourWheelDriveCuteRe } from './mgcIcon-four_wheel_drive_cute_re.icon';
import { mgcIconFrontFogLightsCuteRe } from './mgcIcon-front_fog_lights_cute_re.icon';
import { mgcIconFrontWindshieldDefrosterCuteRe } from './mgcIcon-front_windshield_defroster_cute_re.icon';
import { mgcIconGasStationCuteRe } from './mgcIcon-gas_station_cute_re.icon';
import { mgcIconHightBeamHeadlightsCuteRe } from './mgcIcon-hight_beam_headlights_cute_re.icon';
import { mgcIconHoodCuteRe } from './mgcIcon-hood_cute_re.icon';
import { mgcIconJeepCuteRe } from './mgcIcon-jeep_cute_re.icon';
import { mgcIconLowBeamHeadlightsCuteRe } from './mgcIcon-low_beam_headlights_cute_re.icon';
import { mgcIconOilCuteRe } from './mgcIcon-oil_cute_re.icon';
import { mgcIconParkCuteRe } from './mgcIcon-park_cute_re.icon';
import { mgcIconParkingLightsCuteRe } from './mgcIcon-parking_lights_cute_re.icon';
import { mgcIconPinwheel2CuteRe } from './mgcIcon-pinwheel_2_cute_re.icon';
import { mgcIconPinwheelCuteRe } from './mgcIcon-pinwheel_cute_re.icon';
import { mgcIconRareFogLightsCuteRe } from './mgcIcon-rare_fog_lights_cute_re.icon';
import { mgcIconRearWindshieldDefrosterCuteRe } from './mgcIcon-rear_windshield_defroster_cute_re.icon';
import { mgcIconRocket2CuteRe } from './mgcIcon-rocket_2_cute_re.icon';
import { mgcIconRocketCuteRe } from './mgcIcon-rocket_cute_re.icon';
import { mgcIconRudderCuteRe } from './mgcIcon-rudder_cute_re.icon';
import { mgcIconSailboatCuteRe } from './mgcIcon-sailboat_cute_re.icon';
import { mgcIconScooterCuteRe } from './mgcIcon-scooter_cute_re.icon';
import { mgcIconSeatCuteRe } from './mgcIcon-seat_cute_re.icon';
import { mgcIconSeatHeatedCuteRe } from './mgcIcon-seat_heated_cute_re.icon';
import { mgcIconShipCuteRe } from './mgcIcon-ship_cute_re.icon';
import { mgcIconSleighCuteRe } from './mgcIcon-sleigh_cute_re.icon';
import { mgcIconSteeringWheelCuteRe } from './mgcIcon-steering_wheel_cute_re.icon';
import { mgcIconTankCuteRe } from './mgcIcon-tank_cute_re.icon';
import { mgcIconTrafficLightsCuteRe } from './mgcIcon-traffic_lights_cute_re.icon';
import { mgcIconTrain2CuteRe } from './mgcIcon-train_2_cute_re.icon';
import { mgcIconTrain3CuteRe } from './mgcIcon-train_3_cute_re.icon';
import { mgcIconTrain4CuteRe } from './mgcIcon-train_4_cute_re.icon';
import { mgcIconTrainCuteRe } from './mgcIcon-train_cute_re.icon';
import { mgcIconTruckCuteRe } from './mgcIcon-truck_cute_re.icon';
import { mgcIconTrunkCuteRe } from './mgcIcon-trunk_cute_re.icon';
import { mgcIconTyreCuteRe } from './mgcIcon-tyre_cute_re.icon';
import { mgcIconUfo2CuteRe } from './mgcIcon-UFO_2_cute_re.icon';
import { mgcIconUfoCuteRe } from './mgcIcon-UFO_cute_re.icon';
import { mgcIconWheelCuteRe } from './mgcIcon-wheel_cute_re.icon';
import { mgcIconWiperCuteRe } from './mgcIcon-wiper_cute_re.icon';
import { mgcIconBadgeCuteRe } from './mgcIcon-badge_cute_re.icon';
import { mgcIconContacts2CuteRe } from './mgcIcon-contacts_2_cute_re.icon';
import { mgcIconContacts3CuteRe } from './mgcIcon-contacts_3_cute_re.icon';
import { mgcIconContacts4CuteRe } from './mgcIcon-contacts_4_cute_re.icon';
import { mgcIconContactsCuteRe } from './mgcIcon-contacts_cute_re.icon';
import { mgcIconFemaleCuteRe } from './mgcIcon-female_cute_re.icon';
import { mgcIconGroup2CuteRe } from './mgcIcon-group_2_cute_re.icon';
import { mgcIconGroup3CuteRe } from './mgcIcon-group_3_cute_re.icon';
import { mgcIconGroupCuteRe } from './mgcIcon-group_cute_re.icon';
import { mgcIconIDcardCuteRe } from './mgcIcon-IDcard_cute_re.icon';
import { mgcIconMaleCuteRe } from './mgcIcon-male_cute_re.icon';
import { mgcIconUser1CuteRe } from './mgcIcon-user_1_cute_re.icon';
import { mgcIconUser2CuteRe } from './mgcIcon-user_2_cute_re.icon';
import { mgcIconUser3CuteRe } from './mgcIcon-user_3_cute_re.icon';
import { mgcIconUser4CuteRe } from './mgcIcon-user_4_cute_re.icon';
import { mgcIconUser5CuteRe } from './mgcIcon-user_5_cute_re.icon';
import { mgcIconUserAdd2CuteRe } from './mgcIcon-user_add_2_cute_re.icon';
import { mgcIconUserAddCuteRe } from './mgcIcon-user_add_cute_re.icon';
import { mgcIconUserEditCuteRe } from './mgcIcon-user_edit_cute_re.icon';
import { mgcIconUserFollow2CuteRe } from './mgcIcon-user_follow_2_cute_re.icon';
import { mgcIconUserFollowCuteRe } from './mgcIcon-user_follow_cute_re.icon';
import { mgcIconUserForbidCuteRe } from './mgcIcon-user_forbid_cute_re.icon';
import { mgcIconUserHeartCuteRe } from './mgcIcon-user_heart_cute_re.icon';
import { mgcIconUserHideCuteRe } from './mgcIcon-user_hide_cute_re.icon';
import { mgcIconUserInfoCuteRe } from './mgcIcon-user_info_cute_re.icon';
import { mgcIconUserLockCuteRe } from './mgcIcon-user_lock_cute_re.icon';
import { mgcIconUserPinCuteRe } from './mgcIcon-user_pin_cute_re.icon';
import { mgcIconUserQuestionCuteRe } from './mgcIcon-user_question_cute_re.icon';
import { mgcIconUserRemove2CuteRe } from './mgcIcon-user_remove_2_cute_re.icon';
import { mgcIconUserRemoveCuteRe } from './mgcIcon-user_remove_cute_re.icon';
import { mgcIconUserSearchCuteRe } from './mgcIcon-user_search_cute_re.icon';
import { mgcIconUserSecurityCuteRe } from './mgcIcon-user_security_cute_re.icon';
import { mgcIconUserSettingCuteRe } from './mgcIcon-user_setting_cute_re.icon';
import { mgcIconUserStarCuteRe } from './mgcIcon-user_star_cute_re.icon';
import { mgcIconUserVisibleCuteRe } from './mgcIcon-user_visible_cute_re.icon';
import { mgcIconUserWarningCuteRe } from './mgcIcon-user_warning_cute_re.icon';
import { mgcIconUserXCuteRe } from './mgcIcon-user_x_cute_re.icon';
import { mgcIconCelsiusCuteRe } from './mgcIcon-celsius_cute_re.icon';
import { mgcIconCloud2CuteRe } from './mgcIcon-cloud_2_cute_re.icon';
import { mgcIconCloudCuteRe } from './mgcIcon-cloud_cute_re.icon';
import { mgcIconCloudLightningCuteRe } from './mgcIcon-cloud_lightning_cute_re.icon';
import { mgcIconCloudSnowCuteRe } from './mgcIcon-cloud_snow_cute_re.icon';
import { mgcIconCloudWindyCuteRe } from './mgcIcon-cloud_windy_cute_re.icon';
import { mgcIconCloudsCuteRe } from './mgcIcon-clouds_cute_re.icon';
import { mgcIconDrizzleCuteRe } from './mgcIcon-drizzle_cute_re.icon';
import { mgcIconDryCuteRe } from './mgcIcon-dry_cute_re.icon';
import { mgcIconFahrenheitCuteRe } from './mgcIcon-fahrenheit_cute_re.icon';
import { mgcIconFloatingDustCuteRe } from './mgcIcon-floating_dust_cute_re.icon';
import { mgcIconFogCuteRe } from './mgcIcon-fog_cute_re.icon';
import { mgcIconFullMoonCuteRe } from './mgcIcon-full_moon_cute_re.icon';
import { mgcIconHailCuteRe } from './mgcIcon-hail_cute_re.icon';
import { mgcIconHazeCuteRe } from './mgcIcon-haze_cute_re.icon';
import { mgcIconHeavyRainCuteRe } from './mgcIcon-heavy_rain_cute_re.icon';
import { mgcIconHeavyRainstormCuteRe } from './mgcIcon-heavy_rainstorm_cute_re.icon';
import { mgcIconHeavySnowCuteRe } from './mgcIcon-heavy_snow_cute_re.icon';
import { mgcIconHeavySnowstormCuteRe } from './mgcIcon-heavy_snowstorm_cute_re.icon';
import { mgcIconHighTemperatureCuteRe } from './mgcIcon-high_temperature_cute_re.icon';
import { mgcIconLightSnowCuteRe } from './mgcIcon-light_snow_cute_re.icon';
import { mgcIconLightningCuteRe } from './mgcIcon-lightning_cute_re.icon';
import { mgcIconLowTemperatureCuteRe } from './mgcIcon-low_temperature_cute_re.icon';
import { mgcIconModerateSnowCuteRe } from './mgcIcon-moderate_snow_cute_re.icon';
import { mgcIconMoonCloudyCuteRe } from './mgcIcon-moon_cloudy_cute_re.icon';
import { mgcIconMoonCuteRe } from './mgcIcon-moon_cute_re.icon';
import { mgcIconMoonFogCuteRe } from './mgcIcon-moon_fog_cute_re.icon';
import { mgcIconMoonStarsCuteRe } from './mgcIcon-moon_stars_cute_re.icon';
import { mgcIconMoonlightCuteRe } from './mgcIcon-moonlight_cute_re.icon';
import { mgcIconNaCuteRe } from './mgcIcon-na_cute_re.icon';
import { mgcIconPartlyCloudDaytimeCuteRe } from './mgcIcon-partly_cloud_daytime_cute_re.icon';
import { mgcIconPartlyCloudNightCuteRe } from './mgcIcon-partly_cloud_night_cute_re.icon';
import { mgcIconRainCuteRe } from './mgcIcon-rain_cute_re.icon';
import { mgcIconRainbowCuteRe } from './mgcIcon-rainbow_cute_re.icon';
import { mgcIconRainstormCuteRe } from './mgcIcon-rainstorm_cute_re.icon';
import { mgcIconSandstormCuteRe } from './mgcIcon-sandstorm_cute_re.icon';
import { mgcIconShowersCuteRe } from './mgcIcon-showers_cute_re.icon';
import { mgcIconSnowCuteRe } from './mgcIcon-snow_cute_re.icon';
import { mgcIconSnowflakeCuteRe } from './mgcIcon-snowflake_cute_re.icon';
import { mgcIconSnowmanCuteRe } from './mgcIcon-snowman_cute_re.icon';
import { mgcIconSnowstorm2CuteRe } from './mgcIcon-snowstorm_2_cute_re.icon';
import { mgcIconSnowstormCuteRe } from './mgcIcon-snowstorm_cute_re.icon';
import { mgcIconSparkles2CuteRe } from './mgcIcon-sparkles_2_cute_re.icon';
import { mgcIconSparkles3CuteRe } from './mgcIcon-sparkles_3_cute_re.icon';
import { mgcIconSparklesCuteRe } from './mgcIcon-sparkles_cute_re.icon';
import { mgcIconSun2CuteRe } from './mgcIcon-sun_2_cute_re.icon';
import { mgcIconSunCloudyCuteRe } from './mgcIcon-sun_cloudy_cute_re.icon';
import { mgcIconSunCuteRe } from './mgcIcon-sun_cute_re.icon';
import { mgcIconSunFogCuteRe } from './mgcIcon-sun_fog_cute_re.icon';
import { mgcIconSunriseCuteRe } from './mgcIcon-sunrise_cute_re.icon';
import { mgcIconSunsetCuteRe } from './mgcIcon-sunset_cute_re.icon';
import { mgcIconThermometerCuteRe } from './mgcIcon-thermometer_cute_re.icon';
import { mgcIconThunderstormCuteRe } from './mgcIcon-thunderstorm_cute_re.icon';
import { mgcIconTornado2CuteRe } from './mgcIcon-tornado_2_cute_re.icon';
import { mgcIconTornadoCuteRe } from './mgcIcon-tornado_cute_re.icon';
import { mgcIconTyphoonCuteRe } from './mgcIcon-typhoon_cute_re.icon';
import { mgcIconUmbrellaCuteRe } from './mgcIcon-umbrella_cute_re.icon';
import { mgcIconWaveCuteRe } from './mgcIcon-wave_cute_re.icon';
import { mgcIconWetCuteRe } from './mgcIcon-wet_cute_re.icon';
import { mgcIconWindCuteRe } from './mgcIcon-wind_cute_re.icon';
import { mgcIconAquariusCuteRe } from './mgcIcon-Aquarius_cute_re.icon';
import { mgcIconAriesCuteRe } from './mgcIcon-Aries_cute_re.icon';
import { mgcIconCancerCuteRe } from './mgcIcon-Cancer_cute_re.icon';
import { mgcIconCapricornCuteRe } from './mgcIcon-Capricorn_cute_re.icon';
import { mgcIconGeminiCuteRe } from './mgcIcon-Gemini_cute_re.icon';
import { mgcIconLeoCuteRe } from './mgcIcon-Leo_cute_re.icon';
import { mgcIconLibraCuteRe } from './mgcIcon-Libra_cute_re.icon';
import { mgcIconPiscesCuteRe } from './mgcIcon-Pisces_cute_re.icon';
import { mgcIconSagittariusCuteRe } from './mgcIcon-Sagittarius_cute_re.icon';
import { mgcIconScorpioCuteRe } from './mgcIcon-Scorpio_cute_re.icon';
import { mgcIconTaurusCuteRe } from './mgcIcon-Taurus_cute_re.icon';
import { mgcIconVirgoCuteRe } from './mgcIcon-Virgo_cute_re.icon';
import { mgcIconAlignArrowDownFilled } from './mgcIcon-align_arrow_down_filled.icon';
import { mgcIconAlignArrowLeftFilled } from './mgcIcon-align_arrow_left_filled.icon';
import { mgcIconAlignArrowRightFilled } from './mgcIcon-align_arrow_right_filled.icon';
import { mgcIconAlignArrowUpFilled } from './mgcIcon-align_arrow_up_filled.icon';
import { mgcIconArrowDownCircleFilled } from './mgcIcon-arrow_down_circle_filled.icon';
import { mgcIconArrowDownFilled } from './mgcIcon-arrow_down_filled.icon';
import { mgcIconArrowLeftCircleFilled } from './mgcIcon-arrow_left_circle_filled.icon';
import { mgcIconArrowLeftDownCircleFilled } from './mgcIcon-arrow_left_down_circle_filled.icon';
import { mgcIconArrowLeftDownFilled } from './mgcIcon-arrow_left_down_filled.icon';
import { mgcIconArrowLeftFilled } from './mgcIcon-arrow_left_filled.icon';
import { mgcIconArrowLeftUpCircleFilled } from './mgcIcon-arrow_left_up_circle_filled.icon';
import { mgcIconArrowLeftUpFilled } from './mgcIcon-arrow_left_up_filled.icon';
import { mgcIconArrowRightCircleFilled } from './mgcIcon-arrow_right_circle_filled.icon';
import { mgcIconArrowRightDownCircleFilled } from './mgcIcon-arrow_right_down_circle_filled.icon';
import { mgcIconArrowRightDownFilled } from './mgcIcon-arrow_right_down_filled.icon';
import { mgcIconArrowRightFilled } from './mgcIcon-arrow_right_filled.icon';
import { mgcIconArrowRightUpCircleFilled } from './mgcIcon-arrow_right_up_circle_filled.icon';
import { mgcIconArrowRightUpFilled } from './mgcIcon-arrow_right_up_filled.icon';
import { mgcIconArrowToDownFilled } from './mgcIcon-arrow_to_down_filled.icon';
import { mgcIconArrowToLeftFilled } from './mgcIcon-arrow_to_left_filled.icon';
import { mgcIconArrowToRightFilled } from './mgcIcon-arrow_to_right_filled.icon';
import { mgcIconArrowToUpFilled } from './mgcIcon-arrow_to_up_filled.icon';
import { mgcIconArrowUpCircleFilled } from './mgcIcon-arrow_up_circle_filled.icon';
import { mgcIconArrowUpFilled } from './mgcIcon-arrow_up_filled.icon';
import { mgcIconArrowsDownFilled } from './mgcIcon-arrows_down_filled.icon';
import { mgcIconArrowsLeftFilled } from './mgcIcon-arrows_left_filled.icon';
import { mgcIconArrowsRightFilled } from './mgcIcon-arrows_right_filled.icon';
import { mgcIconArrowsUpFilled } from './mgcIcon-arrows_up_filled.icon';
import { mgcIconBack2Filled } from './mgcIcon-back_2_filled.icon';
import { mgcIconBackFilled } from './mgcIcon-back_filled.icon';
import { mgcIconCornerDownLeftFilled } from './mgcIcon-corner_down_left_filled.icon';
import { mgcIconCornerDownRightFilled } from './mgcIcon-corner_down_right_filled.icon';
import { mgcIconCornerUpLeftFilled } from './mgcIcon-corner_up_left_filled.icon';
import { mgcIconCornerUpRightFilled } from './mgcIcon-corner_up_right_filled.icon';
import { mgcIconDirectionArrowFilled } from './mgcIcon-direction_arrow_filled.icon';
import { mgcIconDownFilled } from './mgcIcon-down_filled.icon';
import { mgcIconDownSmallFilled } from './mgcIcon-down_small_filled.icon';
import { mgcIconForward2Filled } from './mgcIcon-forward_2_filled.icon';
import { mgcIconForwardFilled } from './mgcIcon-forward_filled.icon';
import { mgcIconFullscreen2Filled } from './mgcIcon-fullscreen_2_filled.icon';
import { mgcIconFullscreenExit2Filled } from './mgcIcon-fullscreen_exit_2_filled.icon';
import { mgcIconLargeArrowDownFilled } from './mgcIcon-large_arrow_down_filled.icon';
import { mgcIconLargeArrowLeftFilled } from './mgcIcon-large_arrow_left_filled.icon';
import { mgcIconLargeArrowRightFilled } from './mgcIcon-large_arrow_right_filled.icon';
import { mgcIconLargeArrowUpFilled } from './mgcIcon-large_arrow_up_filled.icon';
import { mgcIconLeftFilled } from './mgcIcon-left_filled.icon';
import { mgcIconLeftSmallFilled } from './mgcIcon-left_small_filled.icon';
import { mgcIconMoveFilled } from './mgcIcon-move_filled.icon';
import { mgcIconRightFilled } from './mgcIcon-right_filled.icon';
import { mgcIconRightSmallFilled } from './mgcIcon-right_small_filled.icon';
import { mgcIconSelectorHorizontalFilled } from './mgcIcon-selector_horizontal_filled.icon';
import { mgcIconSelectorVerticalFilled } from './mgcIcon-selector_vertical_filled.icon';
import { mgcIconSquareArrowDownFilled } from './mgcIcon-square_arrow_down_filled.icon';
import { mgcIconSquareArrowLeftFilled } from './mgcIcon-square_arrow_left_filled.icon';
import { mgcIconSquareArrowRightFilled } from './mgcIcon-square_arrow_right_filled.icon';
import { mgcIconSquareArrowUpFilled } from './mgcIcon-square_arrow_up_filled.icon';
import { mgcIconTransfer2Filled } from './mgcIcon-transfer_2_filled.icon';
import { mgcIconTransfer3Filled } from './mgcIcon-transfer_3_filled.icon';
import { mgcIconTransfer4Filled } from './mgcIcon-transfer_4_filled.icon';
import { mgcIconTransferFilled } from './mgcIcon-transfer_filled.icon';
import { mgcIconTransferHorizontalFilled } from './mgcIcon-transfer_horizontal_filled.icon';
import { mgcIconTransferVerticalFilled } from './mgcIcon-transfer_vertical_filled.icon';
import { mgcIconTrendingDownFilled } from './mgcIcon-trending_down_filled.icon';
import { mgcIconTrendingUpFilled } from './mgcIcon-trending_up_filled.icon';
import { mgcIconUpFilled } from './mgcIcon-up_filled.icon';
import { mgcIconUpSmallFilled } from './mgcIcon-up_small_filled.icon';
import { mgcIconBankFilled } from './mgcIcon-bank_filled.icon';
import { mgcIconBankOfChinaTowerFilled } from './mgcIcon-bank_of_china_tower_filled.icon';
import { mgcIconBigBenFilled } from './mgcIcon-big_ben_filled.icon';
import { mgcIconBridge2Filled } from './mgcIcon-bridge_2_filled.icon';
import { mgcIconBridgeFilled } from './mgcIcon-bridge_filled.icon';
import { mgcIconBuilding1Filled } from './mgcIcon-building_1_filled.icon';
import { mgcIconBuilding2Filled } from './mgcIcon-building_2_filled.icon';
import { mgcIconBuilding3Filled } from './mgcIcon-building_3_filled.icon';
import { mgcIconBuilding4Filled } from './mgcIcon-building_4_filled.icon';
import { mgcIconBuilding5Filled } from './mgcIcon-building_5_filled.icon';
import { mgcIconBuilding6Filled } from './mgcIcon-building_6_filled.icon';
import { mgcIconBurjAlArabFilled } from './mgcIcon-burj_al_arab_filled.icon';
import { mgcIconBurjKhalifaTowerFilled } from './mgcIcon-burj_khalifa_tower_filled.icon';
import { mgcIconCampgroundFilled } from './mgcIcon-campground_filled.icon';
import { mgcIconCantonTowerFilled } from './mgcIcon-canton_tower_filled.icon';
import { mgcIconChristTheRedeemerFilled } from './mgcIcon-christ_the_redeemer_filled.icon';
import { mgcIconChurchFilled } from './mgcIcon-church_filled.icon';
import { mgcIconDutchWindmillFilled } from './mgcIcon-dutch_windmill_filled.icon';
import { mgcIconEgyptianPyramidsFilled } from './mgcIcon-egyptian_pyramids_filled.icon';
import { mgcIconEiffelTowerFilled } from './mgcIcon-eiffel_tower_filled.icon';
import { mgcIconFactory2Filled } from './mgcIcon-factory_2_filled.icon';
import { mgcIconFactoryFilled } from './mgcIcon-factory_filled.icon';
import { mgcIconFerrisWheelFilled } from './mgcIcon-ferris_wheel_filled.icon';
import { mgcIconGovernmentFilled } from './mgcIcon-government_filled.icon';
import { mgcIconGreatwallFilled } from './mgcIcon-greatwall_filled.icon';
import { mgcIconHome1Filled } from './mgcIcon-home_1_filled.icon';
import { mgcIconHome2Filled } from './mgcIcon-home_2_filled.icon';
import { mgcIconHome3Filled } from './mgcIcon-home_3_filled.icon';
import { mgcIconHome4Filled } from './mgcIcon-home_4_filled.icon';
import { mgcIconHome5Filled } from './mgcIcon-home_5_filled.icon';
import { mgcIconHome6Filled } from './mgcIcon-home_6_filled.icon';
import { mgcIconHome7Filled } from './mgcIcon-home_7_filled.icon';
import { mgcIconHospitalFilled } from './mgcIcon-hospital_filled.icon';
import { mgcIconHotelFilled } from './mgcIcon-hotel_filled.icon';
import { mgcIconHouse2Filled } from './mgcIcon-house_2_filled.icon';
import { mgcIconHouseFilled } from './mgcIcon-house_filled.icon';
import { mgcIconKingkey100TowerFilled } from './mgcIcon-kingkey_100_tower_filled.icon';
import { mgcIconLighthouseFilled } from './mgcIcon-lighthouse_filled.icon';
import { mgcIconMarinaBaySandFilled } from './mgcIcon-marina_bay_sand_filled.icon';
import { mgcIconMayaPyramidsFilled } from './mgcIcon-maya_pyramids_filled.icon';
import { mgcIconMiyajimaToriiFilled } from './mgcIcon-miyajima_torii_filled.icon';
import { mgcIconMoaiFilled } from './mgcIcon-moai_filled.icon';
import { mgcIconMonumentFilled } from './mgcIcon-monument_filled.icon';
import { mgcIconPalaceFilled } from './mgcIcon-palace_filled.icon';
import { mgcIconPavilionFilled } from './mgcIcon-pavilion_filled.icon';
import { mgcIconPisaTowerFilled } from './mgcIcon-pisa_tower_filled.icon';
import { mgcIconSchoolFilled } from './mgcIcon-school_filled.icon';
import { mgcIconShopFilled } from './mgcIcon-shop_filled.icon';
import { mgcIconStatueOfLibertyFilled } from './mgcIcon-statue_of_liberty_filled.icon';
import { mgcIconStore2Filled } from './mgcIcon-store_2_filled.icon';
import { mgcIconStoreFilled } from './mgcIcon-store_filled.icon';
import { mgcIconSydneyOperaHouseFilled } from './mgcIcon-sydney_opera_house_filled.icon';
import { mgcIconTaipei101Filled } from './mgcIcon-taipei101_filled.icon';
import { mgcIconTajMahalFilled } from './mgcIcon-taj_mahal_filled.icon';
import { mgcIconTempleOfHeavenFilled } from './mgcIcon-temple_of_heaven_filled.icon';
import { mgcIconTentFilled } from './mgcIcon-tent_filled.icon';
import { mgcIconTowerFilled } from './mgcIcon-tower_filled.icon';
import { mgcIconTriumphalArchFilled } from './mgcIcon-triumphal_arch_filled.icon';
import { mgcIconTvTowerFilled } from './mgcIcon-tv_tower_filled.icon';
import { mgcIconAdCircleFilled } from './mgcIcon-ad_circle_filled.icon';
import { mgcIconAdCircleOffFilled } from './mgcIcon-ad_circle_off_filled.icon';
import { mgcIconAdRectangleFilled } from './mgcIcon-ad_rectangle_filled.icon';
import { mgcIconAdRectangleOffFilled } from './mgcIcon-ad_rectangle_off_filled.icon';
import { mgcIconAnniversaryFilled } from './mgcIcon-anniversary_filled.icon';
import { mgcIconAuctionFilled } from './mgcIcon-auction_filled.icon';
import { mgcIconAwardFilled } from './mgcIcon-award_filled.icon';
import { mgcIconBankCardFilled } from './mgcIcon-bank_card_filled.icon';
import { mgcIconBasket2Filled } from './mgcIcon-basket_2_filled.icon';
import { mgcIconBasketFilled } from './mgcIcon-basket_filled.icon';
import { mgcIconBriefcase2Filled } from './mgcIcon-briefcase_2_filled.icon';
import { mgcIconBriefcaseFilled } from './mgcIcon-briefcase_filled.icon';
import { mgcIconCalendar2Filled } from './mgcIcon-calendar_2_filled.icon';
import { mgcIconCalendar3Filled } from './mgcIcon-calendar_3_filled.icon';
import { mgcIconCalendarAddFilled } from './mgcIcon-calendar_add_filled.icon';
import { mgcIconCalendarDayFilled } from './mgcIcon-calendar_day_filled.icon';
import { mgcIconCalendarFilled } from './mgcIcon-calendar_filled.icon';
import { mgcIconCalendarMonthFilled } from './mgcIcon-calendar_month_filled.icon';
import { mgcIconCalendarTimeAddFilled } from './mgcIcon-calendar_time_add_filled.icon';
import { mgcIconCalendarWeekFilled } from './mgcIcon-calendar_week_filled.icon';
import { mgcIconCandleFilled } from './mgcIcon-candle_filled.icon';
import { mgcIconCandlesFilled } from './mgcIcon-candles_filled.icon';
import { mgcIconCardPayFilled } from './mgcIcon-card_pay_filled.icon';
import { mgcIconCardRefundFilled } from './mgcIcon-card_refund_filled.icon';
import { mgcIconCash2Filled } from './mgcIcon-cash_2_filled.icon';
import { mgcIconCashFilled } from './mgcIcon-cash_filled.icon';
import { mgcIconCelebrateFilled } from './mgcIcon-celebrate_filled.icon';
import { mgcIconChartBar2Filled } from './mgcIcon-chart_bar_2_filled.icon';
import { mgcIconChartBarFilled } from './mgcIcon-chart_bar_filled.icon';
import { mgcIconChartDecreaseFilled } from './mgcIcon-chart_decrease_filled.icon';
import { mgcIconChartHorizontalFilled } from './mgcIcon-chart_horizontal_filled.icon';
import { mgcIconChartLineFilled } from './mgcIcon-chart_line_filled.icon';
import { mgcIconChartPie2Filled } from './mgcIcon-chart_pie_2_filled.icon';
import { mgcIconChartPieFilled } from './mgcIcon-chart_pie_filled.icon';
import { mgcIconChartVerticalFilled } from './mgcIcon-chart_vertical_filled.icon';
import { mgcIconChineseKnotFilled } from './mgcIcon-chinese_knot_filled.icon';
import { mgcIconChristmasBallFilled } from './mgcIcon-christmas_ball_filled.icon';
import { mgcIconCoin2Filled } from './mgcIcon-coin_2_filled.icon';
import { mgcIconCoin3Filled } from './mgcIcon-coin_3_filled.icon';
import { mgcIconCoinFilled } from './mgcIcon-coin_filled.icon';
import { mgcIconCopperCoinFilled } from './mgcIcon-copper_coin_filled.icon';
import { mgcIconCopyrightFilled } from './mgcIcon-copyright_filled.icon';
import { mgcIconCouponFilled } from './mgcIcon-coupon_filled.icon';
import { mgcIconCurrencyBaht2Filled } from './mgcIcon-currency_baht_2_filled.icon';
import { mgcIconCurrencyBahtFilled } from './mgcIcon-currency_baht_filled.icon';
import { mgcIconCurrencyCny2Filled } from './mgcIcon-currency_cny_2_filled.icon';
import { mgcIconCurrencyCnyFilled } from './mgcIcon-currency_cny_filled.icon';
import { mgcIconCurrencyDollar2Filled } from './mgcIcon-currency_dollar_2_filled.icon';
import { mgcIconCurrencyDollarFilled } from './mgcIcon-currency_dollar_filled.icon';
import { mgcIconCurrencyEuro2Filled } from './mgcIcon-currency_euro_2_filled.icon';
import { mgcIconCurrencyEuroFilled } from './mgcIcon-currency_euro_filled.icon';
import { mgcIconCurrencyLira2Filled } from './mgcIcon-currency_lira_2_filled.icon';
import { mgcIconCurrencyLiraFilled } from './mgcIcon-currency_lira_filled.icon';
import { mgcIconCurrencyNigeria2Filled } from './mgcIcon-currency_nigeria_2_filled.icon';
import { mgcIconCurrencyNigeriaFilled } from './mgcIcon-currency_nigeria_filled.icon';
import { mgcIconCurrencyRubel2Filled } from './mgcIcon-currency_rubel_2_filled.icon';
import { mgcIconCurrencyRubelFilled } from './mgcIcon-currency_rubel_filled.icon';
import { mgcIconCurrencyRupee2Filled } from './mgcIcon-currency_rupee_2_filled.icon';
import { mgcIconCurrencyRupeeFilled } from './mgcIcon-currency_rupee_filled.icon';
import { mgcIconCurrencyShekel2Filled } from './mgcIcon-currency_shekel_2_filled.icon';
import { mgcIconCurrencyShekelFilled } from './mgcIcon-currency_shekel_filled.icon';
import { mgcIconCurrencyWon2Filled } from './mgcIcon-currency_won_2_filled.icon';
import { mgcIconCurrencyWonFilled } from './mgcIcon-currency_won_filled.icon';
import { mgcIconDiamond2Filled } from './mgcIcon-diamond_2_filled.icon';
import { mgcIconExchangeBahtFilled } from './mgcIcon-exchange_baht_filled.icon';
import { mgcIconExchangeCnyFilled } from './mgcIcon-exchange_cny_filled.icon';
import { mgcIconExchangeDollarFilled } from './mgcIcon-exchange_dollar_filled.icon';
import { mgcIconExchangeEuroFilled } from './mgcIcon-exchange_euro_filled.icon';
import { mgcIconFilter3Filled } from './mgcIcon-filter_3_filled.icon';
import { mgcIconFilterFilled } from './mgcIcon-filter_filled.icon';
import { mgcIconFlag1Filled } from './mgcIcon-flag_1_filled.icon';
import { mgcIconFlag2Filled } from './mgcIcon-flag_2_filled.icon';
import { mgcIconFlag3Filled } from './mgcIcon-flag_3_filled.icon';
import { mgcIconFlag4Filled } from './mgcIcon-flag_4_filled.icon';
import { mgcIconGift2Filled } from './mgcIcon-gift_2_filled.icon';
import { mgcIconGiftCardFilled } from './mgcIcon-gift_card_filled.icon';
import { mgcIconGiftFilled } from './mgcIcon-gift_filled.icon';
import { mgcIconLadderFilled } from './mgcIcon-ladder_filled.icon';
import { mgcIconLantern2Filled } from './mgcIcon-lantern_2_filled.icon';
import { mgcIconLanternFilled } from './mgcIcon-lantern_filled.icon';
import { mgcIconLaurelWreathFilled } from './mgcIcon-laurel_wreath_filled.icon';
import { mgcIconLuggageFilled } from './mgcIcon-luggage_filled.icon';
import { mgcIconMedalFilled } from './mgcIcon-medal_filled.icon';
import { mgcIconPalette3Filled } from './mgcIcon-palette_3_filled.icon';
import { mgcIconPigMoneyFilled } from './mgcIcon-pig_money_filled.icon';
import { mgcIconPound2Filled } from './mgcIcon-pound_2_filled.icon';
import { mgcIconPoundFilled } from './mgcIcon-pound_filled.icon';
import { mgcIconPresentation1Filled } from './mgcIcon-presentation_1_filled.icon';
import { mgcIconPresentation2Filled } from './mgcIcon-presentation_2_filled.icon';
import { mgcIconPresentation3Filled } from './mgcIcon-presentation_3_filled.icon';
import { mgcIconPumpkinLanternFilled } from './mgcIcon-pumpkin_lantern_filled.icon';
import { mgcIconReceiveMoneyFilled } from './mgcIcon-receive_money_filled.icon';
import { mgcIconRedPacketFilled } from './mgcIcon-red_packet_filled.icon';
import { mgcIconRedPacketOpenFilled } from './mgcIcon-red_packet_open_filled.icon';
import { mgcIconRefundCnyFilled } from './mgcIcon-refund_cny_filled.icon';
import { mgcIconRefundDollarFilled } from './mgcIcon-refund_dollar_filled.icon';
import { mgcIconRegisteredFilled } from './mgcIcon-registered_filled.icon';
import { mgcIconSafeBoxFilled } from './mgcIcon-safe_box_filled.icon';
import { mgcIconSaleFilled } from './mgcIcon-sale_filled.icon';
import { mgcIconScheduleFilled } from './mgcIcon-schedule_filled.icon';
import { mgcIconSealFilled } from './mgcIcon-seal_filled.icon';
import { mgcIconShoppingBag1Filled } from './mgcIcon-shopping_bag_1_filled.icon';
import { mgcIconShoppingBag2Filled } from './mgcIcon-shopping_bag_2_filled.icon';
import { mgcIconShoppingBag3Filled } from './mgcIcon-shopping_bag_3_filled.icon';
import { mgcIconShoppingCart1Filled } from './mgcIcon-shopping_cart_1_filled.icon';
import { mgcIconShoppingCart2Filled } from './mgcIcon-shopping_cart_2_filled.icon';
import { mgcIconSofaFilled } from './mgcIcon-sofa_filled.icon';
import { mgcIconStockFilled } from './mgcIcon-stock_filled.icon';
import { mgcIconSuitcase2Filled } from './mgcIcon-suitcase_2_filled.icon';
import { mgcIconSuitcaseFilled } from './mgcIcon-suitcase_filled.icon';
import { mgcIconTag2Filled } from './mgcIcon-tag_2_filled.icon';
import { mgcIconTagChevronFilled } from './mgcIcon-tag_chevron_filled.icon';
import { mgcIconTagFilled } from './mgcIcon-tag_filled.icon';
import { mgcIconTargetFilled } from './mgcIcon-target_filled.icon';
import { mgcIconTicketFilled } from './mgcIcon-ticket_filled.icon';
import { mgcIconTrophyFilled } from './mgcIcon-trophy_filled.icon';
import { mgcIconVip1Filled } from './mgcIcon-VIP_1_filled.icon';
import { mgcIconVip2Filled } from './mgcIcon-VIP_2_filled.icon';
import { mgcIconVip3Filled } from './mgcIcon-VIP_3_filled.icon';
import { mgcIconVip4Filled } from './mgcIcon-VIP_4_filled.icon';
import { mgcIconWallet2Filled } from './mgcIcon-wallet_2_filled.icon';
import { mgcIconWallet3Filled } from './mgcIcon-wallet_3_filled.icon';
import { mgcIconWallet4Filled } from './mgcIcon-wallet_4_filled.icon';
import { mgcIconWallet5Filled } from './mgcIcon-wallet_5_filled.icon';
import { mgcIconWalletFilled } from './mgcIcon-wallet_filled.icon';
import { mgcIconYuanbaoFilled } from './mgcIcon-yuanbao_filled.icon';
import { mgcIconChat1Filled } from './mgcIcon-chat_1_filled.icon';
import { mgcIconChat2Filled } from './mgcIcon-chat_2_filled.icon';
import { mgcIconChat3Filled } from './mgcIcon-chat_3_filled.icon';
import { mgcIconChat4Filled } from './mgcIcon-chat_4_filled.icon';
import { mgcIconComment2Filled } from './mgcIcon-comment_2_filled.icon';
import { mgcIconCommentFilled } from './mgcIcon-comment_filled.icon';
import { mgcIconInviteFilled } from './mgcIcon-invite_filled.icon';
import { mgcIconMailAiFilled } from './mgcIcon-mail_ai_filled.icon';
import { mgcIconMailFilled } from './mgcIcon-mail_filled.icon';
import { mgcIconMailOpenFilled } from './mgcIcon-mail_open_filled.icon';
import { mgcIconMailSendFilled } from './mgcIcon-mail_send_filled.icon';
import { mgcIconMailboxFilled } from './mgcIcon-mailbox_filled.icon';
import { mgcIconMessage1Filled } from './mgcIcon-message_1_filled.icon';
import { mgcIconMessage2Filled } from './mgcIcon-message_2_filled.icon';
import { mgcIconMessage3Filled } from './mgcIcon-message_3_filled.icon';
import { mgcIconMessage4Filled } from './mgcIcon-message_4_filled.icon';
import { mgcIconPhoneAddFilled } from './mgcIcon-phone_add_filled.icon';
import { mgcIconPhoneBlockFilled } from './mgcIcon-phone_block_filled.icon';
import { mgcIconPhoneCallFilled } from './mgcIcon-phone_call_filled.icon';
import { mgcIconPhoneFilled } from './mgcIcon-phone_filled.icon';
import { mgcIconPhoneIncomingFilled } from './mgcIcon-phone_incoming_filled.icon';
import { mgcIconPhoneOffFilled } from './mgcIcon-phone_off_filled.icon';
import { mgcIconPhoneOutgoingFilled } from './mgcIcon-phone_outgoing_filled.icon';
import { mgcIconPhoneSuccessFilled } from './mgcIcon-phone_success_filled.icon';
import { mgcIconSendFilled } from './mgcIcon-send_filled.icon';
import { mgcIconSendPlaneFilled } from './mgcIcon-send_plane_filled.icon';
import { mgcIconAvalancheAvaxFilled } from './mgcIcon-avalanche_AVAX_filled.icon';
import { mgcIconBinanceCoinBnbFilled } from './mgcIcon-binance_coin_BNB_filled.icon';
import { mgcIconBinanceUsdBusdFilled } from './mgcIcon-binance_USD_BUSD_filled.icon';
import { mgcIconBnbFilled } from './mgcIcon-BNB_filled.icon';
import { mgcIconCardanoAdaFilled } from './mgcIcon-cardano_ADA_filled.icon';
import { mgcIconCurrencyBitcoin2Filled } from './mgcIcon-currency_bitcoin_2_filled.icon';
import { mgcIconCurrencyBitcoinFilled } from './mgcIcon-currency_bitcoin_filled.icon';
import { mgcIconDogecoinDogeFilled } from './mgcIcon-dogecoin_DOGE_filled.icon';
import { mgcIconEthereumFilled } from './mgcIcon-ethereum_filled.icon';
import { mgcIconExchangeBitcoinFilled } from './mgcIcon-exchange_bitcoin_filled.icon';
import { mgcIconMoneroFilled } from './mgcIcon-monero_filled.icon';
import { mgcIconPolkadotDotFilled } from './mgcIcon-polkadot_DOT_filled.icon';
import { mgcIconSolanaSolFilled } from './mgcIcon-solana_SOL_filled.icon';
import { mgcIconTetherUsdtFilled } from './mgcIcon-tether_USDT_filled.icon';
import { mgcIconUsdCoinUsdcFilled } from './mgcIcon-usd_coin_USDC_filled.icon';
import { mgcIconXrpFilled } from './mgcIcon-XRP_filled.icon';
import { mgcIconAlignBottomFilled } from './mgcIcon-align_bottom_filled.icon';
import { mgcIconAlignHorizontalCenterFilled } from './mgcIcon-align_horizontal_center_filled.icon';
import { mgcIconAlignLeft2Filled } from './mgcIcon-align_left_2_filled.icon';
import { mgcIconAlignRight2Filled } from './mgcIcon-align_right_2_filled.icon';
import { mgcIconAlignTopFilled } from './mgcIcon-align_top_filled.icon';
import { mgcIconAlignVerticalCenterFilled } from './mgcIcon-align_vertical_center_filled.icon';
import { mgcIconAnticlockwiseAltFilled } from './mgcIcon-anticlockwise_alt_filled.icon';
import { mgcIconAnticlockwiseFilled } from './mgcIcon-anticlockwise_filled.icon';
import { mgcIconArtboardFilled } from './mgcIcon-artboard_filled.icon';
import { mgcIconBackgroundBaseFilled } from './mgcIcon-background_base_filled.icon';
import { mgcIconBackgroundFilled } from './mgcIcon-background_filled.icon';
import { mgcIconBlingFilled } from './mgcIcon-bling_filled.icon';
import { mgcIconBoardFilled } from './mgcIcon-board_filled.icon';
import { mgcIconBorderBlankFilled } from './mgcIcon-border_blank_filled.icon';
import { mgcIconBorderBottomFilled } from './mgcIcon-border_bottom_filled.icon';
import { mgcIconBorderHorizontalFilled } from './mgcIcon-border_horizontal_filled.icon';
import { mgcIconBorderInnerFilled } from './mgcIcon-border_inner_filled.icon';
import { mgcIconBorderLeftFilled } from './mgcIcon-border_left_filled.icon';
import { mgcIconBorderOuterFilled } from './mgcIcon-border_outer_filled.icon';
import { mgcIconBorderRadiusFilled } from './mgcIcon-border_radius_filled.icon';
import { mgcIconBorderRightFilled } from './mgcIcon-border_right_filled.icon';
import { mgcIconBorderTopFilled } from './mgcIcon-border_top_filled.icon';
import { mgcIconBorderVerticalFilled } from './mgcIcon-border_vertical_filled.icon';
import { mgcIconBrightnessFilled } from './mgcIcon-brightness_filled.icon';
import { mgcIconBrush2Filled } from './mgcIcon-brush_2_filled.icon';
import { mgcIconClockwiseAltFilled } from './mgcIcon-clockwise_alt_filled.icon';
import { mgcIconClockwiseFilled } from './mgcIcon-clockwise_filled.icon';
import { mgcIconColorFilterFilled } from './mgcIcon-color_filter_filled.icon';
import { mgcIconColorPickerFilled } from './mgcIcon-color_picker_filled.icon';
import { mgcIconColumns2Filled } from './mgcIcon-columns_2_filled.icon';
import { mgcIconColumns3Filled } from './mgcIcon-columns_3_filled.icon';
import { mgcIconCombineFilled } from './mgcIcon-combine_filled.icon';
import { mgcIconComponentsFilled } from './mgcIcon-components_filled.icon';
import { mgcIconDistributeSpacingHorizontalFilled } from './mgcIcon-distribute_spacing_horizontal_filled.icon';
import { mgcIconDistributeSpacingVerticalFilled } from './mgcIcon-distribute_spacing_vertical_filled.icon';
import { mgcIconDrawingBoardFilled } from './mgcIcon-drawing_board_filled.icon';
import { mgcIconDropFilled } from './mgcIcon-drop_filled.icon';
import { mgcIconEaseInControlPointFilled } from './mgcIcon-ease_in_control_point_filled.icon';
import { mgcIconEaseInFilled } from './mgcIcon-ease_in_filled.icon';
import { mgcIconEaseInOutControlPointFilled } from './mgcIcon-ease_in_out_control_point_filled.icon';
import { mgcIconEaseOutControlPointFilled } from './mgcIcon-ease_out_control_point_filled.icon';
import { mgcIconEaseOutFilled } from './mgcIcon-ease_out_filled.icon';
import { mgcIconEasyInOutFilled } from './mgcIcon-easy_in_out_filled.icon';
import { mgcIconExcludeFilled } from './mgcIcon-exclude_filled.icon';
import { mgcIconExposureFilled } from './mgcIcon-exposure_filled.icon';
import { mgcIconFlipHorizontalFilled } from './mgcIcon-flip_horizontal_filled.icon';
import { mgcIconFlipVerticalFilled } from './mgcIcon-flip_vertical_filled.icon';
import { mgcIconFoldHorizontalFilled } from './mgcIcon-fold_horizontal_filled.icon';
import { mgcIconFoldVerticalFilled } from './mgcIcon-fold_vertical_filled.icon';
import { mgcIconIntersectFilled } from './mgcIcon-intersect_filled.icon';
import { mgcIconKnifeFilled } from './mgcIcon-knife_filled.icon';
import { mgcIconLayerFilled } from './mgcIcon-layer_filled.icon';
import { mgcIconLayout10Filled } from './mgcIcon-layout_10_filled.icon';
import { mgcIconLayout11Filled } from './mgcIcon-layout_11_filled.icon';
import { mgcIconLayout2Filled } from './mgcIcon-layout_2_filled.icon';
import { mgcIconLayout3Filled } from './mgcIcon-layout_3_filled.icon';
import { mgcIconLayout4Filled } from './mgcIcon-layout_4_filled.icon';
import { mgcIconLayout5Filled } from './mgcIcon-layout_5_filled.icon';
import { mgcIconLayout6Filled } from './mgcIcon-layout_6_filled.icon';
import { mgcIconLayout7Filled } from './mgcIcon-layout_7_filled.icon';
import { mgcIconLayout8Filled } from './mgcIcon-layout_8_filled.icon';
import { mgcIconLayout9Filled } from './mgcIcon-layout_9_filled.icon';
import { mgcIconLayoutBottomCloseFilled } from './mgcIcon-layout_bottom_close_filled.icon';
import { mgcIconLayoutBottomFilled } from './mgcIcon-layout_bottom_filled.icon';
import { mgcIconLayoutBottomOpenFilled } from './mgcIcon-layout_bottom_open_filled.icon';
import { mgcIconLayoutFilled } from './mgcIcon-layout_filled.icon';
import { mgcIconLayoutGridFilled } from './mgcIcon-layout_grid_filled.icon';
import { mgcIconLayoutLeftFilled } from './mgcIcon-layout_left_filled.icon';
import { mgcIconLayoutLeftbarCloseFilled } from './mgcIcon-layout_leftbar_close_filled.icon';
import { mgcIconLayoutLeftbarOpenFilled } from './mgcIcon-layout_leftbar_open_filled.icon';
import { mgcIconLayoutRightFilled } from './mgcIcon-layout_right_filled.icon';
import { mgcIconLayoutRightbarCloseFilled } from './mgcIcon-layout_rightbar_close_filled.icon';
import { mgcIconLayoutRightbarOpenFilled } from './mgcIcon-layout_rightbar_open_filled.icon';
import { mgcIconLayoutTopCloseFilled } from './mgcIcon-layout_top_close_filled.icon';
import { mgcIconLayoutTopFilled } from './mgcIcon-layout_top_filled.icon';
import { mgcIconLayoutTopOpenFilled } from './mgcIcon-layout_top_open_filled.icon';
import { mgcIconMagic1Filled } from './mgcIcon-magic_1_filled.icon';
import { mgcIconMagic2Filled } from './mgcIcon-magic_2_filled.icon';
import { mgcIconMagic3Filled } from './mgcIcon-magic_3_filled.icon';
import { mgcIconMagicHat2Filled } from './mgcIcon-magic_hat_2_filled.icon';
import { mgcIconMagicHatFilled } from './mgcIcon-magic_hat_filled.icon';
import { mgcIconMarkPenFilled } from './mgcIcon-mark_pen_filled.icon';
import { mgcIconMarkupFilled } from './mgcIcon-markup_filled.icon';
import { mgcIconMirrorFilled } from './mgcIcon-mirror_filled.icon';
import { mgcIconMosaicFilled } from './mgcIcon-mosaic_filled.icon';
import { mgcIconPaint2Filled } from './mgcIcon-paint_2_filled.icon';
import { mgcIconPaintBrushAiFilled } from './mgcIcon-paint_brush_ai_filled.icon';
import { mgcIconPaintBrushFilled } from './mgcIcon-paint_brush_filled.icon';
import { mgcIconPalette2Filled } from './mgcIcon-palette_2_filled.icon';
import { mgcIconPaletteFilled } from './mgcIcon-palette_filled.icon';
import { mgcIconPasterFilled } from './mgcIcon-paster_filled.icon';
import { mgcIconPenFilled } from './mgcIcon-pen_filled.icon';
import { mgcIconQuillPenAiFilled } from './mgcIcon-quill_pen_ai_filled.icon';
import { mgcIconQuillPenFilled } from './mgcIcon-quill_pen_filled.icon';
import { mgcIconRotateXFilled } from './mgcIcon-rotate_x_filled.icon';
import { mgcIconRotateYFilled } from './mgcIcon-rotate_y_filled.icon';
import { mgcIconRows2Filled } from './mgcIcon-rows_2_filled.icon';
import { mgcIconRows3Filled } from './mgcIcon-rows_3_filled.icon';
import { mgcIconRows4Filled } from './mgcIcon-rows_4_filled.icon';
import { mgcIconRulerFilled } from './mgcIcon-ruler_filled.icon';
import { mgcIconScaleFilled } from './mgcIcon-scale_filled.icon';
import { mgcIconScissors2Filled } from './mgcIcon-scissors_2_filled.icon';
import { mgcIconScissors3Filled } from './mgcIcon-scissors_3_filled.icon';
import { mgcIconScissorsFilled } from './mgcIcon-scissors_filled.icon';
import { mgcIconScreenshotFilled } from './mgcIcon-screenshot_filled.icon';
import { mgcIconSectionFilled } from './mgcIcon-section_filled.icon';
import { mgcIconShadowFilled } from './mgcIcon-shadow_filled.icon';
import { mgcIconStickerFilled } from './mgcIcon-sticker_filled.icon';
import { mgcIconSubtractFilled } from './mgcIcon-subtract_filled.icon';
import { mgcIconTable2Filled } from './mgcIcon-table_2_filled.icon';
import { mgcIconUnfoldHorizontalFilled } from './mgcIcon-unfold_horizontal_filled.icon';
import { mgcIconUnfoldVerticalFilled } from './mgcIcon-unfold_vertical_filled.icon';
import { mgcIconUnionFilled } from './mgcIcon-union_filled.icon';
import { mgcIconVectorBezier2Filled } from './mgcIcon-vector_bezier_2_filled.icon';
import { mgcIconVectorBezier3Filled } from './mgcIcon-vector_bezier_3_filled.icon';
import { mgcIconVectorBezierFilled } from './mgcIcon-vector_bezier_filled.icon';
import { mgcIconVectorGroupFilled } from './mgcIcon-vector_group_filled.icon';
import { mgcIconXSkewFilled } from './mgcIcon-x_skew_filled.icon';
import { mgcIconYSkewFilled } from './mgcIcon-y_skew_filled.icon';
import { mgcIconBracesFilled } from './mgcIcon-braces_filled.icon';
import { mgcIconBracketsAngleFilled } from './mgcIcon-brackets_angle_filled.icon';
import { mgcIconBracketsFilled } from './mgcIcon-brackets_filled.icon';
import { mgcIconBugFilled } from './mgcIcon-bug_filled.icon';
import { mgcIconCodeFilled } from './mgcIcon-code_filled.icon';
import { mgcIconCommandFilled } from './mgcIcon-command_filled.icon';
import { mgcIconCursor2Filled } from './mgcIcon-cursor_2_filled.icon';
import { mgcIconCursor3Filled } from './mgcIcon-cursor_3_filled.icon';
import { mgcIconCursorFilled } from './mgcIcon-cursor_filled.icon';
import { mgcIconDepartmentFilled } from './mgcIcon-department_filled.icon';
import { mgcIconDirectoryFilled } from './mgcIcon-directory_filled.icon';
import { mgcIconGitBranchFilled } from './mgcIcon-git_branch_filled.icon';
import { mgcIconGitCommitFilled } from './mgcIcon-git_commit_filled.icon';
import { mgcIconGitCompareFilled } from './mgcIcon-git_compare_filled.icon';
import { mgcIconGitMergeFilled } from './mgcIcon-git_merge_filled.icon';
import { mgcIconGitPullRequestCloseFilled } from './mgcIcon-git_pull_request_close_filled.icon';
import { mgcIconGitPullRequestFilled } from './mgcIcon-git_pull_request_filled.icon';
import { mgcIconHotkeyFilled } from './mgcIcon-hotkey_filled.icon';
import { mgcIconInspectFilled } from './mgcIcon-inspect_filled.icon';
import { mgcIconParenthesesFilled } from './mgcIcon-parentheses_filled.icon';
import { mgcIconPerformanceFilled } from './mgcIcon-performance_filled.icon';
import { mgcIconSitemapFilled } from './mgcIcon-sitemap_filled.icon';
import { mgcIconTerminalBoxFilled } from './mgcIcon-terminal_box_filled.icon';
import { mgcIconTerminalFilled } from './mgcIcon-terminal_filled.icon';
import { mgcIconWebFilled } from './mgcIcon-web_filled.icon';
import { mgcIconAiFilled } from './mgcIcon-ai_filled.icon';
import { mgcIconAirConditionFilled } from './mgcIcon-air_condition_filled.icon';
import { mgcIconAirConditionOpenFilled } from './mgcIcon-air_condition_open_filled.icon';
import { mgcIconAirplayFilled } from './mgcIcon-airplay_filled.icon';
import { mgcIconAirpods2Filled } from './mgcIcon-airpods_2_filled.icon';
import { mgcIconAlarm1Filled } from './mgcIcon-alarm_1_filled.icon';
import { mgcIconAlarm2Filled } from './mgcIcon-alarm_2_filled.icon';
import { mgcIconAspectRatioFilled } from './mgcIcon-aspect_ratio_filled.icon';
import { mgcIconBarcodeFilled } from './mgcIcon-barcode_filled.icon';
import { mgcIconBarcodeScaFilled } from './mgcIcon-barcode_sca_filled.icon';
import { mgcIconBaseStation2Filled } from './mgcIcon-base_station_2_filled.icon';
import { mgcIconBaseStationFilled } from './mgcIcon-base_station_filled.icon';
import { mgcIconBattery1Filled } from './mgcIcon-battery_1_filled.icon';
import { mgcIconBattery2Filled } from './mgcIcon-battery_2_filled.icon';
import { mgcIconBattery3Filled } from './mgcIcon-battery_3_filled.icon';
import { mgcIconBattery4Filled } from './mgcIcon-battery_4_filled.icon';
import { mgcIconBatteryAutomotiveFilled } from './mgcIcon-battery_automotive_filled.icon';
import { mgcIconBatteryChargingFilled } from './mgcIcon-battery_charging_filled.icon';
import { mgcIconBatteryFilled } from './mgcIcon-battery_filled.icon';
import { mgcIconBluetoothFilled } from './mgcIcon-bluetooth_filled.icon';
import { mgcIconBluetoothOffFilled } from './mgcIcon-bluetooth_off_filled.icon';
import { mgcIconBulb2Filled } from './mgcIcon-bulb_2_filled.icon';
import { mgcIconBulbFilled } from './mgcIcon-bulb_filled.icon';
import { mgcIconCamcorder2Filled } from './mgcIcon-camcorder_2_filled.icon';
import { mgcIconCardboardVrFilled } from './mgcIcon-cardboard_vr_filled.icon';
import { mgcIconCeilingLampFilled } from './mgcIcon-ceiling_lamp_filled.icon';
import { mgcIconCellphone2AiFilled } from './mgcIcon-cellphone_2_ai_filled.icon';
import { mgcIconCellphone2Filled } from './mgcIcon-cellphone_2_filled.icon';
import { mgcIconCellphone2HorizontalFilled } from './mgcIcon-cellphone_2_horizontal_filled.icon';
import { mgcIconCellphoneFilled } from './mgcIcon-cellphone_filled.icon';
import { mgcIconCellphoneVibrationFilled } from './mgcIcon-cellphone_vibration_filled.icon';
import { mgcIconChipFilled } from './mgcIcon-chip_filled.icon';
import { mgcIconComputerCamerFilled } from './mgcIcon-computer_camer_filled.icon';
import { mgcIconComputerCameraOffFilled } from './mgcIcon-computer_camera_off_filled.icon';
import { mgcIconComputerFilled } from './mgcIcon-computer_filled.icon';
import { mgcIconCounter2Filled } from './mgcIcon-counter_2_filled.icon';
import { mgcIconCube3DFilled } from './mgcIcon-cube_3d_filled.icon';
import { mgcIconDashboard2Filled } from './mgcIcon-dashboard_2_filled.icon';
import { mgcIconDashboard3Filled } from './mgcIcon-dashboard_3_filled.icon';
import { mgcIconDashboard4Filled } from './mgcIcon-dashboard_4_filled.icon';
import { mgcIconDashboardFilled } from './mgcIcon-dashboard_filled.icon';
import { mgcIconDeskLamp2Filled } from './mgcIcon-desk_lamp_2_filled.icon';
import { mgcIconDeskLampFilled } from './mgcIcon-desk_lamp_filled.icon';
import { mgcIconDeviceFilled } from './mgcIcon-device_filled.icon';
import { mgcIconDisplayFilled } from './mgcIcon-display_filled.icon';
import { mgcIconDroneFilled } from './mgcIcon-drone_filled.icon';
import { mgcIconEscalatorDownFilled } from './mgcIcon-escalator_down_filled.icon';
import { mgcIconEscalatorUpFilled } from './mgcIcon-escalator_up_filled.icon';
import { mgcIconFaxFilled } from './mgcIcon-fax_filled.icon';
import { mgcIconFlashCircleFilled } from './mgcIcon-flash_circle_filled.icon';
import { mgcIconFlashFilled } from './mgcIcon-flash_filled.icon';
import { mgcIconFlashlightFilled } from './mgcIcon-flashlight_filled.icon';
import { mgcIconFridgeFilled } from './mgcIcon-fridge_filled.icon';
import { mgcIconGame1Filled } from './mgcIcon-game_1_filled.icon';
import { mgcIconGame2Filled } from './mgcIcon-game_2_filled.icon';
import { mgcIconGradienterFilled } from './mgcIcon-gradienter_filled.icon';
import { mgcIconGuitarFilled } from './mgcIcon-guitar_filled.icon';
import { mgcIconHighVoltagePowerFilled } from './mgcIcon-high_voltage_power_filled.icon';
import { mgcIconHomeWifiFilled } from './mgcIcon-home_wifi_filled.icon';
import { mgcIconHomepodFilled } from './mgcIcon-homepod_filled.icon';
import { mgcIconHomepodMiniFilled } from './mgcIcon-homepod_mini_filled.icon';
import { mgcIconIMacFilled } from './mgcIcon-iMac_filled.icon';
import { mgcIconInstrumentFilled } from './mgcIcon-instrument_filled.icon';
import { mgcIconKeyboard2Filled } from './mgcIcon-keyboard_2_filled.icon';
import { mgcIconKeyboardFilled } from './mgcIcon-keyboard_filled.icon';
import { mgcIconLaptop2Filled } from './mgcIcon-laptop_2_filled.icon';
import { mgcIconLaptopFilled } from './mgcIcon-laptop_filled.icon';
import { mgcIconLightFilled } from './mgcIcon-light_filled.icon';
import { mgcIconMicroscopeFilled } from './mgcIcon-microscope_filled.icon';
import { mgcIconMidiFilled } from './mgcIcon-midi_filled.icon';
import { mgcIconMonitorFilled } from './mgcIcon-monitor_filled.icon';
import { mgcIconMouseFilled } from './mgcIcon-mouse_filled.icon';
import { mgcIconPadFilled } from './mgcIcon-pad_filled.icon';
import { mgcIconPanoramasFilled } from './mgcIcon-panoramas_filled.icon';
import { mgcIconPlugin2Filled } from './mgcIcon-plugin_2_filled.icon';
import { mgcIconPluginFilled } from './mgcIcon-plugin_filled.icon';
import { mgcIconPrintFilled } from './mgcIcon-print_filled.icon';
import { mgcIconProjectorFilled } from './mgcIcon-projector_filled.icon';
import { mgcIconProjectorScreenFilled } from './mgcIcon-projector_screen_filled.icon';
import { mgcIconQrcode2Filled } from './mgcIcon-qrcode_2_filled.icon';
import { mgcIconQrcodeFilled } from './mgcIcon-qrcode_filled.icon';
import { mgcIconRadaFilled } from './mgcIcon-rada_filled.icon';
import { mgcIconRadar2Filled } from './mgcIcon-radar_2_filled.icon';
import { mgcIconRadioFilled } from './mgcIcon-radio_filled.icon';
import { mgcIconRemoteControlFilled } from './mgcIcon-remote_control_filled.icon';
import { mgcIconRemoteFilled } from './mgcIcon-remote_filled.icon';
import { mgcIconRouterModemFilled } from './mgcIcon-router_modem_filled.icon';
import { mgcIconRss2Filled } from './mgcIcon-rss_2_filled.icon';
import { mgcIconRssFilled } from './mgcIcon-rss_filled.icon';
import { mgcIconSandglass2Filled } from './mgcIcon-sandglass_2_filled.icon';
import { mgcIconSandglassFilled } from './mgcIcon-sandglass_filled.icon';
import { mgcIconScan2Filled } from './mgcIcon-scan_2_filled.icon';
import { mgcIconScanFilled } from './mgcIcon-scan_filled.icon';
import { mgcIconServer2Filled } from './mgcIcon-server_2_filled.icon';
import { mgcIconServerFilled } from './mgcIcon-server_filled.icon';
import { mgcIconShowerFilled } from './mgcIcon-shower_filled.icon';
import { mgcIconSignalFilled } from './mgcIcon-signal_filled.icon';
import { mgcIconSolarPanelFilled } from './mgcIcon-solar_panel_filled.icon';
import { mgcIconSpeakerFilled } from './mgcIcon-speaker_filled.icon';
import { mgcIconStopwatchFilled } from './mgcIcon-stopwatch_filled.icon';
import { mgcIconStorageFilled } from './mgcIcon-storage_filled.icon';
import { mgcIconTelescope2Filled } from './mgcIcon-telescope_2_filled.icon';
import { mgcIconTelescopeFilled } from './mgcIcon-telescope_filled.icon';
import { mgcIconTowerCraneFilled } from './mgcIcon-tower_crane_filled.icon';
import { mgcIconTv1Filled } from './mgcIcon-tv_1_filled.icon';
import { mgcIconTv2Filled } from './mgcIcon-tv_2_filled.icon';
import { mgcIconUsbFilled } from './mgcIcon-usb_filled.icon';
import { mgcIconUsbFlashDiskFilled } from './mgcIcon-usb_flash_disk_filled.icon';
import { mgcIconVisonProFilled } from './mgcIcon-vison_pro_filled.icon';
import { mgcIconWashMachineFilled } from './mgcIcon-wash_machine_filled.icon';
import { mgcIconWatch2Filled } from './mgcIcon-watch_2_filled.icon';
import { mgcIconWatchFilled } from './mgcIcon-watch_filled.icon';
import { mgcIconWifiFilled } from './mgcIcon-wifi_filled.icon';
import { mgcIconWifiOffFilled } from './mgcIcon-wifi_off_filled.icon';
import { mgcIconAlignCenterFilled } from './mgcIcon-align_center_filled.icon';
import { mgcIconAlignJustifyFilled } from './mgcIcon-align_justify_filled.icon';
import { mgcIconAlignLeftFilled } from './mgcIcon-align_left_filled.icon';
import { mgcIconAlignRightFilled } from './mgcIcon-align_right_filled.icon';
import { mgcIconAndFilled } from './mgcIcon-and_filled.icon';
import { mgcIconAsterisk2Filled } from './mgcIcon-asterisk_2_filled.icon';
import { mgcIconAsteriskFilled } from './mgcIcon-asterisk_filled.icon';
import { mgcIconAtFilled } from './mgcIcon-at_filled.icon';
import { mgcIconAzSortAscendingLettersFilled } from './mgcIcon-AZ_sort_ascending_letters_filled.icon';
import { mgcIconAzSortDescendingLettersFilled } from './mgcIcon-AZ_sort_descending_letters_filled.icon';
import { mgcIconBlockquoteFilled } from './mgcIcon-blockquote_filled.icon';
import { mgcIconBoldFilled } from './mgcIcon-bold_filled.icon';
import { mgcIconColumnFilled } from './mgcIcon-column_filled.icon';
import { mgcIconContentAiFilled } from './mgcIcon-content_ai_filled.icon';
import { mgcIconCursorTextFilled } from './mgcIcon-cursor_text_filled.icon';
import { mgcIconDividingLineFilled } from './mgcIcon-dividing_line_filled.icon';
import { mgcIconEdit2Filled } from './mgcIcon-edit_2_filled.icon';
import { mgcIconEdit3Filled } from './mgcIcon-edit_3_filled.icon';
import { mgcIconEdit4Filled } from './mgcIcon-edit_4_filled.icon';
import { mgcIconEditFilled } from './mgcIcon-edit_filled.icon';
import { mgcIconEraserFilled } from './mgcIcon-eraser_filled.icon';
import { mgcIconFontFilled } from './mgcIcon-font_filled.icon';
import { mgcIconFontSizeFilled } from './mgcIcon-font_size_filled.icon';
import { mgcIconFormulaFilled } from './mgcIcon-formula_filled.icon';
import { mgcIconFrameFilled } from './mgcIcon-frame_filled.icon';
import { mgcIconHashtagFilled } from './mgcIcon-hashtag_filled.icon';
import { mgcIconHeading1Filled } from './mgcIcon-heading_1_filled.icon';
import { mgcIconHeading2Filled } from './mgcIcon-heading_2_filled.icon';
import { mgcIconHeading3Filled } from './mgcIcon-heading_3_filled.icon';
import { mgcIconIndentDecreaseFilled } from './mgcIcon-indent_decrease_filled.icon';
import { mgcIconIndentIncreaseFilled } from './mgcIcon-indent_increase_filled.icon';
import { mgcIconItalicFilled } from './mgcIcon-italic_filled.icon';
import { mgcIconLetterSpacingFilled } from './mgcIcon-letter_spacing_filled.icon';
import { mgcIconLineHeightFilled } from './mgcIcon-line_height_filled.icon';
import { mgcIconListCheck2Filled } from './mgcIcon-list_check_2_filled.icon';
import { mgcIconListCheck3Filled } from './mgcIcon-list_check_3_filled.icon';
import { mgcIconListCheckFilled } from './mgcIcon-list_check_filled.icon';
import { mgcIconListCollapseFilled } from './mgcIcon-list_collapse_filled.icon';
import { mgcIconListExpansionFilled } from './mgcIcon-list_expansion_filled.icon';
import { mgcIconListOrderedFilled } from './mgcIcon-list_ordered_filled.icon';
import { mgcIconListSearchFilled } from './mgcIcon-list_search_filled.icon';
import { mgcIconMenuFilled } from './mgcIcon-menu_filled.icon';
import { mgcIconNumbers09SortAscendingFilled } from './mgcIcon-numbers_09_sort_ascending_filled.icon';
import { mgcIconNumbers09SortDescendingFilled } from './mgcIcon-numbers_09_sort_descending_filled.icon';
import { mgcIconNumbers90SortAscendingFilled } from './mgcIcon-numbers_90_sort_ascending_filled.icon';
import { mgcIconNumbers90SortDescendingFilled } from './mgcIcon-numbers_90_sort_descending_filled.icon';
import { mgcIconOmegaFilled } from './mgcIcon-omega_filled.icon';
import { mgcIconPaintFilled } from './mgcIcon-paint_filled.icon';
import { mgcIconParagraphFilled } from './mgcIcon-paragraph_filled.icon';
import { mgcIconPen2Filled } from './mgcIcon-pen_2_filled.icon';
import { mgcIconPencil2AiFilled } from './mgcIcon-pencil_2_ai_filled.icon';
import { mgcIconPencil2Filled } from './mgcIcon-pencil_2_filled.icon';
import { mgcIconPencil3Filled } from './mgcIcon-pencil_3_filled.icon';
import { mgcIconPencilFilled } from './mgcIcon-pencil_filled.icon';
import { mgcIconPencilRulerFilled } from './mgcIcon-pencil_ruler_filled.icon';
import { mgcIconQuoteLeftFilled } from './mgcIcon-quote_left_filled.icon';
import { mgcIconQuoteRightFilled } from './mgcIcon-quote_right_filled.icon';
import { mgcIconSignatureFilled } from './mgcIcon-signature_filled.icon';
import { mgcIconSortAscendingFilled } from './mgcIcon-sort_ascending_filled.icon';
import { mgcIconSortDescendingFilled } from './mgcIcon-sort_descending_filled.icon';
import { mgcIconSpaceFilled } from './mgcIcon-space_filled.icon';
import { mgcIconSpacingHorizontalFilled } from './mgcIcon-spacing_horizontal_filled.icon';
import { mgcIconSpacingVerticalFilled } from './mgcIcon-spacing_vertical_filled.icon';
import { mgcIconStrikethroughFilled } from './mgcIcon-strikethrough_filled.icon';
import { mgcIconSubtitleFilled } from './mgcIcon-subtitle_filled.icon';
import { mgcIconTable3Filled } from './mgcIcon-table_3_filled.icon';
import { mgcIconTableFilled } from './mgcIcon-table_filled.icon';
import { mgcIconText2Filled } from './mgcIcon-text_2_filled.icon';
import { mgcIconTextAreaFilled } from './mgcIcon-text_area_filled.icon';
import { mgcIconTextColorFilled } from './mgcIcon-text_color_filled.icon';
import { mgcIconTextDirectionLeftFilled } from './mgcIcon-text_direction_left_filled.icon';
import { mgcIconTextDirectionRightFilled } from './mgcIcon-text_direction_right_filled.icon';
import { mgcIconTextFilled } from './mgcIcon-text_filled.icon';
import { mgcIconTextboxAiFilled } from './mgcIcon-textbox_ai_filled.icon';
import { mgcIconTextboxFilled } from './mgcIcon-textbox_filled.icon';
import { mgcIconTranslate2AiFilled } from './mgcIcon-translate_2_ai_filled.icon';
import { mgcIconTranslate2Filled } from './mgcIcon-translate_2_filled.icon';
import { mgcIconTranslateFilled } from './mgcIcon-translate_filled.icon';
import { mgcIconUnderlineFilled } from './mgcIcon-underline_filled.icon';
import { mgcIconZaSortAscendingLettersFilled } from './mgcIcon-ZA_sort_ascending_letters_filled.icon';
import { mgcIconZaSortDescendingLettersFilled } from './mgcIcon-ZA_sort_descending_letters_filled.icon';
import { mgcIconBackpackFilled } from './mgcIcon-backpack_filled.icon';
import { mgcIconBalanceFilled } from './mgcIcon-balance_filled.icon';
import { mgcIconBlackBoard2Filled } from './mgcIcon-black_board_2_filled.icon';
import { mgcIconBlackBoardFilled } from './mgcIcon-black_board_filled.icon';
import { mgcIconBook2Filled } from './mgcIcon-book_2_filled.icon';
import { mgcIconBook3Filled } from './mgcIcon-book_3_filled.icon';
import { mgcIconBook4Filled } from './mgcIcon-book_4_filled.icon';
import { mgcIconBook5Filled } from './mgcIcon-book_5_filled.icon';
import { mgcIconBook6Filled } from './mgcIcon-book_6_filled.icon';
import { mgcIconBookFilled } from './mgcIcon-book_filled.icon';
import { mgcIconBookmarkAddFilled } from './mgcIcon-bookmark_add_filled.icon';
import { mgcIconBookmarkEditFilled } from './mgcIcon-bookmark_edit_filled.icon';
import { mgcIconBookmarkFilled } from './mgcIcon-bookmark_filled.icon';
import { mgcIconBookmarkRemoveFilled } from './mgcIcon-bookmark_remove_filled.icon';
import { mgcIconBookmarksFilled } from './mgcIcon-bookmarks_filled.icon';
import { mgcIconCertificate2Filled } from './mgcIcon-certificate_2_filled.icon';
import { mgcIconCompass2Filled } from './mgcIcon-compass_2_filled.icon';
import { mgcIconCounterFilled } from './mgcIcon-counter_filled.icon';
import { mgcIconDeskFilled } from './mgcIcon-desk_filled.icon';
import { mgcIconDiaryFilled } from './mgcIcon-diary_filled.icon';
import { mgcIconDrumFilled } from './mgcIcon-drum_filled.icon';
import { mgcIconEyeglassFilled } from './mgcIcon-eyeglass_filled.icon';
import { mgcIconFlask2Filled } from './mgcIcon-flask_2_filled.icon';
import { mgcIconFlask3Filled } from './mgcIcon-flask_3_filled.icon';
import { mgcIconFlaskFilled } from './mgcIcon-flask_filled.icon';
import { mgcIconFoldingFanFilled } from './mgcIcon-folding_fan_filled.icon';
import { mgcIconGlobeFilled } from './mgcIcon-globe_filled.icon';
import { mgcIconMagnetFilled } from './mgcIcon-magnet_filled.icon';
import { mgcIconMortarboardFilled } from './mgcIcon-mortarboard_filled.icon';
import { mgcIconNotebook2Filled } from './mgcIcon-notebook_2_filled.icon';
import { mgcIconNotebookFilled } from './mgcIcon-notebook_filled.icon';
import { mgcIconScienceFilled } from './mgcIcon-science_filled.icon';
import { mgcIconSpeechFilled } from './mgcIcon-speech_filled.icon';
import { mgcIconTestTubeFilled } from './mgcIcon-test_tube_filled.icon';
import { mgcIconAngelFilled } from './mgcIcon-angel_filled.icon';
import { mgcIconAngryFilled } from './mgcIcon-angry_filled.icon';
import { mgcIconConfusedFilled } from './mgcIcon-confused_filled.icon';
import { mgcIconEmoji2Filled } from './mgcIcon-emoji_2_filled.icon';
import { mgcIconEmojiFilled } from './mgcIcon-emoji_filled.icon';
import { mgcIconHappyFilled } from './mgcIcon-happy_filled.icon';
import { mgcIconLaughFilled } from './mgcIcon-laugh_filled.icon';
import { mgcIconLookDownFilled } from './mgcIcon-look_down_filled.icon';
import { mgcIconLookLeftFilled } from './mgcIcon-look_left_filled.icon';
import { mgcIconLookRightFilled } from './mgcIcon-look_right_filled.icon';
import { mgcIconLookUpFilled } from './mgcIcon-look_up_filled.icon';
import { mgcIconOmgFilled } from './mgcIcon-omg_filled.icon';
import { mgcIconPuzzledFilled } from './mgcIcon-puzzled_filled.icon';
import { mgcIconSadFilled } from './mgcIcon-sad_filled.icon';
import { mgcIconSickFilled } from './mgcIcon-sick_filled.icon';
import { mgcIconSilentFilled } from './mgcIcon-silent_filled.icon';
import { mgcIconSobFilled } from './mgcIcon-sob_filled.icon';
import { mgcIconSurpriseFilled } from './mgcIcon-surprise_filled.icon';
import { mgcIconSweatsFilled } from './mgcIcon-sweats_filled.icon';
import { mgcIconTerrorFilled } from './mgcIcon-terror_filled.icon';
import { mgcIconTongueFilled } from './mgcIcon-tongue_filled.icon';
import { mgcIconUnhappyDizzyFilled } from './mgcIcon-unhappy_dizzy_filled.icon';
import { mgcIconUnhappyFilled } from './mgcIcon-unhappy_filled.icon';
import { mgcIconAlbum2Filled } from './mgcIcon-album_2_filled.icon';
import { mgcIconArchiveFilled } from './mgcIcon-archive_filled.icon';
import { mgcIconAttachment2Filled } from './mgcIcon-attachment_2_filled.icon';
import { mgcIconAttachmentFilled } from './mgcIcon-attachment_filled.icon';
import { mgcIconBill2Filled } from './mgcIcon-bill_2_filled.icon';
import { mgcIconBillFilled } from './mgcIcon-bill_filled.icon';
import { mgcIconBox2Filled } from './mgcIcon-box_2_filled.icon';
import { mgcIconBox3Filled } from './mgcIcon-box_3_filled.icon';
import { mgcIconBoxFilled } from './mgcIcon-box_filled.icon';
import { mgcIconClipboardFilled } from './mgcIcon-clipboard_filled.icon';
import { mgcIconCopy2Filled } from './mgcIcon-copy_2_filled.icon';
import { mgcIconCopy3Filled } from './mgcIcon-copy_3_filled.icon';
import { mgcIconCopyFilled } from './mgcIcon-copy_filled.icon';
import { mgcIconDocFilled } from './mgcIcon-doc_filled.icon';
import { mgcIconDocmentFilled } from './mgcIcon-docment_filled.icon';
import { mgcIconDocument2Filled } from './mgcIcon-document_2_filled.icon';
import { mgcIconDocument3Filled } from './mgcIcon-document_3_filled.icon';
import { mgcIconDocumentsFilled } from './mgcIcon-documents_filled.icon';
import { mgcIconDownload2Filled } from './mgcIcon-download_2_filled.icon';
import { mgcIconDownload3Filled } from './mgcIcon-download_3_filled.icon';
import { mgcIconDownloadFilled } from './mgcIcon-download_filled.icon';
import { mgcIconEmptyBoxFilled } from './mgcIcon-empty_box_filled.icon';
import { mgcIconExternalLinkFilled } from './mgcIcon-external_link_filled.icon';
import { mgcIconFileCertificateFilled } from './mgcIcon-file_certificate_filled.icon';
import { mgcIconFileCheckFilled } from './mgcIcon-file_check_filled.icon';
import { mgcIconFileCodeFilled } from './mgcIcon-file_code_filled.icon';
import { mgcIconFileDownloadFilled } from './mgcIcon-file_download_filled.icon';
import { mgcIconFileExportFilled } from './mgcIcon-file_export_filled.icon';
import { mgcIconFileFilled } from './mgcIcon-file_filled.icon';
import { mgcIconFileForbidFilled } from './mgcIcon-file_forbid_filled.icon';
import { mgcIconFileImportFilled } from './mgcIcon-file_import_filled.icon';
import { mgcIconFileInfoFilled } from './mgcIcon-file_info_filled.icon';
import { mgcIconFileLockedFilled } from './mgcIcon-file_locked_filled.icon';
import { mgcIconFileMoreFilled } from './mgcIcon-file_more_filled.icon';
import { mgcIconFileMusicFilled } from './mgcIcon-file_music_filled.icon';
import { mgcIconFileNewFilled } from './mgcIcon-file_new_filled.icon';
import { mgcIconFileSearchFilled } from './mgcIcon-file_search_filled.icon';
import { mgcIconFileSecurityFilled } from './mgcIcon-file_security_filled.icon';
import { mgcIconFileStarFilled } from './mgcIcon-file_star_filled.icon';
import { mgcIconFileUnknownFilled } from './mgcIcon-file_unknown_filled.icon';
import { mgcIconFileUploadFilled } from './mgcIcon-file_upload_filled.icon';
import { mgcIconFileWarningFilled } from './mgcIcon-file_warning_filled.icon';
import { mgcIconFileZipFilled } from './mgcIcon-file_zip_filled.icon';
import { mgcIconFolder2Filled } from './mgcIcon-folder_2_filled.icon';
import { mgcIconFolder3Filled } from './mgcIcon-folder_3_filled.icon';
import { mgcIconFolderCheckFilled } from './mgcIcon-folder_check_filled.icon';
import { mgcIconFolderDeleteFilled } from './mgcIcon-folder_delete_filled.icon';
import { mgcIconFolderDownloadFilled } from './mgcIcon-folder_download_filled.icon';
import { mgcIconFolderFilled } from './mgcIcon-folder_filled.icon';
import { mgcIconFolderForbidFilled } from './mgcIcon-folder_forbid_filled.icon';
import { mgcIconFolderInfoFilled } from './mgcIcon-folder_info_filled.icon';
import { mgcIconFolderLocked2Filled } from './mgcIcon-folder_locked_2_filled.icon';
import { mgcIconFolderLockedFilled } from './mgcIcon-folder_locked_filled.icon';
import { mgcIconFolderMinusFilled } from './mgcIcon-folder_minus_filled.icon';
import { mgcIconFolderMoreFilled } from './mgcIcon-folder_more_filled.icon';
import { mgcIconFolderOpen2Filled } from './mgcIcon-folder_open_2_filled.icon';
import { mgcIconFolderOpenFilled } from './mgcIcon-folder_open_filled.icon';
import { mgcIconFolderSecurityFilled } from './mgcIcon-folder_security_filled.icon';
import { mgcIconFolderStarFilled } from './mgcIcon-folder_star_filled.icon';
import { mgcIconFolderUploadFilled } from './mgcIcon-folder_upload_filled.icon';
import { mgcIconFolderWarningFilled } from './mgcIcon-folder_warning_filled.icon';
import { mgcIconFolderZipFilled } from './mgcIcon-folder_zip_filled.icon';
import { mgcIconFoldersFilled } from './mgcIcon-folders_filled.icon';
import { mgcIconInbox2Filled } from './mgcIcon-inbox_2_filled.icon';
import { mgcIconInboxFilled } from './mgcIcon-inbox_filled.icon';
import { mgcIconInventoryFilled } from './mgcIcon-inventory_filled.icon';
import { mgcIconLink2Filled } from './mgcIcon-link_2_filled.icon';
import { mgcIconLink3Filled } from './mgcIcon-link_3_filled.icon';
import { mgcIconLinkFilled } from './mgcIcon-link_filled.icon';
import { mgcIconMarkdownFilled } from './mgcIcon-markdown_filled.icon';
import { mgcIconNewFolderFilled } from './mgcIcon-new_folder_filled.icon';
import { mgcIconNews2Filled } from './mgcIcon-news_2_filled.icon';
import { mgcIconNewsFilled } from './mgcIcon-news_filled.icon';
import { mgcIconPackage2Filled } from './mgcIcon-package_2_filled.icon';
import { mgcIconPackageFilled } from './mgcIcon-package_filled.icon';
import { mgcIconPaper2Filled } from './mgcIcon-paper_2_filled.icon';
import { mgcIconPaperFilled } from './mgcIcon-paper_filled.icon';
import { mgcIconPassportFilled } from './mgcIcon-passport_filled.icon';
import { mgcIconPasteFilled } from './mgcIcon-paste_filled.icon';
import { mgcIconPdfFilled } from './mgcIcon-pdf_filled.icon';
import { mgcIconPhotoAlbum2Filled } from './mgcIcon-photo_album_2_filled.icon';
import { mgcIconPhotoAlbumFilled } from './mgcIcon-photo_album_filled.icon';
import { mgcIconPic2Filled } from './mgcIcon-pic_2_filled.icon';
import { mgcIconPicAiFilled } from './mgcIcon-pic_ai_filled.icon';
import { mgcIconPicFilled } from './mgcIcon-pic_filled.icon';
import { mgcIconPin2Filled } from './mgcIcon-pin_2_filled.icon';
import { mgcIconPinFilled } from './mgcIcon-pin_filled.icon';
import { mgcIconPptFilled } from './mgcIcon-ppt_filled.icon';
import { mgcIconProfileFilled } from './mgcIcon-profile_filled.icon';
import { mgcIconReportFormsFilled } from './mgcIcon-report_forms_filled.icon';
import { mgcIconSave2Filled } from './mgcIcon-save_2_filled.icon';
import { mgcIconSaveFilled } from './mgcIcon-save_filled.icon';
import { mgcIconSearch2Filled } from './mgcIcon-search_2_filled.icon';
import { mgcIconSearch3Filled } from './mgcIcon-search_3_filled.icon';
import { mgcIconSearchAiFilled } from './mgcIcon-search_ai_filled.icon';
import { mgcIconSearchFilled } from './mgcIcon-search_filled.icon';
import { mgcIconTask2Filled } from './mgcIcon-task_2_filled.icon';
import { mgcIconTaskFilled } from './mgcIcon-task_filled.icon';
import { mgcIconToDoFilled } from './mgcIcon-to_do_filled.icon';
import { mgcIconUnarchiveFilled } from './mgcIcon-unarchive_filled.icon';
import { mgcIconUnlink2Filled } from './mgcIcon-unlink_2_filled.icon';
import { mgcIconUnlinkFilled } from './mgcIcon-unlink_filled.icon';
import { mgcIconUpload2Filled } from './mgcIcon-upload_2_filled.icon';
import { mgcIconUpload3Filled } from './mgcIcon-upload_3_filled.icon';
import { mgcIconUploadFilled } from './mgcIcon-upload_filled.icon';
import { mgcIconXlsFilled } from './mgcIcon-xls_filled.icon';
import { mgcIconZoomInFilled } from './mgcIcon-zoom_in_filled.icon';
import { mgcIconZoomOutFilled } from './mgcIcon-zoom_out_filled.icon';
import { mgcIconBirthday2Filled } from './mgcIcon-birthday_2_filled.icon';
import { mgcIconBoneFilled } from './mgcIcon-bone_filled.icon';
import { mgcIconBottleGlassFilled } from './mgcIcon-bottle_glass_filled.icon';
import { mgcIconBowl2Filled } from './mgcIcon-bowl_2_filled.icon';
import { mgcIconBowlFilled } from './mgcIcon-bowl_filled.icon';
import { mgcIconBreadFilled } from './mgcIcon-bread_filled.icon';
import { mgcIconCakeFilled } from './mgcIcon-cake_filled.icon';
import { mgcIconCandy2Filled } from './mgcIcon-candy_2_filled.icon';
import { mgcIconCandyFilled } from './mgcIcon-candy_filled.icon';
import { mgcIconCarrotFilled } from './mgcIcon-carrot_filled.icon';
import { mgcIconChampagneFilled } from './mgcIcon-champagne_filled.icon';
import { mgcIconChickenFilled } from './mgcIcon-chicken_filled.icon';
import { mgcIconChopsticksFilled } from './mgcIcon-chopsticks_filled.icon';
import { mgcIconCookieFilled } from './mgcIcon-cookie_filled.icon';
import { mgcIconCookieManFilled } from './mgcIcon-cookie_man_filled.icon';
import { mgcIconCupcakeFilled } from './mgcIcon-cupcake_filled.icon';
import { mgcIconDinnerFilled } from './mgcIcon-dinner_filled.icon';
import { mgcIconDishCoverFilled } from './mgcIcon-dish_cover_filled.icon';
import { mgcIconDonutFilled } from './mgcIcon-donut_filled.icon';
import { mgcIconDrinkFilled } from './mgcIcon-drink_filled.icon';
import { mgcIconEggCrackFilled } from './mgcIcon-egg_crack_filled.icon';
import { mgcIconEggFilled } from './mgcIcon-egg_filled.icon';
import { mgcIconElectricCookerFilled } from './mgcIcon-electric_cooker_filled.icon';
import { mgcIconFeederFilled } from './mgcIcon-feeder_filled.icon';
import { mgcIconFishFilled } from './mgcIcon-fish_filled.icon';
import { mgcIconForkFilled } from './mgcIcon-fork_filled.icon';
import { mgcIconForkKnifeFilled } from './mgcIcon-fork_knife_filled.icon';
import { mgcIconForkSpoonFilled } from './mgcIcon-fork_spoon_filled.icon';
import { mgcIconFriedEggFilled } from './mgcIcon-fried_egg_filled.icon';
import { mgcIconFriesFilled } from './mgcIcon-fries_filled.icon';
import { mgcIconGlassCupFilled } from './mgcIcon-glass_cup_filled.icon';
import { mgcIconHamburgerFilled } from './mgcIcon-hamburger_filled.icon';
import { mgcIconIceCream2Filled } from './mgcIcon-ice_cream_2_filled.icon';
import { mgcIconIceCreamFilled } from './mgcIcon-ice_cream_filled.icon';
import { mgcIconLollipopFilled } from './mgcIcon-lollipop_filled.icon';
import { mgcIconPizzaFilled } from './mgcIcon-pizza_filled.icon';
import { mgcIconSoupPot2Filled } from './mgcIcon-soup_pot_2_filled.icon';
import { mgcIconSoupPotFilled } from './mgcIcon-soup_pot_filled.icon';
import { mgcIconSpatulaFilled } from './mgcIcon-spatula_filled.icon';
import { mgcIconSpoonFilled } from './mgcIcon-spoon_filled.icon';
import { mgcIconSugarCoatedHawsFilled } from './mgcIcon-sugar_coated_haws_filled.icon';
import { mgcIconTeacupFilled } from './mgcIcon-teacup_filled.icon';
import { mgcIconWineFilled } from './mgcIcon-wine_filled.icon';
import { mgcIconWineglass2Filled } from './mgcIcon-wineglass_2_filled.icon';
import { mgcIconWineglassFilled } from './mgcIcon-wineglass_filled.icon';
import { mgcIconAirbnbFilled } from './mgcIcon-airbnb_filled.icon';
import { mgcIconAirdropFilled } from './mgcIcon-airdrop_filled.icon';
import { mgcIconAlipayFilled } from './mgcIcon-alipay_filled.icon';
import { mgcIconAndroid2Filled } from './mgcIcon-Android_2_filled.icon';
import { mgcIconAndroidFilled } from './mgcIcon-android_filled.icon';
import { mgcIconAppleFilled } from './mgcIcon-apple_filled.icon';
import { mgcIconAppleIntelligenceFilled } from './mgcIcon-apple_intelligence_filled.icon';
import { mgcIconAppleIntelligenceFrameFilled } from './mgcIcon-apple_intelligence_frame_filled.icon';
import { mgcIconAppstoreFilled } from './mgcIcon-appstore_filled.icon';
import { mgcIconArcBrowserFilled } from './mgcIcon-arc_browser_filled.icon';
import { mgcIconBehanceFilled } from './mgcIcon-behance_filled.icon';
import { mgcIconBilibiliFilled } from './mgcIcon-bilibili_filled.icon';
import { mgcIconBlueskeySocialFilled } from './mgcIcon-blueskey_social_filled.icon';
import { mgcIconCarplayFilled } from './mgcIcon-carplay_filled.icon';
import { mgcIconChromeFilled } from './mgcIcon-chrome_filled.icon';
import { mgcIconCodepenFilled } from './mgcIcon-codepen_filled.icon';
import { mgcIconCopilotFilled } from './mgcIcon-copilot_filled.icon';
import { mgcIconDingtalkFilled } from './mgcIcon-dingtalk_filled.icon';
import { mgcIconDiscordFilled } from './mgcIcon-discord_filled.icon';
import { mgcIconDribbbleFilled } from './mgcIcon-dribbble_filled.icon';
import { mgcIconDriveFilled } from './mgcIcon-drive_filled.icon';
import { mgcIconDropboxFilled } from './mgcIcon-dropbox_filled.icon';
import { mgcIconEdgeFilled } from './mgcIcon-edge_filled.icon';
import { mgcIconFacebookFilled } from './mgcIcon-facebook_filled.icon';
import { mgcIconFigmaFilled } from './mgcIcon-figma_filled.icon';
import { mgcIconFirefoxFilled } from './mgcIcon-firefox_filled.icon';
import { mgcIconFollowFilled } from './mgcIcon-follow_filled.icon';
import { mgcIconGitLabFilled } from './mgcIcon-git_lab_filled.icon';
import { mgcIconGithub2Filled } from './mgcIcon-github_2_filled.icon';
import { mgcIconGithubFilled } from './mgcIcon-github_filled.icon';
import { mgcIconGoogleFilled } from './mgcIcon-google_filled.icon';
import { mgcIconGooglePlayFilled } from './mgcIcon-google_play_filled.icon';
import { mgcIconGrokFilled } from './mgcIcon-grok_filled.icon';
import { mgcIconGumroadFilled } from './mgcIcon-gumroad_filled.icon';
import { mgcIconInstagramFilled } from './mgcIcon-instagram_filled.icon';
import { mgcIconKakaoTalkFilled } from './mgcIcon-kakao_talk_filled.icon';
import { mgcIconLayersFilled } from './mgcIcon-layers_filled.icon';
import { mgcIconLemonSqueezyFilled } from './mgcIcon-lemon_squeezy_filled.icon';
import { mgcIconLineAppFilled } from './mgcIcon-line_app_filled.icon';
import { mgcIconLinearFilled } from './mgcIcon-linear_filled.icon';
import { mgcIconLinkedinFilled } from './mgcIcon-linkedin_filled.icon';
import { mgcIconLinuxFilled } from './mgcIcon-linux_filled.icon';
import { mgcIconMastercardFilled } from './mgcIcon-mastercard_filled.icon';
import { mgcIconMastodonFilled } from './mgcIcon-mastodon_filled.icon';
import { mgcIconMediumFilled } from './mgcIcon-medium_filled.icon';
import { mgcIconMessengerFilled } from './mgcIcon-messenger_filled.icon';
import { mgcIconMetaFilled } from './mgcIcon-meta_filled.icon';
import { mgcIconMingcuteFilled } from './mgcIcon-mingcute_filled.icon';
import { mgcIconMomentFilled } from './mgcIcon-moment_filled.icon';
import { mgcIconNeteaseMusicFilled } from './mgcIcon-netease_music_filled.icon';
import { mgcIconNfcFilled } from './mgcIcon-nfc_filled.icon';
import { mgcIconNintendoSwitchFilled } from './mgcIcon-nintendo_switch_filled.icon';
import { mgcIconNotionFilled } from './mgcIcon-notion_filled.icon';
import { mgcIconOpenaiFilled } from './mgcIcon-openai_filled.icon';
import { mgcIconPaypalFilled } from './mgcIcon-paypal_filled.icon';
import { mgcIconPinterestFilled } from './mgcIcon-pinterest_filled.icon';
import { mgcIconQqFilled } from './mgcIcon-qq_filled.icon';
import { mgcIconReactFilled } from './mgcIcon-react_filled.icon';
import { mgcIconRedditFilled } from './mgcIcon-reddit_filled.icon';
import { mgcIconSafariFilled } from './mgcIcon-safari_filled.icon';
import { mgcIconSiriFilled } from './mgcIcon-siri_filled.icon';
import { mgcIconSiriFrameFilled } from './mgcIcon-siri_frame_filled.icon';
import { mgcIconSnapchatFilled } from './mgcIcon-snapchat_filled.icon';
import { mgcIconSocialXFilled } from './mgcIcon-social_x_filled.icon';
import { mgcIconSpotifyFilled } from './mgcIcon-spotify_filled.icon';
import { mgcIconStripeFilled } from './mgcIcon-stripe_filled.icon';
import { mgcIconTelegramFilled } from './mgcIcon-telegram_filled.icon';
import { mgcIconThreadsFilled } from './mgcIcon-threads_filled.icon';
import { mgcIconTiktokFilled } from './mgcIcon-tiktok_filled.icon';
import { mgcIconTrelloBoardFilled } from './mgcIcon-trello_board_filled.icon';
import { mgcIconTwitterFilled } from './mgcIcon-twitter_filled.icon';
import { mgcIconViberMessengerFilled } from './mgcIcon-viber_messenger_filled.icon';
import { mgcIconVisaFilled } from './mgcIcon-visa_filled.icon';
import { mgcIconVkontakteFilled } from './mgcIcon-vkontakte_filled.icon';
import { mgcIconVscodeFilled } from './mgcIcon-vscode_filled.icon';
import { mgcIconVueFilled } from './mgcIcon-vue_filled.icon';
import { mgcIconWechatFilled } from './mgcIcon-wechat_filled.icon';
import { mgcIconWechatMiniprogramFilled } from './mgcIcon-wechat_miniprogram_filled.icon';
import { mgcIconWechatPayFilled } from './mgcIcon-wechat_pay_filled.icon';
import { mgcIconWeiboFilled } from './mgcIcon-weibo_filled.icon';
import { mgcIconWhatsappFilled } from './mgcIcon-whatsapp_filled.icon';
import { mgcIconWindowsFilled } from './mgcIcon-windows_filled.icon';
import { mgcIconXboxFilled } from './mgcIcon-xbox_filled.icon';
import { mgcIconYoutubeFilled } from './mgcIcon-youtube_filled.icon';
import { mgcIconAiming2Filled } from './mgcIcon-aiming_2_filled.icon';
import { mgcIconAimingFilled } from './mgcIcon-aiming_filled.icon';
import { mgcIconAnchorFilled } from './mgcIcon-anchor_filled.icon';
import { mgcIconBed2Filled } from './mgcIcon-bed_2_filled.icon';
import { mgcIconBedFilled } from './mgcIcon-bed_filled.icon';
import { mgcIconClock2Filled } from './mgcIcon-clock_2_filled.icon';
import { mgcIconClockFilled } from './mgcIcon-clock_filled.icon';
import { mgcIconCompass3Filled } from './mgcIcon-compass_3_filled.icon';
import { mgcIconCompassFilled } from './mgcIcon-compass_filled.icon';
import { mgcIconDirections2Filled } from './mgcIcon-directions_2_filled.icon';
import { mgcIconDirectionsFilled } from './mgcIcon-directions_filled.icon';
import { mgcIconEarth2Filled } from './mgcIcon-earth_2_filled.icon';
import { mgcIconEarth3Filled } from './mgcIcon-earth_3_filled.icon';
import { mgcIconEarthFilled } from './mgcIcon-earth_filled.icon';
import { mgcIconEarthLatitudeFilled } from './mgcIcon-earth_latitude_filled.icon';
import { mgcIconEarthLongitudeFilled } from './mgcIcon-earth_longitude_filled.icon';
import { mgcIconFootFilled } from './mgcIcon-foot_filled.icon';
import { mgcIconGlobe2Filled } from './mgcIcon-globe_2_filled.icon';
import { mgcIconHoursFilled } from './mgcIcon-hours_filled.icon';
import { mgcIconLifebuoyFilled } from './mgcIcon-lifebuoy_filled.icon';
import { mgcIconLiveLocationFilled } from './mgcIcon-live_location_filled.icon';
import { mgcIconLocation2Filled } from './mgcIcon-location_2_filled.icon';
import { mgcIconLocation3Filled } from './mgcIcon-location_3_filled.icon';
import { mgcIconLocationFilled } from './mgcIcon-location_filled.icon';
import { mgcIconMap2Filled } from './mgcIcon-map_2_filled.icon';
import { mgcIconMapFilled } from './mgcIcon-map_filled.icon';
import { mgcIconMapPinFilled } from './mgcIcon-map_pin_filled.icon';
import { mgcIconNavigationFilled } from './mgcIcon-navigation_filled.icon';
import { mgcIconParkingFilled } from './mgcIcon-parking_filled.icon';
import { mgcIconPlanetFilled } from './mgcIcon-planet_filled.icon';
import { mgcIconRestAreaFilled } from './mgcIcon-rest_area_filled.icon';
import { mgcIconRoadFilled } from './mgcIcon-road_filled.icon';
import { mgcIconRouteFilled } from './mgcIcon-route_filled.icon';
import { mgcIconTrafficConeFilled } from './mgcIcon-traffic_cone_filled.icon';
import { mgcIconTunnelFilled } from './mgcIcon-tunnel_filled.icon';
import { mgcIconUmbrella2Filled } from './mgcIcon-umbrella_2_filled.icon';
import { mgcIconWorld2Filled } from './mgcIcon-world_2_filled.icon';
import { mgcIconWorldFilled } from './mgcIcon-world_filled.icon';
import { mgcIconAirpodsFilled } from './mgcIcon-airpods_filled.icon';
import { mgcIconAlbumFilled } from './mgcIcon-album_filled.icon';
import { mgcIconAnnouncementFilled } from './mgcIcon-announcement_filled.icon';
import { mgcIconAudioTapeFilled } from './mgcIcon-audio_tape_filled.icon';
import { mgcIconBellRingingFilled } from './mgcIcon-bell_ringing_filled.icon';
import { mgcIconCamcorder3Filled } from './mgcIcon-camcorder_3_filled.icon';
import { mgcIconCamcorderFilled } from './mgcIcon-camcorder_filled.icon';
import { mgcIconCamcorderOffFilled } from './mgcIcon-camcorder_off_filled.icon';
import { mgcIconCamera2AiFilled } from './mgcIcon-camera_2_ai_filled.icon';
import { mgcIconCamera2Filled } from './mgcIcon-camera_2_filled.icon';
import { mgcIconCamera2OffFilled } from './mgcIcon-camera_2_off_filled.icon';
import { mgcIconCameraFilled } from './mgcIcon-camera_filled.icon';
import { mgcIconCameraRotateFilled } from './mgcIcon-camera_rotate_filled.icon';
import { mgcIconClapperboardFilled } from './mgcIcon-clapperboard_filled.icon';
import { mgcIconDanmakuFilled } from './mgcIcon-danmaku_filled.icon';
import { mgcIconDanmakuOffFilled } from './mgcIcon-danmaku_off_filled.icon';
import { mgcIconDanmakuOnFilled } from './mgcIcon-danmaku_on_filled.icon';
import { mgcIconDiscFilled } from './mgcIcon-disc_filled.icon';
import { mgcIconExpandPlayerFilled } from './mgcIcon-expand_player_filled.icon';
import { mgcIconFastForwardFilled } from './mgcIcon-fast_forward_filled.icon';
import { mgcIconFastRewindFilled } from './mgcIcon-fast_rewind_filled.icon';
import { mgcIconFilmFilled } from './mgcIcon-film_filled.icon';
import { mgcIconFullscreenExitFilled } from './mgcIcon-fullscreen_exit_filled.icon';
import { mgcIconFullscreenFilled } from './mgcIcon-fullscreen_filled.icon';
import { mgcIconHeadphone2Filled } from './mgcIcon-headphone_2_filled.icon';
import { mgcIconHeadphoneFilled } from './mgcIcon-headphone_filled.icon';
import { mgcIconHorn2Filled } from './mgcIcon-horn_2_filled.icon';
import { mgcIconHornFilled } from './mgcIcon-horn_filled.icon';
import { mgcIconLiveFilled } from './mgcIcon-live_filled.icon';
import { mgcIconLivePhotoFilled } from './mgcIcon-live_photo_filled.icon';
import { mgcIconMic2Filled } from './mgcIcon-mic_2_filled.icon';
import { mgcIconMicAiFilled } from './mgcIcon-mic_ai_filled.icon';
import { mgcIconMicFilled } from './mgcIcon-mic_filled.icon';
import { mgcIconMicOffFilled } from './mgcIcon-mic_off_filled.icon';
import { mgcIconMicrophoneFilled } from './mgcIcon-microphone_filled.icon';
import { mgcIconMiniplayerFilled } from './mgcIcon-miniplayer_filled.icon';
import { mgcIconMovieFilled } from './mgcIcon-movie_filled.icon';
import { mgcIconMusic2AiFilled } from './mgcIcon-music_2_ai_filled.icon';
import { mgcIconMusic2Filled } from './mgcIcon-music_2_filled.icon';
import { mgcIconMusic3Filled } from './mgcIcon-music_3_filled.icon';
import { mgcIconMusicFilled } from './mgcIcon-music_filled.icon';
import { mgcIconNotificationFilled } from './mgcIcon-notification_filled.icon';
import { mgcIconNotificationNewdotFilled } from './mgcIcon-notification_newdot_filled.icon';
import { mgcIconNotificationOffFilled } from './mgcIcon-notification_off_filled.icon';
import { mgcIconPauseCircleFilled } from './mgcIcon-pause_circle_filled.icon';
import { mgcIconPauseFilled } from './mgcIcon-pause_filled.icon';
import { mgcIconPlayCircleFilled } from './mgcIcon-play_circle_filled.icon';
import { mgcIconPlayFilled } from './mgcIcon-play_filled.icon';
import { mgcIconPlaylist2Filled } from './mgcIcon-playlist_2_filled.icon';
import { mgcIconPlaylistFilled } from './mgcIcon-playlist_filled.icon';
import { mgcIconRecordMailFilled } from './mgcIcon-record_mail_filled.icon';
import { mgcIconRepeatFilled } from './mgcIcon-repeat_filled.icon';
import { mgcIconRepeatOneFilled } from './mgcIcon-repeat_one_filled.icon';
import { mgcIconRewindBackward10Filled } from './mgcIcon-rewind_backward_10_filled.icon';
import { mgcIconRewindBackward15Filled } from './mgcIcon-rewind_backward_15_filled.icon';
import { mgcIconRewindBackward30Filled } from './mgcIcon-rewind_backward_30_filled.icon';
import { mgcIconRewindBackward5Filled } from './mgcIcon-rewind_backward_5_filled.icon';
import { mgcIconRewindBackwardSquare10Filled } from './mgcIcon-rewind_backward_square_10_filled.icon';
import { mgcIconRewindBackwardSquare15Filled } from './mgcIcon-rewind_backward_square_15_filled.icon';
import { mgcIconRewindBackwardSquare30Filled } from './mgcIcon-rewind_backward_square_30_filled.icon';
import { mgcIconRewindBackwardSquare5Filled } from './mgcIcon-rewind_backward_square_5_filled.icon';
import { mgcIconRewindForward10Filled } from './mgcIcon-rewind_forward_10_filled.icon';
import { mgcIconRewindForward15Filled } from './mgcIcon-rewind_forward_15_filled.icon';
import { mgcIconRewindForward30Filled } from './mgcIcon-rewind_forward_30_filled.icon';
import { mgcIconRewindForward5Filled } from './mgcIcon-rewind_forward_5_filled.icon';
import { mgcIconRewindForwardSquare10Filled } from './mgcIcon-rewind_forward_square_10_filled.icon';
import { mgcIconRewindForwardSquare15Filled } from './mgcIcon-rewind_forward_square_15_filled.icon';
import { mgcIconRewindForwardSquare30Filled } from './mgcIcon-rewind_forward_square_30_filled.icon';
import { mgcIconRewindForwardSquare5Filled } from './mgcIcon-rewind_forward_square_5_filled.icon';
import { mgcIconRotateToHorizontalFilled } from './mgcIcon-rotate_to_horizontal_filled.icon';
import { mgcIconRotateToVerticalFilled } from './mgcIcon-rotate_to_vertical_filled.icon';
import { mgcIconServiceFilled } from './mgcIcon-service_filled.icon';
import { mgcIconShuffle2Filled } from './mgcIcon-shuffle_2_filled.icon';
import { mgcIconShuffleFilled } from './mgcIcon-shuffle_filled.icon';
import { mgcIconSkipForwardFilled } from './mgcIcon-skip_forward_filled.icon';
import { mgcIconSkipPreviousFilled } from './mgcIcon-skip_previous_filled.icon';
import { mgcIconSoundLineFilled } from './mgcIcon-sound_line_filled.icon';
import { mgcIconStopCircleFilled } from './mgcIcon-stop_circle_filled.icon';
import { mgcIconStopFilled } from './mgcIcon-stop_filled.icon';
import { mgcIconVideoCamera2Filled } from './mgcIcon-video_camera_2_filled.icon';
import { mgcIconVideoCameraFilled } from './mgcIcon-video_camera_filled.icon';
import { mgcIconVideoFilled } from './mgcIcon-video_filled.icon';
import { mgcIconVoice2Filled } from './mgcIcon-voice_2_filled.icon';
import { mgcIconVoiceFilled } from './mgcIcon-voice_filled.icon';
import { mgcIconVolumeFilled } from './mgcIcon-volume_filled.icon';
import { mgcIconVolumeMuteFilled } from './mgcIcon-volume_mute_filled.icon';
import { mgcIconVolumeOffFilled } from './mgcIcon-volume_off_filled.icon';
import { mgcIconBearFilled } from './mgcIcon-bear_filled.icon';
import { mgcIconBirdFilled } from './mgcIcon-bird_filled.icon';
import { mgcIconButterfly2Filled } from './mgcIcon-butterfly_2_filled.icon';
import { mgcIconButterflyFilled } from './mgcIcon-butterfly_filled.icon';
import { mgcIconCactus2Filled } from './mgcIcon-cactus_2_filled.icon';
import { mgcIconCactusFilled } from './mgcIcon-cactus_filled.icon';
import { mgcIconCampfireFilled } from './mgcIcon-campfire_filled.icon';
import { mgcIconCatFilled } from './mgcIcon-cat_filled.icon';
import { mgcIconChessFilled } from './mgcIcon-chess_filled.icon';
import { mgcIconDandelionFilled } from './mgcIcon-dandelion_filled.icon';
import { mgcIconDogFilled } from './mgcIcon-dog_filled.icon';
import { mgcIconDragonflyFilled } from './mgcIcon-dragonfly_filled.icon';
import { mgcIconFlower2Filled } from './mgcIcon-flower_2_filled.icon';
import { mgcIconFlower3Filled } from './mgcIcon-flower_3_filled.icon';
import { mgcIconFlower4Filled } from './mgcIcon-flower_4_filled.icon';
import { mgcIconFlower5Filled } from './mgcIcon-flower_5_filled.icon';
import { mgcIconFlowerFilled } from './mgcIcon-flower_filled.icon';
import { mgcIconFlowerpotFilled } from './mgcIcon-flowerpot_filled.icon';
import { mgcIconGrassFilled } from './mgcIcon-grass_filled.icon';
import { mgcIconLeaf2Filled } from './mgcIcon-leaf_2_filled.icon';
import { mgcIconLeaf3Filled } from './mgcIcon-leaf_3_filled.icon';
import { mgcIconLeafFilled } from './mgcIcon-leaf_filled.icon';
import { mgcIconLotusFilled } from './mgcIcon-lotus_filled.icon';
import { mgcIconMapleLeafFilled } from './mgcIcon-maple_leaf_filled.icon';
import { mgcIconMickeymouseFilled } from './mgcIcon-mickeymouse_filled.icon';
import { mgcIconMountain2Filled } from './mgcIcon-mountain_2_filled.icon';
import { mgcIconMountainFilled } from './mgcIcon-mountain_filled.icon';
import { mgcIconMushroomFilled } from './mgcIcon-mushroom_filled.icon';
import { mgcIconPawFilled } from './mgcIcon-paw_filled.icon';
import { mgcIconPigFilled } from './mgcIcon-pig_filled.icon';
import { mgcIconPumpkinFilled } from './mgcIcon-pumpkin_filled.icon';
import { mgcIconRabbitFilled } from './mgcIcon-rabbit_filled.icon';
import { mgcIconSunflowerFilled } from './mgcIcon-sunflower_filled.icon';
import { mgcIconToyHorseFilled } from './mgcIcon-toy_horse_filled.icon';
import { mgcIconTree2Filled } from './mgcIcon-tree_2_filled.icon';
import { mgcIconTree3Filled } from './mgcIcon-tree_3_filled.icon';
import { mgcIconTree4Filled } from './mgcIcon-tree_4_filled.icon';
import { mgcIconTreeFilled } from './mgcIcon-tree_filled.icon';
import { mgcIconWreathFilled } from './mgcIcon-wreath_filled.icon';
import { mgcIconAxeFilled } from './mgcIcon-axe_filled.icon';
import { mgcIconBalloon2Filled } from './mgcIcon-balloon_2_filled.icon';
import { mgcIconBathFilled } from './mgcIcon-bath_filled.icon';
import { mgcIconBesideTable2Filled } from './mgcIcon-beside_table_2_filled.icon';
import { mgcIconBesideTableFilled } from './mgcIcon-beside_table_filled.icon';
import { mgcIconBlessingFilled } from './mgcIcon-blessing_filled.icon';
import { mgcIconBombFilled } from './mgcIcon-bomb_filled.icon';
import { mgcIconBoomFilled } from './mgcIcon-boom_filled.icon';
import { mgcIconBottleFilled } from './mgcIcon-bottle_filled.icon';
import { mgcIconCapsuleFilled } from './mgcIcon-capsule_filled.icon';
import { mgcIconCoathangerFilled } from './mgcIcon-coathanger_filled.icon';
import { mgcIconCross2Filled } from './mgcIcon-cross_2_filled.icon';
import { mgcIconCrystalBallFilled } from './mgcIcon-crystal_ball_filled.icon';
import { mgcIconCurtainFilled } from './mgcIcon-curtain_filled.icon';
import { mgcIconDrawer2Filled } from './mgcIcon-drawer_2_filled.icon';
import { mgcIconDrawerFilled } from './mgcIcon-drawer_filled.icon';
import { mgcIconFaceMaskFilled } from './mgcIcon-face_mask_filled.icon';
import { mgcIconFirecrackerFilled } from './mgcIcon-firecracker_filled.icon';
import { mgcIconFireworkFilled } from './mgcIcon-firework_filled.icon';
import { mgcIconFirstAidKitFilled } from './mgcIcon-first_aid_kit_filled.icon';
import { mgcIconHammerFilled } from './mgcIcon-hammer_filled.icon';
import { mgcIconHandCardFilled } from './mgcIcon-hand_card_filled.icon';
import { mgcIconHandHeartFilled } from './mgcIcon-hand_heart_filled.icon';
import { mgcIconHoeFilled } from './mgcIcon-hoe_filled.icon';
import { mgcIconInjectionFilled } from './mgcIcon-injection_filled.icon';
import { mgcIconKiteFilled } from './mgcIcon-kite_filled.icon';
import { mgcIconLipstickFilled } from './mgcIcon-lipstick_filled.icon';
import { mgcIconNurseFilled } from './mgcIcon-nurse_filled.icon';
import { mgcIconParfumFilled } from './mgcIcon-parfum_filled.icon';
import { mgcIconPickaxFilled } from './mgcIcon-pickax_filled.icon';
import { mgcIconPotFilled } from './mgcIcon-pot_filled.icon';
import { mgcIconPrescriptionFilled } from './mgcIcon-prescription_filled.icon';
import { mgcIconRakeFilled } from './mgcIcon-rake_filled.icon';
import { mgcIconRandomFilled } from './mgcIcon-random_filled.icon';
import { mgcIconScrewdriverFilled } from './mgcIcon-screwdriver_filled.icon';
import { mgcIconShovelFilled } from './mgcIcon-shovel_filled.icon';
import { mgcIconShowerGelFilled } from './mgcIcon-shower_gel_filled.icon';
import { mgcIconStar2Filled } from './mgcIcon-star_2_filled.icon';
import { mgcIconStarTopperFilled } from './mgcIcon-star_topper_filled.icon';
import { mgcIconStethoscopeFilled } from './mgcIcon-stethoscope_filled.icon';
import { mgcIconThoughtFilled } from './mgcIcon-thought_filled.icon';
import { mgcIconToiletPaperFilled } from './mgcIcon-toilet_paper_filled.icon';
import { mgcIconVirusFilled } from './mgcIcon-virus_filled.icon';
import { mgcIconWardrobe2Filled } from './mgcIcon-wardrobe_2_filled.icon';
import { mgcIconWardrobeFilled } from './mgcIcon-wardrobe_filled.icon';
import { mgcIconWateringCanFilled } from './mgcIcon-watering_can_filled.icon';
import { mgcIconYinyangFilled } from './mgcIcon-yinyang_filled.icon';
import { mgcIconBabyFilled } from './mgcIcon-baby_filled.icon';
import { mgcIconBeardFilled } from './mgcIcon-beard_filled.icon';
import { mgcIconBodyFilled } from './mgcIcon-body_filled.icon';
import { mgcIconBowTieFilled } from './mgcIcon-bow_tie_filled.icon';
import { mgcIconBowknotFilled } from './mgcIcon-bowknot_filled.icon';
import { mgcIconBrainFilled } from './mgcIcon-brain_filled.icon';
import { mgcIconBriefFilled } from './mgcIcon-brief_filled.icon';
import { mgcIconChefHatFilled } from './mgcIcon-chef_hat_filled.icon';
import { mgcIconChristmasHatFilled } from './mgcIcon-christmas_hat_filled.icon';
import { mgcIconCoatFilled } from './mgcIcon-coat_filled.icon';
import { mgcIconDeerFilled } from './mgcIcon-deer_filled.icon';
import { mgcIconDentalFilled } from './mgcIcon-dental_filled.icon';
import { mgcIconDressFilled } from './mgcIcon-dress_filled.icon';
import { mgcIconEarFilled } from './mgcIcon-ear_filled.icon';
import { mgcIconEye2Filled } from './mgcIcon-eye_2_filled.icon';
import { mgcIconEyebrowFilled } from './mgcIcon-eyebrow_filled.icon';
import { mgcIconFaceFilled } from './mgcIcon-face_filled.icon';
import { mgcIconFatherChristmasFilled } from './mgcIcon-father_christmas_filled.icon';
import { mgcIconFingerPressFilled } from './mgcIcon-finger_press_filled.icon';
import { mgcIconFingerRockFilled } from './mgcIcon-finger_rock_filled.icon';
import { mgcIconFingerSwipeFilled } from './mgcIcon-finger_swipe_filled.icon';
import { mgcIconFingerTapFilled } from './mgcIcon-finger_tap_filled.icon';
import { mgcIconGloveFilled } from './mgcIcon-glove_filled.icon';
import { mgcIconHair2Filled } from './mgcIcon-hair_2_filled.icon';
import { mgcIconHairFilled } from './mgcIcon-hair_filled.icon';
import { mgcIconHandFilled } from './mgcIcon-hand_filled.icon';
import { mgcIconHandFinger2Filled } from './mgcIcon-hand_finger_2_filled.icon';
import { mgcIconHandFingerFilled } from './mgcIcon-hand_finger_filled.icon';
import { mgcIconHandGrabFilled } from './mgcIcon-hand_grab_filled.icon';
import { mgcIconHandTwoFingersFilled } from './mgcIcon-hand_two_fingers_filled.icon';
import { mgcIconHandsClappingFilled } from './mgcIcon-hands_clapping_filled.icon';
import { mgcIconHat2Filled } from './mgcIcon-hat_2_filled.icon';
import { mgcIconHatFilled } from './mgcIcon-hat_filled.icon';
import { mgcIconHeadFilled } from './mgcIcon-head_filled.icon';
import { mgcIconHeartHandFilled } from './mgcIcon-heart_hand_filled.icon';
import { mgcIconHeartbeat2Filled } from './mgcIcon-heartbeat_2_filled.icon';
import { mgcIconIncognitoModeFilled } from './mgcIcon-incognito_mode_filled.icon';
import { mgcIconLoveFilled } from './mgcIcon-love_filled.icon';
import { mgcIconLungsFilled } from './mgcIcon-lungs_filled.icon';
import { mgcIconMiddleFingerFilled } from './mgcIcon-middle_finger_filled.icon';
import { mgcIconMouthFilled } from './mgcIcon-mouth_filled.icon';
import { mgcIconNecktieFilled } from './mgcIcon-necktie_filled.icon';
import { mgcIconNoseFilled } from './mgcIcon-nose_filled.icon';
import { mgcIconPrayFilled } from './mgcIcon-pray_filled.icon';
import { mgcIconScarfFilled } from './mgcIcon-scarf_filled.icon';
import { mgcIconShirtFilled } from './mgcIcon-shirt_filled.icon';
import { mgcIconShoe2Filled } from './mgcIcon-shoe_2_filled.icon';
import { mgcIconShoeFilled } from './mgcIcon-shoe_filled.icon';
import { mgcIconShortsFilled } from './mgcIcon-shorts_filled.icon';
import { mgcIconSkirtFilled } from './mgcIcon-skirt_filled.icon';
import { mgcIconSkullFilled } from './mgcIcon-skull_filled.icon';
import { mgcIconSockFilled } from './mgcIcon-sock_filled.icon';
import { mgcIconTShirt2Filled } from './mgcIcon-t_shirt_2_filled.icon';
import { mgcIconTrouserFilled } from './mgcIcon-trouser_filled.icon';
import { mgcIconVestFilled } from './mgcIcon-vest_filled.icon';
import { mgcIconClubsFilled } from './mgcIcon-clubs_filled.icon';
import { mgcIconCylinder2Filled } from './mgcIcon-cylinder_2_filled.icon';
import { mgcIconCylinderFilled } from './mgcIcon-cylinder_filled.icon';
import { mgcIconDiamondFilled } from './mgcIcon-diamond_filled.icon';
import { mgcIconDiamondSquareFilled } from './mgcIcon-diamond_square_filled.icon';
import { mgcIconHeartCrackFilled } from './mgcIcon-heart_crack_filled.icon';
import { mgcIconHeartFilled } from './mgcIcon-heart_filled.icon';
import { mgcIconHeartHalfFilled } from './mgcIcon-heart_half_filled.icon';
import { mgcIconHemisphere2Filled } from './mgcIcon-hemisphere_2_filled.icon';
import { mgcIconHemisphereFilled } from './mgcIcon-hemisphere_filled.icon';
import { mgcIconHexagonFilled } from './mgcIcon-hexagon_filled.icon';
import { mgcIconLineFilled } from './mgcIcon-line_filled.icon';
import { mgcIconOctagonFilled } from './mgcIcon-octagon_filled.icon';
import { mgcIconPentagonFilled } from './mgcIcon-pentagon_filled.icon';
import { mgcIconRectangleFilled } from './mgcIcon-rectangle_filled.icon';
import { mgcIconRectangleVerticalFilled } from './mgcIcon-rectangle_vertical_filled.icon';
import { mgcIconRoundFilled } from './mgcIcon-round_filled.icon';
import { mgcIconSectorFilled } from './mgcIcon-sector_filled.icon';
import { mgcIconShieldShapeFilled } from './mgcIcon-shield_shape_filled.icon';
import { mgcIconSpadeFilled } from './mgcIcon-spade_filled.icon';
import { mgcIconSquareFilled } from './mgcIcon-square_filled.icon';
import { mgcIconStarFilled } from './mgcIcon-star_filled.icon';
import { mgcIconStarHalfFilled } from './mgcIcon-star_half_filled.icon';
import { mgcIconTriangleFilled } from './mgcIcon-triangle_filled.icon';
import { mgcIconAirBalloonFilled } from './mgcIcon-air_balloon_filled.icon';
import { mgcIconAmericanFootballFilled } from './mgcIcon-american_football_filled.icon';
import { mgcIconBackboardFilled } from './mgcIcon-backboard_filled.icon';
import { mgcIconBadmintonFilled } from './mgcIcon-badminton_filled.icon';
import { mgcIconBarbellFilled } from './mgcIcon-barbell_filled.icon';
import { mgcIconBaseball2Filled } from './mgcIcon-baseball_2_filled.icon';
import { mgcIconBaseballFilled } from './mgcIcon-baseball_filled.icon';
import { mgcIconBasketballFilled } from './mgcIcon-basketball_filled.icon';
import { mgcIconBeachballFilled } from './mgcIcon-beachball_filled.icon';
import { mgcIconDisabled2Filled } from './mgcIcon-disabled_2_filled.icon';
import { mgcIconDisabledFilled } from './mgcIcon-disabled_filled.icon';
import { mgcIconFitnessFilled } from './mgcIcon-fitness_filled.icon';
import { mgcIconFootballFilled } from './mgcIcon-football_filled.icon';
import { mgcIconParachuteFilled } from './mgcIcon-parachute_filled.icon';
import { mgcIconPingpongFilled } from './mgcIcon-pingpong_filled.icon';
import { mgcIconPlaygroundFilled } from './mgcIcon-playground_filled.icon';
import { mgcIconRidingFilled } from './mgcIcon-riding_filled.icon';
import { mgcIconRunFilled } from './mgcIcon-run_filled.icon';
import { mgcIconSkateboardFilled } from './mgcIcon-skateboard_filled.icon';
import { mgcIconSurfboardFilled } from './mgcIcon-surfboard_filled.icon';
import { mgcIconSwimmingPoolFilled } from './mgcIcon-swimming_pool_filled.icon';
import { mgcIconSwordFilled } from './mgcIcon-sword_filled.icon';
import { mgcIconToxophilyFilled } from './mgcIcon-toxophily_filled.icon';
import { mgcIconVolleyballFilled } from './mgcIcon-volleyball_filled.icon';
import { mgcIconWalkFilled } from './mgcIcon-walk_filled.icon';
import { mgcIconWheelchairFilled } from './mgcIcon-wheelchair_filled.icon';
import { mgcIconWhistleFilled } from './mgcIcon-whistle_filled.icon';
import { mgcIconAddCircleFilled } from './mgcIcon-add_circle_filled.icon';
import { mgcIconAddFilled } from './mgcIcon-add_filled.icon';
import { mgcIconAddSquareFilled } from './mgcIcon-add_square_filled.icon';
import { mgcIconAlertDiamondFilled } from './mgcIcon-alert_diamond_filled.icon';
import { mgcIconAlertFilled } from './mgcIcon-alert_filled.icon';
import { mgcIconAlertOctagonFilled } from './mgcIcon-alert_octagon_filled.icon';
import { mgcIconBroomFilled } from './mgcIcon-broom_filled.icon';
import { mgcIconBrush3Filled } from './mgcIcon-brush_3_filled.icon';
import { mgcIconBrushFilled } from './mgcIcon-brush_filled.icon';
import { mgcIconBubbleFilled } from './mgcIcon-bubble_filled.icon';
import { mgcIconCertificateFilled } from './mgcIcon-certificate_filled.icon';
import { mgcIconCheck2Filled } from './mgcIcon-check_2_filled.icon';
import { mgcIconCheckCircleFilled } from './mgcIcon-check_circle_filled.icon';
import { mgcIconCheckFilled } from './mgcIcon-check_filled.icon';
import { mgcIconCheckboxFilled } from './mgcIcon-checkbox_filled.icon';
import { mgcIconChecksFilled } from './mgcIcon-checks_filled.icon';
import { mgcIconChoiceFilled } from './mgcIcon-choice_filled.icon';
import { mgcIconClassify2Filled } from './mgcIcon-classify_2_filled.icon';
import { mgcIconClassify3Filled } from './mgcIcon-classify_3_filled.icon';
import { mgcIconClassifyAdd2Filled } from './mgcIcon-classify_add_2_filled.icon';
import { mgcIconClassifyAddFilled } from './mgcIcon-classify_add_filled.icon';
import { mgcIconClassifyFilled } from './mgcIcon-classify_filled.icon';
import { mgcIconCloseCircleFilled } from './mgcIcon-close_circle_filled.icon';
import { mgcIconCloseFilled } from './mgcIcon-close_filled.icon';
import { mgcIconCloseSquareFilled } from './mgcIcon-close_square_filled.icon';
import { mgcIconCrossFilled } from './mgcIcon-cross_filled.icon';
import { mgcIconCrutchFilled } from './mgcIcon-crutch_filled.icon';
import { mgcIconCubeFilled } from './mgcIcon-cube_filled.icon';
import { mgcIconDelete2Filled } from './mgcIcon-delete_2_filled.icon';
import { mgcIconDelete3Filled } from './mgcIcon-delete_3_filled.icon';
import { mgcIconDeleteBackFilled } from './mgcIcon-delete_back_filled.icon';
import { mgcIconDeleteFilled } from './mgcIcon-delete_filled.icon';
import { mgcIconDirectionDotFilled } from './mgcIcon-direction_dot_filled.icon';
import { mgcIconDoorFilled } from './mgcIcon-door_filled.icon';
import { mgcIconDotGridFilled } from './mgcIcon-dot_grid_filled.icon';
import { mgcIconDotsFilled } from './mgcIcon-dots_filled.icon';
import { mgcIconDotsVerticalFilled } from './mgcIcon-dots_vertical_filled.icon';
import { mgcIconEnterDoorFilled } from './mgcIcon-enter_door_filled.icon';
import { mgcIconEntranceFilled } from './mgcIcon-entrance_filled.icon';
import { mgcIconExitDoorFilled } from './mgcIcon-exit_door_filled.icon';
import { mgcIconExitFilled } from './mgcIcon-exit_filled.icon';
import { mgcIconEyeCloseFilled } from './mgcIcon-eye_close_filled.icon';
import { mgcIconEyeFilled } from './mgcIcon-eye_filled.icon';
import { mgcIconFaceidFilled } from './mgcIcon-faceid_filled.icon';
import { mgcIconFaultFilled } from './mgcIcon-fault_filled.icon';
import { mgcIconFilter2Filled } from './mgcIcon-filter_2_filled.icon';
import { mgcIconFingerprint2Filled } from './mgcIcon-fingerprint_2_filled.icon';
import { mgcIconFingerprintFilled } from './mgcIcon-fingerprint_filled.icon';
import { mgcIconFireFilled } from './mgcIcon-fire_filled.icon';
import { mgcIconFlameFilled } from './mgcIcon-flame_filled.icon';
import { mgcIconForbidCircleFilled } from './mgcIcon-forbid_circle_filled.icon';
import { mgcIconGestureUnlockFilled } from './mgcIcon-gesture_unlock_filled.icon';
import { mgcIconGhostFilled } from './mgcIcon-ghost_filled.icon';
import { mgcIconGrid2Filled } from './mgcIcon-grid_2_filled.icon';
import { mgcIconGridFilled } from './mgcIcon-grid_filled.icon';
import { mgcIconHeartbeatFilled } from './mgcIcon-heartbeat_filled.icon';
import { mgcIconHexagons2Filled } from './mgcIcon-hexagons_2_filled.icon';
import { mgcIconHexagonsFilled } from './mgcIcon-hexagons_filled.icon';
import { mgcIconHistory2Filled } from './mgcIcon-history_2_filled.icon';
import { mgcIconHistoryAnticlockwiseFilled } from './mgcIcon-history_anticlockwise_filled.icon';
import { mgcIconHistoryFilled } from './mgcIcon-history_filled.icon';
import { mgcIconInformationFilled } from './mgcIcon-information_filled.icon';
import { mgcIconKey1Filled } from './mgcIcon-key_1_filled.icon';
import { mgcIconKey2Filled } from './mgcIcon-key_2_filled.icon';
import { mgcIconKeyholeFilled } from './mgcIcon-keyhole_filled.icon';
import { mgcIconLoading2Filled } from './mgcIcon-loading_2_filled.icon';
import { mgcIconLoading3Filled } from './mgcIcon-loading_3_filled.icon';
import { mgcIconLoading4Filled } from './mgcIcon-loading_4_filled.icon';
import { mgcIconLoadingFilled } from './mgcIcon-loading_filled.icon';
import { mgcIconLockFilled } from './mgcIcon-lock_filled.icon';
import { mgcIconMindMapFilled } from './mgcIcon-mind_map_filled.icon';
import { mgcIconMinimizeFilled } from './mgcIcon-minimize_filled.icon';
import { mgcIconMinusCircleFilled } from './mgcIcon-minus_circle_filled.icon';
import { mgcIconMinusSquareFilled } from './mgcIcon-minus_square_filled.icon';
import { mgcIconMore1Filled } from './mgcIcon-more_1_filled.icon';
import { mgcIconMore2Filled } from './mgcIcon-more_2_filled.icon';
import { mgcIconMore3Filled } from './mgcIcon-more_3_filled.icon';
import { mgcIconMore4Filled } from './mgcIcon-more_4_filled.icon';
import { mgcIconMultiselectFilled } from './mgcIcon-multiselect_filled.icon';
import { mgcIconNewdotFilled } from './mgcIcon-newdot_filled.icon';
import { mgcIconOpenDoorFilled } from './mgcIcon-open_door_filled.icon';
import { mgcIconPlusFilled } from './mgcIcon-plus_filled.icon';
import { mgcIconPolygonFilled } from './mgcIcon-polygon_filled.icon';
import { mgcIconPowerFilled } from './mgcIcon-power_filled.icon';
import { mgcIconProcessFilled } from './mgcIcon-process_filled.icon';
import { mgcIconQuestionFilled } from './mgcIcon-question_filled.icon';
import { mgcIconRadioboxFilled } from './mgcIcon-radiobox_filled.icon';
import { mgcIconRecycleFilled } from './mgcIcon-recycle_filled.icon';
import { mgcIconRefresh1Filled } from './mgcIcon-refresh_1_filled.icon';
import { mgcIconRefresh2Filled } from './mgcIcon-refresh_2_filled.icon';
import { mgcIconRefresh3Filled } from './mgcIcon-refresh_3_filled.icon';
import { mgcIconRefresh4AiFilled } from './mgcIcon-refresh_4_ai_filled.icon';
import { mgcIconRefresh4Filled } from './mgcIcon-refresh_4_filled.icon';
import { mgcIconRefreshAnticlockwise1Filled } from './mgcIcon-refresh_anticlockwise_1_filled.icon';
import { mgcIconReportFilled } from './mgcIcon-report_filled.icon';
import { mgcIconRestoreFilled } from './mgcIcon-restore_filled.icon';
import { mgcIconSafeAlertFilled } from './mgcIcon-safe_alert_filled.icon';
import { mgcIconSafeFlashFilled } from './mgcIcon-safe_flash_filled.icon';
import { mgcIconSafeLockFilled } from './mgcIcon-safe_lock_filled.icon';
import { mgcIconSafeShield2Filled } from './mgcIcon-safe_shield_2_filled.icon';
import { mgcIconSafeShieldFilled } from './mgcIcon-safe_shield_filled.icon';
import { mgcIconSafetyCertificateFilled } from './mgcIcon-safety_certificate_filled.icon';
import { mgcIconSettings1Filled } from './mgcIcon-settings_1_filled.icon';
import { mgcIconSettings2Filled } from './mgcIcon-settings_2_filled.icon';
import { mgcIconSettings3Filled } from './mgcIcon-settings_3_filled.icon';
import { mgcIconSettings4Filled } from './mgcIcon-settings_4_filled.icon';
import { mgcIconSettings5Filled } from './mgcIcon-settings_5_filled.icon';
import { mgcIconSettings6Filled } from './mgcIcon-settings_6_filled.icon';
import { mgcIconSettings7Filled } from './mgcIcon-settings_7_filled.icon';
import { mgcIconShare2Filled } from './mgcIcon-share_2_filled.icon';
import { mgcIconShare3Filled } from './mgcIcon-share_3_filled.icon';
import { mgcIconShareForwardFilled } from './mgcIcon-share_forward_filled.icon';
import { mgcIconShieldFilled } from './mgcIcon-shield_filled.icon';
import { mgcIconSleepFilled } from './mgcIcon-sleep_filled.icon';
import { mgcIconSwitchFilled } from './mgcIcon-switch_filled.icon';
import { mgcIconTShirtFilled } from './mgcIcon-t_shirt_filled.icon';
import { mgcIconThreeCirclesFilled } from './mgcIcon-three_circles_filled.icon';
import { mgcIconThumbDown2Filled } from './mgcIcon-thumb_down_2_filled.icon';
import { mgcIconThumbDownFilled } from './mgcIcon-thumb_down_filled.icon';
import { mgcIconThumbUp2Filled } from './mgcIcon-thumb_up_2_filled.icon';
import { mgcIconThumbUpFilled } from './mgcIcon-thumb_up_filled.icon';
import { mgcIconTimeDurationFilled } from './mgcIcon-time_duration_filled.icon';
import { mgcIconTimeFilled } from './mgcIcon-time_filled.icon';
import { mgcIconTimelineFilled } from './mgcIcon-timeline_filled.icon';
import { mgcIconToggleLeft2Filled } from './mgcIcon-toggle_left_2_filled.icon';
import { mgcIconToggleLeftFilled } from './mgcIcon-toggle_left_filled.icon';
import { mgcIconToggleRight2Filled } from './mgcIcon-toggle_right_2_filled.icon';
import { mgcIconToggleRightFilled } from './mgcIcon-toggle_right_filled.icon';
import { mgcIconToolFilled } from './mgcIcon-tool_filled.icon';
import { mgcIconTransformationFilled } from './mgcIcon-transformation_filled.icon';
import { mgcIconUnlockFilled } from './mgcIcon-unlock_filled.icon';
import { mgcIconVersionFilled } from './mgcIcon-version_filled.icon';
import { mgcIconWarningFilled } from './mgcIcon-warning_filled.icon';
import { mgcIconWastebasketFilled } from './mgcIcon-wastebasket_filled.icon';
import { mgcIconWebhookFilled } from './mgcIcon-webhook_filled.icon';
import { mgcIconAbsFilled } from './mgcIcon-ABS_filled.icon';
import { mgcIconAerialLiftFilled } from './mgcIcon-aerial_lift_filled.icon';
import { mgcIconAirplaneFilled } from './mgcIcon-airplane_filled.icon';
import { mgcIconAutoHoldFilled } from './mgcIcon-auto_hold_filled.icon';
import { mgcIconBabyCarriageFilled } from './mgcIcon-baby_carriage_filled.icon';
import { mgcIconBikeFilled } from './mgcIcon-bike_filled.icon';
import { mgcIconBrakeFilled } from './mgcIcon-brake_filled.icon';
import { mgcIconBus2Filled } from './mgcIcon-bus_2_filled.icon';
import { mgcIconBusFilled } from './mgcIcon-bus_filled.icon';
import { mgcIconCar2Filled } from './mgcIcon-car_2_filled.icon';
import { mgcIconCar3Filled } from './mgcIcon-car_3_filled.icon';
import { mgcIconCarDoorFilled } from './mgcIcon-car_door_filled.icon';
import { mgcIconCarFilled } from './mgcIcon-car_filled.icon';
import { mgcIconCarWindowFilled } from './mgcIcon-car_window_filled.icon';
import { mgcIconChargingPileFilled } from './mgcIcon-charging_pile_filled.icon';
import { mgcIconEbikeFilled } from './mgcIcon-ebike_filled.icon';
import { mgcIconEmergencyFlashersFilled } from './mgcIcon-emergency_flashers_filled.icon';
import { mgcIconEngineFilled } from './mgcIcon-engine_filled.icon';
import { mgcIconFan2Filled } from './mgcIcon-fan_2_filled.icon';
import { mgcIconFanDirectionDownFilled } from './mgcIcon-fan_direction_down_filled.icon';
import { mgcIconFanDirectionFrontFilled } from './mgcIcon-fan_direction_front_filled.icon';
import { mgcIconFanDirectionUpFilled } from './mgcIcon-fan_direction_up_filled.icon';
import { mgcIconFanFilled } from './mgcIcon-fan_filled.icon';
import { mgcIconFlightInflightFilled } from './mgcIcon-flight_inflight_filled.icon';
import { mgcIconFlightLandFilled } from './mgcIcon-flight_land_filled.icon';
import { mgcIconFlightTakeoffFilled } from './mgcIcon-flight_takeoff_filled.icon';
import { mgcIconFourWheelDriveFilled } from './mgcIcon-four_wheel_drive_filled.icon';
import { mgcIconFrontFogLightsFilled } from './mgcIcon-front_fog_lights_filled.icon';
import { mgcIconFrontWindshieldDefrosterFilled } from './mgcIcon-front_windshield_defroster_filled.icon';
import { mgcIconGasStationFilled } from './mgcIcon-gas_station_filled.icon';
import { mgcIconHightBeamHeadlightsFilled } from './mgcIcon-hight_beam_headlights_filled.icon';
import { mgcIconHoodFilled } from './mgcIcon-hood_filled.icon';
import { mgcIconJeepFilled } from './mgcIcon-jeep_filled.icon';
import { mgcIconLowBeamHeadlightsFilled } from './mgcIcon-low_beam_headlights_filled.icon';
import { mgcIconOilFilled } from './mgcIcon-oil_filled.icon';
import { mgcIconParkFilled } from './mgcIcon-park_filled.icon';
import { mgcIconParkingLightsFilled } from './mgcIcon-parking_lights_filled.icon';
import { mgcIconPinwheel2Filled } from './mgcIcon-pinwheel_2_filled.icon';
import { mgcIconPinwheelFilled } from './mgcIcon-pinwheel_filled.icon';
import { mgcIconRareFogLightsFilled } from './mgcIcon-rare_fog_lights_filled.icon';
import { mgcIconRearWindshieldDefrosterFilled } from './mgcIcon-rear_windshield_defroster_filled.icon';
import { mgcIconRocket2Filled } from './mgcIcon-rocket_2_filled.icon';
import { mgcIconRocketFilled } from './mgcIcon-rocket_filled.icon';
import { mgcIconRudderFilled } from './mgcIcon-rudder_filled.icon';
import { mgcIconSailboatFilled } from './mgcIcon-sailboat_filled.icon';
import { mgcIconScooterFilled } from './mgcIcon-scooter_filled.icon';
import { mgcIconSeatFilled } from './mgcIcon-seat_filled.icon';
import { mgcIconSeatHeatedFilled } from './mgcIcon-seat_heated_filled.icon';
import { mgcIconShipFilled } from './mgcIcon-ship_filled.icon';
import { mgcIconSleighFilled } from './mgcIcon-sleigh_filled.icon';
import { mgcIconSteeringWheelFilled } from './mgcIcon-steering_wheel_filled.icon';
import { mgcIconTankFilled } from './mgcIcon-tank_filled.icon';
import { mgcIconTrafficLightsFilled } from './mgcIcon-traffic_lights_filled.icon';
import { mgcIconTrain2Filled } from './mgcIcon-train_2_filled.icon';
import { mgcIconTrain3Filled } from './mgcIcon-train_3_filled.icon';
import { mgcIconTrain4Filled } from './mgcIcon-train_4_filled.icon';
import { mgcIconTrainFilled } from './mgcIcon-train_filled.icon';
import { mgcIconTruckFilled } from './mgcIcon-truck_filled.icon';
import { mgcIconTrunkFilled } from './mgcIcon-trunk_filled.icon';
import { mgcIconTyreFilled } from './mgcIcon-tyre_filled.icon';
import { mgcIconUfo2Filled } from './mgcIcon-UFO_2_filled.icon';
import { mgcIconUfoFilled } from './mgcIcon-UFO_filled.icon';
import { mgcIconWheelFilled } from './mgcIcon-wheel_filled.icon';
import { mgcIconWiperFilled } from './mgcIcon-wiper_filled.icon';
import { mgcIconBadgeFilled } from './mgcIcon-badge_filled.icon';
import { mgcIconContacts2Filled } from './mgcIcon-contacts_2_filled.icon';
import { mgcIconContacts3Filled } from './mgcIcon-contacts_3_filled.icon';
import { mgcIconContacts4Filled } from './mgcIcon-contacts_4_filled.icon';
import { mgcIconContactsFilled } from './mgcIcon-contacts_filled.icon';
import { mgcIconFemaleFilled } from './mgcIcon-female_filled.icon';
import { mgcIconGroup2Filled } from './mgcIcon-group_2_filled.icon';
import { mgcIconGroup3Filled } from './mgcIcon-group_3_filled.icon';
import { mgcIconGroupFilled } from './mgcIcon-group_filled.icon';
import { mgcIconIDcardFilled } from './mgcIcon-IDcard_filled.icon';
import { mgcIconMaleFilled } from './mgcIcon-male_filled.icon';
import { mgcIconUser1Filled } from './mgcIcon-user_1_filled.icon';
import { mgcIconUser2Filled } from './mgcIcon-user_2_filled.icon';
import { mgcIconUser3Filled } from './mgcIcon-user_3_filled.icon';
import { mgcIconUser4Filled } from './mgcIcon-user_4_filled.icon';
import { mgcIconUser5Filled } from './mgcIcon-user_5_filled.icon';
import { mgcIconUserAdd2Filled } from './mgcIcon-user_add_2_filled.icon';
import { mgcIconUserAddFilled } from './mgcIcon-user_add_filled.icon';
import { mgcIconUserEditFilled } from './mgcIcon-user_edit_filled.icon';
import { mgcIconUserFollow2Filled } from './mgcIcon-user_follow_2_filled.icon';
import { mgcIconUserFollowFilled } from './mgcIcon-user_follow_filled.icon';
import { mgcIconUserForbidFilled } from './mgcIcon-user_forbid_filled.icon';
import { mgcIconUserHeartFilled } from './mgcIcon-user_heart_filled.icon';
import { mgcIconUserHideFilled } from './mgcIcon-user_hide_filled.icon';
import { mgcIconUserInfoFilled } from './mgcIcon-user_info_filled.icon';
import { mgcIconUserLockFilled } from './mgcIcon-user_lock_filled.icon';
import { mgcIconUserPinFilled } from './mgcIcon-user_pin_filled.icon';
import { mgcIconUserQuestionFilled } from './mgcIcon-user_question_filled.icon';
import { mgcIconUserRemove2Filled } from './mgcIcon-user_remove_2_filled.icon';
import { mgcIconUserRemoveFilled } from './mgcIcon-user_remove_filled.icon';
import { mgcIconUserSearchFilled } from './mgcIcon-user_search_filled.icon';
import { mgcIconUserSecurityFilled } from './mgcIcon-user_security_filled.icon';
import { mgcIconUserSettingFilled } from './mgcIcon-user_setting_filled.icon';
import { mgcIconUserStarFilled } from './mgcIcon-user_star_filled.icon';
import { mgcIconUserVisibleFilled } from './mgcIcon-user_visible_filled.icon';
import { mgcIconUserWarningFilled } from './mgcIcon-user_warning_filled.icon';
import { mgcIconUserXFilled } from './mgcIcon-user_x_filled.icon';
import { mgcIconCelsiusFilled } from './mgcIcon-celsius_filled.icon';
import { mgcIconCloud2Filled } from './mgcIcon-cloud_2_filled.icon';
import { mgcIconCloudFilled } from './mgcIcon-cloud_filled.icon';
import { mgcIconCloudLightningFilled } from './mgcIcon-cloud_lightning_filled.icon';
import { mgcIconCloudSnowFilled } from './mgcIcon-cloud_snow_filled.icon';
import { mgcIconCloudWindyFilled } from './mgcIcon-cloud_windy_filled.icon';
import { mgcIconCloudsFilled } from './mgcIcon-clouds_filled.icon';
import { mgcIconDrizzleFilled } from './mgcIcon-drizzle_filled.icon';
import { mgcIconDryFilled } from './mgcIcon-dry_filled.icon';
import { mgcIconFahrenheitFilled } from './mgcIcon-fahrenheit_filled.icon';
import { mgcIconFloatingDustFilled } from './mgcIcon-floating_dust_filled.icon';
import { mgcIconFogFilled } from './mgcIcon-fog_filled.icon';
import { mgcIconFullMoonFilled } from './mgcIcon-full_moon_filled.icon';
import { mgcIconHailFilled } from './mgcIcon-hail_filled.icon';
import { mgcIconHazeFilled } from './mgcIcon-haze_filled.icon';
import { mgcIconHeavyRainFilled } from './mgcIcon-heavy_rain_filled.icon';
import { mgcIconHeavyRainstormFilled } from './mgcIcon-heavy_rainstorm_filled.icon';
import { mgcIconHeavySnowFilled } from './mgcIcon-heavy_snow_filled.icon';
import { mgcIconHeavySnowstormFilled } from './mgcIcon-heavy_snowstorm_filled.icon';
import { mgcIconHighTemperatureFilled } from './mgcIcon-high_temperature_filled.icon';
import { mgcIconLightSnowFilled } from './mgcIcon-light_snow_filled.icon';
import { mgcIconLightningFilled } from './mgcIcon-lightning_filled.icon';
import { mgcIconLowTemperatureFilled } from './mgcIcon-low_temperature_filled.icon';
import { mgcIconModerateSnowFilled } from './mgcIcon-moderate_snow_filled.icon';
import { mgcIconMoonCloudyFilled } from './mgcIcon-moon_cloudy_filled.icon';
import { mgcIconMoonFilled } from './mgcIcon-moon_filled.icon';
import { mgcIconMoonFogFilled } from './mgcIcon-moon_fog_filled.icon';
import { mgcIconMoonStarsFilled } from './mgcIcon-moon_stars_filled.icon';
import { mgcIconMoonlightFilled } from './mgcIcon-moonlight_filled.icon';
import { mgcIconNaFilled } from './mgcIcon-na_filled.icon';
import { mgcIconPartlyCloudDaytimeFilled } from './mgcIcon-partly_cloud_daytime_filled.icon';
import { mgcIconPartlyCloudNightFilled } from './mgcIcon-partly_cloud_night_filled.icon';
import { mgcIconRainFilled } from './mgcIcon-rain_filled.icon';
import { mgcIconRainbowFilled } from './mgcIcon-rainbow_filled.icon';
import { mgcIconRainstormFilled } from './mgcIcon-rainstorm_filled.icon';
import { mgcIconSandstormFilled } from './mgcIcon-sandstorm_filled.icon';
import { mgcIconShowersFilled } from './mgcIcon-showers_filled.icon';
import { mgcIconSnowFilled } from './mgcIcon-snow_filled.icon';
import { mgcIconSnowflakeFilled } from './mgcIcon-snowflake_filled.icon';
import { mgcIconSnowmanFilled } from './mgcIcon-snowman_filled.icon';
import { mgcIconSnowstorm2Filled } from './mgcIcon-snowstorm_2_filled.icon';
import { mgcIconSnowstormFilled } from './mgcIcon-snowstorm_filled.icon';
import { mgcIconSparkles2Filled } from './mgcIcon-sparkles_2_filled.icon';
import { mgcIconSparkles3Filled } from './mgcIcon-sparkles_3_filled.icon';
import { mgcIconSparklesFilled } from './mgcIcon-sparkles_filled.icon';
import { mgcIconSun2Filled } from './mgcIcon-sun_2_filled.icon';
import { mgcIconSunCloudyFilled } from './mgcIcon-sun_cloudy_filled.icon';
import { mgcIconSunFilled } from './mgcIcon-sun_filled.icon';
import { mgcIconSunFogFilled } from './mgcIcon-sun_fog_filled.icon';
import { mgcIconSunriseFilled } from './mgcIcon-sunrise_filled.icon';
import { mgcIconSunsetFilled } from './mgcIcon-sunset_filled.icon';
import { mgcIconThermometerFilled } from './mgcIcon-thermometer_filled.icon';
import { mgcIconThunderstormFilled } from './mgcIcon-thunderstorm_filled.icon';
import { mgcIconTornado2Filled } from './mgcIcon-tornado_2_filled.icon';
import { mgcIconTornadoFilled } from './mgcIcon-tornado_filled.icon';
import { mgcIconTyphoonFilled } from './mgcIcon-typhoon_filled.icon';
import { mgcIconUmbrellaFilled } from './mgcIcon-umbrella_filled.icon';
import { mgcIconWaveFilled } from './mgcIcon-wave_filled.icon';
import { mgcIconWetFilled } from './mgcIcon-wet_filled.icon';
import { mgcIconWindFilled } from './mgcIcon-wind_filled.icon';
import { mgcIconAquariusFilled } from './mgcIcon-Aquarius_filled.icon';
import { mgcIconAriesFilled } from './mgcIcon-Aries_filled.icon';
import { mgcIconCancerFilled } from './mgcIcon-Cancer_filled.icon';
import { mgcIconCapricornFilled } from './mgcIcon-Capricorn_filled.icon';
import { mgcIconGeminiFilled } from './mgcIcon-Gemini_filled.icon';
import { mgcIconLeoFilled } from './mgcIcon-Leo_filled.icon';
import { mgcIconLibraFilled } from './mgcIcon-Libra_filled.icon';
import { mgcIconPiscesFilled } from './mgcIcon-Pisces_filled.icon';
import { mgcIconSagittariusFilled } from './mgcIcon-Sagittarius_filled.icon';
import { mgcIconScorpioFilled } from './mgcIcon-Scorpio_filled.icon';
import { mgcIconTaurusFilled } from './mgcIcon-Taurus_filled.icon';
import { mgcIconVirgoFilled } from './mgcIcon-Virgo_filled.icon';
import { mgcIconAlignArrowDownRegular } from './mgcIcon-align_arrow_down_regular.icon';
import { mgcIconAlignArrowLeftRegular } from './mgcIcon-align_arrow_left_regular.icon';
import { mgcIconAlignArrowRightRegular } from './mgcIcon-align_arrow_right_regular.icon';
import { mgcIconAlignArrowUpRegular } from './mgcIcon-align_arrow_up_regular.icon';
import { mgcIconArrowDownCircleRegular } from './mgcIcon-arrow_down_circle_regular.icon';
import { mgcIconArrowDownRegular } from './mgcIcon-arrow_down_regular.icon';
import { mgcIconArrowLeftCircleRegular } from './mgcIcon-arrow_left_circle_regular.icon';
import { mgcIconArrowLeftDownCircleRegular } from './mgcIcon-arrow_left_down_circle_regular.icon';
import { mgcIconArrowLeftDownRegular } from './mgcIcon-arrow_left_down_regular.icon';
import { mgcIconArrowLeftRegular } from './mgcIcon-arrow_left_regular.icon';
import { mgcIconArrowLeftUpCircleRegular } from './mgcIcon-arrow_left_up_circle_regular.icon';
import { mgcIconArrowLeftUpRegular } from './mgcIcon-arrow_left_up_regular.icon';
import { mgcIconArrowRightCircleRegular } from './mgcIcon-arrow_right_circle_regular.icon';
import { mgcIconArrowRightDownCircleRegular } from './mgcIcon-arrow_right_down_circle_regular.icon';
import { mgcIconArrowRightDownRegular } from './mgcIcon-arrow_right_down_regular.icon';
import { mgcIconArrowRightRegular } from './mgcIcon-arrow_right_regular.icon';
import { mgcIconArrowRightUpCircleRegular } from './mgcIcon-arrow_right_up_circle_regular.icon';
import { mgcIconArrowRightUpRegular } from './mgcIcon-arrow_right_up_regular.icon';
import { mgcIconArrowToDownRegular } from './mgcIcon-arrow_to_down_regular.icon';
import { mgcIconArrowToLeftRegular } from './mgcIcon-arrow_to_left_regular.icon';
import { mgcIconArrowToRightRegular } from './mgcIcon-arrow_to_right_regular.icon';
import { mgcIconArrowToUpRegular } from './mgcIcon-arrow_to_up_regular.icon';
import { mgcIconArrowUpCircleRegular } from './mgcIcon-arrow_up_circle_regular.icon';
import { mgcIconArrowUpRegular } from './mgcIcon-arrow_up_regular.icon';
import { mgcIconArrowsDownRegular } from './mgcIcon-arrows_down_regular.icon';
import { mgcIconArrowsLeftRegular } from './mgcIcon-arrows_left_regular.icon';
import { mgcIconArrowsRightRegular } from './mgcIcon-arrows_right_regular.icon';
import { mgcIconArrowsUpRegular } from './mgcIcon-arrows_up_regular.icon';
import { mgcIconBack2Regular } from './mgcIcon-back_2_regular.icon';
import { mgcIconBackRegular } from './mgcIcon-back_regular.icon';
import { mgcIconCornerDownLeftRegular } from './mgcIcon-corner_down_left_regular.icon';
import { mgcIconCornerDownRightRegular } from './mgcIcon-corner_down_right_regular.icon';
import { mgcIconCornerUpLeftRegular } from './mgcIcon-corner_up_left_regular.icon';
import { mgcIconCornerUpRightRegular } from './mgcIcon-corner_up_right_regular.icon';
import { mgcIconDirectionArrowRegular } from './mgcIcon-direction_arrow_regular.icon';
import { mgcIconDownRegular } from './mgcIcon-down_regular.icon';
import { mgcIconDownSmallRegular } from './mgcIcon-down_small_regular.icon';
import { mgcIconForward2Regular } from './mgcIcon-forward_2_regular.icon';
import { mgcIconForwardRegular } from './mgcIcon-forward_regular.icon';
import { mgcIconFullscreen2Regular } from './mgcIcon-fullscreen_2_regular.icon';
import { mgcIconFullscreenExit2Regular } from './mgcIcon-fullscreen_exit_2_regular.icon';
import { mgcIconLargeArrowDownRegular } from './mgcIcon-large_arrow_down_regular.icon';
import { mgcIconLargeArrowLeftRegular } from './mgcIcon-large_arrow_left_regular.icon';
import { mgcIconLargeArrowRightRegular } from './mgcIcon-large_arrow_right_regular.icon';
import { mgcIconLargeArrowUpRegular } from './mgcIcon-large_arrow_up_regular.icon';
import { mgcIconLeftRegular } from './mgcIcon-left_regular.icon';
import { mgcIconLeftSmallRegular } from './mgcIcon-left_small_regular.icon';
import { mgcIconMoveRegular } from './mgcIcon-move_regular.icon';
import { mgcIconRightRegular } from './mgcIcon-right_regular.icon';
import { mgcIconRightSmallRegular } from './mgcIcon-right_small_regular.icon';
import { mgcIconSelectorHorizontalRegular } from './mgcIcon-selector_horizontal_regular.icon';
import { mgcIconSelectorVerticalRegular } from './mgcIcon-selector_vertical_regular.icon';
import { mgcIconSquareArrowDownRegular } from './mgcIcon-square_arrow_down_regular.icon';
import { mgcIconSquareArrowLeftRegular } from './mgcIcon-square_arrow_left_regular.icon';
import { mgcIconSquareArrowRightRegular } from './mgcIcon-square_arrow_right_regular.icon';
import { mgcIconSquareArrowUpRegular } from './mgcIcon-square_arrow_up_regular.icon';
import { mgcIconTransfer2Regular } from './mgcIcon-transfer_2_regular.icon';
import { mgcIconTransfer3Regular } from './mgcIcon-transfer_3_regular.icon';
import { mgcIconTransfer4Regular } from './mgcIcon-transfer_4_regular.icon';
import { mgcIconTransferHorizontalRegular } from './mgcIcon-transfer_horizontal_regular.icon';
import { mgcIconTransferRegular } from './mgcIcon-transfer_regular.icon';
import { mgcIconTransferVerticalRegular } from './mgcIcon-transfer_vertical_regular.icon';
import { mgcIconTrendingDownRegular } from './mgcIcon-trending_down_regular.icon';
import { mgcIconTrendingUpRegular } from './mgcIcon-trending_up_regular.icon';
import { mgcIconUpRegular } from './mgcIcon-up_regular.icon';
import { mgcIconUpSmallRegular } from './mgcIcon-up_small_regular.icon';
import { mgcIconBankOfChinaTowerRegular } from './mgcIcon-bank_of_china_tower_regular.icon';
import { mgcIconBankRegular } from './mgcIcon-bank_regular.icon';
import { mgcIconBigBenRegular } from './mgcIcon-big_ben_regular.icon';
import { mgcIconBridge2Regular } from './mgcIcon-bridge_2_regular.icon';
import { mgcIconBridgeRegular } from './mgcIcon-bridge_regular.icon';
import { mgcIconBuilding1Regular } from './mgcIcon-building_1_regular.icon';
import { mgcIconBuilding2Regular } from './mgcIcon-building_2_regular.icon';
import { mgcIconBuilding3Regular } from './mgcIcon-building_3_regular.icon';
import { mgcIconBuilding4Regular } from './mgcIcon-building_4_regular.icon';
import { mgcIconBuilding5Regular } from './mgcIcon-building_5_regular.icon';
import { mgcIconBuilding6Regular } from './mgcIcon-building_6_regular.icon';
import { mgcIconBurjAlArabRegular } from './mgcIcon-burj_al_arab_regular.icon';
import { mgcIconBurjKhalifaTowerRegular } from './mgcIcon-burj_khalifa_tower_regular.icon';
import { mgcIconCampgroundRegular } from './mgcIcon-campground_regular.icon';
import { mgcIconCantonTowerRegular } from './mgcIcon-canton_tower_regular.icon';
import { mgcIconChristTheRedeemerRegular } from './mgcIcon-christ_the_redeemer_regular.icon';
import { mgcIconChurchRegular } from './mgcIcon-church_regular.icon';
import { mgcIconDutchWindmillRegular } from './mgcIcon-dutch_windmill_regular.icon';
import { mgcIconEgyptianPyramidsRegular } from './mgcIcon-egyptian_pyramids_regular.icon';
import { mgcIconEiffelTowerRegular } from './mgcIcon-eiffel_tower_regular.icon';
import { mgcIconFactory2Regular } from './mgcIcon-factory_2_regular.icon';
import { mgcIconFactoryRegular } from './mgcIcon-factory_regular.icon';
import { mgcIconFerrisWheelRegular } from './mgcIcon-ferris_wheel_regular.icon';
import { mgcIconGovernmentRegular } from './mgcIcon-government_regular.icon';
import { mgcIconGreatwallRegular } from './mgcIcon-greatwall_regular.icon';
import { mgcIconHome1Regular } from './mgcIcon-home_1_regular.icon';
import { mgcIconHome2Regular } from './mgcIcon-home_2_regular.icon';
import { mgcIconHome3Regular } from './mgcIcon-home_3_regular.icon';
import { mgcIconHome4Regular } from './mgcIcon-home_4_regular.icon';
import { mgcIconHome5Regular } from './mgcIcon-home_5_regular.icon';
import { mgcIconHome6Regular } from './mgcIcon-home_6_regular.icon';
import { mgcIconHome7Regular } from './mgcIcon-home_7_regular.icon';
import { mgcIconHospitalRegular } from './mgcIcon-hospital_regular.icon';
import { mgcIconHotelRegular } from './mgcIcon-hotel_regular.icon';
import { mgcIconHouse2Regular } from './mgcIcon-house_2_regular.icon';
import { mgcIconHouseRegular } from './mgcIcon-house_regular.icon';
import { mgcIconKingkey100TowerRegular } from './mgcIcon-kingkey_100_tower_regular.icon';
import { mgcIconLighthouseRegular } from './mgcIcon-lighthouse_regular.icon';
import { mgcIconMarinaBaySandRegular } from './mgcIcon-marina_bay_sand_regular.icon';
import { mgcIconMayaPyramidsRegular } from './mgcIcon-maya_pyramids_regular.icon';
import { mgcIconMiyajimaToriiRegular } from './mgcIcon-miyajima_torii_regular.icon';
import { mgcIconMoaiRegular } from './mgcIcon-moai_regular.icon';
import { mgcIconMonumentRegular } from './mgcIcon-monument_regular.icon';
import { mgcIconPalaceRegular } from './mgcIcon-palace_regular.icon';
import { mgcIconPavilionRegular } from './mgcIcon-pavilion_regular.icon';
import { mgcIconPisaTowerRegular } from './mgcIcon-pisa_tower_regular.icon';
import { mgcIconSchoolRegular } from './mgcIcon-school_regular.icon';
import { mgcIconShopRegular } from './mgcIcon-shop_regular.icon';
import { mgcIconStatueOfLibertyRegular } from './mgcIcon-statue_of_liberty_regular.icon';
import { mgcIconStore2Regular } from './mgcIcon-store_2_regular.icon';
import { mgcIconStoreRegular } from './mgcIcon-store_regular.icon';
import { mgcIconSydneyOperaHouseRegular } from './mgcIcon-sydney_opera_house_regular.icon';
import { mgcIconTaipei101Regular } from './mgcIcon-taipei101_regular.icon';
import { mgcIconTajMahalRegular } from './mgcIcon-taj_mahal_regular.icon';
import { mgcIconTempleOfHeavenRegular } from './mgcIcon-temple_of_heaven_regular.icon';
import { mgcIconTentRegular } from './mgcIcon-tent_regular.icon';
import { mgcIconTowerRegular } from './mgcIcon-tower_regular.icon';
import { mgcIconTriumphalArchRegular } from './mgcIcon-triumphal_arch_regular.icon';
import { mgcIconTvTowerRegular } from './mgcIcon-tv_tower_regular.icon';
import { mgcIconAdCircleOffRegular } from './mgcIcon-ad_circle_off_regular.icon';
import { mgcIconAdCircleRegular } from './mgcIcon-ad_circle_regular.icon';
import { mgcIconAdRectangleOffRegular } from './mgcIcon-ad_rectangle_off_regular.icon';
import { mgcIconAdRectangleRegular } from './mgcIcon-ad_rectangle_regular.icon';
import { mgcIconAnniversaryRegular } from './mgcIcon-anniversary_regular.icon';
import { mgcIconAuctionRegular } from './mgcIcon-auction_regular.icon';
import { mgcIconAwardRegular } from './mgcIcon-award_regular.icon';
import { mgcIconBankCardRegular } from './mgcIcon-bank_card_regular.icon';
import { mgcIconBasket2Regular } from './mgcIcon-basket_2_regular.icon';
import { mgcIconBasketRegular } from './mgcIcon-basket_regular.icon';
import { mgcIconBriefcase2Regular } from './mgcIcon-briefcase_2_regular.icon';
import { mgcIconBriefcaseRegular } from './mgcIcon-briefcase_regular.icon';
import { mgcIconCalendar2Regular } from './mgcIcon-calendar_2_regular.icon';
import { mgcIconCalendar3Regular } from './mgcIcon-calendar_3_regular.icon';
import { mgcIconCalendarAddRegular } from './mgcIcon-calendar_add_regular.icon';
import { mgcIconCalendarDayRegular } from './mgcIcon-calendar_day_regular.icon';
import { mgcIconCalendarMonthRegular } from './mgcIcon-calendar_month_regular.icon';
import { mgcIconCalendarRegular } from './mgcIcon-calendar_regular.icon';
import { mgcIconCalendarTimeAddRegular } from './mgcIcon-calendar_time_add_regular.icon';
import { mgcIconCalendarWeekRegular } from './mgcIcon-calendar_week_regular.icon';
import { mgcIconCandleRegular } from './mgcIcon-candle_regular.icon';
import { mgcIconCandlesRegular } from './mgcIcon-candles_regular.icon';
import { mgcIconCardPayRegular } from './mgcIcon-card_pay_regular.icon';
import { mgcIconCardRefundRegular } from './mgcIcon-card_refund_regular.icon';
import { mgcIconCash2Regular } from './mgcIcon-cash_2_regular.icon';
import { mgcIconCashRegular } from './mgcIcon-cash_regular.icon';
import { mgcIconCelebrateRegular } from './mgcIcon-celebrate_regular.icon';
import { mgcIconChartBar2Regular } from './mgcIcon-chart_bar_2_regular.icon';
import { mgcIconChartBarRegular } from './mgcIcon-chart_bar_regular.icon';
import { mgcIconChartDecreaseRegular } from './mgcIcon-chart_decrease_regular.icon';
import { mgcIconChartHorizontalRegular } from './mgcIcon-chart_horizontal_regular.icon';
import { mgcIconChartLineRegular } from './mgcIcon-chart_line_regular.icon';
import { mgcIconChartPie2Regular } from './mgcIcon-chart_pie_2_regular.icon';
import { mgcIconChartPieRegular } from './mgcIcon-chart_pie_regular.icon';
import { mgcIconChartVerticalRegular } from './mgcIcon-chart_vertical_regular.icon';
import { mgcIconChineseKnotRegular } from './mgcIcon-chinese_knot_regular.icon';
import { mgcIconChristmasBallRegular } from './mgcIcon-christmas_ball_regular.icon';
import { mgcIconCoin2Regular } from './mgcIcon-coin_2_regular.icon';
import { mgcIconCoin3Regular } from './mgcIcon-coin_3_regular.icon';
import { mgcIconCoinRegular } from './mgcIcon-coin_regular.icon';
import { mgcIconCopperCoinRegular } from './mgcIcon-copper_coin_regular.icon';
import { mgcIconCopyrightRegular } from './mgcIcon-copyright_regular.icon';
import { mgcIconCouponRegular } from './mgcIcon-coupon_regular.icon';
import { mgcIconCurrencyBaht2Regular } from './mgcIcon-currency_baht_2_regular.icon';
import { mgcIconCurrencyBahtRegular } from './mgcIcon-currency_baht_regular.icon';
import { mgcIconCurrencyCny2Regular } from './mgcIcon-currency_cny_2_regular.icon';
import { mgcIconCurrencyCnyRegular } from './mgcIcon-currency_cny_regular.icon';
import { mgcIconCurrencyDollar2Regular } from './mgcIcon-currency_dollar_2_regular.icon';
import { mgcIconCurrencyDollarRegular } from './mgcIcon-currency_dollar_regular.icon';
import { mgcIconCurrencyEuro2Regular } from './mgcIcon-currency_euro_2_regular.icon';
import { mgcIconCurrencyEuroRegular } from './mgcIcon-currency_euro_regular.icon';
import { mgcIconCurrencyLira2Regular } from './mgcIcon-currency_lira_2_regular.icon';
import { mgcIconCurrencyLiraRegular } from './mgcIcon-currency_lira_regular.icon';
import { mgcIconCurrencyNigeria2Regular } from './mgcIcon-currency_nigeria_2_regular.icon';
import { mgcIconCurrencyNigeriaRegular } from './mgcIcon-currency_nigeria_regular.icon';
import { mgcIconCurrencyRubel2Regular } from './mgcIcon-currency_rubel_2_regular.icon';
import { mgcIconCurrencyRubelRegular } from './mgcIcon-currency_rubel_regular.icon';
import { mgcIconCurrencyRupee2Regular } from './mgcIcon-currency_rupee_2_regular.icon';
import { mgcIconCurrencyRupeeRegular } from './mgcIcon-currency_rupee_regular.icon';
import { mgcIconCurrencyShekel2Regular } from './mgcIcon-currency_shekel_2_regular.icon';
import { mgcIconCurrencyShekelRegular } from './mgcIcon-currency_shekel_regular.icon';
import { mgcIconCurrencyWon2Regular } from './mgcIcon-currency_won_2_regular.icon';
import { mgcIconCurrencyWonRegular } from './mgcIcon-currency_won_regular.icon';
import { mgcIconDiamond2Regular } from './mgcIcon-diamond_2_regular.icon';
import { mgcIconExchangeBahtRegular } from './mgcIcon-exchange_baht_regular.icon';
import { mgcIconExchangeCnyRegular } from './mgcIcon-exchange_cny_regular.icon';
import { mgcIconExchangeDollarRegular } from './mgcIcon-exchange_dollar_regular.icon';
import { mgcIconExchangeEuroRegular } from './mgcIcon-exchange_euro_regular.icon';
import { mgcIconFilter3Regular } from './mgcIcon-filter_3_regular.icon';
import { mgcIconFilterRegular } from './mgcIcon-filter_regular.icon';
import { mgcIconFlag1Regular } from './mgcIcon-flag_1_regular.icon';
import { mgcIconFlag2Regular } from './mgcIcon-flag_2_regular.icon';
import { mgcIconFlag3Regular } from './mgcIcon-flag_3_regular.icon';
import { mgcIconFlag4Regular } from './mgcIcon-flag_4_regular.icon';
import { mgcIconGift2Regular } from './mgcIcon-gift_2_regular.icon';
import { mgcIconGiftCardRegular } from './mgcIcon-gift_card_regular.icon';
import { mgcIconGiftRegular } from './mgcIcon-gift_regular.icon';
import { mgcIconLadderRegular } from './mgcIcon-ladder_regular.icon';
import { mgcIconLantern2Regular } from './mgcIcon-lantern_2_regular.icon';
import { mgcIconLanternRegular } from './mgcIcon-lantern_regular.icon';
import { mgcIconLaurelWreathRegular } from './mgcIcon-laurel_wreath_regular.icon';
import { mgcIconLuggageRegular } from './mgcIcon-luggage_regular.icon';
import { mgcIconMedalRegular } from './mgcIcon-medal_regular.icon';
import { mgcIconPalette3Regular } from './mgcIcon-palette_3_regular.icon';
import { mgcIconPigMoneyRegular } from './mgcIcon-pig_money_regular.icon';
import { mgcIconPound2Regular } from './mgcIcon-pound_2_regular.icon';
import { mgcIconPoundRegular } from './mgcIcon-pound_regular.icon';
import { mgcIconPresentation1Regular } from './mgcIcon-presentation_1_regular.icon';
import { mgcIconPresentation2Regular } from './mgcIcon-presentation_2_regular.icon';
import { mgcIconPresentation3Regular } from './mgcIcon-presentation_3_regular.icon';
import { mgcIconPumpkinLanternRegular } from './mgcIcon-pumpkin_lantern_regular.icon';
import { mgcIconReceiveMoneyRegular } from './mgcIcon-receive_money_regular.icon';
import { mgcIconRedPacketOpenRegular } from './mgcIcon-red_packet_open_regular.icon';
import { mgcIconRedPacketRegular } from './mgcIcon-red_packet_regular.icon';
import { mgcIconRefundCnyRegular } from './mgcIcon-refund_cny_regular.icon';
import { mgcIconRefundDollarRegular } from './mgcIcon-refund_dollar_regular.icon';
import { mgcIconRegisteredRegular } from './mgcIcon-registered_regular.icon';
import { mgcIconSafeBoxRegular } from './mgcIcon-safe_box_regular.icon';
import { mgcIconSaleRegular } from './mgcIcon-sale_regular.icon';
import { mgcIconScheduleRegular } from './mgcIcon-schedule_regular.icon';
import { mgcIconSealRegular } from './mgcIcon-seal_regular.icon';
import { mgcIconShoppingBag1Regular } from './mgcIcon-shopping_bag_1_regular.icon';
import { mgcIconShoppingBag2Regular } from './mgcIcon-shopping_bag_2_regular.icon';
import { mgcIconShoppingBag3Regular } from './mgcIcon-shopping_bag_3_regular.icon';
import { mgcIconShoppingCart1Regular } from './mgcIcon-shopping_cart_1_regular.icon';
import { mgcIconShoppingCart2Regular } from './mgcIcon-shopping_cart_2_regular.icon';
import { mgcIconSofaRegular } from './mgcIcon-sofa_regular.icon';
import { mgcIconStockRegular } from './mgcIcon-stock_regular.icon';
import { mgcIconSuitcase2Regular } from './mgcIcon-suitcase_2_regular.icon';
import { mgcIconSuitcaseRegular } from './mgcIcon-suitcase_regular.icon';
import { mgcIconTag2Regular } from './mgcIcon-tag_2_regular.icon';
import { mgcIconTagChevronRegular } from './mgcIcon-tag_chevron_regular.icon';
import { mgcIconTagRegular } from './mgcIcon-tag_regular.icon';
import { mgcIconTargetRegular } from './mgcIcon-target_regular.icon';
import { mgcIconTicketRegular } from './mgcIcon-ticket_regular.icon';
import { mgcIconTrophyRegular } from './mgcIcon-trophy_regular.icon';
import { mgcIconVip1Regular } from './mgcIcon-VIP_1_regular.icon';
import { mgcIconVip2Regular } from './mgcIcon-VIP_2_regular.icon';
import { mgcIconVip3Regular } from './mgcIcon-VIP_3_regular.icon';
import { mgcIconVip4Regular } from './mgcIcon-VIP_4_regular.icon';
import { mgcIconWallet2Regular } from './mgcIcon-wallet_2_regular.icon';
import { mgcIconWallet3Regular } from './mgcIcon-wallet_3_regular.icon';
import { mgcIconWallet4Regular } from './mgcIcon-wallet_4_regular.icon';
import { mgcIconWallet5Regular } from './mgcIcon-wallet_5_regular.icon';
import { mgcIconWalletRegular } from './mgcIcon-wallet_regular.icon';
import { mgcIconYuanbaoRegular } from './mgcIcon-yuanbao_regular.icon';
import { mgcIconChat1Regular } from './mgcIcon-chat_1_regular.icon';
import { mgcIconChat2Regular } from './mgcIcon-chat_2_regular.icon';
import { mgcIconChat3Regular } from './mgcIcon-chat_3_regular.icon';
import { mgcIconChat4Regular } from './mgcIcon-chat_4_regular.icon';
import { mgcIconComment2Regular } from './mgcIcon-comment_2_regular.icon';
import { mgcIconCommentRegular } from './mgcIcon-comment_regular.icon';
import { mgcIconInviteRegular } from './mgcIcon-invite_regular.icon';
import { mgcIconMailAiRegular } from './mgcIcon-mail_ai_regular.icon';
import { mgcIconMailOpenRegular } from './mgcIcon-mail_open_regular.icon';
import { mgcIconMailRegular } from './mgcIcon-mail_regular.icon';
import { mgcIconMailSendRegular } from './mgcIcon-mail_send_regular.icon';
import { mgcIconMailboxRegular } from './mgcIcon-mailbox_regular.icon';
import { mgcIconMessage1Regular } from './mgcIcon-message_1_regular.icon';
import { mgcIconMessage2Regular } from './mgcIcon-message_2_regular.icon';
import { mgcIconMessage3Regular } from './mgcIcon-message_3_regular.icon';
import { mgcIconMessage4Regular } from './mgcIcon-message_4_regular.icon';
import { mgcIconPhoneAddRegular } from './mgcIcon-phone_add_regular.icon';
import { mgcIconPhoneBlockRegular } from './mgcIcon-phone_block_regular.icon';
import { mgcIconPhoneCallRegular } from './mgcIcon-phone_call_regular.icon';
import { mgcIconPhoneIncomingRegular } from './mgcIcon-phone_incoming_regular.icon';
import { mgcIconPhoneOffRegular } from './mgcIcon-phone_off_regular.icon';
import { mgcIconPhoneOutgoingRegular } from './mgcIcon-phone_outgoing_regular.icon';
import { mgcIconPhoneRegular } from './mgcIcon-phone_regular.icon';
import { mgcIconPhoneSuccessRegular } from './mgcIcon-phone_success_regular.icon';
import { mgcIconSendPlaneRegular } from './mgcIcon-send_plane_regular.icon';
import { mgcIconSendRegular } from './mgcIcon-send_regular.icon';
import { mgcIconAvalancheAvaxRegular } from './mgcIcon-avalanche_AVAX_regular.icon';
import { mgcIconBinanceCoinBnbRegular } from './mgcIcon-binance_coin_BNB_regular.icon';
import { mgcIconBinanceUsdBusdRegular } from './mgcIcon-binance_USD_BUSD_regular.icon';
import { mgcIconBnbRegular } from './mgcIcon-BNB_regular.icon';
import { mgcIconCardanoAdaRegular } from './mgcIcon-cardano_ADA_regular.icon';
import { mgcIconCurrencyBitcoin2Regular } from './mgcIcon-currency_bitcoin_2_regular.icon';
import { mgcIconCurrencyBitcoinRegular } from './mgcIcon-currency_bitcoin_regular.icon';
import { mgcIconDogecoinDogeRegular } from './mgcIcon-dogecoin_DOGE_regular.icon';
import { mgcIconEthereumRegular } from './mgcIcon-ethereum_regular.icon';
import { mgcIconExchangeBitcoinRegular } from './mgcIcon-exchange_bitcoin_regular.icon';
import { mgcIconMoneroRegular } from './mgcIcon-monero_regular.icon';
import { mgcIconPolkadotDotRegular } from './mgcIcon-polkadot_DOT_regular.icon';
import { mgcIconSolanaSolRegular } from './mgcIcon-solana_SOL_regular.icon';
import { mgcIconTetherUsdtRegular } from './mgcIcon-tether_USDT_regular.icon';
import { mgcIconUsdCoinUsdcRegular } from './mgcIcon-usd_coin_USDC_regular.icon';
import { mgcIconXrpRegular } from './mgcIcon-XRP_regular.icon';
import { mgcIconAlignBottomRegular } from './mgcIcon-align_bottom_regular.icon';
import { mgcIconAlignHorizontalCenterRegular } from './mgcIcon-align_horizontal_center_regular.icon';
import { mgcIconAlignLeft2Regular } from './mgcIcon-align_left_2_regular.icon';
import { mgcIconAlignRight2Regular } from './mgcIcon-align_right_2_regular.icon';
import { mgcIconAlignTopRegular } from './mgcIcon-align_top_regular.icon';
import { mgcIconAlignVerticalCenterRegular } from './mgcIcon-align_vertical_center_regular.icon';
import { mgcIconAnticlockwiseAltRegular } from './mgcIcon-anticlockwise_alt_regular.icon';
import { mgcIconAnticlockwiseRegular } from './mgcIcon-anticlockwise_regular.icon';
import { mgcIconArtboardRegular } from './mgcIcon-artboard_regular.icon';
import { mgcIconBackgroundBaseRegular } from './mgcIcon-background_base_regular.icon';
import { mgcIconBackgroundRegular } from './mgcIcon-background_regular.icon';
import { mgcIconBlingRegular } from './mgcIcon-bling_regular.icon';
import { mgcIconBoardRegular } from './mgcIcon-board_regular.icon';
import { mgcIconBorderBlankRegular } from './mgcIcon-border_blank_regular.icon';
import { mgcIconBorderBottomRegular } from './mgcIcon-border_bottom_regular.icon';
import { mgcIconBorderHorizontalRegular } from './mgcIcon-border_horizontal_regular.icon';
import { mgcIconBorderInnerRegular } from './mgcIcon-border_inner_regular.icon';
import { mgcIconBorderLeftRegular } from './mgcIcon-border_left_regular.icon';
import { mgcIconBorderOuterRegular } from './mgcIcon-border_outer_regular.icon';
import { mgcIconBorderRadiusRegular } from './mgcIcon-border_radius_regular.icon';
import { mgcIconBorderRightRegular } from './mgcIcon-border_right_regular.icon';
import { mgcIconBorderTopRegular } from './mgcIcon-border_top_regular.icon';
import { mgcIconBorderVerticalRegular } from './mgcIcon-border_vertical_regular.icon';
import { mgcIconBrightnessRegular } from './mgcIcon-brightness_regular.icon';
import { mgcIconBrush2Regular } from './mgcIcon-brush_2_regular.icon';
import { mgcIconClockwiseAltRegular } from './mgcIcon-clockwise_alt_regular.icon';
import { mgcIconClockwiseRegular } from './mgcIcon-clockwise_regular.icon';
import { mgcIconColorFilterRegular } from './mgcIcon-color_filter_regular.icon';
import { mgcIconColorPickerRegular } from './mgcIcon-color_picker_regular.icon';
import { mgcIconColumns2Regular } from './mgcIcon-columns_2_regular.icon';
import { mgcIconColumns3Regular } from './mgcIcon-columns_3_regular.icon';
import { mgcIconCombineRegular } from './mgcIcon-combine_regular.icon';
import { mgcIconComponentsRegular } from './mgcIcon-components_regular.icon';
import { mgcIconDistributeSpacingHorizontalRegular } from './mgcIcon-distribute_spacing_horizontal_regular.icon';
import { mgcIconDistributeSpacingVerticalRegular } from './mgcIcon-distribute_spacing_vertical_regular.icon';
import { mgcIconDrawingBoardRegular } from './mgcIcon-drawing_board_regular.icon';
import { mgcIconDropRegular } from './mgcIcon-drop_regular.icon';
import { mgcIconEaseInControlPointRegular } from './mgcIcon-ease_in_control_point_regular.icon';
import { mgcIconEaseInOutControlPointRegular } from './mgcIcon-ease_in_out_control_point_regular.icon';
import { mgcIconEaseInRegular } from './mgcIcon-ease_in_regular.icon';
import { mgcIconEaseOutControlPointRegular } from './mgcIcon-ease_out_control_point_regular.icon';
import { mgcIconEaseOutRegular } from './mgcIcon-ease_out_regular.icon';
import { mgcIconEasyInOutRegular } from './mgcIcon-easy_in_out_regular.icon';
import { mgcIconExcludeRegular } from './mgcIcon-exclude_regular.icon';
import { mgcIconExposureRegular } from './mgcIcon-exposure_regular.icon';
import { mgcIconFlipHorizontalRegular } from './mgcIcon-flip_horizontal_regular.icon';
import { mgcIconFlipVerticalRegular } from './mgcIcon-flip_vertical_regular.icon';
import { mgcIconFoldHorizontalRegular } from './mgcIcon-fold_horizontal_regular.icon';
import { mgcIconFoldVerticalRegular } from './mgcIcon-fold_vertical_regular.icon';
import { mgcIconIntersectRegular } from './mgcIcon-intersect_regular.icon';
import { mgcIconKnifeRegular } from './mgcIcon-knife_regular.icon';
import { mgcIconLayerRegular } from './mgcIcon-layer_regular.icon';
import { mgcIconLayout10Regular } from './mgcIcon-layout_10_regular.icon';
import { mgcIconLayout11Regular } from './mgcIcon-layout_11_regular.icon';
import { mgcIconLayout2Regular } from './mgcIcon-layout_2_regular.icon';
import { mgcIconLayout3Regular } from './mgcIcon-layout_3_regular.icon';
import { mgcIconLayout4Regular } from './mgcIcon-layout_4_regular.icon';
import { mgcIconLayout5Regular } from './mgcIcon-layout_5_regular.icon';
import { mgcIconLayout6Regular } from './mgcIcon-layout_6_regular.icon';
import { mgcIconLayout7Regular } from './mgcIcon-layout_7_regular.icon';
import { mgcIconLayout8Regular } from './mgcIcon-layout_8_regular.icon';
import { mgcIconLayout9Regular } from './mgcIcon-layout_9_regular.icon';
import { mgcIconLayoutBottomCloseRegular } from './mgcIcon-layout_bottom_close_regular.icon';
import { mgcIconLayoutBottomOpenRegular } from './mgcIcon-layout_bottom_open_regular.icon';
import { mgcIconLayoutBottomRegular } from './mgcIcon-layout_bottom_regular.icon';
import { mgcIconLayoutGridRegular } from './mgcIcon-layout_grid_regular.icon';
import { mgcIconLayoutLeftRegular } from './mgcIcon-layout_left_regular.icon';
import { mgcIconLayoutLeftbarCloseRegular } from './mgcIcon-layout_leftbar_close_regular.icon';
import { mgcIconLayoutLeftbarOpenRegular } from './mgcIcon-layout_leftbar_open_regular.icon';
import { mgcIconLayoutRegular } from './mgcIcon-layout_regular.icon';
import { mgcIconLayoutRightRegular } from './mgcIcon-layout_right_regular.icon';
import { mgcIconLayoutRightbarCloseRegular } from './mgcIcon-layout_rightbar_close_regular.icon';
import { mgcIconLayoutRightbarOpenRegular } from './mgcIcon-layout_rightbar_open_regular.icon';
import { mgcIconLayoutTopCloseRegular } from './mgcIcon-layout_top_close_regular.icon';
import { mgcIconLayoutTopOpenRegular } from './mgcIcon-layout_top_open_regular.icon';
import { mgcIconLayoutTopRegular } from './mgcIcon-layout_top_regular.icon';
import { mgcIconMagic1Regular } from './mgcIcon-magic_1_regular.icon';
import { mgcIconMagic2Regular } from './mgcIcon-magic_2_regular.icon';
import { mgcIconMagic3Regular } from './mgcIcon-magic_3_regular.icon';
import { mgcIconMagicHat2Regular } from './mgcIcon-magic_hat_2_regular.icon';
import { mgcIconMagicHatRegular } from './mgcIcon-magic_hat_regular.icon';
import { mgcIconMarkPenRegular } from './mgcIcon-mark_pen_regular.icon';
import { mgcIconMarkupRegular } from './mgcIcon-markup_regular.icon';
import { mgcIconMirrorRegular } from './mgcIcon-mirror_regular.icon';
import { mgcIconMosaicRegular } from './mgcIcon-mosaic_regular.icon';
import { mgcIconPaint2Regular } from './mgcIcon-paint_2_regular.icon';
import { mgcIconPaintBrushAiRegular } from './mgcIcon-paint_brush_ai_regular.icon';
import { mgcIconPaintBrushRegular } from './mgcIcon-paint_brush_regular.icon';
import { mgcIconPalette2Regular } from './mgcIcon-palette_2_regular.icon';
import { mgcIconPaletteRegular } from './mgcIcon-palette_regular.icon';
import { mgcIconPasterRegular } from './mgcIcon-paster_regular.icon';
import { mgcIconPenRegular } from './mgcIcon-pen_regular.icon';
import { mgcIconQuillPenAiRegular } from './mgcIcon-quill_pen_ai_regular.icon';
import { mgcIconQuillPenRegular } from './mgcIcon-quill_pen_regular.icon';
import { mgcIconRotateXRegular } from './mgcIcon-rotate_x_regular.icon';
import { mgcIconRotateYRegular } from './mgcIcon-rotate_y_regular.icon';
import { mgcIconRows2Regular } from './mgcIcon-rows_2_regular.icon';
import { mgcIconRows3Regular } from './mgcIcon-rows_3_regular.icon';
import { mgcIconRows4Regular } from './mgcIcon-rows_4_regular.icon';
import { mgcIconRulerRegular } from './mgcIcon-ruler_regular.icon';
import { mgcIconScaleRegular } from './mgcIcon-scale_regular.icon';
import { mgcIconScissors2Regular } from './mgcIcon-scissors_2_regular.icon';
import { mgcIconScissors3Regular } from './mgcIcon-scissors_3_regular.icon';
import { mgcIconScissorsRegular } from './mgcIcon-scissors_regular.icon';
import { mgcIconScreenshotRegular } from './mgcIcon-screenshot_regular.icon';
import { mgcIconSectionRegular } from './mgcIcon-section_regular.icon';
import { mgcIconShadowRegular } from './mgcIcon-shadow_regular.icon';
import { mgcIconStickerRegular } from './mgcIcon-sticker_regular.icon';
import { mgcIconSubtractRegular } from './mgcIcon-subtract_regular.icon';
import { mgcIconTable2Regular } from './mgcIcon-table_2_regular.icon';
import { mgcIconUnfoldHorizontalRegular } from './mgcIcon-unfold_horizontal_regular.icon';
import { mgcIconUnfoldVerticalRegular } from './mgcIcon-unfold_vertical_regular.icon';
import { mgcIconUnionRegular } from './mgcIcon-union_regular.icon';
import { mgcIconVectorBezier2Regular } from './mgcIcon-vector_bezier_2_regular.icon';
import { mgcIconVectorBezier3Regular } from './mgcIcon-vector_bezier_3_regular.icon';
import { mgcIconVectorBezierRegular } from './mgcIcon-vector_bezier_regular.icon';
import { mgcIconVectorGroupRegular } from './mgcIcon-vector_group_regular.icon';
import { mgcIconXSkewRegular } from './mgcIcon-x_skew_regular.icon';
import { mgcIconYSkewRegular } from './mgcIcon-y_skew_regular.icon';
import { mgcIconBracesRegular } from './mgcIcon-braces_regular.icon';
import { mgcIconBracketsAngleRegular } from './mgcIcon-brackets_angle_regular.icon';
import { mgcIconBracketsRegular } from './mgcIcon-brackets_regular.icon';
import { mgcIconBugRegular } from './mgcIcon-bug_regular.icon';
import { mgcIconCodeRegular } from './mgcIcon-code_regular.icon';
import { mgcIconCommandRegular } from './mgcIcon-command_regular.icon';
import { mgcIconCursor2Regular } from './mgcIcon-cursor_2_regular.icon';
import { mgcIconCursor3Regular } from './mgcIcon-cursor_3_regular.icon';
import { mgcIconCursorRegular } from './mgcIcon-cursor_regular.icon';
import { mgcIconDepartmentRegular } from './mgcIcon-department_regular.icon';
import { mgcIconDirectoryRegular } from './mgcIcon-directory_regular.icon';
import { mgcIconGitBranchRegular } from './mgcIcon-git_branch_regular.icon';
import { mgcIconGitCommitRegular } from './mgcIcon-git_commit_regular.icon';
import { mgcIconGitCompareRegular } from './mgcIcon-git_compare_regular.icon';
import { mgcIconGitMergeRegular } from './mgcIcon-git_merge_regular.icon';
import { mgcIconGitPullRequestCloseRegular } from './mgcIcon-git_pull_request_close_regular.icon';
import { mgcIconGitPullRequestRegular } from './mgcIcon-git_pull_request_regular.icon';
import { mgcIconHotkeyRegular } from './mgcIcon-hotkey_regular.icon';
import { mgcIconInspectRegular } from './mgcIcon-inspect_regular.icon';
import { mgcIconParenthesesRegular } from './mgcIcon-parentheses_regular.icon';
import { mgcIconPerformanceRegular } from './mgcIcon-performance_regular.icon';
import { mgcIconSitemapRegular } from './mgcIcon-sitemap_regular.icon';
import { mgcIconTerminalBoxRegular } from './mgcIcon-terminal_box_regular.icon';
import { mgcIconTerminalRegular } from './mgcIcon-terminal_regular.icon';
import { mgcIconWebRegular } from './mgcIcon-web_regular.icon';
import { mgcIconAiRegular } from './mgcIcon-ai_regular.icon';
import { mgcIconAirConditionOpenRegular } from './mgcIcon-air_condition_open_regular.icon';
import { mgcIconAirConditionRegular } from './mgcIcon-air_condition_regular.icon';
import { mgcIconAirplayRegular } from './mgcIcon-airplay_regular.icon';
import { mgcIconAirpods2Regular } from './mgcIcon-airpods_2_regular.icon';
import { mgcIconAlarm1Regular } from './mgcIcon-alarm_1_regular.icon';
import { mgcIconAlarm2Regular } from './mgcIcon-alarm_2_regular.icon';
import { mgcIconAspectRatioRegular } from './mgcIcon-aspect_ratio_regular.icon';
import { mgcIconBarcodeRegular } from './mgcIcon-barcode_regular.icon';
import { mgcIconBarcodeScaRegular } from './mgcIcon-barcode_sca_regular.icon';
import { mgcIconBaseStation2Regular } from './mgcIcon-base_station_2_regular.icon';
import { mgcIconBaseStationRegular } from './mgcIcon-base_station_regular.icon';
import { mgcIconBattery1Regular } from './mgcIcon-battery_1_regular.icon';
import { mgcIconBattery2Regular } from './mgcIcon-battery_2_regular.icon';
import { mgcIconBattery3Regular } from './mgcIcon-battery_3_regular.icon';
import { mgcIconBattery4Regular } from './mgcIcon-battery_4_regular.icon';
import { mgcIconBatteryAutomotiveRegular } from './mgcIcon-battery_automotive_regular.icon';
import { mgcIconBatteryChargingRegular } from './mgcIcon-battery_charging_regular.icon';
import { mgcIconBatteryRegular } from './mgcIcon-battery_regular.icon';
import { mgcIconBluetoothOffRegular } from './mgcIcon-bluetooth_off_regular.icon';
import { mgcIconBluetoothRegular } from './mgcIcon-bluetooth_regular.icon';
import { mgcIconBulb2Regular } from './mgcIcon-bulb_2_regular.icon';
import { mgcIconBulbRegular } from './mgcIcon-bulb_regular.icon';
import { mgcIconCamcorder2Regular } from './mgcIcon-camcorder_2_regular.icon';
import { mgcIconCardboardVrRegular } from './mgcIcon-cardboard_vr_regular.icon';
import { mgcIconCeilingLampRegular } from './mgcIcon-ceiling_lamp_regular.icon';
import { mgcIconCellphone2AiRegular } from './mgcIcon-cellphone_2_ai_regular.icon';
import { mgcIconCellphone2HorizontalRegular } from './mgcIcon-cellphone_2_horizontal_regular.icon';
import { mgcIconCellphone2Regular } from './mgcIcon-cellphone_2_regular.icon';
import { mgcIconCellphoneRegular } from './mgcIcon-cellphone_regular.icon';
import { mgcIconCellphoneVibrationRegular } from './mgcIcon-cellphone_vibration_regular.icon';
import { mgcIconChipRegular } from './mgcIcon-chip_regular.icon';
import { mgcIconComputerCamerRegular } from './mgcIcon-computer_camer_regular.icon';
import { mgcIconComputerCameraOffRegular } from './mgcIcon-computer_camera_off_regular.icon';
import { mgcIconComputerRegular } from './mgcIcon-computer_regular.icon';
import { mgcIconCounter2Regular } from './mgcIcon-counter_2_regular.icon';
import { mgcIconCube3DRegular } from './mgcIcon-cube_3d_regular.icon';
import { mgcIconDashboard2Regular } from './mgcIcon-dashboard_2_regular.icon';
import { mgcIconDashboard3Regular } from './mgcIcon-dashboard_3_regular.icon';
import { mgcIconDashboard4Regular } from './mgcIcon-dashboard_4_regular.icon';
import { mgcIconDashboardRegular } from './mgcIcon-dashboard_regular.icon';
import { mgcIconDeskLamp2Regular } from './mgcIcon-desk_lamp_2_regular.icon';
import { mgcIconDeskLampRegular } from './mgcIcon-desk_lamp_regular.icon';
import { mgcIconDeviceRegular } from './mgcIcon-device_regular.icon';
import { mgcIconDisplayRegular } from './mgcIcon-display_regular.icon';
import { mgcIconDroneRegular } from './mgcIcon-drone_regular.icon';
import { mgcIconEscalatorDownRegular } from './mgcIcon-escalator_down_regular.icon';
import { mgcIconEscalatorUpRegular } from './mgcIcon-escalator_up_regular.icon';
import { mgcIconFaxRegular } from './mgcIcon-fax_regular.icon';
import { mgcIconFlashCircleRegular } from './mgcIcon-flash_circle_regular.icon';
import { mgcIconFlashRegular } from './mgcIcon-flash_regular.icon';
import { mgcIconFlashlightRegular } from './mgcIcon-flashlight_regular.icon';
import { mgcIconFridgeRegular } from './mgcIcon-fridge_regular.icon';
import { mgcIconGame1Regular } from './mgcIcon-game_1_regular.icon';
import { mgcIconGame2Regular } from './mgcIcon-game_2_regular.icon';
import { mgcIconGradienterRegular } from './mgcIcon-gradienter_regular.icon';
import { mgcIconGuitarRegular } from './mgcIcon-guitar_regular.icon';
import { mgcIconHighVoltagePowerRegular } from './mgcIcon-high_voltage_power_regular.icon';
import { mgcIconHomeWifiRegular } from './mgcIcon-home_wifi_regular.icon';
import { mgcIconHomepodMiniRegular } from './mgcIcon-homepod_mini_regular.icon';
import { mgcIconHomepodRegular } from './mgcIcon-homepod_regular.icon';
import { mgcIconIMacRegular } from './mgcIcon-iMac_regular.icon';
import { mgcIconInstrumentRegular } from './mgcIcon-instrument_regular.icon';
import { mgcIconKeyboard2Regular } from './mgcIcon-keyboard_2_regular.icon';
import { mgcIconKeyboardRegular } from './mgcIcon-keyboard_regular.icon';
import { mgcIconLaptop2Regular } from './mgcIcon-laptop_2_regular.icon';
import { mgcIconLaptopRegular } from './mgcIcon-laptop_regular.icon';
import { mgcIconLightRegular } from './mgcIcon-light_regular.icon';
import { mgcIconMicroscopeRegular } from './mgcIcon-microscope_regular.icon';
import { mgcIconMidiRegular } from './mgcIcon-midi_regular.icon';
import { mgcIconMonitorRegular } from './mgcIcon-monitor_regular.icon';
import { mgcIconMouseRegular } from './mgcIcon-mouse_regular.icon';
import { mgcIconPadRegular } from './mgcIcon-pad_regular.icon';
import { mgcIconPanoramasRegular } from './mgcIcon-panoramas_regular.icon';
import { mgcIconPlugin2Regular } from './mgcIcon-plugin_2_regular.icon';
import { mgcIconPluginRegular } from './mgcIcon-plugin_regular.icon';
import { mgcIconPrintRegular } from './mgcIcon-print_regular.icon';
import { mgcIconProjectorRegular } from './mgcIcon-projector_regular.icon';
import { mgcIconProjectorScreenRegular } from './mgcIcon-projector_screen_regular.icon';
import { mgcIconQrcode2Regular } from './mgcIcon-qrcode_2_regular.icon';
import { mgcIconQrcodeRegular } from './mgcIcon-qrcode_regular.icon';
import { mgcIconRadaRegular } from './mgcIcon-rada_regular.icon';
import { mgcIconRadar2Regular } from './mgcIcon-radar_2_regular.icon';
import { mgcIconRadioRegular } from './mgcIcon-radio_regular.icon';
import { mgcIconRemoteControlRegular } from './mgcIcon-remote_control_regular.icon';
import { mgcIconRemoteRegular } from './mgcIcon-remote_regular.icon';
import { mgcIconRouterModemRegular } from './mgcIcon-router_modem_regular.icon';
import { mgcIconRss2Regular } from './mgcIcon-rss_2_regular.icon';
import { mgcIconRssRegular } from './mgcIcon-rss_regular.icon';
import { mgcIconSandglass2Regular } from './mgcIcon-sandglass_2_regular.icon';
import { mgcIconSandglassRegular } from './mgcIcon-sandglass_regular.icon';
import { mgcIconScan2Regular } from './mgcIcon-scan_2_regular.icon';
import { mgcIconScanRegular } from './mgcIcon-scan_regular.icon';
import { mgcIconServer2Regular } from './mgcIcon-server_2_regular.icon';
import { mgcIconServerRegular } from './mgcIcon-server_regular.icon';
import { mgcIconShowerRegular } from './mgcIcon-shower_regular.icon';
import { mgcIconSignalRegular } from './mgcIcon-signal_regular.icon';
import { mgcIconSolarPanelRegular } from './mgcIcon-solar_panel_regular.icon';
import { mgcIconSpeakerRegular } from './mgcIcon-speaker_regular.icon';
import { mgcIconStopwatchRegular } from './mgcIcon-stopwatch_regular.icon';
import { mgcIconStorageRegular } from './mgcIcon-storage_regular.icon';
import { mgcIconTelescope2Regular } from './mgcIcon-telescope_2_regular.icon';
import { mgcIconTelescopeRegular } from './mgcIcon-telescope_regular.icon';
import { mgcIconTowerCraneRegular } from './mgcIcon-tower_crane_regular.icon';
import { mgcIconTv1Regular } from './mgcIcon-tv_1_regular.icon';
import { mgcIconTv2Regular } from './mgcIcon-tv_2_regular.icon';
import { mgcIconUsbFlashDiskRegular } from './mgcIcon-usb_flash_disk_regular.icon';
import { mgcIconUsbRegular } from './mgcIcon-usb_regular.icon';
import { mgcIconVisonProRegular } from './mgcIcon-vison_pro_regular.icon';
import { mgcIconWashMachineRegular } from './mgcIcon-wash_machine_regular.icon';
import { mgcIconWatch2Regular } from './mgcIcon-watch_2_regular.icon';
import { mgcIconWatchRegular } from './mgcIcon-watch_regular.icon';
import { mgcIconWifiOffRegular } from './mgcIcon-wifi_off_regular.icon';
import { mgcIconWifiRegular } from './mgcIcon-wifi_regular.icon';
import { mgcIconAlignCenterRegular } from './mgcIcon-align_center_regular.icon';
import { mgcIconAlignJustifyRegular } from './mgcIcon-align_justify_regular.icon';
import { mgcIconAlignLeftRegular } from './mgcIcon-align_left_regular.icon';
import { mgcIconAlignRightRegular } from './mgcIcon-align_right_regular.icon';
import { mgcIconAndRegular } from './mgcIcon-and_regular.icon';
import { mgcIconAsterisk2Regular } from './mgcIcon-asterisk_2_regular.icon';
import { mgcIconAsteriskRegular } from './mgcIcon-asterisk_regular.icon';
import { mgcIconAtRegular } from './mgcIcon-at_regular.icon';
import { mgcIconAzSortAscendingLettersRegular } from './mgcIcon-AZ_sort_ascending_letters_regular.icon';
import { mgcIconAzSortDescendingLettersRegular } from './mgcIcon-AZ_sort_descending_letters_regular.icon';
import { mgcIconBlockquoteRegular } from './mgcIcon-blockquote_regular.icon';
import { mgcIconBoldRegular } from './mgcIcon-bold_regular.icon';
import { mgcIconColumnRegular } from './mgcIcon-column_regular.icon';
import { mgcIconContentAiRegular } from './mgcIcon-content_ai_regular.icon';
import { mgcIconCursorTextRegular } from './mgcIcon-cursor_text_regular.icon';
import { mgcIconDividingLineRegular } from './mgcIcon-dividing_line_regular.icon';
import { mgcIconEdit2Regular } from './mgcIcon-edit_2_regular.icon';
import { mgcIconEdit3Regular } from './mgcIcon-edit_3_regular.icon';
import { mgcIconEdit4Regular } from './mgcIcon-edit_4_regular.icon';
import { mgcIconEditRegular } from './mgcIcon-edit_regular.icon';
import { mgcIconEraserRegular } from './mgcIcon-eraser_regular.icon';
import { mgcIconFontRegular } from './mgcIcon-font_regular.icon';
import { mgcIconFontSizeRegular } from './mgcIcon-font_size_regular.icon';
import { mgcIconFormulaRegular } from './mgcIcon-formula_regular.icon';
import { mgcIconFrameRegular } from './mgcIcon-frame_regular.icon';
import { mgcIconHashtagRegular } from './mgcIcon-hashtag_regular.icon';
import { mgcIconHeading1Regular } from './mgcIcon-heading_1_regular.icon';
import { mgcIconHeading2Regular } from './mgcIcon-heading_2_regular.icon';
import { mgcIconHeading3Regular } from './mgcIcon-heading_3_regular.icon';
import { mgcIconIndentDecreaseRegular } from './mgcIcon-indent_decrease_regular.icon';
import { mgcIconIndentIncreaseRegular } from './mgcIcon-indent_increase_regular.icon';
import { mgcIconItalicRegular } from './mgcIcon-italic_regular.icon';
import { mgcIconLetterSpacingRegular } from './mgcIcon-letter_spacing_regular.icon';
import { mgcIconLineHeightRegular } from './mgcIcon-line_height_regular.icon';
import { mgcIconListCheck2Regular } from './mgcIcon-list_check_2_regular.icon';
import { mgcIconListCheck3Regular } from './mgcIcon-list_check_3_regular.icon';
import { mgcIconListCheckRegular } from './mgcIcon-list_check_regular.icon';
import { mgcIconListCollapseRegular } from './mgcIcon-list_collapse_regular.icon';
import { mgcIconListExpansionRegular } from './mgcIcon-list_expansion_regular.icon';
import { mgcIconListOrderedRegular } from './mgcIcon-list_ordered_regular.icon';
import { mgcIconListSearchRegular } from './mgcIcon-list_search_regular.icon';
import { mgcIconMenuRegular } from './mgcIcon-menu_regular.icon';
import { mgcIconNumbers09SortAscendingRegular } from './mgcIcon-numbers_09_sort_ascending_regular.icon';
import { mgcIconNumbers09SortDescendingRegular } from './mgcIcon-numbers_09_sort_descending_regular.icon';
import { mgcIconNumbers90SortAscendingRegular } from './mgcIcon-numbers_90_sort_ascending_regular.icon';
import { mgcIconNumbers90SortDescendingRegular } from './mgcIcon-numbers_90_sort_descending_regular.icon';
import { mgcIconOmegaRegular } from './mgcIcon-omega_regular.icon';
import { mgcIconPaintRegular } from './mgcIcon-paint_regular.icon';
import { mgcIconParagraphRegular } from './mgcIcon-paragraph_regular.icon';
import { mgcIconPen2Regular } from './mgcIcon-pen_2_regular.icon';
import { mgcIconPencil2AiRegular } from './mgcIcon-pencil_2_ai_regular.icon';
import { mgcIconPencil2Regular } from './mgcIcon-pencil_2_regular.icon';
import { mgcIconPencil3Regular } from './mgcIcon-pencil_3_regular.icon';
import { mgcIconPencilRegular } from './mgcIcon-pencil_regular.icon';
import { mgcIconPencilRulerRegular } from './mgcIcon-pencil_ruler_regular.icon';
import { mgcIconQuoteLeftRegular } from './mgcIcon-quote_left_regular.icon';
import { mgcIconQuoteRightRegular } from './mgcIcon-quote_right_regular.icon';
import { mgcIconSignatureRegular } from './mgcIcon-signature_regular.icon';
import { mgcIconSortAscendingRegular } from './mgcIcon-sort_ascending_regular.icon';
import { mgcIconSortDescendingRegular } from './mgcIcon-sort_descending_regular.icon';
import { mgcIconSpaceRegular } from './mgcIcon-space_regular.icon';
import { mgcIconSpacingHorizontalRegular } from './mgcIcon-spacing_horizontal_regular.icon';
import { mgcIconSpacingVerticalRegular } from './mgcIcon-spacing_vertical_regular.icon';
import { mgcIconStrikethroughRegular } from './mgcIcon-strikethrough_regular.icon';
import { mgcIconSubtitleRegular } from './mgcIcon-subtitle_regular.icon';
import { mgcIconTable3Regular } from './mgcIcon-table_3_regular.icon';
import { mgcIconTableRegular } from './mgcIcon-table_regular.icon';
import { mgcIconText2Regular } from './mgcIcon-text_2_regular.icon';
import { mgcIconTextAreaRegular } from './mgcIcon-text_area_regular.icon';
import { mgcIconTextColorRegular } from './mgcIcon-text_color_regular.icon';
import { mgcIconTextDirectionLeftRegular } from './mgcIcon-text_direction_left_regular.icon';
import { mgcIconTextDirectionRightRegular } from './mgcIcon-text_direction_right_regular.icon';
import { mgcIconTextRegular } from './mgcIcon-text_regular.icon';
import { mgcIconTextboxAiRegular } from './mgcIcon-textbox_ai_regular.icon';
import { mgcIconTextboxRegular } from './mgcIcon-textbox_regular.icon';
import { mgcIconTranslate2AiRegular } from './mgcIcon-translate_2_ai_regular.icon';
import { mgcIconTranslate2Regular } from './mgcIcon-translate_2_regular.icon';
import { mgcIconTranslateRegular } from './mgcIcon-translate_regular.icon';
import { mgcIconUnderlineRegular } from './mgcIcon-underline_regular.icon';
import { mgcIconZaSortAscendingLettersRegular } from './mgcIcon-ZA_sort_ascending_letters_regular.icon';
import { mgcIconZaSortDescendingLettersRegular } from './mgcIcon-ZA_sort_descending_letters_regular.icon';
import { mgcIconBackpackRegular } from './mgcIcon-backpack_regular.icon';
import { mgcIconBalanceRegular } from './mgcIcon-balance_regular.icon';
import { mgcIconBlackBoard2Regular } from './mgcIcon-black_board_2_regular.icon';
import { mgcIconBlackBoardRegular } from './mgcIcon-black_board_regular.icon';
import { mgcIconBook2Regular } from './mgcIcon-book_2_regular.icon';
import { mgcIconBook3Regular } from './mgcIcon-book_3_regular.icon';
import { mgcIconBook4Regular } from './mgcIcon-book_4_regular.icon';
import { mgcIconBook5Regular } from './mgcIcon-book_5_regular.icon';
import { mgcIconBook6Regular } from './mgcIcon-book_6_regular.icon';
import { mgcIconBookRegular } from './mgcIcon-book_regular.icon';
import { mgcIconBookmarkAddRegular } from './mgcIcon-bookmark_add_regular.icon';
import { mgcIconBookmarkEditRegular } from './mgcIcon-bookmark_edit_regular.icon';
import { mgcIconBookmarkRegular } from './mgcIcon-bookmark_regular.icon';
import { mgcIconBookmarkRemoveRegular } from './mgcIcon-bookmark_remove_regular.icon';
import { mgcIconBookmarksRegular } from './mgcIcon-bookmarks_regular.icon';
import { mgcIconCertificate2Regular } from './mgcIcon-certificate_2_regular.icon';
import { mgcIconCompass2Regular } from './mgcIcon-compass_2_regular.icon';
import { mgcIconCounterRegular } from './mgcIcon-counter_regular.icon';
import { mgcIconDeskRegular } from './mgcIcon-desk_regular.icon';
import { mgcIconDiaryRegular } from './mgcIcon-diary_regular.icon';
import { mgcIconDrumRegular } from './mgcIcon-drum_regular.icon';
import { mgcIconEyeglassRegular } from './mgcIcon-eyeglass_regular.icon';
import { mgcIconFlask2Regular } from './mgcIcon-flask_2_regular.icon';
import { mgcIconFlask3Regular } from './mgcIcon-flask_3_regular.icon';
import { mgcIconFlaskRegular } from './mgcIcon-flask_regular.icon';
import { mgcIconFoldingFanRegular } from './mgcIcon-folding_fan_regular.icon';
import { mgcIconGlobeRegular } from './mgcIcon-globe_regular.icon';
import { mgcIconMagnetRegular } from './mgcIcon-magnet_regular.icon';
import { mgcIconMortarboardRegular } from './mgcIcon-mortarboard_regular.icon';
import { mgcIconNotebook2Regular } from './mgcIcon-notebook_2_regular.icon';
import { mgcIconNotebookRegular } from './mgcIcon-notebook_regular.icon';
import { mgcIconScienceRegular } from './mgcIcon-science_regular.icon';
import { mgcIconSpeechRegular } from './mgcIcon-speech_regular.icon';
import { mgcIconTestTubeRegular } from './mgcIcon-test_tube_regular.icon';
import { mgcIconAngelRegular } from './mgcIcon-angel_regular.icon';
import { mgcIconAngryRegular } from './mgcIcon-angry_regular.icon';
import { mgcIconConfusedRegular } from './mgcIcon-confused_regular.icon';
import { mgcIconEmoji2Regular } from './mgcIcon-emoji_2_regular.icon';
import { mgcIconEmojiRegular } from './mgcIcon-emoji_regular.icon';
import { mgcIconHappyRegular } from './mgcIcon-happy_regular.icon';
import { mgcIconLaughRegular } from './mgcIcon-laugh_regular.icon';
import { mgcIconLookDownRegular } from './mgcIcon-look_down_regular.icon';
import { mgcIconLookLeftRegular } from './mgcIcon-look_left_regular.icon';
import { mgcIconLookRightRegular } from './mgcIcon-look_right_regular.icon';
import { mgcIconLookUpRegular } from './mgcIcon-look_up_regular.icon';
import { mgcIconOmgRegular } from './mgcIcon-omg_regular.icon';
import { mgcIconPuzzledRegular } from './mgcIcon-puzzled_regular.icon';
import { mgcIconSadRegular } from './mgcIcon-sad_regular.icon';
import { mgcIconSickRegular } from './mgcIcon-sick_regular.icon';
import { mgcIconSilentRegular } from './mgcIcon-silent_regular.icon';
import { mgcIconSobRegular } from './mgcIcon-sob_regular.icon';
import { mgcIconSurpriseRegular } from './mgcIcon-surprise_regular.icon';
import { mgcIconSweatsRegular } from './mgcIcon-sweats_regular.icon';
import { mgcIconTerrorRegular } from './mgcIcon-terror_regular.icon';
import { mgcIconTongueRegular } from './mgcIcon-tongue_regular.icon';
import { mgcIconUnhappyDizzyRegular } from './mgcIcon-unhappy_dizzy_regular.icon';
import { mgcIconUnhappyRegular } from './mgcIcon-unhappy_regular.icon';
import { mgcIconAlbum2Regular } from './mgcIcon-album_2_regular.icon';
import { mgcIconArchiveRegular } from './mgcIcon-archive_regular.icon';
import { mgcIconAttachment2Regular } from './mgcIcon-attachment_2_regular.icon';
import { mgcIconAttachmentRegular } from './mgcIcon-attachment_regular.icon';
import { mgcIconBill2Regular } from './mgcIcon-bill_2_regular.icon';
import { mgcIconBillRegular } from './mgcIcon-bill_regular.icon';
import { mgcIconBox2Regular } from './mgcIcon-box_2_regular.icon';
import { mgcIconBox3Regular } from './mgcIcon-box_3_regular.icon';
import { mgcIconBoxRegular } from './mgcIcon-box_regular.icon';
import { mgcIconClipboardRegular } from './mgcIcon-clipboard_regular.icon';
import { mgcIconCopy2Regular } from './mgcIcon-copy_2_regular.icon';
import { mgcIconCopy3Regular } from './mgcIcon-copy_3_regular.icon';
import { mgcIconCopyRegular } from './mgcIcon-copy_regular.icon';
import { mgcIconDocRegular } from './mgcIcon-doc_regular.icon';
import { mgcIconDocmentRegular } from './mgcIcon-docment_regular.icon';
import { mgcIconDocument2Regular } from './mgcIcon-document_2_regular.icon';
import { mgcIconDocument3Regular } from './mgcIcon-document_3_regular.icon';
import { mgcIconDocumentsRegular } from './mgcIcon-documents_regular.icon';
import { mgcIconDownload2Regular } from './mgcIcon-download_2_regular.icon';
import { mgcIconDownload3Regular } from './mgcIcon-download_3_regular.icon';
import { mgcIconDownloadRegular } from './mgcIcon-download_regular.icon';
import { mgcIconEmptyBoxRegular } from './mgcIcon-empty_box_regular.icon';
import { mgcIconExternalLinkRegular } from './mgcIcon-external_link_regular.icon';
import { mgcIconFileCertificateRegular } from './mgcIcon-file_certificate_regular.icon';
import { mgcIconFileCheckRegular } from './mgcIcon-file_check_regular.icon';
import { mgcIconFileCodeRegular } from './mgcIcon-file_code_regular.icon';
import { mgcIconFileDownloadRegular } from './mgcIcon-file_download_regular.icon';
import { mgcIconFileExportRegular } from './mgcIcon-file_export_regular.icon';
import { mgcIconFileForbidRegular } from './mgcIcon-file_forbid_regular.icon';
import { mgcIconFileImportRegular } from './mgcIcon-file_import_regular.icon';
import { mgcIconFileInfoRegular } from './mgcIcon-file_info_regular.icon';
import { mgcIconFileLockedRegular } from './mgcIcon-file_locked_regular.icon';
import { mgcIconFileMoreRegular } from './mgcIcon-file_more_regular.icon';
import { mgcIconFileMusicRegular } from './mgcIcon-file_music_regular.icon';
import { mgcIconFileNewRegular } from './mgcIcon-file_new_regular.icon';
import { mgcIconFileRegular } from './mgcIcon-file_regular.icon';
import { mgcIconFileSearchRegular } from './mgcIcon-file_search_regular.icon';
import { mgcIconFileSecurityRegular } from './mgcIcon-file_security_regular.icon';
import { mgcIconFileStarRegular } from './mgcIcon-file_star_regular.icon';
import { mgcIconFileUnknownRegular } from './mgcIcon-file_unknown_regular.icon';
import { mgcIconFileUploadRegular } from './mgcIcon-file_upload_regular.icon';
import { mgcIconFileWarningRegular } from './mgcIcon-file_warning_regular.icon';
import { mgcIconFileZipRegular } from './mgcIcon-file_zip_regular.icon';
import { mgcIconFolder2Regular } from './mgcIcon-folder_2_regular.icon';
import { mgcIconFolder3Regular } from './mgcIcon-folder_3_regular.icon';
import { mgcIconFolderCheckRegular } from './mgcIcon-folder_check_regular.icon';
import { mgcIconFolderDeleteRegular } from './mgcIcon-folder_delete_regular.icon';
import { mgcIconFolderDownloadRegular } from './mgcIcon-folder_download_regular.icon';
import { mgcIconFolderForbidRegular } from './mgcIcon-folder_forbid_regular.icon';
import { mgcIconFolderInfoRegular } from './mgcIcon-folder_info_regular.icon';
import { mgcIconFolderLocked2Regular } from './mgcIcon-folder_locked_2_regular.icon';
import { mgcIconFolderLockedRegular } from './mgcIcon-folder_locked_regular.icon';
import { mgcIconFolderMinusRegular } from './mgcIcon-folder_minus_regular.icon';
import { mgcIconFolderMoreRegular } from './mgcIcon-folder_more_regular.icon';
import { mgcIconFolderOpen2Regular } from './mgcIcon-folder_open_2_regular.icon';
import { mgcIconFolderOpenRegular } from './mgcIcon-folder_open_regular.icon';
import { mgcIconFolderRegular } from './mgcIcon-folder_regular.icon';
import { mgcIconFolderSecurityRegular } from './mgcIcon-folder_security_regular.icon';
import { mgcIconFolderStarRegular } from './mgcIcon-folder_star_regular.icon';
import { mgcIconFolderUploadRegular } from './mgcIcon-folder_upload_regular.icon';
import { mgcIconFolderWarningRegular } from './mgcIcon-folder_warning_regular.icon';
import { mgcIconFolderZipRegular } from './mgcIcon-folder_zip_regular.icon';
import { mgcIconFoldersRegular } from './mgcIcon-folders_regular.icon';
import { mgcIconInbox2Regular } from './mgcIcon-inbox_2_regular.icon';
import { mgcIconInboxRegular } from './mgcIcon-inbox_regular.icon';
import { mgcIconInventoryRegular } from './mgcIcon-inventory_regular.icon';
import { mgcIconLink2Regular } from './mgcIcon-link_2_regular.icon';
import { mgcIconLink3Regular } from './mgcIcon-link_3_regular.icon';
import { mgcIconLinkRegular } from './mgcIcon-link_regular.icon';
import { mgcIconMarkdownRegular } from './mgcIcon-markdown_regular.icon';
import { mgcIconNewFolderRegular } from './mgcIcon-new_folder_regular.icon';
import { mgcIconNews2Regular } from './mgcIcon-news_2_regular.icon';
import { mgcIconNewsRegular } from './mgcIcon-news_regular.icon';
import { mgcIconPackage2Regular } from './mgcIcon-package_2_regular.icon';
import { mgcIconPackageRegular } from './mgcIcon-package_regular.icon';
import { mgcIconPaper2Regular } from './mgcIcon-paper_2_regular.icon';
import { mgcIconPaperRegular } from './mgcIcon-paper_regular.icon';
import { mgcIconPassportRegular } from './mgcIcon-passport_regular.icon';
import { mgcIconPasteRegular } from './mgcIcon-paste_regular.icon';
import { mgcIconPdfRegular } from './mgcIcon-pdf_regular.icon';
import { mgcIconPhotoAlbum2Regular } from './mgcIcon-photo_album_2_regular.icon';
import { mgcIconPhotoAlbumRegular } from './mgcIcon-photo_album_regular.icon';
import { mgcIconPic2Regular } from './mgcIcon-pic_2_regular.icon';
import { mgcIconPicAiRegular } from './mgcIcon-pic_ai_regular.icon';
import { mgcIconPicRegular } from './mgcIcon-pic_regular.icon';
import { mgcIconPin2Regular } from './mgcIcon-pin_2_regular.icon';
import { mgcIconPinRegular } from './mgcIcon-pin_regular.icon';
import { mgcIconPptRegular } from './mgcIcon-ppt_regular.icon';
import { mgcIconProfileRegular } from './mgcIcon-profile_regular.icon';
import { mgcIconReportFormsRegular } from './mgcIcon-report_forms_regular.icon';
import { mgcIconSave2Regular } from './mgcIcon-save_2_regular.icon';
import { mgcIconSaveRegular } from './mgcIcon-save_regular.icon';
import { mgcIconSearch2Regular } from './mgcIcon-search_2_regular.icon';
import { mgcIconSearch3Regular } from './mgcIcon-search_3_regular.icon';
import { mgcIconSearchAiRegular } from './mgcIcon-search_ai_regular.icon';
import { mgcIconSearchRegular } from './mgcIcon-search_regular.icon';
import { mgcIconTask2Regular } from './mgcIcon-task_2_regular.icon';
import { mgcIconTaskRegular } from './mgcIcon-task_regular.icon';
import { mgcIconToDoRegular } from './mgcIcon-to_do_regular.icon';
import { mgcIconUnarchiveRegular } from './mgcIcon-unarchive_regular.icon';
import { mgcIconUnlink2Regular } from './mgcIcon-unlink_2_regular.icon';
import { mgcIconUnlinkRegular } from './mgcIcon-unlink_regular.icon';
import { mgcIconUpload2Regular } from './mgcIcon-upload_2_regular.icon';
import { mgcIconUpload3Regular } from './mgcIcon-upload_3_regular.icon';
import { mgcIconUploadRegular } from './mgcIcon-upload_regular.icon';
import { mgcIconXlsRegular } from './mgcIcon-xls_regular.icon';
import { mgcIconZoomInRegular } from './mgcIcon-zoom_in_regular.icon';
import { mgcIconZoomOutRegular } from './mgcIcon-zoom_out_regular.icon';
import { mgcIconBirthday2Regular } from './mgcIcon-birthday_2_regular.icon';
import { mgcIconBoneRegular } from './mgcIcon-bone_regular.icon';
import { mgcIconBottleGlassRegular } from './mgcIcon-bottle_glass_regular.icon';
import { mgcIconBowl2Regular } from './mgcIcon-bowl_2_regular.icon';
import { mgcIconBowlRegular } from './mgcIcon-bowl_regular.icon';
import { mgcIconBreadRegular } from './mgcIcon-bread_regular.icon';
import { mgcIconCakeRegular } from './mgcIcon-cake_regular.icon';
import { mgcIconCandy2Regular } from './mgcIcon-candy_2_regular.icon';
import { mgcIconCandyRegular } from './mgcIcon-candy_regular.icon';
import { mgcIconCarrotRegular } from './mgcIcon-carrot_regular.icon';
import { mgcIconChampagneRegular } from './mgcIcon-champagne_regular.icon';
import { mgcIconChickenRegular } from './mgcIcon-chicken_regular.icon';
import { mgcIconChopsticksRegular } from './mgcIcon-chopsticks_regular.icon';
import { mgcIconCookieManRegular } from './mgcIcon-cookie_man_regular.icon';
import { mgcIconCookieRegular } from './mgcIcon-cookie_regular.icon';
import { mgcIconCupcakeRegular } from './mgcIcon-cupcake_regular.icon';
import { mgcIconDinnerRegular } from './mgcIcon-dinner_regular.icon';
import { mgcIconDishCoverRegular } from './mgcIcon-dish_cover_regular.icon';
import { mgcIconDonutRegular } from './mgcIcon-donut_regular.icon';
import { mgcIconDrinkRegular } from './mgcIcon-drink_regular.icon';
import { mgcIconEggCrackRegular } from './mgcIcon-egg_crack_regular.icon';
import { mgcIconEggRegular } from './mgcIcon-egg_regular.icon';
import { mgcIconElectricCookerRegular } from './mgcIcon-electric_cooker_regular.icon';
import { mgcIconFeederRegular } from './mgcIcon-feeder_regular.icon';
import { mgcIconFishRegular } from './mgcIcon-fish_regular.icon';
import { mgcIconForkKnifeRegular } from './mgcIcon-fork_knife_regular.icon';
import { mgcIconForkRegular } from './mgcIcon-fork_regular.icon';
import { mgcIconForkSpoonRegular } from './mgcIcon-fork_spoon_regular.icon';
import { mgcIconFriedEggRegular } from './mgcIcon-fried_egg_regular.icon';
import { mgcIconFriesRegular } from './mgcIcon-fries_regular.icon';
import { mgcIconGlassCupRegular } from './mgcIcon-glass_cup_regular.icon';
import { mgcIconHamburgerRegular } from './mgcIcon-hamburger_regular.icon';
import { mgcIconIceCream2Regular } from './mgcIcon-ice_cream_2_regular.icon';
import { mgcIconIceCreamRegular } from './mgcIcon-ice_cream_regular.icon';
import { mgcIconLollipopRegular } from './mgcIcon-lollipop_regular.icon';
import { mgcIconPizzaRegular } from './mgcIcon-pizza_regular.icon';
import { mgcIconSoupPot2Regular } from './mgcIcon-soup_pot_2_regular.icon';
import { mgcIconSoupPotRegular } from './mgcIcon-soup_pot_regular.icon';
import { mgcIconSpatulaRegular } from './mgcIcon-spatula_regular.icon';
import { mgcIconSpoonRegular } from './mgcIcon-spoon_regular.icon';
import { mgcIconSugarCoatedHawsRegular } from './mgcIcon-sugar_coated_haws_regular.icon';
import { mgcIconTeacupRegular } from './mgcIcon-teacup_regular.icon';
import { mgcIconWineRegular } from './mgcIcon-wine_regular.icon';
import { mgcIconWineglass2Regular } from './mgcIcon-wineglass_2_regular.icon';
import { mgcIconWineglassRegular } from './mgcIcon-wineglass_regular.icon';
import { mgcIconAirbnbRegular } from './mgcIcon-airbnb_regular.icon';
import { mgcIconAirdropRegular } from './mgcIcon-airdrop_regular.icon';
import { mgcIconAlipayRegular } from './mgcIcon-alipay_regular.icon';
import { mgcIconAndroid2Regular } from './mgcIcon-Android_2_regular.icon';
import { mgcIconAndroidRegular } from './mgcIcon-android_regular.icon';
import { mgcIconAppleIntelligenceFrameRegular } from './mgcIcon-apple_intelligence_frame_regular.icon';
import { mgcIconAppleIntelligenceRegular } from './mgcIcon-apple_intelligence_regular.icon';
import { mgcIconAppleRegular } from './mgcIcon-apple_regular.icon';
import { mgcIconAppstoreRegular } from './mgcIcon-appstore_regular.icon';
import { mgcIconArcBrowserRegular } from './mgcIcon-arc_browser_regular.icon';
import { mgcIconBehanceRegular } from './mgcIcon-behance_regular.icon';
import { mgcIconBilibiliRegular } from './mgcIcon-bilibili_regular.icon';
import { mgcIconBlueskeySocialRegular } from './mgcIcon-blueskey_social_regular.icon';
import { mgcIconCarplayRegular } from './mgcIcon-carplay_regular.icon';
import { mgcIconChromeRegular } from './mgcIcon-chrome_regular.icon';
import { mgcIconCodepenRegular } from './mgcIcon-codepen_regular.icon';
import { mgcIconCopilotRegular } from './mgcIcon-copilot_regular.icon';
import { mgcIconDingtalkRegular } from './mgcIcon-dingtalk_regular.icon';
import { mgcIconDiscordRegular } from './mgcIcon-discord_regular.icon';
import { mgcIconDribbbleRegular } from './mgcIcon-dribbble_regular.icon';
import { mgcIconDriveRegular } from './mgcIcon-drive_regular.icon';
import { mgcIconDropboxRegular } from './mgcIcon-dropbox_regular.icon';
import { mgcIconEdgeRegular } from './mgcIcon-edge_regular.icon';
import { mgcIconFacebookRegular } from './mgcIcon-facebook_regular.icon';
import { mgcIconFigmaRegular } from './mgcIcon-figma_regular.icon';
import { mgcIconFirefoxRegular } from './mgcIcon-firefox_regular.icon';
import { mgcIconFollowRegular } from './mgcIcon-follow_regular.icon';
import { mgcIconGitLabRegular } from './mgcIcon-git_lab_regular.icon';
import { mgcIconGithub2Regular } from './mgcIcon-github_2_regular.icon';
import { mgcIconGithubRegular } from './mgcIcon-github_regular.icon';
import { mgcIconGooglePlayRegular } from './mgcIcon-google_play_regular.icon';
import { mgcIconGoogleRegular } from './mgcIcon-google_regular.icon';
import { mgcIconGrokRegular } from './mgcIcon-grok_regular.icon';
import { mgcIconGumroadRegular } from './mgcIcon-gumroad_regular.icon';
import { mgcIconInstagramRegular } from './mgcIcon-instagram_regular.icon';
import { mgcIconKakaoTalkRegular } from './mgcIcon-kakao_talk_regular.icon';
import { mgcIconLayersRegular } from './mgcIcon-layers_regular.icon';
import { mgcIconLemonSqueezyRegular } from './mgcIcon-lemon_squeezy_regular.icon';
import { mgcIconLineAppRegular } from './mgcIcon-line_app_regular.icon';
import { mgcIconLinearRegular } from './mgcIcon-linear_regular.icon';
import { mgcIconLinkedinRegular } from './mgcIcon-linkedin_regular.icon';
import { mgcIconLinuxRegular } from './mgcIcon-linux_regular.icon';
import { mgcIconMastercardRegular } from './mgcIcon-mastercard_regular.icon';
import { mgcIconMastodonRegular } from './mgcIcon-mastodon_regular.icon';
import { mgcIconMediumRegular } from './mgcIcon-medium_regular.icon';
import { mgcIconMessengerRegular } from './mgcIcon-messenger_regular.icon';
import { mgcIconMetaRegular } from './mgcIcon-meta_regular.icon';
import { mgcIconMingcuteRegular } from './mgcIcon-mingcute_regular.icon';
import { mgcIconMomentRegular } from './mgcIcon-moment_regular.icon';
import { mgcIconNeteaseMusicRegular } from './mgcIcon-netease_music_regular.icon';
import { mgcIconNfcRegular } from './mgcIcon-nfc_regular.icon';
import { mgcIconNintendoSwitchRegular } from './mgcIcon-nintendo_switch_regular.icon';
import { mgcIconNotionRegular } from './mgcIcon-notion_regular.icon';
import { mgcIconOpenaiRegular } from './mgcIcon-openai_regular.icon';
import { mgcIconPaypalRegular } from './mgcIcon-paypal_regular.icon';
import { mgcIconPinterestRegular } from './mgcIcon-pinterest_regular.icon';
import { mgcIconQqRegular } from './mgcIcon-qq_regular.icon';
import { mgcIconReactRegular } from './mgcIcon-react_regular.icon';
import { mgcIconRedditRegular } from './mgcIcon-reddit_regular.icon';
import { mgcIconSafariRegular } from './mgcIcon-safari_regular.icon';
import { mgcIconSiriFrameRegular } from './mgcIcon-siri_frame_regular.icon';
import { mgcIconSiriRegular } from './mgcIcon-siri_regular.icon';
import { mgcIconSnapchatRegular } from './mgcIcon-snapchat_regular.icon';
import { mgcIconSocialXRegular } from './mgcIcon-social_x_regular.icon';
import { mgcIconSpotifyRegular } from './mgcIcon-spotify_regular.icon';
import { mgcIconStripeRegular } from './mgcIcon-stripe_regular.icon';
import { mgcIconTelegramRegular } from './mgcIcon-telegram_regular.icon';
import { mgcIconThreadsRegular } from './mgcIcon-threads_regular.icon';
import { mgcIconTiktokRegular } from './mgcIcon-tiktok_regular.icon';
import { mgcIconTrelloBoardRegular } from './mgcIcon-trello_board_regular.icon';
import { mgcIconTwitterRegular } from './mgcIcon-twitter_regular.icon';
import { mgcIconViberMessengerRegular } from './mgcIcon-viber_messenger_regular.icon';
import { mgcIconVisaRegular } from './mgcIcon-visa_regular.icon';
import { mgcIconVkontakteRegular } from './mgcIcon-vkontakte_regular.icon';
import { mgcIconVscodeRegular } from './mgcIcon-vscode_regular.icon';
import { mgcIconVueRegular } from './mgcIcon-vue_regular.icon';
import { mgcIconWechatMiniprogramRegular } from './mgcIcon-wechat_miniprogram_regular.icon';
import { mgcIconWechatPayRegular } from './mgcIcon-wechat_pay_regular.icon';
import { mgcIconWechatRegular } from './mgcIcon-wechat_regular.icon';
import { mgcIconWeiboRegular } from './mgcIcon-weibo_regular.icon';
import { mgcIconWhatsappRegular } from './mgcIcon-whatsapp_regular.icon';
import { mgcIconWindowsRegular } from './mgcIcon-windows_regular.icon';
import { mgcIconXboxRegular } from './mgcIcon-xbox_regular.icon';
import { mgcIconYoutubeRegular } from './mgcIcon-youtube_regular.icon';
import { mgcIconAiming2Regular } from './mgcIcon-aiming_2_regular.icon';
import { mgcIconAimingRegular } from './mgcIcon-aiming_regular.icon';
import { mgcIconAnchorRegular } from './mgcIcon-anchor_regular.icon';
import { mgcIconBed2Regular } from './mgcIcon-bed_2_regular.icon';
import { mgcIconBedRegular } from './mgcIcon-bed_regular.icon';
import { mgcIconClock2Regular } from './mgcIcon-clock_2_regular.icon';
import { mgcIconClockRegular } from './mgcIcon-clock_regular.icon';
import { mgcIconCompass3Regular } from './mgcIcon-compass_3_regular.icon';
import { mgcIconCompassRegular } from './mgcIcon-compass_regular.icon';
import { mgcIconDirections2Regular } from './mgcIcon-directions_2_regular.icon';
import { mgcIconDirectionsRegular } from './mgcIcon-directions_regular.icon';
import { mgcIconEarth2Regular } from './mgcIcon-earth_2_regular.icon';
import { mgcIconEarth3Regular } from './mgcIcon-earth_3_regular.icon';
import { mgcIconEarthLatitudeRegular } from './mgcIcon-earth_latitude_regular.icon';
import { mgcIconEarthLongitudeRegular } from './mgcIcon-earth_longitude_regular.icon';
import { mgcIconEarthRegular } from './mgcIcon-earth_regular.icon';
import { mgcIconFootRegular } from './mgcIcon-foot_regular.icon';
import { mgcIconGlobe2Regular } from './mgcIcon-globe_2_regular.icon';
import { mgcIconHoursRegular } from './mgcIcon-hours_regular.icon';
import { mgcIconLifebuoyRegular } from './mgcIcon-lifebuoy_regular.icon';
import { mgcIconLiveLocationRegular } from './mgcIcon-live_location_regular.icon';
import { mgcIconLocation2Regular } from './mgcIcon-location_2_regular.icon';
import { mgcIconLocation3Regular } from './mgcIcon-location_3_regular.icon';
import { mgcIconLocationRegular } from './mgcIcon-location_regular.icon';
import { mgcIconMap2Regular } from './mgcIcon-map_2_regular.icon';
import { mgcIconMapPinRegular } from './mgcIcon-map_pin_regular.icon';
import { mgcIconMapRegular } from './mgcIcon-map_regular.icon';
import { mgcIconNavigationRegular } from './mgcIcon-navigation_regular.icon';
import { mgcIconParkingRegular } from './mgcIcon-parking_regular.icon';
import { mgcIconPlanetRegular } from './mgcIcon-planet_regular.icon';
import { mgcIconRestAreaRegular } from './mgcIcon-rest_area_regular.icon';
import { mgcIconRoadRegular } from './mgcIcon-road_regular.icon';
import { mgcIconRouteRegular } from './mgcIcon-route_regular.icon';
import { mgcIconTrafficConeRegular } from './mgcIcon-traffic_cone_regular.icon';
import { mgcIconTunnelRegular } from './mgcIcon-tunnel_regular.icon';
import { mgcIconUmbrella2Regular } from './mgcIcon-umbrella_2_regular.icon';
import { mgcIconWorld2Regular } from './mgcIcon-world_2_regular.icon';
import { mgcIconWorldRegular } from './mgcIcon-world_regular.icon';
import { mgcIconAirpodsRegular } from './mgcIcon-airpods_regular.icon';
import { mgcIconAlbumRegular } from './mgcIcon-album_regular.icon';
import { mgcIconAnnouncementRegular } from './mgcIcon-announcement_regular.icon';
import { mgcIconAudioTapeRegular } from './mgcIcon-audio_tape_regular.icon';
import { mgcIconBellRingingRegular } from './mgcIcon-bell_ringing_regular.icon';
import { mgcIconCamcorder3Regular } from './mgcIcon-camcorder_3_regular.icon';
import { mgcIconCamcorderOffRegular } from './mgcIcon-camcorder_off_regular.icon';
import { mgcIconCamcorderRegular } from './mgcIcon-camcorder_regular.icon';
import { mgcIconCamera2AiRegular } from './mgcIcon-camera_2_ai_regular.icon';
import { mgcIconCamera2OffRegular } from './mgcIcon-camera_2_off_regular.icon';
import { mgcIconCamera2Regular } from './mgcIcon-camera_2_regular.icon';
import { mgcIconCameraRegular } from './mgcIcon-camera_regular.icon';
import { mgcIconCameraRotateRegular } from './mgcIcon-camera_rotate_regular.icon';
import { mgcIconClapperboardRegular } from './mgcIcon-clapperboard_regular.icon';
import { mgcIconDanmakuOffRegular } from './mgcIcon-danmaku_off_regular.icon';
import { mgcIconDanmakuOnRegular } from './mgcIcon-danmaku_on_regular.icon';
import { mgcIconDanmakuRegular } from './mgcIcon-danmaku_regular.icon';
import { mgcIconDiscRegular } from './mgcIcon-disc_regular.icon';
import { mgcIconExpandPlayerRegular } from './mgcIcon-expand_player_regular.icon';
import { mgcIconFastForwardRegular } from './mgcIcon-fast_forward_regular.icon';
import { mgcIconFastRewindRegular } from './mgcIcon-fast_rewind_regular.icon';
import { mgcIconFilmRegular } from './mgcIcon-film_regular.icon';
import { mgcIconFullscreenExitRegular } from './mgcIcon-fullscreen_exit_regular.icon';
import { mgcIconFullscreenRegular } from './mgcIcon-fullscreen_regular.icon';
import { mgcIconHeadphone2Regular } from './mgcIcon-headphone_2_regular.icon';
import { mgcIconHeadphoneRegular } from './mgcIcon-headphone_regular.icon';
import { mgcIconHorn2Regular } from './mgcIcon-horn_2_regular.icon';
import { mgcIconHornRegular } from './mgcIcon-horn_regular.icon';
import { mgcIconLivePhotoRegular } from './mgcIcon-live_photo_regular.icon';
import { mgcIconLiveRegular } from './mgcIcon-live_regular.icon';
import { mgcIconMic2Regular } from './mgcIcon-mic_2_regular.icon';
import { mgcIconMicAiRegular } from './mgcIcon-mic_ai_regular.icon';
import { mgcIconMicOffRegular } from './mgcIcon-mic_off_regular.icon';
import { mgcIconMicRegular } from './mgcIcon-mic_regular.icon';
import { mgcIconMicrophoneRegular } from './mgcIcon-microphone_regular.icon';
import { mgcIconMiniplayerRegular } from './mgcIcon-miniplayer_regular.icon';
import { mgcIconMovieRegular } from './mgcIcon-movie_regular.icon';
import { mgcIconMusic2AiRegular } from './mgcIcon-music_2_ai_regular.icon';
import { mgcIconMusic2Regular } from './mgcIcon-music_2_regular.icon';
import { mgcIconMusic3Regular } from './mgcIcon-music_3_regular.icon';
import { mgcIconMusicRegular } from './mgcIcon-music_regular.icon';
import { mgcIconNotificationNewdotRegular } from './mgcIcon-notification_newdot_regular.icon';
import { mgcIconNotificationOffRegular } from './mgcIcon-notification_off_regular.icon';
import { mgcIconNotificationRegular } from './mgcIcon-notification_regular.icon';
import { mgcIconPauseCircleRegular } from './mgcIcon-pause_circle_regular.icon';
import { mgcIconPauseRegular } from './mgcIcon-pause_regular.icon';
import { mgcIconPlayCircleRegular } from './mgcIcon-play_circle_regular.icon';
import { mgcIconPlayRegular } from './mgcIcon-play_regular.icon';
import { mgcIconPlaylist2Regular } from './mgcIcon-playlist_2_regular.icon';
import { mgcIconPlaylistRegular } from './mgcIcon-playlist_regular.icon';
import { mgcIconRecordMailRegular } from './mgcIcon-record_mail_regular.icon';
import { mgcIconRepeatOneRegular } from './mgcIcon-repeat_one_regular.icon';
import { mgcIconRepeatRegular } from './mgcIcon-repeat_regular.icon';
import { mgcIconRewindBackward10Regular } from './mgcIcon-rewind_backward_10_regular.icon';
import { mgcIconRewindBackward15Regular } from './mgcIcon-rewind_backward_15_regular.icon';
import { mgcIconRewindBackward30Regular } from './mgcIcon-rewind_backward_30_regular.icon';
import { mgcIconRewindBackward5Regular } from './mgcIcon-rewind_backward_5_regular.icon';
import { mgcIconRewindBackwardSquare10Regular } from './mgcIcon-rewind_backward_square_10_regular.icon';
import { mgcIconRewindBackwardSquare15Regular } from './mgcIcon-rewind_backward_square_15_regular.icon';
import { mgcIconRewindBackwardSquare30Regular } from './mgcIcon-rewind_backward_square_30_regular.icon';
import { mgcIconRewindBackwardSquare5Regular } from './mgcIcon-rewind_backward_square_5_regular.icon';
import { mgcIconRewindForward10Regular } from './mgcIcon-rewind_forward_10_regular.icon';
import { mgcIconRewindForward15Regular } from './mgcIcon-rewind_forward_15_regular.icon';
import { mgcIconRewindForward30Regular } from './mgcIcon-rewind_forward_30_regular.icon';
import { mgcIconRewindForward5Regular } from './mgcIcon-rewind_forward_5_regular.icon';
import { mgcIconRewindForwardSquare10Regular } from './mgcIcon-rewind_forward_square_10_regular.icon';
import { mgcIconRewindForwardSquare15Regular } from './mgcIcon-rewind_forward_square_15_regular.icon';
import { mgcIconRewindForwardSquare30Regular } from './mgcIcon-rewind_forward_square_30_regular.icon';
import { mgcIconRewindForwardSquare5Regular } from './mgcIcon-rewind_forward_square_5_regular.icon';
import { mgcIconRotateToHorizontalRegular } from './mgcIcon-rotate_to_horizontal_regular.icon';
import { mgcIconRotateToVerticalRegular } from './mgcIcon-rotate_to_vertical_regular.icon';
import { mgcIconServiceRegular } from './mgcIcon-service_regular.icon';
import { mgcIconShuffle2Regular } from './mgcIcon-shuffle_2_regular.icon';
import { mgcIconShuffleRegular } from './mgcIcon-shuffle_regular.icon';
import { mgcIconSkipForwardRegular } from './mgcIcon-skip_forward_regular.icon';
import { mgcIconSkipPreviousRegular } from './mgcIcon-skip_previous_regular.icon';
import { mgcIconSoundLineRegular } from './mgcIcon-sound_line_regular.icon';
import { mgcIconStopCircleRegular } from './mgcIcon-stop_circle_regular.icon';
import { mgcIconStopRegular } from './mgcIcon-stop_regular.icon';
import { mgcIconVideoCamera2Regular } from './mgcIcon-video_camera_2_regular.icon';
import { mgcIconVideoCameraRegular } from './mgcIcon-video_camera_regular.icon';
import { mgcIconVideoRegular } from './mgcIcon-video_regular.icon';
import { mgcIconVoice2Regular } from './mgcIcon-voice_2_regular.icon';
import { mgcIconVoiceRegular } from './mgcIcon-voice_regular.icon';
import { mgcIconVolumeMuteRegular } from './mgcIcon-volume_mute_regular.icon';
import { mgcIconVolumeOffRegular } from './mgcIcon-volume_off_regular.icon';
import { mgcIconVolumeRegular } from './mgcIcon-volume_regular.icon';
import { mgcIconBearRegular } from './mgcIcon-bear_regular.icon';
import { mgcIconBirdRegular } from './mgcIcon-bird_regular.icon';
import { mgcIconButterfly2Regular } from './mgcIcon-butterfly_2_regular.icon';
import { mgcIconButterflyRegular } from './mgcIcon-butterfly_regular.icon';
import { mgcIconCactus2Regular } from './mgcIcon-cactus_2_regular.icon';
import { mgcIconCactusRegular } from './mgcIcon-cactus_regular.icon';
import { mgcIconCampfireRegular } from './mgcIcon-campfire_regular.icon';
import { mgcIconCatRegular } from './mgcIcon-cat_regular.icon';
import { mgcIconChessRegular } from './mgcIcon-chess_regular.icon';
import { mgcIconDandelionRegular } from './mgcIcon-dandelion_regular.icon';
import { mgcIconDogRegular } from './mgcIcon-dog_regular.icon';
import { mgcIconDragonflyRegular } from './mgcIcon-dragonfly_regular.icon';
import { mgcIconFlower2Regular } from './mgcIcon-flower_2_regular.icon';
import { mgcIconFlower3Regular } from './mgcIcon-flower_3_regular.icon';
import { mgcIconFlower4Regular } from './mgcIcon-flower_4_regular.icon';
import { mgcIconFlower5Regular } from './mgcIcon-flower_5_regular.icon';
import { mgcIconFlowerRegular } from './mgcIcon-flower_regular.icon';
import { mgcIconFlowerpotRegular } from './mgcIcon-flowerpot_regular.icon';
import { mgcIconGrassRegular } from './mgcIcon-grass_regular.icon';
import { mgcIconLeaf2Regular } from './mgcIcon-leaf_2_regular.icon';
import { mgcIconLeaf3Regular } from './mgcIcon-leaf_3_regular.icon';
import { mgcIconLeafRegular } from './mgcIcon-leaf_regular.icon';
import { mgcIconLotusRegular } from './mgcIcon-lotus_regular.icon';
import { mgcIconMapleLeafRegular } from './mgcIcon-maple_leaf_regular.icon';
import { mgcIconMickeymouseRegular } from './mgcIcon-mickeymouse_regular.icon';
import { mgcIconMountain2Regular } from './mgcIcon-mountain_2_regular.icon';
import { mgcIconMountainRegular } from './mgcIcon-mountain_regular.icon';
import { mgcIconMushroomRegular } from './mgcIcon-mushroom_regular.icon';
import { mgcIconPawRegular } from './mgcIcon-paw_regular.icon';
import { mgcIconPigRegular } from './mgcIcon-pig_regular.icon';
import { mgcIconPumpkinRegular } from './mgcIcon-pumpkin_regular.icon';
import { mgcIconRabbitRegular } from './mgcIcon-rabbit_regular.icon';
import { mgcIconSunflowerRegular } from './mgcIcon-sunflower_regular.icon';
import { mgcIconToyHorseRegular } from './mgcIcon-toy_horse_regular.icon';
import { mgcIconTree2Regular } from './mgcIcon-tree_2_regular.icon';
import { mgcIconTree3Regular } from './mgcIcon-tree_3_regular.icon';
import { mgcIconTree4Regular } from './mgcIcon-tree_4_regular.icon';
import { mgcIconTreeRegular } from './mgcIcon-tree_regular.icon';
import { mgcIconWreathRegular } from './mgcIcon-wreath_regular.icon';
import { mgcIconAxeRegular } from './mgcIcon-axe_regular.icon';
import { mgcIconBalloon2Regular } from './mgcIcon-balloon_2_regular.icon';
import { mgcIconBathRegular } from './mgcIcon-bath_regular.icon';
import { mgcIconBesideTable2Regular } from './mgcIcon-beside_table_2_regular.icon';
import { mgcIconBesideTableRegular } from './mgcIcon-beside_table_regular.icon';
import { mgcIconBlessingRegular } from './mgcIcon-blessing_regular.icon';
import { mgcIconBombRegular } from './mgcIcon-bomb_regular.icon';
import { mgcIconBoomRegular } from './mgcIcon-boom_regular.icon';
import { mgcIconBottleRegular } from './mgcIcon-bottle_regular.icon';
import { mgcIconCapsuleRegular } from './mgcIcon-capsule_regular.icon';
import { mgcIconCoathangerRegular } from './mgcIcon-coathanger_regular.icon';
import { mgcIconCross2Regular } from './mgcIcon-cross_2_regular.icon';
import { mgcIconCrystalBallRegular } from './mgcIcon-crystal_ball_regular.icon';
import { mgcIconCurtainRegular } from './mgcIcon-curtain_regular.icon';
import { mgcIconDrawer2Regular } from './mgcIcon-drawer_2_regular.icon';
import { mgcIconDrawerRegular } from './mgcIcon-drawer_regular.icon';
import { mgcIconFaceMaskRegular } from './mgcIcon-face_mask_regular.icon';
import { mgcIconFirecrackerRegular } from './mgcIcon-firecracker_regular.icon';
import { mgcIconFireworkRegular } from './mgcIcon-firework_regular.icon';
import { mgcIconFirstAidKitRegular } from './mgcIcon-first_aid_kit_regular.icon';
import { mgcIconHammerRegular } from './mgcIcon-hammer_regular.icon';
import { mgcIconHandCardRegular } from './mgcIcon-hand_card_regular.icon';
import { mgcIconHandHeartRegular } from './mgcIcon-hand_heart_regular.icon';
import { mgcIconHoeRegular } from './mgcIcon-hoe_regular.icon';
import { mgcIconInjectionRegular } from './mgcIcon-injection_regular.icon';
import { mgcIconKiteRegular } from './mgcIcon-kite_regular.icon';
import { mgcIconLipstickRegular } from './mgcIcon-lipstick_regular.icon';
import { mgcIconNurseRegular } from './mgcIcon-nurse_regular.icon';
import { mgcIconParfumRegular } from './mgcIcon-parfum_regular.icon';
import { mgcIconPickaxRegular } from './mgcIcon-pickax_regular.icon';
import { mgcIconPotRegular } from './mgcIcon-pot_regular.icon';
import { mgcIconPrescriptionRegular } from './mgcIcon-prescription_regular.icon';
import { mgcIconRakeRegular } from './mgcIcon-rake_regular.icon';
import { mgcIconRandomRegular } from './mgcIcon-random_regular.icon';
import { mgcIconScrewdriverRegular } from './mgcIcon-screwdriver_regular.icon';
import { mgcIconShovelRegular } from './mgcIcon-shovel_regular.icon';
import { mgcIconShowerGelRegular } from './mgcIcon-shower_gel_regular.icon';
import { mgcIconStar2Regular } from './mgcIcon-star_2_regular.icon';
import { mgcIconStarTopperRegular } from './mgcIcon-star_topper_regular.icon';
import { mgcIconStethoscopeRegular } from './mgcIcon-stethoscope_regular.icon';
import { mgcIconThoughtRegular } from './mgcIcon-thought_regular.icon';
import { mgcIconToiletPaperRegular } from './mgcIcon-toilet_paper_regular.icon';
import { mgcIconVirusRegular } from './mgcIcon-virus_regular.icon';
import { mgcIconWardrobe2Regular } from './mgcIcon-wardrobe_2_regular.icon';
import { mgcIconWardrobeRegular } from './mgcIcon-wardrobe_regular.icon';
import { mgcIconWateringCanRegular } from './mgcIcon-watering_can_regular.icon';
import { mgcIconYinyangRegular } from './mgcIcon-yinyang_regular.icon';
import { mgcIconBabyRegular } from './mgcIcon-baby_regular.icon';
import { mgcIconBeardRegular } from './mgcIcon-beard_regular.icon';
import { mgcIconBodyRegular } from './mgcIcon-body_regular.icon';
import { mgcIconBowTieRegular } from './mgcIcon-bow_tie_regular.icon';
import { mgcIconBowknotRegular } from './mgcIcon-bowknot_regular.icon';
import { mgcIconBrainRegular } from './mgcIcon-brain_regular.icon';
import { mgcIconBriefRegular } from './mgcIcon-brief_regular.icon';
import { mgcIconChefHatRegular } from './mgcIcon-chef_hat_regular.icon';
import { mgcIconChristmasHatRegular } from './mgcIcon-christmas_hat_regular.icon';
import { mgcIconCoatRegular } from './mgcIcon-coat_regular.icon';
import { mgcIconDeerRegular } from './mgcIcon-deer_regular.icon';
import { mgcIconDentalRegular } from './mgcIcon-dental_regular.icon';
import { mgcIconDressRegular } from './mgcIcon-dress_regular.icon';
import { mgcIconEarRegular } from './mgcIcon-ear_regular.icon';
import { mgcIconEye2Regular } from './mgcIcon-eye_2_regular.icon';
import { mgcIconEyebrowRegular } from './mgcIcon-eyebrow_regular.icon';
import { mgcIconFaceRegular } from './mgcIcon-face_regular.icon';
import { mgcIconFatherChristmasRegular } from './mgcIcon-father_christmas_regular.icon';
import { mgcIconFingerPressRegular } from './mgcIcon-finger_press_regular.icon';
import { mgcIconFingerRockRegular } from './mgcIcon-finger_rock_regular.icon';
import { mgcIconFingerSwipeRegular } from './mgcIcon-finger_swipe_regular.icon';
import { mgcIconFingerTapRegular } from './mgcIcon-finger_tap_regular.icon';
import { mgcIconGloveRegular } from './mgcIcon-glove_regular.icon';
import { mgcIconHair2Regular } from './mgcIcon-hair_2_regular.icon';
import { mgcIconHairRegular } from './mgcIcon-hair_regular.icon';
import { mgcIconHandFinger2Regular } from './mgcIcon-hand_finger_2_regular.icon';
import { mgcIconHandFingerRegular } from './mgcIcon-hand_finger_regular.icon';
import { mgcIconHandGrabRegular } from './mgcIcon-hand_grab_regular.icon';
import { mgcIconHandRegular } from './mgcIcon-hand_regular.icon';
import { mgcIconHandTwoFingersRegular } from './mgcIcon-hand_two_fingers_regular.icon';
import { mgcIconHandsClappingRegular } from './mgcIcon-hands_clapping_regular.icon';
import { mgcIconHat2Regular } from './mgcIcon-hat_2_regular.icon';
import { mgcIconHatRegular } from './mgcIcon-hat_regular.icon';
import { mgcIconHeadRegular } from './mgcIcon-head_regular.icon';
import { mgcIconHeartHandRegular } from './mgcIcon-heart_hand_regular.icon';
import { mgcIconHeartbeat2Regular } from './mgcIcon-heartbeat_2_regular.icon';
import { mgcIconIncognitoModeRegular } from './mgcIcon-incognito_mode_regular.icon';
import { mgcIconLoveRegular } from './mgcIcon-love_regular.icon';
import { mgcIconLungsRegular } from './mgcIcon-lungs_regular.icon';
import { mgcIconMiddleFingerRegular } from './mgcIcon-middle_finger_regular.icon';
import { mgcIconMouthRegular } from './mgcIcon-mouth_regular.icon';
import { mgcIconNecktieRegular } from './mgcIcon-necktie_regular.icon';
import { mgcIconNoseRegular } from './mgcIcon-nose_regular.icon';
import { mgcIconPrayRegular } from './mgcIcon-pray_regular.icon';
import { mgcIconScarfRegular } from './mgcIcon-scarf_regular.icon';
import { mgcIconShirtRegular } from './mgcIcon-shirt_regular.icon';
import { mgcIconShoe2Regular } from './mgcIcon-shoe_2_regular.icon';
import { mgcIconShoeRegular } from './mgcIcon-shoe_regular.icon';
import { mgcIconShortsRegular } from './mgcIcon-shorts_regular.icon';
import { mgcIconSkirtRegular } from './mgcIcon-skirt_regular.icon';
import { mgcIconSkullRegular } from './mgcIcon-skull_regular.icon';
import { mgcIconSockRegular } from './mgcIcon-sock_regular.icon';
import { mgcIconTShirt2Regular } from './mgcIcon-t_shirt_2_regular.icon';
import { mgcIconTrouserRegular } from './mgcIcon-trouser_regular.icon';
import { mgcIconVestRegular } from './mgcIcon-vest_regular.icon';
import { mgcIconClubsRegular } from './mgcIcon-clubs_regular.icon';
import { mgcIconCylinder2Regular } from './mgcIcon-cylinder_2_regular.icon';
import { mgcIconCylinderRegular } from './mgcIcon-cylinder_regular.icon';
import { mgcIconDiamondRegular } from './mgcIcon-diamond_regular.icon';
import { mgcIconDiamondSquareRegular } from './mgcIcon-diamond_square_regular.icon';
import { mgcIconHeartCrackRegular } from './mgcIcon-heart_crack_regular.icon';
import { mgcIconHeartHalfRegular } from './mgcIcon-heart_half_regular.icon';
import { mgcIconHeartRegular } from './mgcIcon-heart_regular.icon';
import { mgcIconHemisphere2Regular } from './mgcIcon-hemisphere_2_regular.icon';
import { mgcIconHemisphereRegular } from './mgcIcon-hemisphere_regular.icon';
import { mgcIconHexagonRegular } from './mgcIcon-hexagon_regular.icon';
import { mgcIconLineRegular } from './mgcIcon-line_regular.icon';
import { mgcIconOctagonRegular } from './mgcIcon-octagon_regular.icon';
import { mgcIconPentagonRegular } from './mgcIcon-pentagon_regular.icon';
import { mgcIconRectangleRegular } from './mgcIcon-rectangle_regular.icon';
import { mgcIconRectangleVerticalRegular } from './mgcIcon-rectangle_vertical_regular.icon';
import { mgcIconRoundRegular } from './mgcIcon-round_regular.icon';
import { mgcIconSectorRegular } from './mgcIcon-sector_regular.icon';
import { mgcIconShieldShapeRegular } from './mgcIcon-shield_shape_regular.icon';
import { mgcIconSpadeRegular } from './mgcIcon-spade_regular.icon';
import { mgcIconSquareRegular } from './mgcIcon-square_regular.icon';
import { mgcIconStarHalfRegular } from './mgcIcon-star_half_regular.icon';
import { mgcIconStarRegular } from './mgcIcon-star_regular.icon';
import { mgcIconTriangleRegular } from './mgcIcon-triangle_regular.icon';
import { mgcIconAirBalloonRegular } from './mgcIcon-air_balloon_regular.icon';
import { mgcIconAmericanFootballRegular } from './mgcIcon-american_football_regular.icon';
import { mgcIconBackboardRegular } from './mgcIcon-backboard_regular.icon';
import { mgcIconBadmintonRegular } from './mgcIcon-badminton_regular.icon';
import { mgcIconBarbellRegular } from './mgcIcon-barbell_regular.icon';
import { mgcIconBaseball2Regular } from './mgcIcon-baseball_2_regular.icon';
import { mgcIconBaseballRegular } from './mgcIcon-baseball_regular.icon';
import { mgcIconBasketballRegular } from './mgcIcon-basketball_regular.icon';
import { mgcIconBeachballRegular } from './mgcIcon-beachball_regular.icon';
import { mgcIconDisabled2Regular } from './mgcIcon-disabled_2_regular.icon';
import { mgcIconDisabledRegular } from './mgcIcon-disabled_regular.icon';
import { mgcIconFitnessRegular } from './mgcIcon-fitness_regular.icon';
import { mgcIconFootballRegular } from './mgcIcon-football_regular.icon';
import { mgcIconParachuteRegular } from './mgcIcon-parachute_regular.icon';
import { mgcIconPingpongRegular } from './mgcIcon-pingpong_regular.icon';
import { mgcIconPlaygroundRegular } from './mgcIcon-playground_regular.icon';
import { mgcIconRidingRegular } from './mgcIcon-riding_regular.icon';
import { mgcIconRunRegular } from './mgcIcon-run_regular.icon';
import { mgcIconSkateboardRegular } from './mgcIcon-skateboard_regular.icon';
import { mgcIconSurfboardRegular } from './mgcIcon-surfboard_regular.icon';
import { mgcIconSwimmingPoolRegular } from './mgcIcon-swimming_pool_regular.icon';
import { mgcIconSwordRegular } from './mgcIcon-sword_regular.icon';
import { mgcIconToxophilyRegular } from './mgcIcon-toxophily_regular.icon';
import { mgcIconVolleyballRegular } from './mgcIcon-volleyball_regular.icon';
import { mgcIconWalkRegular } from './mgcIcon-walk_regular.icon';
import { mgcIconWheelchairRegular } from './mgcIcon-wheelchair_regular.icon';
import { mgcIconWhistleRegular } from './mgcIcon-whistle_regular.icon';
import { mgcIconAddCircleRegular } from './mgcIcon-add_circle_regular.icon';
import { mgcIconAddRegular } from './mgcIcon-add_regular.icon';
import { mgcIconAddSquareRegular } from './mgcIcon-add_square_regular.icon';
import { mgcIconAlertDiamondRegular } from './mgcIcon-alert_diamond_regular.icon';
import { mgcIconAlertOctagonRegular } from './mgcIcon-alert_octagon_regular.icon';
import { mgcIconAlertRegular } from './mgcIcon-alert_regular.icon';
import { mgcIconBroomRegular } from './mgcIcon-broom_regular.icon';
import { mgcIconBrush3Regular } from './mgcIcon-brush_3_regular.icon';
import { mgcIconBrushRegular } from './mgcIcon-brush_regular.icon';
import { mgcIconBubbleRegular } from './mgcIcon-bubble_regular.icon';
import { mgcIconCertificateRegular } from './mgcIcon-certificate_regular.icon';
import { mgcIconCheck2Regular } from './mgcIcon-check_2_regular.icon';
import { mgcIconCheckCircleRegular } from './mgcIcon-check_circle_regular.icon';
import { mgcIconCheckRegular } from './mgcIcon-check_regular.icon';
import { mgcIconCheckboxRegular } from './mgcIcon-checkbox_regular.icon';
import { mgcIconChecksRegular } from './mgcIcon-checks_regular.icon';
import { mgcIconChoiceRegular } from './mgcIcon-choice_regular.icon';
import { mgcIconClassify2Regular } from './mgcIcon-classify_2_regular.icon';
import { mgcIconClassify3Regular } from './mgcIcon-classify_3_regular.icon';
import { mgcIconClassifyAdd2Regular } from './mgcIcon-classify_add_2_regular.icon';
import { mgcIconClassifyAddRegular } from './mgcIcon-classify_add_regular.icon';
import { mgcIconClassifyRegular } from './mgcIcon-classify_regular.icon';
import { mgcIconCloseCircleRegular } from './mgcIcon-close_circle_regular.icon';
import { mgcIconCloseRegular } from './mgcIcon-close_regular.icon';
import { mgcIconCloseSquareRegular } from './mgcIcon-close_square_regular.icon';
import { mgcIconCrossRegular } from './mgcIcon-cross_regular.icon';
import { mgcIconCrutchRegular } from './mgcIcon-crutch_regular.icon';
import { mgcIconCubeRegular } from './mgcIcon-cube_regular.icon';
import { mgcIconDelete2Regular } from './mgcIcon-delete_2_regular.icon';
import { mgcIconDelete3Regular } from './mgcIcon-delete_3_regular.icon';
import { mgcIconDeleteBackRegular } from './mgcIcon-delete_back_regular.icon';
import { mgcIconDeleteRegular } from './mgcIcon-delete_regular.icon';
import { mgcIconDirectionDotRegular } from './mgcIcon-direction_dot_regular.icon';
import { mgcIconDoorRegular } from './mgcIcon-door_regular.icon';
import { mgcIconDotGridRegular } from './mgcIcon-dot_grid_regular.icon';
import { mgcIconDotsRegular } from './mgcIcon-dots_regular.icon';
import { mgcIconDotsVerticalRegular } from './mgcIcon-dots_vertical_regular.icon';
import { mgcIconEnterDoorRegular } from './mgcIcon-enter_door_regular.icon';
import { mgcIconEntranceRegular } from './mgcIcon-entrance_regular.icon';
import { mgcIconExitDoorRegular } from './mgcIcon-exit_door_regular.icon';
import { mgcIconExitRegular } from './mgcIcon-exit_regular.icon';
import { mgcIconEyeCloseRegular } from './mgcIcon-eye_close_regular.icon';
import { mgcIconEyeRegular } from './mgcIcon-eye_regular.icon';
import { mgcIconFaceidRegular } from './mgcIcon-faceid_regular.icon';
import { mgcIconFaultRegular } from './mgcIcon-fault_regular.icon';
import { mgcIconFilter2Regular } from './mgcIcon-filter_2_regular.icon';
import { mgcIconFingerprint2Regular } from './mgcIcon-fingerprint_2_regular.icon';
import { mgcIconFingerprintRegular } from './mgcIcon-fingerprint_regular.icon';
import { mgcIconFireRegular } from './mgcIcon-fire_regular.icon';
import { mgcIconFlameRegular } from './mgcIcon-flame_regular.icon';
import { mgcIconForbidCircleRegular } from './mgcIcon-forbid_circle_regular.icon';
import { mgcIconGestureUnlockRegular } from './mgcIcon-gesture_unlock_regular.icon';
import { mgcIconGhostRegular } from './mgcIcon-ghost_regular.icon';
import { mgcIconGrid2Regular } from './mgcIcon-grid_2_regular.icon';
import { mgcIconGridRegular } from './mgcIcon-grid_regular.icon';
import { mgcIconHeartbeatRegular } from './mgcIcon-heartbeat_regular.icon';
import { mgcIconHexagons2Regular } from './mgcIcon-hexagons_2_regular.icon';
import { mgcIconHexagonsRegular } from './mgcIcon-hexagons_regular.icon';
import { mgcIconHistory2Regular } from './mgcIcon-history_2_regular.icon';
import { mgcIconHistoryAnticlockwiseRegular } from './mgcIcon-history_anticlockwise_regular.icon';
import { mgcIconHistoryRegular } from './mgcIcon-history_regular.icon';
import { mgcIconInformationRegular } from './mgcIcon-information_regular.icon';
import { mgcIconKey1Regular } from './mgcIcon-key_1_regular.icon';
import { mgcIconKey2Regular } from './mgcIcon-key_2_regular.icon';
import { mgcIconKeyholeRegular } from './mgcIcon-keyhole_regular.icon';
import { mgcIconLoading2Regular } from './mgcIcon-loading_2_regular.icon';
import { mgcIconLoading3Regular } from './mgcIcon-loading_3_regular.icon';
import { mgcIconLoading4Regular } from './mgcIcon-loading_4_regular.icon';
import { mgcIconLoadingRegular } from './mgcIcon-loading_regular.icon';
import { mgcIconLockRegular } from './mgcIcon-lock_regular.icon';
import { mgcIconMindMapRegular } from './mgcIcon-mind_map_regular.icon';
import { mgcIconMinimizeRegular } from './mgcIcon-minimize_regular.icon';
import { mgcIconMinusCircleRegular } from './mgcIcon-minus_circle_regular.icon';
import { mgcIconMinusSquareRegular } from './mgcIcon-minus_square_regular.icon';
import { mgcIconMore1Regular } from './mgcIcon-more_1_regular.icon';
import { mgcIconMore2Regular } from './mgcIcon-more_2_regular.icon';
import { mgcIconMore3Regular } from './mgcIcon-more_3_regular.icon';
import { mgcIconMore4Regular } from './mgcIcon-more_4_regular.icon';
import { mgcIconMultiselectRegular } from './mgcIcon-multiselect_regular.icon';
import { mgcIconNewdotRegular } from './mgcIcon-newdot_regular.icon';
import { mgcIconOpenDoorRegular } from './mgcIcon-open_door_regular.icon';
import { mgcIconPlusRegular } from './mgcIcon-plus_regular.icon';
import { mgcIconPolygonRegular } from './mgcIcon-polygon_regular.icon';
import { mgcIconPowerRegular } from './mgcIcon-power_regular.icon';
import { mgcIconProcessRegular } from './mgcIcon-process_regular.icon';
import { mgcIconQuestionRegular } from './mgcIcon-question_regular.icon';
import { mgcIconRadioboxRegular } from './mgcIcon-radiobox_regular.icon';
import { mgcIconRecycleRegular } from './mgcIcon-recycle_regular.icon';
import { mgcIconRefresh1Regular } from './mgcIcon-refresh_1_regular.icon';
import { mgcIconRefresh2Regular } from './mgcIcon-refresh_2_regular.icon';
import { mgcIconRefresh3Regular } from './mgcIcon-refresh_3_regular.icon';
import { mgcIconRefresh4AiRegular } from './mgcIcon-refresh_4_ai_regular.icon';
import { mgcIconRefresh4Regular } from './mgcIcon-refresh_4_regular.icon';
import { mgcIconRefreshAnticlockwise1Regular } from './mgcIcon-refresh_anticlockwise_1_regular.icon';
import { mgcIconReportRegular } from './mgcIcon-report_regular.icon';
import { mgcIconRestoreRegular } from './mgcIcon-restore_regular.icon';
import { mgcIconSafeAlertRegular } from './mgcIcon-safe_alert_regular.icon';
import { mgcIconSafeFlashRegular } from './mgcIcon-safe_flash_regular.icon';
import { mgcIconSafeLockRegular } from './mgcIcon-safe_lock_regular.icon';
import { mgcIconSafeShield2Regular } from './mgcIcon-safe_shield_2_regular.icon';
import { mgcIconSafeShieldRegular } from './mgcIcon-safe_shield_regular.icon';
import { mgcIconSafetyCertificateRegular } from './mgcIcon-safety_certificate_regular.icon';
import { mgcIconSettings1Regular } from './mgcIcon-settings_1_regular.icon';
import { mgcIconSettings2Regular } from './mgcIcon-settings_2_regular.icon';
import { mgcIconSettings3Regular } from './mgcIcon-settings_3_regular.icon';
import { mgcIconSettings4Regular } from './mgcIcon-settings_4_regular.icon';
import { mgcIconSettings5Regular } from './mgcIcon-settings_5_regular.icon';
import { mgcIconSettings6Regular } from './mgcIcon-settings_6_regular.icon';
import { mgcIconSettings7Regular } from './mgcIcon-settings_7_regular.icon';
import { mgcIconShare2Regular } from './mgcIcon-share_2_regular.icon';
import { mgcIconShare3Regular } from './mgcIcon-share_3_regular.icon';
import { mgcIconShareForwardRegular } from './mgcIcon-share_forward_regular.icon';
import { mgcIconShieldRegular } from './mgcIcon-shield_regular.icon';
import { mgcIconSleepRegular } from './mgcIcon-sleep_regular.icon';
import { mgcIconSwitchRegular } from './mgcIcon-switch_regular.icon';
import { mgcIconTShirtRegular } from './mgcIcon-t_shirt_regular.icon';
import { mgcIconThreeCirclesRegular } from './mgcIcon-three_circles_regular.icon';
import { mgcIconThumbDown2Regular } from './mgcIcon-thumb_down_2_regular.icon';
import { mgcIconThumbDownRegular } from './mgcIcon-thumb_down_regular.icon';
import { mgcIconThumbUp2Regular } from './mgcIcon-thumb_up_2_regular.icon';
import { mgcIconThumbUpRegular } from './mgcIcon-thumb_up_regular.icon';
import { mgcIconTimeDurationRegular } from './mgcIcon-time_duration_regular.icon';
import { mgcIconTimeRegular } from './mgcIcon-time_regular.icon';
import { mgcIconTimelineRegular } from './mgcIcon-timeline_regular.icon';
import { mgcIconToggleLeft2Regular } from './mgcIcon-toggle_left_2_regular.icon';
import { mgcIconToggleLeftRegular } from './mgcIcon-toggle_left_regular.icon';
import { mgcIconToggleRight2Regular } from './mgcIcon-toggle_right_2_regular.icon';
import { mgcIconToggleRightRegular } from './mgcIcon-toggle_right_regular.icon';
import { mgcIconToolRegular } from './mgcIcon-tool_regular.icon';
import { mgcIconTransformationRegular } from './mgcIcon-transformation_regular.icon';
import { mgcIconUnlockRegular } from './mgcIcon-unlock_regular.icon';
import { mgcIconVersionRegular } from './mgcIcon-version_regular.icon';
import { mgcIconWarningRegular } from './mgcIcon-warning_regular.icon';
import { mgcIconWastebasketRegular } from './mgcIcon-wastebasket_regular.icon';
import { mgcIconWebhookRegular } from './mgcIcon-webhook_regular.icon';
import { mgcIconAbsRegular } from './mgcIcon-ABS_regular.icon';
import { mgcIconAerialLiftRegular } from './mgcIcon-aerial_lift_regular.icon';
import { mgcIconAirplaneRegular } from './mgcIcon-airplane_regular.icon';
import { mgcIconAutoHoldRegular } from './mgcIcon-auto_hold_regular.icon';
import { mgcIconBabyCarriageRegular } from './mgcIcon-baby_carriage_regular.icon';
import { mgcIconBikeRegular } from './mgcIcon-bike_regular.icon';
import { mgcIconBrakeRegular } from './mgcIcon-brake_regular.icon';
import { mgcIconBus2Regular } from './mgcIcon-bus_2_regular.icon';
import { mgcIconBusRegular } from './mgcIcon-bus_regular.icon';
import { mgcIconCar2Regular } from './mgcIcon-car_2_regular.icon';
import { mgcIconCar3Regular } from './mgcIcon-car_3_regular.icon';
import { mgcIconCarDoorRegular } from './mgcIcon-car_door_regular.icon';
import { mgcIconCarRegular } from './mgcIcon-car_regular.icon';
import { mgcIconCarWindowRegular } from './mgcIcon-car_window_regular.icon';
import { mgcIconChargingPileRegular } from './mgcIcon-charging_pile_regular.icon';
import { mgcIconEbikeRegular } from './mgcIcon-ebike_regular.icon';
import { mgcIconEmergencyFlashersRegular } from './mgcIcon-emergency_flashers_regular.icon';
import { mgcIconEngineRegular } from './mgcIcon-engine_regular.icon';
import { mgcIconFan2Regular } from './mgcIcon-fan_2_regular.icon';
import { mgcIconFanDirectionDownRegular } from './mgcIcon-fan_direction_down_regular.icon';
import { mgcIconFanDirectionFrontRegular } from './mgcIcon-fan_direction_front_regular.icon';
import { mgcIconFanDirectionUpRegular } from './mgcIcon-fan_direction_up_regular.icon';
import { mgcIconFanRegular } from './mgcIcon-fan_regular.icon';
import { mgcIconFlightInflightRegular } from './mgcIcon-flight_inflight_regular.icon';
import { mgcIconFlightLandRegular } from './mgcIcon-flight_land_regular.icon';
import { mgcIconFlightTakeoffRegular } from './mgcIcon-flight_takeoff_regular.icon';
import { mgcIconFourWheelDriveRegular } from './mgcIcon-four_wheel_drive_regular.icon';
import { mgcIconFrontFogLightsRegular } from './mgcIcon-front_fog_lights_regular.icon';
import { mgcIconFrontWindshieldDefrosterRegular } from './mgcIcon-front_windshield_defroster_regular.icon';
import { mgcIconGasStationRegular } from './mgcIcon-gas_station_regular.icon';
import { mgcIconHightBeamHeadlightsRegular } from './mgcIcon-hight_beam_headlights_regular.icon';
import { mgcIconHoodRegular } from './mgcIcon-hood_regular.icon';
import { mgcIconJeepRegular } from './mgcIcon-jeep_regular.icon';
import { mgcIconLowBeamHeadlightsRegular } from './mgcIcon-low_beam_headlights_regular.icon';
import { mgcIconOilRegular } from './mgcIcon-oil_regular.icon';
import { mgcIconParkRegular } from './mgcIcon-park_regular.icon';
import { mgcIconParkingLightsRegular } from './mgcIcon-parking_lights_regular.icon';
import { mgcIconPinwheel2Regular } from './mgcIcon-pinwheel_2_regular.icon';
import { mgcIconPinwheelRegular } from './mgcIcon-pinwheel_regular.icon';
import { mgcIconRareFogLightsRegular } from './mgcIcon-rare_fog_lights_regular.icon';
import { mgcIconRearWindshieldDefrosterRegular } from './mgcIcon-rear_windshield_defroster_regular.icon';
import { mgcIconRocket2Regular } from './mgcIcon-rocket_2_regular.icon';
import { mgcIconRocketRegular } from './mgcIcon-rocket_regular.icon';
import { mgcIconRudderRegular } from './mgcIcon-rudder_regular.icon';
import { mgcIconSailboatRegular } from './mgcIcon-sailboat_regular.icon';
import { mgcIconScooterRegular } from './mgcIcon-scooter_regular.icon';
import { mgcIconSeatHeatedRegular } from './mgcIcon-seat_heated_regular.icon';
import { mgcIconSeatRegular } from './mgcIcon-seat_regular.icon';
import { mgcIconShipRegular } from './mgcIcon-ship_regular.icon';
import { mgcIconSleighRegular } from './mgcIcon-sleigh_regular.icon';
import { mgcIconSteeringWheelRegular } from './mgcIcon-steering_wheel_regular.icon';
import { mgcIconTankRegular } from './mgcIcon-tank_regular.icon';
import { mgcIconTrafficLightsRegular } from './mgcIcon-traffic_lights_regular.icon';
import { mgcIconTrain2Regular } from './mgcIcon-train_2_regular.icon';
import { mgcIconTrain3Regular } from './mgcIcon-train_3_regular.icon';
import { mgcIconTrain4Regular } from './mgcIcon-train_4_regular.icon';
import { mgcIconTrainRegular } from './mgcIcon-train_regular.icon';
import { mgcIconTruckRegular } from './mgcIcon-truck_regular.icon';
import { mgcIconTrunkRegular } from './mgcIcon-trunk_regular.icon';
import { mgcIconTyreRegular } from './mgcIcon-tyre_regular.icon';
import { mgcIconUfo2Regular } from './mgcIcon-UFO_2_regular.icon';
import { mgcIconUfoRegular } from './mgcIcon-UFO_regular.icon';
import { mgcIconWheelRegular } from './mgcIcon-wheel_regular.icon';
import { mgcIconWiperRegular } from './mgcIcon-wiper_regular.icon';
import { mgcIconBadgeRegular } from './mgcIcon-badge_regular.icon';
import { mgcIconContacts2Regular } from './mgcIcon-contacts_2_regular.icon';
import { mgcIconContacts3Regular } from './mgcIcon-contacts_3_regular.icon';
import { mgcIconContacts4Regular } from './mgcIcon-contacts_4_regular.icon';
import { mgcIconContactsRegular } from './mgcIcon-contacts_regular.icon';
import { mgcIconFemaleRegular } from './mgcIcon-female_regular.icon';
import { mgcIconGroup2Regular } from './mgcIcon-group_2_regular.icon';
import { mgcIconGroup3Regular } from './mgcIcon-group_3_regular.icon';
import { mgcIconGroupRegular } from './mgcIcon-group_regular.icon';
import { mgcIconIDcardRegular } from './mgcIcon-IDcard_regular.icon';
import { mgcIconMaleRegular } from './mgcIcon-male_regular.icon';
import { mgcIconUser1Regular } from './mgcIcon-user_1_regular.icon';
import { mgcIconUser2Regular } from './mgcIcon-user_2_regular.icon';
import { mgcIconUser3Regular } from './mgcIcon-user_3_regular.icon';
import { mgcIconUser4Regular } from './mgcIcon-user_4_regular.icon';
import { mgcIconUser5Regular } from './mgcIcon-user_5_regular.icon';
import { mgcIconUserAdd2Regular } from './mgcIcon-user_add_2_regular.icon';
import { mgcIconUserAddRegular } from './mgcIcon-user_add_regular.icon';
import { mgcIconUserEditRegular } from './mgcIcon-user_edit_regular.icon';
import { mgcIconUserFollow2Regular } from './mgcIcon-user_follow_2_regular.icon';
import { mgcIconUserFollowRegular } from './mgcIcon-user_follow_regular.icon';
import { mgcIconUserForbidRegular } from './mgcIcon-user_forbid_regular.icon';
import { mgcIconUserHeartRegular } from './mgcIcon-user_heart_regular.icon';
import { mgcIconUserHideRegular } from './mgcIcon-user_hide_regular.icon';
import { mgcIconUserInfoRegular } from './mgcIcon-user_info_regular.icon';
import { mgcIconUserLockRegular } from './mgcIcon-user_lock_regular.icon';
import { mgcIconUserPinRegular } from './mgcIcon-user_pin_regular.icon';
import { mgcIconUserQuestionRegular } from './mgcIcon-user_question_regular.icon';
import { mgcIconUserRemove2Regular } from './mgcIcon-user_remove_2_regular.icon';
import { mgcIconUserRemoveRegular } from './mgcIcon-user_remove_regular.icon';
import { mgcIconUserSearchRegular } from './mgcIcon-user_search_regular.icon';
import { mgcIconUserSecurityRegular } from './mgcIcon-user_security_regular.icon';
import { mgcIconUserSettingRegular } from './mgcIcon-user_setting_regular.icon';
import { mgcIconUserStarRegular } from './mgcIcon-user_star_regular.icon';
import { mgcIconUserVisibleRegular } from './mgcIcon-user_visible_regular.icon';
import { mgcIconUserWarningRegular } from './mgcIcon-user_warning_regular.icon';
import { mgcIconUserXRegular } from './mgcIcon-user_x_regular.icon';
import { mgcIconCelsiusRegular } from './mgcIcon-celsius_regular.icon';
import { mgcIconCloud2Regular } from './mgcIcon-cloud_2_regular.icon';
import { mgcIconCloudLightningRegular } from './mgcIcon-cloud_lightning_regular.icon';
import { mgcIconCloudRegular } from './mgcIcon-cloud_regular.icon';
import { mgcIconCloudSnowRegular } from './mgcIcon-cloud_snow_regular.icon';
import { mgcIconCloudWindyRegular } from './mgcIcon-cloud_windy_regular.icon';
import { mgcIconCloudsRegular } from './mgcIcon-clouds_regular.icon';
import { mgcIconDrizzleRegular } from './mgcIcon-drizzle_regular.icon';
import { mgcIconDryRegular } from './mgcIcon-dry_regular.icon';
import { mgcIconFahrenheitRegular } from './mgcIcon-fahrenheit_regular.icon';
import { mgcIconFloatingDustRegular } from './mgcIcon-floating_dust_regular.icon';
import { mgcIconFogRegular } from './mgcIcon-fog_regular.icon';
import { mgcIconFullMoonRegular } from './mgcIcon-full_moon_regular.icon';
import { mgcIconHailRegular } from './mgcIcon-hail_regular.icon';
import { mgcIconHazeRegular } from './mgcIcon-haze_regular.icon';
import { mgcIconHeavyRainRegular } from './mgcIcon-heavy_rain_regular.icon';
import { mgcIconHeavyRainstormRegular } from './mgcIcon-heavy_rainstorm_regular.icon';
import { mgcIconHeavySnowRegular } from './mgcIcon-heavy_snow_regular.icon';
import { mgcIconHeavySnowstormRegular } from './mgcIcon-heavy_snowstorm_regular.icon';
import { mgcIconHighTemperatureRegular } from './mgcIcon-high_temperature_regular.icon';
import { mgcIconLightSnowRegular } from './mgcIcon-light_snow_regular.icon';
import { mgcIconLightningRegular } from './mgcIcon-lightning_regular.icon';
import { mgcIconLowTemperatureRegular } from './mgcIcon-low_temperature_regular.icon';
import { mgcIconModerateSnowRegular } from './mgcIcon-moderate_snow_regular.icon';
import { mgcIconMoonCloudyRegular } from './mgcIcon-moon_cloudy_regular.icon';
import { mgcIconMoonFogRegular } from './mgcIcon-moon_fog_regular.icon';
import { mgcIconMoonRegular } from './mgcIcon-moon_regular.icon';
import { mgcIconMoonStarsRegular } from './mgcIcon-moon_stars_regular.icon';
import { mgcIconMoonlightRegular } from './mgcIcon-moonlight_regular.icon';
import { mgcIconNaRegular } from './mgcIcon-na_regular.icon';
import { mgcIconPartlyCloudDaytimeRegular } from './mgcIcon-partly_cloud_daytime_regular.icon';
import { mgcIconPartlyCloudNightRegular } from './mgcIcon-partly_cloud_night_regular.icon';
import { mgcIconRainRegular } from './mgcIcon-rain_regular.icon';
import { mgcIconRainbowRegular } from './mgcIcon-rainbow_regular.icon';
import { mgcIconRainstormRegular } from './mgcIcon-rainstorm_regular.icon';
import { mgcIconSandstormRegular } from './mgcIcon-sandstorm_regular.icon';
import { mgcIconShowersRegular } from './mgcIcon-showers_regular.icon';
import { mgcIconSnowRegular } from './mgcIcon-snow_regular.icon';
import { mgcIconSnowflakeRegular } from './mgcIcon-snowflake_regular.icon';
import { mgcIconSnowmanRegular } from './mgcIcon-snowman_regular.icon';
import { mgcIconSnowstorm2Regular } from './mgcIcon-snowstorm_2_regular.icon';
import { mgcIconSnowstormRegular } from './mgcIcon-snowstorm_regular.icon';
import { mgcIconSparkles2Regular } from './mgcIcon-sparkles_2_regular.icon';
import { mgcIconSparkles3Regular } from './mgcIcon-sparkles_3_regular.icon';
import { mgcIconSparklesRegular } from './mgcIcon-sparkles_regular.icon';
import { mgcIconSun2Regular } from './mgcIcon-sun_2_regular.icon';
import { mgcIconSunCloudyRegular } from './mgcIcon-sun_cloudy_regular.icon';
import { mgcIconSunFogRegular } from './mgcIcon-sun_fog_regular.icon';
import { mgcIconSunRegular } from './mgcIcon-sun_regular.icon';
import { mgcIconSunriseRegular } from './mgcIcon-sunrise_regular.icon';
import { mgcIconSunsetRegular } from './mgcIcon-sunset_regular.icon';
import { mgcIconThermometerRegular } from './mgcIcon-thermometer_regular.icon';
import { mgcIconThunderstormRegular } from './mgcIcon-thunderstorm_regular.icon';
import { mgcIconTornado2Regular } from './mgcIcon-tornado_2_regular.icon';
import { mgcIconTornadoRegular } from './mgcIcon-tornado_regular.icon';
import { mgcIconTyphoonRegular } from './mgcIcon-typhoon_regular.icon';
import { mgcIconUmbrellaRegular } from './mgcIcon-umbrella_regular.icon';
import { mgcIconWaveRegular } from './mgcIcon-wave_regular.icon';
import { mgcIconWetRegular } from './mgcIcon-wet_regular.icon';
import { mgcIconWindRegular } from './mgcIcon-wind_regular.icon';
import { mgcIconAquariusRegular } from './mgcIcon-Aquarius_regular.icon';
import { mgcIconAriesRegular } from './mgcIcon-Aries_regular.icon';
import { mgcIconCancerRegular } from './mgcIcon-Cancer_regular.icon';
import { mgcIconCapricornRegular } from './mgcIcon-Capricorn_regular.icon';
import { mgcIconGeminiRegular } from './mgcIcon-Gemini_regular.icon';
import { mgcIconLeoRegular } from './mgcIcon-Leo_regular.icon';
import { mgcIconLibraRegular } from './mgcIcon-Libra_regular.icon';
import { mgcIconPiscesRegular } from './mgcIcon-Pisces_regular.icon';
import { mgcIconSagittariusRegular } from './mgcIcon-Sagittarius_regular.icon';
import { mgcIconScorpioRegular } from './mgcIcon-Scorpio_regular.icon';
import { mgcIconTaurusRegular } from './mgcIcon-Taurus_regular.icon';
import { mgcIconVirgoRegular } from './mgcIcon-Virgo_regular.icon';
export const completeIconSet: MGCIcon[] = [
  mgcIconAlignArrowDownCuteFi as MGCIcon,
  mgcIconAlignArrowLeftCuteFi as MGCIcon,
  mgcIconAlignArrowRightCuteFi as MGCIcon,
  mgcIconAlignArrowUpCuteFi as MGCIcon,
  mgcIconArrowDownCircleCuteFi as MGCIcon,
  mgcIconArrowDownCuteFi as MGCIcon,
  mgcIconArrowLeftCircleCuteFi as MGCIcon,
  mgcIconArrowLeftCuteFi as MGCIcon,
  mgcIconArrowLeftDownCircleCuteFi as MGCIcon,
  mgcIconArrowLeftDownCuteFi as MGCIcon,
  mgcIconArrowLeftUpCircleCuteFi as MGCIcon,
  mgcIconArrowLeftUpCuteFi as MGCIcon,
  mgcIconArrowRightCircleCuteFi as MGCIcon,
  mgcIconArrowRightCuteFi as MGCIcon,
  mgcIconArrowRightDownCircleCuteFi as MGCIcon,
  mgcIconArrowRightDownCuteFi as MGCIcon,
  mgcIconArrowRightUpCircleCuteFi as MGCIcon,
  mgcIconArrowRightUpCuteFi as MGCIcon,
  mgcIconArrowToDownCuteFi as MGCIcon,
  mgcIconArrowToLeftCuteFi as MGCIcon,
  mgcIconArrowToRightCuteFi as MGCIcon,
  mgcIconArrowToUpCuteFi as MGCIcon,
  mgcIconArrowUpCircleCuteFi as MGCIcon,
  mgcIconArrowUpCuteFi as MGCIcon,
  mgcIconArrowsDownCuteFi as MGCIcon,
  mgcIconArrowsLeftCuteFi as MGCIcon,
  mgcIconArrowsRightCuteFi as MGCIcon,
  mgcIconArrowsUpCuteFi as MGCIcon,
  mgcIconBack2CuteFi as MGCIcon,
  mgcIconBackCuteFi as MGCIcon,
  mgcIconCornerDownLeftCuteFi as MGCIcon,
  mgcIconCornerDownRightCuteFi as MGCIcon,
  mgcIconCornerUpLeftCuteFi as MGCIcon,
  mgcIconCornerUpRightCuteFi as MGCIcon,
  mgcIconDirectionArrowCuteFi as MGCIcon,
  mgcIconDownCuteFi as MGCIcon,
  mgcIconDownSmallCuteFi as MGCIcon,
  mgcIconForward2CuteFi as MGCIcon,
  mgcIconForwardCuteFi as MGCIcon,
  mgcIconFullscreen2CuteFi as MGCIcon,
  mgcIconFullscreenExit2CuteFi as MGCIcon,
  mgcIconLargeArrowDownCuteFi as MGCIcon,
  mgcIconLargeArrowLeftCuteFi as MGCIcon,
  mgcIconLargeArrowRightCuteFi as MGCIcon,
  mgcIconLargeArrowUpCuteFi as MGCIcon,
  mgcIconLeftCuteFi as MGCIcon,
  mgcIconLeftSmallCuteFi as MGCIcon,
  mgcIconMoveCuteFi as MGCIcon,
  mgcIconRightCuteFi as MGCIcon,
  mgcIconRightSmallCuteFi as MGCIcon,
  mgcIconSelectorHorizontalCuteFi as MGCIcon,
  mgcIconSelectorVerticalCuteFi as MGCIcon,
  mgcIconSquareArrowDownCuteFi as MGCIcon,
  mgcIconSquareArrowLeftCuteFi as MGCIcon,
  mgcIconSquareArrowRightCuteFi as MGCIcon,
  mgcIconSquareArrowUpCuteFi as MGCIcon,
  mgcIconTransfer2CuteFi as MGCIcon,
  mgcIconTransfer3CuteFi as MGCIcon,
  mgcIconTransfer4CuteFi as MGCIcon,
  mgcIconTransferCuteFi as MGCIcon,
  mgcIconTransferHorizontalCuteFi as MGCIcon,
  mgcIconTransferVerticalCuteFi as MGCIcon,
  mgcIconTrendingDownCuteFi as MGCIcon,
  mgcIconTrendingUpCuteFi as MGCIcon,
  mgcIconUpCuteFi as MGCIcon,
  mgcIconUpSmallCuteFi as MGCIcon,
  mgcIconBankCuteFi as MGCIcon,
  mgcIconBankOfChinaTowerCuteFi as MGCIcon,
  mgcIconBigBenCuteFi as MGCIcon,
  mgcIconBridge2CuteFi as MGCIcon,
  mgcIconBridgeCuteFi as MGCIcon,
  mgcIconBuilding1CuteFi as MGCIcon,
  mgcIconBuilding2CuteFi as MGCIcon,
  mgcIconBuilding3CuteFi as MGCIcon,
  mgcIconBuilding4CuteFi as MGCIcon,
  mgcIconBuilding5CuteFi as MGCIcon,
  mgcIconBuilding6CuteFi as MGCIcon,
  mgcIconBurjAlArabCuteFi as MGCIcon,
  mgcIconBurjKhalifaTowerCuteFi as MGCIcon,
  mgcIconCampgroundCuteFi as MGCIcon,
  mgcIconCantonTowerCuteFi as MGCIcon,
  mgcIconChristTheRedeemerCuteFi as MGCIcon,
  mgcIconChurchCuteFi as MGCIcon,
  mgcIconDutchWindmillCuteFi as MGCIcon,
  mgcIconEgyptianPyramidsCuteFi as MGCIcon,
  mgcIconEiffelTowerCuteFi as MGCIcon,
  mgcIconFactory2CuteFi as MGCIcon,
  mgcIconFactoryCuteFi as MGCIcon,
  mgcIconFerrisWheelCuteFi as MGCIcon,
  mgcIconGovernmentCuteFi as MGCIcon,
  mgcIconGreatwallCuteFi as MGCIcon,
  mgcIconHome1CuteFi as MGCIcon,
  mgcIconHome2CuteFi as MGCIcon,
  mgcIconHome3CuteFi as MGCIcon,
  mgcIconHome4CuteFi as MGCIcon,
  mgcIconHome5CuteFi as MGCIcon,
  mgcIconHome6CuteFi as MGCIcon,
  mgcIconHome7CuteFi as MGCIcon,
  mgcIconHospitalCuteFi as MGCIcon,
  mgcIconHotelCuteFi as MGCIcon,
  mgcIconHouse2CuteFi as MGCIcon,
  mgcIconHouseCuteFi as MGCIcon,
  mgcIconKingkey100TowerCuteFi as MGCIcon,
  mgcIconLighthouseCuteFi as MGCIcon,
  mgcIconMarinaBaySandCuteFi as MGCIcon,
  mgcIconMayaPyramidsCuteFi as MGCIcon,
  mgcIconMiyajimaToriiCuteFi as MGCIcon,
  mgcIconMoaiCuteFi as MGCIcon,
  mgcIconMonumentCuteFi as MGCIcon,
  mgcIconPalaceCuteFi as MGCIcon,
  mgcIconPavilionCuteFi as MGCIcon,
  mgcIconPisaTowerCuteFi as MGCIcon,
  mgcIconSchoolCuteFi as MGCIcon,
  mgcIconShopCuteFi as MGCIcon,
  mgcIconStatueOfLibertyCuteFi as MGCIcon,
  mgcIconStore2CuteFi as MGCIcon,
  mgcIconStoreCuteFi as MGCIcon,
  mgcIconSydneyOperaHouseCuteFi as MGCIcon,
  mgcIconTaipei101CuteFi as MGCIcon,
  mgcIconTajMahalCuteFi as MGCIcon,
  mgcIconTempleOfHeavenCuteFi as MGCIcon,
  mgcIconTentCuteFi as MGCIcon,
  mgcIconTowerCuteFi as MGCIcon,
  mgcIconTriumphalArchCuteFi as MGCIcon,
  mgcIconTvTowerCuteFi as MGCIcon,
  mgcIconAdCircleCuteFi as MGCIcon,
  mgcIconAdCircleOffCuteFi as MGCIcon,
  mgcIconAdRectangleCuteFi as MGCIcon,
  mgcIconAdRectangleOffCuteFi as MGCIcon,
  mgcIconAnniversaryCuteFi as MGCIcon,
  mgcIconAuctionCuteFi as MGCIcon,
  mgcIconAwardCuteFi as MGCIcon,
  mgcIconBankCardCuteFi as MGCIcon,
  mgcIconBasket2CuteFi as MGCIcon,
  mgcIconBasketCuteFi as MGCIcon,
  mgcIconBriefcase2CuteFi as MGCIcon,
  mgcIconBriefcaseCuteFi as MGCIcon,
  mgcIconCalendar2CuteFi as MGCIcon,
  mgcIconCalendar3CuteFi as MGCIcon,
  mgcIconCalendarAddCuteFi as MGCIcon,
  mgcIconCalendarCuteFi as MGCIcon,
  mgcIconCalendarDayCuteFi as MGCIcon,
  mgcIconCalendarMonthCuteFi as MGCIcon,
  mgcIconCalendarTimeAddCuteFi as MGCIcon,
  mgcIconCalendarWeekCuteFi as MGCIcon,
  mgcIconCandleCuteFi as MGCIcon,
  mgcIconCandlesCuteFi as MGCIcon,
  mgcIconCardPayCuteFi as MGCIcon,
  mgcIconCardRefundCuteFi as MGCIcon,
  mgcIconCash2CuteFi as MGCIcon,
  mgcIconCashCuteFi as MGCIcon,
  mgcIconCelebrateCuteFi as MGCIcon,
  mgcIconChartBar2CuteFi as MGCIcon,
  mgcIconChartBarCuteFi as MGCIcon,
  mgcIconChartDecreaseCuteFi as MGCIcon,
  mgcIconChartHorizontalCuteFi as MGCIcon,
  mgcIconChartLineCuteFi as MGCIcon,
  mgcIconChartPie2CuteFi as MGCIcon,
  mgcIconChartPieCuteFi as MGCIcon,
  mgcIconChartVerticalCuteFi as MGCIcon,
  mgcIconChineseKnotCuteFi as MGCIcon,
  mgcIconChristmasBallCuteFi as MGCIcon,
  mgcIconCoin2CuteFi as MGCIcon,
  mgcIconCoin3CuteFi as MGCIcon,
  mgcIconCoinCuteFi as MGCIcon,
  mgcIconCopperCoinCuteFi as MGCIcon,
  mgcIconCopyrightCuteFi as MGCIcon,
  mgcIconCouponCuteFi as MGCIcon,
  mgcIconCurrencyBaht2CuteFi as MGCIcon,
  mgcIconCurrencyBahtCuteFi as MGCIcon,
  mgcIconCurrencyCny2CuteFi as MGCIcon,
  mgcIconCurrencyCnyCuteFi as MGCIcon,
  mgcIconCurrencyDollar2CuteFi as MGCIcon,
  mgcIconCurrencyDollarCuteFi as MGCIcon,
  mgcIconCurrencyEuro2CuteFi as MGCIcon,
  mgcIconCurrencyEuroCuteFi as MGCIcon,
  mgcIconCurrencyLira2CuteFi as MGCIcon,
  mgcIconCurrencyLiraCuteFi as MGCIcon,
  mgcIconCurrencyNigeria2CuteFi as MGCIcon,
  mgcIconCurrencyNigeriaCuteFi as MGCIcon,
  mgcIconCurrencyRubel2CuteFi as MGCIcon,
  mgcIconCurrencyRubelCuteFi as MGCIcon,
  mgcIconCurrencyRupee2CuteFi as MGCIcon,
  mgcIconCurrencyRupeeCuteFi as MGCIcon,
  mgcIconCurrencyShekel2CuteFi as MGCIcon,
  mgcIconCurrencyShekelCuteFi as MGCIcon,
  mgcIconCurrencyWon2CuteFi as MGCIcon,
  mgcIconCurrencyWonCuteFi as MGCIcon,
  mgcIconDiamond2CuteFi as MGCIcon,
  mgcIconExchangeBahtCuteFi as MGCIcon,
  mgcIconExchangeCnyCuteFi as MGCIcon,
  mgcIconExchangeDollarCuteFi as MGCIcon,
  mgcIconExchangeEuroCuteFi as MGCIcon,
  mgcIconFilter3CuteFi as MGCIcon,
  mgcIconFilterCuteFi as MGCIcon,
  mgcIconFlag1CuteFi as MGCIcon,
  mgcIconFlag2CuteFi as MGCIcon,
  mgcIconFlag3CuteFi as MGCIcon,
  mgcIconFlag4CuteFi as MGCIcon,
  mgcIconGift2CuteFi as MGCIcon,
  mgcIconGiftCardCuteFi as MGCIcon,
  mgcIconGiftCuteFi as MGCIcon,
  mgcIconLadderCuteFi as MGCIcon,
  mgcIconLantern2CuteFi as MGCIcon,
  mgcIconLanternCuteFi as MGCIcon,
  mgcIconLaurelWreathCuteFi as MGCIcon,
  mgcIconLuggageCuteFi as MGCIcon,
  mgcIconMedalCuteFi as MGCIcon,
  mgcIconPalette3CuteFi as MGCIcon,
  mgcIconPigMoneyCuteFi as MGCIcon,
  mgcIconPound2CuteFi as MGCIcon,
  mgcIconPoundCuteFi as MGCIcon,
  mgcIconPresentation1CuteFi as MGCIcon,
  mgcIconPresentation2CuteFi as MGCIcon,
  mgcIconPresentation3CuteFi as MGCIcon,
  mgcIconPumpkinLanternCuteFi as MGCIcon,
  mgcIconReceiveMoneyCuteFi as MGCIcon,
  mgcIconRedPacketCuteFi as MGCIcon,
  mgcIconRedPacketOpenCuteFi as MGCIcon,
  mgcIconRefundCnyCuteFi as MGCIcon,
  mgcIconRefundDollarCuteFi as MGCIcon,
  mgcIconRegisteredCuteFi as MGCIcon,
  mgcIconSafeBoxCuteFi as MGCIcon,
  mgcIconSaleCuteFi as MGCIcon,
  mgcIconScheduleCuteFi as MGCIcon,
  mgcIconSealCuteFi as MGCIcon,
  mgcIconShoppingBag1CuteFi as MGCIcon,
  mgcIconShoppingBag2CuteFi as MGCIcon,
  mgcIconShoppingBag3CuteFi as MGCIcon,
  mgcIconShoppingCart1CuteFi as MGCIcon,
  mgcIconShoppingCart2CuteFi as MGCIcon,
  mgcIconSofaCuteFi as MGCIcon,
  mgcIconStockCuteFi as MGCIcon,
  mgcIconSuitcase2CuteFi as MGCIcon,
  mgcIconSuitcaseCuteFi as MGCIcon,
  mgcIconTag2CuteFi as MGCIcon,
  mgcIconTagChevronCuteFi as MGCIcon,
  mgcIconTagCuteFi as MGCIcon,
  mgcIconTargetCuteFi as MGCIcon,
  mgcIconTicketCuteFi as MGCIcon,
  mgcIconTrophyCuteFi as MGCIcon,
  mgcIconVip1CuteFi as MGCIcon,
  mgcIconVip2CuteFi as MGCIcon,
  mgcIconVip3CuteFi as MGCIcon,
  mgcIconVip4CuteFi as MGCIcon,
  mgcIconWallet2CuteFi as MGCIcon,
  mgcIconWallet3CuteFi as MGCIcon,
  mgcIconWallet4CuteFi as MGCIcon,
  mgcIconWallet5CuteFi as MGCIcon,
  mgcIconWalletCuteFi as MGCIcon,
  mgcIconYuanbaoCuteFi as MGCIcon,
  mgcIconChat1CuteFi as MGCIcon,
  mgcIconChat2CuteFi as MGCIcon,
  mgcIconChat3CuteFi as MGCIcon,
  mgcIconChat4CuteFi as MGCIcon,
  mgcIconComment2CuteFi as MGCIcon,
  mgcIconCommentCuteFi as MGCIcon,
  mgcIconInviteCuteFi as MGCIcon,
  mgcIconMailAiCuteFi as MGCIcon,
  mgcIconMailCuteFi as MGCIcon,
  mgcIconMailOpenCuteFi as MGCIcon,
  mgcIconMailSendCuteFi as MGCIcon,
  mgcIconMailboxCuteFi as MGCIcon,
  mgcIconMessage1CuteFi as MGCIcon,
  mgcIconMessage2CuteFi as MGCIcon,
  mgcIconMessage3CuteFi as MGCIcon,
  mgcIconMessage4CuteFi as MGCIcon,
  mgcIconPhoneAddCuteFi as MGCIcon,
  mgcIconPhoneBlockCuteFi as MGCIcon,
  mgcIconPhoneCallCuteFi as MGCIcon,
  mgcIconPhoneCuteFi as MGCIcon,
  mgcIconPhoneIncomingCuteFi as MGCIcon,
  mgcIconPhoneOffCuteFi as MGCIcon,
  mgcIconPhoneOutgoingCuteFi as MGCIcon,
  mgcIconPhoneSuccessCuteFi as MGCIcon,
  mgcIconSendCuteFi as MGCIcon,
  mgcIconSendPlaneCuteFi as MGCIcon,
  mgcIconAvalancheAvaxCuteFi as MGCIcon,
  mgcIconBinanceCoinBnbCuteFi as MGCIcon,
  mgcIconBinanceUsdBusdCuteFi as MGCIcon,
  mgcIconBnbCuteFi as MGCIcon,
  mgcIconCardanoAdaCuteFi as MGCIcon,
  mgcIconCurrencyBitcoin2CuteFi as MGCIcon,
  mgcIconCurrencyBitcoinCuteFi as MGCIcon,
  mgcIconDogecoinDogeCuteFi as MGCIcon,
  mgcIconEthereumCuteFi as MGCIcon,
  mgcIconExchangeBitcoinCuteFi as MGCIcon,
  mgcIconMoneroCuteFi as MGCIcon,
  mgcIconPolkadotDotCuteFi as MGCIcon,
  mgcIconSolanaSolCuteFi as MGCIcon,
  mgcIconTetherUsdtCuteFi as MGCIcon,
  mgcIconUsdCoinUsdcCuteFi as MGCIcon,
  mgcIconXrpCuteFi as MGCIcon,
  mgcIconAlignBottomCuteFi as MGCIcon,
  mgcIconAlignHorizontalCenterCuteFi as MGCIcon,
  mgcIconAlignLeft2CuteFi as MGCIcon,
  mgcIconAlignRight2CuteFi as MGCIcon,
  mgcIconAlignTopCuteFi as MGCIcon,
  mgcIconAlignVerticalCenterCuteFi as MGCIcon,
  mgcIconAnticlockwiseAltCuteFi as MGCIcon,
  mgcIconAnticlockwiseCuteFi as MGCIcon,
  mgcIconArtboardCuteFi as MGCIcon,
  mgcIconBackgroundBaseCuteFi as MGCIcon,
  mgcIconBackgroundCuteFi as MGCIcon,
  mgcIconBlingCuteFi as MGCIcon,
  mgcIconBoardCuteFi as MGCIcon,
  mgcIconBorderBlankCuteFi as MGCIcon,
  mgcIconBorderBottomCuteFi as MGCIcon,
  mgcIconBorderHorizontalCuteFi as MGCIcon,
  mgcIconBorderInnerCuteFi as MGCIcon,
  mgcIconBorderLeftCuteFi as MGCIcon,
  mgcIconBorderOuterCuteFi as MGCIcon,
  mgcIconBorderRadiusCuteFi as MGCIcon,
  mgcIconBorderRightCuteFi as MGCIcon,
  mgcIconBorderTopCuteFi as MGCIcon,
  mgcIconBorderVerticalCuteFi as MGCIcon,
  mgcIconBrightnessCuteFi as MGCIcon,
  mgcIconBrush2CuteFi as MGCIcon,
  mgcIconClockwiseAltCuteFi as MGCIcon,
  mgcIconClockwiseCuteFi as MGCIcon,
  mgcIconColorFilterCuteFi as MGCIcon,
  mgcIconColorPickerCuteFi as MGCIcon,
  mgcIconColumns2CuteFi as MGCIcon,
  mgcIconColumns3CuteFi as MGCIcon,
  mgcIconCombineCuteFi as MGCIcon,
  mgcIconComponentsCuteFi as MGCIcon,
  mgcIconDistributeSpacingHorizontalCuteFi as MGCIcon,
  mgcIconDistributeSpacingVerticalCuteFi as MGCIcon,
  mgcIconDrawingBoardCuteFi as MGCIcon,
  mgcIconDropCuteFi as MGCIcon,
  mgcIconEaseInControlPointCuteFi as MGCIcon,
  mgcIconEaseInCuteFi as MGCIcon,
  mgcIconEaseInOutControlPointCuteFi as MGCIcon,
  mgcIconEaseOutControlPointCuteFi as MGCIcon,
  mgcIconEaseOutCuteFi as MGCIcon,
  mgcIconEasyInOutCuteFi as MGCIcon,
  mgcIconExcludeCuteFi as MGCIcon,
  mgcIconExposureCuteFi as MGCIcon,
  mgcIconFlipHorizontalCuteFi as MGCIcon,
  mgcIconFlipVerticalCuteFi as MGCIcon,
  mgcIconFoldHorizontalCuteFi as MGCIcon,
  mgcIconFoldVerticalCuteFi as MGCIcon,
  mgcIconIntersectCuteFi as MGCIcon,
  mgcIconKnifeCuteFi as MGCIcon,
  mgcIconLayerCuteFi as MGCIcon,
  mgcIconLayout10CuteFi as MGCIcon,
  mgcIconLayout11CuteFi as MGCIcon,
  mgcIconLayout2CuteFi as MGCIcon,
  mgcIconLayout3CuteFi as MGCIcon,
  mgcIconLayout4CuteFi as MGCIcon,
  mgcIconLayout5CuteFi as MGCIcon,
  mgcIconLayout6CuteFi as MGCIcon,
  mgcIconLayout7CuteFi as MGCIcon,
  mgcIconLayout8CuteFi as MGCIcon,
  mgcIconLayout9CuteFi as MGCIcon,
  mgcIconLayoutBottomCloseCuteFi as MGCIcon,
  mgcIconLayoutBottomCuteFi as MGCIcon,
  mgcIconLayoutBottomOpenCuteFi as MGCIcon,
  mgcIconLayoutCuteFi as MGCIcon,
  mgcIconLayoutGridCuteFi as MGCIcon,
  mgcIconLayoutLeftCuteFi as MGCIcon,
  mgcIconLayoutLeftbarCloseCuteFi as MGCIcon,
  mgcIconLayoutLeftbarOpenCuteFi as MGCIcon,
  mgcIconLayoutRightCuteFi as MGCIcon,
  mgcIconLayoutRightbarCloseCuteFi as MGCIcon,
  mgcIconLayoutRightbarOpenCuteFi as MGCIcon,
  mgcIconLayoutTopCloseCuteFi as MGCIcon,
  mgcIconLayoutTopCuteFi as MGCIcon,
  mgcIconLayoutTopOpenCuteFi as MGCIcon,
  mgcIconMagic1CuteFi as MGCIcon,
  mgcIconMagic2CuteFi as MGCIcon,
  mgcIconMagic3CuteFi as MGCIcon,
  mgcIconMagicHat2CuteFi as MGCIcon,
  mgcIconMagicHatCuteFi as MGCIcon,
  mgcIconMarkPenCuteFi as MGCIcon,
  mgcIconMarkupCuteFi as MGCIcon,
  mgcIconMirrorCuteFi as MGCIcon,
  mgcIconMosaicCuteFi as MGCIcon,
  mgcIconPaint2CuteFi as MGCIcon,
  mgcIconPaintBrushAiCuteFi as MGCIcon,
  mgcIconPaintBrushCuteFi as MGCIcon,
  mgcIconPalette2CuteFi as MGCIcon,
  mgcIconPaletteCuteFi as MGCIcon,
  mgcIconPasterCuteFi as MGCIcon,
  mgcIconPenCuteFi as MGCIcon,
  mgcIconQuillPenAiCuteFi as MGCIcon,
  mgcIconQuillPenCuteFi as MGCIcon,
  mgcIconRotateXCuteFi as MGCIcon,
  mgcIconRotateYCuteFi as MGCIcon,
  mgcIconRows2CuteFi as MGCIcon,
  mgcIconRows3CuteFi as MGCIcon,
  mgcIconRows4CuteFi as MGCIcon,
  mgcIconRulerCuteFi as MGCIcon,
  mgcIconScaleCuteFi as MGCIcon,
  mgcIconScissors2CuteFi as MGCIcon,
  mgcIconScissors3CuteFi as MGCIcon,
  mgcIconScissorsCuteFi as MGCIcon,
  mgcIconScreenshotCuteFi as MGCIcon,
  mgcIconSectionCuteFi as MGCIcon,
  mgcIconShadowCuteFi as MGCIcon,
  mgcIconStickerCuteFi as MGCIcon,
  mgcIconSubtractCuteFi as MGCIcon,
  mgcIconTable2CuteFi as MGCIcon,
  mgcIconUnfoldHorizontalCuteFi as MGCIcon,
  mgcIconUnfoldVerticalCuteFi as MGCIcon,
  mgcIconUnionCuteFi as MGCIcon,
  mgcIconVectorBezier2CuteFi as MGCIcon,
  mgcIconVectorBezier3CuteFi as MGCIcon,
  mgcIconVectorBezierCuteFi as MGCIcon,
  mgcIconVectorGroupCuteFi as MGCIcon,
  mgcIconXSkewCuteFi as MGCIcon,
  mgcIconYSkewCuteFi as MGCIcon,
  mgcIconBracesCuteFi as MGCIcon,
  mgcIconBracketsAngleCuteFi as MGCIcon,
  mgcIconBracketsCuteFi as MGCIcon,
  mgcIconBugCuteFi as MGCIcon,
  mgcIconCodeCuteFi as MGCIcon,
  mgcIconCommandCuteFi as MGCIcon,
  mgcIconCursor2CuteFi as MGCIcon,
  mgcIconCursor3CuteFi as MGCIcon,
  mgcIconCursorCuteFi as MGCIcon,
  mgcIconDepartmentCuteFi as MGCIcon,
  mgcIconDirectoryCuteFi as MGCIcon,
  mgcIconGitBranchCuteFi as MGCIcon,
  mgcIconGitCommitCuteFi as MGCIcon,
  mgcIconGitCompareCuteFi as MGCIcon,
  mgcIconGitMergeCuteFi as MGCIcon,
  mgcIconGitPullRequestCloseCuteFi as MGCIcon,
  mgcIconGitPullRequestCuteFi as MGCIcon,
  mgcIconHotkeyCuteFi as MGCIcon,
  mgcIconInspectCuteFi as MGCIcon,
  mgcIconParenthesesCuteFi as MGCIcon,
  mgcIconPerformanceCuteFi as MGCIcon,
  mgcIconSitemapCuteFi as MGCIcon,
  mgcIconTerminalBoxCuteFi as MGCIcon,
  mgcIconTerminalCuteFi as MGCIcon,
  mgcIconWebCuteFi as MGCIcon,
  mgcIconAiCuteFi as MGCIcon,
  mgcIconAirConditionCuteFi as MGCIcon,
  mgcIconAirConditionOpenCuteFi as MGCIcon,
  mgcIconAirplayCuteFi as MGCIcon,
  mgcIconAirpods2CuteFi as MGCIcon,
  mgcIconAlarm1CuteFi as MGCIcon,
  mgcIconAlarm2CuteFi as MGCIcon,
  mgcIconAspectRatioCuteFi as MGCIcon,
  mgcIconBarcodeCuteFi as MGCIcon,
  mgcIconBarcodeScaCuteFi as MGCIcon,
  mgcIconBaseStation2CuteFi as MGCIcon,
  mgcIconBaseStationCuteFi as MGCIcon,
  mgcIconBattery1CuteFi as MGCIcon,
  mgcIconBattery2CuteFi as MGCIcon,
  mgcIconBattery3CuteFi as MGCIcon,
  mgcIconBattery4CuteFi as MGCIcon,
  mgcIconBatteryAutomotiveCuteFi as MGCIcon,
  mgcIconBatteryChargingCuteFi as MGCIcon,
  mgcIconBatteryCuteFi as MGCIcon,
  mgcIconBluetoothCuteFi as MGCIcon,
  mgcIconBluetoothOffCuteFi as MGCIcon,
  mgcIconBulb2CuteFi as MGCIcon,
  mgcIconBulbCuteFi as MGCIcon,
  mgcIconCamcorder2CuteFi as MGCIcon,
  mgcIconCardboardVrCuteFi as MGCIcon,
  mgcIconCeilingLampCuteFi as MGCIcon,
  mgcIconCellphone2AiCuteFi as MGCIcon,
  mgcIconCellphone2CuteFi as MGCIcon,
  mgcIconCellphone2HorizontalCuteFi as MGCIcon,
  mgcIconCellphoneCuteFi as MGCIcon,
  mgcIconCellphoneVibrationCuteFi as MGCIcon,
  mgcIconChipCuteFi as MGCIcon,
  mgcIconComputerCamerCuteFi as MGCIcon,
  mgcIconComputerCameraOffCuteFi as MGCIcon,
  mgcIconComputerCuteFi as MGCIcon,
  mgcIconCounter2CuteFi as MGCIcon,
  mgcIconCube3DCuteFi as MGCIcon,
  mgcIconDashboard2CuteFi as MGCIcon,
  mgcIconDashboard3CuteFi as MGCIcon,
  mgcIconDashboard4CuteFi as MGCIcon,
  mgcIconDashboardCuteFi as MGCIcon,
  mgcIconDeskLamp2CuteFi as MGCIcon,
  mgcIconDeskLampCuteFi as MGCIcon,
  mgcIconDeviceCuteFi as MGCIcon,
  mgcIconDisplayCuteFi as MGCIcon,
  mgcIconDroneCuteFi as MGCIcon,
  mgcIconEscalatorDownCuteFi as MGCIcon,
  mgcIconEscalatorUpCuteFi as MGCIcon,
  mgcIconFaxCuteFi as MGCIcon,
  mgcIconFlashCircleCuteFi as MGCIcon,
  mgcIconFlashCuteFi as MGCIcon,
  mgcIconFlashlightCuteFi as MGCIcon,
  mgcIconFridgeCuteFi as MGCIcon,
  mgcIconGame1CuteFi as MGCIcon,
  mgcIconGame2CuteFi as MGCIcon,
  mgcIconGradienterCuteFi as MGCIcon,
  mgcIconGuitarCuteFi as MGCIcon,
  mgcIconHighVoltagePowerCuteFi as MGCIcon,
  mgcIconHomeWifiCuteFi as MGCIcon,
  mgcIconHomepodCuteFi as MGCIcon,
  mgcIconHomepodMiniCuteFi as MGCIcon,
  mgcIconIMacCuteFi as MGCIcon,
  mgcIconInstrumentCuteFi as MGCIcon,
  mgcIconKeyboard2CuteFi as MGCIcon,
  mgcIconKeyboardCuteFi as MGCIcon,
  mgcIconLaptop2CuteFi as MGCIcon,
  mgcIconLaptopCuteFi as MGCIcon,
  mgcIconLightCuteFi as MGCIcon,
  mgcIconMicroscopeCuteFi as MGCIcon,
  mgcIconMidiCuteFi as MGCIcon,
  mgcIconMonitorCuteFi as MGCIcon,
  mgcIconMouseCuteFi as MGCIcon,
  mgcIconPadCuteFi as MGCIcon,
  mgcIconPanoramasCuteFi as MGCIcon,
  mgcIconPlugin2CuteFi as MGCIcon,
  mgcIconPluginCuteFi as MGCIcon,
  mgcIconPrintCuteFi as MGCIcon,
  mgcIconProjectorCuteFi as MGCIcon,
  mgcIconProjectorScreenCuteFi as MGCIcon,
  mgcIconQrcode2CuteFi as MGCIcon,
  mgcIconQrcodeCuteFi as MGCIcon,
  mgcIconRadaCuteFi as MGCIcon,
  mgcIconRadar2CuteFi as MGCIcon,
  mgcIconRadioCuteFi as MGCIcon,
  mgcIconRemoteControlCuteFi as MGCIcon,
  mgcIconRemoteCuteFi as MGCIcon,
  mgcIconRouterModemCuteFi as MGCIcon,
  mgcIconRss2CuteFi as MGCIcon,
  mgcIconRssCuteFi as MGCIcon,
  mgcIconSandglass2CuteFi as MGCIcon,
  mgcIconSandglassCuteFi as MGCIcon,
  mgcIconScan2CuteFi as MGCIcon,
  mgcIconScanCuteFi as MGCIcon,
  mgcIconServer2CuteFi as MGCIcon,
  mgcIconServerCuteFi as MGCIcon,
  mgcIconShowerCuteFi as MGCIcon,
  mgcIconSignalCuteFi as MGCIcon,
  mgcIconSolarPanelCuteFi as MGCIcon,
  mgcIconSpeakerCuteFi as MGCIcon,
  mgcIconStopwatchCuteFi as MGCIcon,
  mgcIconStorageCuteFi as MGCIcon,
  mgcIconTelescope2CuteFi as MGCIcon,
  mgcIconTelescopeCuteFi as MGCIcon,
  mgcIconTowerCraneCuteFi as MGCIcon,
  mgcIconTv1CuteFi as MGCIcon,
  mgcIconTv2CuteFi as MGCIcon,
  mgcIconUsbCuteFi as MGCIcon,
  mgcIconUsbFlashDiskCuteFi as MGCIcon,
  mgcIconVisonProCuteFi as MGCIcon,
  mgcIconWashMachineCuteFi as MGCIcon,
  mgcIconWatch2CuteFi as MGCIcon,
  mgcIconWatchCuteFi as MGCIcon,
  mgcIconWifiCuteFi as MGCIcon,
  mgcIconWifiOffCuteFi as MGCIcon,
  mgcIconAlignCenterCuteFi as MGCIcon,
  mgcIconAlignJustifyCuteFi as MGCIcon,
  mgcIconAlignLeftCuteFi as MGCIcon,
  mgcIconAlignRightCuteFi as MGCIcon,
  mgcIconAndCuteFi as MGCIcon,
  mgcIconAsterisk2CuteFi as MGCIcon,
  mgcIconAsteriskCuteFi as MGCIcon,
  mgcIconAtCuteFi as MGCIcon,
  mgcIconAzSortAscendingLettersCuteFi as MGCIcon,
  mgcIconAzSortDescendingLettersCuteFi as MGCIcon,
  mgcIconBlockquoteCuteFi as MGCIcon,
  mgcIconBoldCuteFi as MGCIcon,
  mgcIconColumnCuteFi as MGCIcon,
  mgcIconContentAiCuteFi as MGCIcon,
  mgcIconCursorTextCuteFi as MGCIcon,
  mgcIconDividingLineCuteFi as MGCIcon,
  mgcIconEdit2CuteFi as MGCIcon,
  mgcIconEdit3CuteFi as MGCIcon,
  mgcIconEdit4CuteFi as MGCIcon,
  mgcIconEditCuteFi as MGCIcon,
  mgcIconEraserCuteFi as MGCIcon,
  mgcIconFontCuteFi as MGCIcon,
  mgcIconFontSizeCuteFi as MGCIcon,
  mgcIconFormulaCuteFi as MGCIcon,
  mgcIconFrameCuteFi as MGCIcon,
  mgcIconHashtagCuteFi as MGCIcon,
  mgcIconHeading1CuteFi as MGCIcon,
  mgcIconHeading2CuteFi as MGCIcon,
  mgcIconHeading3CuteFi as MGCIcon,
  mgcIconIndentDecreaseCuteFi as MGCIcon,
  mgcIconIndentIncreaseCuteFi as MGCIcon,
  mgcIconItalicCuteFi as MGCIcon,
  mgcIconLetterSpacingCuteFi as MGCIcon,
  mgcIconLineHeightCuteFi as MGCIcon,
  mgcIconListCheck2CuteFi as MGCIcon,
  mgcIconListCheck3CuteFi as MGCIcon,
  mgcIconListCheckCuteFi as MGCIcon,
  mgcIconListCollapseCuteFi as MGCIcon,
  mgcIconListExpansionCuteFi as MGCIcon,
  mgcIconListOrderedCuteFi as MGCIcon,
  mgcIconListSearchCuteFi as MGCIcon,
  mgcIconMenuCuteFi as MGCIcon,
  mgcIconNumbers09SortAscendingCuteFi as MGCIcon,
  mgcIconNumbers09SortDescendingCuteFi as MGCIcon,
  mgcIconNumbers90SortAscendingCuteFi as MGCIcon,
  mgcIconNumbers90SortDescendingCuteFi as MGCIcon,
  mgcIconOmegaCuteFi as MGCIcon,
  mgcIconPaintCuteFi as MGCIcon,
  mgcIconParagraphCuteFi as MGCIcon,
  mgcIconPen2CuteFi as MGCIcon,
  mgcIconPencil2AiCuteFi as MGCIcon,
  mgcIconPencil2CuteFi as MGCIcon,
  mgcIconPencil3CuteFi as MGCIcon,
  mgcIconPencilCuteFi as MGCIcon,
  mgcIconPencilRulerCuteFi as MGCIcon,
  mgcIconQuoteLeftCuteFi as MGCIcon,
  mgcIconQuoteRightCuteFi as MGCIcon,
  mgcIconSignatureCuteFi as MGCIcon,
  mgcIconSortAscendingCuteFi as MGCIcon,
  mgcIconSortDescendingCuteFi as MGCIcon,
  mgcIconSpaceCuteFi as MGCIcon,
  mgcIconSpacingHorizontalCuteFi as MGCIcon,
  mgcIconSpacingVerticalCuteFi as MGCIcon,
  mgcIconStrikethroughCuteFi as MGCIcon,
  mgcIconSubtitleCuteFi as MGCIcon,
  mgcIconTable3CuteFi as MGCIcon,
  mgcIconTableCuteFi as MGCIcon,
  mgcIconText2CuteFi as MGCIcon,
  mgcIconTextAreaCuteFi as MGCIcon,
  mgcIconTextColorCuteFi as MGCIcon,
  mgcIconTextCuteFi as MGCIcon,
  mgcIconTextDirectionLeftCuteFi as MGCIcon,
  mgcIconTextDirectionRightCuteFi as MGCIcon,
  mgcIconTextboxAiCuteFi as MGCIcon,
  mgcIconTextboxCuteFi as MGCIcon,
  mgcIconTranslate2AiCuteFi as MGCIcon,
  mgcIconTranslate2CuteFi as MGCIcon,
  mgcIconTranslateCuteFi as MGCIcon,
  mgcIconUnderlineCuteFi as MGCIcon,
  mgcIconZaSortAscendingLettersCuteFi as MGCIcon,
  mgcIconZaSortDescendingLettersCuteFi as MGCIcon,
  mgcIconBackpackCuteFi as MGCIcon,
  mgcIconBalanceCuteFi as MGCIcon,
  mgcIconBlackBoard2CuteFi as MGCIcon,
  mgcIconBlackBoardCuteFi as MGCIcon,
  mgcIconBook2CuteFi as MGCIcon,
  mgcIconBook3CuteFi as MGCIcon,
  mgcIconBook4CuteFi as MGCIcon,
  mgcIconBook5CuteFi as MGCIcon,
  mgcIconBook6CuteFi as MGCIcon,
  mgcIconBookCuteFi as MGCIcon,
  mgcIconBookmarkAddCuteFi as MGCIcon,
  mgcIconBookmarkCuteFi as MGCIcon,
  mgcIconBookmarkEditCuteFi as MGCIcon,
  mgcIconBookmarkRemoveCuteFi as MGCIcon,
  mgcIconBookmarksCuteFi as MGCIcon,
  mgcIconCertificate2CuteFi as MGCIcon,
  mgcIconCompass2CuteFi as MGCIcon,
  mgcIconCounterCuteFi as MGCIcon,
  mgcIconDeskCuteFi as MGCIcon,
  mgcIconDiaryCuteFi as MGCIcon,
  mgcIconDrumCuteFi as MGCIcon,
  mgcIconEyeglassCuteFi as MGCIcon,
  mgcIconFlask2CuteFi as MGCIcon,
  mgcIconFlask3CuteFi as MGCIcon,
  mgcIconFlaskCuteFi as MGCIcon,
  mgcIconFoldingFanCuteFi as MGCIcon,
  mgcIconGlobeCuteFi as MGCIcon,
  mgcIconMagnetCuteFi as MGCIcon,
  mgcIconMortarboardCuteFi as MGCIcon,
  mgcIconNotebook2CuteFi as MGCIcon,
  mgcIconNotebookCuteFi as MGCIcon,
  mgcIconScienceCuteFi as MGCIcon,
  mgcIconSpeechCuteFi as MGCIcon,
  mgcIconTestTubeCuteFi as MGCIcon,
  mgcIconAngelCuteFi as MGCIcon,
  mgcIconAngryCuteFi as MGCIcon,
  mgcIconConfusedCuteFi as MGCIcon,
  mgcIconEmoji2CuteFi as MGCIcon,
  mgcIconEmojiCuteFi as MGCIcon,
  mgcIconHappyCuteFi as MGCIcon,
  mgcIconLaughCuteFi as MGCIcon,
  mgcIconLookDownCuteFi as MGCIcon,
  mgcIconLookLeftCuteFi as MGCIcon,
  mgcIconLookRightCuteFi as MGCIcon,
  mgcIconLookUpCuteFi as MGCIcon,
  mgcIconOmgCuteFi as MGCIcon,
  mgcIconPuzzledCuteFi as MGCIcon,
  mgcIconSadCuteFi as MGCIcon,
  mgcIconSickCuteFi as MGCIcon,
  mgcIconSilentCuteFi as MGCIcon,
  mgcIconSobCuteFi as MGCIcon,
  mgcIconSurpriseCuteFi as MGCIcon,
  mgcIconSweatsCuteFi as MGCIcon,
  mgcIconTerrorCuteFi as MGCIcon,
  mgcIconTongueCuteFi as MGCIcon,
  mgcIconUnhappyCuteFi as MGCIcon,
  mgcIconUnhappyDizzyCuteFi as MGCIcon,
  mgcIconAlbum2CuteFi as MGCIcon,
  mgcIconArchiveCuteFi as MGCIcon,
  mgcIconAttachment2CuteFi as MGCIcon,
  mgcIconAttachmentCuteFi as MGCIcon,
  mgcIconBill2CuteFi as MGCIcon,
  mgcIconBillCuteFi as MGCIcon,
  mgcIconBox2CuteFi as MGCIcon,
  mgcIconBox3CuteFi as MGCIcon,
  mgcIconBoxCuteFi as MGCIcon,
  mgcIconClipboardCuteFi as MGCIcon,
  mgcIconCopy2CuteFi as MGCIcon,
  mgcIconCopy3CuteFi as MGCIcon,
  mgcIconCopyCuteFi as MGCIcon,
  mgcIconDocCuteFi as MGCIcon,
  mgcIconDocmentCuteFi as MGCIcon,
  mgcIconDocument2CuteFi as MGCIcon,
  mgcIconDocument3CuteFi as MGCIcon,
  mgcIconDocumentsCuteFi as MGCIcon,
  mgcIconDownload2CuteFi as MGCIcon,
  mgcIconDownload3CuteFi as MGCIcon,
  mgcIconDownloadCuteFi as MGCIcon,
  mgcIconEmptyBoxCuteFi as MGCIcon,
  mgcIconExternalLinkCuteFi as MGCIcon,
  mgcIconFileCertificateCuteFi as MGCIcon,
  mgcIconFileCheckCuteFi as MGCIcon,
  mgcIconFileCodeCuteFi as MGCIcon,
  mgcIconFileCuteFi as MGCIcon,
  mgcIconFileDownloadCuteFi as MGCIcon,
  mgcIconFileExportCuteFi as MGCIcon,
  mgcIconFileForbidCuteFi as MGCIcon,
  mgcIconFileImportCuteFi as MGCIcon,
  mgcIconFileInfoCuteFi as MGCIcon,
  mgcIconFileLockedCuteFi as MGCIcon,
  mgcIconFileMoreCuteFi as MGCIcon,
  mgcIconFileMusicCuteFi as MGCIcon,
  mgcIconFileNewCuteFi as MGCIcon,
  mgcIconFileSearchCuteFi as MGCIcon,
  mgcIconFileSecurityCuteFi as MGCIcon,
  mgcIconFileStarCuteFi as MGCIcon,
  mgcIconFileUnknownCuteFi as MGCIcon,
  mgcIconFileUploadCuteFi as MGCIcon,
  mgcIconFileWarningCuteFi as MGCIcon,
  mgcIconFileZipCuteFi as MGCIcon,
  mgcIconFolder2CuteFi as MGCIcon,
  mgcIconFolder3CuteFi as MGCIcon,
  mgcIconFolderCheckCuteFi as MGCIcon,
  mgcIconFolderCuteFi as MGCIcon,
  mgcIconFolderDeleteCuteFi as MGCIcon,
  mgcIconFolderDownloadCuteFi as MGCIcon,
  mgcIconFolderForbidCuteFi as MGCIcon,
  mgcIconFolderInfoCuteFi as MGCIcon,
  mgcIconFolderLocked2CuteFi as MGCIcon,
  mgcIconFolderLockedCuteFi as MGCIcon,
  mgcIconFolderMinusCuteFi as MGCIcon,
  mgcIconFolderMoreCuteFi as MGCIcon,
  mgcIconFolderOpen2CuteFi as MGCIcon,
  mgcIconFolderOpenCuteFi as MGCIcon,
  mgcIconFolderSecurityCuteFi as MGCIcon,
  mgcIconFolderStarCuteFi as MGCIcon,
  mgcIconFolderUploadCuteFi as MGCIcon,
  mgcIconFolderWarningCuteFi as MGCIcon,
  mgcIconFolderZipCuteFi as MGCIcon,
  mgcIconFoldersCuteFi as MGCIcon,
  mgcIconInbox2CuteFi as MGCIcon,
  mgcIconInboxCuteFi as MGCIcon,
  mgcIconInventoryCuteFi as MGCIcon,
  mgcIconLink2CuteFi as MGCIcon,
  mgcIconLink3CuteFi as MGCIcon,
  mgcIconLinkCuteFi as MGCIcon,
  mgcIconMarkdownCuteFi as MGCIcon,
  mgcIconNewFolderCuteFi as MGCIcon,
  mgcIconNews2CuteFi as MGCIcon,
  mgcIconNewsCuteFi as MGCIcon,
  mgcIconPackage2CuteFi as MGCIcon,
  mgcIconPackageCuteFi as MGCIcon,
  mgcIconPaper2CuteFi as MGCIcon,
  mgcIconPaperCuteFi as MGCIcon,
  mgcIconPassportCuteFi as MGCIcon,
  mgcIconPasteCuteFi as MGCIcon,
  mgcIconPdfCuteFi as MGCIcon,
  mgcIconPhotoAlbum2CuteFi as MGCIcon,
  mgcIconPhotoAlbumCuteFi as MGCIcon,
  mgcIconPic2CuteFi as MGCIcon,
  mgcIconPicAiCuteFi as MGCIcon,
  mgcIconPicCuteFi as MGCIcon,
  mgcIconPin2CuteFi as MGCIcon,
  mgcIconPinCuteFi as MGCIcon,
  mgcIconPptCuteFi as MGCIcon,
  mgcIconProfileCuteFi as MGCIcon,
  mgcIconReportFormsCuteFi as MGCIcon,
  mgcIconSave2CuteFi as MGCIcon,
  mgcIconSaveCuteFi as MGCIcon,
  mgcIconSearch2CuteFi as MGCIcon,
  mgcIconSearch3CuteFi as MGCIcon,
  mgcIconSearchAiCuteFi as MGCIcon,
  mgcIconSearchCuteFi as MGCIcon,
  mgcIconTask2CuteFi as MGCIcon,
  mgcIconTaskCuteFi as MGCIcon,
  mgcIconToDoCuteFi as MGCIcon,
  mgcIconUnarchiveCuteFi as MGCIcon,
  mgcIconUnlink2CuteFi as MGCIcon,
  mgcIconUnlinkCuteFi as MGCIcon,
  mgcIconUpload2CuteFi as MGCIcon,
  mgcIconUpload3CuteFi as MGCIcon,
  mgcIconUploadCuteFi as MGCIcon,
  mgcIconXlsCuteFi as MGCIcon,
  mgcIconZoomInCuteFi as MGCIcon,
  mgcIconZoomOutCuteFi as MGCIcon,
  mgcIconBirthday2CuteFi as MGCIcon,
  mgcIconBoneCuteFi as MGCIcon,
  mgcIconBottleGlassCuteFi as MGCIcon,
  mgcIconBowl2CuteFi as MGCIcon,
  mgcIconBowlCuteFi as MGCIcon,
  mgcIconBreadCuteFi as MGCIcon,
  mgcIconCakeCuteFi as MGCIcon,
  mgcIconCandy2CuteFi as MGCIcon,
  mgcIconCandyCuteFi as MGCIcon,
  mgcIconCarrotCuteFi as MGCIcon,
  mgcIconChampagneCuteFi as MGCIcon,
  mgcIconChickenCuteFi as MGCIcon,
  mgcIconChopsticksCuteFi as MGCIcon,
  mgcIconCookieCuteFi as MGCIcon,
  mgcIconCookieManCuteFi as MGCIcon,
  mgcIconCupcakeCuteFi as MGCIcon,
  mgcIconDinnerCuteFi as MGCIcon,
  mgcIconDishCoverCuteFi as MGCIcon,
  mgcIconDonutCuteFi as MGCIcon,
  mgcIconDrinkCuteFi as MGCIcon,
  mgcIconEggCrackCuteFi as MGCIcon,
  mgcIconEggCuteFi as MGCIcon,
  mgcIconElectricCookerCuteFi as MGCIcon,
  mgcIconFeederCuteFi as MGCIcon,
  mgcIconFishCuteFi as MGCIcon,
  mgcIconForkCuteFi as MGCIcon,
  mgcIconForkKnifeCuteFi as MGCIcon,
  mgcIconForkSpoonCuteFi as MGCIcon,
  mgcIconFriedEggCuteFi as MGCIcon,
  mgcIconFriesCuteFi as MGCIcon,
  mgcIconGlassCupCuteFi as MGCIcon,
  mgcIconHamburgerCuteFi as MGCIcon,
  mgcIconIceCream2CuteFi as MGCIcon,
  mgcIconIceCreamCuteFi as MGCIcon,
  mgcIconLollipopCuteFi as MGCIcon,
  mgcIconPizzaCuteFi as MGCIcon,
  mgcIconSoupPot2CuteFi as MGCIcon,
  mgcIconSoupPotCuteFi as MGCIcon,
  mgcIconSpatulaCuteFi as MGCIcon,
  mgcIconSpoonCuteFi as MGCIcon,
  mgcIconSugarCoatedHawsCuteFi as MGCIcon,
  mgcIconTeacupCuteFi as MGCIcon,
  mgcIconWineCuteFi as MGCIcon,
  mgcIconWineglass2CuteFi as MGCIcon,
  mgcIconWineglassCuteFi as MGCIcon,
  mgcIconAirbnbCuteFi as MGCIcon,
  mgcIconAirdropCuteFi as MGCIcon,
  mgcIconAlipayCuteFi as MGCIcon,
  mgcIconAndroid2CuteFi as MGCIcon,
  mgcIconAndroidCuteFi as MGCIcon,
  mgcIconAppleCuteFi as MGCIcon,
  mgcIconAppleIntelligenceCuteFi as MGCIcon,
  mgcIconAppleIntelligenceFrameCuteFi as MGCIcon,
  mgcIconAppstoreCuteFi as MGCIcon,
  mgcIconArcBrowserCuteFi as MGCIcon,
  mgcIconBehanceCuteFi as MGCIcon,
  mgcIconBilibiliCuteFi as MGCIcon,
  mgcIconBlueskySocialCuteFi as MGCIcon,
  mgcIconCarplayCuteFi as MGCIcon,
  mgcIconChromeCuteFi as MGCIcon,
  mgcIconCodepenCuteFi as MGCIcon,
  mgcIconCopilotCuteFi as MGCIcon,
  mgcIconDingtalkCuteFi as MGCIcon,
  mgcIconDiscordCuteFi as MGCIcon,
  mgcIconDribbbleCuteFi as MGCIcon,
  mgcIconDriveCuteFi as MGCIcon,
  mgcIconDropboxCuteFi as MGCIcon,
  mgcIconEdgeCuteFi as MGCIcon,
  mgcIconFacebookCuteFi as MGCIcon,
  mgcIconFigmaCuteFi as MGCIcon,
  mgcIconFirefoxCuteFi as MGCIcon,
  mgcIconFollowCuteFi as MGCIcon,
  mgcIconGitLabCuteFi as MGCIcon,
  mgcIconGithub2CuteFi as MGCIcon,
  mgcIconGithubCuteFi as MGCIcon,
  mgcIconGoogleCuteFi as MGCIcon,
  mgcIconGooglePlayCuteFi as MGCIcon,
  mgcIconGrokCuteFi as MGCIcon,
  mgcIconGumroadCuteFi as MGCIcon,
  mgcIconInstagramCuteFi as MGCIcon,
  mgcIconKakaoTalkCuteFi as MGCIcon,
  mgcIconLayersCuteFi as MGCIcon,
  mgcIconLemonSqueezyCuteFi as MGCIcon,
  mgcIconLineAppCuteFi as MGCIcon,
  mgcIconLinearCuteFi as MGCIcon,
  mgcIconLinkedinCuteFi as MGCIcon,
  mgcIconLinuxCuteFi as MGCIcon,
  mgcIconMastercardCuteFi as MGCIcon,
  mgcIconMastodonCuteFi as MGCIcon,
  mgcIconMediumCuteFi as MGCIcon,
  mgcIconMessengerCuteFi as MGCIcon,
  mgcIconMetaCuteFi as MGCIcon,
  mgcIconMingcuteCuteFi as MGCIcon,
  mgcIconMomentCuteFi as MGCIcon,
  mgcIconNeteaseMusicCuteFi as MGCIcon,
  mgcIconNfcCuteFi as MGCIcon,
  mgcIconNintendoSwitchCuteFi as MGCIcon,
  mgcIconNotionCuteFi as MGCIcon,
  mgcIconOpenaiCuteFi as MGCIcon,
  mgcIconPaypalCuteFi as MGCIcon,
  mgcIconPinterestCuteFi as MGCIcon,
  mgcIconQqCuteFi as MGCIcon,
  mgcIconReactCuteFi as MGCIcon,
  mgcIconRedditCuteFi as MGCIcon,
  mgcIconSafariCuteFi as MGCIcon,
  mgcIconSiriCuteFi as MGCIcon,
  mgcIconSiriFrameCuteFi as MGCIcon,
  mgcIconSnapchatCuteFi as MGCIcon,
  mgcIconSocialXCuteFi as MGCIcon,
  mgcIconSpotifyCuteFi as MGCIcon,
  mgcIconStripeCuteFi as MGCIcon,
  mgcIconTelegramCuteFi as MGCIcon,
  mgcIconThreadsCuteFi as MGCIcon,
  mgcIconTiktokCuteFi as MGCIcon,
  mgcIconTrelloBoardCuteFi as MGCIcon,
  mgcIconTwitterCuteFi as MGCIcon,
  mgcIconViberMessengerCuteFi as MGCIcon,
  mgcIconVisaCuteFi as MGCIcon,
  mgcIconVkontakteCuteFi as MGCIcon,
  mgcIconVscodeCuteFi as MGCIcon,
  mgcIconVueCuteFi as MGCIcon,
  mgcIconWechatCuteFi as MGCIcon,
  mgcIconWechatMiniprogramCuteFi as MGCIcon,
  mgcIconWechatPayCuteFi as MGCIcon,
  mgcIconWeiboCuteFi as MGCIcon,
  mgcIconWhatsappCuteFi as MGCIcon,
  mgcIconWindowsCuteFi as MGCIcon,
  mgcIconXboxCuteFi as MGCIcon,
  mgcIconYoutubeCuteFi as MGCIcon,
  mgcIconAiming2CuteFi as MGCIcon,
  mgcIconAimingCuteFi as MGCIcon,
  mgcIconAnchorCuteFi as MGCIcon,
  mgcIconBed2CuteFi as MGCIcon,
  mgcIconBedCuteFi as MGCIcon,
  mgcIconClock2CuteFi as MGCIcon,
  mgcIconClockCuteFi as MGCIcon,
  mgcIconCompass3CuteFi as MGCIcon,
  mgcIconCompassCuteFi as MGCIcon,
  mgcIconDirections2CuteFi as MGCIcon,
  mgcIconDirectionsCuteFi as MGCIcon,
  mgcIconEarth2CuteFi as MGCIcon,
  mgcIconEarth3CuteFi as MGCIcon,
  mgcIconEarthCuteFi as MGCIcon,
  mgcIconEarthLatitudeCuteFi as MGCIcon,
  mgcIconEarthLongitudeCuteFi as MGCIcon,
  mgcIconFootCuteFi as MGCIcon,
  mgcIconGlobe2CuteFi as MGCIcon,
  mgcIconHoursCuteFi as MGCIcon,
  mgcIconLifebuoyCuteFi as MGCIcon,
  mgcIconLiveLocationCuteFi as MGCIcon,
  mgcIconLocation2CuteFi as MGCIcon,
  mgcIconLocation3CuteFi as MGCIcon,
  mgcIconLocationCuteFi as MGCIcon,
  mgcIconMap2CuteFi as MGCIcon,
  mgcIconMapCuteFi as MGCIcon,
  mgcIconMapPinCuteFi as MGCIcon,
  mgcIconNavigationCuteFi as MGCIcon,
  mgcIconParkingCuteFi as MGCIcon,
  mgcIconPlanetCuteFi as MGCIcon,
  mgcIconRestAreaCuteFi as MGCIcon,
  mgcIconRoadCuteFi as MGCIcon,
  mgcIconRouteCuteFi as MGCIcon,
  mgcIconTrafficConeCuteFi as MGCIcon,
  mgcIconTunnelCuteFi as MGCIcon,
  mgcIconUmbrella2CuteFi as MGCIcon,
  mgcIconWorld2CuteFi as MGCIcon,
  mgcIconWorldCuteFi as MGCIcon,
  mgcIconAirpodsCuteFi as MGCIcon,
  mgcIconAlbumCuteFi as MGCIcon,
  mgcIconAnnouncementCuteFi as MGCIcon,
  mgcIconAudioTapeCuteFi as MGCIcon,
  mgcIconBellRingingCuteFi as MGCIcon,
  mgcIconCamcorder3CuteFi as MGCIcon,
  mgcIconCamcorderCuteFi as MGCIcon,
  mgcIconCamcorderOffCuteFi as MGCIcon,
  mgcIconCamera2AiCuteFi as MGCIcon,
  mgcIconCamera2CuteFi as MGCIcon,
  mgcIconCamera2OffCuteFi as MGCIcon,
  mgcIconCameraCuteFi as MGCIcon,
  mgcIconCameraRotateCuteFi as MGCIcon,
  mgcIconClapperboardCuteFi as MGCIcon,
  mgcIconDanmakuCuteFi as MGCIcon,
  mgcIconDanmakuOffCuteFi as MGCIcon,
  mgcIconDanmakuOnCuteFi as MGCIcon,
  mgcIconDiscCuteFi as MGCIcon,
  mgcIconExpandPlayerCuteFi as MGCIcon,
  mgcIconFastForwardCuteFi as MGCIcon,
  mgcIconFastRewindCuteFi as MGCIcon,
  mgcIconFilmCuteFi as MGCIcon,
  mgcIconFullscreenCuteFi as MGCIcon,
  mgcIconFullscreenExitCuteFi as MGCIcon,
  mgcIconHeadphone2CuteFi as MGCIcon,
  mgcIconHeadphoneCuteFi as MGCIcon,
  mgcIconHorn2CuteFi as MGCIcon,
  mgcIconHornCuteFi as MGCIcon,
  mgcIconLiveCuteFi as MGCIcon,
  mgcIconLivePhotoCuteFi as MGCIcon,
  mgcIconMic2CuteFi as MGCIcon,
  mgcIconMicAiCuteFi as MGCIcon,
  mgcIconMicCuteFi as MGCIcon,
  mgcIconMicOffCuteFi as MGCIcon,
  mgcIconMicrophoneCuteFi as MGCIcon,
  mgcIconMiniplayerCuteFi as MGCIcon,
  mgcIconMovieCuteFi as MGCIcon,
  mgcIconMusic2AiCuteFi as MGCIcon,
  mgcIconMusic2CuteFi as MGCIcon,
  mgcIconMusic3CuteFi as MGCIcon,
  mgcIconMusicCuteFi as MGCIcon,
  mgcIconNotificationCuteFi as MGCIcon,
  mgcIconNotificationNewdotCuteFi as MGCIcon,
  mgcIconNotificationOffCuteFi as MGCIcon,
  mgcIconPauseCircleCuteFi as MGCIcon,
  mgcIconPauseCuteFi as MGCIcon,
  mgcIconPlayCircleCuteFi as MGCIcon,
  mgcIconPlayCuteFi as MGCIcon,
  mgcIconPlaylist2CuteFi as MGCIcon,
  mgcIconPlaylistCuteFi as MGCIcon,
  mgcIconRecordMailCuteFi as MGCIcon,
  mgcIconRepeatCuteFi as MGCIcon,
  mgcIconRepeatOneCuteFi as MGCIcon,
  mgcIconRewindBackward10CuteFi as MGCIcon,
  mgcIconRewindBackward15CuteFi as MGCIcon,
  mgcIconRewindBackward30CuteFi as MGCIcon,
  mgcIconRewindBackward5CuteFi as MGCIcon,
  mgcIconRewindBackwardSquare10CuteFi as MGCIcon,
  mgcIconRewindBackwardSquare15CuteFi as MGCIcon,
  mgcIconRewindBackwardSquare30CuteFi as MGCIcon,
  mgcIconRewindBackwardSquare5CuteFi as MGCIcon,
  mgcIconRewindForward10CuteFi as MGCIcon,
  mgcIconRewindForward15CuteFi as MGCIcon,
  mgcIconRewindForward30CuteFi as MGCIcon,
  mgcIconRewindForward5CuteFi as MGCIcon,
  mgcIconRewindForwardSquare10CuteFi as MGCIcon,
  mgcIconRewindForwardSquare15CuteFi as MGCIcon,
  mgcIconRewindForwardSquare30CuteFi as MGCIcon,
  mgcIconRewindForwardSquare5CuteFi as MGCIcon,
  mgcIconRotateToHorizontalCuteFi as MGCIcon,
  mgcIconRotateToVerticalCuteFi as MGCIcon,
  mgcIconServiceCuteFi as MGCIcon,
  mgcIconShuffle2CuteFi as MGCIcon,
  mgcIconShuffleCuteFi as MGCIcon,
  mgcIconSkipForwardCuteFi as MGCIcon,
  mgcIconSkipPreviousCuteFi as MGCIcon,
  mgcIconSoundLineCuteFi as MGCIcon,
  mgcIconStopCircleCuteFi as MGCIcon,
  mgcIconStopCuteFi as MGCIcon,
  mgcIconVideoCamera2CuteFi as MGCIcon,
  mgcIconVideoCameraCuteFi as MGCIcon,
  mgcIconVideoCuteFi as MGCIcon,
  mgcIconVoice2CuteFi as MGCIcon,
  mgcIconVoiceCuteFi as MGCIcon,
  mgcIconVolumeCuteFi as MGCIcon,
  mgcIconVolumeMuteCuteFi as MGCIcon,
  mgcIconVolumeOffCuteFi as MGCIcon,
  mgcIconBearCuteFi as MGCIcon,
  mgcIconBirdCuteFi as MGCIcon,
  mgcIconButterfly2CuteFi as MGCIcon,
  mgcIconButterflyCuteFi as MGCIcon,
  mgcIconCactus2CuteFi as MGCIcon,
  mgcIconCactusCuteFi as MGCIcon,
  mgcIconCampfireCuteFi as MGCIcon,
  mgcIconCatCuteFi as MGCIcon,
  mgcIconChessCuteFi as MGCIcon,
  mgcIconDandelionCuteFi as MGCIcon,
  mgcIconDogCuteFi as MGCIcon,
  mgcIconDragonflyCuteFi as MGCIcon,
  mgcIconFlower2CuteFi as MGCIcon,
  mgcIconFlower3CuteFi as MGCIcon,
  mgcIconFlower4CuteFi as MGCIcon,
  mgcIconFlower5CuteFi as MGCIcon,
  mgcIconFlowerCuteFi as MGCIcon,
  mgcIconFlowerpotCuteFi as MGCIcon,
  mgcIconGrassCuteFi as MGCIcon,
  mgcIconLeaf2CuteFi as MGCIcon,
  mgcIconLeaf3CuteFi as MGCIcon,
  mgcIconLeafCuteFi as MGCIcon,
  mgcIconLotusCuteFi as MGCIcon,
  mgcIconMapleLeafCuteFi as MGCIcon,
  mgcIconMickeymouseCuteFi as MGCIcon,
  mgcIconMountain2CuteFi as MGCIcon,
  mgcIconMountainCuteFi as MGCIcon,
  mgcIconMushroomCuteFi as MGCIcon,
  mgcIconPawCuteFi as MGCIcon,
  mgcIconPigCuteFi as MGCIcon,
  mgcIconPumpkinCuteFi as MGCIcon,
  mgcIconRabbitCuteFi as MGCIcon,
  mgcIconSunflowerCuteFi as MGCIcon,
  mgcIconToyHorseCuteFi as MGCIcon,
  mgcIconTree2CuteFi as MGCIcon,
  mgcIconTree3CuteFi as MGCIcon,
  mgcIconTree4CuteFi as MGCIcon,
  mgcIconTreeCuteFi as MGCIcon,
  mgcIconWreathCuteFi as MGCIcon,
  mgcIconAxeCuteFi as MGCIcon,
  mgcIconBalloon2CuteFi as MGCIcon,
  mgcIconBathCuteFi as MGCIcon,
  mgcIconBedsideTable2CuteFi as MGCIcon,
  mgcIconBedsideTableCuteFi as MGCIcon,
  mgcIconBlessingCuteFi as MGCIcon,
  mgcIconBombCuteFi as MGCIcon,
  mgcIconBoomCuteFi as MGCIcon,
  mgcIconBottleCuteFi as MGCIcon,
  mgcIconCapsuleCuteFi as MGCIcon,
  mgcIconCoathangerCuteFi as MGCIcon,
  mgcIconCross2CuteFi as MGCIcon,
  mgcIconCrystalBallCuteFi as MGCIcon,
  mgcIconCurtainCuteFi as MGCIcon,
  mgcIconDrawer2CuteFi as MGCIcon,
  mgcIconDrawerCuteFi as MGCIcon,
  mgcIconFaceMaskCuteFi as MGCIcon,
  mgcIconFirecrackerCuteFi as MGCIcon,
  mgcIconFireworkCuteFi as MGCIcon,
  mgcIconFirstAidKitCuteFi as MGCIcon,
  mgcIconHammerCuteFi as MGCIcon,
  mgcIconHandCardCuteFi as MGCIcon,
  mgcIconHandHeartCuteFi as MGCIcon,
  mgcIconHoeCuteFi as MGCIcon,
  mgcIconInjectionCuteFi as MGCIcon,
  mgcIconKiteCuteFi as MGCIcon,
  mgcIconLipstickCuteFi as MGCIcon,
  mgcIconNurseCuteFi as MGCIcon,
  mgcIconParfumCuteFi as MGCIcon,
  mgcIconPickaxCuteFi as MGCIcon,
  mgcIconPotCuteFi as MGCIcon,
  mgcIconPrescriptionCuteFi as MGCIcon,
  mgcIconRakeCuteFi as MGCIcon,
  mgcIconRandomCuteFi as MGCIcon,
  mgcIconScrewdriverCuteFi as MGCIcon,
  mgcIconShovelCuteFi as MGCIcon,
  mgcIconShowerGelCuteFi as MGCIcon,
  mgcIconStar2CuteFi as MGCIcon,
  mgcIconStarTopperCuteFi as MGCIcon,
  mgcIconStethoscopeCuteFi as MGCIcon,
  mgcIconThoughtCuteFi as MGCIcon,
  mgcIconToiletPaperCuteFi as MGCIcon,
  mgcIconVirusCuteFi as MGCIcon,
  mgcIconWardrobe2CuteFi as MGCIcon,
  mgcIconWardrobeCuteFi as MGCIcon,
  mgcIconWateringCanCuteFi as MGCIcon,
  mgcIconYinyangCuteFi as MGCIcon,
  mgcIconBabyCuteFi as MGCIcon,
  mgcIconBeardCuteFi as MGCIcon,
  mgcIconBodyCuteFi as MGCIcon,
  mgcIconBowTieCuteFi as MGCIcon,
  mgcIconBowknotCuteFi as MGCIcon,
  mgcIconBrainCuteFi as MGCIcon,
  mgcIconBriefCuteFi as MGCIcon,
  mgcIconChefHatCuteFi as MGCIcon,
  mgcIconChristmasHatCuteFi as MGCIcon,
  mgcIconCoatCuteFi as MGCIcon,
  mgcIconDeerCuteFi as MGCIcon,
  mgcIconDentalCuteFi as MGCIcon,
  mgcIconDressCuteFi as MGCIcon,
  mgcIconEarCuteFi as MGCIcon,
  mgcIconEye2CuteFi as MGCIcon,
  mgcIconEyebrowCuteFi as MGCIcon,
  mgcIconFaceCuteFi as MGCIcon,
  mgcIconFatherChristmasCuteFi as MGCIcon,
  mgcIconFingerPressCuteFi as MGCIcon,
  mgcIconFingerRockCuteFi as MGCIcon,
  mgcIconFingerSwipeCuteFi as MGCIcon,
  mgcIconFingerTapCuteFi as MGCIcon,
  mgcIconGloveCuteFi as MGCIcon,
  mgcIconHair2CuteFi as MGCIcon,
  mgcIconHairCuteFi as MGCIcon,
  mgcIconHandCuteFi as MGCIcon,
  mgcIconHandFinger2CuteFi as MGCIcon,
  mgcIconHandFingerCuteFi as MGCIcon,
  mgcIconHandGrabCuteFi as MGCIcon,
  mgcIconHandTwoFingersCuteFi as MGCIcon,
  mgcIconHandsClappingCuteFi as MGCIcon,
  mgcIconHat2CuteFi as MGCIcon,
  mgcIconHatCuteFi as MGCIcon,
  mgcIconHeadCuteFi as MGCIcon,
  mgcIconHeartHandCuteFi as MGCIcon,
  mgcIconHeartbeat2CuteFi as MGCIcon,
  mgcIconIncognitoModeCuteFi as MGCIcon,
  mgcIconLoveCuteFi as MGCIcon,
  mgcIconLungsCuteFi as MGCIcon,
  mgcIconMiddleFingerCuteFi as MGCIcon,
  mgcIconMouthCuteFi as MGCIcon,
  mgcIconNecktieCuteFi as MGCIcon,
  mgcIconNoseCuteFi as MGCIcon,
  mgcIconPrayCuteFi as MGCIcon,
  mgcIconScarfCuteFi as MGCIcon,
  mgcIconShirtCuteFi as MGCIcon,
  mgcIconShoe2CuteFi as MGCIcon,
  mgcIconShoeCuteFi as MGCIcon,
  mgcIconShortsCuteFi as MGCIcon,
  mgcIconSkirtCuteFi as MGCIcon,
  mgcIconSkullCuteFi as MGCIcon,
  mgcIconSockCuteFi as MGCIcon,
  mgcIconTShirt2CuteFi as MGCIcon,
  mgcIconTrouserCuteFi as MGCIcon,
  mgcIconVestCuteFi as MGCIcon,
  mgcIconClubsCuteFi as MGCIcon,
  mgcIconCylinder2CuteFi as MGCIcon,
  mgcIconCylinderCuteFi as MGCIcon,
  mgcIconDiamondCuteFi as MGCIcon,
  mgcIconDiamondSquareCuteFi as MGCIcon,
  mgcIconHeartCrackCuteFi as MGCIcon,
  mgcIconHeartCuteFi as MGCIcon,
  mgcIconHeartHalfCuteFi as MGCIcon,
  mgcIconHemisphere2CuteFi as MGCIcon,
  mgcIconHemisphereCuteFi as MGCIcon,
  mgcIconHexagonCuteFi as MGCIcon,
  mgcIconLineCuteFi as MGCIcon,
  mgcIconOctagonCuteFi as MGCIcon,
  mgcIconPentagonCuteFi as MGCIcon,
  mgcIconRectangleCuteFi as MGCIcon,
  mgcIconRectangleVerticalCuteFi as MGCIcon,
  mgcIconRoundCuteFi as MGCIcon,
  mgcIconSectorCuteFi as MGCIcon,
  mgcIconShieldShapeCuteFi as MGCIcon,
  mgcIconSpadeCuteFi as MGCIcon,
  mgcIconSquareCuteFi as MGCIcon,
  mgcIconStarCuteFi as MGCIcon,
  mgcIconStarHalfCuteFi as MGCIcon,
  mgcIconTriangleCuteFi as MGCIcon,
  mgcIconAirBalloonCuteFi as MGCIcon,
  mgcIconAmericanFootballCuteFi as MGCIcon,
  mgcIconBackboardCuteFi as MGCIcon,
  mgcIconBadmintonCuteFi as MGCIcon,
  mgcIconBarbellCuteFi as MGCIcon,
  mgcIconBaseball2CuteFi as MGCIcon,
  mgcIconBaseballCuteFi as MGCIcon,
  mgcIconBasketballCuteFi as MGCIcon,
  mgcIconBeachballCuteFi as MGCIcon,
  mgcIconDisabled2CuteFi as MGCIcon,
  mgcIconDisabledCuteFi as MGCIcon,
  mgcIconFitnessCuteFi as MGCIcon,
  mgcIconFootballCuteFi as MGCIcon,
  mgcIconParachuteCuteFi as MGCIcon,
  mgcIconPingpongCuteFi as MGCIcon,
  mgcIconPlaygroundCuteFi as MGCIcon,
  mgcIconRidingCuteFi as MGCIcon,
  mgcIconRunCuteFi as MGCIcon,
  mgcIconSkateboardCuteFi as MGCIcon,
  mgcIconSurfboardCuteFi as MGCIcon,
  mgcIconSwimmingPoolCuteFi as MGCIcon,
  mgcIconSwordCuteFi as MGCIcon,
  mgcIconToxophilyCuteFi as MGCIcon,
  mgcIconVolleyballCuteFi as MGCIcon,
  mgcIconWalkCuteFi as MGCIcon,
  mgcIconWheelchairCuteFi as MGCIcon,
  mgcIconWhistleCuteFi as MGCIcon,
  mgcIconAddCircleCuteFi as MGCIcon,
  mgcIconAddCuteFi as MGCIcon,
  mgcIconAddSquareCuteFi as MGCIcon,
  mgcIconAlertCuteFi as MGCIcon,
  mgcIconAlertDiamondCuteFi as MGCIcon,
  mgcIconAlertOctagonCuteFi as MGCIcon,
  mgcIconBroomCuteFi as MGCIcon,
  mgcIconBrush3CuteFi as MGCIcon,
  mgcIconBrushCuteFi as MGCIcon,
  mgcIconBubbleCuteFi as MGCIcon,
  mgcIconCertificateCuteFi as MGCIcon,
  mgcIconCheck2CuteFi as MGCIcon,
  mgcIconCheckCircleCuteFi as MGCIcon,
  mgcIconCheckCuteFi as MGCIcon,
  mgcIconCheckboxCuteFi as MGCIcon,
  mgcIconChecksCuteFi as MGCIcon,
  mgcIconChoiceCuteFi as MGCIcon,
  mgcIconClassify2CuteFi as MGCIcon,
  mgcIconClassify3CuteFi as MGCIcon,
  mgcIconClassifyAdd2CuteFi as MGCIcon,
  mgcIconClassifyAddCuteFi as MGCIcon,
  mgcIconClassifyCuteFi as MGCIcon,
  mgcIconCloseCircleCuteFi as MGCIcon,
  mgcIconCloseCuteFi as MGCIcon,
  mgcIconCloseSquareCuteFi as MGCIcon,
  mgcIconCrossCuteFi as MGCIcon,
  mgcIconCrutchCuteFi as MGCIcon,
  mgcIconCubeCuteFi as MGCIcon,
  mgcIconDelete2CuteFi as MGCIcon,
  mgcIconDelete3CuteFi as MGCIcon,
  mgcIconDeleteBackCuteFi as MGCIcon,
  mgcIconDeleteCuteFi as MGCIcon,
  mgcIconDirectionDotCuteFi as MGCIcon,
  mgcIconDoorCuteFi as MGCIcon,
  mgcIconDotGridCuteFi as MGCIcon,
  mgcIconDotsCuteFi as MGCIcon,
  mgcIconDotsVerticalCuteFi as MGCIcon,
  mgcIconEnterDoorCuteFi as MGCIcon,
  mgcIconEntranceCuteFi as MGCIcon,
  mgcIconExitCuteFi as MGCIcon,
  mgcIconExitDoorCuteFi as MGCIcon,
  mgcIconEyeCloseCuteFi as MGCIcon,
  mgcIconEyeCuteFi as MGCIcon,
  mgcIconFaceidCuteFi as MGCIcon,
  mgcIconFaultCuteFi as MGCIcon,
  mgcIconFilter2CuteFi as MGCIcon,
  mgcIconFingerprint2CuteFi as MGCIcon,
  mgcIconFingerprintCuteFi as MGCIcon,
  mgcIconFireCuteFi as MGCIcon,
  mgcIconFlameCuteFi as MGCIcon,
  mgcIconForbidCircleCuteFi as MGCIcon,
  mgcIconGestureUnlockCuteFi as MGCIcon,
  mgcIconGhostCuteFi as MGCIcon,
  mgcIconGrid2CuteFi as MGCIcon,
  mgcIconGridCuteFi as MGCIcon,
  mgcIconHeartbeatCuteFi as MGCIcon,
  mgcIconHexagons2CuteFi as MGCIcon,
  mgcIconHexagonsCuteFi as MGCIcon,
  mgcIconHistory2CuteFi as MGCIcon,
  mgcIconHistoryAnticlockwiseCuteFi as MGCIcon,
  mgcIconHistoryCuteFi as MGCIcon,
  mgcIconInformationCuteFi as MGCIcon,
  mgcIconKey1CuteFi as MGCIcon,
  mgcIconKey2CuteFi as MGCIcon,
  mgcIconKeyholeCuteFi as MGCIcon,
  mgcIconLoading2CuteFi as MGCIcon,
  mgcIconLoading3CuteFi as MGCIcon,
  mgcIconLoading4CuteFi as MGCIcon,
  mgcIconLoadingCuteFi as MGCIcon,
  mgcIconLockCuteFi as MGCIcon,
  mgcIconMindMapCuteFi as MGCIcon,
  mgcIconMinimizeCuteFi as MGCIcon,
  mgcIconMinusCircleCuteFi as MGCIcon,
  mgcIconMinusSquareCuteFi as MGCIcon,
  mgcIconMore1CuteFi as MGCIcon,
  mgcIconMore2CuteFi as MGCIcon,
  mgcIconMore3CuteFi as MGCIcon,
  mgcIconMore4CuteFi as MGCIcon,
  mgcIconMultiselectCuteFi as MGCIcon,
  mgcIconNewdotCuteFi as MGCIcon,
  mgcIconOpenDoorCuteFi as MGCIcon,
  mgcIconPlusCuteFi as MGCIcon,
  mgcIconPolygonCuteFi as MGCIcon,
  mgcIconPowerCuteFi as MGCIcon,
  mgcIconProcessCuteFi as MGCIcon,
  mgcIconQuestionCuteFi as MGCIcon,
  mgcIconRadioboxCuteFi as MGCIcon,
  mgcIconRecycleCuteFi as MGCIcon,
  mgcIconRefresh1CuteFi as MGCIcon,
  mgcIconRefresh2CuteFi as MGCIcon,
  mgcIconRefresh3CuteFi as MGCIcon,
  mgcIconRefresh4AiCuteFi as MGCIcon,
  mgcIconRefresh4CuteFi as MGCIcon,
  mgcIconRefreshAnticlockwise1CuteFi as MGCIcon,
  mgcIconReportCuteFi as MGCIcon,
  mgcIconRestoreCuteFi as MGCIcon,
  mgcIconSafeAlertCuteFi as MGCIcon,
  mgcIconSafeFlashCuteFi as MGCIcon,
  mgcIconSafeLockCuteFi as MGCIcon,
  mgcIconSafeShield2CuteFi as MGCIcon,
  mgcIconSafeShieldCuteFi as MGCIcon,
  mgcIconSafetyCertificateCuteFi as MGCIcon,
  mgcIconSettings1CuteFi as MGCIcon,
  mgcIconSettings2CuteFi as MGCIcon,
  mgcIconSettings3CuteFi as MGCIcon,
  mgcIconSettings4CuteFi as MGCIcon,
  mgcIconSettings5CuteFi as MGCIcon,
  mgcIconSettings6CuteFi as MGCIcon,
  mgcIconSettings7CuteFi as MGCIcon,
  mgcIconShare2CuteFi as MGCIcon,
  mgcIconShare3CuteFi as MGCIcon,
  mgcIconShareForwardCuteFi as MGCIcon,
  mgcIconShieldCuteFi as MGCIcon,
  mgcIconSleepCuteFi as MGCIcon,
  mgcIconSwitchCuteFi as MGCIcon,
  mgcIconTShirtCuteFi as MGCIcon,
  mgcIconThreeCirclesCuteFi as MGCIcon,
  mgcIconThumbDown2CuteFi as MGCIcon,
  mgcIconThumbDownCuteFi as MGCIcon,
  mgcIconThumbUp2CuteFi as MGCIcon,
  mgcIconThumbUpCuteFi as MGCIcon,
  mgcIconTimeCuteFi as MGCIcon,
  mgcIconTimeDurationCuteFi as MGCIcon,
  mgcIconTimelineCuteFi as MGCIcon,
  mgcIconToggleLeft2CuteFi as MGCIcon,
  mgcIconToggleLeftCuteFi as MGCIcon,
  mgcIconToggleRight2CuteFi as MGCIcon,
  mgcIconToggleRightCuteFi as MGCIcon,
  mgcIconToolCuteFi as MGCIcon,
  mgcIconTransformationCuteFi as MGCIcon,
  mgcIconUnlockCuteFi as MGCIcon,
  mgcIconVersionCuteFi as MGCIcon,
  mgcIconWarningCuteFi as MGCIcon,
  mgcIconWastebasketCuteFi as MGCIcon,
  mgcIconWebhookCuteFi as MGCIcon,
  mgcIconAbsCuteFi as MGCIcon,
  mgcIconAerialLiftCuteFi as MGCIcon,
  mgcIconAirplaneCuteFi as MGCIcon,
  mgcIconAutoHoldCuteFi as MGCIcon,
  mgcIconBabyCarriageCuteFi as MGCIcon,
  mgcIconBikeCuteFi as MGCIcon,
  mgcIconBrakeCuteFi as MGCIcon,
  mgcIconBus2CuteFi as MGCIcon,
  mgcIconBusCuteFi as MGCIcon,
  mgcIconCar2CuteFi as MGCIcon,
  mgcIconCar3CuteFi as MGCIcon,
  mgcIconCarCuteFi as MGCIcon,
  mgcIconCarDoorCuteFi as MGCIcon,
  mgcIconCarWindowCuteFi as MGCIcon,
  mgcIconChargingPileCuteFi as MGCIcon,
  mgcIconEbikeCuteFi as MGCIcon,
  mgcIconEmergencyFlashersCuteFi as MGCIcon,
  mgcIconEngineCuteFi as MGCIcon,
  mgcIconFan2CuteFi as MGCIcon,
  mgcIconFanCuteFi as MGCIcon,
  mgcIconFanDirectionDownCuteFi as MGCIcon,
  mgcIconFanDirectionFrontCuteFi as MGCIcon,
  mgcIconFanDirectionUpCuteFi as MGCIcon,
  mgcIconFlightInflightCuteFi as MGCIcon,
  mgcIconFlightLandCuteFi as MGCIcon,
  mgcIconFlightTakeoffCuteFi as MGCIcon,
  mgcIconFourWheelDriveCuteFi as MGCIcon,
  mgcIconFrontFogLightsCuteFi as MGCIcon,
  mgcIconFrontWindshieldDefrosterCuteFi as MGCIcon,
  mgcIconGasStationCuteFi as MGCIcon,
  mgcIconHightBeamHeadlightsCuteFi as MGCIcon,
  mgcIconHoodCuteFi as MGCIcon,
  mgcIconJeepCuteFi as MGCIcon,
  mgcIconLowBeamHeadlightsCuteFi as MGCIcon,
  mgcIconOilCuteFi as MGCIcon,
  mgcIconParkCuteFi as MGCIcon,
  mgcIconParkingLightsCuteFi as MGCIcon,
  mgcIconPinwheel2CuteFi as MGCIcon,
  mgcIconPinwheelCuteFi as MGCIcon,
  mgcIconRareFogLightsCuteFi as MGCIcon,
  mgcIconRearWindshieldDefrosterCuteFi as MGCIcon,
  mgcIconRocket2CuteFi as MGCIcon,
  mgcIconRocketCuteFi as MGCIcon,
  mgcIconRudderCuteFi as MGCIcon,
  mgcIconSailboatCuteFi as MGCIcon,
  mgcIconScooterCuteFi as MGCIcon,
  mgcIconSeatCuteFi as MGCIcon,
  mgcIconSeatHeatedCuteFi as MGCIcon,
  mgcIconShipCuteFi as MGCIcon,
  mgcIconSleighCuteFi as MGCIcon,
  mgcIconSteeringWheelCuteFi as MGCIcon,
  mgcIconTankCuteFi as MGCIcon,
  mgcIconTrafficLightsCuteFi as MGCIcon,
  mgcIconTrain2CuteFi as MGCIcon,
  mgcIconTrain3CuteFi as MGCIcon,
  mgcIconTrain4CuteFi as MGCIcon,
  mgcIconTrainCuteFi as MGCIcon,
  mgcIconTruckCuteFi as MGCIcon,
  mgcIconTrunkCuteFi as MGCIcon,
  mgcIconTyreCuteFi as MGCIcon,
  mgcIconUfo2CuteFi as MGCIcon,
  mgcIconUfoCuteFi as MGCIcon,
  mgcIconWheelCuteFi as MGCIcon,
  mgcIconWiperCuteFi as MGCIcon,
  mgcIconBadgeCuteFi as MGCIcon,
  mgcIconContacts2CuteFi as MGCIcon,
  mgcIconContacts3CuteFi as MGCIcon,
  mgcIconContacts4CuteFi as MGCIcon,
  mgcIconContactsCuteFi as MGCIcon,
  mgcIconFemaleCuteFi as MGCIcon,
  mgcIconGroup2CuteFi as MGCIcon,
  mgcIconGroup3CuteFi as MGCIcon,
  mgcIconGroupCuteFi as MGCIcon,
  mgcIconIDcardCuteFi as MGCIcon,
  mgcIconMaleCuteFi as MGCIcon,
  mgcIconUser1CuteFi as MGCIcon,
  mgcIconUser2CuteFi as MGCIcon,
  mgcIconUser3CuteFi as MGCIcon,
  mgcIconUser4CuteFi as MGCIcon,
  mgcIconUser5CuteFi as MGCIcon,
  mgcIconUserAdd2CuteFi as MGCIcon,
  mgcIconUserAddCuteFi as MGCIcon,
  mgcIconUserEditCuteFi as MGCIcon,
  mgcIconUserFollow2CuteFi as MGCIcon,
  mgcIconUserFollowCuteFi as MGCIcon,
  mgcIconUserForbidCuteFi as MGCIcon,
  mgcIconUserHeartCuteFi as MGCIcon,
  mgcIconUserHideCuteFi as MGCIcon,
  mgcIconUserInfoCuteFi as MGCIcon,
  mgcIconUserLockCuteFi as MGCIcon,
  mgcIconUserPinCuteFi as MGCIcon,
  mgcIconUserQuestionCuteFi as MGCIcon,
  mgcIconUserRemove2CuteFi as MGCIcon,
  mgcIconUserRemoveCuteFi as MGCIcon,
  mgcIconUserSearchCuteFi as MGCIcon,
  mgcIconUserSecurityCuteFi as MGCIcon,
  mgcIconUserSettingCuteFi as MGCIcon,
  mgcIconUserStarCuteFi as MGCIcon,
  mgcIconUserVisibleCuteFi as MGCIcon,
  mgcIconUserWarningCuteFi as MGCIcon,
  mgcIconUserXCuteFi as MGCIcon,
  mgcIconCelsiusCuteFi as MGCIcon,
  mgcIconCloud2CuteFi as MGCIcon,
  mgcIconCloudCuteFi as MGCIcon,
  mgcIconCloudLightningCuteFi as MGCIcon,
  mgcIconCloudSnowCuteFi as MGCIcon,
  mgcIconCloudWindyCuteFi as MGCIcon,
  mgcIconCloudsCuteFi as MGCIcon,
  mgcIconDrizzleCuteFi as MGCIcon,
  mgcIconDryCuteFi as MGCIcon,
  mgcIconFahrenheitCuteFi as MGCIcon,
  mgcIconFloatingDustCuteFi as MGCIcon,
  mgcIconFogCuteFi as MGCIcon,
  mgcIconFullMoonCuteFi as MGCIcon,
  mgcIconHailCuteFi as MGCIcon,
  mgcIconHazeCuteFi as MGCIcon,
  mgcIconHeavyRainCuteFi as MGCIcon,
  mgcIconHeavyRainstormCuteFi as MGCIcon,
  mgcIconHeavySnowCuteFi as MGCIcon,
  mgcIconHeavySnowstormCuteFi as MGCIcon,
  mgcIconHighTemperatureCuteFi as MGCIcon,
  mgcIconLightSnowCuteFi as MGCIcon,
  mgcIconLightningCuteFi as MGCIcon,
  mgcIconLowTemperatureCuteFi as MGCIcon,
  mgcIconModerateSnowCuteFi as MGCIcon,
  mgcIconMoonCloudyCuteFi as MGCIcon,
  mgcIconMoonCuteFi as MGCIcon,
  mgcIconMoonFogCuteFi as MGCIcon,
  mgcIconMoonStarsCuteFi as MGCIcon,
  mgcIconMoonlightCuteFi as MGCIcon,
  mgcIconNaCuteFi as MGCIcon,
  mgcIconPartlyCloudDaytimeCuteFi as MGCIcon,
  mgcIconPartlyCloudNightCuteFi as MGCIcon,
  mgcIconRainCuteFi as MGCIcon,
  mgcIconRainbowCuteFi as MGCIcon,
  mgcIconRainstormCuteFi as MGCIcon,
  mgcIconSandstormCuteFi as MGCIcon,
  mgcIconShowersCuteFi as MGCIcon,
  mgcIconSnowCuteFi as MGCIcon,
  mgcIconSnowflakeCuteFi as MGCIcon,
  mgcIconSnowmanCuteFi as MGCIcon,
  mgcIconSnowstorm2CuteFi as MGCIcon,
  mgcIconSnowstormCuteFi as MGCIcon,
  mgcIconSparkles2CuteFi as MGCIcon,
  mgcIconSparkles3CuteFi as MGCIcon,
  mgcIconSparklesCuteFi as MGCIcon,
  mgcIconSun2CuteFi as MGCIcon,
  mgcIconSunCloudyCuteFi as MGCIcon,
  mgcIconSunCuteFi as MGCIcon,
  mgcIconSunFogCuteFi as MGCIcon,
  mgcIconSunriseCuteFi as MGCIcon,
  mgcIconSunsetCuteFi as MGCIcon,
  mgcIconThermometerCuteFi as MGCIcon,
  mgcIconThunderstormCuteFi as MGCIcon,
  mgcIconTornado2CuteFi as MGCIcon,
  mgcIconTornadoCuteFi as MGCIcon,
  mgcIconTyphoonCuteFi as MGCIcon,
  mgcIconUmbrellaCuteFi as MGCIcon,
  mgcIconWaveCuteFi as MGCIcon,
  mgcIconWetCuteFi as MGCIcon,
  mgcIconWindCuteFi as MGCIcon,
  mgcIconAquariusCuteFi as MGCIcon,
  mgcIconAriesCuteFi as MGCIcon,
  mgcIconCancerCuteFi as MGCIcon,
  mgcIconCapricornCuteFi as MGCIcon,
  mgcIconGeminiCuteFi as MGCIcon,
  mgcIconLeoCuteFi as MGCIcon,
  mgcIconLibraCuteFi as MGCIcon,
  mgcIconPiscesCuteFi as MGCIcon,
  mgcIconSagittariusCuteFi as MGCIcon,
  mgcIconScorpioCuteFi as MGCIcon,
  mgcIconTaurusCuteFi as MGCIcon,
  mgcIconVirgoCuteFi as MGCIcon,
  mgcIconAlignArrowDownCuteRe as MGCIcon,
  mgcIconAlignArrowLeftCuteRe as MGCIcon,
  mgcIconAlignArrowRightCuteRe as MGCIcon,
  mgcIconAlignArrowUpCuteRe as MGCIcon,
  mgcIconArrowDownCircleCuteRe as MGCIcon,
  mgcIconArrowDownCuteRe as MGCIcon,
  mgcIconArrowLeftCircleCuteRe as MGCIcon,
  mgcIconArrowLeftCuteRe as MGCIcon,
  mgcIconArrowLeftDownCircleCuteRe as MGCIcon,
  mgcIconArrowLeftDownCuteRe as MGCIcon,
  mgcIconArrowLeftUpCircleCuteRe as MGCIcon,
  mgcIconArrowLeftUpCuteRe as MGCIcon,
  mgcIconArrowRightCircleCuteRe as MGCIcon,
  mgcIconArrowRightCuteRe as MGCIcon,
  mgcIconArrowRightDownCircleCuteRe as MGCIcon,
  mgcIconArrowRightDownCuteRe as MGCIcon,
  mgcIconArrowRightUpCircleCuteRe as MGCIcon,
  mgcIconArrowRightUpCuteRe as MGCIcon,
  mgcIconArrowToDownCuteRe as MGCIcon,
  mgcIconArrowToLeftCuteRe as MGCIcon,
  mgcIconArrowToRightCuteRe as MGCIcon,
  mgcIconArrowToUpCuteRe as MGCIcon,
  mgcIconArrowUpCircleCuteRe as MGCIcon,
  mgcIconArrowUpCuteRe as MGCIcon,
  mgcIconArrowsDownCuteRe as MGCIcon,
  mgcIconArrowsLeftCuteRe as MGCIcon,
  mgcIconArrowsRightCuteRe as MGCIcon,
  mgcIconArrowsUpCuteRe as MGCIcon,
  mgcIconBack2CuteRe as MGCIcon,
  mgcIconBackCuteRe as MGCIcon,
  mgcIconCornerDownLeftCuteRe as MGCIcon,
  mgcIconCornerDownRightCuteRe as MGCIcon,
  mgcIconCornerUpLeftCuteRe as MGCIcon,
  mgcIconCornerUpRightCuteRe as MGCIcon,
  mgcIconDirectionArrowCuteRe as MGCIcon,
  mgcIconDownCuteRe as MGCIcon,
  mgcIconDownSmallCuteRe as MGCIcon,
  mgcIconForward2CuteRe as MGCIcon,
  mgcIconForwardCuteRe as MGCIcon,
  mgcIconFullscreen2CuteRe as MGCIcon,
  mgcIconFullscreenExit2CuteRe as MGCIcon,
  mgcIconLargeArrowDownCuteRe as MGCIcon,
  mgcIconLargeArrowLeftCuteRe as MGCIcon,
  mgcIconLargeArrowRightCuteRe as MGCIcon,
  mgcIconLargeArrowUpCuteRe as MGCIcon,
  mgcIconLeftCuteRe as MGCIcon,
  mgcIconLeftSmallCuteRe as MGCIcon,
  mgcIconMoveCuteRe as MGCIcon,
  mgcIconRightCuteRe as MGCIcon,
  mgcIconRightSmallCuteRe as MGCIcon,
  mgcIconSelectorHorizontalCuteRe as MGCIcon,
  mgcIconSelectorVerticalCuteRe as MGCIcon,
  mgcIconSquareArrowDownCuteRe as MGCIcon,
  mgcIconSquareArrowLeftCuteRe as MGCIcon,
  mgcIconSquareArrowRightCuteRe as MGCIcon,
  mgcIconSquareArrowUpCuteRe as MGCIcon,
  mgcIconTransfer2CuteRe as MGCIcon,
  mgcIconTransfer3CuteRe as MGCIcon,
  mgcIconTransfer4CuteRe as MGCIcon,
  mgcIconTransferCuteRe as MGCIcon,
  mgcIconTransferHorizontalCuteRe as MGCIcon,
  mgcIconTransferVerticalCuteRe as MGCIcon,
  mgcIconTrendingDownCuteRe as MGCIcon,
  mgcIconTrendingUpCuteRe as MGCIcon,
  mgcIconUpCuteRe as MGCIcon,
  mgcIconUpSmallCuteRe as MGCIcon,
  mgcIconBankCuteRe as MGCIcon,
  mgcIconBankOfChinaTowerCuteRe as MGCIcon,
  mgcIconBigBenCuteRe as MGCIcon,
  mgcIconBridge2CuteRe as MGCIcon,
  mgcIconBridgeCuteRe as MGCIcon,
  mgcIconBuilding1CuteRe as MGCIcon,
  mgcIconBuilding2CuteRe as MGCIcon,
  mgcIconBuilding3CuteRe as MGCIcon,
  mgcIconBuilding4CuteRe as MGCIcon,
  mgcIconBuilding5CuteRe as MGCIcon,
  mgcIconBuilding6CuteRe as MGCIcon,
  mgcIconBurjAlArabCuteRe as MGCIcon,
  mgcIconBurjKhalifaTowerCuteRe as MGCIcon,
  mgcIconCampgroundCuteRe as MGCIcon,
  mgcIconCantonTowerCuteRe as MGCIcon,
  mgcIconChristTheRedeemerCuteRe as MGCIcon,
  mgcIconChurchCuteRe as MGCIcon,
  mgcIconDutchWindmillCuteRe as MGCIcon,
  mgcIconEgyptianPyramidsCuteRe as MGCIcon,
  mgcIconEiffelTowerCuteRe as MGCIcon,
  mgcIconFactory2CuteRe as MGCIcon,
  mgcIconFactoryCuteRe as MGCIcon,
  mgcIconFerrisWheelCuteRe as MGCIcon,
  mgcIconGovernmentCuteRe as MGCIcon,
  mgcIconGreatwallCuteRe as MGCIcon,
  mgcIconHome1CuteRe as MGCIcon,
  mgcIconHome2CuteRe as MGCIcon,
  mgcIconHome3CuteRe as MGCIcon,
  mgcIconHome4CuteRe as MGCIcon,
  mgcIconHome5CuteRe as MGCIcon,
  mgcIconHome6CuteRe as MGCIcon,
  mgcIconHome7CuteRe as MGCIcon,
  mgcIconHospitalCuteRe as MGCIcon,
  mgcIconHotelCuteRe as MGCIcon,
  mgcIconHouse2CuteRe as MGCIcon,
  mgcIconHouseCuteRe as MGCIcon,
  mgcIconKingkey100TowerCuteRe as MGCIcon,
  mgcIconLighthouseCuteRe as MGCIcon,
  mgcIconMarinaBaySandCuteRe as MGCIcon,
  mgcIconMayaPyramidsCuteRe as MGCIcon,
  mgcIconMiyajimaToriiCuteRe as MGCIcon,
  mgcIconMoaiCuteRe as MGCIcon,
  mgcIconMonumentCuteRe as MGCIcon,
  mgcIconPalaceCuteRe as MGCIcon,
  mgcIconPavilionCuteRe as MGCIcon,
  mgcIconPisaTowerCuteRe as MGCIcon,
  mgcIconSchoolCuteRe as MGCIcon,
  mgcIconShopCuteRe as MGCIcon,
  mgcIconStatueOfLibertyCuteRe as MGCIcon,
  mgcIconStore2CuteRe as MGCIcon,
  mgcIconStoreCuteRe as MGCIcon,
  mgcIconSydneyOperaHouseCuteRe as MGCIcon,
  mgcIconTaipei101CuteRe as MGCIcon,
  mgcIconTajMahalCuteRe as MGCIcon,
  mgcIconTempleOfHeavenCuteRe as MGCIcon,
  mgcIconTentCuteRe as MGCIcon,
  mgcIconTowerCuteRe as MGCIcon,
  mgcIconTriumphalArchCuteRe as MGCIcon,
  mgcIconTvTowerCuteRe as MGCIcon,
  mgcIconAdCircleCuteRe as MGCIcon,
  mgcIconAdCircleOffCuteRe as MGCIcon,
  mgcIconAdRectangleCuteRe as MGCIcon,
  mgcIconAdRectangleOffCuteRe as MGCIcon,
  mgcIconAnniversaryCuteRe as MGCIcon,
  mgcIconAuctionCuteRe as MGCIcon,
  mgcIconAwardCuteRe as MGCIcon,
  mgcIconBankCardCuteRe as MGCIcon,
  mgcIconBasket2CuteRe as MGCIcon,
  mgcIconBasketCuteRe as MGCIcon,
  mgcIconBriefcase2CuteRe as MGCIcon,
  mgcIconBriefcaseCuteRe as MGCIcon,
  mgcIconCalendar2CuteRe as MGCIcon,
  mgcIconCalendar3CuteRe as MGCIcon,
  mgcIconCalendarAddCuteRe as MGCIcon,
  mgcIconCalendarCuteRe as MGCIcon,
  mgcIconCalendarDayCuteRe as MGCIcon,
  mgcIconCalendarMonthCuteRe as MGCIcon,
  mgcIconCalendarTimeAddCuteRe as MGCIcon,
  mgcIconCalendarWeekCuteRe as MGCIcon,
  mgcIconCandleCuteRe as MGCIcon,
  mgcIconCandlesCuteRe as MGCIcon,
  mgcIconCardPayCuteRe as MGCIcon,
  mgcIconCardRefundCuteRe as MGCIcon,
  mgcIconCash2CuteRe as MGCIcon,
  mgcIconCashCuteRe as MGCIcon,
  mgcIconCelebrateCuteRe as MGCIcon,
  mgcIconChartBar2CuteRe as MGCIcon,
  mgcIconChartBarCuteRe as MGCIcon,
  mgcIconChartDecreaseCuteRe as MGCIcon,
  mgcIconChartHorizontalCuteRe as MGCIcon,
  mgcIconChartLineCuteRe as MGCIcon,
  mgcIconChartPie2CuteRe as MGCIcon,
  mgcIconChartPieCuteRe as MGCIcon,
  mgcIconChartVerticalCuteRe as MGCIcon,
  mgcIconChineseKnotCuteRe as MGCIcon,
  mgcIconChristmasBallCuteRe as MGCIcon,
  mgcIconCoin2CuteRe as MGCIcon,
  mgcIconCoin3CuteRe as MGCIcon,
  mgcIconCoinCuteRe as MGCIcon,
  mgcIconCopperCoinCuteRe as MGCIcon,
  mgcIconCopyrightCuteRe as MGCIcon,
  mgcIconCouponCuteRe as MGCIcon,
  mgcIconCurrencyBaht2CuteRe as MGCIcon,
  mgcIconCurrencyBahtCuteRe as MGCIcon,
  mgcIconCurrencyCny2CuteRe as MGCIcon,
  mgcIconCurrencyCnyCuteRe as MGCIcon,
  mgcIconCurrencyDollar2CuteRe as MGCIcon,
  mgcIconCurrencyDollarCuteRe as MGCIcon,
  mgcIconCurrencyEuro2CuteRe as MGCIcon,
  mgcIconCurrencyEuroCuteRe as MGCIcon,
  mgcIconCurrencyLira2CuteRe as MGCIcon,
  mgcIconCurrencyLiraCuteRe as MGCIcon,
  mgcIconCurrencyNigeria2CuteRe as MGCIcon,
  mgcIconCurrencyNigeriaCuteRe as MGCIcon,
  mgcIconCurrencyRubel2CuteRe as MGCIcon,
  mgcIconCurrencyRubelCuteRe as MGCIcon,
  mgcIconCurrencyRupee2CuteRe as MGCIcon,
  mgcIconCurrencyRupeeCuteRe as MGCIcon,
  mgcIconCurrencyShekel2CuteRe as MGCIcon,
  mgcIconCurrencyShekelCuteRe as MGCIcon,
  mgcIconCurrencyWon2CuteRe as MGCIcon,
  mgcIconCurrencyWonCuteRe as MGCIcon,
  mgcIconDiamond2CuteRe as MGCIcon,
  mgcIconExchangeBahtCuteRe as MGCIcon,
  mgcIconExchangeCnyCuteRe as MGCIcon,
  mgcIconExchangeDollarCuteRe as MGCIcon,
  mgcIconExchangeEuroCuteRe as MGCIcon,
  mgcIconFilter3CuteRe as MGCIcon,
  mgcIconFilterCuteRe as MGCIcon,
  mgcIconFlag1CuteRe as MGCIcon,
  mgcIconFlag2CuteRe as MGCIcon,
  mgcIconFlag3CuteRe as MGCIcon,
  mgcIconFlag4CuteRe as MGCIcon,
  mgcIconGift2CuteRe as MGCIcon,
  mgcIconGiftCardCuteRe as MGCIcon,
  mgcIconGiftCuteRe as MGCIcon,
  mgcIconLadderCuteRe as MGCIcon,
  mgcIconLantern2CuteRe as MGCIcon,
  mgcIconLanternCuteRe as MGCIcon,
  mgcIconLaurelWreathCuteRe as MGCIcon,
  mgcIconLuggageCuteRe as MGCIcon,
  mgcIconMedalCuteRe as MGCIcon,
  mgcIconPalette3CuteRe as MGCIcon,
  mgcIconPigMoneyCuteRe as MGCIcon,
  mgcIconPound2CuteRe as MGCIcon,
  mgcIconPoundCuteRe as MGCIcon,
  mgcIconPresentation1CuteRe as MGCIcon,
  mgcIconPresentation2CuteRe as MGCIcon,
  mgcIconPresentation3CuteRe as MGCIcon,
  mgcIconPumpkinLanternCuteRe as MGCIcon,
  mgcIconReceiveMoneyCuteRe as MGCIcon,
  mgcIconRedPacketCuteRe as MGCIcon,
  mgcIconRedPacketOpenCuteRe as MGCIcon,
  mgcIconRefundCnyCuteRe as MGCIcon,
  mgcIconRefundDollarCuteRe as MGCIcon,
  mgcIconRegisteredCuteRe as MGCIcon,
  mgcIconSafeBoxCuteRe as MGCIcon,
  mgcIconSaleCuteRe as MGCIcon,
  mgcIconScheduleCuteRe as MGCIcon,
  mgcIconSealCuteRe as MGCIcon,
  mgcIconShoppingBag1CuteRe as MGCIcon,
  mgcIconShoppingBag2CuteRe as MGCIcon,
  mgcIconShoppingBag3CuteRe as MGCIcon,
  mgcIconShoppingCart1CuteRe as MGCIcon,
  mgcIconShoppingCart2CuteRe as MGCIcon,
  mgcIconSofaCuteRe as MGCIcon,
  mgcIconStockCuteRe as MGCIcon,
  mgcIconSuitcase2CuteRe as MGCIcon,
  mgcIconSuitcaseCuteRe as MGCIcon,
  mgcIconTag2CuteRe as MGCIcon,
  mgcIconTagChevronCuteRe as MGCIcon,
  mgcIconTagCuteRe as MGCIcon,
  mgcIconTargetCuteRe as MGCIcon,
  mgcIconTicketCuteRe as MGCIcon,
  mgcIconTrophyCuteRe as MGCIcon,
  mgcIconVip1CuteRe as MGCIcon,
  mgcIconVip2CuteRe as MGCIcon,
  mgcIconVip3CuteRe as MGCIcon,
  mgcIconVip4CuteRe as MGCIcon,
  mgcIconWallet2CuteRe as MGCIcon,
  mgcIconWallet3CuteRe as MGCIcon,
  mgcIconWallet4CuteRe as MGCIcon,
  mgcIconWallet5CuteRe as MGCIcon,
  mgcIconWalletCuteRe as MGCIcon,
  mgcIconYuanbaoCuteRe as MGCIcon,
  mgcIconChat1CuteRe as MGCIcon,
  mgcIconChat2CuteRe as MGCIcon,
  mgcIconChat3CuteRe as MGCIcon,
  mgcIconChat4CuteRe as MGCIcon,
  mgcIconComment2CuteRe as MGCIcon,
  mgcIconCommentCuteRe as MGCIcon,
  mgcIconInviteCuteRe as MGCIcon,
  mgcIconMailAiCuteRe as MGCIcon,
  mgcIconMailCuteRe as MGCIcon,
  mgcIconMailOpenCuteRe as MGCIcon,
  mgcIconMailSendCuteRe as MGCIcon,
  mgcIconMailboxCuteRe as MGCIcon,
  mgcIconMessage1CuteRe as MGCIcon,
  mgcIconMessage2CuteRe as MGCIcon,
  mgcIconMessage3CuteRe as MGCIcon,
  mgcIconMessage4CuteRe as MGCIcon,
  mgcIconPhoneAddCuteRe as MGCIcon,
  mgcIconPhoneBlockCuteRe as MGCIcon,
  mgcIconPhoneCallCuteRe as MGCIcon,
  mgcIconPhoneCuteRe as MGCIcon,
  mgcIconPhoneIncomingCuteRe as MGCIcon,
  mgcIconPhoneOffCuteRe as MGCIcon,
  mgcIconPhoneOutgoingCuteRe as MGCIcon,
  mgcIconPhoneSuccessCuteRe as MGCIcon,
  mgcIconSendCuteRe as MGCIcon,
  mgcIconSendPlaneCuteRe as MGCIcon,
  mgcIconAvalancheAvaxCuteRe as MGCIcon,
  mgcIconBinanceCoinBnbCuteRe as MGCIcon,
  mgcIconBinanceUsdBusdCuteRe as MGCIcon,
  mgcIconBnbCuteRe as MGCIcon,
  mgcIconCardanoAdaCuteRe as MGCIcon,
  mgcIconCurrencyBitcoin2CuteRe as MGCIcon,
  mgcIconCurrencyBitcoinCuteRe as MGCIcon,
  mgcIconDogecoinDogeCuteRe as MGCIcon,
  mgcIconEthereumCuteRe as MGCIcon,
  mgcIconExchangeBitcoinCuteRe as MGCIcon,
  mgcIconMoneroCuteRe as MGCIcon,
  mgcIconPolkadotDotCuteRe as MGCIcon,
  mgcIconSolanaSolCuteRe as MGCIcon,
  mgcIconTetherUsdtCuteRe as MGCIcon,
  mgcIconUsdCoinUsdcCuteRe as MGCIcon,
  mgcIconXrpCuteRe as MGCIcon,
  mgcIconAlignBottomCuteRe as MGCIcon,
  mgcIconAlignHorizontalCenterCuteRe as MGCIcon,
  mgcIconAlignLeft2CuteRe as MGCIcon,
  mgcIconAlignRight2CuteRe as MGCIcon,
  mgcIconAlignTopCuteRe as MGCIcon,
  mgcIconAlignVerticalCenterCuteRe as MGCIcon,
  mgcIconAnticlockwiseAltCuteRe as MGCIcon,
  mgcIconAnticlockwiseCuteRe as MGCIcon,
  mgcIconArtboardCuteRe as MGCIcon,
  mgcIconBackgroundBaseCuteRe as MGCIcon,
  mgcIconBackgroundCuteRe as MGCIcon,
  mgcIconBlingCuteRe as MGCIcon,
  mgcIconBoardCuteRe as MGCIcon,
  mgcIconBorderBlankCuteRe as MGCIcon,
  mgcIconBorderBottomCuteRe as MGCIcon,
  mgcIconBorderHorizontalCuteRe as MGCIcon,
  mgcIconBorderInnerCuteRe as MGCIcon,
  mgcIconBorderLeftCuteRe as MGCIcon,
  mgcIconBorderOuterCuteRe as MGCIcon,
  mgcIconBorderRadiusCuteRe as MGCIcon,
  mgcIconBorderRightCuteRe as MGCIcon,
  mgcIconBorderTopCuteRe as MGCIcon,
  mgcIconBorderVerticalCuteRe as MGCIcon,
  mgcIconBrightnessCuteRe as MGCIcon,
  mgcIconBrush2CuteRe as MGCIcon,
  mgcIconClockwiseAltCuteRe as MGCIcon,
  mgcIconClockwiseCuteRe as MGCIcon,
  mgcIconColorFilterCuteRe as MGCIcon,
  mgcIconColorPickerCuteRe as MGCIcon,
  mgcIconColumns2CuteRe as MGCIcon,
  mgcIconColumns3CuteRe as MGCIcon,
  mgcIconCombineCuteRe as MGCIcon,
  mgcIconComponentsCuteRe as MGCIcon,
  mgcIconDistributeSpacingHorizontalCuteRe as MGCIcon,
  mgcIconDistributeSpacingVerticalCuteRe as MGCIcon,
  mgcIconDrawingBoardCuteRe as MGCIcon,
  mgcIconDropCuteRe as MGCIcon,
  mgcIconEaseInControlPointCuteRe as MGCIcon,
  mgcIconEaseInCuteRe as MGCIcon,
  mgcIconEaseInOutControlPointCuteRe as MGCIcon,
  mgcIconEaseOutControlPointCuteRe as MGCIcon,
  mgcIconEaseOutCuteRe as MGCIcon,
  mgcIconEasyInOutCuteRe as MGCIcon,
  mgcIconExcludeCuteRe as MGCIcon,
  mgcIconExposureCuteRe as MGCIcon,
  mgcIconFlipHorizontalCuteRe as MGCIcon,
  mgcIconFlipVerticalCuteRe as MGCIcon,
  mgcIconFoldHorizontalCuteRe as MGCIcon,
  mgcIconFoldVerticalCuteRe as MGCIcon,
  mgcIconIntersectCuteRe as MGCIcon,
  mgcIconKnifeCuteRe as MGCIcon,
  mgcIconLayerCuteRe as MGCIcon,
  mgcIconLayout10CuteRe as MGCIcon,
  mgcIconLayout11CuteRe as MGCIcon,
  mgcIconLayout2CuteRe as MGCIcon,
  mgcIconLayout3CuteRe as MGCIcon,
  mgcIconLayout4CuteRe as MGCIcon,
  mgcIconLayout5CuteRe as MGCIcon,
  mgcIconLayout6CuteRe as MGCIcon,
  mgcIconLayout7CuteRe as MGCIcon,
  mgcIconLayout8CuteRe as MGCIcon,
  mgcIconLayout9CuteRe as MGCIcon,
  mgcIconLayoutBottomCloseCuteRe as MGCIcon,
  mgcIconLayoutBottomCuteRe as MGCIcon,
  mgcIconLayoutBottomOpenCuteRe as MGCIcon,
  mgcIconLayoutCuteRe as MGCIcon,
  mgcIconLayoutGridCuteRe as MGCIcon,
  mgcIconLayoutLeftCuteRe as MGCIcon,
  mgcIconLayoutLeftbarCloseCuteRe as MGCIcon,
  mgcIconLayoutLeftbarOpenCuteRe as MGCIcon,
  mgcIconLayoutRightCuteRe as MGCIcon,
  mgcIconLayoutRightbarCloseCuteRe as MGCIcon,
  mgcIconLayoutRightbarOpenCuteRe as MGCIcon,
  mgcIconLayoutTopCloseCuteRe as MGCIcon,
  mgcIconLayoutTopCuteRe as MGCIcon,
  mgcIconLayoutTopOpenCuteRe as MGCIcon,
  mgcIconMagic1CuteRe as MGCIcon,
  mgcIconMagic2CuteRe as MGCIcon,
  mgcIconMagic3CuteRe as MGCIcon,
  mgcIconMagicHat2CuteRe as MGCIcon,
  mgcIconMagicHatCuteRe as MGCIcon,
  mgcIconMarkPenCuteRe as MGCIcon,
  mgcIconMarkupCuteRe as MGCIcon,
  mgcIconMirrorCuteRe as MGCIcon,
  mgcIconMosaicCuteRe as MGCIcon,
  mgcIconPaint2CuteRe as MGCIcon,
  mgcIconPaintBrushAiCuteRe as MGCIcon,
  mgcIconPaintBrushCuteRe as MGCIcon,
  mgcIconPalette2CuteRe as MGCIcon,
  mgcIconPaletteCuteRe as MGCIcon,
  mgcIconPasterCuteRe as MGCIcon,
  mgcIconPenCuteRe as MGCIcon,
  mgcIconQuillPenAiCuteRe as MGCIcon,
  mgcIconQuillPenCuteRe as MGCIcon,
  mgcIconRotateXCuteRe as MGCIcon,
  mgcIconRotateYCuteRe as MGCIcon,
  mgcIconRows2CuteRe as MGCIcon,
  mgcIconRows3CuteRe as MGCIcon,
  mgcIconRows4CuteRe as MGCIcon,
  mgcIconRulerCuteRe as MGCIcon,
  mgcIconScaleCuteRe as MGCIcon,
  mgcIconScissors2CuteRe as MGCIcon,
  mgcIconScissors3CuteRe as MGCIcon,
  mgcIconScissorsCuteRe as MGCIcon,
  mgcIconScreenshotCuteRe as MGCIcon,
  mgcIconSectionCuteRe as MGCIcon,
  mgcIconShadowCuteRe as MGCIcon,
  mgcIconStickerCuteRe as MGCIcon,
  mgcIconSubtractCuteRe as MGCIcon,
  mgcIconTable2CuteRe as MGCIcon,
  mgcIconUnfoldHorizontalCuteRe as MGCIcon,
  mgcIconUnfoldVerticalCuteRe as MGCIcon,
  mgcIconUnionCuteRe as MGCIcon,
  mgcIconVectorBezier2CuteRe as MGCIcon,
  mgcIconVectorBezier3CuteRe as MGCIcon,
  mgcIconVectorBezierCuteRe as MGCIcon,
  mgcIconVectorGroupCuteRe as MGCIcon,
  mgcIconXSkewCuteRe as MGCIcon,
  mgcIconYSkewCuteRe as MGCIcon,
  mgcIconBracesCuteRe as MGCIcon,
  mgcIconBracketsAngleCuteRe as MGCIcon,
  mgcIconBracketsCuteRe as MGCIcon,
  mgcIconBugCuteRe as MGCIcon,
  mgcIconCodeCuteRe as MGCIcon,
  mgcIconCommandCuteRe as MGCIcon,
  mgcIconCursor2CuteRe as MGCIcon,
  mgcIconCursor3CuteRe as MGCIcon,
  mgcIconCursorCuteRe as MGCIcon,
  mgcIconDepartmentCuteRe as MGCIcon,
  mgcIconDirectoryCuteRe as MGCIcon,
  mgcIconGitBranchCuteRe as MGCIcon,
  mgcIconGitCommitCuteRe as MGCIcon,
  mgcIconGitCompareCuteRe as MGCIcon,
  mgcIconGitMergeCuteRe as MGCIcon,
  mgcIconGitPullRequestCloseCuteRe as MGCIcon,
  mgcIconGitPullRequestCuteRe as MGCIcon,
  mgcIconHotkeyCuteRe as MGCIcon,
  mgcIconInspectCuteRe as MGCIcon,
  mgcIconParenthesesCuteRe as MGCIcon,
  mgcIconPerformanceCuteRe as MGCIcon,
  mgcIconSitemapCuteRe as MGCIcon,
  mgcIconTerminalBoxCuteRe as MGCIcon,
  mgcIconTerminalCuteRe as MGCIcon,
  mgcIconWebCuteRe as MGCIcon,
  mgcIconAiCuteRe as MGCIcon,
  mgcIconAirConditionCuteRe as MGCIcon,
  mgcIconAirConditionOpenCuteRe as MGCIcon,
  mgcIconAirplayCuteRe as MGCIcon,
  mgcIconAirpods2CuteRe as MGCIcon,
  mgcIconAlarm1CuteRe as MGCIcon,
  mgcIconAlarm2CuteRe as MGCIcon,
  mgcIconAspectRatioCuteRe as MGCIcon,
  mgcIconBarcodeCuteRe as MGCIcon,
  mgcIconBarcodeScaCuteRe as MGCIcon,
  mgcIconBaseStation2CuteRe as MGCIcon,
  mgcIconBaseStationCuteRe as MGCIcon,
  mgcIconBattery1CuteRe as MGCIcon,
  mgcIconBattery2CuteRe as MGCIcon,
  mgcIconBattery3CuteRe as MGCIcon,
  mgcIconBattery4CuteRe as MGCIcon,
  mgcIconBatteryAutomotiveCuteRe as MGCIcon,
  mgcIconBatteryChargingCuteRe as MGCIcon,
  mgcIconBatteryCuteRe as MGCIcon,
  mgcIconBluetoothCuteRe as MGCIcon,
  mgcIconBluetoothOffCuteRe as MGCIcon,
  mgcIconBulb2CuteRe as MGCIcon,
  mgcIconBulbCuteRe as MGCIcon,
  mgcIconCamcorder2CuteRe as MGCIcon,
  mgcIconCardboardVrCuteRe as MGCIcon,
  mgcIconCeilingLampCuteRe as MGCIcon,
  mgcIconCellphone2AiCuteRe as MGCIcon,
  mgcIconCellphone2CuteRe as MGCIcon,
  mgcIconCellphone2HorizontalCuteRe as MGCIcon,
  mgcIconCellphoneCuteRe as MGCIcon,
  mgcIconCellphoneVibrationCuteRe as MGCIcon,
  mgcIconChipCuteRe as MGCIcon,
  mgcIconComputerCamerCuteRe as MGCIcon,
  mgcIconComputerCameraOffCuteRe as MGCIcon,
  mgcIconComputerCuteRe as MGCIcon,
  mgcIconCounter2CuteRe as MGCIcon,
  mgcIconCube3DCuteRe as MGCIcon,
  mgcIconDashboard2CuteRe as MGCIcon,
  mgcIconDashboard3CuteRe as MGCIcon,
  mgcIconDashboard4CuteRe as MGCIcon,
  mgcIconDashboardCuteRe as MGCIcon,
  mgcIconDeskLamp2CuteRe as MGCIcon,
  mgcIconDeskLampCuteRe as MGCIcon,
  mgcIconDeviceCuteRe as MGCIcon,
  mgcIconDisplayCuteRe as MGCIcon,
  mgcIconDroneCuteRe as MGCIcon,
  mgcIconEscalatorDownCuteRe as MGCIcon,
  mgcIconEscalatorUpCuteRe as MGCIcon,
  mgcIconFaxCuteRe as MGCIcon,
  mgcIconFlashCircleCuteRe as MGCIcon,
  mgcIconFlashCuteRe as MGCIcon,
  mgcIconFlashlightCuteRe as MGCIcon,
  mgcIconFridgeCuteRe as MGCIcon,
  mgcIconGame1CuteRe as MGCIcon,
  mgcIconGame2CuteRe as MGCIcon,
  mgcIconGradienterCuteRe as MGCIcon,
  mgcIconGuitarCuteRe as MGCIcon,
  mgcIconHighVoltagePowerCuteRe as MGCIcon,
  mgcIconHomeWifiCuteRe as MGCIcon,
  mgcIconHomepodCuteRe as MGCIcon,
  mgcIconHomepodMiniCuteRe as MGCIcon,
  mgcIconIMacCuteRe as MGCIcon,
  mgcIconInstrumentCuteRe as MGCIcon,
  mgcIconKeyboard2CuteRe as MGCIcon,
  mgcIconKeyboardCuteRe as MGCIcon,
  mgcIconLaptop2CuteRe as MGCIcon,
  mgcIconLaptopCuteRe as MGCIcon,
  mgcIconLightCuteRe as MGCIcon,
  mgcIconMicroscopeCuteRe as MGCIcon,
  mgcIconMidiCuteRe as MGCIcon,
  mgcIconMonitorCuteRe as MGCIcon,
  mgcIconMouseCuteRe as MGCIcon,
  mgcIconPadCuteRe as MGCIcon,
  mgcIconPanoramasCuteRe as MGCIcon,
  mgcIconPlugin2CuteRe as MGCIcon,
  mgcIconPluginCuteRe as MGCIcon,
  mgcIconPrintCuteRe as MGCIcon,
  mgcIconProjectorCuteRe as MGCIcon,
  mgcIconProjectorScreenCuteRe as MGCIcon,
  mgcIconQrcode2CuteRe as MGCIcon,
  mgcIconQrcodeCuteRe as MGCIcon,
  mgcIconRadaCuteRe as MGCIcon,
  mgcIconRadar2CuteRe as MGCIcon,
  mgcIconRadioCuteRe as MGCIcon,
  mgcIconRemoteControlCuteRe as MGCIcon,
  mgcIconRemoteCuteRe as MGCIcon,
  mgcIconRouterModemCuteRe as MGCIcon,
  mgcIconRss2CuteRe as MGCIcon,
  mgcIconRssCuteRe as MGCIcon,
  mgcIconSandglass2CuteRe as MGCIcon,
  mgcIconSandglassCuteRe as MGCIcon,
  mgcIconScan2CuteRe as MGCIcon,
  mgcIconScanCuteRe as MGCIcon,
  mgcIconServer2CuteRe as MGCIcon,
  mgcIconServerCuteRe as MGCIcon,
  mgcIconShowerCuteRe as MGCIcon,
  mgcIconSignalCuteRe as MGCIcon,
  mgcIconSolarPanelCuteRe as MGCIcon,
  mgcIconSpeakerCuteRe as MGCIcon,
  mgcIconStopwatchCuteRe as MGCIcon,
  mgcIconStorageCuteRe as MGCIcon,
  mgcIconTelescope2CuteRe as MGCIcon,
  mgcIconTelescopeCuteRe as MGCIcon,
  mgcIconTowerCraneCuteRe as MGCIcon,
  mgcIconTv1CuteRe as MGCIcon,
  mgcIconTv2CuteRe as MGCIcon,
  mgcIconUsbCuteRe as MGCIcon,
  mgcIconUsbFlashDiskCuteRe as MGCIcon,
  mgcIconVisonProCuteRe as MGCIcon,
  mgcIconWashMachineCuteRe as MGCIcon,
  mgcIconWatch2CuteRe as MGCIcon,
  mgcIconWatchCuteRe as MGCIcon,
  mgcIconWifiCuteRe as MGCIcon,
  mgcIconWifiOffCuteRe as MGCIcon,
  mgcIconAlignCenterCuteRe as MGCIcon,
  mgcIconAlignJustifyCuteRe as MGCIcon,
  mgcIconAlignLeftCuteRe as MGCIcon,
  mgcIconAlignRightCuteRe as MGCIcon,
  mgcIconAndCuteRe as MGCIcon,
  mgcIconAsterisk2CuteRe as MGCIcon,
  mgcIconAsteriskCuteRe as MGCIcon,
  mgcIconAtCuteRe as MGCIcon,
  mgcIconAzSortAscendingLettersCuteRe as MGCIcon,
  mgcIconAzSortDescendingLettersCuteRe as MGCIcon,
  mgcIconBlockquoteCuteRe as MGCIcon,
  mgcIconBoldCuteRe as MGCIcon,
  mgcIconColumnCuteRe as MGCIcon,
  mgcIconContentAiCuteRe as MGCIcon,
  mgcIconCursorTextCuteRe as MGCIcon,
  mgcIconDividingLineCuteRe as MGCIcon,
  mgcIconEdit2CuteRe as MGCIcon,
  mgcIconEdit3CuteRe as MGCIcon,
  mgcIconEdit4CuteRe as MGCIcon,
  mgcIconEditCuteRe as MGCIcon,
  mgcIconEraserCuteRe as MGCIcon,
  mgcIconFontCuteRe as MGCIcon,
  mgcIconFontSizeCuteRe as MGCIcon,
  mgcIconFormulaCuteRe as MGCIcon,
  mgcIconFrameCuteRe as MGCIcon,
  mgcIconHashtagCuteRe as MGCIcon,
  mgcIconHeading1CuteRe as MGCIcon,
  mgcIconHeading2CuteRe as MGCIcon,
  mgcIconHeading3CuteRe as MGCIcon,
  mgcIconIndentDecreaseCuteRe as MGCIcon,
  mgcIconIndentIncreaseCuteRe as MGCIcon,
  mgcIconItalicCuteRe as MGCIcon,
  mgcIconLetterSpacingCuteRe as MGCIcon,
  mgcIconLineHeightCuteRe as MGCIcon,
  mgcIconListCheck2CuteRe as MGCIcon,
  mgcIconListCheck3CuteRe as MGCIcon,
  mgcIconListCheckCuteRe as MGCIcon,
  mgcIconListCollapseCuteRe as MGCIcon,
  mgcIconListExpansionCuteRe as MGCIcon,
  mgcIconListOrderedCuteRe as MGCIcon,
  mgcIconListSearchCuteRe as MGCIcon,
  mgcIconMenuCuteRe as MGCIcon,
  mgcIconNumbers09SortAscendingCuteRe as MGCIcon,
  mgcIconNumbers09SortDescendingCuteRe as MGCIcon,
  mgcIconNumbers90SortAscendingCuteRe as MGCIcon,
  mgcIconNumbers90SortDescendingCuteRe as MGCIcon,
  mgcIconOmegaCuteRe as MGCIcon,
  mgcIconPaintCuteRe as MGCIcon,
  mgcIconParagraphCuteRe as MGCIcon,
  mgcIconPen2CuteRe as MGCIcon,
  mgcIconPencil2AiCuteRe as MGCIcon,
  mgcIconPencil2CuteRe as MGCIcon,
  mgcIconPencil3CuteRe as MGCIcon,
  mgcIconPencilCuteRe as MGCIcon,
  mgcIconPencilRulerCuteRe as MGCIcon,
  mgcIconQuoteLeftCuteRe as MGCIcon,
  mgcIconQuoteRightCuteRe as MGCIcon,
  mgcIconSignatureCuteRe as MGCIcon,
  mgcIconSortAscendingCuteRe as MGCIcon,
  mgcIconSortDescendingCuteRe as MGCIcon,
  mgcIconSpaceCuteRe as MGCIcon,
  mgcIconSpacingHorizontalCuteRe as MGCIcon,
  mgcIconSpacingVerticalCuteRe as MGCIcon,
  mgcIconStrikethroughCuteRe as MGCIcon,
  mgcIconSubtitleCuteRe as MGCIcon,
  mgcIconTable3CuteRe as MGCIcon,
  mgcIconTableCuteRe as MGCIcon,
  mgcIconText2CuteRe as MGCIcon,
  mgcIconTextAreaCuteRe as MGCIcon,
  mgcIconTextColorCuteRe as MGCIcon,
  mgcIconTextCuteRe as MGCIcon,
  mgcIconTextDirectionLeftCuteRe as MGCIcon,
  mgcIconTextDirectionRightCuteRe as MGCIcon,
  mgcIconTextboxAiCuteRe as MGCIcon,
  mgcIconTextboxCuteRe as MGCIcon,
  mgcIconTranslate2AiCuteRe as MGCIcon,
  mgcIconTranslate2CuteRe as MGCIcon,
  mgcIconTranslateCuteRe as MGCIcon,
  mgcIconUnderlineCuteRe as MGCIcon,
  mgcIconZaSortAscendingLettersCuteRe as MGCIcon,
  mgcIconZaSortDescendingLettersCuteRe as MGCIcon,
  mgcIconBackpackCuteRe as MGCIcon,
  mgcIconBalanceCuteRe as MGCIcon,
  mgcIconBlackBoard2CuteRe as MGCIcon,
  mgcIconBlackBoardCuteRe as MGCIcon,
  mgcIconBook2CuteRe as MGCIcon,
  mgcIconBook3CuteRe as MGCIcon,
  mgcIconBook4CuteRe as MGCIcon,
  mgcIconBook5CuteRe as MGCIcon,
  mgcIconBook6CuteRe as MGCIcon,
  mgcIconBookCuteRe as MGCIcon,
  mgcIconBookmarkAddCuteRe as MGCIcon,
  mgcIconBookmarkCuteRe as MGCIcon,
  mgcIconBookmarkEditCuteRe as MGCIcon,
  mgcIconBookmarkRemoveCuteRe as MGCIcon,
  mgcIconBookmarksCuteRe as MGCIcon,
  mgcIconCertificate2CuteRe as MGCIcon,
  mgcIconCompass2CuteRe as MGCIcon,
  mgcIconCounterCuteRe as MGCIcon,
  mgcIconDeskCuteRe as MGCIcon,
  mgcIconDiaryCuteRe as MGCIcon,
  mgcIconDrumCuteRe as MGCIcon,
  mgcIconEyeglassCuteRe as MGCIcon,
  mgcIconFlask2CuteRe as MGCIcon,
  mgcIconFlask3CuteRe as MGCIcon,
  mgcIconFlaskCuteRe as MGCIcon,
  mgcIconFoldingFanCuteRe as MGCIcon,
  mgcIconGlobeCuteRe as MGCIcon,
  mgcIconMagnetCuteRe as MGCIcon,
  mgcIconMortarboardCuteRe as MGCIcon,
  mgcIconNotebook2CuteRe as MGCIcon,
  mgcIconNotebookCuteRe as MGCIcon,
  mgcIconScienceCuteRe as MGCIcon,
  mgcIconSpeechCuteRe as MGCIcon,
  mgcIconTestTubeCuteRe as MGCIcon,
  mgcIconAngelCuteRe as MGCIcon,
  mgcIconAngryCuteRe as MGCIcon,
  mgcIconConfusedCuteRe as MGCIcon,
  mgcIconEmoji2CuteRe as MGCIcon,
  mgcIconEmojiCuteRe as MGCIcon,
  mgcIconHappyCuteRe as MGCIcon,
  mgcIconLaughCuteRe as MGCIcon,
  mgcIconLookDownCuteRe as MGCIcon,
  mgcIconLookLeftCuteRe as MGCIcon,
  mgcIconLookRightCuteRe as MGCIcon,
  mgcIconLookUpCuteRe as MGCIcon,
  mgcIconOmgCuteRe as MGCIcon,
  mgcIconPuzzledCuteRe as MGCIcon,
  mgcIconSadCuteRe as MGCIcon,
  mgcIconSickCuteRe as MGCIcon,
  mgcIconSilentCuteRe as MGCIcon,
  mgcIconSobCuteRe as MGCIcon,
  mgcIconSurpriseCuteRe as MGCIcon,
  mgcIconSweatsCuteRe as MGCIcon,
  mgcIconTerrorCuteRe as MGCIcon,
  mgcIconTongueCuteRe as MGCIcon,
  mgcIconUnhappyCuteRe as MGCIcon,
  mgcIconUnhappyDizzyCuteRe as MGCIcon,
  mgcIconAlbum2CuteRe as MGCIcon,
  mgcIconArchiveCuteRe as MGCIcon,
  mgcIconAttachment2CuteRe as MGCIcon,
  mgcIconAttachmentCuteRe as MGCIcon,
  mgcIconBill2CuteRe as MGCIcon,
  mgcIconBillCuteRe as MGCIcon,
  mgcIconBox2CuteRe as MGCIcon,
  mgcIconBox3CuteRe as MGCIcon,
  mgcIconBoxCuteRe as MGCIcon,
  mgcIconClipboardCuteRe as MGCIcon,
  mgcIconCopy2CuteRe as MGCIcon,
  mgcIconCopy3CuteRe as MGCIcon,
  mgcIconCopyCuteRe as MGCIcon,
  mgcIconDocCuteRe as MGCIcon,
  mgcIconDocmentCuteRe as MGCIcon,
  mgcIconDocument2CuteRe as MGCIcon,
  mgcIconDocument3CuteRe as MGCIcon,
  mgcIconDocumentsCuteRe as MGCIcon,
  mgcIconDownload2CuteRe as MGCIcon,
  mgcIconDownload3CuteRe as MGCIcon,
  mgcIconDownloadCuteRe as MGCIcon,
  mgcIconEmptyBoxCuteRe as MGCIcon,
  mgcIconExternalLinkCuteRe as MGCIcon,
  mgcIconFileCertificateCuteRe as MGCIcon,
  mgcIconFileCheckCuteRe as MGCIcon,
  mgcIconFileCodeCuteRe as MGCIcon,
  mgcIconFileCuteRe as MGCIcon,
  mgcIconFileDownloadCuteRe as MGCIcon,
  mgcIconFileExportCuteRe as MGCIcon,
  mgcIconFileForbidCuteRe as MGCIcon,
  mgcIconFileImportCuteRe as MGCIcon,
  mgcIconFileInfoCuteRe as MGCIcon,
  mgcIconFileLockedCuteRe as MGCIcon,
  mgcIconFileMoreCuteRe as MGCIcon,
  mgcIconFileMusicCuteRe as MGCIcon,
  mgcIconFileNewCuteRe as MGCIcon,
  mgcIconFileSearchCuteRe as MGCIcon,
  mgcIconFileSecurityCuteRe as MGCIcon,
  mgcIconFileStarCuteRe as MGCIcon,
  mgcIconFileUnknownCuteRe as MGCIcon,
  mgcIconFileUploadCuteRe as MGCIcon,
  mgcIconFileWarningCuteRe as MGCIcon,
  mgcIconFileZipCuteRe as MGCIcon,
  mgcIconFolder2CuteRe as MGCIcon,
  mgcIconFolder3CuteRe as MGCIcon,
  mgcIconFolderCheckCuteRe as MGCIcon,
  mgcIconFolderCuteRe as MGCIcon,
  mgcIconFolderDeleteCuteRe as MGCIcon,
  mgcIconFolderDownloadCuteRe as MGCIcon,
  mgcIconFolderForbidCuteRe as MGCIcon,
  mgcIconFolderInfoCuteRe as MGCIcon,
  mgcIconFolderLocked2CuteRe as MGCIcon,
  mgcIconFolderLockedCuteRe as MGCIcon,
  mgcIconFolderMinusCuteRe as MGCIcon,
  mgcIconFolderMoreCuteRe as MGCIcon,
  mgcIconFolderOpen2CuteRe as MGCIcon,
  mgcIconFolderOpenCuteRe as MGCIcon,
  mgcIconFolderSecurityCuteRe as MGCIcon,
  mgcIconFolderStarCuteRe as MGCIcon,
  mgcIconFolderUploadCuteRe as MGCIcon,
  mgcIconFolderWarningCuteRe as MGCIcon,
  mgcIconFolderZipCuteRe as MGCIcon,
  mgcIconFoldersCuteRe as MGCIcon,
  mgcIconInbox2CuteRe as MGCIcon,
  mgcIconInboxCuteRe as MGCIcon,
  mgcIconInventoryCuteRe as MGCIcon,
  mgcIconLink2CuteRe as MGCIcon,
  mgcIconLink3CuteRe as MGCIcon,
  mgcIconLinkCuteRe as MGCIcon,
  mgcIconMarkdownCuteRe as MGCIcon,
  mgcIconNewFolderCuteRe as MGCIcon,
  mgcIconNews2CuteRe as MGCIcon,
  mgcIconNewsCuteRe as MGCIcon,
  mgcIconPackage2CuteRe as MGCIcon,
  mgcIconPackageCuteRe as MGCIcon,
  mgcIconPaper2CuteRe as MGCIcon,
  mgcIconPaperCuteRe as MGCIcon,
  mgcIconPassportCuteRe as MGCIcon,
  mgcIconPasteCuteRe as MGCIcon,
  mgcIconPdfCuteRe as MGCIcon,
  mgcIconPhotoAlbum2CuteRe as MGCIcon,
  mgcIconPhotoAlbumCuteRe as MGCIcon,
  mgcIconPic2CuteRe as MGCIcon,
  mgcIconPicAiCuteRe as MGCIcon,
  mgcIconPicCuteRe as MGCIcon,
  mgcIconPin2CuteRe as MGCIcon,
  mgcIconPinCuteRe as MGCIcon,
  mgcIconPptCuteRe as MGCIcon,
  mgcIconProfileCuteRe as MGCIcon,
  mgcIconReportFormsCuteRe as MGCIcon,
  mgcIconSave2CuteRe as MGCIcon,
  mgcIconSaveCuteRe as MGCIcon,
  mgcIconSearch2CuteRe as MGCIcon,
  mgcIconSearch3CuteRe as MGCIcon,
  mgcIconSearchAiCuteRe as MGCIcon,
  mgcIconSearchCuteRe as MGCIcon,
  mgcIconTask2CuteRe as MGCIcon,
  mgcIconTaskCuteRe as MGCIcon,
  mgcIconToDoCuteRe as MGCIcon,
  mgcIconUnarchiveCuteRe as MGCIcon,
  mgcIconUnlink2CuteRe as MGCIcon,
  mgcIconUnlinkCuteRe as MGCIcon,
  mgcIconUpload2CuteRe as MGCIcon,
  mgcIconUpload3CuteRe as MGCIcon,
  mgcIconUploadCuteRe as MGCIcon,
  mgcIconXlsCuteRe as MGCIcon,
  mgcIconZoomInCuteRe as MGCIcon,
  mgcIconZoomOutCuteRe as MGCIcon,
  mgcIconBirthday2CuteRe as MGCIcon,
  mgcIconBoneCuteRe as MGCIcon,
  mgcIconBottleGlassCuteRe as MGCIcon,
  mgcIconBowl2CuteRe as MGCIcon,
  mgcIconBowlCuteRe as MGCIcon,
  mgcIconBreadCuteRe as MGCIcon,
  mgcIconCakeCuteRe as MGCIcon,
  mgcIconCandy2CuteRe as MGCIcon,
  mgcIconCandyCuteRe as MGCIcon,
  mgcIconCarrotCuteRe as MGCIcon,
  mgcIconChampagneCuteRe as MGCIcon,
  mgcIconChickenCuteRe as MGCIcon,
  mgcIconChopsticksCuteRe as MGCIcon,
  mgcIconCookieCuteRe as MGCIcon,
  mgcIconCookieManCuteRe as MGCIcon,
  mgcIconCupcakeCuteRe as MGCIcon,
  mgcIconDinnerCuteRe as MGCIcon,
  mgcIconDishCoverCuteRe as MGCIcon,
  mgcIconDonutCuteRe as MGCIcon,
  mgcIconDrinkCuteRe as MGCIcon,
  mgcIconEggCrackCuteRe as MGCIcon,
  mgcIconEggCuteRe as MGCIcon,
  mgcIconElectricCookerCuteRe as MGCIcon,
  mgcIconFeederCuteRe as MGCIcon,
  mgcIconFishCuteRe as MGCIcon,
  mgcIconForkCuteRe as MGCIcon,
  mgcIconForkKnifeCuteRe as MGCIcon,
  mgcIconForkSpoonCuteRe as MGCIcon,
  mgcIconFriedEggCuteRe as MGCIcon,
  mgcIconFriesCuteRe as MGCIcon,
  mgcIconGlassCupCuteRe as MGCIcon,
  mgcIconHamburgerCuteRe as MGCIcon,
  mgcIconIceCream2CuteRe as MGCIcon,
  mgcIconIceCreamCuteRe as MGCIcon,
  mgcIconLollipopCuteRe as MGCIcon,
  mgcIconPizzaCuteRe as MGCIcon,
  mgcIconSoupPot2CuteRe as MGCIcon,
  mgcIconSoupPotCuteRe as MGCIcon,
  mgcIconSpatulaCuteRe as MGCIcon,
  mgcIconSpoonCuteRe as MGCIcon,
  mgcIconSugarCoatedHawsCuteRe as MGCIcon,
  mgcIconTeacupCuteRe as MGCIcon,
  mgcIconWineCuteRe as MGCIcon,
  mgcIconWineglass2CuteRe as MGCIcon,
  mgcIconWineglassCuteRe as MGCIcon,
  mgcIconAirbnbCuteRe as MGCIcon,
  mgcIconAirdropCuteRe as MGCIcon,
  mgcIconAlipayCuteRe as MGCIcon,
  mgcIconAndroid2CuteRe as MGCIcon,
  mgcIconAndroidCuteRe as MGCIcon,
  mgcIconAppleCuteRe as MGCIcon,
  mgcIconAppleIntelligenceCuteRe as MGCIcon,
  mgcIconAppleIntelligenceFrameCuteRe as MGCIcon,
  mgcIconAppstoreCuteRe as MGCIcon,
  mgcIconArcBrowserCuteRe as MGCIcon,
  mgcIconBehanceCuteRe as MGCIcon,
  mgcIconBilibiliCuteRe as MGCIcon,
  mgcIconBlueskySocialCuteRe as MGCIcon,
  mgcIconCarplayCuteRe as MGCIcon,
  mgcIconChromeCuteRe as MGCIcon,
  mgcIconCodepenCuteRe as MGCIcon,
  mgcIconCopilotCuteRe as MGCIcon,
  mgcIconDingtalkCuteRe as MGCIcon,
  mgcIconDiscordCuteRe as MGCIcon,
  mgcIconDribbbleCuteRe as MGCIcon,
  mgcIconDriveCuteRe as MGCIcon,
  mgcIconDropboxCuteRe as MGCIcon,
  mgcIconEdgeCuteRe as MGCIcon,
  mgcIconFacebookCuteRe as MGCIcon,
  mgcIconFigmaCuteRe as MGCIcon,
  mgcIconFirefoxCuteRe as MGCIcon,
  mgcIconFollowCuteRe as MGCIcon,
  mgcIconGitLabCuteRe as MGCIcon,
  mgcIconGithub2CuteRe as MGCIcon,
  mgcIconGithubCuteRe as MGCIcon,
  mgcIconGoogleCuteRe as MGCIcon,
  mgcIconGooglePlayCuteRe as MGCIcon,
  mgcIconGrokCuteRe as MGCIcon,
  mgcIconGumroadCuteRe as MGCIcon,
  mgcIconInstagramCuteRe as MGCIcon,
  mgcIconKakaoTalkCuteRe as MGCIcon,
  mgcIconLayersCuteRe as MGCIcon,
  mgcIconLemonSqueezyCuteRe as MGCIcon,
  mgcIconLineAppCuteRe as MGCIcon,
  mgcIconLinearCuteRe as MGCIcon,
  mgcIconLinkedinCuteRe as MGCIcon,
  mgcIconLinuxCuteRe as MGCIcon,
  mgcIconMastercardCuteRe as MGCIcon,
  mgcIconMastodonCuteRe as MGCIcon,
  mgcIconMediumCuteRe as MGCIcon,
  mgcIconMessengerCuteRe as MGCIcon,
  mgcIconMetaCuteRe as MGCIcon,
  mgcIconMingcuteCuteRe as MGCIcon,
  mgcIconMomentCuteRe as MGCIcon,
  mgcIconNeteaseMusicCuteRe as MGCIcon,
  mgcIconNfcCuteRe as MGCIcon,
  mgcIconNintendoSwitchCuteRe as MGCIcon,
  mgcIconNotionCuteRe as MGCIcon,
  mgcIconOpenaiCuteRe as MGCIcon,
  mgcIconPaypalCuteRe as MGCIcon,
  mgcIconPinterestCuteRe as MGCIcon,
  mgcIconQqCuteRe as MGCIcon,
  mgcIconReactCuteRe as MGCIcon,
  mgcIconRedditCuteRe as MGCIcon,
  mgcIconSafariCuteRe as MGCIcon,
  mgcIconSiriCuteRe as MGCIcon,
  mgcIconSiriFrameCuteRe as MGCIcon,
  mgcIconSnapchatCuteRe as MGCIcon,
  mgcIconSocialXCuteRe as MGCIcon,
  mgcIconSpotifyCuteRe as MGCIcon,
  mgcIconStripeCuteRe as MGCIcon,
  mgcIconTelegramCuteRe as MGCIcon,
  mgcIconThreadsCuteRe as MGCIcon,
  mgcIconTiktokCuteRe as MGCIcon,
  mgcIconTrelloBoardCuteRe as MGCIcon,
  mgcIconTwitterCuteRe as MGCIcon,
  mgcIconViberMessengerCuteRe as MGCIcon,
  mgcIconVisaCuteRe as MGCIcon,
  mgcIconVkontakteCuteRe as MGCIcon,
  mgcIconVscodeCuteRe as MGCIcon,
  mgcIconVueCuteRe as MGCIcon,
  mgcIconWechatCuteRe as MGCIcon,
  mgcIconWechatMiniprogramCuteRe as MGCIcon,
  mgcIconWechatPayCuteRe as MGCIcon,
  mgcIconWeiboCuteRe as MGCIcon,
  mgcIconWhatsappCuteRe as MGCIcon,
  mgcIconWindowsCuteRe as MGCIcon,
  mgcIconXboxCuteRe as MGCIcon,
  mgcIconYoutubeCuteRe as MGCIcon,
  mgcIconAiming2CuteRe as MGCIcon,
  mgcIconAimingCuteRe as MGCIcon,
  mgcIconAnchorCuteRe as MGCIcon,
  mgcIconBed2CuteRe as MGCIcon,
  mgcIconBedCuteRe as MGCIcon,
  mgcIconClock2CuteRe as MGCIcon,
  mgcIconClockCuteRe as MGCIcon,
  mgcIconCompass3CuteRe as MGCIcon,
  mgcIconCompassCuteRe as MGCIcon,
  mgcIconDirections2CuteRe as MGCIcon,
  mgcIconDirectionsCuteRe as MGCIcon,
  mgcIconEarth2CuteRe as MGCIcon,
  mgcIconEarth3CuteRe as MGCIcon,
  mgcIconEarthCuteRe as MGCIcon,
  mgcIconEarthLatitudeCuteRe as MGCIcon,
  mgcIconEarthLongitudeCuteRe as MGCIcon,
  mgcIconFootCuteRe as MGCIcon,
  mgcIconGlobe2CuteRe as MGCIcon,
  mgcIconHoursCuteRe as MGCIcon,
  mgcIconLifebuoyCuteRe as MGCIcon,
  mgcIconLiveLocationCuteRe as MGCIcon,
  mgcIconLocation2CuteRe as MGCIcon,
  mgcIconLocation3CuteRe as MGCIcon,
  mgcIconLocationCuteRe as MGCIcon,
  mgcIconMap2CuteRe as MGCIcon,
  mgcIconMapCuteRe as MGCIcon,
  mgcIconMapPinCuteRe as MGCIcon,
  mgcIconNavigationCuteRe as MGCIcon,
  mgcIconParkingCuteRe as MGCIcon,
  mgcIconPlanetCuteRe as MGCIcon,
  mgcIconRestAreaCuteRe as MGCIcon,
  mgcIconRoadCuteRe as MGCIcon,
  mgcIconRouteCuteRe as MGCIcon,
  mgcIconTrafficConeCuteRe as MGCIcon,
  mgcIconTunnelCuteRe as MGCIcon,
  mgcIconUmbrella2CuteRe as MGCIcon,
  mgcIconWorld2CuteRe as MGCIcon,
  mgcIconWorldCuteRe as MGCIcon,
  mgcIconAirpodsCuteRe as MGCIcon,
  mgcIconAlbumCuteRe as MGCIcon,
  mgcIconAnnouncementCuteRe as MGCIcon,
  mgcIconAudioTapeCuteRe as MGCIcon,
  mgcIconBellRingingCuteRe as MGCIcon,
  mgcIconCamcorder3CuteRe as MGCIcon,
  mgcIconCamcorderCuteRe as MGCIcon,
  mgcIconCamcorderOffCuteRe as MGCIcon,
  mgcIconCamera2AiCuteRe as MGCIcon,
  mgcIconCamera2CuteRe as MGCIcon,
  mgcIconCamera2OffCuteRe as MGCIcon,
  mgcIconCameraCuteRe as MGCIcon,
  mgcIconCameraRotateCuteRe as MGCIcon,
  mgcIconClapperboardCuteRe as MGCIcon,
  mgcIconDanmakuCuteRe as MGCIcon,
  mgcIconDanmakuOffCuteRe as MGCIcon,
  mgcIconDanmakuOnCuteRe as MGCIcon,
  mgcIconDiscCuteRe as MGCIcon,
  mgcIconExpandPlayerCuteRe as MGCIcon,
  mgcIconFastForwardCuteRe as MGCIcon,
  mgcIconFastRewindCuteRe as MGCIcon,
  mgcIconFilmCuteRe as MGCIcon,
  mgcIconFullscreenCuteRe as MGCIcon,
  mgcIconFullscreenExitCuteRe as MGCIcon,
  mgcIconHeadphone2CuteRe as MGCIcon,
  mgcIconHeadphoneCuteRe as MGCIcon,
  mgcIconHorn2CuteRe as MGCIcon,
  mgcIconHornCuteRe as MGCIcon,
  mgcIconLiveCuteRe as MGCIcon,
  mgcIconLivePhotoCuteRe as MGCIcon,
  mgcIconMic2CuteRe as MGCIcon,
  mgcIconMicAiCuteRe as MGCIcon,
  mgcIconMicCuteRe as MGCIcon,
  mgcIconMicOffCuteRe as MGCIcon,
  mgcIconMicrophoneCuteRe as MGCIcon,
  mgcIconMiniplayerCuteRe as MGCIcon,
  mgcIconMovieCuteRe as MGCIcon,
  mgcIconMusic2AiCuteRe as MGCIcon,
  mgcIconMusic2CuteRe as MGCIcon,
  mgcIconMusic3CuteRe as MGCIcon,
  mgcIconMusicCuteRe as MGCIcon,
  mgcIconNotificationCuteRe as MGCIcon,
  mgcIconNotificationNewdotCuteRe as MGCIcon,
  mgcIconNotificationOffCuteRe as MGCIcon,
  mgcIconPauseCircleCuteRe as MGCIcon,
  mgcIconPauseCuteRe as MGCIcon,
  mgcIconPlayCircleCuteRe as MGCIcon,
  mgcIconPlayCuteRe as MGCIcon,
  mgcIconPlaylist2CuteRe as MGCIcon,
  mgcIconPlaylistCuteRe as MGCIcon,
  mgcIconRecordMailCuteRe as MGCIcon,
  mgcIconRepeatCuteRe as MGCIcon,
  mgcIconRepeatOneCuteRe as MGCIcon,
  mgcIconRewindBackward10CuteRe as MGCIcon,
  mgcIconRewindBackward15CuteRe as MGCIcon,
  mgcIconRewindBackward30CuteRe as MGCIcon,
  mgcIconRewindBackward5CuteRe as MGCIcon,
  mgcIconRewindBackwardSquare10CuteRe as MGCIcon,
  mgcIconRewindBackwardSquare15CuteRe as MGCIcon,
  mgcIconRewindBackwardSquare30CuteRe as MGCIcon,
  mgcIconRewindBackwardSquare5CuteRe as MGCIcon,
  mgcIconRewindForward10CuteRe as MGCIcon,
  mgcIconRewindForward15CuteRe as MGCIcon,
  mgcIconRewindForward30CuteRe as MGCIcon,
  mgcIconRewindForward5CuteRe as MGCIcon,
  mgcIconRewindForwardSquare10CuteRe as MGCIcon,
  mgcIconRewindForwardSquare15CuteRe as MGCIcon,
  mgcIconRewindForwardSquare30CuteRe as MGCIcon,
  mgcIconRewindForwardSquare5CuteRe as MGCIcon,
  mgcIconRotateToHorizontalCuteRe as MGCIcon,
  mgcIconRotateToVerticalCuteRe as MGCIcon,
  mgcIconServiceCuteRe as MGCIcon,
  mgcIconShuffle2CuteRe as MGCIcon,
  mgcIconShuffleCuteRe as MGCIcon,
  mgcIconSkipForwardCuteRe as MGCIcon,
  mgcIconSkipPreviousCuteRe as MGCIcon,
  mgcIconSoundLineCuteRe as MGCIcon,
  mgcIconStopCircleCuteRe as MGCIcon,
  mgcIconStopCuteRe as MGCIcon,
  mgcIconVideoCamera2CuteRe as MGCIcon,
  mgcIconVideoCameraCuteRe as MGCIcon,
  mgcIconVideoCuteRe as MGCIcon,
  mgcIconVoice2CuteRe as MGCIcon,
  mgcIconVoiceCuteRe as MGCIcon,
  mgcIconVolumeCuteRe as MGCIcon,
  mgcIconVolumeMuteCuteRe as MGCIcon,
  mgcIconVolumeOffCuteRe as MGCIcon,
  mgcIconBearCuteRe as MGCIcon,
  mgcIconBirdCuteRe as MGCIcon,
  mgcIconButterfly2CuteRe as MGCIcon,
  mgcIconButterflyCuteRe as MGCIcon,
  mgcIconCactus2CuteRe as MGCIcon,
  mgcIconCactusCuteRe as MGCIcon,
  mgcIconCampfireCuteRe as MGCIcon,
  mgcIconCatCuteRe as MGCIcon,
  mgcIconChessCuteRe as MGCIcon,
  mgcIconDandelionCuteRe as MGCIcon,
  mgcIconDogCuteRe as MGCIcon,
  mgcIconDragonflyCuteRe as MGCIcon,
  mgcIconFlower2CuteRe as MGCIcon,
  mgcIconFlower3CuteRe as MGCIcon,
  mgcIconFlower4CuteRe as MGCIcon,
  mgcIconFlower5CuteRe as MGCIcon,
  mgcIconFlowerCuteRe as MGCIcon,
  mgcIconFlowerpotCuteRe as MGCIcon,
  mgcIconGrassCuteRe as MGCIcon,
  mgcIconLeaf2CuteRe as MGCIcon,
  mgcIconLeaf3CuteRe as MGCIcon,
  mgcIconLeafCuteRe as MGCIcon,
  mgcIconLotusCuteRe as MGCIcon,
  mgcIconMapleLeafCuteRe as MGCIcon,
  mgcIconMickeymouseCuteRe as MGCIcon,
  mgcIconMountain2CuteRe as MGCIcon,
  mgcIconMountainCuteRe as MGCIcon,
  mgcIconMushroomCuteRe as MGCIcon,
  mgcIconPawCuteRe as MGCIcon,
  mgcIconPigCuteRe as MGCIcon,
  mgcIconPumpkinCuteRe as MGCIcon,
  mgcIconRabbitCuteRe as MGCIcon,
  mgcIconSunflowerCuteRe as MGCIcon,
  mgcIconToyHorseCuteRe as MGCIcon,
  mgcIconTree2CuteRe as MGCIcon,
  mgcIconTree3CuteRe as MGCIcon,
  mgcIconTree4CuteRe as MGCIcon,
  mgcIconTreeCuteRe as MGCIcon,
  mgcIconWreathCuteRe as MGCIcon,
  mgcIconAxeCuteRe as MGCIcon,
  mgcIconBalloon2CuteRe as MGCIcon,
  mgcIconBathCuteRe as MGCIcon,
  mgcIconBedsideTable2CuteRe as MGCIcon,
  mgcIconBedsideTableCuteRe as MGCIcon,
  mgcIconBlessingCuteRe as MGCIcon,
  mgcIconBombCuteRe as MGCIcon,
  mgcIconBoomCuteRe as MGCIcon,
  mgcIconBottleCuteRe as MGCIcon,
  mgcIconCapsuleCuteRe as MGCIcon,
  mgcIconCoathangerCuteRe as MGCIcon,
  mgcIconCross2CuteRe as MGCIcon,
  mgcIconCrystalBallCuteRe as MGCIcon,
  mgcIconCurtainCuteRe as MGCIcon,
  mgcIconDrawer2CuteRe as MGCIcon,
  mgcIconDrawerCuteRe as MGCIcon,
  mgcIconFaceMaskCuteRe as MGCIcon,
  mgcIconFirecrackerCuteRe as MGCIcon,
  mgcIconFireworkCuteRe as MGCIcon,
  mgcIconFirstAidKitCuteRe as MGCIcon,
  mgcIconHammerCuteRe as MGCIcon,
  mgcIconHandCardCuteRe as MGCIcon,
  mgcIconHandHeartCuteRe as MGCIcon,
  mgcIconHoeCuteRe as MGCIcon,
  mgcIconInjectionCuteRe as MGCIcon,
  mgcIconKiteCuteRe as MGCIcon,
  mgcIconLipstickCuteRe as MGCIcon,
  mgcIconNurseCuteRe as MGCIcon,
  mgcIconParfumCuteRe as MGCIcon,
  mgcIconPickaxCuteRe as MGCIcon,
  mgcIconPotCuteRe as MGCIcon,
  mgcIconPrescriptionCuteRe as MGCIcon,
  mgcIconRakeCuteRe as MGCIcon,
  mgcIconRandomCuteRe as MGCIcon,
  mgcIconScrewdriverCuteRe as MGCIcon,
  mgcIconShovelCuteRe as MGCIcon,
  mgcIconShowerGelCuteRe as MGCIcon,
  mgcIconStar2CuteRe as MGCIcon,
  mgcIconStarTopperCuteRe as MGCIcon,
  mgcIconStethoscopeCuteRe as MGCIcon,
  mgcIconThoughtCuteRe as MGCIcon,
  mgcIconToiletPaperCuteRe as MGCIcon,
  mgcIconVirusCuteRe as MGCIcon,
  mgcIconWardrobe2CuteRe as MGCIcon,
  mgcIconWardrobeCuteRe as MGCIcon,
  mgcIconWateringCanCuteRe as MGCIcon,
  mgcIconYinyangCuteRe as MGCIcon,
  mgcIconBabyCuteRe as MGCIcon,
  mgcIconBeardCuteRe as MGCIcon,
  mgcIconBodyCuteRe as MGCIcon,
  mgcIconBowTieCuteRe as MGCIcon,
  mgcIconBowknotCuteRe as MGCIcon,
  mgcIconBrainCuteRe as MGCIcon,
  mgcIconBriefCuteRe as MGCIcon,
  mgcIconChefHatCuteRe as MGCIcon,
  mgcIconChristmasHatCuteRe as MGCIcon,
  mgcIconCoatCuteRe as MGCIcon,
  mgcIconDeerCuteRe as MGCIcon,
  mgcIconDentalCuteRe as MGCIcon,
  mgcIconDressCuteRe as MGCIcon,
  mgcIconEarCuteRe as MGCIcon,
  mgcIconEye2CuteRe as MGCIcon,
  mgcIconEyebrowCuteRe as MGCIcon,
  mgcIconFaceCuteRe as MGCIcon,
  mgcIconFatherChristmasCuteRe as MGCIcon,
  mgcIconFingerPressCuteRe as MGCIcon,
  mgcIconFingerRockCuteRe as MGCIcon,
  mgcIconFingerSwipeCuteRe as MGCIcon,
  mgcIconFingerTapCuteRe as MGCIcon,
  mgcIconGloveCuteRe as MGCIcon,
  mgcIconHair2CuteRe as MGCIcon,
  mgcIconHairCuteRe as MGCIcon,
  mgcIconHandCuteRe as MGCIcon,
  mgcIconHandFinger2CuteRe as MGCIcon,
  mgcIconHandFingerCuteRe as MGCIcon,
  mgcIconHandGrabCuteRe as MGCIcon,
  mgcIconHandTwoFingersCuteRe as MGCIcon,
  mgcIconHandsClappingCuteRe as MGCIcon,
  mgcIconHat2CuteRe as MGCIcon,
  mgcIconHatCuteRe as MGCIcon,
  mgcIconHeadCuteRe as MGCIcon,
  mgcIconHeartHandCuteRe as MGCIcon,
  mgcIconHeartbeat2CuteRe as MGCIcon,
  mgcIconIncognitoModeCuteRe as MGCIcon,
  mgcIconLoveCuteRe as MGCIcon,
  mgcIconLungsCuteRe as MGCIcon,
  mgcIconMiddleFingerCuteRe as MGCIcon,
  mgcIconMouthCuteRe as MGCIcon,
  mgcIconNecktieCuteRe as MGCIcon,
  mgcIconNoseCuteRe as MGCIcon,
  mgcIconPrayCuteRe as MGCIcon,
  mgcIconScarfCuteRe as MGCIcon,
  mgcIconShirtCuteRe as MGCIcon,
  mgcIconShoe2CuteRe as MGCIcon,
  mgcIconShoeCuteRe as MGCIcon,
  mgcIconShortsCuteRe as MGCIcon,
  mgcIconSkirtCuteRe as MGCIcon,
  mgcIconSkullCuteRe as MGCIcon,
  mgcIconSockCuteRe as MGCIcon,
  mgcIconTShirt2CuteRe as MGCIcon,
  mgcIconTrouserCuteRe as MGCIcon,
  mgcIconVestCuteRe as MGCIcon,
  mgcIconClubsCuteRe as MGCIcon,
  mgcIconCylinder2CuteRe as MGCIcon,
  mgcIconCylinderCuteRe as MGCIcon,
  mgcIconDiamondCuteRe as MGCIcon,
  mgcIconDiamondSquareCuteRe as MGCIcon,
  mgcIconHeartCrackCuteRe as MGCIcon,
  mgcIconHeartCuteRe as MGCIcon,
  mgcIconHeartHalfCuteRe as MGCIcon,
  mgcIconHemisphere2CuteRe as MGCIcon,
  mgcIconHemisphereCuteRe as MGCIcon,
  mgcIconHexagonCuteRe as MGCIcon,
  mgcIconLineCuteRe as MGCIcon,
  mgcIconOctagonCuteRe as MGCIcon,
  mgcIconPentagonCuteRe as MGCIcon,
  mgcIconRectangleCuteRe as MGCIcon,
  mgcIconRectangleVerticalCuteRe as MGCIcon,
  mgcIconRoundCuteRe as MGCIcon,
  mgcIconSectorCuteRe as MGCIcon,
  mgcIconShieldShapeCuteRe as MGCIcon,
  mgcIconSpadeCuteRe as MGCIcon,
  mgcIconSquareCuteRe as MGCIcon,
  mgcIconStarCuteRe as MGCIcon,
  mgcIconStarHalfCuteRe as MGCIcon,
  mgcIconTriangleCuteRe as MGCIcon,
  mgcIconAirBalloonCuteRe as MGCIcon,
  mgcIconAmericanFootballCuteRe as MGCIcon,
  mgcIconBackboardCuteRe as MGCIcon,
  mgcIconBadmintonCuteRe as MGCIcon,
  mgcIconBarbellCuteRe as MGCIcon,
  mgcIconBaseball2CuteRe as MGCIcon,
  mgcIconBaseballCuteRe as MGCIcon,
  mgcIconBasketballCuteRe as MGCIcon,
  mgcIconBeachballCuteRe as MGCIcon,
  mgcIconDisabled2CuteRe as MGCIcon,
  mgcIconDisabledCuteRe as MGCIcon,
  mgcIconFitnessCuteRe as MGCIcon,
  mgcIconFootballCuteRe as MGCIcon,
  mgcIconParachuteCuteRe as MGCIcon,
  mgcIconPingpongCuteRe as MGCIcon,
  mgcIconPlaygroundCuteRe as MGCIcon,
  mgcIconRidingCuteRe as MGCIcon,
  mgcIconRunCuteRe as MGCIcon,
  mgcIconSkateboardCuteRe as MGCIcon,
  mgcIconSurfboardCuteRe as MGCIcon,
  mgcIconSwimmingPoolCuteRe as MGCIcon,
  mgcIconSwordCuteRe as MGCIcon,
  mgcIconToxophilyCuteRe as MGCIcon,
  mgcIconVolleyballCuteRe as MGCIcon,
  mgcIconWalkCuteRe as MGCIcon,
  mgcIconWheelchairCuteRe as MGCIcon,
  mgcIconWhistleCuteRe as MGCIcon,
  mgcIconAddCircleCuteRe as MGCIcon,
  mgcIconAddCuteRe as MGCIcon,
  mgcIconAddSquareCuteRe as MGCIcon,
  mgcIconAlertCuteRe as MGCIcon,
  mgcIconAlertDiamondCuteRe as MGCIcon,
  mgcIconAlertOctagonCuteRe as MGCIcon,
  mgcIconBroomCuteRe as MGCIcon,
  mgcIconBrush3CuteRe as MGCIcon,
  mgcIconBrushCuteRe as MGCIcon,
  mgcIconBubbleCuteRe as MGCIcon,
  mgcIconCertificateCuteRe as MGCIcon,
  mgcIconCheck2CuteRe as MGCIcon,
  mgcIconCheckCircleCuteRe as MGCIcon,
  mgcIconCheckCuteRe as MGCIcon,
  mgcIconCheckboxCuteRe as MGCIcon,
  mgcIconChecksCuteRe as MGCIcon,
  mgcIconChoiceCuteRe as MGCIcon,
  mgcIconClassify2CuteRe as MGCIcon,
  mgcIconClassify3CuteRe as MGCIcon,
  mgcIconClassifyAdd2CuteRe as MGCIcon,
  mgcIconClassifyAddCuteRe as MGCIcon,
  mgcIconClassifyCuteRe as MGCIcon,
  mgcIconCloseCircleCuteRe as MGCIcon,
  mgcIconCloseCuteRe as MGCIcon,
  mgcIconCloseSquareCuteRe as MGCIcon,
  mgcIconCrossCuteRe as MGCIcon,
  mgcIconCrutchCuteRe as MGCIcon,
  mgcIconCubeCuteRe as MGCIcon,
  mgcIconDelete2CuteRe as MGCIcon,
  mgcIconDelete3CuteRe as MGCIcon,
  mgcIconDeleteBackCuteRe as MGCIcon,
  mgcIconDeleteCuteRe as MGCIcon,
  mgcIconDirectionDotCuteRe as MGCIcon,
  mgcIconDoorCuteRe as MGCIcon,
  mgcIconDotGridCuteRe as MGCIcon,
  mgcIconDotsCuteRe as MGCIcon,
  mgcIconDotsVerticalCuteRe as MGCIcon,
  mgcIconEnterDoorCuteRe as MGCIcon,
  mgcIconEntranceCuteRe as MGCIcon,
  mgcIconExitCuteRe as MGCIcon,
  mgcIconExitDoorCuteRe as MGCIcon,
  mgcIconEyeCloseCuteRe as MGCIcon,
  mgcIconEyeCuteRe as MGCIcon,
  mgcIconFaceidCuteRe as MGCIcon,
  mgcIconFaultCuteRe as MGCIcon,
  mgcIconFilter2CuteRe as MGCIcon,
  mgcIconFingerprint2CuteRe as MGCIcon,
  mgcIconFingerprintCuteRe as MGCIcon,
  mgcIconFireCuteRe as MGCIcon,
  mgcIconFlameCuteRe as MGCIcon,
  mgcIconForbidCircleCuteRe as MGCIcon,
  mgcIconGestureUnlockCuteRe as MGCIcon,
  mgcIconGhostCuteRe as MGCIcon,
  mgcIconGrid2CuteRe as MGCIcon,
  mgcIconGridCuteRe as MGCIcon,
  mgcIconHeartbeatCuteRe as MGCIcon,
  mgcIconHexagons2CuteRe as MGCIcon,
  mgcIconHexagonsCuteRe as MGCIcon,
  mgcIconHistory2CuteRe as MGCIcon,
  mgcIconHistoryAnticlockwiseCuteRe as MGCIcon,
  mgcIconHistoryCuteRe as MGCIcon,
  mgcIconInformationCuteRe as MGCIcon,
  mgcIconKey1CuteRe as MGCIcon,
  mgcIconKey2CuteRe as MGCIcon,
  mgcIconKeyholeCuteRe as MGCIcon,
  mgcIconLoading2CuteRe as MGCIcon,
  mgcIconLoading3CuteRe as MGCIcon,
  mgcIconLoading4CuteRe as MGCIcon,
  mgcIconLoadingCuteRe as MGCIcon,
  mgcIconLockCuteRe as MGCIcon,
  mgcIconMindMapCuteRe as MGCIcon,
  mgcIconMinimizeCuteRe as MGCIcon,
  mgcIconMinusCircleCuteRe as MGCIcon,
  mgcIconMinusSquareCuteRe as MGCIcon,
  mgcIconMore1CuteRe as MGCIcon,
  mgcIconMore2CuteRe as MGCIcon,
  mgcIconMore3CuteRe as MGCIcon,
  mgcIconMore4CuteRe as MGCIcon,
  mgcIconMultiselectCuteRe as MGCIcon,
  mgcIconNewdotCuteRe as MGCIcon,
  mgcIconOpenDoorCuteRe as MGCIcon,
  mgcIconPlusCuteRe as MGCIcon,
  mgcIconPolygonCuteRe as MGCIcon,
  mgcIconPowerCuteRe as MGCIcon,
  mgcIconProcessCuteRe as MGCIcon,
  mgcIconQuestionCuteRe as MGCIcon,
  mgcIconRadioboxCuteRe as MGCIcon,
  mgcIconRecycleCuteRe as MGCIcon,
  mgcIconRefresh1CuteRe as MGCIcon,
  mgcIconRefresh2CuteRe as MGCIcon,
  mgcIconRefresh3CuteRe as MGCIcon,
  mgcIconRefresh4AiCuteRe as MGCIcon,
  mgcIconRefresh4CuteRe as MGCIcon,
  mgcIconRefreshAnticlockwise1CuteRe as MGCIcon,
  mgcIconReportCuteRe as MGCIcon,
  mgcIconRestoreCuteRe as MGCIcon,
  mgcIconSafeAlertCuteRe as MGCIcon,
  mgcIconSafeFlashCuteRe as MGCIcon,
  mgcIconSafeLockCuteRe as MGCIcon,
  mgcIconSafeShield2CuteRe as MGCIcon,
  mgcIconSafeShieldCuteRe as MGCIcon,
  mgcIconSafetyCertificateCuteRe as MGCIcon,
  mgcIconSettings1CuteRe as MGCIcon,
  mgcIconSettings2CuteRe as MGCIcon,
  mgcIconSettings3CuteRe as MGCIcon,
  mgcIconSettings4CuteRe as MGCIcon,
  mgcIconSettings5CuteRe as MGCIcon,
  mgcIconSettings6CuteRe as MGCIcon,
  mgcIconSettings7CuteRe as MGCIcon,
  mgcIconShare2CuteRe as MGCIcon,
  mgcIconShare3CuteRe as MGCIcon,
  mgcIconShareForwardCuteRe as MGCIcon,
  mgcIconShieldCuteRe as MGCIcon,
  mgcIconSleepCuteRe as MGCIcon,
  mgcIconSwitchCuteRe as MGCIcon,
  mgcIconTShirtCuteRe as MGCIcon,
  mgcIconThreeCirclesCuteRe as MGCIcon,
  mgcIconThumbDown2CuteRe as MGCIcon,
  mgcIconThumbDownCuteRe as MGCIcon,
  mgcIconThumbUp2CuteRe as MGCIcon,
  mgcIconThumbUpCuteRe as MGCIcon,
  mgcIconTimeCuteRe as MGCIcon,
  mgcIconTimeDurationCuteRe as MGCIcon,
  mgcIconTimelineCuteRe as MGCIcon,
  mgcIconToggleLeft2CuteRe as MGCIcon,
  mgcIconToggleLeftCuteRe as MGCIcon,
  mgcIconToggleRight2CuteRe as MGCIcon,
  mgcIconToggleRightCuteRe as MGCIcon,
  mgcIconToolCuteRe as MGCIcon,
  mgcIconTransformationCuteRe as MGCIcon,
  mgcIconUnlockCuteRe as MGCIcon,
  mgcIconVersionCuteRe as MGCIcon,
  mgcIconWarningCuteRe as MGCIcon,
  mgcIconWastebasketCuteRe as MGCIcon,
  mgcIconWebhookCuteRe as MGCIcon,
  mgcIconAbsCuteRe as MGCIcon,
  mgcIconAerialLiftCuteRe as MGCIcon,
  mgcIconAirplaneCuteRe as MGCIcon,
  mgcIconAutoHoldCuteRe as MGCIcon,
  mgcIconBabyCarriageCuteRe as MGCIcon,
  mgcIconBikeCuteRe as MGCIcon,
  mgcIconBrakeCuteRe as MGCIcon,
  mgcIconBus2CuteRe as MGCIcon,
  mgcIconBusCuteRe as MGCIcon,
  mgcIconCar2CuteRe as MGCIcon,
  mgcIconCar3CuteRe as MGCIcon,
  mgcIconCarCuteRe as MGCIcon,
  mgcIconCarDoorCuteRe as MGCIcon,
  mgcIconCarWindowCuteRe as MGCIcon,
  mgcIconChargingPileCuteRe as MGCIcon,
  mgcIconEbikeCuteRe as MGCIcon,
  mgcIconEmergencyFlashersCuteRe as MGCIcon,
  mgcIconEngineCuteRe as MGCIcon,
  mgcIconFan2CuteRe as MGCIcon,
  mgcIconFanCuteRe as MGCIcon,
  mgcIconFanDirectionDownCuteRe as MGCIcon,
  mgcIconFanDirectionFrontCuteRe as MGCIcon,
  mgcIconFanDirectionUpCuteRe as MGCIcon,
  mgcIconFlightInflightCuteRe as MGCIcon,
  mgcIconFlightLandCuteRe as MGCIcon,
  mgcIconFlightTakeoffCuteRe as MGCIcon,
  mgcIconFourWheelDriveCuteRe as MGCIcon,
  mgcIconFrontFogLightsCuteRe as MGCIcon,
  mgcIconFrontWindshieldDefrosterCuteRe as MGCIcon,
  mgcIconGasStationCuteRe as MGCIcon,
  mgcIconHightBeamHeadlightsCuteRe as MGCIcon,
  mgcIconHoodCuteRe as MGCIcon,
  mgcIconJeepCuteRe as MGCIcon,
  mgcIconLowBeamHeadlightsCuteRe as MGCIcon,
  mgcIconOilCuteRe as MGCIcon,
  mgcIconParkCuteRe as MGCIcon,
  mgcIconParkingLightsCuteRe as MGCIcon,
  mgcIconPinwheel2CuteRe as MGCIcon,
  mgcIconPinwheelCuteRe as MGCIcon,
  mgcIconRareFogLightsCuteRe as MGCIcon,
  mgcIconRearWindshieldDefrosterCuteRe as MGCIcon,
  mgcIconRocket2CuteRe as MGCIcon,
  mgcIconRocketCuteRe as MGCIcon,
  mgcIconRudderCuteRe as MGCIcon,
  mgcIconSailboatCuteRe as MGCIcon,
  mgcIconScooterCuteRe as MGCIcon,
  mgcIconSeatCuteRe as MGCIcon,
  mgcIconSeatHeatedCuteRe as MGCIcon,
  mgcIconShipCuteRe as MGCIcon,
  mgcIconSleighCuteRe as MGCIcon,
  mgcIconSteeringWheelCuteRe as MGCIcon,
  mgcIconTankCuteRe as MGCIcon,
  mgcIconTrafficLightsCuteRe as MGCIcon,
  mgcIconTrain2CuteRe as MGCIcon,
  mgcIconTrain3CuteRe as MGCIcon,
  mgcIconTrain4CuteRe as MGCIcon,
  mgcIconTrainCuteRe as MGCIcon,
  mgcIconTruckCuteRe as MGCIcon,
  mgcIconTrunkCuteRe as MGCIcon,
  mgcIconTyreCuteRe as MGCIcon,
  mgcIconUfo2CuteRe as MGCIcon,
  mgcIconUfoCuteRe as MGCIcon,
  mgcIconWheelCuteRe as MGCIcon,
  mgcIconWiperCuteRe as MGCIcon,
  mgcIconBadgeCuteRe as MGCIcon,
  mgcIconContacts2CuteRe as MGCIcon,
  mgcIconContacts3CuteRe as MGCIcon,
  mgcIconContacts4CuteRe as MGCIcon,
  mgcIconContactsCuteRe as MGCIcon,
  mgcIconFemaleCuteRe as MGCIcon,
  mgcIconGroup2CuteRe as MGCIcon,
  mgcIconGroup3CuteRe as MGCIcon,
  mgcIconGroupCuteRe as MGCIcon,
  mgcIconIDcardCuteRe as MGCIcon,
  mgcIconMaleCuteRe as MGCIcon,
  mgcIconUser1CuteRe as MGCIcon,
  mgcIconUser2CuteRe as MGCIcon,
  mgcIconUser3CuteRe as MGCIcon,
  mgcIconUser4CuteRe as MGCIcon,
  mgcIconUser5CuteRe as MGCIcon,
  mgcIconUserAdd2CuteRe as MGCIcon,
  mgcIconUserAddCuteRe as MGCIcon,
  mgcIconUserEditCuteRe as MGCIcon,
  mgcIconUserFollow2CuteRe as MGCIcon,
  mgcIconUserFollowCuteRe as MGCIcon,
  mgcIconUserForbidCuteRe as MGCIcon,
  mgcIconUserHeartCuteRe as MGCIcon,
  mgcIconUserHideCuteRe as MGCIcon,
  mgcIconUserInfoCuteRe as MGCIcon,
  mgcIconUserLockCuteRe as MGCIcon,
  mgcIconUserPinCuteRe as MGCIcon,
  mgcIconUserQuestionCuteRe as MGCIcon,
  mgcIconUserRemove2CuteRe as MGCIcon,
  mgcIconUserRemoveCuteRe as MGCIcon,
  mgcIconUserSearchCuteRe as MGCIcon,
  mgcIconUserSecurityCuteRe as MGCIcon,
  mgcIconUserSettingCuteRe as MGCIcon,
  mgcIconUserStarCuteRe as MGCIcon,
  mgcIconUserVisibleCuteRe as MGCIcon,
  mgcIconUserWarningCuteRe as MGCIcon,
  mgcIconUserXCuteRe as MGCIcon,
  mgcIconCelsiusCuteRe as MGCIcon,
  mgcIconCloud2CuteRe as MGCIcon,
  mgcIconCloudCuteRe as MGCIcon,
  mgcIconCloudLightningCuteRe as MGCIcon,
  mgcIconCloudSnowCuteRe as MGCIcon,
  mgcIconCloudWindyCuteRe as MGCIcon,
  mgcIconCloudsCuteRe as MGCIcon,
  mgcIconDrizzleCuteRe as MGCIcon,
  mgcIconDryCuteRe as MGCIcon,
  mgcIconFahrenheitCuteRe as MGCIcon,
  mgcIconFloatingDustCuteRe as MGCIcon,
  mgcIconFogCuteRe as MGCIcon,
  mgcIconFullMoonCuteRe as MGCIcon,
  mgcIconHailCuteRe as MGCIcon,
  mgcIconHazeCuteRe as MGCIcon,
  mgcIconHeavyRainCuteRe as MGCIcon,
  mgcIconHeavyRainstormCuteRe as MGCIcon,
  mgcIconHeavySnowCuteRe as MGCIcon,
  mgcIconHeavySnowstormCuteRe as MGCIcon,
  mgcIconHighTemperatureCuteRe as MGCIcon,
  mgcIconLightSnowCuteRe as MGCIcon,
  mgcIconLightningCuteRe as MGCIcon,
  mgcIconLowTemperatureCuteRe as MGCIcon,
  mgcIconModerateSnowCuteRe as MGCIcon,
  mgcIconMoonCloudyCuteRe as MGCIcon,
  mgcIconMoonCuteRe as MGCIcon,
  mgcIconMoonFogCuteRe as MGCIcon,
  mgcIconMoonStarsCuteRe as MGCIcon,
  mgcIconMoonlightCuteRe as MGCIcon,
  mgcIconNaCuteRe as MGCIcon,
  mgcIconPartlyCloudDaytimeCuteRe as MGCIcon,
  mgcIconPartlyCloudNightCuteRe as MGCIcon,
  mgcIconRainCuteRe as MGCIcon,
  mgcIconRainbowCuteRe as MGCIcon,
  mgcIconRainstormCuteRe as MGCIcon,
  mgcIconSandstormCuteRe as MGCIcon,
  mgcIconShowersCuteRe as MGCIcon,
  mgcIconSnowCuteRe as MGCIcon,
  mgcIconSnowflakeCuteRe as MGCIcon,
  mgcIconSnowmanCuteRe as MGCIcon,
  mgcIconSnowstorm2CuteRe as MGCIcon,
  mgcIconSnowstormCuteRe as MGCIcon,
  mgcIconSparkles2CuteRe as MGCIcon,
  mgcIconSparkles3CuteRe as MGCIcon,
  mgcIconSparklesCuteRe as MGCIcon,
  mgcIconSun2CuteRe as MGCIcon,
  mgcIconSunCloudyCuteRe as MGCIcon,
  mgcIconSunCuteRe as MGCIcon,
  mgcIconSunFogCuteRe as MGCIcon,
  mgcIconSunriseCuteRe as MGCIcon,
  mgcIconSunsetCuteRe as MGCIcon,
  mgcIconThermometerCuteRe as MGCIcon,
  mgcIconThunderstormCuteRe as MGCIcon,
  mgcIconTornado2CuteRe as MGCIcon,
  mgcIconTornadoCuteRe as MGCIcon,
  mgcIconTyphoonCuteRe as MGCIcon,
  mgcIconUmbrellaCuteRe as MGCIcon,
  mgcIconWaveCuteRe as MGCIcon,
  mgcIconWetCuteRe as MGCIcon,
  mgcIconWindCuteRe as MGCIcon,
  mgcIconAquariusCuteRe as MGCIcon,
  mgcIconAriesCuteRe as MGCIcon,
  mgcIconCancerCuteRe as MGCIcon,
  mgcIconCapricornCuteRe as MGCIcon,
  mgcIconGeminiCuteRe as MGCIcon,
  mgcIconLeoCuteRe as MGCIcon,
  mgcIconLibraCuteRe as MGCIcon,
  mgcIconPiscesCuteRe as MGCIcon,
  mgcIconSagittariusCuteRe as MGCIcon,
  mgcIconScorpioCuteRe as MGCIcon,
  mgcIconTaurusCuteRe as MGCIcon,
  mgcIconVirgoCuteRe as MGCIcon,
  mgcIconAlignArrowDownFilled as MGCIcon,
  mgcIconAlignArrowLeftFilled as MGCIcon,
  mgcIconAlignArrowRightFilled as MGCIcon,
  mgcIconAlignArrowUpFilled as MGCIcon,
  mgcIconArrowDownCircleFilled as MGCIcon,
  mgcIconArrowDownFilled as MGCIcon,
  mgcIconArrowLeftCircleFilled as MGCIcon,
  mgcIconArrowLeftDownCircleFilled as MGCIcon,
  mgcIconArrowLeftDownFilled as MGCIcon,
  mgcIconArrowLeftFilled as MGCIcon,
  mgcIconArrowLeftUpCircleFilled as MGCIcon,
  mgcIconArrowLeftUpFilled as MGCIcon,
  mgcIconArrowRightCircleFilled as MGCIcon,
  mgcIconArrowRightDownCircleFilled as MGCIcon,
  mgcIconArrowRightDownFilled as MGCIcon,
  mgcIconArrowRightFilled as MGCIcon,
  mgcIconArrowRightUpCircleFilled as MGCIcon,
  mgcIconArrowRightUpFilled as MGCIcon,
  mgcIconArrowToDownFilled as MGCIcon,
  mgcIconArrowToLeftFilled as MGCIcon,
  mgcIconArrowToRightFilled as MGCIcon,
  mgcIconArrowToUpFilled as MGCIcon,
  mgcIconArrowUpCircleFilled as MGCIcon,
  mgcIconArrowUpFilled as MGCIcon,
  mgcIconArrowsDownFilled as MGCIcon,
  mgcIconArrowsLeftFilled as MGCIcon,
  mgcIconArrowsRightFilled as MGCIcon,
  mgcIconArrowsUpFilled as MGCIcon,
  mgcIconBack2Filled as MGCIcon,
  mgcIconBackFilled as MGCIcon,
  mgcIconCornerDownLeftFilled as MGCIcon,
  mgcIconCornerDownRightFilled as MGCIcon,
  mgcIconCornerUpLeftFilled as MGCIcon,
  mgcIconCornerUpRightFilled as MGCIcon,
  mgcIconDirectionArrowFilled as MGCIcon,
  mgcIconDownFilled as MGCIcon,
  mgcIconDownSmallFilled as MGCIcon,
  mgcIconForward2Filled as MGCIcon,
  mgcIconForwardFilled as MGCIcon,
  mgcIconFullscreen2Filled as MGCIcon,
  mgcIconFullscreenExit2Filled as MGCIcon,
  mgcIconLargeArrowDownFilled as MGCIcon,
  mgcIconLargeArrowLeftFilled as MGCIcon,
  mgcIconLargeArrowRightFilled as MGCIcon,
  mgcIconLargeArrowUpFilled as MGCIcon,
  mgcIconLeftFilled as MGCIcon,
  mgcIconLeftSmallFilled as MGCIcon,
  mgcIconMoveFilled as MGCIcon,
  mgcIconRightFilled as MGCIcon,
  mgcIconRightSmallFilled as MGCIcon,
  mgcIconSelectorHorizontalFilled as MGCIcon,
  mgcIconSelectorVerticalFilled as MGCIcon,
  mgcIconSquareArrowDownFilled as MGCIcon,
  mgcIconSquareArrowLeftFilled as MGCIcon,
  mgcIconSquareArrowRightFilled as MGCIcon,
  mgcIconSquareArrowUpFilled as MGCIcon,
  mgcIconTransfer2Filled as MGCIcon,
  mgcIconTransfer3Filled as MGCIcon,
  mgcIconTransfer4Filled as MGCIcon,
  mgcIconTransferFilled as MGCIcon,
  mgcIconTransferHorizontalFilled as MGCIcon,
  mgcIconTransferVerticalFilled as MGCIcon,
  mgcIconTrendingDownFilled as MGCIcon,
  mgcIconTrendingUpFilled as MGCIcon,
  mgcIconUpFilled as MGCIcon,
  mgcIconUpSmallFilled as MGCIcon,
  mgcIconBankFilled as MGCIcon,
  mgcIconBankOfChinaTowerFilled as MGCIcon,
  mgcIconBigBenFilled as MGCIcon,
  mgcIconBridge2Filled as MGCIcon,
  mgcIconBridgeFilled as MGCIcon,
  mgcIconBuilding1Filled as MGCIcon,
  mgcIconBuilding2Filled as MGCIcon,
  mgcIconBuilding3Filled as MGCIcon,
  mgcIconBuilding4Filled as MGCIcon,
  mgcIconBuilding5Filled as MGCIcon,
  mgcIconBuilding6Filled as MGCIcon,
  mgcIconBurjAlArabFilled as MGCIcon,
  mgcIconBurjKhalifaTowerFilled as MGCIcon,
  mgcIconCampgroundFilled as MGCIcon,
  mgcIconCantonTowerFilled as MGCIcon,
  mgcIconChristTheRedeemerFilled as MGCIcon,
  mgcIconChurchFilled as MGCIcon,
  mgcIconDutchWindmillFilled as MGCIcon,
  mgcIconEgyptianPyramidsFilled as MGCIcon,
  mgcIconEiffelTowerFilled as MGCIcon,
  mgcIconFactory2Filled as MGCIcon,
  mgcIconFactoryFilled as MGCIcon,
  mgcIconFerrisWheelFilled as MGCIcon,
  mgcIconGovernmentFilled as MGCIcon,
  mgcIconGreatwallFilled as MGCIcon,
  mgcIconHome1Filled as MGCIcon,
  mgcIconHome2Filled as MGCIcon,
  mgcIconHome3Filled as MGCIcon,
  mgcIconHome4Filled as MGCIcon,
  mgcIconHome5Filled as MGCIcon,
  mgcIconHome6Filled as MGCIcon,
  mgcIconHome7Filled as MGCIcon,
  mgcIconHospitalFilled as MGCIcon,
  mgcIconHotelFilled as MGCIcon,
  mgcIconHouse2Filled as MGCIcon,
  mgcIconHouseFilled as MGCIcon,
  mgcIconKingkey100TowerFilled as MGCIcon,
  mgcIconLighthouseFilled as MGCIcon,
  mgcIconMarinaBaySandFilled as MGCIcon,
  mgcIconMayaPyramidsFilled as MGCIcon,
  mgcIconMiyajimaToriiFilled as MGCIcon,
  mgcIconMoaiFilled as MGCIcon,
  mgcIconMonumentFilled as MGCIcon,
  mgcIconPalaceFilled as MGCIcon,
  mgcIconPavilionFilled as MGCIcon,
  mgcIconPisaTowerFilled as MGCIcon,
  mgcIconSchoolFilled as MGCIcon,
  mgcIconShopFilled as MGCIcon,
  mgcIconStatueOfLibertyFilled as MGCIcon,
  mgcIconStore2Filled as MGCIcon,
  mgcIconStoreFilled as MGCIcon,
  mgcIconSydneyOperaHouseFilled as MGCIcon,
  mgcIconTaipei101Filled as MGCIcon,
  mgcIconTajMahalFilled as MGCIcon,
  mgcIconTempleOfHeavenFilled as MGCIcon,
  mgcIconTentFilled as MGCIcon,
  mgcIconTowerFilled as MGCIcon,
  mgcIconTriumphalArchFilled as MGCIcon,
  mgcIconTvTowerFilled as MGCIcon,
  mgcIconAdCircleFilled as MGCIcon,
  mgcIconAdCircleOffFilled as MGCIcon,
  mgcIconAdRectangleFilled as MGCIcon,
  mgcIconAdRectangleOffFilled as MGCIcon,
  mgcIconAnniversaryFilled as MGCIcon,
  mgcIconAuctionFilled as MGCIcon,
  mgcIconAwardFilled as MGCIcon,
  mgcIconBankCardFilled as MGCIcon,
  mgcIconBasket2Filled as MGCIcon,
  mgcIconBasketFilled as MGCIcon,
  mgcIconBriefcase2Filled as MGCIcon,
  mgcIconBriefcaseFilled as MGCIcon,
  mgcIconCalendar2Filled as MGCIcon,
  mgcIconCalendar3Filled as MGCIcon,
  mgcIconCalendarAddFilled as MGCIcon,
  mgcIconCalendarDayFilled as MGCIcon,
  mgcIconCalendarFilled as MGCIcon,
  mgcIconCalendarMonthFilled as MGCIcon,
  mgcIconCalendarTimeAddFilled as MGCIcon,
  mgcIconCalendarWeekFilled as MGCIcon,
  mgcIconCandleFilled as MGCIcon,
  mgcIconCandlesFilled as MGCIcon,
  mgcIconCardPayFilled as MGCIcon,
  mgcIconCardRefundFilled as MGCIcon,
  mgcIconCash2Filled as MGCIcon,
  mgcIconCashFilled as MGCIcon,
  mgcIconCelebrateFilled as MGCIcon,
  mgcIconChartBar2Filled as MGCIcon,
  mgcIconChartBarFilled as MGCIcon,
  mgcIconChartDecreaseFilled as MGCIcon,
  mgcIconChartHorizontalFilled as MGCIcon,
  mgcIconChartLineFilled as MGCIcon,
  mgcIconChartPie2Filled as MGCIcon,
  mgcIconChartPieFilled as MGCIcon,
  mgcIconChartVerticalFilled as MGCIcon,
  mgcIconChineseKnotFilled as MGCIcon,
  mgcIconChristmasBallFilled as MGCIcon,
  mgcIconCoin2Filled as MGCIcon,
  mgcIconCoin3Filled as MGCIcon,
  mgcIconCoinFilled as MGCIcon,
  mgcIconCopperCoinFilled as MGCIcon,
  mgcIconCopyrightFilled as MGCIcon,
  mgcIconCouponFilled as MGCIcon,
  mgcIconCurrencyBaht2Filled as MGCIcon,
  mgcIconCurrencyBahtFilled as MGCIcon,
  mgcIconCurrencyCny2Filled as MGCIcon,
  mgcIconCurrencyCnyFilled as MGCIcon,
  mgcIconCurrencyDollar2Filled as MGCIcon,
  mgcIconCurrencyDollarFilled as MGCIcon,
  mgcIconCurrencyEuro2Filled as MGCIcon,
  mgcIconCurrencyEuroFilled as MGCIcon,
  mgcIconCurrencyLira2Filled as MGCIcon,
  mgcIconCurrencyLiraFilled as MGCIcon,
  mgcIconCurrencyNigeria2Filled as MGCIcon,
  mgcIconCurrencyNigeriaFilled as MGCIcon,
  mgcIconCurrencyRubel2Filled as MGCIcon,
  mgcIconCurrencyRubelFilled as MGCIcon,
  mgcIconCurrencyRupee2Filled as MGCIcon,
  mgcIconCurrencyRupeeFilled as MGCIcon,
  mgcIconCurrencyShekel2Filled as MGCIcon,
  mgcIconCurrencyShekelFilled as MGCIcon,
  mgcIconCurrencyWon2Filled as MGCIcon,
  mgcIconCurrencyWonFilled as MGCIcon,
  mgcIconDiamond2Filled as MGCIcon,
  mgcIconExchangeBahtFilled as MGCIcon,
  mgcIconExchangeCnyFilled as MGCIcon,
  mgcIconExchangeDollarFilled as MGCIcon,
  mgcIconExchangeEuroFilled as MGCIcon,
  mgcIconFilter3Filled as MGCIcon,
  mgcIconFilterFilled as MGCIcon,
  mgcIconFlag1Filled as MGCIcon,
  mgcIconFlag2Filled as MGCIcon,
  mgcIconFlag3Filled as MGCIcon,
  mgcIconFlag4Filled as MGCIcon,
  mgcIconGift2Filled as MGCIcon,
  mgcIconGiftCardFilled as MGCIcon,
  mgcIconGiftFilled as MGCIcon,
  mgcIconLadderFilled as MGCIcon,
  mgcIconLantern2Filled as MGCIcon,
  mgcIconLanternFilled as MGCIcon,
  mgcIconLaurelWreathFilled as MGCIcon,
  mgcIconLuggageFilled as MGCIcon,
  mgcIconMedalFilled as MGCIcon,
  mgcIconPalette3Filled as MGCIcon,
  mgcIconPigMoneyFilled as MGCIcon,
  mgcIconPound2Filled as MGCIcon,
  mgcIconPoundFilled as MGCIcon,
  mgcIconPresentation1Filled as MGCIcon,
  mgcIconPresentation2Filled as MGCIcon,
  mgcIconPresentation3Filled as MGCIcon,
  mgcIconPumpkinLanternFilled as MGCIcon,
  mgcIconReceiveMoneyFilled as MGCIcon,
  mgcIconRedPacketFilled as MGCIcon,
  mgcIconRedPacketOpenFilled as MGCIcon,
  mgcIconRefundCnyFilled as MGCIcon,
  mgcIconRefundDollarFilled as MGCIcon,
  mgcIconRegisteredFilled as MGCIcon,
  mgcIconSafeBoxFilled as MGCIcon,
  mgcIconSaleFilled as MGCIcon,
  mgcIconScheduleFilled as MGCIcon,
  mgcIconSealFilled as MGCIcon,
  mgcIconShoppingBag1Filled as MGCIcon,
  mgcIconShoppingBag2Filled as MGCIcon,
  mgcIconShoppingBag3Filled as MGCIcon,
  mgcIconShoppingCart1Filled as MGCIcon,
  mgcIconShoppingCart2Filled as MGCIcon,
  mgcIconSofaFilled as MGCIcon,
  mgcIconStockFilled as MGCIcon,
  mgcIconSuitcase2Filled as MGCIcon,
  mgcIconSuitcaseFilled as MGCIcon,
  mgcIconTag2Filled as MGCIcon,
  mgcIconTagChevronFilled as MGCIcon,
  mgcIconTagFilled as MGCIcon,
  mgcIconTargetFilled as MGCIcon,
  mgcIconTicketFilled as MGCIcon,
  mgcIconTrophyFilled as MGCIcon,
  mgcIconVip1Filled as MGCIcon,
  mgcIconVip2Filled as MGCIcon,
  mgcIconVip3Filled as MGCIcon,
  mgcIconVip4Filled as MGCIcon,
  mgcIconWallet2Filled as MGCIcon,
  mgcIconWallet3Filled as MGCIcon,
  mgcIconWallet4Filled as MGCIcon,
  mgcIconWallet5Filled as MGCIcon,
  mgcIconWalletFilled as MGCIcon,
  mgcIconYuanbaoFilled as MGCIcon,
  mgcIconChat1Filled as MGCIcon,
  mgcIconChat2Filled as MGCIcon,
  mgcIconChat3Filled as MGCIcon,
  mgcIconChat4Filled as MGCIcon,
  mgcIconComment2Filled as MGCIcon,
  mgcIconCommentFilled as MGCIcon,
  mgcIconInviteFilled as MGCIcon,
  mgcIconMailAiFilled as MGCIcon,
  mgcIconMailFilled as MGCIcon,
  mgcIconMailOpenFilled as MGCIcon,
  mgcIconMailSendFilled as MGCIcon,
  mgcIconMailboxFilled as MGCIcon,
  mgcIconMessage1Filled as MGCIcon,
  mgcIconMessage2Filled as MGCIcon,
  mgcIconMessage3Filled as MGCIcon,
  mgcIconMessage4Filled as MGCIcon,
  mgcIconPhoneAddFilled as MGCIcon,
  mgcIconPhoneBlockFilled as MGCIcon,
  mgcIconPhoneCallFilled as MGCIcon,
  mgcIconPhoneFilled as MGCIcon,
  mgcIconPhoneIncomingFilled as MGCIcon,
  mgcIconPhoneOffFilled as MGCIcon,
  mgcIconPhoneOutgoingFilled as MGCIcon,
  mgcIconPhoneSuccessFilled as MGCIcon,
  mgcIconSendFilled as MGCIcon,
  mgcIconSendPlaneFilled as MGCIcon,
  mgcIconAvalancheAvaxFilled as MGCIcon,
  mgcIconBinanceCoinBnbFilled as MGCIcon,
  mgcIconBinanceUsdBusdFilled as MGCIcon,
  mgcIconBnbFilled as MGCIcon,
  mgcIconCardanoAdaFilled as MGCIcon,
  mgcIconCurrencyBitcoin2Filled as MGCIcon,
  mgcIconCurrencyBitcoinFilled as MGCIcon,
  mgcIconDogecoinDogeFilled as MGCIcon,
  mgcIconEthereumFilled as MGCIcon,
  mgcIconExchangeBitcoinFilled as MGCIcon,
  mgcIconMoneroFilled as MGCIcon,
  mgcIconPolkadotDotFilled as MGCIcon,
  mgcIconSolanaSolFilled as MGCIcon,
  mgcIconTetherUsdtFilled as MGCIcon,
  mgcIconUsdCoinUsdcFilled as MGCIcon,
  mgcIconXrpFilled as MGCIcon,
  mgcIconAlignBottomFilled as MGCIcon,
  mgcIconAlignHorizontalCenterFilled as MGCIcon,
  mgcIconAlignLeft2Filled as MGCIcon,
  mgcIconAlignRight2Filled as MGCIcon,
  mgcIconAlignTopFilled as MGCIcon,
  mgcIconAlignVerticalCenterFilled as MGCIcon,
  mgcIconAnticlockwiseAltFilled as MGCIcon,
  mgcIconAnticlockwiseFilled as MGCIcon,
  mgcIconArtboardFilled as MGCIcon,
  mgcIconBackgroundBaseFilled as MGCIcon,
  mgcIconBackgroundFilled as MGCIcon,
  mgcIconBlingFilled as MGCIcon,
  mgcIconBoardFilled as MGCIcon,
  mgcIconBorderBlankFilled as MGCIcon,
  mgcIconBorderBottomFilled as MGCIcon,
  mgcIconBorderHorizontalFilled as MGCIcon,
  mgcIconBorderInnerFilled as MGCIcon,
  mgcIconBorderLeftFilled as MGCIcon,
  mgcIconBorderOuterFilled as MGCIcon,
  mgcIconBorderRadiusFilled as MGCIcon,
  mgcIconBorderRightFilled as MGCIcon,
  mgcIconBorderTopFilled as MGCIcon,
  mgcIconBorderVerticalFilled as MGCIcon,
  mgcIconBrightnessFilled as MGCIcon,
  mgcIconBrush2Filled as MGCIcon,
  mgcIconClockwiseAltFilled as MGCIcon,
  mgcIconClockwiseFilled as MGCIcon,
  mgcIconColorFilterFilled as MGCIcon,
  mgcIconColorPickerFilled as MGCIcon,
  mgcIconColumns2Filled as MGCIcon,
  mgcIconColumns3Filled as MGCIcon,
  mgcIconCombineFilled as MGCIcon,
  mgcIconComponentsFilled as MGCIcon,
  mgcIconDistributeSpacingHorizontalFilled as MGCIcon,
  mgcIconDistributeSpacingVerticalFilled as MGCIcon,
  mgcIconDrawingBoardFilled as MGCIcon,
  mgcIconDropFilled as MGCIcon,
  mgcIconEaseInControlPointFilled as MGCIcon,
  mgcIconEaseInFilled as MGCIcon,
  mgcIconEaseInOutControlPointFilled as MGCIcon,
  mgcIconEaseOutControlPointFilled as MGCIcon,
  mgcIconEaseOutFilled as MGCIcon,
  mgcIconEasyInOutFilled as MGCIcon,
  mgcIconExcludeFilled as MGCIcon,
  mgcIconExposureFilled as MGCIcon,
  mgcIconFlipHorizontalFilled as MGCIcon,
  mgcIconFlipVerticalFilled as MGCIcon,
  mgcIconFoldHorizontalFilled as MGCIcon,
  mgcIconFoldVerticalFilled as MGCIcon,
  mgcIconIntersectFilled as MGCIcon,
  mgcIconKnifeFilled as MGCIcon,
  mgcIconLayerFilled as MGCIcon,
  mgcIconLayout10Filled as MGCIcon,
  mgcIconLayout11Filled as MGCIcon,
  mgcIconLayout2Filled as MGCIcon,
  mgcIconLayout3Filled as MGCIcon,
  mgcIconLayout4Filled as MGCIcon,
  mgcIconLayout5Filled as MGCIcon,
  mgcIconLayout6Filled as MGCIcon,
  mgcIconLayout7Filled as MGCIcon,
  mgcIconLayout8Filled as MGCIcon,
  mgcIconLayout9Filled as MGCIcon,
  mgcIconLayoutBottomCloseFilled as MGCIcon,
  mgcIconLayoutBottomFilled as MGCIcon,
  mgcIconLayoutBottomOpenFilled as MGCIcon,
  mgcIconLayoutFilled as MGCIcon,
  mgcIconLayoutGridFilled as MGCIcon,
  mgcIconLayoutLeftFilled as MGCIcon,
  mgcIconLayoutLeftbarCloseFilled as MGCIcon,
  mgcIconLayoutLeftbarOpenFilled as MGCIcon,
  mgcIconLayoutRightFilled as MGCIcon,
  mgcIconLayoutRightbarCloseFilled as MGCIcon,
  mgcIconLayoutRightbarOpenFilled as MGCIcon,
  mgcIconLayoutTopCloseFilled as MGCIcon,
  mgcIconLayoutTopFilled as MGCIcon,
  mgcIconLayoutTopOpenFilled as MGCIcon,
  mgcIconMagic1Filled as MGCIcon,
  mgcIconMagic2Filled as MGCIcon,
  mgcIconMagic3Filled as MGCIcon,
  mgcIconMagicHat2Filled as MGCIcon,
  mgcIconMagicHatFilled as MGCIcon,
  mgcIconMarkPenFilled as MGCIcon,
  mgcIconMarkupFilled as MGCIcon,
  mgcIconMirrorFilled as MGCIcon,
  mgcIconMosaicFilled as MGCIcon,
  mgcIconPaint2Filled as MGCIcon,
  mgcIconPaintBrushAiFilled as MGCIcon,
  mgcIconPaintBrushFilled as MGCIcon,
  mgcIconPalette2Filled as MGCIcon,
  mgcIconPaletteFilled as MGCIcon,
  mgcIconPasterFilled as MGCIcon,
  mgcIconPenFilled as MGCIcon,
  mgcIconQuillPenAiFilled as MGCIcon,
  mgcIconQuillPenFilled as MGCIcon,
  mgcIconRotateXFilled as MGCIcon,
  mgcIconRotateYFilled as MGCIcon,
  mgcIconRows2Filled as MGCIcon,
  mgcIconRows3Filled as MGCIcon,
  mgcIconRows4Filled as MGCIcon,
  mgcIconRulerFilled as MGCIcon,
  mgcIconScaleFilled as MGCIcon,
  mgcIconScissors2Filled as MGCIcon,
  mgcIconScissors3Filled as MGCIcon,
  mgcIconScissorsFilled as MGCIcon,
  mgcIconScreenshotFilled as MGCIcon,
  mgcIconSectionFilled as MGCIcon,
  mgcIconShadowFilled as MGCIcon,
  mgcIconStickerFilled as MGCIcon,
  mgcIconSubtractFilled as MGCIcon,
  mgcIconTable2Filled as MGCIcon,
  mgcIconUnfoldHorizontalFilled as MGCIcon,
  mgcIconUnfoldVerticalFilled as MGCIcon,
  mgcIconUnionFilled as MGCIcon,
  mgcIconVectorBezier2Filled as MGCIcon,
  mgcIconVectorBezier3Filled as MGCIcon,
  mgcIconVectorBezierFilled as MGCIcon,
  mgcIconVectorGroupFilled as MGCIcon,
  mgcIconXSkewFilled as MGCIcon,
  mgcIconYSkewFilled as MGCIcon,
  mgcIconBracesFilled as MGCIcon,
  mgcIconBracketsAngleFilled as MGCIcon,
  mgcIconBracketsFilled as MGCIcon,
  mgcIconBugFilled as MGCIcon,
  mgcIconCodeFilled as MGCIcon,
  mgcIconCommandFilled as MGCIcon,
  mgcIconCursor2Filled as MGCIcon,
  mgcIconCursor3Filled as MGCIcon,
  mgcIconCursorFilled as MGCIcon,
  mgcIconDepartmentFilled as MGCIcon,
  mgcIconDirectoryFilled as MGCIcon,
  mgcIconGitBranchFilled as MGCIcon,
  mgcIconGitCommitFilled as MGCIcon,
  mgcIconGitCompareFilled as MGCIcon,
  mgcIconGitMergeFilled as MGCIcon,
  mgcIconGitPullRequestCloseFilled as MGCIcon,
  mgcIconGitPullRequestFilled as MGCIcon,
  mgcIconHotkeyFilled as MGCIcon,
  mgcIconInspectFilled as MGCIcon,
  mgcIconParenthesesFilled as MGCIcon,
  mgcIconPerformanceFilled as MGCIcon,
  mgcIconSitemapFilled as MGCIcon,
  mgcIconTerminalBoxFilled as MGCIcon,
  mgcIconTerminalFilled as MGCIcon,
  mgcIconWebFilled as MGCIcon,
  mgcIconAiFilled as MGCIcon,
  mgcIconAirConditionFilled as MGCIcon,
  mgcIconAirConditionOpenFilled as MGCIcon,
  mgcIconAirplayFilled as MGCIcon,
  mgcIconAirpods2Filled as MGCIcon,
  mgcIconAlarm1Filled as MGCIcon,
  mgcIconAlarm2Filled as MGCIcon,
  mgcIconAspectRatioFilled as MGCIcon,
  mgcIconBarcodeFilled as MGCIcon,
  mgcIconBarcodeScaFilled as MGCIcon,
  mgcIconBaseStation2Filled as MGCIcon,
  mgcIconBaseStationFilled as MGCIcon,
  mgcIconBattery1Filled as MGCIcon,
  mgcIconBattery2Filled as MGCIcon,
  mgcIconBattery3Filled as MGCIcon,
  mgcIconBattery4Filled as MGCIcon,
  mgcIconBatteryAutomotiveFilled as MGCIcon,
  mgcIconBatteryChargingFilled as MGCIcon,
  mgcIconBatteryFilled as MGCIcon,
  mgcIconBluetoothFilled as MGCIcon,
  mgcIconBluetoothOffFilled as MGCIcon,
  mgcIconBulb2Filled as MGCIcon,
  mgcIconBulbFilled as MGCIcon,
  mgcIconCamcorder2Filled as MGCIcon,
  mgcIconCardboardVrFilled as MGCIcon,
  mgcIconCeilingLampFilled as MGCIcon,
  mgcIconCellphone2AiFilled as MGCIcon,
  mgcIconCellphone2Filled as MGCIcon,
  mgcIconCellphone2HorizontalFilled as MGCIcon,
  mgcIconCellphoneFilled as MGCIcon,
  mgcIconCellphoneVibrationFilled as MGCIcon,
  mgcIconChipFilled as MGCIcon,
  mgcIconComputerCamerFilled as MGCIcon,
  mgcIconComputerCameraOffFilled as MGCIcon,
  mgcIconComputerFilled as MGCIcon,
  mgcIconCounter2Filled as MGCIcon,
  mgcIconCube3DFilled as MGCIcon,
  mgcIconDashboard2Filled as MGCIcon,
  mgcIconDashboard3Filled as MGCIcon,
  mgcIconDashboard4Filled as MGCIcon,
  mgcIconDashboardFilled as MGCIcon,
  mgcIconDeskLamp2Filled as MGCIcon,
  mgcIconDeskLampFilled as MGCIcon,
  mgcIconDeviceFilled as MGCIcon,
  mgcIconDisplayFilled as MGCIcon,
  mgcIconDroneFilled as MGCIcon,
  mgcIconEscalatorDownFilled as MGCIcon,
  mgcIconEscalatorUpFilled as MGCIcon,
  mgcIconFaxFilled as MGCIcon,
  mgcIconFlashCircleFilled as MGCIcon,
  mgcIconFlashFilled as MGCIcon,
  mgcIconFlashlightFilled as MGCIcon,
  mgcIconFridgeFilled as MGCIcon,
  mgcIconGame1Filled as MGCIcon,
  mgcIconGame2Filled as MGCIcon,
  mgcIconGradienterFilled as MGCIcon,
  mgcIconGuitarFilled as MGCIcon,
  mgcIconHighVoltagePowerFilled as MGCIcon,
  mgcIconHomeWifiFilled as MGCIcon,
  mgcIconHomepodFilled as MGCIcon,
  mgcIconHomepodMiniFilled as MGCIcon,
  mgcIconIMacFilled as MGCIcon,
  mgcIconInstrumentFilled as MGCIcon,
  mgcIconKeyboard2Filled as MGCIcon,
  mgcIconKeyboardFilled as MGCIcon,
  mgcIconLaptop2Filled as MGCIcon,
  mgcIconLaptopFilled as MGCIcon,
  mgcIconLightFilled as MGCIcon,
  mgcIconMicroscopeFilled as MGCIcon,
  mgcIconMidiFilled as MGCIcon,
  mgcIconMonitorFilled as MGCIcon,
  mgcIconMouseFilled as MGCIcon,
  mgcIconPadFilled as MGCIcon,
  mgcIconPanoramasFilled as MGCIcon,
  mgcIconPlugin2Filled as MGCIcon,
  mgcIconPluginFilled as MGCIcon,
  mgcIconPrintFilled as MGCIcon,
  mgcIconProjectorFilled as MGCIcon,
  mgcIconProjectorScreenFilled as MGCIcon,
  mgcIconQrcode2Filled as MGCIcon,
  mgcIconQrcodeFilled as MGCIcon,
  mgcIconRadaFilled as MGCIcon,
  mgcIconRadar2Filled as MGCIcon,
  mgcIconRadioFilled as MGCIcon,
  mgcIconRemoteControlFilled as MGCIcon,
  mgcIconRemoteFilled as MGCIcon,
  mgcIconRouterModemFilled as MGCIcon,
  mgcIconRss2Filled as MGCIcon,
  mgcIconRssFilled as MGCIcon,
  mgcIconSandglass2Filled as MGCIcon,
  mgcIconSandglassFilled as MGCIcon,
  mgcIconScan2Filled as MGCIcon,
  mgcIconScanFilled as MGCIcon,
  mgcIconServer2Filled as MGCIcon,
  mgcIconServerFilled as MGCIcon,
  mgcIconShowerFilled as MGCIcon,
  mgcIconSignalFilled as MGCIcon,
  mgcIconSolarPanelFilled as MGCIcon,
  mgcIconSpeakerFilled as MGCIcon,
  mgcIconStopwatchFilled as MGCIcon,
  mgcIconStorageFilled as MGCIcon,
  mgcIconTelescope2Filled as MGCIcon,
  mgcIconTelescopeFilled as MGCIcon,
  mgcIconTowerCraneFilled as MGCIcon,
  mgcIconTv1Filled as MGCIcon,
  mgcIconTv2Filled as MGCIcon,
  mgcIconUsbFilled as MGCIcon,
  mgcIconUsbFlashDiskFilled as MGCIcon,
  mgcIconVisonProFilled as MGCIcon,
  mgcIconWashMachineFilled as MGCIcon,
  mgcIconWatch2Filled as MGCIcon,
  mgcIconWatchFilled as MGCIcon,
  mgcIconWifiFilled as MGCIcon,
  mgcIconWifiOffFilled as MGCIcon,
  mgcIconAlignCenterFilled as MGCIcon,
  mgcIconAlignJustifyFilled as MGCIcon,
  mgcIconAlignLeftFilled as MGCIcon,
  mgcIconAlignRightFilled as MGCIcon,
  mgcIconAndFilled as MGCIcon,
  mgcIconAsterisk2Filled as MGCIcon,
  mgcIconAsteriskFilled as MGCIcon,
  mgcIconAtFilled as MGCIcon,
  mgcIconAzSortAscendingLettersFilled as MGCIcon,
  mgcIconAzSortDescendingLettersFilled as MGCIcon,
  mgcIconBlockquoteFilled as MGCIcon,
  mgcIconBoldFilled as MGCIcon,
  mgcIconColumnFilled as MGCIcon,
  mgcIconContentAiFilled as MGCIcon,
  mgcIconCursorTextFilled as MGCIcon,
  mgcIconDividingLineFilled as MGCIcon,
  mgcIconEdit2Filled as MGCIcon,
  mgcIconEdit3Filled as MGCIcon,
  mgcIconEdit4Filled as MGCIcon,
  mgcIconEditFilled as MGCIcon,
  mgcIconEraserFilled as MGCIcon,
  mgcIconFontFilled as MGCIcon,
  mgcIconFontSizeFilled as MGCIcon,
  mgcIconFormulaFilled as MGCIcon,
  mgcIconFrameFilled as MGCIcon,
  mgcIconHashtagFilled as MGCIcon,
  mgcIconHeading1Filled as MGCIcon,
  mgcIconHeading2Filled as MGCIcon,
  mgcIconHeading3Filled as MGCIcon,
  mgcIconIndentDecreaseFilled as MGCIcon,
  mgcIconIndentIncreaseFilled as MGCIcon,
  mgcIconItalicFilled as MGCIcon,
  mgcIconLetterSpacingFilled as MGCIcon,
  mgcIconLineHeightFilled as MGCIcon,
  mgcIconListCheck2Filled as MGCIcon,
  mgcIconListCheck3Filled as MGCIcon,
  mgcIconListCheckFilled as MGCIcon,
  mgcIconListCollapseFilled as MGCIcon,
  mgcIconListExpansionFilled as MGCIcon,
  mgcIconListOrderedFilled as MGCIcon,
  mgcIconListSearchFilled as MGCIcon,
  mgcIconMenuFilled as MGCIcon,
  mgcIconNumbers09SortAscendingFilled as MGCIcon,
  mgcIconNumbers09SortDescendingFilled as MGCIcon,
  mgcIconNumbers90SortAscendingFilled as MGCIcon,
  mgcIconNumbers90SortDescendingFilled as MGCIcon,
  mgcIconOmegaFilled as MGCIcon,
  mgcIconPaintFilled as MGCIcon,
  mgcIconParagraphFilled as MGCIcon,
  mgcIconPen2Filled as MGCIcon,
  mgcIconPencil2AiFilled as MGCIcon,
  mgcIconPencil2Filled as MGCIcon,
  mgcIconPencil3Filled as MGCIcon,
  mgcIconPencilFilled as MGCIcon,
  mgcIconPencilRulerFilled as MGCIcon,
  mgcIconQuoteLeftFilled as MGCIcon,
  mgcIconQuoteRightFilled as MGCIcon,
  mgcIconSignatureFilled as MGCIcon,
  mgcIconSortAscendingFilled as MGCIcon,
  mgcIconSortDescendingFilled as MGCIcon,
  mgcIconSpaceFilled as MGCIcon,
  mgcIconSpacingHorizontalFilled as MGCIcon,
  mgcIconSpacingVerticalFilled as MGCIcon,
  mgcIconStrikethroughFilled as MGCIcon,
  mgcIconSubtitleFilled as MGCIcon,
  mgcIconTable3Filled as MGCIcon,
  mgcIconTableFilled as MGCIcon,
  mgcIconText2Filled as MGCIcon,
  mgcIconTextAreaFilled as MGCIcon,
  mgcIconTextColorFilled as MGCIcon,
  mgcIconTextDirectionLeftFilled as MGCIcon,
  mgcIconTextDirectionRightFilled as MGCIcon,
  mgcIconTextFilled as MGCIcon,
  mgcIconTextboxAiFilled as MGCIcon,
  mgcIconTextboxFilled as MGCIcon,
  mgcIconTranslate2AiFilled as MGCIcon,
  mgcIconTranslate2Filled as MGCIcon,
  mgcIconTranslateFilled as MGCIcon,
  mgcIconUnderlineFilled as MGCIcon,
  mgcIconZaSortAscendingLettersFilled as MGCIcon,
  mgcIconZaSortDescendingLettersFilled as MGCIcon,
  mgcIconBackpackFilled as MGCIcon,
  mgcIconBalanceFilled as MGCIcon,
  mgcIconBlackBoard2Filled as MGCIcon,
  mgcIconBlackBoardFilled as MGCIcon,
  mgcIconBook2Filled as MGCIcon,
  mgcIconBook3Filled as MGCIcon,
  mgcIconBook4Filled as MGCIcon,
  mgcIconBook5Filled as MGCIcon,
  mgcIconBook6Filled as MGCIcon,
  mgcIconBookFilled as MGCIcon,
  mgcIconBookmarkAddFilled as MGCIcon,
  mgcIconBookmarkEditFilled as MGCIcon,
  mgcIconBookmarkFilled as MGCIcon,
  mgcIconBookmarkRemoveFilled as MGCIcon,
  mgcIconBookmarksFilled as MGCIcon,
  mgcIconCertificate2Filled as MGCIcon,
  mgcIconCompass2Filled as MGCIcon,
  mgcIconCounterFilled as MGCIcon,
  mgcIconDeskFilled as MGCIcon,
  mgcIconDiaryFilled as MGCIcon,
  mgcIconDrumFilled as MGCIcon,
  mgcIconEyeglassFilled as MGCIcon,
  mgcIconFlask2Filled as MGCIcon,
  mgcIconFlask3Filled as MGCIcon,
  mgcIconFlaskFilled as MGCIcon,
  mgcIconFoldingFanFilled as MGCIcon,
  mgcIconGlobeFilled as MGCIcon,
  mgcIconMagnetFilled as MGCIcon,
  mgcIconMortarboardFilled as MGCIcon,
  mgcIconNotebook2Filled as MGCIcon,
  mgcIconNotebookFilled as MGCIcon,
  mgcIconScienceFilled as MGCIcon,
  mgcIconSpeechFilled as MGCIcon,
  mgcIconTestTubeFilled as MGCIcon,
  mgcIconAngelFilled as MGCIcon,
  mgcIconAngryFilled as MGCIcon,
  mgcIconConfusedFilled as MGCIcon,
  mgcIconEmoji2Filled as MGCIcon,
  mgcIconEmojiFilled as MGCIcon,
  mgcIconHappyFilled as MGCIcon,
  mgcIconLaughFilled as MGCIcon,
  mgcIconLookDownFilled as MGCIcon,
  mgcIconLookLeftFilled as MGCIcon,
  mgcIconLookRightFilled as MGCIcon,
  mgcIconLookUpFilled as MGCIcon,
  mgcIconOmgFilled as MGCIcon,
  mgcIconPuzzledFilled as MGCIcon,
  mgcIconSadFilled as MGCIcon,
  mgcIconSickFilled as MGCIcon,
  mgcIconSilentFilled as MGCIcon,
  mgcIconSobFilled as MGCIcon,
  mgcIconSurpriseFilled as MGCIcon,
  mgcIconSweatsFilled as MGCIcon,
  mgcIconTerrorFilled as MGCIcon,
  mgcIconTongueFilled as MGCIcon,
  mgcIconUnhappyDizzyFilled as MGCIcon,
  mgcIconUnhappyFilled as MGCIcon,
  mgcIconAlbum2Filled as MGCIcon,
  mgcIconArchiveFilled as MGCIcon,
  mgcIconAttachment2Filled as MGCIcon,
  mgcIconAttachmentFilled as MGCIcon,
  mgcIconBill2Filled as MGCIcon,
  mgcIconBillFilled as MGCIcon,
  mgcIconBox2Filled as MGCIcon,
  mgcIconBox3Filled as MGCIcon,
  mgcIconBoxFilled as MGCIcon,
  mgcIconClipboardFilled as MGCIcon,
  mgcIconCopy2Filled as MGCIcon,
  mgcIconCopy3Filled as MGCIcon,
  mgcIconCopyFilled as MGCIcon,
  mgcIconDocFilled as MGCIcon,
  mgcIconDocmentFilled as MGCIcon,
  mgcIconDocument2Filled as MGCIcon,
  mgcIconDocument3Filled as MGCIcon,
  mgcIconDocumentsFilled as MGCIcon,
  mgcIconDownload2Filled as MGCIcon,
  mgcIconDownload3Filled as MGCIcon,
  mgcIconDownloadFilled as MGCIcon,
  mgcIconEmptyBoxFilled as MGCIcon,
  mgcIconExternalLinkFilled as MGCIcon,
  mgcIconFileCertificateFilled as MGCIcon,
  mgcIconFileCheckFilled as MGCIcon,
  mgcIconFileCodeFilled as MGCIcon,
  mgcIconFileDownloadFilled as MGCIcon,
  mgcIconFileExportFilled as MGCIcon,
  mgcIconFileFilled as MGCIcon,
  mgcIconFileForbidFilled as MGCIcon,
  mgcIconFileImportFilled as MGCIcon,
  mgcIconFileInfoFilled as MGCIcon,
  mgcIconFileLockedFilled as MGCIcon,
  mgcIconFileMoreFilled as MGCIcon,
  mgcIconFileMusicFilled as MGCIcon,
  mgcIconFileNewFilled as MGCIcon,
  mgcIconFileSearchFilled as MGCIcon,
  mgcIconFileSecurityFilled as MGCIcon,
  mgcIconFileStarFilled as MGCIcon,
  mgcIconFileUnknownFilled as MGCIcon,
  mgcIconFileUploadFilled as MGCIcon,
  mgcIconFileWarningFilled as MGCIcon,
  mgcIconFileZipFilled as MGCIcon,
  mgcIconFolder2Filled as MGCIcon,
  mgcIconFolder3Filled as MGCIcon,
  mgcIconFolderCheckFilled as MGCIcon,
  mgcIconFolderDeleteFilled as MGCIcon,
  mgcIconFolderDownloadFilled as MGCIcon,
  mgcIconFolderFilled as MGCIcon,
  mgcIconFolderForbidFilled as MGCIcon,
  mgcIconFolderInfoFilled as MGCIcon,
  mgcIconFolderLocked2Filled as MGCIcon,
  mgcIconFolderLockedFilled as MGCIcon,
  mgcIconFolderMinusFilled as MGCIcon,
  mgcIconFolderMoreFilled as MGCIcon,
  mgcIconFolderOpen2Filled as MGCIcon,
  mgcIconFolderOpenFilled as MGCIcon,
  mgcIconFolderSecurityFilled as MGCIcon,
  mgcIconFolderStarFilled as MGCIcon,
  mgcIconFolderUploadFilled as MGCIcon,
  mgcIconFolderWarningFilled as MGCIcon,
  mgcIconFolderZipFilled as MGCIcon,
  mgcIconFoldersFilled as MGCIcon,
  mgcIconInbox2Filled as MGCIcon,
  mgcIconInboxFilled as MGCIcon,
  mgcIconInventoryFilled as MGCIcon,
  mgcIconLink2Filled as MGCIcon,
  mgcIconLink3Filled as MGCIcon,
  mgcIconLinkFilled as MGCIcon,
  mgcIconMarkdownFilled as MGCIcon,
  mgcIconNewFolderFilled as MGCIcon,
  mgcIconNews2Filled as MGCIcon,
  mgcIconNewsFilled as MGCIcon,
  mgcIconPackage2Filled as MGCIcon,
  mgcIconPackageFilled as MGCIcon,
  mgcIconPaper2Filled as MGCIcon,
  mgcIconPaperFilled as MGCIcon,
  mgcIconPassportFilled as MGCIcon,
  mgcIconPasteFilled as MGCIcon,
  mgcIconPdfFilled as MGCIcon,
  mgcIconPhotoAlbum2Filled as MGCIcon,
  mgcIconPhotoAlbumFilled as MGCIcon,
  mgcIconPic2Filled as MGCIcon,
  mgcIconPicAiFilled as MGCIcon,
  mgcIconPicFilled as MGCIcon,
  mgcIconPin2Filled as MGCIcon,
  mgcIconPinFilled as MGCIcon,
  mgcIconPptFilled as MGCIcon,
  mgcIconProfileFilled as MGCIcon,
  mgcIconReportFormsFilled as MGCIcon,
  mgcIconSave2Filled as MGCIcon,
  mgcIconSaveFilled as MGCIcon,
  mgcIconSearch2Filled as MGCIcon,
  mgcIconSearch3Filled as MGCIcon,
  mgcIconSearchAiFilled as MGCIcon,
  mgcIconSearchFilled as MGCIcon,
  mgcIconTask2Filled as MGCIcon,
  mgcIconTaskFilled as MGCIcon,
  mgcIconToDoFilled as MGCIcon,
  mgcIconUnarchiveFilled as MGCIcon,
  mgcIconUnlink2Filled as MGCIcon,
  mgcIconUnlinkFilled as MGCIcon,
  mgcIconUpload2Filled as MGCIcon,
  mgcIconUpload3Filled as MGCIcon,
  mgcIconUploadFilled as MGCIcon,
  mgcIconXlsFilled as MGCIcon,
  mgcIconZoomInFilled as MGCIcon,
  mgcIconZoomOutFilled as MGCIcon,
  mgcIconBirthday2Filled as MGCIcon,
  mgcIconBoneFilled as MGCIcon,
  mgcIconBottleGlassFilled as MGCIcon,
  mgcIconBowl2Filled as MGCIcon,
  mgcIconBowlFilled as MGCIcon,
  mgcIconBreadFilled as MGCIcon,
  mgcIconCakeFilled as MGCIcon,
  mgcIconCandy2Filled as MGCIcon,
  mgcIconCandyFilled as MGCIcon,
  mgcIconCarrotFilled as MGCIcon,
  mgcIconChampagneFilled as MGCIcon,
  mgcIconChickenFilled as MGCIcon,
  mgcIconChopsticksFilled as MGCIcon,
  mgcIconCookieFilled as MGCIcon,
  mgcIconCookieManFilled as MGCIcon,
  mgcIconCupcakeFilled as MGCIcon,
  mgcIconDinnerFilled as MGCIcon,
  mgcIconDishCoverFilled as MGCIcon,
  mgcIconDonutFilled as MGCIcon,
  mgcIconDrinkFilled as MGCIcon,
  mgcIconEggCrackFilled as MGCIcon,
  mgcIconEggFilled as MGCIcon,
  mgcIconElectricCookerFilled as MGCIcon,
  mgcIconFeederFilled as MGCIcon,
  mgcIconFishFilled as MGCIcon,
  mgcIconForkFilled as MGCIcon,
  mgcIconForkKnifeFilled as MGCIcon,
  mgcIconForkSpoonFilled as MGCIcon,
  mgcIconFriedEggFilled as MGCIcon,
  mgcIconFriesFilled as MGCIcon,
  mgcIconGlassCupFilled as MGCIcon,
  mgcIconHamburgerFilled as MGCIcon,
  mgcIconIceCream2Filled as MGCIcon,
  mgcIconIceCreamFilled as MGCIcon,
  mgcIconLollipopFilled as MGCIcon,
  mgcIconPizzaFilled as MGCIcon,
  mgcIconSoupPot2Filled as MGCIcon,
  mgcIconSoupPotFilled as MGCIcon,
  mgcIconSpatulaFilled as MGCIcon,
  mgcIconSpoonFilled as MGCIcon,
  mgcIconSugarCoatedHawsFilled as MGCIcon,
  mgcIconTeacupFilled as MGCIcon,
  mgcIconWineFilled as MGCIcon,
  mgcIconWineglass2Filled as MGCIcon,
  mgcIconWineglassFilled as MGCIcon,
  mgcIconAirbnbFilled as MGCIcon,
  mgcIconAirdropFilled as MGCIcon,
  mgcIconAlipayFilled as MGCIcon,
  mgcIconAndroid2Filled as MGCIcon,
  mgcIconAndroidFilled as MGCIcon,
  mgcIconAppleFilled as MGCIcon,
  mgcIconAppleIntelligenceFilled as MGCIcon,
  mgcIconAppleIntelligenceFrameFilled as MGCIcon,
  mgcIconAppstoreFilled as MGCIcon,
  mgcIconArcBrowserFilled as MGCIcon,
  mgcIconBehanceFilled as MGCIcon,
  mgcIconBilibiliFilled as MGCIcon,
  mgcIconBlueskeySocialFilled as MGCIcon,
  mgcIconCarplayFilled as MGCIcon,
  mgcIconChromeFilled as MGCIcon,
  mgcIconCodepenFilled as MGCIcon,
  mgcIconCopilotFilled as MGCIcon,
  mgcIconDingtalkFilled as MGCIcon,
  mgcIconDiscordFilled as MGCIcon,
  mgcIconDribbbleFilled as MGCIcon,
  mgcIconDriveFilled as MGCIcon,
  mgcIconDropboxFilled as MGCIcon,
  mgcIconEdgeFilled as MGCIcon,
  mgcIconFacebookFilled as MGCIcon,
  mgcIconFigmaFilled as MGCIcon,
  mgcIconFirefoxFilled as MGCIcon,
  mgcIconFollowFilled as MGCIcon,
  mgcIconGitLabFilled as MGCIcon,
  mgcIconGithub2Filled as MGCIcon,
  mgcIconGithubFilled as MGCIcon,
  mgcIconGoogleFilled as MGCIcon,
  mgcIconGooglePlayFilled as MGCIcon,
  mgcIconGrokFilled as MGCIcon,
  mgcIconGumroadFilled as MGCIcon,
  mgcIconInstagramFilled as MGCIcon,
  mgcIconKakaoTalkFilled as MGCIcon,
  mgcIconLayersFilled as MGCIcon,
  mgcIconLemonSqueezyFilled as MGCIcon,
  mgcIconLineAppFilled as MGCIcon,
  mgcIconLinearFilled as MGCIcon,
  mgcIconLinkedinFilled as MGCIcon,
  mgcIconLinuxFilled as MGCIcon,
  mgcIconMastercardFilled as MGCIcon,
  mgcIconMastodonFilled as MGCIcon,
  mgcIconMediumFilled as MGCIcon,
  mgcIconMessengerFilled as MGCIcon,
  mgcIconMetaFilled as MGCIcon,
  mgcIconMingcuteFilled as MGCIcon,
  mgcIconMomentFilled as MGCIcon,
  mgcIconNeteaseMusicFilled as MGCIcon,
  mgcIconNfcFilled as MGCIcon,
  mgcIconNintendoSwitchFilled as MGCIcon,
  mgcIconNotionFilled as MGCIcon,
  mgcIconOpenaiFilled as MGCIcon,
  mgcIconPaypalFilled as MGCIcon,
  mgcIconPinterestFilled as MGCIcon,
  mgcIconQqFilled as MGCIcon,
  mgcIconReactFilled as MGCIcon,
  mgcIconRedditFilled as MGCIcon,
  mgcIconSafariFilled as MGCIcon,
  mgcIconSiriFilled as MGCIcon,
  mgcIconSiriFrameFilled as MGCIcon,
  mgcIconSnapchatFilled as MGCIcon,
  mgcIconSocialXFilled as MGCIcon,
  mgcIconSpotifyFilled as MGCIcon,
  mgcIconStripeFilled as MGCIcon,
  mgcIconTelegramFilled as MGCIcon,
  mgcIconThreadsFilled as MGCIcon,
  mgcIconTiktokFilled as MGCIcon,
  mgcIconTrelloBoardFilled as MGCIcon,
  mgcIconTwitterFilled as MGCIcon,
  mgcIconViberMessengerFilled as MGCIcon,
  mgcIconVisaFilled as MGCIcon,
  mgcIconVkontakteFilled as MGCIcon,
  mgcIconVscodeFilled as MGCIcon,
  mgcIconVueFilled as MGCIcon,
  mgcIconWechatFilled as MGCIcon,
  mgcIconWechatMiniprogramFilled as MGCIcon,
  mgcIconWechatPayFilled as MGCIcon,
  mgcIconWeiboFilled as MGCIcon,
  mgcIconWhatsappFilled as MGCIcon,
  mgcIconWindowsFilled as MGCIcon,
  mgcIconXboxFilled as MGCIcon,
  mgcIconYoutubeFilled as MGCIcon,
  mgcIconAiming2Filled as MGCIcon,
  mgcIconAimingFilled as MGCIcon,
  mgcIconAnchorFilled as MGCIcon,
  mgcIconBed2Filled as MGCIcon,
  mgcIconBedFilled as MGCIcon,
  mgcIconClock2Filled as MGCIcon,
  mgcIconClockFilled as MGCIcon,
  mgcIconCompass3Filled as MGCIcon,
  mgcIconCompassFilled as MGCIcon,
  mgcIconDirections2Filled as MGCIcon,
  mgcIconDirectionsFilled as MGCIcon,
  mgcIconEarth2Filled as MGCIcon,
  mgcIconEarth3Filled as MGCIcon,
  mgcIconEarthFilled as MGCIcon,
  mgcIconEarthLatitudeFilled as MGCIcon,
  mgcIconEarthLongitudeFilled as MGCIcon,
  mgcIconFootFilled as MGCIcon,
  mgcIconGlobe2Filled as MGCIcon,
  mgcIconHoursFilled as MGCIcon,
  mgcIconLifebuoyFilled as MGCIcon,
  mgcIconLiveLocationFilled as MGCIcon,
  mgcIconLocation2Filled as MGCIcon,
  mgcIconLocation3Filled as MGCIcon,
  mgcIconLocationFilled as MGCIcon,
  mgcIconMap2Filled as MGCIcon,
  mgcIconMapFilled as MGCIcon,
  mgcIconMapPinFilled as MGCIcon,
  mgcIconNavigationFilled as MGCIcon,
  mgcIconParkingFilled as MGCIcon,
  mgcIconPlanetFilled as MGCIcon,
  mgcIconRestAreaFilled as MGCIcon,
  mgcIconRoadFilled as MGCIcon,
  mgcIconRouteFilled as MGCIcon,
  mgcIconTrafficConeFilled as MGCIcon,
  mgcIconTunnelFilled as MGCIcon,
  mgcIconUmbrella2Filled as MGCIcon,
  mgcIconWorld2Filled as MGCIcon,
  mgcIconWorldFilled as MGCIcon,
  mgcIconAirpodsFilled as MGCIcon,
  mgcIconAlbumFilled as MGCIcon,
  mgcIconAnnouncementFilled as MGCIcon,
  mgcIconAudioTapeFilled as MGCIcon,
  mgcIconBellRingingFilled as MGCIcon,
  mgcIconCamcorder3Filled as MGCIcon,
  mgcIconCamcorderFilled as MGCIcon,
  mgcIconCamcorderOffFilled as MGCIcon,
  mgcIconCamera2AiFilled as MGCIcon,
  mgcIconCamera2Filled as MGCIcon,
  mgcIconCamera2OffFilled as MGCIcon,
  mgcIconCameraFilled as MGCIcon,
  mgcIconCameraRotateFilled as MGCIcon,
  mgcIconClapperboardFilled as MGCIcon,
  mgcIconDanmakuFilled as MGCIcon,
  mgcIconDanmakuOffFilled as MGCIcon,
  mgcIconDanmakuOnFilled as MGCIcon,
  mgcIconDiscFilled as MGCIcon,
  mgcIconExpandPlayerFilled as MGCIcon,
  mgcIconFastForwardFilled as MGCIcon,
  mgcIconFastRewindFilled as MGCIcon,
  mgcIconFilmFilled as MGCIcon,
  mgcIconFullscreenExitFilled as MGCIcon,
  mgcIconFullscreenFilled as MGCIcon,
  mgcIconHeadphone2Filled as MGCIcon,
  mgcIconHeadphoneFilled as MGCIcon,
  mgcIconHorn2Filled as MGCIcon,
  mgcIconHornFilled as MGCIcon,
  mgcIconLiveFilled as MGCIcon,
  mgcIconLivePhotoFilled as MGCIcon,
  mgcIconMic2Filled as MGCIcon,
  mgcIconMicAiFilled as MGCIcon,
  mgcIconMicFilled as MGCIcon,
  mgcIconMicOffFilled as MGCIcon,
  mgcIconMicrophoneFilled as MGCIcon,
  mgcIconMiniplayerFilled as MGCIcon,
  mgcIconMovieFilled as MGCIcon,
  mgcIconMusic2AiFilled as MGCIcon,
  mgcIconMusic2Filled as MGCIcon,
  mgcIconMusic3Filled as MGCIcon,
  mgcIconMusicFilled as MGCIcon,
  mgcIconNotificationFilled as MGCIcon,
  mgcIconNotificationNewdotFilled as MGCIcon,
  mgcIconNotificationOffFilled as MGCIcon,
  mgcIconPauseCircleFilled as MGCIcon,
  mgcIconPauseFilled as MGCIcon,
  mgcIconPlayCircleFilled as MGCIcon,
  mgcIconPlayFilled as MGCIcon,
  mgcIconPlaylist2Filled as MGCIcon,
  mgcIconPlaylistFilled as MGCIcon,
  mgcIconRecordMailFilled as MGCIcon,
  mgcIconRepeatFilled as MGCIcon,
  mgcIconRepeatOneFilled as MGCIcon,
  mgcIconRewindBackward10Filled as MGCIcon,
  mgcIconRewindBackward15Filled as MGCIcon,
  mgcIconRewindBackward30Filled as MGCIcon,
  mgcIconRewindBackward5Filled as MGCIcon,
  mgcIconRewindBackwardSquare10Filled as MGCIcon,
  mgcIconRewindBackwardSquare15Filled as MGCIcon,
  mgcIconRewindBackwardSquare30Filled as MGCIcon,
  mgcIconRewindBackwardSquare5Filled as MGCIcon,
  mgcIconRewindForward10Filled as MGCIcon,
  mgcIconRewindForward15Filled as MGCIcon,
  mgcIconRewindForward30Filled as MGCIcon,
  mgcIconRewindForward5Filled as MGCIcon,
  mgcIconRewindForwardSquare10Filled as MGCIcon,
  mgcIconRewindForwardSquare15Filled as MGCIcon,
  mgcIconRewindForwardSquare30Filled as MGCIcon,
  mgcIconRewindForwardSquare5Filled as MGCIcon,
  mgcIconRotateToHorizontalFilled as MGCIcon,
  mgcIconRotateToVerticalFilled as MGCIcon,
  mgcIconServiceFilled as MGCIcon,
  mgcIconShuffle2Filled as MGCIcon,
  mgcIconShuffleFilled as MGCIcon,
  mgcIconSkipForwardFilled as MGCIcon,
  mgcIconSkipPreviousFilled as MGCIcon,
  mgcIconSoundLineFilled as MGCIcon,
  mgcIconStopCircleFilled as MGCIcon,
  mgcIconStopFilled as MGCIcon,
  mgcIconVideoCamera2Filled as MGCIcon,
  mgcIconVideoCameraFilled as MGCIcon,
  mgcIconVideoFilled as MGCIcon,
  mgcIconVoice2Filled as MGCIcon,
  mgcIconVoiceFilled as MGCIcon,
  mgcIconVolumeFilled as MGCIcon,
  mgcIconVolumeMuteFilled as MGCIcon,
  mgcIconVolumeOffFilled as MGCIcon,
  mgcIconBearFilled as MGCIcon,
  mgcIconBirdFilled as MGCIcon,
  mgcIconButterfly2Filled as MGCIcon,
  mgcIconButterflyFilled as MGCIcon,
  mgcIconCactus2Filled as MGCIcon,
  mgcIconCactusFilled as MGCIcon,
  mgcIconCampfireFilled as MGCIcon,
  mgcIconCatFilled as MGCIcon,
  mgcIconChessFilled as MGCIcon,
  mgcIconDandelionFilled as MGCIcon,
  mgcIconDogFilled as MGCIcon,
  mgcIconDragonflyFilled as MGCIcon,
  mgcIconFlower2Filled as MGCIcon,
  mgcIconFlower3Filled as MGCIcon,
  mgcIconFlower4Filled as MGCIcon,
  mgcIconFlower5Filled as MGCIcon,
  mgcIconFlowerFilled as MGCIcon,
  mgcIconFlowerpotFilled as MGCIcon,
  mgcIconGrassFilled as MGCIcon,
  mgcIconLeaf2Filled as MGCIcon,
  mgcIconLeaf3Filled as MGCIcon,
  mgcIconLeafFilled as MGCIcon,
  mgcIconLotusFilled as MGCIcon,
  mgcIconMapleLeafFilled as MGCIcon,
  mgcIconMickeymouseFilled as MGCIcon,
  mgcIconMountain2Filled as MGCIcon,
  mgcIconMountainFilled as MGCIcon,
  mgcIconMushroomFilled as MGCIcon,
  mgcIconPawFilled as MGCIcon,
  mgcIconPigFilled as MGCIcon,
  mgcIconPumpkinFilled as MGCIcon,
  mgcIconRabbitFilled as MGCIcon,
  mgcIconSunflowerFilled as MGCIcon,
  mgcIconToyHorseFilled as MGCIcon,
  mgcIconTree2Filled as MGCIcon,
  mgcIconTree3Filled as MGCIcon,
  mgcIconTree4Filled as MGCIcon,
  mgcIconTreeFilled as MGCIcon,
  mgcIconWreathFilled as MGCIcon,
  mgcIconAxeFilled as MGCIcon,
  mgcIconBalloon2Filled as MGCIcon,
  mgcIconBathFilled as MGCIcon,
  mgcIconBesideTable2Filled as MGCIcon,
  mgcIconBesideTableFilled as MGCIcon,
  mgcIconBlessingFilled as MGCIcon,
  mgcIconBombFilled as MGCIcon,
  mgcIconBoomFilled as MGCIcon,
  mgcIconBottleFilled as MGCIcon,
  mgcIconCapsuleFilled as MGCIcon,
  mgcIconCoathangerFilled as MGCIcon,
  mgcIconCross2Filled as MGCIcon,
  mgcIconCrystalBallFilled as MGCIcon,
  mgcIconCurtainFilled as MGCIcon,
  mgcIconDrawer2Filled as MGCIcon,
  mgcIconDrawerFilled as MGCIcon,
  mgcIconFaceMaskFilled as MGCIcon,
  mgcIconFirecrackerFilled as MGCIcon,
  mgcIconFireworkFilled as MGCIcon,
  mgcIconFirstAidKitFilled as MGCIcon,
  mgcIconHammerFilled as MGCIcon,
  mgcIconHandCardFilled as MGCIcon,
  mgcIconHandHeartFilled as MGCIcon,
  mgcIconHoeFilled as MGCIcon,
  mgcIconInjectionFilled as MGCIcon,
  mgcIconKiteFilled as MGCIcon,
  mgcIconLipstickFilled as MGCIcon,
  mgcIconNurseFilled as MGCIcon,
  mgcIconParfumFilled as MGCIcon,
  mgcIconPickaxFilled as MGCIcon,
  mgcIconPotFilled as MGCIcon,
  mgcIconPrescriptionFilled as MGCIcon,
  mgcIconRakeFilled as MGCIcon,
  mgcIconRandomFilled as MGCIcon,
  mgcIconScrewdriverFilled as MGCIcon,
  mgcIconShovelFilled as MGCIcon,
  mgcIconShowerGelFilled as MGCIcon,
  mgcIconStar2Filled as MGCIcon,
  mgcIconStarTopperFilled as MGCIcon,
  mgcIconStethoscopeFilled as MGCIcon,
  mgcIconThoughtFilled as MGCIcon,
  mgcIconToiletPaperFilled as MGCIcon,
  mgcIconVirusFilled as MGCIcon,
  mgcIconWardrobe2Filled as MGCIcon,
  mgcIconWardrobeFilled as MGCIcon,
  mgcIconWateringCanFilled as MGCIcon,
  mgcIconYinyangFilled as MGCIcon,
  mgcIconBabyFilled as MGCIcon,
  mgcIconBeardFilled as MGCIcon,
  mgcIconBodyFilled as MGCIcon,
  mgcIconBowTieFilled as MGCIcon,
  mgcIconBowknotFilled as MGCIcon,
  mgcIconBrainFilled as MGCIcon,
  mgcIconBriefFilled as MGCIcon,
  mgcIconChefHatFilled as MGCIcon,
  mgcIconChristmasHatFilled as MGCIcon,
  mgcIconCoatFilled as MGCIcon,
  mgcIconDeerFilled as MGCIcon,
  mgcIconDentalFilled as MGCIcon,
  mgcIconDressFilled as MGCIcon,
  mgcIconEarFilled as MGCIcon,
  mgcIconEye2Filled as MGCIcon,
  mgcIconEyebrowFilled as MGCIcon,
  mgcIconFaceFilled as MGCIcon,
  mgcIconFatherChristmasFilled as MGCIcon,
  mgcIconFingerPressFilled as MGCIcon,
  mgcIconFingerRockFilled as MGCIcon,
  mgcIconFingerSwipeFilled as MGCIcon,
  mgcIconFingerTapFilled as MGCIcon,
  mgcIconGloveFilled as MGCIcon,
  mgcIconHair2Filled as MGCIcon,
  mgcIconHairFilled as MGCIcon,
  mgcIconHandFilled as MGCIcon,
  mgcIconHandFinger2Filled as MGCIcon,
  mgcIconHandFingerFilled as MGCIcon,
  mgcIconHandGrabFilled as MGCIcon,
  mgcIconHandTwoFingersFilled as MGCIcon,
  mgcIconHandsClappingFilled as MGCIcon,
  mgcIconHat2Filled as MGCIcon,
  mgcIconHatFilled as MGCIcon,
  mgcIconHeadFilled as MGCIcon,
  mgcIconHeartHandFilled as MGCIcon,
  mgcIconHeartbeat2Filled as MGCIcon,
  mgcIconIncognitoModeFilled as MGCIcon,
  mgcIconLoveFilled as MGCIcon,
  mgcIconLungsFilled as MGCIcon,
  mgcIconMiddleFingerFilled as MGCIcon,
  mgcIconMouthFilled as MGCIcon,
  mgcIconNecktieFilled as MGCIcon,
  mgcIconNoseFilled as MGCIcon,
  mgcIconPrayFilled as MGCIcon,
  mgcIconScarfFilled as MGCIcon,
  mgcIconShirtFilled as MGCIcon,
  mgcIconShoe2Filled as MGCIcon,
  mgcIconShoeFilled as MGCIcon,
  mgcIconShortsFilled as MGCIcon,
  mgcIconSkirtFilled as MGCIcon,
  mgcIconSkullFilled as MGCIcon,
  mgcIconSockFilled as MGCIcon,
  mgcIconTShirt2Filled as MGCIcon,
  mgcIconTrouserFilled as MGCIcon,
  mgcIconVestFilled as MGCIcon,
  mgcIconClubsFilled as MGCIcon,
  mgcIconCylinder2Filled as MGCIcon,
  mgcIconCylinderFilled as MGCIcon,
  mgcIconDiamondFilled as MGCIcon,
  mgcIconDiamondSquareFilled as MGCIcon,
  mgcIconHeartCrackFilled as MGCIcon,
  mgcIconHeartFilled as MGCIcon,
  mgcIconHeartHalfFilled as MGCIcon,
  mgcIconHemisphere2Filled as MGCIcon,
  mgcIconHemisphereFilled as MGCIcon,
  mgcIconHexagonFilled as MGCIcon,
  mgcIconLineFilled as MGCIcon,
  mgcIconOctagonFilled as MGCIcon,
  mgcIconPentagonFilled as MGCIcon,
  mgcIconRectangleFilled as MGCIcon,
  mgcIconRectangleVerticalFilled as MGCIcon,
  mgcIconRoundFilled as MGCIcon,
  mgcIconSectorFilled as MGCIcon,
  mgcIconShieldShapeFilled as MGCIcon,
  mgcIconSpadeFilled as MGCIcon,
  mgcIconSquareFilled as MGCIcon,
  mgcIconStarFilled as MGCIcon,
  mgcIconStarHalfFilled as MGCIcon,
  mgcIconTriangleFilled as MGCIcon,
  mgcIconAirBalloonFilled as MGCIcon,
  mgcIconAmericanFootballFilled as MGCIcon,
  mgcIconBackboardFilled as MGCIcon,
  mgcIconBadmintonFilled as MGCIcon,
  mgcIconBarbellFilled as MGCIcon,
  mgcIconBaseball2Filled as MGCIcon,
  mgcIconBaseballFilled as MGCIcon,
  mgcIconBasketballFilled as MGCIcon,
  mgcIconBeachballFilled as MGCIcon,
  mgcIconDisabled2Filled as MGCIcon,
  mgcIconDisabledFilled as MGCIcon,
  mgcIconFitnessFilled as MGCIcon,
  mgcIconFootballFilled as MGCIcon,
  mgcIconParachuteFilled as MGCIcon,
  mgcIconPingpongFilled as MGCIcon,
  mgcIconPlaygroundFilled as MGCIcon,
  mgcIconRidingFilled as MGCIcon,
  mgcIconRunFilled as MGCIcon,
  mgcIconSkateboardFilled as MGCIcon,
  mgcIconSurfboardFilled as MGCIcon,
  mgcIconSwimmingPoolFilled as MGCIcon,
  mgcIconSwordFilled as MGCIcon,
  mgcIconToxophilyFilled as MGCIcon,
  mgcIconVolleyballFilled as MGCIcon,
  mgcIconWalkFilled as MGCIcon,
  mgcIconWheelchairFilled as MGCIcon,
  mgcIconWhistleFilled as MGCIcon,
  mgcIconAddCircleFilled as MGCIcon,
  mgcIconAddFilled as MGCIcon,
  mgcIconAddSquareFilled as MGCIcon,
  mgcIconAlertDiamondFilled as MGCIcon,
  mgcIconAlertFilled as MGCIcon,
  mgcIconAlertOctagonFilled as MGCIcon,
  mgcIconBroomFilled as MGCIcon,
  mgcIconBrush3Filled as MGCIcon,
  mgcIconBrushFilled as MGCIcon,
  mgcIconBubbleFilled as MGCIcon,
  mgcIconCertificateFilled as MGCIcon,
  mgcIconCheck2Filled as MGCIcon,
  mgcIconCheckCircleFilled as MGCIcon,
  mgcIconCheckFilled as MGCIcon,
  mgcIconCheckboxFilled as MGCIcon,
  mgcIconChecksFilled as MGCIcon,
  mgcIconChoiceFilled as MGCIcon,
  mgcIconClassify2Filled as MGCIcon,
  mgcIconClassify3Filled as MGCIcon,
  mgcIconClassifyAdd2Filled as MGCIcon,
  mgcIconClassifyAddFilled as MGCIcon,
  mgcIconClassifyFilled as MGCIcon,
  mgcIconCloseCircleFilled as MGCIcon,
  mgcIconCloseFilled as MGCIcon,
  mgcIconCloseSquareFilled as MGCIcon,
  mgcIconCrossFilled as MGCIcon,
  mgcIconCrutchFilled as MGCIcon,
  mgcIconCubeFilled as MGCIcon,
  mgcIconDelete2Filled as MGCIcon,
  mgcIconDelete3Filled as MGCIcon,
  mgcIconDeleteBackFilled as MGCIcon,
  mgcIconDeleteFilled as MGCIcon,
  mgcIconDirectionDotFilled as MGCIcon,
  mgcIconDoorFilled as MGCIcon,
  mgcIconDotGridFilled as MGCIcon,
  mgcIconDotsFilled as MGCIcon,
  mgcIconDotsVerticalFilled as MGCIcon,
  mgcIconEnterDoorFilled as MGCIcon,
  mgcIconEntranceFilled as MGCIcon,
  mgcIconExitDoorFilled as MGCIcon,
  mgcIconExitFilled as MGCIcon,
  mgcIconEyeCloseFilled as MGCIcon,
  mgcIconEyeFilled as MGCIcon,
  mgcIconFaceidFilled as MGCIcon,
  mgcIconFaultFilled as MGCIcon,
  mgcIconFilter2Filled as MGCIcon,
  mgcIconFingerprint2Filled as MGCIcon,
  mgcIconFingerprintFilled as MGCIcon,
  mgcIconFireFilled as MGCIcon,
  mgcIconFlameFilled as MGCIcon,
  mgcIconForbidCircleFilled as MGCIcon,
  mgcIconGestureUnlockFilled as MGCIcon,
  mgcIconGhostFilled as MGCIcon,
  mgcIconGrid2Filled as MGCIcon,
  mgcIconGridFilled as MGCIcon,
  mgcIconHeartbeatFilled as MGCIcon,
  mgcIconHexagons2Filled as MGCIcon,
  mgcIconHexagonsFilled as MGCIcon,
  mgcIconHistory2Filled as MGCIcon,
  mgcIconHistoryAnticlockwiseFilled as MGCIcon,
  mgcIconHistoryFilled as MGCIcon,
  mgcIconInformationFilled as MGCIcon,
  mgcIconKey1Filled as MGCIcon,
  mgcIconKey2Filled as MGCIcon,
  mgcIconKeyholeFilled as MGCIcon,
  mgcIconLoading2Filled as MGCIcon,
  mgcIconLoading3Filled as MGCIcon,
  mgcIconLoading4Filled as MGCIcon,
  mgcIconLoadingFilled as MGCIcon,
  mgcIconLockFilled as MGCIcon,
  mgcIconMindMapFilled as MGCIcon,
  mgcIconMinimizeFilled as MGCIcon,
  mgcIconMinusCircleFilled as MGCIcon,
  mgcIconMinusSquareFilled as MGCIcon,
  mgcIconMore1Filled as MGCIcon,
  mgcIconMore2Filled as MGCIcon,
  mgcIconMore3Filled as MGCIcon,
  mgcIconMore4Filled as MGCIcon,
  mgcIconMultiselectFilled as MGCIcon,
  mgcIconNewdotFilled as MGCIcon,
  mgcIconOpenDoorFilled as MGCIcon,
  mgcIconPlusFilled as MGCIcon,
  mgcIconPolygonFilled as MGCIcon,
  mgcIconPowerFilled as MGCIcon,
  mgcIconProcessFilled as MGCIcon,
  mgcIconQuestionFilled as MGCIcon,
  mgcIconRadioboxFilled as MGCIcon,
  mgcIconRecycleFilled as MGCIcon,
  mgcIconRefresh1Filled as MGCIcon,
  mgcIconRefresh2Filled as MGCIcon,
  mgcIconRefresh3Filled as MGCIcon,
  mgcIconRefresh4AiFilled as MGCIcon,
  mgcIconRefresh4Filled as MGCIcon,
  mgcIconRefreshAnticlockwise1Filled as MGCIcon,
  mgcIconReportFilled as MGCIcon,
  mgcIconRestoreFilled as MGCIcon,
  mgcIconSafeAlertFilled as MGCIcon,
  mgcIconSafeFlashFilled as MGCIcon,
  mgcIconSafeLockFilled as MGCIcon,
  mgcIconSafeShield2Filled as MGCIcon,
  mgcIconSafeShieldFilled as MGCIcon,
  mgcIconSafetyCertificateFilled as MGCIcon,
  mgcIconSettings1Filled as MGCIcon,
  mgcIconSettings2Filled as MGCIcon,
  mgcIconSettings3Filled as MGCIcon,
  mgcIconSettings4Filled as MGCIcon,
  mgcIconSettings5Filled as MGCIcon,
  mgcIconSettings6Filled as MGCIcon,
  mgcIconSettings7Filled as MGCIcon,
  mgcIconShare2Filled as MGCIcon,
  mgcIconShare3Filled as MGCIcon,
  mgcIconShareForwardFilled as MGCIcon,
  mgcIconShieldFilled as MGCIcon,
  mgcIconSleepFilled as MGCIcon,
  mgcIconSwitchFilled as MGCIcon,
  mgcIconTShirtFilled as MGCIcon,
  mgcIconThreeCirclesFilled as MGCIcon,
  mgcIconThumbDown2Filled as MGCIcon,
  mgcIconThumbDownFilled as MGCIcon,
  mgcIconThumbUp2Filled as MGCIcon,
  mgcIconThumbUpFilled as MGCIcon,
  mgcIconTimeDurationFilled as MGCIcon,
  mgcIconTimeFilled as MGCIcon,
  mgcIconTimelineFilled as MGCIcon,
  mgcIconToggleLeft2Filled as MGCIcon,
  mgcIconToggleLeftFilled as MGCIcon,
  mgcIconToggleRight2Filled as MGCIcon,
  mgcIconToggleRightFilled as MGCIcon,
  mgcIconToolFilled as MGCIcon,
  mgcIconTransformationFilled as MGCIcon,
  mgcIconUnlockFilled as MGCIcon,
  mgcIconVersionFilled as MGCIcon,
  mgcIconWarningFilled as MGCIcon,
  mgcIconWastebasketFilled as MGCIcon,
  mgcIconWebhookFilled as MGCIcon,
  mgcIconAbsFilled as MGCIcon,
  mgcIconAerialLiftFilled as MGCIcon,
  mgcIconAirplaneFilled as MGCIcon,
  mgcIconAutoHoldFilled as MGCIcon,
  mgcIconBabyCarriageFilled as MGCIcon,
  mgcIconBikeFilled as MGCIcon,
  mgcIconBrakeFilled as MGCIcon,
  mgcIconBus2Filled as MGCIcon,
  mgcIconBusFilled as MGCIcon,
  mgcIconCar2Filled as MGCIcon,
  mgcIconCar3Filled as MGCIcon,
  mgcIconCarDoorFilled as MGCIcon,
  mgcIconCarFilled as MGCIcon,
  mgcIconCarWindowFilled as MGCIcon,
  mgcIconChargingPileFilled as MGCIcon,
  mgcIconEbikeFilled as MGCIcon,
  mgcIconEmergencyFlashersFilled as MGCIcon,
  mgcIconEngineFilled as MGCIcon,
  mgcIconFan2Filled as MGCIcon,
  mgcIconFanDirectionDownFilled as MGCIcon,
  mgcIconFanDirectionFrontFilled as MGCIcon,
  mgcIconFanDirectionUpFilled as MGCIcon,
  mgcIconFanFilled as MGCIcon,
  mgcIconFlightInflightFilled as MGCIcon,
  mgcIconFlightLandFilled as MGCIcon,
  mgcIconFlightTakeoffFilled as MGCIcon,
  mgcIconFourWheelDriveFilled as MGCIcon,
  mgcIconFrontFogLightsFilled as MGCIcon,
  mgcIconFrontWindshieldDefrosterFilled as MGCIcon,
  mgcIconGasStationFilled as MGCIcon,
  mgcIconHightBeamHeadlightsFilled as MGCIcon,
  mgcIconHoodFilled as MGCIcon,
  mgcIconJeepFilled as MGCIcon,
  mgcIconLowBeamHeadlightsFilled as MGCIcon,
  mgcIconOilFilled as MGCIcon,
  mgcIconParkFilled as MGCIcon,
  mgcIconParkingLightsFilled as MGCIcon,
  mgcIconPinwheel2Filled as MGCIcon,
  mgcIconPinwheelFilled as MGCIcon,
  mgcIconRareFogLightsFilled as MGCIcon,
  mgcIconRearWindshieldDefrosterFilled as MGCIcon,
  mgcIconRocket2Filled as MGCIcon,
  mgcIconRocketFilled as MGCIcon,
  mgcIconRudderFilled as MGCIcon,
  mgcIconSailboatFilled as MGCIcon,
  mgcIconScooterFilled as MGCIcon,
  mgcIconSeatFilled as MGCIcon,
  mgcIconSeatHeatedFilled as MGCIcon,
  mgcIconShipFilled as MGCIcon,
  mgcIconSleighFilled as MGCIcon,
  mgcIconSteeringWheelFilled as MGCIcon,
  mgcIconTankFilled as MGCIcon,
  mgcIconTrafficLightsFilled as MGCIcon,
  mgcIconTrain2Filled as MGCIcon,
  mgcIconTrain3Filled as MGCIcon,
  mgcIconTrain4Filled as MGCIcon,
  mgcIconTrainFilled as MGCIcon,
  mgcIconTruckFilled as MGCIcon,
  mgcIconTrunkFilled as MGCIcon,
  mgcIconTyreFilled as MGCIcon,
  mgcIconUfo2Filled as MGCIcon,
  mgcIconUfoFilled as MGCIcon,
  mgcIconWheelFilled as MGCIcon,
  mgcIconWiperFilled as MGCIcon,
  mgcIconBadgeFilled as MGCIcon,
  mgcIconContacts2Filled as MGCIcon,
  mgcIconContacts3Filled as MGCIcon,
  mgcIconContacts4Filled as MGCIcon,
  mgcIconContactsFilled as MGCIcon,
  mgcIconFemaleFilled as MGCIcon,
  mgcIconGroup2Filled as MGCIcon,
  mgcIconGroup3Filled as MGCIcon,
  mgcIconGroupFilled as MGCIcon,
  mgcIconIDcardFilled as MGCIcon,
  mgcIconMaleFilled as MGCIcon,
  mgcIconUser1Filled as MGCIcon,
  mgcIconUser2Filled as MGCIcon,
  mgcIconUser3Filled as MGCIcon,
  mgcIconUser4Filled as MGCIcon,
  mgcIconUser5Filled as MGCIcon,
  mgcIconUserAdd2Filled as MGCIcon,
  mgcIconUserAddFilled as MGCIcon,
  mgcIconUserEditFilled as MGCIcon,
  mgcIconUserFollow2Filled as MGCIcon,
  mgcIconUserFollowFilled as MGCIcon,
  mgcIconUserForbidFilled as MGCIcon,
  mgcIconUserHeartFilled as MGCIcon,
  mgcIconUserHideFilled as MGCIcon,
  mgcIconUserInfoFilled as MGCIcon,
  mgcIconUserLockFilled as MGCIcon,
  mgcIconUserPinFilled as MGCIcon,
  mgcIconUserQuestionFilled as MGCIcon,
  mgcIconUserRemove2Filled as MGCIcon,
  mgcIconUserRemoveFilled as MGCIcon,
  mgcIconUserSearchFilled as MGCIcon,
  mgcIconUserSecurityFilled as MGCIcon,
  mgcIconUserSettingFilled as MGCIcon,
  mgcIconUserStarFilled as MGCIcon,
  mgcIconUserVisibleFilled as MGCIcon,
  mgcIconUserWarningFilled as MGCIcon,
  mgcIconUserXFilled as MGCIcon,
  mgcIconCelsiusFilled as MGCIcon,
  mgcIconCloud2Filled as MGCIcon,
  mgcIconCloudFilled as MGCIcon,
  mgcIconCloudLightningFilled as MGCIcon,
  mgcIconCloudSnowFilled as MGCIcon,
  mgcIconCloudWindyFilled as MGCIcon,
  mgcIconCloudsFilled as MGCIcon,
  mgcIconDrizzleFilled as MGCIcon,
  mgcIconDryFilled as MGCIcon,
  mgcIconFahrenheitFilled as MGCIcon,
  mgcIconFloatingDustFilled as MGCIcon,
  mgcIconFogFilled as MGCIcon,
  mgcIconFullMoonFilled as MGCIcon,
  mgcIconHailFilled as MGCIcon,
  mgcIconHazeFilled as MGCIcon,
  mgcIconHeavyRainFilled as MGCIcon,
  mgcIconHeavyRainstormFilled as MGCIcon,
  mgcIconHeavySnowFilled as MGCIcon,
  mgcIconHeavySnowstormFilled as MGCIcon,
  mgcIconHighTemperatureFilled as MGCIcon,
  mgcIconLightSnowFilled as MGCIcon,
  mgcIconLightningFilled as MGCIcon,
  mgcIconLowTemperatureFilled as MGCIcon,
  mgcIconModerateSnowFilled as MGCIcon,
  mgcIconMoonCloudyFilled as MGCIcon,
  mgcIconMoonFilled as MGCIcon,
  mgcIconMoonFogFilled as MGCIcon,
  mgcIconMoonStarsFilled as MGCIcon,
  mgcIconMoonlightFilled as MGCIcon,
  mgcIconNaFilled as MGCIcon,
  mgcIconPartlyCloudDaytimeFilled as MGCIcon,
  mgcIconPartlyCloudNightFilled as MGCIcon,
  mgcIconRainFilled as MGCIcon,
  mgcIconRainbowFilled as MGCIcon,
  mgcIconRainstormFilled as MGCIcon,
  mgcIconSandstormFilled as MGCIcon,
  mgcIconShowersFilled as MGCIcon,
  mgcIconSnowFilled as MGCIcon,
  mgcIconSnowflakeFilled as MGCIcon,
  mgcIconSnowmanFilled as MGCIcon,
  mgcIconSnowstorm2Filled as MGCIcon,
  mgcIconSnowstormFilled as MGCIcon,
  mgcIconSparkles2Filled as MGCIcon,
  mgcIconSparkles3Filled as MGCIcon,
  mgcIconSparklesFilled as MGCIcon,
  mgcIconSun2Filled as MGCIcon,
  mgcIconSunCloudyFilled as MGCIcon,
  mgcIconSunFilled as MGCIcon,
  mgcIconSunFogFilled as MGCIcon,
  mgcIconSunriseFilled as MGCIcon,
  mgcIconSunsetFilled as MGCIcon,
  mgcIconThermometerFilled as MGCIcon,
  mgcIconThunderstormFilled as MGCIcon,
  mgcIconTornado2Filled as MGCIcon,
  mgcIconTornadoFilled as MGCIcon,
  mgcIconTyphoonFilled as MGCIcon,
  mgcIconUmbrellaFilled as MGCIcon,
  mgcIconWaveFilled as MGCIcon,
  mgcIconWetFilled as MGCIcon,
  mgcIconWindFilled as MGCIcon,
  mgcIconAquariusFilled as MGCIcon,
  mgcIconAriesFilled as MGCIcon,
  mgcIconCancerFilled as MGCIcon,
  mgcIconCapricornFilled as MGCIcon,
  mgcIconGeminiFilled as MGCIcon,
  mgcIconLeoFilled as MGCIcon,
  mgcIconLibraFilled as MGCIcon,
  mgcIconPiscesFilled as MGCIcon,
  mgcIconSagittariusFilled as MGCIcon,
  mgcIconScorpioFilled as MGCIcon,
  mgcIconTaurusFilled as MGCIcon,
  mgcIconVirgoFilled as MGCIcon,
  mgcIconAlignArrowDownRegular as MGCIcon,
  mgcIconAlignArrowLeftRegular as MGCIcon,
  mgcIconAlignArrowRightRegular as MGCIcon,
  mgcIconAlignArrowUpRegular as MGCIcon,
  mgcIconArrowDownCircleRegular as MGCIcon,
  mgcIconArrowDownRegular as MGCIcon,
  mgcIconArrowLeftCircleRegular as MGCIcon,
  mgcIconArrowLeftDownCircleRegular as MGCIcon,
  mgcIconArrowLeftDownRegular as MGCIcon,
  mgcIconArrowLeftRegular as MGCIcon,
  mgcIconArrowLeftUpCircleRegular as MGCIcon,
  mgcIconArrowLeftUpRegular as MGCIcon,
  mgcIconArrowRightCircleRegular as MGCIcon,
  mgcIconArrowRightDownCircleRegular as MGCIcon,
  mgcIconArrowRightDownRegular as MGCIcon,
  mgcIconArrowRightRegular as MGCIcon,
  mgcIconArrowRightUpCircleRegular as MGCIcon,
  mgcIconArrowRightUpRegular as MGCIcon,
  mgcIconArrowToDownRegular as MGCIcon,
  mgcIconArrowToLeftRegular as MGCIcon,
  mgcIconArrowToRightRegular as MGCIcon,
  mgcIconArrowToUpRegular as MGCIcon,
  mgcIconArrowUpCircleRegular as MGCIcon,
  mgcIconArrowUpRegular as MGCIcon,
  mgcIconArrowsDownRegular as MGCIcon,
  mgcIconArrowsLeftRegular as MGCIcon,
  mgcIconArrowsRightRegular as MGCIcon,
  mgcIconArrowsUpRegular as MGCIcon,
  mgcIconBack2Regular as MGCIcon,
  mgcIconBackRegular as MGCIcon,
  mgcIconCornerDownLeftRegular as MGCIcon,
  mgcIconCornerDownRightRegular as MGCIcon,
  mgcIconCornerUpLeftRegular as MGCIcon,
  mgcIconCornerUpRightRegular as MGCIcon,
  mgcIconDirectionArrowRegular as MGCIcon,
  mgcIconDownRegular as MGCIcon,
  mgcIconDownSmallRegular as MGCIcon,
  mgcIconForward2Regular as MGCIcon,
  mgcIconForwardRegular as MGCIcon,
  mgcIconFullscreen2Regular as MGCIcon,
  mgcIconFullscreenExit2Regular as MGCIcon,
  mgcIconLargeArrowDownRegular as MGCIcon,
  mgcIconLargeArrowLeftRegular as MGCIcon,
  mgcIconLargeArrowRightRegular as MGCIcon,
  mgcIconLargeArrowUpRegular as MGCIcon,
  mgcIconLeftRegular as MGCIcon,
  mgcIconLeftSmallRegular as MGCIcon,
  mgcIconMoveRegular as MGCIcon,
  mgcIconRightRegular as MGCIcon,
  mgcIconRightSmallRegular as MGCIcon,
  mgcIconSelectorHorizontalRegular as MGCIcon,
  mgcIconSelectorVerticalRegular as MGCIcon,
  mgcIconSquareArrowDownRegular as MGCIcon,
  mgcIconSquareArrowLeftRegular as MGCIcon,
  mgcIconSquareArrowRightRegular as MGCIcon,
  mgcIconSquareArrowUpRegular as MGCIcon,
  mgcIconTransfer2Regular as MGCIcon,
  mgcIconTransfer3Regular as MGCIcon,
  mgcIconTransfer4Regular as MGCIcon,
  mgcIconTransferHorizontalRegular as MGCIcon,
  mgcIconTransferRegular as MGCIcon,
  mgcIconTransferVerticalRegular as MGCIcon,
  mgcIconTrendingDownRegular as MGCIcon,
  mgcIconTrendingUpRegular as MGCIcon,
  mgcIconUpRegular as MGCIcon,
  mgcIconUpSmallRegular as MGCIcon,
  mgcIconBankOfChinaTowerRegular as MGCIcon,
  mgcIconBankRegular as MGCIcon,
  mgcIconBigBenRegular as MGCIcon,
  mgcIconBridge2Regular as MGCIcon,
  mgcIconBridgeRegular as MGCIcon,
  mgcIconBuilding1Regular as MGCIcon,
  mgcIconBuilding2Regular as MGCIcon,
  mgcIconBuilding3Regular as MGCIcon,
  mgcIconBuilding4Regular as MGCIcon,
  mgcIconBuilding5Regular as MGCIcon,
  mgcIconBuilding6Regular as MGCIcon,
  mgcIconBurjAlArabRegular as MGCIcon,
  mgcIconBurjKhalifaTowerRegular as MGCIcon,
  mgcIconCampgroundRegular as MGCIcon,
  mgcIconCantonTowerRegular as MGCIcon,
  mgcIconChristTheRedeemerRegular as MGCIcon,
  mgcIconChurchRegular as MGCIcon,
  mgcIconDutchWindmillRegular as MGCIcon,
  mgcIconEgyptianPyramidsRegular as MGCIcon,
  mgcIconEiffelTowerRegular as MGCIcon,
  mgcIconFactory2Regular as MGCIcon,
  mgcIconFactoryRegular as MGCIcon,
  mgcIconFerrisWheelRegular as MGCIcon,
  mgcIconGovernmentRegular as MGCIcon,
  mgcIconGreatwallRegular as MGCIcon,
  mgcIconHome1Regular as MGCIcon,
  mgcIconHome2Regular as MGCIcon,
  mgcIconHome3Regular as MGCIcon,
  mgcIconHome4Regular as MGCIcon,
  mgcIconHome5Regular as MGCIcon,
  mgcIconHome6Regular as MGCIcon,
  mgcIconHome7Regular as MGCIcon,
  mgcIconHospitalRegular as MGCIcon,
  mgcIconHotelRegular as MGCIcon,
  mgcIconHouse2Regular as MGCIcon,
  mgcIconHouseRegular as MGCIcon,
  mgcIconKingkey100TowerRegular as MGCIcon,
  mgcIconLighthouseRegular as MGCIcon,
  mgcIconMarinaBaySandRegular as MGCIcon,
  mgcIconMayaPyramidsRegular as MGCIcon,
  mgcIconMiyajimaToriiRegular as MGCIcon,
  mgcIconMoaiRegular as MGCIcon,
  mgcIconMonumentRegular as MGCIcon,
  mgcIconPalaceRegular as MGCIcon,
  mgcIconPavilionRegular as MGCIcon,
  mgcIconPisaTowerRegular as MGCIcon,
  mgcIconSchoolRegular as MGCIcon,
  mgcIconShopRegular as MGCIcon,
  mgcIconStatueOfLibertyRegular as MGCIcon,
  mgcIconStore2Regular as MGCIcon,
  mgcIconStoreRegular as MGCIcon,
  mgcIconSydneyOperaHouseRegular as MGCIcon,
  mgcIconTaipei101Regular as MGCIcon,
  mgcIconTajMahalRegular as MGCIcon,
  mgcIconTempleOfHeavenRegular as MGCIcon,
  mgcIconTentRegular as MGCIcon,
  mgcIconTowerRegular as MGCIcon,
  mgcIconTriumphalArchRegular as MGCIcon,
  mgcIconTvTowerRegular as MGCIcon,
  mgcIconAdCircleOffRegular as MGCIcon,
  mgcIconAdCircleRegular as MGCIcon,
  mgcIconAdRectangleOffRegular as MGCIcon,
  mgcIconAdRectangleRegular as MGCIcon,
  mgcIconAnniversaryRegular as MGCIcon,
  mgcIconAuctionRegular as MGCIcon,
  mgcIconAwardRegular as MGCIcon,
  mgcIconBankCardRegular as MGCIcon,
  mgcIconBasket2Regular as MGCIcon,
  mgcIconBasketRegular as MGCIcon,
  mgcIconBriefcase2Regular as MGCIcon,
  mgcIconBriefcaseRegular as MGCIcon,
  mgcIconCalendar2Regular as MGCIcon,
  mgcIconCalendar3Regular as MGCIcon,
  mgcIconCalendarAddRegular as MGCIcon,
  mgcIconCalendarDayRegular as MGCIcon,
  mgcIconCalendarMonthRegular as MGCIcon,
  mgcIconCalendarRegular as MGCIcon,
  mgcIconCalendarTimeAddRegular as MGCIcon,
  mgcIconCalendarWeekRegular as MGCIcon,
  mgcIconCandleRegular as MGCIcon,
  mgcIconCandlesRegular as MGCIcon,
  mgcIconCardPayRegular as MGCIcon,
  mgcIconCardRefundRegular as MGCIcon,
  mgcIconCash2Regular as MGCIcon,
  mgcIconCashRegular as MGCIcon,
  mgcIconCelebrateRegular as MGCIcon,
  mgcIconChartBar2Regular as MGCIcon,
  mgcIconChartBarRegular as MGCIcon,
  mgcIconChartDecreaseRegular as MGCIcon,
  mgcIconChartHorizontalRegular as MGCIcon,
  mgcIconChartLineRegular as MGCIcon,
  mgcIconChartPie2Regular as MGCIcon,
  mgcIconChartPieRegular as MGCIcon,
  mgcIconChartVerticalRegular as MGCIcon,
  mgcIconChineseKnotRegular as MGCIcon,
  mgcIconChristmasBallRegular as MGCIcon,
  mgcIconCoin2Regular as MGCIcon,
  mgcIconCoin3Regular as MGCIcon,
  mgcIconCoinRegular as MGCIcon,
  mgcIconCopperCoinRegular as MGCIcon,
  mgcIconCopyrightRegular as MGCIcon,
  mgcIconCouponRegular as MGCIcon,
  mgcIconCurrencyBaht2Regular as MGCIcon,
  mgcIconCurrencyBahtRegular as MGCIcon,
  mgcIconCurrencyCny2Regular as MGCIcon,
  mgcIconCurrencyCnyRegular as MGCIcon,
  mgcIconCurrencyDollar2Regular as MGCIcon,
  mgcIconCurrencyDollarRegular as MGCIcon,
  mgcIconCurrencyEuro2Regular as MGCIcon,
  mgcIconCurrencyEuroRegular as MGCIcon,
  mgcIconCurrencyLira2Regular as MGCIcon,
  mgcIconCurrencyLiraRegular as MGCIcon,
  mgcIconCurrencyNigeria2Regular as MGCIcon,
  mgcIconCurrencyNigeriaRegular as MGCIcon,
  mgcIconCurrencyRubel2Regular as MGCIcon,
  mgcIconCurrencyRubelRegular as MGCIcon,
  mgcIconCurrencyRupee2Regular as MGCIcon,
  mgcIconCurrencyRupeeRegular as MGCIcon,
  mgcIconCurrencyShekel2Regular as MGCIcon,
  mgcIconCurrencyShekelRegular as MGCIcon,
  mgcIconCurrencyWon2Regular as MGCIcon,
  mgcIconCurrencyWonRegular as MGCIcon,
  mgcIconDiamond2Regular as MGCIcon,
  mgcIconExchangeBahtRegular as MGCIcon,
  mgcIconExchangeCnyRegular as MGCIcon,
  mgcIconExchangeDollarRegular as MGCIcon,
  mgcIconExchangeEuroRegular as MGCIcon,
  mgcIconFilter3Regular as MGCIcon,
  mgcIconFilterRegular as MGCIcon,
  mgcIconFlag1Regular as MGCIcon,
  mgcIconFlag2Regular as MGCIcon,
  mgcIconFlag3Regular as MGCIcon,
  mgcIconFlag4Regular as MGCIcon,
  mgcIconGift2Regular as MGCIcon,
  mgcIconGiftCardRegular as MGCIcon,
  mgcIconGiftRegular as MGCIcon,
  mgcIconLadderRegular as MGCIcon,
  mgcIconLantern2Regular as MGCIcon,
  mgcIconLanternRegular as MGCIcon,
  mgcIconLaurelWreathRegular as MGCIcon,
  mgcIconLuggageRegular as MGCIcon,
  mgcIconMedalRegular as MGCIcon,
  mgcIconPalette3Regular as MGCIcon,
  mgcIconPigMoneyRegular as MGCIcon,
  mgcIconPound2Regular as MGCIcon,
  mgcIconPoundRegular as MGCIcon,
  mgcIconPresentation1Regular as MGCIcon,
  mgcIconPresentation2Regular as MGCIcon,
  mgcIconPresentation3Regular as MGCIcon,
  mgcIconPumpkinLanternRegular as MGCIcon,
  mgcIconReceiveMoneyRegular as MGCIcon,
  mgcIconRedPacketOpenRegular as MGCIcon,
  mgcIconRedPacketRegular as MGCIcon,
  mgcIconRefundCnyRegular as MGCIcon,
  mgcIconRefundDollarRegular as MGCIcon,
  mgcIconRegisteredRegular as MGCIcon,
  mgcIconSafeBoxRegular as MGCIcon,
  mgcIconSaleRegular as MGCIcon,
  mgcIconScheduleRegular as MGCIcon,
  mgcIconSealRegular as MGCIcon,
  mgcIconShoppingBag1Regular as MGCIcon,
  mgcIconShoppingBag2Regular as MGCIcon,
  mgcIconShoppingBag3Regular as MGCIcon,
  mgcIconShoppingCart1Regular as MGCIcon,
  mgcIconShoppingCart2Regular as MGCIcon,
  mgcIconSofaRegular as MGCIcon,
  mgcIconStockRegular as MGCIcon,
  mgcIconSuitcase2Regular as MGCIcon,
  mgcIconSuitcaseRegular as MGCIcon,
  mgcIconTag2Regular as MGCIcon,
  mgcIconTagChevronRegular as MGCIcon,
  mgcIconTagRegular as MGCIcon,
  mgcIconTargetRegular as MGCIcon,
  mgcIconTicketRegular as MGCIcon,
  mgcIconTrophyRegular as MGCIcon,
  mgcIconVip1Regular as MGCIcon,
  mgcIconVip2Regular as MGCIcon,
  mgcIconVip3Regular as MGCIcon,
  mgcIconVip4Regular as MGCIcon,
  mgcIconWallet2Regular as MGCIcon,
  mgcIconWallet3Regular as MGCIcon,
  mgcIconWallet4Regular as MGCIcon,
  mgcIconWallet5Regular as MGCIcon,
  mgcIconWalletRegular as MGCIcon,
  mgcIconYuanbaoRegular as MGCIcon,
  mgcIconChat1Regular as MGCIcon,
  mgcIconChat2Regular as MGCIcon,
  mgcIconChat3Regular as MGCIcon,
  mgcIconChat4Regular as MGCIcon,
  mgcIconComment2Regular as MGCIcon,
  mgcIconCommentRegular as MGCIcon,
  mgcIconInviteRegular as MGCIcon,
  mgcIconMailAiRegular as MGCIcon,
  mgcIconMailOpenRegular as MGCIcon,
  mgcIconMailRegular as MGCIcon,
  mgcIconMailSendRegular as MGCIcon,
  mgcIconMailboxRegular as MGCIcon,
  mgcIconMessage1Regular as MGCIcon,
  mgcIconMessage2Regular as MGCIcon,
  mgcIconMessage3Regular as MGCIcon,
  mgcIconMessage4Regular as MGCIcon,
  mgcIconPhoneAddRegular as MGCIcon,
  mgcIconPhoneBlockRegular as MGCIcon,
  mgcIconPhoneCallRegular as MGCIcon,
  mgcIconPhoneIncomingRegular as MGCIcon,
  mgcIconPhoneOffRegular as MGCIcon,
  mgcIconPhoneOutgoingRegular as MGCIcon,
  mgcIconPhoneRegular as MGCIcon,
  mgcIconPhoneSuccessRegular as MGCIcon,
  mgcIconSendPlaneRegular as MGCIcon,
  mgcIconSendRegular as MGCIcon,
  mgcIconAvalancheAvaxRegular as MGCIcon,
  mgcIconBinanceCoinBnbRegular as MGCIcon,
  mgcIconBinanceUsdBusdRegular as MGCIcon,
  mgcIconBnbRegular as MGCIcon,
  mgcIconCardanoAdaRegular as MGCIcon,
  mgcIconCurrencyBitcoin2Regular as MGCIcon,
  mgcIconCurrencyBitcoinRegular as MGCIcon,
  mgcIconDogecoinDogeRegular as MGCIcon,
  mgcIconEthereumRegular as MGCIcon,
  mgcIconExchangeBitcoinRegular as MGCIcon,
  mgcIconMoneroRegular as MGCIcon,
  mgcIconPolkadotDotRegular as MGCIcon,
  mgcIconSolanaSolRegular as MGCIcon,
  mgcIconTetherUsdtRegular as MGCIcon,
  mgcIconUsdCoinUsdcRegular as MGCIcon,
  mgcIconXrpRegular as MGCIcon,
  mgcIconAlignBottomRegular as MGCIcon,
  mgcIconAlignHorizontalCenterRegular as MGCIcon,
  mgcIconAlignLeft2Regular as MGCIcon,
  mgcIconAlignRight2Regular as MGCIcon,
  mgcIconAlignTopRegular as MGCIcon,
  mgcIconAlignVerticalCenterRegular as MGCIcon,
  mgcIconAnticlockwiseAltRegular as MGCIcon,
  mgcIconAnticlockwiseRegular as MGCIcon,
  mgcIconArtboardRegular as MGCIcon,
  mgcIconBackgroundBaseRegular as MGCIcon,
  mgcIconBackgroundRegular as MGCIcon,
  mgcIconBlingRegular as MGCIcon,
  mgcIconBoardRegular as MGCIcon,
  mgcIconBorderBlankRegular as MGCIcon,
  mgcIconBorderBottomRegular as MGCIcon,
  mgcIconBorderHorizontalRegular as MGCIcon,
  mgcIconBorderInnerRegular as MGCIcon,
  mgcIconBorderLeftRegular as MGCIcon,
  mgcIconBorderOuterRegular as MGCIcon,
  mgcIconBorderRadiusRegular as MGCIcon,
  mgcIconBorderRightRegular as MGCIcon,
  mgcIconBorderTopRegular as MGCIcon,
  mgcIconBorderVerticalRegular as MGCIcon,
  mgcIconBrightnessRegular as MGCIcon,
  mgcIconBrush2Regular as MGCIcon,
  mgcIconClockwiseAltRegular as MGCIcon,
  mgcIconClockwiseRegular as MGCIcon,
  mgcIconColorFilterRegular as MGCIcon,
  mgcIconColorPickerRegular as MGCIcon,
  mgcIconColumns2Regular as MGCIcon,
  mgcIconColumns3Regular as MGCIcon,
  mgcIconCombineRegular as MGCIcon,
  mgcIconComponentsRegular as MGCIcon,
  mgcIconDistributeSpacingHorizontalRegular as MGCIcon,
  mgcIconDistributeSpacingVerticalRegular as MGCIcon,
  mgcIconDrawingBoardRegular as MGCIcon,
  mgcIconDropRegular as MGCIcon,
  mgcIconEaseInControlPointRegular as MGCIcon,
  mgcIconEaseInOutControlPointRegular as MGCIcon,
  mgcIconEaseInRegular as MGCIcon,
  mgcIconEaseOutControlPointRegular as MGCIcon,
  mgcIconEaseOutRegular as MGCIcon,
  mgcIconEasyInOutRegular as MGCIcon,
  mgcIconExcludeRegular as MGCIcon,
  mgcIconExposureRegular as MGCIcon,
  mgcIconFlipHorizontalRegular as MGCIcon,
  mgcIconFlipVerticalRegular as MGCIcon,
  mgcIconFoldHorizontalRegular as MGCIcon,
  mgcIconFoldVerticalRegular as MGCIcon,
  mgcIconIntersectRegular as MGCIcon,
  mgcIconKnifeRegular as MGCIcon,
  mgcIconLayerRegular as MGCIcon,
  mgcIconLayout10Regular as MGCIcon,
  mgcIconLayout11Regular as MGCIcon,
  mgcIconLayout2Regular as MGCIcon,
  mgcIconLayout3Regular as MGCIcon,
  mgcIconLayout4Regular as MGCIcon,
  mgcIconLayout5Regular as MGCIcon,
  mgcIconLayout6Regular as MGCIcon,
  mgcIconLayout7Regular as MGCIcon,
  mgcIconLayout8Regular as MGCIcon,
  mgcIconLayout9Regular as MGCIcon,
  mgcIconLayoutBottomCloseRegular as MGCIcon,
  mgcIconLayoutBottomOpenRegular as MGCIcon,
  mgcIconLayoutBottomRegular as MGCIcon,
  mgcIconLayoutGridRegular as MGCIcon,
  mgcIconLayoutLeftRegular as MGCIcon,
  mgcIconLayoutLeftbarCloseRegular as MGCIcon,
  mgcIconLayoutLeftbarOpenRegular as MGCIcon,
  mgcIconLayoutRegular as MGCIcon,
  mgcIconLayoutRightRegular as MGCIcon,
  mgcIconLayoutRightbarCloseRegular as MGCIcon,
  mgcIconLayoutRightbarOpenRegular as MGCIcon,
  mgcIconLayoutTopCloseRegular as MGCIcon,
  mgcIconLayoutTopOpenRegular as MGCIcon,
  mgcIconLayoutTopRegular as MGCIcon,
  mgcIconMagic1Regular as MGCIcon,
  mgcIconMagic2Regular as MGCIcon,
  mgcIconMagic3Regular as MGCIcon,
  mgcIconMagicHat2Regular as MGCIcon,
  mgcIconMagicHatRegular as MGCIcon,
  mgcIconMarkPenRegular as MGCIcon,
  mgcIconMarkupRegular as MGCIcon,
  mgcIconMirrorRegular as MGCIcon,
  mgcIconMosaicRegular as MGCIcon,
  mgcIconPaint2Regular as MGCIcon,
  mgcIconPaintBrushAiRegular as MGCIcon,
  mgcIconPaintBrushRegular as MGCIcon,
  mgcIconPalette2Regular as MGCIcon,
  mgcIconPaletteRegular as MGCIcon,
  mgcIconPasterRegular as MGCIcon,
  mgcIconPenRegular as MGCIcon,
  mgcIconQuillPenAiRegular as MGCIcon,
  mgcIconQuillPenRegular as MGCIcon,
  mgcIconRotateXRegular as MGCIcon,
  mgcIconRotateYRegular as MGCIcon,
  mgcIconRows2Regular as MGCIcon,
  mgcIconRows3Regular as MGCIcon,
  mgcIconRows4Regular as MGCIcon,
  mgcIconRulerRegular as MGCIcon,
  mgcIconScaleRegular as MGCIcon,
  mgcIconScissors2Regular as MGCIcon,
  mgcIconScissors3Regular as MGCIcon,
  mgcIconScissorsRegular as MGCIcon,
  mgcIconScreenshotRegular as MGCIcon,
  mgcIconSectionRegular as MGCIcon,
  mgcIconShadowRegular as MGCIcon,
  mgcIconStickerRegular as MGCIcon,
  mgcIconSubtractRegular as MGCIcon,
  mgcIconTable2Regular as MGCIcon,
  mgcIconUnfoldHorizontalRegular as MGCIcon,
  mgcIconUnfoldVerticalRegular as MGCIcon,
  mgcIconUnionRegular as MGCIcon,
  mgcIconVectorBezier2Regular as MGCIcon,
  mgcIconVectorBezier3Regular as MGCIcon,
  mgcIconVectorBezierRegular as MGCIcon,
  mgcIconVectorGroupRegular as MGCIcon,
  mgcIconXSkewRegular as MGCIcon,
  mgcIconYSkewRegular as MGCIcon,
  mgcIconBracesRegular as MGCIcon,
  mgcIconBracketsAngleRegular as MGCIcon,
  mgcIconBracketsRegular as MGCIcon,
  mgcIconBugRegular as MGCIcon,
  mgcIconCodeRegular as MGCIcon,
  mgcIconCommandRegular as MGCIcon,
  mgcIconCursor2Regular as MGCIcon,
  mgcIconCursor3Regular as MGCIcon,
  mgcIconCursorRegular as MGCIcon,
  mgcIconDepartmentRegular as MGCIcon,
  mgcIconDirectoryRegular as MGCIcon,
  mgcIconGitBranchRegular as MGCIcon,
  mgcIconGitCommitRegular as MGCIcon,
  mgcIconGitCompareRegular as MGCIcon,
  mgcIconGitMergeRegular as MGCIcon,
  mgcIconGitPullRequestCloseRegular as MGCIcon,
  mgcIconGitPullRequestRegular as MGCIcon,
  mgcIconHotkeyRegular as MGCIcon,
  mgcIconInspectRegular as MGCIcon,
  mgcIconParenthesesRegular as MGCIcon,
  mgcIconPerformanceRegular as MGCIcon,
  mgcIconSitemapRegular as MGCIcon,
  mgcIconTerminalBoxRegular as MGCIcon,
  mgcIconTerminalRegular as MGCIcon,
  mgcIconWebRegular as MGCIcon,
  mgcIconAiRegular as MGCIcon,
  mgcIconAirConditionOpenRegular as MGCIcon,
  mgcIconAirConditionRegular as MGCIcon,
  mgcIconAirplayRegular as MGCIcon,
  mgcIconAirpods2Regular as MGCIcon,
  mgcIconAlarm1Regular as MGCIcon,
  mgcIconAlarm2Regular as MGCIcon,
  mgcIconAspectRatioRegular as MGCIcon,
  mgcIconBarcodeRegular as MGCIcon,
  mgcIconBarcodeScaRegular as MGCIcon,
  mgcIconBaseStation2Regular as MGCIcon,
  mgcIconBaseStationRegular as MGCIcon,
  mgcIconBattery1Regular as MGCIcon,
  mgcIconBattery2Regular as MGCIcon,
  mgcIconBattery3Regular as MGCIcon,
  mgcIconBattery4Regular as MGCIcon,
  mgcIconBatteryAutomotiveRegular as MGCIcon,
  mgcIconBatteryChargingRegular as MGCIcon,
  mgcIconBatteryRegular as MGCIcon,
  mgcIconBluetoothOffRegular as MGCIcon,
  mgcIconBluetoothRegular as MGCIcon,
  mgcIconBulb2Regular as MGCIcon,
  mgcIconBulbRegular as MGCIcon,
  mgcIconCamcorder2Regular as MGCIcon,
  mgcIconCardboardVrRegular as MGCIcon,
  mgcIconCeilingLampRegular as MGCIcon,
  mgcIconCellphone2AiRegular as MGCIcon,
  mgcIconCellphone2HorizontalRegular as MGCIcon,
  mgcIconCellphone2Regular as MGCIcon,
  mgcIconCellphoneRegular as MGCIcon,
  mgcIconCellphoneVibrationRegular as MGCIcon,
  mgcIconChipRegular as MGCIcon,
  mgcIconComputerCamerRegular as MGCIcon,
  mgcIconComputerCameraOffRegular as MGCIcon,
  mgcIconComputerRegular as MGCIcon,
  mgcIconCounter2Regular as MGCIcon,
  mgcIconCube3DRegular as MGCIcon,
  mgcIconDashboard2Regular as MGCIcon,
  mgcIconDashboard3Regular as MGCIcon,
  mgcIconDashboard4Regular as MGCIcon,
  mgcIconDashboardRegular as MGCIcon,
  mgcIconDeskLamp2Regular as MGCIcon,
  mgcIconDeskLampRegular as MGCIcon,
  mgcIconDeviceRegular as MGCIcon,
  mgcIconDisplayRegular as MGCIcon,
  mgcIconDroneRegular as MGCIcon,
  mgcIconEscalatorDownRegular as MGCIcon,
  mgcIconEscalatorUpRegular as MGCIcon,
  mgcIconFaxRegular as MGCIcon,
  mgcIconFlashCircleRegular as MGCIcon,
  mgcIconFlashRegular as MGCIcon,
  mgcIconFlashlightRegular as MGCIcon,
  mgcIconFridgeRegular as MGCIcon,
  mgcIconGame1Regular as MGCIcon,
  mgcIconGame2Regular as MGCIcon,
  mgcIconGradienterRegular as MGCIcon,
  mgcIconGuitarRegular as MGCIcon,
  mgcIconHighVoltagePowerRegular as MGCIcon,
  mgcIconHomeWifiRegular as MGCIcon,
  mgcIconHomepodMiniRegular as MGCIcon,
  mgcIconHomepodRegular as MGCIcon,
  mgcIconIMacRegular as MGCIcon,
  mgcIconInstrumentRegular as MGCIcon,
  mgcIconKeyboard2Regular as MGCIcon,
  mgcIconKeyboardRegular as MGCIcon,
  mgcIconLaptop2Regular as MGCIcon,
  mgcIconLaptopRegular as MGCIcon,
  mgcIconLightRegular as MGCIcon,
  mgcIconMicroscopeRegular as MGCIcon,
  mgcIconMidiRegular as MGCIcon,
  mgcIconMonitorRegular as MGCIcon,
  mgcIconMouseRegular as MGCIcon,
  mgcIconPadRegular as MGCIcon,
  mgcIconPanoramasRegular as MGCIcon,
  mgcIconPlugin2Regular as MGCIcon,
  mgcIconPluginRegular as MGCIcon,
  mgcIconPrintRegular as MGCIcon,
  mgcIconProjectorRegular as MGCIcon,
  mgcIconProjectorScreenRegular as MGCIcon,
  mgcIconQrcode2Regular as MGCIcon,
  mgcIconQrcodeRegular as MGCIcon,
  mgcIconRadaRegular as MGCIcon,
  mgcIconRadar2Regular as MGCIcon,
  mgcIconRadioRegular as MGCIcon,
  mgcIconRemoteControlRegular as MGCIcon,
  mgcIconRemoteRegular as MGCIcon,
  mgcIconRouterModemRegular as MGCIcon,
  mgcIconRss2Regular as MGCIcon,
  mgcIconRssRegular as MGCIcon,
  mgcIconSandglass2Regular as MGCIcon,
  mgcIconSandglassRegular as MGCIcon,
  mgcIconScan2Regular as MGCIcon,
  mgcIconScanRegular as MGCIcon,
  mgcIconServer2Regular as MGCIcon,
  mgcIconServerRegular as MGCIcon,
  mgcIconShowerRegular as MGCIcon,
  mgcIconSignalRegular as MGCIcon,
  mgcIconSolarPanelRegular as MGCIcon,
  mgcIconSpeakerRegular as MGCIcon,
  mgcIconStopwatchRegular as MGCIcon,
  mgcIconStorageRegular as MGCIcon,
  mgcIconTelescope2Regular as MGCIcon,
  mgcIconTelescopeRegular as MGCIcon,
  mgcIconTowerCraneRegular as MGCIcon,
  mgcIconTv1Regular as MGCIcon,
  mgcIconTv2Regular as MGCIcon,
  mgcIconUsbFlashDiskRegular as MGCIcon,
  mgcIconUsbRegular as MGCIcon,
  mgcIconVisonProRegular as MGCIcon,
  mgcIconWashMachineRegular as MGCIcon,
  mgcIconWatch2Regular as MGCIcon,
  mgcIconWatchRegular as MGCIcon,
  mgcIconWifiOffRegular as MGCIcon,
  mgcIconWifiRegular as MGCIcon,
  mgcIconAlignCenterRegular as MGCIcon,
  mgcIconAlignJustifyRegular as MGCIcon,
  mgcIconAlignLeftRegular as MGCIcon,
  mgcIconAlignRightRegular as MGCIcon,
  mgcIconAndRegular as MGCIcon,
  mgcIconAsterisk2Regular as MGCIcon,
  mgcIconAsteriskRegular as MGCIcon,
  mgcIconAtRegular as MGCIcon,
  mgcIconAzSortAscendingLettersRegular as MGCIcon,
  mgcIconAzSortDescendingLettersRegular as MGCIcon,
  mgcIconBlockquoteRegular as MGCIcon,
  mgcIconBoldRegular as MGCIcon,
  mgcIconColumnRegular as MGCIcon,
  mgcIconContentAiRegular as MGCIcon,
  mgcIconCursorTextRegular as MGCIcon,
  mgcIconDividingLineRegular as MGCIcon,
  mgcIconEdit2Regular as MGCIcon,
  mgcIconEdit3Regular as MGCIcon,
  mgcIconEdit4Regular as MGCIcon,
  mgcIconEditRegular as MGCIcon,
  mgcIconEraserRegular as MGCIcon,
  mgcIconFontRegular as MGCIcon,
  mgcIconFontSizeRegular as MGCIcon,
  mgcIconFormulaRegular as MGCIcon,
  mgcIconFrameRegular as MGCIcon,
  mgcIconHashtagRegular as MGCIcon,
  mgcIconHeading1Regular as MGCIcon,
  mgcIconHeading2Regular as MGCIcon,
  mgcIconHeading3Regular as MGCIcon,
  mgcIconIndentDecreaseRegular as MGCIcon,
  mgcIconIndentIncreaseRegular as MGCIcon,
  mgcIconItalicRegular as MGCIcon,
  mgcIconLetterSpacingRegular as MGCIcon,
  mgcIconLineHeightRegular as MGCIcon,
  mgcIconListCheck2Regular as MGCIcon,
  mgcIconListCheck3Regular as MGCIcon,
  mgcIconListCheckRegular as MGCIcon,
  mgcIconListCollapseRegular as MGCIcon,
  mgcIconListExpansionRegular as MGCIcon,
  mgcIconListOrderedRegular as MGCIcon,
  mgcIconListSearchRegular as MGCIcon,
  mgcIconMenuRegular as MGCIcon,
  mgcIconNumbers09SortAscendingRegular as MGCIcon,
  mgcIconNumbers09SortDescendingRegular as MGCIcon,
  mgcIconNumbers90SortAscendingRegular as MGCIcon,
  mgcIconNumbers90SortDescendingRegular as MGCIcon,
  mgcIconOmegaRegular as MGCIcon,
  mgcIconPaintRegular as MGCIcon,
  mgcIconParagraphRegular as MGCIcon,
  mgcIconPen2Regular as MGCIcon,
  mgcIconPencil2AiRegular as MGCIcon,
  mgcIconPencil2Regular as MGCIcon,
  mgcIconPencil3Regular as MGCIcon,
  mgcIconPencilRegular as MGCIcon,
  mgcIconPencilRulerRegular as MGCIcon,
  mgcIconQuoteLeftRegular as MGCIcon,
  mgcIconQuoteRightRegular as MGCIcon,
  mgcIconSignatureRegular as MGCIcon,
  mgcIconSortAscendingRegular as MGCIcon,
  mgcIconSortDescendingRegular as MGCIcon,
  mgcIconSpaceRegular as MGCIcon,
  mgcIconSpacingHorizontalRegular as MGCIcon,
  mgcIconSpacingVerticalRegular as MGCIcon,
  mgcIconStrikethroughRegular as MGCIcon,
  mgcIconSubtitleRegular as MGCIcon,
  mgcIconTable3Regular as MGCIcon,
  mgcIconTableRegular as MGCIcon,
  mgcIconText2Regular as MGCIcon,
  mgcIconTextAreaRegular as MGCIcon,
  mgcIconTextColorRegular as MGCIcon,
  mgcIconTextDirectionLeftRegular as MGCIcon,
  mgcIconTextDirectionRightRegular as MGCIcon,
  mgcIconTextRegular as MGCIcon,
  mgcIconTextboxAiRegular as MGCIcon,
  mgcIconTextboxRegular as MGCIcon,
  mgcIconTranslate2AiRegular as MGCIcon,
  mgcIconTranslate2Regular as MGCIcon,
  mgcIconTranslateRegular as MGCIcon,
  mgcIconUnderlineRegular as MGCIcon,
  mgcIconZaSortAscendingLettersRegular as MGCIcon,
  mgcIconZaSortDescendingLettersRegular as MGCIcon,
  mgcIconBackpackRegular as MGCIcon,
  mgcIconBalanceRegular as MGCIcon,
  mgcIconBlackBoard2Regular as MGCIcon,
  mgcIconBlackBoardRegular as MGCIcon,
  mgcIconBook2Regular as MGCIcon,
  mgcIconBook3Regular as MGCIcon,
  mgcIconBook4Regular as MGCIcon,
  mgcIconBook5Regular as MGCIcon,
  mgcIconBook6Regular as MGCIcon,
  mgcIconBookRegular as MGCIcon,
  mgcIconBookmarkAddRegular as MGCIcon,
  mgcIconBookmarkEditRegular as MGCIcon,
  mgcIconBookmarkRegular as MGCIcon,
  mgcIconBookmarkRemoveRegular as MGCIcon,
  mgcIconBookmarksRegular as MGCIcon,
  mgcIconCertificate2Regular as MGCIcon,
  mgcIconCompass2Regular as MGCIcon,
  mgcIconCounterRegular as MGCIcon,
  mgcIconDeskRegular as MGCIcon,
  mgcIconDiaryRegular as MGCIcon,
  mgcIconDrumRegular as MGCIcon,
  mgcIconEyeglassRegular as MGCIcon,
  mgcIconFlask2Regular as MGCIcon,
  mgcIconFlask3Regular as MGCIcon,
  mgcIconFlaskRegular as MGCIcon,
  mgcIconFoldingFanRegular as MGCIcon,
  mgcIconGlobeRegular as MGCIcon,
  mgcIconMagnetRegular as MGCIcon,
  mgcIconMortarboardRegular as MGCIcon,
  mgcIconNotebook2Regular as MGCIcon,
  mgcIconNotebookRegular as MGCIcon,
  mgcIconScienceRegular as MGCIcon,
  mgcIconSpeechRegular as MGCIcon,
  mgcIconTestTubeRegular as MGCIcon,
  mgcIconAngelRegular as MGCIcon,
  mgcIconAngryRegular as MGCIcon,
  mgcIconConfusedRegular as MGCIcon,
  mgcIconEmoji2Regular as MGCIcon,
  mgcIconEmojiRegular as MGCIcon,
  mgcIconHappyRegular as MGCIcon,
  mgcIconLaughRegular as MGCIcon,
  mgcIconLookDownRegular as MGCIcon,
  mgcIconLookLeftRegular as MGCIcon,
  mgcIconLookRightRegular as MGCIcon,
  mgcIconLookUpRegular as MGCIcon,
  mgcIconOmgRegular as MGCIcon,
  mgcIconPuzzledRegular as MGCIcon,
  mgcIconSadRegular as MGCIcon,
  mgcIconSickRegular as MGCIcon,
  mgcIconSilentRegular as MGCIcon,
  mgcIconSobRegular as MGCIcon,
  mgcIconSurpriseRegular as MGCIcon,
  mgcIconSweatsRegular as MGCIcon,
  mgcIconTerrorRegular as MGCIcon,
  mgcIconTongueRegular as MGCIcon,
  mgcIconUnhappyDizzyRegular as MGCIcon,
  mgcIconUnhappyRegular as MGCIcon,
  mgcIconAlbum2Regular as MGCIcon,
  mgcIconArchiveRegular as MGCIcon,
  mgcIconAttachment2Regular as MGCIcon,
  mgcIconAttachmentRegular as MGCIcon,
  mgcIconBill2Regular as MGCIcon,
  mgcIconBillRegular as MGCIcon,
  mgcIconBox2Regular as MGCIcon,
  mgcIconBox3Regular as MGCIcon,
  mgcIconBoxRegular as MGCIcon,
  mgcIconClipboardRegular as MGCIcon,
  mgcIconCopy2Regular as MGCIcon,
  mgcIconCopy3Regular as MGCIcon,
  mgcIconCopyRegular as MGCIcon,
  mgcIconDocRegular as MGCIcon,
  mgcIconDocmentRegular as MGCIcon,
  mgcIconDocument2Regular as MGCIcon,
  mgcIconDocument3Regular as MGCIcon,
  mgcIconDocumentsRegular as MGCIcon,
  mgcIconDownload2Regular as MGCIcon,
  mgcIconDownload3Regular as MGCIcon,
  mgcIconDownloadRegular as MGCIcon,
  mgcIconEmptyBoxRegular as MGCIcon,
  mgcIconExternalLinkRegular as MGCIcon,
  mgcIconFileCertificateRegular as MGCIcon,
  mgcIconFileCheckRegular as MGCIcon,
  mgcIconFileCodeRegular as MGCIcon,
  mgcIconFileDownloadRegular as MGCIcon,
  mgcIconFileExportRegular as MGCIcon,
  mgcIconFileForbidRegular as MGCIcon,
  mgcIconFileImportRegular as MGCIcon,
  mgcIconFileInfoRegular as MGCIcon,
  mgcIconFileLockedRegular as MGCIcon,
  mgcIconFileMoreRegular as MGCIcon,
  mgcIconFileMusicRegular as MGCIcon,
  mgcIconFileNewRegular as MGCIcon,
  mgcIconFileRegular as MGCIcon,
  mgcIconFileSearchRegular as MGCIcon,
  mgcIconFileSecurityRegular as MGCIcon,
  mgcIconFileStarRegular as MGCIcon,
  mgcIconFileUnknownRegular as MGCIcon,
  mgcIconFileUploadRegular as MGCIcon,
  mgcIconFileWarningRegular as MGCIcon,
  mgcIconFileZipRegular as MGCIcon,
  mgcIconFolder2Regular as MGCIcon,
  mgcIconFolder3Regular as MGCIcon,
  mgcIconFolderCheckRegular as MGCIcon,
  mgcIconFolderDeleteRegular as MGCIcon,
  mgcIconFolderDownloadRegular as MGCIcon,
  mgcIconFolderForbidRegular as MGCIcon,
  mgcIconFolderInfoRegular as MGCIcon,
  mgcIconFolderLocked2Regular as MGCIcon,
  mgcIconFolderLockedRegular as MGCIcon,
  mgcIconFolderMinusRegular as MGCIcon,
  mgcIconFolderMoreRegular as MGCIcon,
  mgcIconFolderOpen2Regular as MGCIcon,
  mgcIconFolderOpenRegular as MGCIcon,
  mgcIconFolderRegular as MGCIcon,
  mgcIconFolderSecurityRegular as MGCIcon,
  mgcIconFolderStarRegular as MGCIcon,
  mgcIconFolderUploadRegular as MGCIcon,
  mgcIconFolderWarningRegular as MGCIcon,
  mgcIconFolderZipRegular as MGCIcon,
  mgcIconFoldersRegular as MGCIcon,
  mgcIconInbox2Regular as MGCIcon,
  mgcIconInboxRegular as MGCIcon,
  mgcIconInventoryRegular as MGCIcon,
  mgcIconLink2Regular as MGCIcon,
  mgcIconLink3Regular as MGCIcon,
  mgcIconLinkRegular as MGCIcon,
  mgcIconMarkdownRegular as MGCIcon,
  mgcIconNewFolderRegular as MGCIcon,
  mgcIconNews2Regular as MGCIcon,
  mgcIconNewsRegular as MGCIcon,
  mgcIconPackage2Regular as MGCIcon,
  mgcIconPackageRegular as MGCIcon,
  mgcIconPaper2Regular as MGCIcon,
  mgcIconPaperRegular as MGCIcon,
  mgcIconPassportRegular as MGCIcon,
  mgcIconPasteRegular as MGCIcon,
  mgcIconPdfRegular as MGCIcon,
  mgcIconPhotoAlbum2Regular as MGCIcon,
  mgcIconPhotoAlbumRegular as MGCIcon,
  mgcIconPic2Regular as MGCIcon,
  mgcIconPicAiRegular as MGCIcon,
  mgcIconPicRegular as MGCIcon,
  mgcIconPin2Regular as MGCIcon,
  mgcIconPinRegular as MGCIcon,
  mgcIconPptRegular as MGCIcon,
  mgcIconProfileRegular as MGCIcon,
  mgcIconReportFormsRegular as MGCIcon,
  mgcIconSave2Regular as MGCIcon,
  mgcIconSaveRegular as MGCIcon,
  mgcIconSearch2Regular as MGCIcon,
  mgcIconSearch3Regular as MGCIcon,
  mgcIconSearchAiRegular as MGCIcon,
  mgcIconSearchRegular as MGCIcon,
  mgcIconTask2Regular as MGCIcon,
  mgcIconTaskRegular as MGCIcon,
  mgcIconToDoRegular as MGCIcon,
  mgcIconUnarchiveRegular as MGCIcon,
  mgcIconUnlink2Regular as MGCIcon,
  mgcIconUnlinkRegular as MGCIcon,
  mgcIconUpload2Regular as MGCIcon,
  mgcIconUpload3Regular as MGCIcon,
  mgcIconUploadRegular as MGCIcon,
  mgcIconXlsRegular as MGCIcon,
  mgcIconZoomInRegular as MGCIcon,
  mgcIconZoomOutRegular as MGCIcon,
  mgcIconBirthday2Regular as MGCIcon,
  mgcIconBoneRegular as MGCIcon,
  mgcIconBottleGlassRegular as MGCIcon,
  mgcIconBowl2Regular as MGCIcon,
  mgcIconBowlRegular as MGCIcon,
  mgcIconBreadRegular as MGCIcon,
  mgcIconCakeRegular as MGCIcon,
  mgcIconCandy2Regular as MGCIcon,
  mgcIconCandyRegular as MGCIcon,
  mgcIconCarrotRegular as MGCIcon,
  mgcIconChampagneRegular as MGCIcon,
  mgcIconChickenRegular as MGCIcon,
  mgcIconChopsticksRegular as MGCIcon,
  mgcIconCookieManRegular as MGCIcon,
  mgcIconCookieRegular as MGCIcon,
  mgcIconCupcakeRegular as MGCIcon,
  mgcIconDinnerRegular as MGCIcon,
  mgcIconDishCoverRegular as MGCIcon,
  mgcIconDonutRegular as MGCIcon,
  mgcIconDrinkRegular as MGCIcon,
  mgcIconEggCrackRegular as MGCIcon,
  mgcIconEggRegular as MGCIcon,
  mgcIconElectricCookerRegular as MGCIcon,
  mgcIconFeederRegular as MGCIcon,
  mgcIconFishRegular as MGCIcon,
  mgcIconForkKnifeRegular as MGCIcon,
  mgcIconForkRegular as MGCIcon,
  mgcIconForkSpoonRegular as MGCIcon,
  mgcIconFriedEggRegular as MGCIcon,
  mgcIconFriesRegular as MGCIcon,
  mgcIconGlassCupRegular as MGCIcon,
  mgcIconHamburgerRegular as MGCIcon,
  mgcIconIceCream2Regular as MGCIcon,
  mgcIconIceCreamRegular as MGCIcon,
  mgcIconLollipopRegular as MGCIcon,
  mgcIconPizzaRegular as MGCIcon,
  mgcIconSoupPot2Regular as MGCIcon,
  mgcIconSoupPotRegular as MGCIcon,
  mgcIconSpatulaRegular as MGCIcon,
  mgcIconSpoonRegular as MGCIcon,
  mgcIconSugarCoatedHawsRegular as MGCIcon,
  mgcIconTeacupRegular as MGCIcon,
  mgcIconWineRegular as MGCIcon,
  mgcIconWineglass2Regular as MGCIcon,
  mgcIconWineglassRegular as MGCIcon,
  mgcIconAirbnbRegular as MGCIcon,
  mgcIconAirdropRegular as MGCIcon,
  mgcIconAlipayRegular as MGCIcon,
  mgcIconAndroid2Regular as MGCIcon,
  mgcIconAndroidRegular as MGCIcon,
  mgcIconAppleIntelligenceFrameRegular as MGCIcon,
  mgcIconAppleIntelligenceRegular as MGCIcon,
  mgcIconAppleRegular as MGCIcon,
  mgcIconAppstoreRegular as MGCIcon,
  mgcIconArcBrowserRegular as MGCIcon,
  mgcIconBehanceRegular as MGCIcon,
  mgcIconBilibiliRegular as MGCIcon,
  mgcIconBlueskeySocialRegular as MGCIcon,
  mgcIconCarplayRegular as MGCIcon,
  mgcIconChromeRegular as MGCIcon,
  mgcIconCodepenRegular as MGCIcon,
  mgcIconCopilotRegular as MGCIcon,
  mgcIconDingtalkRegular as MGCIcon,
  mgcIconDiscordRegular as MGCIcon,
  mgcIconDribbbleRegular as MGCIcon,
  mgcIconDriveRegular as MGCIcon,
  mgcIconDropboxRegular as MGCIcon,
  mgcIconEdgeRegular as MGCIcon,
  mgcIconFacebookRegular as MGCIcon,
  mgcIconFigmaRegular as MGCIcon,
  mgcIconFirefoxRegular as MGCIcon,
  mgcIconFollowRegular as MGCIcon,
  mgcIconGitLabRegular as MGCIcon,
  mgcIconGithub2Regular as MGCIcon,
  mgcIconGithubRegular as MGCIcon,
  mgcIconGooglePlayRegular as MGCIcon,
  mgcIconGoogleRegular as MGCIcon,
  mgcIconGrokRegular as MGCIcon,
  mgcIconGumroadRegular as MGCIcon,
  mgcIconInstagramRegular as MGCIcon,
  mgcIconKakaoTalkRegular as MGCIcon,
  mgcIconLayersRegular as MGCIcon,
  mgcIconLemonSqueezyRegular as MGCIcon,
  mgcIconLineAppRegular as MGCIcon,
  mgcIconLinearRegular as MGCIcon,
  mgcIconLinkedinRegular as MGCIcon,
  mgcIconLinuxRegular as MGCIcon,
  mgcIconMastercardRegular as MGCIcon,
  mgcIconMastodonRegular as MGCIcon,
  mgcIconMediumRegular as MGCIcon,
  mgcIconMessengerRegular as MGCIcon,
  mgcIconMetaRegular as MGCIcon,
  mgcIconMingcuteRegular as MGCIcon,
  mgcIconMomentRegular as MGCIcon,
  mgcIconNeteaseMusicRegular as MGCIcon,
  mgcIconNfcRegular as MGCIcon,
  mgcIconNintendoSwitchRegular as MGCIcon,
  mgcIconNotionRegular as MGCIcon,
  mgcIconOpenaiRegular as MGCIcon,
  mgcIconPaypalRegular as MGCIcon,
  mgcIconPinterestRegular as MGCIcon,
  mgcIconQqRegular as MGCIcon,
  mgcIconReactRegular as MGCIcon,
  mgcIconRedditRegular as MGCIcon,
  mgcIconSafariRegular as MGCIcon,
  mgcIconSiriFrameRegular as MGCIcon,
  mgcIconSiriRegular as MGCIcon,
  mgcIconSnapchatRegular as MGCIcon,
  mgcIconSocialXRegular as MGCIcon,
  mgcIconSpotifyRegular as MGCIcon,
  mgcIconStripeRegular as MGCIcon,
  mgcIconTelegramRegular as MGCIcon,
  mgcIconThreadsRegular as MGCIcon,
  mgcIconTiktokRegular as MGCIcon,
  mgcIconTrelloBoardRegular as MGCIcon,
  mgcIconTwitterRegular as MGCIcon,
  mgcIconViberMessengerRegular as MGCIcon,
  mgcIconVisaRegular as MGCIcon,
  mgcIconVkontakteRegular as MGCIcon,
  mgcIconVscodeRegular as MGCIcon,
  mgcIconVueRegular as MGCIcon,
  mgcIconWechatMiniprogramRegular as MGCIcon,
  mgcIconWechatPayRegular as MGCIcon,
  mgcIconWechatRegular as MGCIcon,
  mgcIconWeiboRegular as MGCIcon,
  mgcIconWhatsappRegular as MGCIcon,
  mgcIconWindowsRegular as MGCIcon,
  mgcIconXboxRegular as MGCIcon,
  mgcIconYoutubeRegular as MGCIcon,
  mgcIconAiming2Regular as MGCIcon,
  mgcIconAimingRegular as MGCIcon,
  mgcIconAnchorRegular as MGCIcon,
  mgcIconBed2Regular as MGCIcon,
  mgcIconBedRegular as MGCIcon,
  mgcIconClock2Regular as MGCIcon,
  mgcIconClockRegular as MGCIcon,
  mgcIconCompass3Regular as MGCIcon,
  mgcIconCompassRegular as MGCIcon,
  mgcIconDirections2Regular as MGCIcon,
  mgcIconDirectionsRegular as MGCIcon,
  mgcIconEarth2Regular as MGCIcon,
  mgcIconEarth3Regular as MGCIcon,
  mgcIconEarthLatitudeRegular as MGCIcon,
  mgcIconEarthLongitudeRegular as MGCIcon,
  mgcIconEarthRegular as MGCIcon,
  mgcIconFootRegular as MGCIcon,
  mgcIconGlobe2Regular as MGCIcon,
  mgcIconHoursRegular as MGCIcon,
  mgcIconLifebuoyRegular as MGCIcon,
  mgcIconLiveLocationRegular as MGCIcon,
  mgcIconLocation2Regular as MGCIcon,
  mgcIconLocation3Regular as MGCIcon,
  mgcIconLocationRegular as MGCIcon,
  mgcIconMap2Regular as MGCIcon,
  mgcIconMapPinRegular as MGCIcon,
  mgcIconMapRegular as MGCIcon,
  mgcIconNavigationRegular as MGCIcon,
  mgcIconParkingRegular as MGCIcon,
  mgcIconPlanetRegular as MGCIcon,
  mgcIconRestAreaRegular as MGCIcon,
  mgcIconRoadRegular as MGCIcon,
  mgcIconRouteRegular as MGCIcon,
  mgcIconTrafficConeRegular as MGCIcon,
  mgcIconTunnelRegular as MGCIcon,
  mgcIconUmbrella2Regular as MGCIcon,
  mgcIconWorld2Regular as MGCIcon,
  mgcIconWorldRegular as MGCIcon,
  mgcIconAirpodsRegular as MGCIcon,
  mgcIconAlbumRegular as MGCIcon,
  mgcIconAnnouncementRegular as MGCIcon,
  mgcIconAudioTapeRegular as MGCIcon,
  mgcIconBellRingingRegular as MGCIcon,
  mgcIconCamcorder3Regular as MGCIcon,
  mgcIconCamcorderOffRegular as MGCIcon,
  mgcIconCamcorderRegular as MGCIcon,
  mgcIconCamera2AiRegular as MGCIcon,
  mgcIconCamera2OffRegular as MGCIcon,
  mgcIconCamera2Regular as MGCIcon,
  mgcIconCameraRegular as MGCIcon,
  mgcIconCameraRotateRegular as MGCIcon,
  mgcIconClapperboardRegular as MGCIcon,
  mgcIconDanmakuOffRegular as MGCIcon,
  mgcIconDanmakuOnRegular as MGCIcon,
  mgcIconDanmakuRegular as MGCIcon,
  mgcIconDiscRegular as MGCIcon,
  mgcIconExpandPlayerRegular as MGCIcon,
  mgcIconFastForwardRegular as MGCIcon,
  mgcIconFastRewindRegular as MGCIcon,
  mgcIconFilmRegular as MGCIcon,
  mgcIconFullscreenExitRegular as MGCIcon,
  mgcIconFullscreenRegular as MGCIcon,
  mgcIconHeadphone2Regular as MGCIcon,
  mgcIconHeadphoneRegular as MGCIcon,
  mgcIconHorn2Regular as MGCIcon,
  mgcIconHornRegular as MGCIcon,
  mgcIconLivePhotoRegular as MGCIcon,
  mgcIconLiveRegular as MGCIcon,
  mgcIconMic2Regular as MGCIcon,
  mgcIconMicAiRegular as MGCIcon,
  mgcIconMicOffRegular as MGCIcon,
  mgcIconMicRegular as MGCIcon,
  mgcIconMicrophoneRegular as MGCIcon,
  mgcIconMiniplayerRegular as MGCIcon,
  mgcIconMovieRegular as MGCIcon,
  mgcIconMusic2AiRegular as MGCIcon,
  mgcIconMusic2Regular as MGCIcon,
  mgcIconMusic3Regular as MGCIcon,
  mgcIconMusicRegular as MGCIcon,
  mgcIconNotificationNewdotRegular as MGCIcon,
  mgcIconNotificationOffRegular as MGCIcon,
  mgcIconNotificationRegular as MGCIcon,
  mgcIconPauseCircleRegular as MGCIcon,
  mgcIconPauseRegular as MGCIcon,
  mgcIconPlayCircleRegular as MGCIcon,
  mgcIconPlayRegular as MGCIcon,
  mgcIconPlaylist2Regular as MGCIcon,
  mgcIconPlaylistRegular as MGCIcon,
  mgcIconRecordMailRegular as MGCIcon,
  mgcIconRepeatOneRegular as MGCIcon,
  mgcIconRepeatRegular as MGCIcon,
  mgcIconRewindBackward10Regular as MGCIcon,
  mgcIconRewindBackward15Regular as MGCIcon,
  mgcIconRewindBackward30Regular as MGCIcon,
  mgcIconRewindBackward5Regular as MGCIcon,
  mgcIconRewindBackwardSquare10Regular as MGCIcon,
  mgcIconRewindBackwardSquare15Regular as MGCIcon,
  mgcIconRewindBackwardSquare30Regular as MGCIcon,
  mgcIconRewindBackwardSquare5Regular as MGCIcon,
  mgcIconRewindForward10Regular as MGCIcon,
  mgcIconRewindForward15Regular as MGCIcon,
  mgcIconRewindForward30Regular as MGCIcon,
  mgcIconRewindForward5Regular as MGCIcon,
  mgcIconRewindForwardSquare10Regular as MGCIcon,
  mgcIconRewindForwardSquare15Regular as MGCIcon,
  mgcIconRewindForwardSquare30Regular as MGCIcon,
  mgcIconRewindForwardSquare5Regular as MGCIcon,
  mgcIconRotateToHorizontalRegular as MGCIcon,
  mgcIconRotateToVerticalRegular as MGCIcon,
  mgcIconServiceRegular as MGCIcon,
  mgcIconShuffle2Regular as MGCIcon,
  mgcIconShuffleRegular as MGCIcon,
  mgcIconSkipForwardRegular as MGCIcon,
  mgcIconSkipPreviousRegular as MGCIcon,
  mgcIconSoundLineRegular as MGCIcon,
  mgcIconStopCircleRegular as MGCIcon,
  mgcIconStopRegular as MGCIcon,
  mgcIconVideoCamera2Regular as MGCIcon,
  mgcIconVideoCameraRegular as MGCIcon,
  mgcIconVideoRegular as MGCIcon,
  mgcIconVoice2Regular as MGCIcon,
  mgcIconVoiceRegular as MGCIcon,
  mgcIconVolumeMuteRegular as MGCIcon,
  mgcIconVolumeOffRegular as MGCIcon,
  mgcIconVolumeRegular as MGCIcon,
  mgcIconBearRegular as MGCIcon,
  mgcIconBirdRegular as MGCIcon,
  mgcIconButterfly2Regular as MGCIcon,
  mgcIconButterflyRegular as MGCIcon,
  mgcIconCactus2Regular as MGCIcon,
  mgcIconCactusRegular as MGCIcon,
  mgcIconCampfireRegular as MGCIcon,
  mgcIconCatRegular as MGCIcon,
  mgcIconChessRegular as MGCIcon,
  mgcIconDandelionRegular as MGCIcon,
  mgcIconDogRegular as MGCIcon,
  mgcIconDragonflyRegular as MGCIcon,
  mgcIconFlower2Regular as MGCIcon,
  mgcIconFlower3Regular as MGCIcon,
  mgcIconFlower4Regular as MGCIcon,
  mgcIconFlower5Regular as MGCIcon,
  mgcIconFlowerRegular as MGCIcon,
  mgcIconFlowerpotRegular as MGCIcon,
  mgcIconGrassRegular as MGCIcon,
  mgcIconLeaf2Regular as MGCIcon,
  mgcIconLeaf3Regular as MGCIcon,
  mgcIconLeafRegular as MGCIcon,
  mgcIconLotusRegular as MGCIcon,
  mgcIconMapleLeafRegular as MGCIcon,
  mgcIconMickeymouseRegular as MGCIcon,
  mgcIconMountain2Regular as MGCIcon,
  mgcIconMountainRegular as MGCIcon,
  mgcIconMushroomRegular as MGCIcon,
  mgcIconPawRegular as MGCIcon,
  mgcIconPigRegular as MGCIcon,
  mgcIconPumpkinRegular as MGCIcon,
  mgcIconRabbitRegular as MGCIcon,
  mgcIconSunflowerRegular as MGCIcon,
  mgcIconToyHorseRegular as MGCIcon,
  mgcIconTree2Regular as MGCIcon,
  mgcIconTree3Regular as MGCIcon,
  mgcIconTree4Regular as MGCIcon,
  mgcIconTreeRegular as MGCIcon,
  mgcIconWreathRegular as MGCIcon,
  mgcIconAxeRegular as MGCIcon,
  mgcIconBalloon2Regular as MGCIcon,
  mgcIconBathRegular as MGCIcon,
  mgcIconBesideTable2Regular as MGCIcon,
  mgcIconBesideTableRegular as MGCIcon,
  mgcIconBlessingRegular as MGCIcon,
  mgcIconBombRegular as MGCIcon,
  mgcIconBoomRegular as MGCIcon,
  mgcIconBottleRegular as MGCIcon,
  mgcIconCapsuleRegular as MGCIcon,
  mgcIconCoathangerRegular as MGCIcon,
  mgcIconCross2Regular as MGCIcon,
  mgcIconCrystalBallRegular as MGCIcon,
  mgcIconCurtainRegular as MGCIcon,
  mgcIconDrawer2Regular as MGCIcon,
  mgcIconDrawerRegular as MGCIcon,
  mgcIconFaceMaskRegular as MGCIcon,
  mgcIconFirecrackerRegular as MGCIcon,
  mgcIconFireworkRegular as MGCIcon,
  mgcIconFirstAidKitRegular as MGCIcon,
  mgcIconHammerRegular as MGCIcon,
  mgcIconHandCardRegular as MGCIcon,
  mgcIconHandHeartRegular as MGCIcon,
  mgcIconHoeRegular as MGCIcon,
  mgcIconInjectionRegular as MGCIcon,
  mgcIconKiteRegular as MGCIcon,
  mgcIconLipstickRegular as MGCIcon,
  mgcIconNurseRegular as MGCIcon,
  mgcIconParfumRegular as MGCIcon,
  mgcIconPickaxRegular as MGCIcon,
  mgcIconPotRegular as MGCIcon,
  mgcIconPrescriptionRegular as MGCIcon,
  mgcIconRakeRegular as MGCIcon,
  mgcIconRandomRegular as MGCIcon,
  mgcIconScrewdriverRegular as MGCIcon,
  mgcIconShovelRegular as MGCIcon,
  mgcIconShowerGelRegular as MGCIcon,
  mgcIconStar2Regular as MGCIcon,
  mgcIconStarTopperRegular as MGCIcon,
  mgcIconStethoscopeRegular as MGCIcon,
  mgcIconThoughtRegular as MGCIcon,
  mgcIconToiletPaperRegular as MGCIcon,
  mgcIconVirusRegular as MGCIcon,
  mgcIconWardrobe2Regular as MGCIcon,
  mgcIconWardrobeRegular as MGCIcon,
  mgcIconWateringCanRegular as MGCIcon,
  mgcIconYinyangRegular as MGCIcon,
  mgcIconBabyRegular as MGCIcon,
  mgcIconBeardRegular as MGCIcon,
  mgcIconBodyRegular as MGCIcon,
  mgcIconBowTieRegular as MGCIcon,
  mgcIconBowknotRegular as MGCIcon,
  mgcIconBrainRegular as MGCIcon,
  mgcIconBriefRegular as MGCIcon,
  mgcIconChefHatRegular as MGCIcon,
  mgcIconChristmasHatRegular as MGCIcon,
  mgcIconCoatRegular as MGCIcon,
  mgcIconDeerRegular as MGCIcon,
  mgcIconDentalRegular as MGCIcon,
  mgcIconDressRegular as MGCIcon,
  mgcIconEarRegular as MGCIcon,
  mgcIconEye2Regular as MGCIcon,
  mgcIconEyebrowRegular as MGCIcon,
  mgcIconFaceRegular as MGCIcon,
  mgcIconFatherChristmasRegular as MGCIcon,
  mgcIconFingerPressRegular as MGCIcon,
  mgcIconFingerRockRegular as MGCIcon,
  mgcIconFingerSwipeRegular as MGCIcon,
  mgcIconFingerTapRegular as MGCIcon,
  mgcIconGloveRegular as MGCIcon,
  mgcIconHair2Regular as MGCIcon,
  mgcIconHairRegular as MGCIcon,
  mgcIconHandFinger2Regular as MGCIcon,
  mgcIconHandFingerRegular as MGCIcon,
  mgcIconHandGrabRegular as MGCIcon,
  mgcIconHandRegular as MGCIcon,
  mgcIconHandTwoFingersRegular as MGCIcon,
  mgcIconHandsClappingRegular as MGCIcon,
  mgcIconHat2Regular as MGCIcon,
  mgcIconHatRegular as MGCIcon,
  mgcIconHeadRegular as MGCIcon,
  mgcIconHeartHandRegular as MGCIcon,
  mgcIconHeartbeat2Regular as MGCIcon,
  mgcIconIncognitoModeRegular as MGCIcon,
  mgcIconLoveRegular as MGCIcon,
  mgcIconLungsRegular as MGCIcon,
  mgcIconMiddleFingerRegular as MGCIcon,
  mgcIconMouthRegular as MGCIcon,
  mgcIconNecktieRegular as MGCIcon,
  mgcIconNoseRegular as MGCIcon,
  mgcIconPrayRegular as MGCIcon,
  mgcIconScarfRegular as MGCIcon,
  mgcIconShirtRegular as MGCIcon,
  mgcIconShoe2Regular as MGCIcon,
  mgcIconShoeRegular as MGCIcon,
  mgcIconShortsRegular as MGCIcon,
  mgcIconSkirtRegular as MGCIcon,
  mgcIconSkullRegular as MGCIcon,
  mgcIconSockRegular as MGCIcon,
  mgcIconTShirt2Regular as MGCIcon,
  mgcIconTrouserRegular as MGCIcon,
  mgcIconVestRegular as MGCIcon,
  mgcIconClubsRegular as MGCIcon,
  mgcIconCylinder2Regular as MGCIcon,
  mgcIconCylinderRegular as MGCIcon,
  mgcIconDiamondRegular as MGCIcon,
  mgcIconDiamondSquareRegular as MGCIcon,
  mgcIconHeartCrackRegular as MGCIcon,
  mgcIconHeartHalfRegular as MGCIcon,
  mgcIconHeartRegular as MGCIcon,
  mgcIconHemisphere2Regular as MGCIcon,
  mgcIconHemisphereRegular as MGCIcon,
  mgcIconHexagonRegular as MGCIcon,
  mgcIconLineRegular as MGCIcon,
  mgcIconOctagonRegular as MGCIcon,
  mgcIconPentagonRegular as MGCIcon,
  mgcIconRectangleRegular as MGCIcon,
  mgcIconRectangleVerticalRegular as MGCIcon,
  mgcIconRoundRegular as MGCIcon,
  mgcIconSectorRegular as MGCIcon,
  mgcIconShieldShapeRegular as MGCIcon,
  mgcIconSpadeRegular as MGCIcon,
  mgcIconSquareRegular as MGCIcon,
  mgcIconStarHalfRegular as MGCIcon,
  mgcIconStarRegular as MGCIcon,
  mgcIconTriangleRegular as MGCIcon,
  mgcIconAirBalloonRegular as MGCIcon,
  mgcIconAmericanFootballRegular as MGCIcon,
  mgcIconBackboardRegular as MGCIcon,
  mgcIconBadmintonRegular as MGCIcon,
  mgcIconBarbellRegular as MGCIcon,
  mgcIconBaseball2Regular as MGCIcon,
  mgcIconBaseballRegular as MGCIcon,
  mgcIconBasketballRegular as MGCIcon,
  mgcIconBeachballRegular as MGCIcon,
  mgcIconDisabled2Regular as MGCIcon,
  mgcIconDisabledRegular as MGCIcon,
  mgcIconFitnessRegular as MGCIcon,
  mgcIconFootballRegular as MGCIcon,
  mgcIconParachuteRegular as MGCIcon,
  mgcIconPingpongRegular as MGCIcon,
  mgcIconPlaygroundRegular as MGCIcon,
  mgcIconRidingRegular as MGCIcon,
  mgcIconRunRegular as MGCIcon,
  mgcIconSkateboardRegular as MGCIcon,
  mgcIconSurfboardRegular as MGCIcon,
  mgcIconSwimmingPoolRegular as MGCIcon,
  mgcIconSwordRegular as MGCIcon,
  mgcIconToxophilyRegular as MGCIcon,
  mgcIconVolleyballRegular as MGCIcon,
  mgcIconWalkRegular as MGCIcon,
  mgcIconWheelchairRegular as MGCIcon,
  mgcIconWhistleRegular as MGCIcon,
  mgcIconAddCircleRegular as MGCIcon,
  mgcIconAddRegular as MGCIcon,
  mgcIconAddSquareRegular as MGCIcon,
  mgcIconAlertDiamondRegular as MGCIcon,
  mgcIconAlertOctagonRegular as MGCIcon,
  mgcIconAlertRegular as MGCIcon,
  mgcIconBroomRegular as MGCIcon,
  mgcIconBrush3Regular as MGCIcon,
  mgcIconBrushRegular as MGCIcon,
  mgcIconBubbleRegular as MGCIcon,
  mgcIconCertificateRegular as MGCIcon,
  mgcIconCheck2Regular as MGCIcon,
  mgcIconCheckCircleRegular as MGCIcon,
  mgcIconCheckRegular as MGCIcon,
  mgcIconCheckboxRegular as MGCIcon,
  mgcIconChecksRegular as MGCIcon,
  mgcIconChoiceRegular as MGCIcon,
  mgcIconClassify2Regular as MGCIcon,
  mgcIconClassify3Regular as MGCIcon,
  mgcIconClassifyAdd2Regular as MGCIcon,
  mgcIconClassifyAddRegular as MGCIcon,
  mgcIconClassifyRegular as MGCIcon,
  mgcIconCloseCircleRegular as MGCIcon,
  mgcIconCloseRegular as MGCIcon,
  mgcIconCloseSquareRegular as MGCIcon,
  mgcIconCrossRegular as MGCIcon,
  mgcIconCrutchRegular as MGCIcon,
  mgcIconCubeRegular as MGCIcon,
  mgcIconDelete2Regular as MGCIcon,
  mgcIconDelete3Regular as MGCIcon,
  mgcIconDeleteBackRegular as MGCIcon,
  mgcIconDeleteRegular as MGCIcon,
  mgcIconDirectionDotRegular as MGCIcon,
  mgcIconDoorRegular as MGCIcon,
  mgcIconDotGridRegular as MGCIcon,
  mgcIconDotsRegular as MGCIcon,
  mgcIconDotsVerticalRegular as MGCIcon,
  mgcIconEnterDoorRegular as MGCIcon,
  mgcIconEntranceRegular as MGCIcon,
  mgcIconExitDoorRegular as MGCIcon,
  mgcIconExitRegular as MGCIcon,
  mgcIconEyeCloseRegular as MGCIcon,
  mgcIconEyeRegular as MGCIcon,
  mgcIconFaceidRegular as MGCIcon,
  mgcIconFaultRegular as MGCIcon,
  mgcIconFilter2Regular as MGCIcon,
  mgcIconFingerprint2Regular as MGCIcon,
  mgcIconFingerprintRegular as MGCIcon,
  mgcIconFireRegular as MGCIcon,
  mgcIconFlameRegular as MGCIcon,
  mgcIconForbidCircleRegular as MGCIcon,
  mgcIconGestureUnlockRegular as MGCIcon,
  mgcIconGhostRegular as MGCIcon,
  mgcIconGrid2Regular as MGCIcon,
  mgcIconGridRegular as MGCIcon,
  mgcIconHeartbeatRegular as MGCIcon,
  mgcIconHexagons2Regular as MGCIcon,
  mgcIconHexagonsRegular as MGCIcon,
  mgcIconHistory2Regular as MGCIcon,
  mgcIconHistoryAnticlockwiseRegular as MGCIcon,
  mgcIconHistoryRegular as MGCIcon,
  mgcIconInformationRegular as MGCIcon,
  mgcIconKey1Regular as MGCIcon,
  mgcIconKey2Regular as MGCIcon,
  mgcIconKeyholeRegular as MGCIcon,
  mgcIconLoading2Regular as MGCIcon,
  mgcIconLoading3Regular as MGCIcon,
  mgcIconLoading4Regular as MGCIcon,
  mgcIconLoadingRegular as MGCIcon,
  mgcIconLockRegular as MGCIcon,
  mgcIconMindMapRegular as MGCIcon,
  mgcIconMinimizeRegular as MGCIcon,
  mgcIconMinusCircleRegular as MGCIcon,
  mgcIconMinusSquareRegular as MGCIcon,
  mgcIconMore1Regular as MGCIcon,
  mgcIconMore2Regular as MGCIcon,
  mgcIconMore3Regular as MGCIcon,
  mgcIconMore4Regular as MGCIcon,
  mgcIconMultiselectRegular as MGCIcon,
  mgcIconNewdotRegular as MGCIcon,
  mgcIconOpenDoorRegular as MGCIcon,
  mgcIconPlusRegular as MGCIcon,
  mgcIconPolygonRegular as MGCIcon,
  mgcIconPowerRegular as MGCIcon,
  mgcIconProcessRegular as MGCIcon,
  mgcIconQuestionRegular as MGCIcon,
  mgcIconRadioboxRegular as MGCIcon,
  mgcIconRecycleRegular as MGCIcon,
  mgcIconRefresh1Regular as MGCIcon,
  mgcIconRefresh2Regular as MGCIcon,
  mgcIconRefresh3Regular as MGCIcon,
  mgcIconRefresh4AiRegular as MGCIcon,
  mgcIconRefresh4Regular as MGCIcon,
  mgcIconRefreshAnticlockwise1Regular as MGCIcon,
  mgcIconReportRegular as MGCIcon,
  mgcIconRestoreRegular as MGCIcon,
  mgcIconSafeAlertRegular as MGCIcon,
  mgcIconSafeFlashRegular as MGCIcon,
  mgcIconSafeLockRegular as MGCIcon,
  mgcIconSafeShield2Regular as MGCIcon,
  mgcIconSafeShieldRegular as MGCIcon,
  mgcIconSafetyCertificateRegular as MGCIcon,
  mgcIconSettings1Regular as MGCIcon,
  mgcIconSettings2Regular as MGCIcon,
  mgcIconSettings3Regular as MGCIcon,
  mgcIconSettings4Regular as MGCIcon,
  mgcIconSettings5Regular as MGCIcon,
  mgcIconSettings6Regular as MGCIcon,
  mgcIconSettings7Regular as MGCIcon,
  mgcIconShare2Regular as MGCIcon,
  mgcIconShare3Regular as MGCIcon,
  mgcIconShareForwardRegular as MGCIcon,
  mgcIconShieldRegular as MGCIcon,
  mgcIconSleepRegular as MGCIcon,
  mgcIconSwitchRegular as MGCIcon,
  mgcIconTShirtRegular as MGCIcon,
  mgcIconThreeCirclesRegular as MGCIcon,
  mgcIconThumbDown2Regular as MGCIcon,
  mgcIconThumbDownRegular as MGCIcon,
  mgcIconThumbUp2Regular as MGCIcon,
  mgcIconThumbUpRegular as MGCIcon,
  mgcIconTimeDurationRegular as MGCIcon,
  mgcIconTimeRegular as MGCIcon,
  mgcIconTimelineRegular as MGCIcon,
  mgcIconToggleLeft2Regular as MGCIcon,
  mgcIconToggleLeftRegular as MGCIcon,
  mgcIconToggleRight2Regular as MGCIcon,
  mgcIconToggleRightRegular as MGCIcon,
  mgcIconToolRegular as MGCIcon,
  mgcIconTransformationRegular as MGCIcon,
  mgcIconUnlockRegular as MGCIcon,
  mgcIconVersionRegular as MGCIcon,
  mgcIconWarningRegular as MGCIcon,
  mgcIconWastebasketRegular as MGCIcon,
  mgcIconWebhookRegular as MGCIcon,
  mgcIconAbsRegular as MGCIcon,
  mgcIconAerialLiftRegular as MGCIcon,
  mgcIconAirplaneRegular as MGCIcon,
  mgcIconAutoHoldRegular as MGCIcon,
  mgcIconBabyCarriageRegular as MGCIcon,
  mgcIconBikeRegular as MGCIcon,
  mgcIconBrakeRegular as MGCIcon,
  mgcIconBus2Regular as MGCIcon,
  mgcIconBusRegular as MGCIcon,
  mgcIconCar2Regular as MGCIcon,
  mgcIconCar3Regular as MGCIcon,
  mgcIconCarDoorRegular as MGCIcon,
  mgcIconCarRegular as MGCIcon,
  mgcIconCarWindowRegular as MGCIcon,
  mgcIconChargingPileRegular as MGCIcon,
  mgcIconEbikeRegular as MGCIcon,
  mgcIconEmergencyFlashersRegular as MGCIcon,
  mgcIconEngineRegular as MGCIcon,
  mgcIconFan2Regular as MGCIcon,
  mgcIconFanDirectionDownRegular as MGCIcon,
  mgcIconFanDirectionFrontRegular as MGCIcon,
  mgcIconFanDirectionUpRegular as MGCIcon,
  mgcIconFanRegular as MGCIcon,
  mgcIconFlightInflightRegular as MGCIcon,
  mgcIconFlightLandRegular as MGCIcon,
  mgcIconFlightTakeoffRegular as MGCIcon,
  mgcIconFourWheelDriveRegular as MGCIcon,
  mgcIconFrontFogLightsRegular as MGCIcon,
  mgcIconFrontWindshieldDefrosterRegular as MGCIcon,
  mgcIconGasStationRegular as MGCIcon,
  mgcIconHightBeamHeadlightsRegular as MGCIcon,
  mgcIconHoodRegular as MGCIcon,
  mgcIconJeepRegular as MGCIcon,
  mgcIconLowBeamHeadlightsRegular as MGCIcon,
  mgcIconOilRegular as MGCIcon,
  mgcIconParkRegular as MGCIcon,
  mgcIconParkingLightsRegular as MGCIcon,
  mgcIconPinwheel2Regular as MGCIcon,
  mgcIconPinwheelRegular as MGCIcon,
  mgcIconRareFogLightsRegular as MGCIcon,
  mgcIconRearWindshieldDefrosterRegular as MGCIcon,
  mgcIconRocket2Regular as MGCIcon,
  mgcIconRocketRegular as MGCIcon,
  mgcIconRudderRegular as MGCIcon,
  mgcIconSailboatRegular as MGCIcon,
  mgcIconScooterRegular as MGCIcon,
  mgcIconSeatHeatedRegular as MGCIcon,
  mgcIconSeatRegular as MGCIcon,
  mgcIconShipRegular as MGCIcon,
  mgcIconSleighRegular as MGCIcon,
  mgcIconSteeringWheelRegular as MGCIcon,
  mgcIconTankRegular as MGCIcon,
  mgcIconTrafficLightsRegular as MGCIcon,
  mgcIconTrain2Regular as MGCIcon,
  mgcIconTrain3Regular as MGCIcon,
  mgcIconTrain4Regular as MGCIcon,
  mgcIconTrainRegular as MGCIcon,
  mgcIconTruckRegular as MGCIcon,
  mgcIconTrunkRegular as MGCIcon,
  mgcIconTyreRegular as MGCIcon,
  mgcIconUfo2Regular as MGCIcon,
  mgcIconUfoRegular as MGCIcon,
  mgcIconWheelRegular as MGCIcon,
  mgcIconWiperRegular as MGCIcon,
  mgcIconBadgeRegular as MGCIcon,
  mgcIconContacts2Regular as MGCIcon,
  mgcIconContacts3Regular as MGCIcon,
  mgcIconContacts4Regular as MGCIcon,
  mgcIconContactsRegular as MGCIcon,
  mgcIconFemaleRegular as MGCIcon,
  mgcIconGroup2Regular as MGCIcon,
  mgcIconGroup3Regular as MGCIcon,
  mgcIconGroupRegular as MGCIcon,
  mgcIconIDcardRegular as MGCIcon,
  mgcIconMaleRegular as MGCIcon,
  mgcIconUser1Regular as MGCIcon,
  mgcIconUser2Regular as MGCIcon,
  mgcIconUser3Regular as MGCIcon,
  mgcIconUser4Regular as MGCIcon,
  mgcIconUser5Regular as MGCIcon,
  mgcIconUserAdd2Regular as MGCIcon,
  mgcIconUserAddRegular as MGCIcon,
  mgcIconUserEditRegular as MGCIcon,
  mgcIconUserFollow2Regular as MGCIcon,
  mgcIconUserFollowRegular as MGCIcon,
  mgcIconUserForbidRegular as MGCIcon,
  mgcIconUserHeartRegular as MGCIcon,
  mgcIconUserHideRegular as MGCIcon,
  mgcIconUserInfoRegular as MGCIcon,
  mgcIconUserLockRegular as MGCIcon,
  mgcIconUserPinRegular as MGCIcon,
  mgcIconUserQuestionRegular as MGCIcon,
  mgcIconUserRemove2Regular as MGCIcon,
  mgcIconUserRemoveRegular as MGCIcon,
  mgcIconUserSearchRegular as MGCIcon,
  mgcIconUserSecurityRegular as MGCIcon,
  mgcIconUserSettingRegular as MGCIcon,
  mgcIconUserStarRegular as MGCIcon,
  mgcIconUserVisibleRegular as MGCIcon,
  mgcIconUserWarningRegular as MGCIcon,
  mgcIconUserXRegular as MGCIcon,
  mgcIconCelsiusRegular as MGCIcon,
  mgcIconCloud2Regular as MGCIcon,
  mgcIconCloudLightningRegular as MGCIcon,
  mgcIconCloudRegular as MGCIcon,
  mgcIconCloudSnowRegular as MGCIcon,
  mgcIconCloudWindyRegular as MGCIcon,
  mgcIconCloudsRegular as MGCIcon,
  mgcIconDrizzleRegular as MGCIcon,
  mgcIconDryRegular as MGCIcon,
  mgcIconFahrenheitRegular as MGCIcon,
  mgcIconFloatingDustRegular as MGCIcon,
  mgcIconFogRegular as MGCIcon,
  mgcIconFullMoonRegular as MGCIcon,
  mgcIconHailRegular as MGCIcon,
  mgcIconHazeRegular as MGCIcon,
  mgcIconHeavyRainRegular as MGCIcon,
  mgcIconHeavyRainstormRegular as MGCIcon,
  mgcIconHeavySnowRegular as MGCIcon,
  mgcIconHeavySnowstormRegular as MGCIcon,
  mgcIconHighTemperatureRegular as MGCIcon,
  mgcIconLightSnowRegular as MGCIcon,
  mgcIconLightningRegular as MGCIcon,
  mgcIconLowTemperatureRegular as MGCIcon,
  mgcIconModerateSnowRegular as MGCIcon,
  mgcIconMoonCloudyRegular as MGCIcon,
  mgcIconMoonFogRegular as MGCIcon,
  mgcIconMoonRegular as MGCIcon,
  mgcIconMoonStarsRegular as MGCIcon,
  mgcIconMoonlightRegular as MGCIcon,
  mgcIconNaRegular as MGCIcon,
  mgcIconPartlyCloudDaytimeRegular as MGCIcon,
  mgcIconPartlyCloudNightRegular as MGCIcon,
  mgcIconRainRegular as MGCIcon,
  mgcIconRainbowRegular as MGCIcon,
  mgcIconRainstormRegular as MGCIcon,
  mgcIconSandstormRegular as MGCIcon,
  mgcIconShowersRegular as MGCIcon,
  mgcIconSnowRegular as MGCIcon,
  mgcIconSnowflakeRegular as MGCIcon,
  mgcIconSnowmanRegular as MGCIcon,
  mgcIconSnowstorm2Regular as MGCIcon,
  mgcIconSnowstormRegular as MGCIcon,
  mgcIconSparkles2Regular as MGCIcon,
  mgcIconSparkles3Regular as MGCIcon,
  mgcIconSparklesRegular as MGCIcon,
  mgcIconSun2Regular as MGCIcon,
  mgcIconSunCloudyRegular as MGCIcon,
  mgcIconSunFogRegular as MGCIcon,
  mgcIconSunRegular as MGCIcon,
  mgcIconSunriseRegular as MGCIcon,
  mgcIconSunsetRegular as MGCIcon,
  mgcIconThermometerRegular as MGCIcon,
  mgcIconThunderstormRegular as MGCIcon,
  mgcIconTornado2Regular as MGCIcon,
  mgcIconTornadoRegular as MGCIcon,
  mgcIconTyphoonRegular as MGCIcon,
  mgcIconUmbrellaRegular as MGCIcon,
  mgcIconWaveRegular as MGCIcon,
  mgcIconWetRegular as MGCIcon,
  mgcIconWindRegular as MGCIcon,
  mgcIconAquariusRegular as MGCIcon,
  mgcIconAriesRegular as MGCIcon,
  mgcIconCancerRegular as MGCIcon,
  mgcIconCapricornRegular as MGCIcon,
  mgcIconGeminiRegular as MGCIcon,
  mgcIconLeoRegular as MGCIcon,
  mgcIconLibraRegular as MGCIcon,
  mgcIconPiscesRegular as MGCIcon,
  mgcIconSagittariusRegular as MGCIcon,
  mgcIconScorpioRegular as MGCIcon,
  mgcIconTaurusRegular as MGCIcon,
  mgcIconVirgoRegular as MGCIcon
];
